
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("irimY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4253c39628e0acb7$export$2e2bcd8739ae039);
parcelRequire("3avtZ");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $9pL9Y = parcelRequire("9pL9Y");

var $b5RwB = parcelRequire("b5RwB");

var $h6i8k = parcelRequire("h6i8k");

var $hqYEY = parcelRequire("hqYEY");

var $7jTnu = parcelRequire("7jTnu");

var $82cqT = parcelRequire("82cqT");

var $eibCx = parcelRequire("eibCx");

var $aPS2z = parcelRequire("aPS2z");

var $ljej9 = parcelRequire("ljej9");

var $dLEbR = parcelRequire("dLEbR");

var $hLPih = parcelRequire("hLPih");

var $akiS9 = parcelRequire("akiS9");

var $16sa1 = parcelRequire("16sa1");

var $2mHfh = parcelRequire("2mHfh");
var $lcB5K = parcelRequire("lcB5K");
var $ivzXw = parcelRequire("ivzXw");

var $bJscI = parcelRequire("bJscI");

var $ad2Dp = parcelRequire("ad2Dp");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $ftN6c = parcelRequire("ftN6c");

var $eacwX = parcelRequire("eacwX");

var $lUYYk = parcelRequire("lUYYk");
const $4253c39628e0acb7$var$BROWSER_METRICS_INTERACTION_APP_KEY = 'jira.project-issue-navigator';
const $4253c39628e0acb7$var$initInteractions = ()=>({
        pagination: {
            metrics: (0, $hqYEY.metrics).interaction({
                key: `${$4253c39628e0acb7$var$BROWSER_METRICS_INTERACTION_APP_KEY}.pagination.start-end.diff`
            }),
            properties: {}
        },
        refinement: {
            metrics: (0, $hqYEY.metrics).interaction({
                key: `${$4253c39628e0acb7$var$BROWSER_METRICS_INTERACTION_APP_KEY}.refinement.start-end.diff`
            }),
            properties: {}
        },
        filter: {
            metrics: (0, $hqYEY.metrics).interaction({
                key: `${$4253c39628e0acb7$var$BROWSER_METRICS_INTERACTION_APP_KEY}.filter.start-end.diff`
            }),
            properties: {}
        },
        'list-view': {
            metrics: (0, $hqYEY.metrics).interaction({
                key: `${$4253c39628e0acb7$var$BROWSER_METRICS_INTERACTION_APP_KEY}.list-view.start-end.diff`
            }),
            properties: {}
        },
        'split-view': {
            metrics: (0, $hqYEY.metrics).interaction({
                key: `${$4253c39628e0acb7$var$BROWSER_METRICS_INTERACTION_APP_KEY}.split-view.start-end.diff`
            }),
            properties: {}
        },
        'column-configuration': {
            metrics: (0, $hqYEY.metrics).interaction({
                key: `${$4253c39628e0acb7$var$BROWSER_METRICS_INTERACTION_APP_KEY}.column-configuration.start-end.diff`
            }),
            properties: {}
        }
    });
const $4253c39628e0acb7$var$MaybeNinErrorBoundary = (0, $bJscI.componentWithFG)('improve_nin_slo_events', (0, $ad2Dp.NinErrorBoundary), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children));
// eslint-disable-next-line jira/react/no-class-components
class $4253c39628e0acb7$var$ProjectIssueNavigatorSPAWrapper extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.view = undefined, /**
   * Update the currently selected issue in the URL.
   *
   * @param issueKey Issue key to update in the URL
   * @param isSelectedByUserInteraction True if this issue was selected by a user interaction, e.g. clicking an issue
   * in the list. This will be false if an issue was automatically selected by the app, e.g. automatically selecting
   * the first issue once the issue list has loaded.
   * @param viewActivity True to indicate the issue app should scroll to the activity feed section after opening.
   */ this.onChangeIssue = (issueKey, isSelectedByUserInteraction, viewActivity)=>{
            // Replace the history entry when an issue is auto selected by the app so we're not pushing redundant entries to
            // the history stack
            this.push({
                issueKey: issueKey,
                ...(0, $7jTnu.fg)('jsc_inline_editing_field_refactor') ? {
                    viewActivity: viewActivity
                } : {}
            }, !isSelectedByUserInteraction);
        }, /**
   * Set the currently selected view and update the selected issue in the URL if provided.
   *
   * @param newView View to update
   * @param issueKey Issue key to update in the URL
   */ this.onSetView = (newView, issueKey)=>{
            this.startInteraction((0, $eibCx.convertToView)(newView));
            (0, $7jTnu.fg)('add_nin_press_interactions') && (0, $h6i8k.default)(`issue-navigator.${(0, $eibCx.convertToView)(newView)}`);
            this.view = newView;
            if (issueKey !== undefined || newView === 'detail' && (0, $7jTnu.fg)('jsc_list_query_param_merge')) this.push({
                ...issueKey !== undefined ? {
                    issueKey: issueKey
                } : {},
                ...newView === 'detail' && (0, $7jTnu.fg)('jsc_list_query_param_merge') ? {
                    groupBy: undefined,
                    hideDone: undefined
                } : {}
            }, true);
        }, this.onRefinement = ()=>{
            this.startInteraction('refinement');
            (0, $7jTnu.fg)('add_nin_press_interactions') && (0, $h6i8k.default)('issue-navigator.refinement');
        }, /**
   * Callback function called when internal changes are made to PIN's state which generates new JQL.
   *
   * @param jql string The new JQL string
   * @param clearFilter boolean When true we clear the filter from url params
   */ this.onChangeJql = (jql, clearFilter = false)=>{
            this.push({
                ...clearFilter ? {
                    filter: undefined
                } : {},
                jql: jql,
                // Clear issue key from URL whenever JQL changes
                issueKey: (0, $ljej9.toIssueKey)('')
            });
        }, this.onPageDataLoad = (selectedView)=>{
            if (selectedView !== undefined) this.view = selectedView;
            if (!this.state.initialised) this.setState({
                initialised: true
            });
            this.endInteractions();
        }, this.onStartFilterChangeInteractionIfAny = (filter)=>{
            if (this.lastFilter !== filter) {
                this.lastFilter = filter;
                if (filter != null && ((0, $82cqT.isFilterId)(filter) || (0, $hLPih.isFilterKey)(filter))) {
                    this.startInteraction('filter', {
                        filterId: filter
                    });
                    (0, $7jTnu.fg)('add_nin_press_interactions') && (0, $h6i8k.default)('issue-navigator.filter');
                }
            }
        }, this.onChangeFilter = (filter)=>{
            this.push({
                ...filter ? {
                    filter: filter,
                    jql: undefined
                } : {
                    jql: undefined
                }
            }, true);
        }, this.onChangeColumnConfiguration = ()=>{
            this.startInteraction('column-configuration');
            (0, $7jTnu.fg)('add_nin_press_interactions') && (0, $h6i8k.default)('issue-navigator.column-configuration');
        }, this.startInteraction = (key, properties)=>{
            if (!this.activeInteractions.includes(key)) this.activeInteractions.push(key);
            const interaction = this.interactions[key];
            if (interaction) {
                interaction.properties = properties || {};
                interaction.metrics.start();
            }
        }, this.endInteractions = ()=>{
            this.activeInteractions.forEach((key)=>{
                this.interactions[key]?.metrics.stop({
                    customData: this.interactions[key]?.properties
                });
            });
            this.activeInteractions = [];
        }, this.getQueryStringParams = ()=>{
            const { location: location } = this.props;
            const { filter: filter, jql: jql } = (0, $b5RwB.parse)(location.search, {
                // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
                arrayFormat: 'comma'
            });
            return {
                filter: filter,
                jql: jql
            };
        };
        const { location: location } = props;
        this.locationSearchStr = location.search;
        this.activeInteractions = [];
        this.interactions = $4253c39628e0acb7$var$initInteractions();
        if ((0, $7jTnu.fg)('add_nin_press_interactions')) {
            // Ensure filter change event does not fire on initial loads & transitions because it
            // will cause the page load interaction to be aborted
            const { filter: filter } = this.getQueryStringParams();
            this.lastFilter = filter;
        }
        const query = (0, $b5RwB.parse)(location.search);
        const issueKey = query.selectedIssue ?? '';
        this.state = {
            initialised: false,
            issueKey: issueKey
        };
    }
    componentDidUpdate(prevProps) {
        const prevQuery = (0, $b5RwB.parse)(prevProps.location.search);
        const query = (0, $b5RwB.parse)(this.props.location.search);
        const prevIssueKey = prevQuery.selectedIssue ?? '';
        const issueKey = query.selectedIssue ?? '';
        // If issue key has changed from the router and does not match our internal key then update our state
        if (issueKey !== prevIssueKey && issueKey !== this.state.issueKey) this.setState({
            issueKey: issueKey
        });
    }
    push(newParams, shouldReplace = false) {
        const { match: match, push: push, location: location, replace: replace } = this.props;
        const historyAction = shouldReplace ? replace : push;
        const oldIssueKey = this.state.issueKey;
        const { projectKey: projectKey = match?.params.projectKey ?? '', issueKey: issueKey = oldIssueKey ?? '', ...params } = newParams;
        const newProjectKey = newParams.projectKey;
        const oldProjectKey = match?.params.projectKey;
        const projectKeyChanged = typeof newProjectKey !== 'undefined' && newProjectKey !== oldProjectKey;
        const newIssueKey = newParams.issueKey;
        const issueKeyParamsAreDefined = !!(newIssueKey || oldIssueKey);
        const issueKeyChanged = issueKeyParamsAreDefined && newIssueKey !== oldIssueKey;
        // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
        const query = (0, $b5RwB.parse)(location.search, {
            arrayFormat: 'comma'
        });
        const queryParamsChanged = Object.keys(params).length !== 0 && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))((0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(params, (param)=>param != null), query);
        if (projectKeyChanged || issueKeyChanged || queryParamsChanged) {
            const queryParams = {
                ...query,
                ...params,
                selectedIssue: newIssueKey
            };
            if (newIssueKey == null || newIssueKey === '') delete queryParams.selectedIssue;
            const itemId = match?.params.itemId;
            const itemIdSegment = itemId && (0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding') ? `${itemId}/` : '';
            // @ts-expect-error - React-resource-router's external type interface claims push/replace only accept "string", however the underlying code works with the `Location` object we're using
            historyAction({
                pathname: `${(match && (0, $hLPih.getUrlPrefix)(match.url)) ?? ''}/projects/${projectKey}/${(0, $7jTnu.fg)('jira_list_nin_merge') ? 'list' : 'issues'}/${itemIdSegment}`,
                search: (0, $b5RwB.stringify)(queryParams, // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
                {
                    arrayFormat: 'comma'
                })
            });
        }
        if (issueKeyChanged) // We explicitly set this into state instead of being purely prop driven as browser history actions are not
        // re-rendered synchronously. Setting into state makes our render order more reliable.
        this.setState({
            issueKey: issueKey ?? ''
        });
        return true;
    }
    render() {
        const { match: match, location: location } = this.props;
        const { projectKey: projectKey } = match?.params ?? {};
        const params = (0, $7jTnu.fg)('add_nin_press_interactions') ? this.getQueryStringParams() : // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
        (0, $b5RwB.parse)(location.search, {
            arrayFormat: 'comma'
        });
        const { filter: filter, jql: jql } = params;
        this.onStartFilterChangeInteractionIfAny(filter);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akiS9.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4253c39628e0acb7$var$MaybeNinErrorBoundary, {
            id: "unhandled",
            packageName: "jiraSpaAppsProjectIssueNavigator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLEbR.ProjectSubProductUpdater), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aPS2z.default), {
            projectKey: projectKey ?? null
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lUYYk.default), {
            showNav3Header: this.props.showNav3Header,
            projectKey: (0, $ljej9.toProjectKey)(projectKey ?? ''),
            issueKey: (0, $ljej9.toIssueKey)(this.state.issueKey),
            jql: jql,
            onChangeIssue: this.onChangeIssue,
            onPageDataLoad: this.onPageDataLoad,
            onChangeColumnConfiguration: this.onChangeColumnConfiguration,
            onChangeJql: this.onChangeJql,
            initialised: this.state.initialised,
            onRefinement: this.onRefinement,
            onSetView: this.onSetView,
            view: this.view ? (0, $eibCx.convertToView)(this.view) : undefined,
            filter: filter,
            onChangeFilter: this.onChangeFilter,
            preloadedEntryPoints: this.props.preloadedEntryPoints
        })));
    }
}
const $4253c39628e0acb7$var$ProjectIssueNavigatorSPA = ({ entryPoints: entryPoints })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "project-issue-navigator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ push: push, replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivzXw.RouterSubscriber), null, ({ location: location, match: match, route: route })=>{
            if ((0, $7jTnu.fg)('slv-227_nin_selected_issue_fe_redirect')) {
                let path = match.url;
                const itemId = match.params.itemId ?? '';
                const issueKeyRegex = new RegExp(`^${(0, $eacwX.ISSUEKEY_REGEX)}$`);
                const isIssueKey = issueKeyRegex.test(itemId);
                const queryParams = (0, $b5RwB.parse)(location.search);
                const isIssuesRoute = path.includes('/issues');
                if (isIssuesRoute && (0, $7jTnu.fg)('jira_list_nin_merge')) path = path.replace('issues', 'list');
                /*
             * At some point the route config was changed from:
             *
             * .../:issueKey
             * to
             * .../:itemId
             *
             * Where the :issueKey path param represented the selected issue key
             * and the :itemId path param represents the navigation item ID.
             *
             * We are performing a frontend redirect when we detect that an issue key
             * is present in the position where the navigation item ID is expected.
             *
             * This ensures we maintain backwards compatibility with existing links
             * when performing a SPA transition.
             */ if (isIssueKey) {
                    const pathSegments = path.split('/').filter(Boolean);
                    const updatedPathSegments = pathSegments.filter((segment)=>segment !== itemId);
                    path = `/${updatedPathSegments.join('/')}`;
                    queryParams.selectedIssue = itemId;
                }
                let url = path;
                if (Object.keys(queryParams).length) url += `?${(0, $b5RwB.stringify)(queryParams)}`;
                if (isIssuesRoute && (0, $7jTnu.fg)('jira_list_nin_merge') || isIssueKey) {
                    (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'route redirected', 'projectIssues', {
                        didIssueKeyRedirect: isIssueKey,
                        didIssuesRouteRedirect: isIssuesRoute && (0, $7jTnu.fg)('jira_list_nin_merge')
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
                        to: url
                    });
                }
            } else if (match.url.includes('/issues') && (0, $7jTnu.fg)('jira_list_nin_merge')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireOperationalAnalytics), {
                action: "redirected",
                actionSubject: "route",
                actionSubjectId: "projectIssues"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
                to: match.url.replace('issues', 'list')
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4253c39628e0acb7$var$ProjectIssueNavigatorSPAWrapper, {
                push: push,
                location: location,
                match: match,
                replace: replace,
                showNav3Header: (0, $7jTnu.fg)('jira_list_nin_merge') ? route.name === 'servicedesk-issues' || route.name === 'servicedesk-list' : route.name === 'servicedesk-issues',
                preloadedEntryPoints: entryPoints
            });
        })));
};
var $4253c39628e0acb7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($4253c39628e0acb7$var$ProjectIssueNavigatorSPA);

});
parcelRegister("aPS2z", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $09ee4a6709eeeeea$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $09ee4a6709eeeeea$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $09ee4a6709eeeeea$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2aY2d = parcelRequire("2aY2d");

var $2mHfh = parcelRequire("2mHfh");

const $09ee4a6709eeeeea$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $09ee4a6709eeeeea$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2aY2d.ProjectContextProvider), null, (projectContext)=>$09ee4a6709eeeeea$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: (0, $5e412e91f864721a$export$9a6ccb84170b615b)
        }) : null);
};
const $09ee4a6709eeeeea$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: (0, $5e412e91f864721a$export$9a6ccb84170b615b)
    });
var $09ee4a6709eeeeea$export$2e2bcd8739ae039 = $09ee4a6709eeeeea$var$RedirectIfProjectArchived;

});
const $5e412e91f864721a$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("dLEbR", function(module, exports) {

$parcel$export(module.exports, "ProjectSubProductUpdater", () => $22f8ab1c02faa372$export$bfbf80c212b0dcb9);

var $eJOHy = parcelRequire("eJOHy");

var $6nVJI = parcelRequire("6nVJI");

var $jRGAq = parcelRequire("jRGAq");

var $figsJ = parcelRequire("figsJ");

var $cZTMg = parcelRequire("cZTMg");
const $22f8ab1c02faa372$export$bfbf80c212b0dcb9 = ({ allowMonolithDeferral: allowMonolithDeferral = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6nVJI.ContainerContextSubscriber), null, ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, data && (0, $jRGAq.isProjectContext)(data) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZTMg.SubProductUpdater), {
            subProduct: (0, $figsJ.subProductFromProjectTypeForAnalytics)(data.project.type),
            allowMonolithDeferral: allowMonolithDeferral
        })));

});
parcelRegister("jRGAq", function(module, exports) {

$parcel$export(module.exports, "isProjectContext", () => $ac0d9f43e2f849b3$export$d46e75e464bf2407);
$parcel$export(module.exports, "isUserContext", () => $ac0d9f43e2f849b3$export$8d1083037a4a6250);
const $ac0d9f43e2f849b3$export$d46e75e464bf2407 = (containerContext)=>containerContext.project !== undefined;
const $ac0d9f43e2f849b3$export$8d1083037a4a6250 = (containerContext)=>containerContext.user !== undefined;

});

parcelRegister("cZTMg", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $e3e218a75c21102a$export$eb40d3df56aa5c53);

var $eJOHy = parcelRequire("eJOHy");

var $5onjV = parcelRequire("5onjV");

var $figsJ = parcelRequire("figsJ");

var $5nYJB = parcelRequire("5nYJB");

var $aO6tw = parcelRequire("aO6tw");

var $adiVF = parcelRequire("adiVF");
const $e3e218a75c21102a$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $adiVF.isSubProductProps)(props) ? props.subProduct : (0, $figsJ.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5onjV.default), {
        op: (0, $aO6tw.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5nYJB.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("5nYJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $82e051cbb2adac57$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3aa9n = parcelRequire("3aa9n");

var $8VfmF = parcelRequire("8VfmF");
const $82e051cbb2adac57$var$TagMauEvent = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aa9n.default), {
        op: (0, $8VfmF.default),
        args: [
            subProduct
        ]
    });
var $82e051cbb2adac57$export$2e2bcd8739ae039 = $82e051cbb2adac57$var$TagMauEvent;

});
parcelRegister("8VfmF", function(module, exports) {

$parcel$export(module.exports, "default", () => $811461c69dc55236$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $jGzN3 = parcelRequire("jGzN3");
const $811461c69dc55236$var$tagMauEvent = (subProduct)=>{
    (0, $jGzN3.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};
var $811461c69dc55236$export$2e2bcd8739ae039 = $811461c69dc55236$var$tagMauEvent;

});


parcelRegister("aO6tw", function(module, exports) {

$parcel$export(module.exports, "default", () => $53a2c520c0b2b632$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");


var $eSnSE = parcelRequire("eSnSE");

var $2Mqjh = parcelRequire("2Mqjh");
const $53a2c520c0b2b632$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
const $53a2c520c0b2b632$var$setCurrentSubProduct = async (subProduct, allowMonolithDeferral)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $99993c16fc53d6ec$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $53a2c520c0b2b632$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4T9yL.waitForHeritage)() : null, ()=>(0, $97BGz.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $iyT45.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $eSnSE.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };
var $53a2c520c0b2b632$export$2e2bcd8739ae039 = $53a2c520c0b2b632$var$setCurrentSubProduct;

});
const $99993c16fc53d6ec$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("adiVF", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $b41c599c0dbb9c69$export$c3063d6d7a8c075f);
const $b41c599c0dbb9c69$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});



parcelRegister("akiS9", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $50b865cde2c2d004$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $50b865cde2c2d004$export$2a999c5f84501025);

var $6uWhG = parcelRequire("6uWhG");
const $50b865cde2c2d004$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $50b865cde2c2d004$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($50b865cde2c2d004$export$8e54fca0a680fdfd);
        (0, $6uWhG.setMark)($50b865cde2c2d004$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("ad2Dp", function(module, exports) {

$parcel$export(module.exports, "NinErrorBoundary", () => $4ee5781ea33fce97$export$b63c3d14be9f8b13);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $aqnJa = parcelRequire("aqnJa");

var $2aY2d = parcelRequire("2aY2d");

var $bRJAs = parcelRequire("bRJAs");

var $8Uqf3 = parcelRequire("8Uqf3");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");

var $7jTnu = parcelRequire("7jTnu");

var $jiTA8 = parcelRequire("jiTA8");

var $8KUFq = parcelRequire("8KUFq");

var $iRahl = parcelRequire("iRahl");
const $4ee5781ea33fce97$var$ANALYTICS_SOURCE = 'issue-navigator';
const $4ee5781ea33fce97$export$b63c3d14be9f8b13 = ({ children: children, id: id, packageName: packageName })=>{
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $iRahl.EXPERIENCE_NAME),
        experienceId: undefined,
        analyticsSource: $4ee5781ea33fce97$var$ANALYTICS_SOURCE
    });
    const appEditions = (0, $8vyDv.useAppEditions)();
    const application = project?.projectType ? (0, $bRJAs.getApplicationForProject)(project.projectType) : null;
    const edition = application ? (0, $a9ldn.getEdition)(application, appEditions) : null;
    let analyticsAttributes = {
        application: application,
        edition: edition
    };
    if ((0, $7jTnu.fg)('jira_nin_smart_link')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const isEmbed = (0, $jiTA8.useIsEmbedMode)();
        analyticsAttributes = {
            ...analyticsAttributes,
            isEmbed: isEmbed
        };
    }
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $iRahl.EXPERIENCE_NAME),
        attributes: analyticsAttributes
    });
    const onError = (0, $eJOHy.useCallback)((location, error)=>{
        if (!(0, $8KUFq.isHttpClientErrorResponse)(error)) {
            onExperienceStart();
            onExperienceFail(location, error);
        }
    }, [
        onExperienceFail,
        onExperienceStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        onError: onError,
        sendToPrivacyUnsafeSplunk: true
    }, children);
};

});

parcelRegister("eacwX", function(module, exports) {

$parcel$export(module.exports, "ISSUEKEY_REGEX", () => $73cfa692bc7b4588$export$b52c9cee589449a8);
$parcel$export(module.exports, "default", () => $73cfa692bc7b4588$export$2e2bcd8739ae039);

var $3Q6BV = parcelRequire("3Q6BV");
const $73cfa692bc7b4588$export$b52c9cee589449a8 = '([A-Z][A-Z0-9_]+-\\d+)';
/**
 * Returns the issue key if the URL is a valid full page Jira issue URL. It may also include a trailing
 * hash fragment. A matching URL must look like:
 * <host><baseurl>/browse/<issuekey><#hash?>
 * e.g. https://my-jira-instance.atlassian.net/browse/FOO-123#xyz
 */ const $73cfa692bc7b4588$var$matchJiraUrl = (url, host)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(url, {});
    const isMatchingProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    const isMatchingHost = parsedUrl.host === host;
    const matches = parsedUrl.pathname.match(new RegExp(`^\\/browse\\/${$73cfa692bc7b4588$export$b52c9cee589449a8}\\/?$`));
    const issueKey = matches && matches.length > 1 ? matches[1] : null;
    return isMatchingProtocol && isMatchingHost && issueKey || null;
};
var $73cfa692bc7b4588$export$2e2bcd8739ae039 = $73cfa692bc7b4588$var$matchJiraUrl;

});

parcelRegister("lUYYk", function(module, exports) {

$parcel$export(module.exports, "default", () => $21104aa9edc62ebc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $huMFD = parcelRequire("huMFD");

var $7jTnu = parcelRequire("7jTnu");

var $ln6Iy = parcelRequire("ln6Iy");

var $g8Az8 = parcelRequire("g8Az8");

var $5kYyR = parcelRequire("5kYyR");

var $epTsa = parcelRequire("epTsa");

var $82cqT = parcelRequire("82cqT");

var $dV4qk = parcelRequire("dV4qk");

var $fAgUF = parcelRequire("fAgUF");

var $3Ssg5 = parcelRequire("3Ssg5");

var $ch9En = parcelRequire("ch9En");

var $4xbv3 = parcelRequire("4xbv3");

var $dzJIl = parcelRequire("dzJIl");

var $4kMB4 = parcelRequire("4kMB4");

var $lA4uT = parcelRequire("lA4uT");

var $9FYIg = parcelRequire("9FYIg");

var $dSkEC = parcelRequire("dSkEC");

var $8k1uC = parcelRequire("8k1uC");

var $dZRaT = parcelRequire("dZRaT");

var $gwH93 = parcelRequire("gwH93");

var $hLPih = parcelRequire("hLPih");

var $dTqD3 = parcelRequire("dTqD3");

var $eJrcF = parcelRequire("eJrcF");

var $bJscI = parcelRequire("bJscI");

var $aaLZH = parcelRequire("aaLZH");

var $2MmuH = parcelRequire("2MmuH");
const $21104aa9edc62ebc$var$getSearchInput = (projectKey, jql, filter)=>{
    const filterInput = (0, $82cqT.isFilterId)(filter) ? filter : (0, $hLPih.mapFilterToJql)(projectKey, filter);
    return (0, $3Ssg5.getSearchInput)(jql, filterInput);
};
const $21104aa9edc62ebc$var$getFilterForAnalytics = (filter)=>{
    return filter && ((0, $82cqT.isFilterId)(filter) || (0, $hLPih.isFilterKey)(filter)) ? filter : 'default';
};
const $21104aa9edc62ebc$var$useProjectAttributes = ()=>{
    const { data: projectContext } = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    let resolvedProjectConfig;
    switch(projectContext?.simplified){
        case true:
            resolvedProjectConfig = (0, $ln6Iy.ProjectStyle).NEXT_GEN;
            break;
        case false:
            resolvedProjectConfig = (0, $ln6Iy.ProjectStyle).CLASSIC;
            break;
        default:
            resolvedProjectConfig = '';
    }
    const resolvedProjectType = projectContext?.projectType || '';
    return (0, $eJOHy.useMemo)(()=>({
            projectConfig: resolvedProjectConfig,
            projectType: resolvedProjectType
        }), [
        resolvedProjectConfig,
        resolvedProjectType
    ]);
};
const $21104aa9edc62ebc$var$useIssueTableProps = (projectKey, preloadedEntryPoints)=>{
    return (0, $eJOHy.useMemo)(()=>({
            projectContext: projectKey,
            isGroupingSupported: (0, $epTsa.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) && (0, $epTsa.expVal)('jira_spreadsheet_component_grouping', 'isGroupingEnabled', false),
            preloadedEntryPoints: {
                nativeIssueTableEntryPoint: preloadedEntryPoints?.nativeIssueTableEntryPoint
            }
        }), [
        projectKey,
        preloadedEntryPoints?.nativeIssueTableEntryPoint
    ]);
};
const $21104aa9edc62ebc$var$useGlobalScopeEnrolment = ()=>{
    const { data: globalEnrolmentData } = (0, $eJrcF.useResource)((0, $dSkEC.isNinGlobalScopeEnrolmentEnabledResource));
    if (globalEnrolmentData !== null && globalEnrolmentData !== undefined) (0, $dV4qk.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(globalEnrolmentData);
};
const $21104aa9edc62ebc$var$MaybeReportErrors = (0, $bJscI.componentWithFG)('improve_nin_slo_events', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children), (0, $5kYyR.default));
const $21104aa9edc62ebc$var$AsyncProjectIssueNavigatorWrapper = ({ filter: filter, jql: jqlParam, initialised: initialised, view: view, projectKey: projectKey, showNav3Header: showNav3Header = false, ...props })=>{
    const onMutateJqlParam = (0, $3Ssg5.useUpdateUrlQueryParamCallback)('jql');
    const getServerTimeUFO = (0, $huMFD.useServerTimeUFO)();
    const defaultJql = (0, $hLPih.getDefaultJql)(projectKey);
    const jql = (0, $3Ssg5.getJqlFromParamValues)(defaultJql, jqlParam, filter, (0, $hLPih.mapFilterToJql).bind(undefined, projectKey), onMutateJqlParam);
    const issueTableProps = $21104aa9edc62ebc$var$useIssueTableProps(projectKey, props.preloadedEntryPoints);
    const searchInput = (0, $eJOHy.useMemo)(()=>$21104aa9edc62ebc$var$getSearchInput(projectKey, jql, filter), [
        projectKey,
        jql,
        filter
    ]);
    const projectAttributes = $21104aa9edc62ebc$var$useProjectAttributes();
    $21104aa9edc62ebc$var$useGlobalScopeEnrolment();
    const response = (0, $9FYIg.useRelayResource)((0, $8k1uC.issueNavigatorRelayResource));
    const { queryReference: queryReference } = response;
    const filterResponse = (0, $9FYIg.useRelayResource)((0, $8k1uC.issueNavigatorFilterRelayResource));
    const filterQueryReference = filterResponse.queryReference;
    const issueNavigatorHydrationRelayResource = (0, $7jTnu.fg)('render_jql_builder_in_ssr') ? (0, $8k1uC.issueNavigatorHydrationRelayResource) : (0, $8k1uC.issueNavigatorHydrationRelayResourceBrowserOnly);
    const hydrationResponse = (0, $9FYIg.useRelayResource)(issueNavigatorHydrationRelayResource);
    const hydrationQueryReference = hydrationResponse.queryReference;
    const jqlBuilderProps = (0, $huMFD.useJqlBuilderProps)(hydrationQueryReference, props.preloadedEntryPoints);
    // During SSR our issueNavigatorRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (queryReference == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gwH93.ProjectIssueNavigatorSkeleton), null);
    // During SSR our issueNavigatorFilterRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (filterQueryReference == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gwH93.ProjectIssueNavigatorSkeleton), null);
    // During SSR our issueNavigatorHydrationRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (hydrationQueryReference == null && (0, $7jTnu.fg)('render_jql_builder_in_ssr')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gwH93.ProjectIssueNavigatorSkeleton), null);
    const filterForAnalytics = $21104aa9edc62ebc$var$getFilterForAnalytics(filter);
    const attributes = {
        navigatorScope: 'project',
        viewLayout: view || '',
        jql: !!jqlParam,
        filter: filterForAnalytics,
        ...projectAttributes
    };
    const extraInfo = {
        scope: 'project',
        filterId: filterForAnalytics,
        isJqlParamPresent: !!jqlParam,
        ...(0, $7jTnu.fg)('analytics_for_issue_key_included_in_nin_url') && {
            isIssueKeyPresent: !!props.issueKey
        },
        ...initialised && getServerTimeUFO?.(),
        ...attributes
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: attributes,
        ...filter !== null && filter !== undefined && ((0, $82cqT.isFilterId)(filter) || (0, $hLPih.isFilterKey)(filter)) && {
            containers: {
                issueFilter: {
                    id: filter
                }
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($21104aa9edc62ebc$var$MaybeReportErrors, {
        id: "unhandled",
        packageName: "jiraSpaAppsProjectIssueNavigator",
        teamName: "empanada",
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $g8Az8.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "project-issue-navigator-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gwH93.ProjectIssueNavigatorSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($21104aa9edc62ebc$export$98541361bc463108, {
        isConditionalFormattingEnabled: (0, $7jTnu.fg)('jira_list_conditional_formatting'),
        // eslint-disable-next-line jira/ff/no-preconditioning
        isSaveFilterButtonEnabled: !((0, $7jTnu.fg)('nin-saved-filters') && (0, $7jTnu.fg)('jira_list_nin_merge')),
        isProjectQuickstartOnboardingEnabled: (0, $7jTnu.fg)('jira_list_nin_merge')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dzJIl.default), {
        ...props,
        showNav3Header: showNav3Header,
        projectKey: projectKey,
        defaultJql: defaultJql,
        queryReference: queryReference || undefined,
        filterQueryReference: filterQueryReference,
        searchInput: searchInput,
        issueTableProps: issueTableProps,
        isIssueHierarchySupportEnabled: (0, $epTsa.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false),
        isHideDoneSupportEnabled: (0, $epTsa.expVal)('jira_list_hide_done_items', 'isEnabled', false),
        isIssueRankingSupportEnabled: (0, $7jTnu.fg)('jsc_list_reranking_gate'),
        jqlBuilderProps: (0, $7jTnu.fg)('jql_builder_basic_ssr_stability_fixes') ? jqlBuilderProps : {
            maybeHydrationQueryReference: hydrationQueryReference || undefined
        },
        isMergedColumnSupportEnabled: (0, $7jTnu.fg)('jira_list_merged_column_gate'),
        isFrozenColumnSupportEnabled: (0, $7jTnu.fg)('issue_table_frozen_columns'),
        isGridNavigationEnabled: (0, $epTsa.expVal)('nin_grid_navigation_experiment', 'isGridNavigationEnabled', false),
        isInlineFieldConfigEnabled: (0, $epTsa.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false),
        isInBetweenColumnPickerEnabled: (0, $7jTnu.fg)('jira_inline_field_config_gate')
    })))), initialised && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lA4uT.default), {
        appName: "project-issue-navigator",
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $4kMB4.appBundleReadyMark),
            (0, $4kMB4.prefetchApiReadyMark)
        ],
        ttrSlo: 3000,
        ttiSlo: 4000,
        extra: extraInfo,
        metric: (0, $fAgUF.NINPageLoad)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStatePageReady), null), (0, $7jTnu.fg)('jira_onboarding_wizard_m1_feature_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2MmuH.WelcomeModal), null)));
};
const $21104aa9edc62ebc$var$NoOp = ({ children: children })=>children;
const $21104aa9edc62ebc$export$98541361bc463108 = (0, $bJscI.componentWithFG)('jira_list_conditional_formatting', (0, $aaLZH.IssueNavigatorFeatureProvider), $21104aa9edc62ebc$var$NoOp);
var $21104aa9edc62ebc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($21104aa9edc62ebc$var$AsyncProjectIssueNavigatorWrapper);

});
parcelRegister("huMFD", function(module, exports) {

$parcel$export(module.exports, "useServerTimeUFO", () => $427e1e4f2cb07291$export$2f7ed9d4472b5578);
$parcel$export(module.exports, "useJqlBuilderProps", () => $427e1e4f2cb07291$export$a3c886ae4538cc12);

var $eJOHy = parcelRequire("eJOHy");

var $3w0Dj = parcelRequire("3w0Dj");

var $93W2w = parcelRequire("93W2w");

var $7jTnu = parcelRequire("7jTnu");
/*
 * Approximates the server time for the query by first:
 * - checking the SSR-origin response time (if it doesn't time out),
 * - and then the client-origin response time.
 */ const $427e1e4f2cb07291$var$getServerTime = (queryName)=>{
    return globalThis?.window?.SPA_STATE?.['ssr/relay_fetch']?.[queryName]?.duration ?? globalThis?.window?.performance.getEntriesByType('measure').find(({ name: name })=>name.includes(queryName))?.duration;
};
const $427e1e4f2cb07291$export$2f7ed9d4472b5578 = ()=>{
    const serverTimeCallback = (0, $eJOHy.useCallback)(()=>{
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $7jTnu.fg)('add_servertime_to_ufo_for_nin') && !false && globalThis?.window?.performance && globalThis?.window?.SPA_STATE) {
            const hydrationServerTime = $427e1e4f2cb07291$var$getServerTime((0, $3w0Dj.default).params.name);
            const searchServerTime = $427e1e4f2cb07291$var$getServerTime((0, $93W2w.default).params.name);
            return {
                // Only add statsig ingested custom serverTime data if both server times are available
                serverTime: hydrationServerTime && searchServerTime ? hydrationServerTime + searchServerTime : undefined,
                hydrationServerTime: hydrationServerTime,
                searchServerTime: searchServerTime
            };
        }
        return {
            serverTime: undefined,
            hydrationServerTime: undefined,
            searchServerTime: undefined
        };
    }, []);
    return (0, $7jTnu.fg)('add_servertime_to_ufo_for_nin') ? serverTimeCallback : undefined;
};
const $427e1e4f2cb07291$export$a3c886ae4538cc12 = (hydrationQueryReference, preloadedEntryPoints)=>{
    return (0, $eJOHy.useMemo)(()=>({
            maybeHydrationQueryReference: hydrationQueryReference || undefined,
            preloadedEntryPoints: {
                jqlBuilderWithAiEntryPoint: preloadedEntryPoints?.jqlBuilderWithAiEntryPoint
            }
        }), [
        hydrationQueryReference,
        preloadedEntryPoints?.jqlBuilderWithAiEntryPoint
    ]);
};

});

parcelRegister("g8Az8", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $57d2792abb57212f$export$c7209ce2e0d060ea);

var $7Jk3f = parcelRequire("7Jk3f");
const $57d2792abb57212f$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $7Jk3f.isLoaderError)(error)
    });

});

parcelRegister("dV4qk", function(module, exports) {

$parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", () => $0a39e098f20828aa$export$55632339cd4dae9c);
$parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", () => $0a39e098f20828aa$export$7b78bfe0a111cecf);
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", () => $0a39e098f20828aa$export$82b2633cf7498c5e);
$parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", () => $0a39e098f20828aa$export$458eda2352a1e223);

var $dnU6V = parcelRequire("dnU6V");

var $eSnSE = parcelRequire("eSnSE");
const $0a39e098f20828aa$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const $0a39e098f20828aa$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
const $0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage = (0, $dnU6V.createLocalStorageProvider)('nin-changeboarding');
const $0a39e098f20828aa$export$34434fbbe40a8047 = ()=>$0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.remove($0a39e098f20828aa$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $0a39e098f20828aa$export$55632339cd4dae9c = ()=>$0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.get($0a39e098f20828aa$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $0a39e098f20828aa$export$7b78bfe0a111cecf = ()=>$0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.get($0a39e098f20828aa$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
const $0a39e098f20828aa$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
    // In practice this is very unlikely to fail, as our local storage library checks that local storage is working
    // during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
    // existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
    try {
        $0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.set($0a39e098f20828aa$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $eSnSE.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
        $0a39e098f20828aa$export$34434fbbe40a8047();
    }
};
const $0a39e098f20828aa$export$458eda2352a1e223 = ()=>{
    try {
        $0a39e098f20828aa$var$ninGlobalScopeEnrolmentLocalStorage.set($0a39e098f20828aa$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $eSnSE.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
    }
};

});

parcelRegister("fAgUF", function(module, exports) {

$parcel$export(module.exports, "marks", () => $b6c8c5a5805d3a77$export$3a8025f2f3e0c64);
$parcel$export(module.exports, "NINJqlBuilderAsyncLoad", () => $b6c8c5a5805d3a77$export$8ba5b9245ec3f6f9);
$parcel$export(module.exports, "NINPageLoad", () => $b6c8c5a5805d3a77$export$248c6c208e271182);
$parcel$export(module.exports, "NINEmbedPageLoad", () => $b6c8c5a5805d3a77$export$48368cea8238c302);
$parcel$export(module.exports, "markOnce", () => $b6c8c5a5805d3a77$export$243d158112bae094);

var $hqYEY = parcelRequire("hqYEY");

var $5fhUb = parcelRequire("5fhUb");

var $7jTnu = parcelRequire("7jTnu");
const $b6c8c5a5805d3a77$export$3a8025f2f3e0c64 = {
    ISSUE_NAVIGATOR_START: 'ISSUE_NAVIGATOR_START',
    ISSUE_NAVIGATOR_END: 'ISSUE_NAVIGATOR_END',
    ISSUE_NAVIGATOR_UI_START: 'ISSUE_NAVIGATOR_UI_START',
    ISSUE_NAVIGATOR_UI_END: 'ISSUE_NAVIGATOR_UI_END',
    PAGE_ACTIONS_START: 'PAGE_ACTIONS_START',
    PAGE_ACTIONS_END: 'PAGE_ACTIONS_END',
    PAGE_ACTIONS_VIEW_SWITCHER_START: 'PAGE_ACTIONS_VIEW_SWITCHER_START',
    PAGE_ACTIONS_VIEW_SWITCHER_END: 'PAGE_ACTIONS_VIEW_SWITCHER_END',
    REFINEMENT_START: 'REFINEMENT_START',
    REFINEMENT_END: 'REFINEMENT_END',
    ISSUE_RESULTS_START: 'ISSUE_RESULTS_START',
    ISSUE_RESULTS_END: 'ISSUE_RESULTS_END',
    ISSUE_RESULTS_DETAIL_VIEW_START: 'ISSUE_RESULTS_DETAIL_VIEW_START',
    ISSUE_RESULTS_DETAIL_VIEW_END: 'ISSUE_RESULTS_DETAIL_VIEW_END',
    ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START: 'ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START',
    ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END: 'ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END',
    ISSUE_RESULTS_LIST_VIEW_START: 'ISSUE_RESULTS_LIST_VIEW_START',
    ISSUE_RESULTS_LIST_VIEW_END: 'ISSUE_RESULTS_LIST_VIEW_END',
    ISSUE_RESULTS_LIST_VIEW_FOOTER_START: 'ISSUE_RESULTS_LIST_VIEW_FOOTER_START',
    ISSUE_RESULTS_LIST_VIEW_FOOTER_END: 'ISSUE_RESULTS_LIST_VIEW_FOOTER_END',
    ISSUE_APP_START: 'ISSUE_APP_START',
    ISSUE_APP_END: 'ISSUE_APP_END',
    ...(0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS)
};
const $b6c8c5a5805d3a77$export$8ba5b9245ec3f6f9 = (0, $hqYEY.metrics).pageSegmentLoad({
    key: 'new-issue-navigator-jql-builder',
    timings: [
        {
            key: 'product/issue-navigator/ui/jql-builder',
            startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_START,
            endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/hydrate',
            startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_HYDRATE_START,
            endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_HYDRATE_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-basic',
            startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_START,
            endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-basic/js',
            startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_JS_START,
            endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_JS_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-advanced',
            startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_START,
            endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-advanced/js',
            startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_JS_START,
            endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_JS_END
        }
    ],
    histogram: {
        initial: {
            fmp: '100_200_500_1000_2500_3000_4000_5000_10000',
            tti: '100_200_500_1000_2500_3000_4000_5000_10000'
        },
        transition: {
            fmp: '100_200_500_1000_2500_3000_4000_5000_10000',
            tti: '100_200_500_1000_2500_3000_4000_5000_10000'
        }
    },
    featureFlags: []
});
const $b6c8c5a5805d3a77$export$8c9c137679bb68c8 = (key)=>(0, $hqYEY.metrics).pageLoad({
        key: key,
        slo: {
            fmp: {
                initial: {
                    threshold: 3000
                },
                transition: {
                    threshold: 3000
                }
            },
            tti: {
                initial: {
                    threshold: 4000
                },
                transition: {
                    threshold: 4000
                }
            }
        },
        ssr: {
            doneAsFmp: true
        },
        timings: [
            {
                key: 'product/issue-navigator',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_END
            },
            {
                key: 'product/issue-navigator/ui',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_UI_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_UI_END
            },
            {
                key: 'product/issue-navigator/ui/page-actions',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.PAGE_ACTIONS_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.PAGE_ACTIONS_END
            },
            {
                key: 'product/issue-navigator/ui/page-actions/view-switcher',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.PAGE_ACTIONS_VIEW_SWITCHER_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.PAGE_ACTIONS_VIEW_SWITCHER_END
            },
            {
                key: 'product/issue-navigator/ui/refinement',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.REFINEMENT_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.REFINEMENT_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results/detail-view',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results/detail-view/card-list',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results/list-view',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results/list-view/footer',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_FOOTER_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_FOOTER_END
            },
            {
                key: 'product/issue-navigator/ui/issue-app',
                startMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_APP_START,
                endMark: $b6c8c5a5805d3a77$export$3a8025f2f3e0c64.ISSUE_APP_END
            }
        ],
        featureFlags: []
    });
const $b6c8c5a5805d3a77$export$248c6c208e271182 = $b6c8c5a5805d3a77$export$8c9c137679bb68c8('new-issue-navigator');
const $b6c8c5a5805d3a77$export$48368cea8238c302 = $b6c8c5a5805d3a77$export$8c9c137679bb68c8('new-issue-navigator-embed');
const $b6c8c5a5805d3a77$var$consumedMarks = [];
const $b6c8c5a5805d3a77$export$243d158112bae094 = (mark)=>{
    if (!$b6c8c5a5805d3a77$var$consumedMarks.includes(mark)) {
        $b6c8c5a5805d3a77$var$consumedMarks.push(mark);
        $b6c8c5a5805d3a77$export$248c6c208e271182.mark(mark);
        (0, $7jTnu.fg)('jira_nin_smart_link') && $b6c8c5a5805d3a77$export$48368cea8238c302.mark(mark);
        $b6c8c5a5805d3a77$export$8ba5b9245ec3f6f9.mark(mark);
    }
};

});
parcelRegister("5fhUb", function(module, exports) {

$parcel$export(module.exports, "JQL_BUILDER_PERFORMANCE_MARKS", () => $f65791ff64431993$export$5fd6d8ece357700d);
// Performance marks
const $f65791ff64431993$var$JQL_BUILDER_START = 'JQL_BUILDER_START';
const $f65791ff64431993$var$JQL_BUILDER_END = 'JQL_BUILDER_END';
const $f65791ff64431993$var$JQL_BUILDER_HYDRATE_START = 'JQL_BUILDER_HYDRATE_START';
const $f65791ff64431993$var$JQL_BUILDER_HYDRATE_END = 'JQL_BUILDER_HYDRATE_END';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_START = 'JQL_BUILDER_BASIC_START';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_END = 'JQL_BUILDER_BASIC_END';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_START = 'JQL_BUILDER_BASIC_JS_START';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_END = 'JQL_BUILDER_BASIC_JS_END';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_START = 'JQL_BUILDER_ADVANCED_START';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_END = 'JQL_BUILDER_ADVANCED_END';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_START = 'JQL_BUILDER_ADVANCED_JS_START';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_END = 'JQL_BUILDER_ADVANCED_JS_END';
const $f65791ff64431993$export$5fd6d8ece357700d = {
    JQL_BUILDER_START: /**
	 * JQL_BUILDER
	 * Count how long it takes to load the JQL Builder,
	 * from first render of async component to ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_START,
    JQL_BUILDER_END: $f65791ff64431993$var$JQL_BUILDER_END,
    JQL_BUILDER_HYDRATE_START: /**
	 * JQL_BUILDER_HYDRATE
	 * Count how long it takes from first try to use hydrated data
	 * to the momento is actually ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_HYDRATE_START,
    JQL_BUILDER_HYDRATE_END: $f65791ff64431993$var$JQL_BUILDER_HYDRATE_END,
    JQL_BUILDER_BASIC_JS_START: /**
	 * JQL_BUILDER_BASIC_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Basic js package
	 */ $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_START,
    JQL_BUILDER_BASIC_JS_END: $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_END,
    JQL_BUILDER_BASIC_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Basic,
	 * from first render of async basic component to ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_BASIC_START,
    JQL_BUILDER_BASIC_END: $f65791ff64431993$var$JQL_BUILDER_BASIC_END,
    JQL_BUILDER_ADVANCED_JS_START: /**
	 * JQL_BUILDER_ADVANCED_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Advanced js package
	 */ $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_START,
    JQL_BUILDER_ADVANCED_JS_END: $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_END,
    JQL_BUILDER_ADVANCED_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Advnaced,
	 * from first render of async advanced component to ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_ADVANCED_START,
    JQL_BUILDER_ADVANCED_END: $f65791ff64431993$var$JQL_BUILDER_ADVANCED_END
};

});


parcelRegister("3Ssg5", function(module, exports) {

$parcel$export(module.exports, "getJqlFromParamValues", () => $71a1073bd460eeca$export$52de656da34011c3);
$parcel$export(module.exports, "getSearchInput", () => $71a1073bd460eeca$export$2fa22ca814667ff4);
$parcel$export(module.exports, "useUpdateUrlQueryParamCallback", () => $71a1073bd460eeca$export$f6b4f46bd8314b51);

var $eJOHy = parcelRequire("eJOHy");

var $82cqT = parcelRequire("82cqT");

var $95O7y = parcelRequire("95O7y");

var $iRahl = parcelRequire("iRahl");
const $71a1073bd460eeca$export$52de656da34011c3 = (defaultJql, jqlParam, filter, /**
	 * when `filter` has a value that is not a standard numeric filter ID, consumers can provide a
	 * customMapper function to transform the filter value to a jql string. For example this is used
	 * by Project Issue Navigator to map filter query params such as '?filter=myopenissues into jql
	 * strings without calling the backend API
	 */ customMapper, /**
	 * callback in the event of jql being returned is different to the jqlParam value, such as when
	 * it is undefined and the default jql is being returned. This allows the caller to sync the new
	 * jql value with the `?jql=...` url query param
	 */ onMutateJqlParam)=>{
    let jql = jqlParam;
    if (typeof jql === 'string') return jql;
    if ((0, $82cqT.isFilterId)(filter)) return undefined;
    if (typeof filter === 'string' && customMapper) jql = customMapper(filter);
    if (jql === undefined) jql = defaultJql;
    if (jql !== jqlParam) onMutateJqlParam?.(jql);
    return jql;
};
const $71a1073bd460eeca$var$getFilter = (filterInput)=>(0, $82cqT.isFilterId)(filterInput) ? {
        value: filterInput,
        type: (0, $iRahl.FilterTypes).ID
    } : {
        value: filterInput,
        type: (0, $iRahl.FilterTypes).JQL
    };
const $71a1073bd460eeca$export$2fa22ca814667ff4 = (jqlInput, filterInput)=>{
    const filter = filterInput !== undefined ? $71a1073bd460eeca$var$getFilter(filterInput) : undefined;
    if (jqlInput === undefined) {
        if (filter === undefined) throw new Error('filter is missing for search input');
        return filter;
    }
    if (filter === undefined) return {
        jql: jqlInput,
        type: (0, $iRahl.SearchInputTypes).JQL
    };
    return {
        jql: jqlInput,
        filter: filter,
        type: (0, $iRahl.SearchInputTypes).FILTER_AND_JQL
    };
};
const $71a1073bd460eeca$export$f6b4f46bd8314b51 = (queryParamKey)=>{
    const [_, setQueryParam] = (0, $95O7y.useQueryParam)(queryParamKey);
    const setJqlQueryParamCallback = (0, $eJOHy.useCallback)((value)=>setQueryParam(value, 'replace'), [
        setQueryParam
    ]);
    return setJqlQueryParamCallback;
};

});

parcelRegister("dzJIl", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb6d1f3dba33ce49$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jmQek = parcelRequire("jmQek");

var $2UZ2Y = parcelRequire("2UZ2Y");

var $6zXPf = parcelRequire("6zXPf");

var $9I5E1 = parcelRequire("9I5E1");

var $2tWP9 = parcelRequire("2tWP9");

var $5OzqY = parcelRequire("5OzqY");

var $kEUB1 = parcelRequire("kEUB1");

var $aBIfT = parcelRequire("aBIfT");

var $7jTnu = parcelRequire("7jTnu");

var $foygf = parcelRequire("foygf");

var $epLyV = parcelRequire("epLyV");

var $7Nlco = parcelRequire("7Nlco");
const $cb6d1f3dba33ce49$var$ActionMenu = (customHeaderProps)=>{
    const { jql: jql, filterId: filterId, filterDetails: filterDetails, searchResultPageData: searchResultPageData, HierarchyToggle: HierarchyToggle, GroupByDropdown: GroupByDropdown, HideDoneToggle: HideDoneToggle, FiltersMenu: FiltersMenu, SaveResetViewSettingsButton: SaveResetViewSettingsButton, isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled, isGridNavigationEnabled: isGridNavigationEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isModifiedFilter: isModifiedFilter, onChangeFilter: onChangeFilter } = customHeaderProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Nlco.default), {
        jql: jql,
        filterId: filterId,
        isModifiedFilter: (0, $7jTnu.fg)('visual-refresh-headers-buttons') ? isModifiedFilter : filterDetails?.jql !== jql,
        searchResultPageData: searchResultPageData,
        HierarchyToggle: HierarchyToggle,
        GroupByDropdown: GroupByDropdown,
        HideDoneToggle: HideDoneToggle,
        FiltersMenu: FiltersMenu,
        SaveResetViewSettingsButton: SaveResetViewSettingsButton,
        isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled,
        isConditionalFormattingEnabled: (0, $7jTnu.fg)('jira_list_conditional_formatting') ? isConditionalFormattingEnabled : undefined,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        onChangeFilter: onChangeFilter
    });
};
const $cb6d1f3dba33ce49$var$actionMenuWithHideDoneSupport = (isHideDoneSupportEnabled)=>{
    return (customHeaderProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Nlco.default), {
            ...customHeaderProps,
            isHideDoneSupportEnabled: isHideDoneSupportEnabled
        });
    };
};
const $cb6d1f3dba33ce49$var$ProjectIssueNavigator = ({ projectKey: projectKey, showNav3Header: showNav3Header = false, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isHideDoneSupportEnabled: isHideDoneSupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled, isGridNavigationEnabled: isGridNavigationEnabled, ...rest })=>{
    const CustomHeader = (0, $eJOHy.useCallback)((customHeaderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $foygf.default), {
            projectKey: projectKey,
            ...customHeaderProps,
            isQuickFiltersDisabled: showNav3Header,
            isHideDoneSupportEnabled: isHideDoneSupportEnabled,
            isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled
        }), [
        isHideDoneSupportEnabled,
        isIssueHierarchySupportEnabled,
        projectKey,
        showNav3Header
    ]);
    const showNewNav = (0, $6zXPf.getWillShowNav4)() && !showNav3Header;
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $5OzqY.default));
    const cloudId = (0, $kEUB1.useCloudId)();
    (0, $eJOHy.useEffect)(()=>{
        loadQuery({
            projectKey: projectKey,
            cloudId: cloudId
        });
    }, [
        loadQuery,
        projectKey,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showNewNav && (queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $epLyV.default), {
        queryReference: queryReference
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBIfT.DocumentTitle), {
        title: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2UZ2Y.default), {
        ...!showNewNav && {
            CustomHeader: CustomHeader
        },
        ...showNewNav && {
            ActionMenu: (0, $7jTnu.fg)('jsc_bulk_edit_hide_done_work_items') ? $cb6d1f3dba33ce49$var$actionMenuWithHideDoneSupport(isHideDoneSupportEnabled) : $cb6d1f3dba33ce49$var$ActionMenu
        },
        HeaderSkeletonImage: (0, $2tWP9.ProjectIssueNavigatorHeaderSkeleton),
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        isIssueRankingSupportEnabled: isIssueRankingSupportEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isMergedColumnSupportEnabled: isMergedColumnSupportEnabled,
        ...rest
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmQek.default), {
        hasServiceDeskAccess: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9I5E1.JsdGettingStartedPanelShouldRender), null)));
};
const $cb6d1f3dba33ce49$export$b008d460035de468 = ({ projectKey: projectKey, showNewNav: showNewNav })=>{
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $5OzqY.default));
    const cloudId = (0, $kEUB1.useCloudId)();
    (0, $eJOHy.useEffect)(()=>{
        loadQuery({
            projectKey: projectKey,
            cloudId: cloudId
        });
    }, [
        loadQuery,
        projectKey,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showNewNav && (queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $epLyV.default), {
        queryReference: queryReference
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBIfT.DocumentTitle), {
        title: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmQek.default), {
        hasServiceDeskAccess: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9I5E1.JsdGettingStartedPanelShouldRender), null)));
};
var $cb6d1f3dba33ce49$export$2e2bcd8739ae039 = $cb6d1f3dba33ce49$var$ProjectIssueNavigator;

});
parcelRegister("2UZ2Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f5753a2111e6c64$export$2e2bcd8739ae039);

var $8BHcQ = parcelRequire("8BHcQ");

var $jXlpN = parcelRequire("jXlpN");

var $a2EpN = parcelRequire("a2EpN");

var $hLdpc = parcelRequire("hLdpc");

var $5RSPa = parcelRequire("5RSPa");

var $f5p42 = parcelRequire("f5p42");

var $gqVni = parcelRequire("gqVni");

var $hvATp = parcelRequire("hvATp");

var $93W2w = parcelRequire("93W2w");

var $4mFQO = parcelRequire("4mFQO");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $bJscI = parcelRequire("bJscI");

var $gHKwt = parcelRequire("gHKwt");

var $l8Ydr = parcelRequire("l8Ydr");

var $9edpF = parcelRequire("9edpF");

var $iRahl = parcelRequire("iRahl");

var $fAgUF = parcelRequire("fAgUF");

var $61oZD = parcelRequire("61oZD");

var $fwKw5 = parcelRequire("fwKw5");

var $cJdYi = parcelRequire("cJdYi");

var $1Puj1 = parcelRequire("1Puj1");

var $2kVBT = parcelRequire("2kVBT");

var $7QuRk = parcelRequire("7QuRk");

var $2y1A0 = parcelRequire("2y1A0");

var $7emTO = parcelRequire("7emTO");

var $lvpZz = parcelRequire("lvpZz");

var $aaLZH = parcelRequire("aaLZH");

var $3YMzi = parcelRequire("3YMzi");
const $8f5753a2111e6c64$export$e111e6466962b82b = (0, $4mFQO.default);
// We memo as an optimisation to reduce forced re-renders when the immediate parent renders. In this case it's
// AppContextualAnalytics which will re-render when interacting with the JQL builder, e.g. opening picker.
const $8f5753a2111e6c64$var$FilterAndJqlProvider = /*#__PURE__*/ (0, $eJOHy.memo)(({ children: children, jql: jql, refetch: refetch, filterId: filterId, isFilterEditable: isFilterEditable, filterJql: filterJql })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJdYi.FilterQueryProvider), {
        query: $8f5753a2111e6c64$export$e111e6466962b82b,
        refetch: refetch,
        filterId: filterId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fwKw5.ActiveJqlProvider), {
        filterId: filterId,
        filterJql: filterJql,
        jql: jql,
        isFilterEditable: isFilterEditable
    }, children)));
const $8f5753a2111e6c64$var$MaybeFilterAndJqlProvider = (0, $bJscI.componentWithFG)('jira_nin_last_used_jql', ({ children: children })=>children, $8f5753a2111e6c64$var$FilterAndJqlProvider);
const $8f5753a2111e6c64$var$MaybeIssueSearchInputProvider = (0, $bJscI.componentWithFG)('jira_nin_last_used_jql', (0, $3YMzi.IssueSearchInputProvider), ({ children: children })=>children);
const $8f5753a2111e6c64$var$getFilter = (searchParam)=>{
    if (searchParam?.type === (0, $iRahl.SearchInputTypes).JQL) return undefined;
    return searchParam.type === (0, $iRahl.SearchInputTypes).FILTER_AND_JQL ? searchParam.filter : searchParam;
};
const $8f5753a2111e6c64$var$IssueNavigator = ({ issueKey: issueKey, queryReference: queryReference, filterQueryReference: filterQueryReference, CustomHeader: CustomHeader, ActionMenu: ActionMenu, HeaderSkeletonImage: HeaderSkeletonImage, onChangeIssue: onChangeIssue, onChangeFilter: onChangeFilter, onRefinement: onRefinement, onPageDataLoad: onPageDataLoadProp, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onSetView: onSetView, defaultJql: defaultJql, searchInput: searchInput, jqlBuilderProps: jqlBuilderProps, issueTableProps: issueTableProps, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled, isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isGridNavigationEnabled: isGridNavigationEnabled })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_NAVIGATOR_START);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_NAVIGATOR_END);
    }, []);
    const [isInitialized, setIsInitialized] = (0, $eJOHy.useState)(false);
    const onPageDataLoad = (0, $eJOHy.useCallback)((...props)=>{
        if (!isInitialized) setIsInitialized(true);
        return onPageDataLoadProp?.(...props);
    }, [
        isInitialized,
        onPageDataLoadProp
    ]);
    const filterInput = searchInput ? $8f5753a2111e6c64$var$getFilter(searchInput) : undefined;
    const issueQuery = (0, $j4oe4.usePreloadedQuery)((0, $93W2w.default), queryReference);
    const refetchQuery = (0, $j4oe4.useFragment)((0, $hvATp.default), issueQuery);
    const [issueNavigatorRefetchDataNew, issueNavigatorRefetchNew] = (0, $j4oe4.useRefetchableFragment)((0, $gqVni.default), refetchQuery);
    const jiraViewData = issueNavigatorRefetchDataNew?.jira?.jiraIssueSearchView ?? null;
    const detailedViewPaginationFragment = (0, $j4oe4.usePaginationFragment)((0, $f5p42.default), jiraViewData?.__typename === 'JiraDetailedView' ? jiraViewData : null);
    const groupedListViewPaginationFragment = (0, $j4oe4.usePaginationFragment)((0, $5RSPa.default), jiraViewData?.__typename === 'JiraGroupedListView' ? jiraViewData : null);
    const listViewPaginationFragment = (0, $j4oe4.usePaginationFragment)((0, $hLdpc.default), jiraViewData?.__typename === 'JiraListView' ? jiraViewData : null);
    const userPreferencesData = (0, $j4oe4.useFragment)((0, $a2EpN.default), issueQuery.jira?.userPreferences ?? null);
    const jqlBuilderWithAiData = (0, $j4oe4.useFragment)((0, $jXlpN.default), issueQuery.jira);
    let activePaginationFragment = listViewPaginationFragment;
    let groupResultsData = null;
    let issueResultsData = listViewPaginationFragment?.data?.issues ?? null;
    if (detailedViewPaginationFragment.data) {
        activePaginationFragment = detailedViewPaginationFragment;
        issueResultsData = detailedViewPaginationFragment?.data?.issues ?? null;
    } else if (groupedListViewPaginationFragment.data) {
        activePaginationFragment = groupedListViewPaginationFragment;
        groupResultsData = groupedListViewPaginationFragment?.data?.groups ?? null;
    }
    const filterQuery = (0, $j4oe4.usePreloadedQuery)($8f5753a2111e6c64$export$e111e6466962b82b, filterQueryReference);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const [filterData, refetchFilter] = (0, $j4oe4.useRefetchableFragment)((0, $8BHcQ.default), filterQuery);
    /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ /**
   * initialQueryAsJql remembers the initial query on mount
   */ const [initialQueryAsJql] = (0, $eJOHy.useState)(()=>{
        if (!(0, $7jTnu.fg)('jracloud_85520_hydration_ref_only_on_page_load') || (0, $7jTnu.fg)('jira_nin_last_used_jql')) return undefined;
        // Use base input for plain JQL input OR
        // If both filter and JQL are present, JQL takes precedence
        if (searchInput.type === (0, $iRahl.SearchInputTypes).JQL || searchInput.type === (0, $iRahl.SearchInputTypes).FILTER_AND_JQL) return searchInput.jql;
        // Use filter JQL for manually-mapped filters like we use in Project Scope
        if (filterInput?.type === (0, $iRahl.FilterTypes).JQL) return filterInput.value;
        // Otherwise, use the saved filter JQL as returned by the backend
        return filterData?.jira?.filter?.jql;
    });
    let setFlatListIssues = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ setFlatListIssues: setFlatListIssues } = (0, $lvpZz.useFlatListIssuesActions)());
    const handleIssueFlatListUpdated = (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)((newFlatKeyList)=>{
        setFlatListIssues(newFlatKeyList);
    }, [
        setFlatListIssues
    ]) : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    const isConditionalFormattingEnabled = (0, $7jTnu.fg)('jira_list_conditional_formatting') && // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $aaLZH.useIssueNavigatorFeatures)().isConditionalFormattingEnabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $61oZD.AppContextualAnalytics), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8f5753a2111e6c64$export$6d44d4a22d5bca7a, {
        isEnabled: isConditionalFormattingEnabled,
        project: issueQuery.jira?.jiraProjectByKey ?? null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHKwt.SidebarContainer), {
        scope: (0, $iRahl.NIN_SIDEBAR_SCOPE),
        sidebarId: (0, $iRahl.ISSUE_NAVIGATOR_SIDEBAR_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8f5753a2111e6c64$var$MaybeIssueSearchInputProvider, {
        filterQuery: $8f5753a2111e6c64$export$e111e6466962b82b,
        jiraFilter: filterData?.jira?.filter ?? null,
        refetch: refetchFilter,
        searchInput: searchInput
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8f5753a2111e6c64$var$MaybeFilterAndJqlProvider, {
        refetch: refetchFilter,
        filterId: filterInput?.type === (0, $iRahl.FilterTypes).ID ? filterInput?.value : undefined,
        filterJql: filterInput?.type === (0, $iRahl.FilterTypes).JQL ? filterInput?.value : filterData?.jira?.filter?.jql,
        isFilterEditable: filterData.jira?.filter?.isEditable !== null ? filterData.jira?.filter?.isEditable : undefined,
        jql: searchInput?.type === (0, $iRahl.SearchInputTypes).FILTER_AND_JQL || searchInput?.type === (0, $iRahl.SearchInputTypes).JQL ? searchInput?.jql : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Puj1.IssueSearch), {
        onPageDataLoad: onPageDataLoad,
        jiraView: jiraViewData,
        refetch: issueNavigatorRefetchNew,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        project: issueQuery.jira?.jiraProjectByKey ?? null,
        ...((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') || (0, $7jTnu.fg)('jira_list_group_shadow_requests')) && {
            issueTableProps: issueTableProps
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7emTO.InfiniteScrollProvider), {
        onLoadNext: activePaginationFragment.loadNext,
        onLoadPrevious: activePaginationFragment.loadPrevious,
        isLoadingNext: activePaginationFragment.isLoadingNext,
        isLoadingPrevious: activePaginationFragment.isLoadingPrevious,
        hasNext: activePaginationFragment.hasNext,
        hasPrevious: activePaginationFragment.hasPrevious
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2y1A0.SelectedViewContainer), {
        onSetView: onSetView,
        jiraView: jiraViewData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7QuRk.SelectedIssue), {
        selectedIssueKey: issueKey,
        onChange: onChangeIssue,
        issues: issueResultsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2kVBT.default), {
        CustomHeader: CustomHeader,
        ActionMenu: ActionMenu,
        HeaderSkeletonImage: HeaderSkeletonImage,
        filter: filterData?.jira?.filter ?? null,
        onChangeIssue: onChangeIssue,
        onChangeFilter: onChangeFilter,
        onPageDataLoad: onPageDataLoad,
        onChangeColumnConfiguration: onChangeColumnConfiguration,
        onChangeJql: onChangeJql,
        onRefinement: onRefinement,
        defaultJql: defaultJql,
        issueResults: issueResultsData,
        groupResults: groupResultsData,
        project: issueQuery.jira?.jiraProjectByKey ?? null,
        userPreferences: userPreferencesData ?? null,
        jqlBuilderProps: jqlBuilderProps,
        jqlBuilderWithAiKey: jqlBuilderWithAiData ?? null,
        issueTableProps: issueTableProps,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        jiraView: jiraViewData,
        onIssueFlatListUpdated: handleIssueFlatListUpdated,
        initialQueryAsJql: initialQueryAsJql,
        isInitialized: isInitialized,
        isIssueRankingSupportEnabled: isIssueRankingSupportEnabled,
        isMergedColumnSupportEnabled: isMergedColumnSupportEnabled,
        isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        isGridNavigationEnabled: isGridNavigationEnabled
    }))))))))));
};
const $8f5753a2111e6c64$export$6d44d4a22d5bca7a = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('saved_list_view_technical_changes'), (0, $9edpF.ConditionalFormattingSidebarContainer), (0, $l8Ydr.ConditionalFormatting));
const $8f5753a2111e6c64$var$WithFlatListIssuesContainer = (Component)=>{
    const IssueNavigatorWithFlatListIssuesContainer = (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvpZz.FlatListIssuesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props));
    };
    return IssueNavigatorWithFlatListIssuesContainer;
};
const $8f5753a2111e6c64$var$ConditionalIssueNavigator = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes'), $8f5753a2111e6c64$var$WithFlatListIssuesContainer($8f5753a2111e6c64$var$IssueNavigator), $8f5753a2111e6c64$var$IssueNavigator);
var $8f5753a2111e6c64$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($8f5753a2111e6c64$var$ConditionalIssueNavigator);

});
parcelRegister("8BHcQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef19ccb9dbc8bbcf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0db0de983744de81785a47f3a71540bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $lVf1u = parcelRequire("lVf1u");
const $ef19ccb9dbc8bbcf$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "filterAri"
        },
        {
            "kind": "RootArgument",
            "name": "includeFilter"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $lVf1u.default)
        }
    },
    "name": "main_issueNavigator_IssueNavigator_filterQuery",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "includeFilter",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "id",
                                    "variableName": "filterAri"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "filter",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jql"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditable"
                                        }
                                    ],
                                    "type": "JiraCustomFilter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "IssueSearchInputProvider_jiraFilter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_Header_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "topBar_issueNavigator_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_ListView_filter"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$ef19ccb9dbc8bbcf$var$node.hash = "96adaeb0ea412a121f8c6bd7c6d18060";
var $ef19ccb9dbc8bbcf$export$2e2bcd8739ae039 = $ef19ccb9dbc8bbcf$var$node;

});
parcelRegister("lVf1u", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e2c08f1bdc8d1b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f8315a29bd5c7e5a2f590bc33608bf78>>
 * @relayHash 03d0b36dbfc0f84b81e3ca48e36a6e7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 04c1fba8df45d251a0f00e03bda2406c57347ce5fb839d27446ae6d7d61b8c00
const $2e2c08f1bdc8d1b4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FilterRefetchQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FilterRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "04c1fba8df45d251a0f00e03bda2406c57347ce5fb839d27446ae6d7d61b8c00",
            "metadata": {},
            "name": "FilterRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2e2c08f1bdc8d1b4$var$node.hash = "96adaeb0ea412a121f8c6bd7c6d18060";
var $2e2c08f1bdc8d1b4$export$2e2bcd8739ae039 = $2e2c08f1bdc8d1b4$var$node;

});


parcelRegister("jXlpN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4a944b87e96790c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9b849f64e4a61be907eaec3accbf05bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f4a944b87e96790c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_jira",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey"
        }
    ],
    "type": "JiraQuery"
};
$f4a944b87e96790c$var$node.hash = "e871bd0eb341a6573bd1df76ea8e5df1";
var $f4a944b87e96790c$export$2e2bcd8739ae039 = $f4a944b87e96790c$var$node;

});

parcelRegister("a2EpN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a823ca43a4c8e86$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1ecec124bc87c6002f2c45127804b4c1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2a823ca43a4c8e86$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_userPreferences",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigatorUI_userPreferences"
        }
    ],
    "type": "JiraUserPreferences"
};
$2a823ca43a4c8e86$var$node.hash = "1143e00ad7112d3bc319370b0e0a4b27";
var $2a823ca43a4c8e86$export$2e2bcd8739ae039 = $2a823ca43a4c8e86$var$node;

});

parcelRegister("hLdpc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f208a14eb04af0d7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c3e0f9d4a8bcf7869d491f4a2e95154d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $1mjO6 = parcelRequire("1mjO6");
const $f208a14eb04af0d7$var$node = function() {
    var v0 = [
        "issues"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "saveJQLToUserHistory"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $1mjO6.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_listViewData",
        "selections": [
            {
                "alias": "issues",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorListViewPagination__issues_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "selectedIssue_issueNavigator"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isConditionalFormattingEnabled",
                                "variableName": "isConditionalFormattingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Variable",
                                "name": "shouldQueryHasChildren",
                                "variableName": "shouldQueryHasChildren"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraListView"
    };
}();
$f208a14eb04af0d7$var$node.hash = "22a2814eefaacda9ce108e2fd8c70777";
var $f208a14eb04af0d7$export$2e2bcd8739ae039 = $f208a14eb04af0d7$var$node;

});
parcelRegister("1mjO6", function(module, exports) {

$parcel$export(module.exports, "default", () => $df160cc2d68f433d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<303bf33d9142b93c0493556b59fc2274>>
 * @relayHash e1fe8486fe1d12f2bacac87cf2461f1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 768f6ab069a36e335ff3aef06037702af80ff951e9a31bbb1efd7c4b81c76ea5

var $kZq2R = parcelRequire("kZq2R");

var $hHOEN = parcelRequire("hHOEN");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $hRj2m = parcelRequire("hRj2m");

var $jvWSl = parcelRequire("jvWSl");

var $2HLoK = parcelRequire("2HLoK");

var $kmr3r = parcelRequire("kmr3r");

var $bU8Sj = parcelRequire("bU8Sj");

var $gDQIG = parcelRequire("gDQIG");

var $clCUA = parcelRequire("clCUA");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");

var $7lcgt = parcelRequire("7lcgt");

var $iOvkB = parcelRequire("iOvkB");
const $df160cc2d68f433d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "saveJQLToUserHistory"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v16 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v17 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "id"
    }, v20 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "saveJQLToUserHistory",
            "variableName": "saveJQLToUserHistory"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "settings",
            "variableName": "settings"
        },
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v22 = {
        "kind": "ScalarField",
        "name": "key"
    }, v23 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v24 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "name"
    }, v26 = [
        v25 /*: any*/ 
    ], v27 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v28 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v30 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v31 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v33 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "type"
    }, v35 = {
        "kind": "ScalarField",
        "name": "value"
    }, v36 = [
        v35 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v37 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v38 = {
        "kind": "ClientExtension",
        "selections": [
            v37 /*: any*/ 
        ]
    }, v39 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v40 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v41 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v42 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v43 = {
        "kind": "ScalarField",
        "name": "text"
    }, v44 = {
        "kind": "InlineFragment",
        "selections": [
            v43 /*: any*/ ,
            v25 /*: any*/ ,
            v38 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v45 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v46 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v19 /*: any*/ 
        ]
    }, v47 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v48 = [
        v45 /*: any*/ 
    ], v49 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v50 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v51 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v52 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v53 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    }, v54 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v55 = {
        "kind": "ClientExtension",
        "selections": [
            v27 /*: any*/ 
        ]
    }, v56 = {
        "kind": "ScalarField",
        "name": "href"
    }, v57 = {
        "kind": "ScalarField",
        "name": "message"
    }, v58 = [
        v57 /*: any*/ 
    ], v59 = [
        v25 /*: any*/ ,
        v19 /*: any*/ 
    ], v60 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v61 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v43 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v62 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v46 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v63 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v64 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v63 /*: any*/ ,
                    v25 /*: any*/ ,
                    v19 /*: any*/ 
                ]
            },
            v19 /*: any*/ 
        ]
    }, v65 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v66 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v67 = {
        "kind": "ScalarField",
        "name": "number"
    }, v68 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v69 = [
        v18 /*: any*/ ,
        v19 /*: any*/ 
    ], v70 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v71 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v72 = [
        v70 /*: any*/ ,
        v21 /*: any*/ ,
        v71 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorListViewPaginationQuery",
            "selections": [
                {
                    "args": v16 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isConditionalFormattingEnabled",
                                    "variableName": "isConditionalFormattingEnabled"
                                },
                                v17 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "shouldQueryHasChildren",
                                    "variableName": "shouldQueryHasChildren"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_listViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorListViewPaginationQuery",
            "selections": [
                {
                    "args": v16 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v20 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isResolved"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                },
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": v26 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isHighlightedIssueRow"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatusField",
                                                                    "kind": "LinkedField",
                                                                    "name": "statusField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v28 /*: any*/ ,
                                                                        v31 /*: any*/ ,
                                                                        v19 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                                "status"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v18 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v28 /*: any*/ ,
                                                                                                v31 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"status\"])"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v32 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v33 /*: any*/ ,
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": v26 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v18 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 500
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v34 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldSetId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v34 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "TypeDiscriminator",
                                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                                },
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "serviceId"
                                                                                                                                },
                                                                                                                                v25 /*: any*/ ,
                                                                                                                                v19 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraAffectedServicesField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "cascadingOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "parentOptionValue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v36 /*: any*/ 
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "childOptionValue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v36 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraCascadingSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v39 /*: any*/ ,
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v40 /*: any*/ ,
                                                                                                                                        v41 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v42 /*: any*/ ,
                                                                                                                v25 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraDateTimePickerField"
                                                                                                        },
                                                                                                        v44 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "commentSummary",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "canAddComment"
                                                                                                                        },
                                                                                                                        v45 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraCommentSummaryField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "uri"
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraUrlField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v46 /*: any*/ ,
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v47 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldOptions",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v48 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v35 /*: any*/ ,
                                                                                                                                        v47 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                v49 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraCheckboxesField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedUsersConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                        v50 /*: any*/ ,
                                                                                                                                        v25 /*: any*/ ,
                                                                                                                                        v51 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v52 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "email"
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraTeamView",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedTeam",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "jiraSuppliedId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "jiraSuppliedName"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraTeamViewField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraEstimate",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "originalEstimate",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "timeInSeconds"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "timeTrackingSettings",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "workingHoursPerDay"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "workingDaysPerWeek"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "defaultFormat"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "defaultUnit"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v28 /*: any*/ ,
                                                                                                                                v25 /*: any*/ ,
                                                                                                                                v34 /*: any*/ ,
                                                                                                                                v38 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v40 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraRadioSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v39 /*: any*/ ,
                                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedVersionsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v25 /*: any*/ ,
                                                                                                                                        v40 /*: any*/ ,
                                                                                                                                        v41 /*: any*/ ,
                                                                                                                                        v54 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v39 /*: any*/ ,
                                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedGoals",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v22 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v55 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ClientExtension",
                                                                                                                    "selections": [
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        v37 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraGoalsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v39 /*: any*/ ,
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v56 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "pageContent",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v56 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v45 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                                },
                                                                                                                v38 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "objectId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "label"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "mediaClientConfig",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "clientId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "fileId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaBaseUrl"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaJwtToken"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "url48"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "QueryError",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "errors",
                                                                                                                    "plural": true,
                                                                                                                    "selections": v58 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCMDBField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": "componentsOld",
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v59 /*: any*/ 
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v43 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "date"
                                                                                                        },
                                                                                                        v25 /*: any*/ ,
                                                                                                        v60 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDatePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v42 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraEpic",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "epic",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v32 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "color"
                                                                                                                },
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraEpicLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "renderedFieldHtml"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFallbackField"
                                                                                                },
                                                                                                v44 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                v29 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusId"
                                                                                                                },
                                                                                                                v30 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v39 /*: any*/ ,
                                                                                                            "concreteType": "JiraLabelConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedLabelsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraLabel",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v25 /*: any*/ ,
                                                                                                                                v46 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v45 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                        },
                                                                                                        v25 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraLabelsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                v33 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v61 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v62 /*: any*/ ,
                                                                                                                        v64 /*: any*/ ,
                                                                                                                        v61 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v62 /*: any*/ ,
                                                                                                                        v64 /*: any*/ ,
                                                                                                                        v61 /*: any*/ ,
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v23 /*: any*/ ,
                                                                                                                        v65 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "issuetype",
                                                                                                                                                "project",
                                                                                                                                                "summary",
                                                                                                                                                "status"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v28 /*: any*/ ,
                                                                                                                                                                v43 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v28 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "issueType",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                                        v66 /*: any*/ ,
                                                                                                                                                                        v25 /*: any*/ ,
                                                                                                                                                                        v63 /*: any*/ ,
                                                                                                                                                                        v24 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v28 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "status",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                                                        {
                                                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "statusCategory",
                                                                                                                                                                            "plural": false,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                v19 /*: any*/ ,
                                                                                                                                                                                v29 /*: any*/ 
                                                                                                                                                                            ]
                                                                                                                                                                        }
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueTypeField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueType",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v66 /*: any*/ ,
                                                                                                                                                v24 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "summaryField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v28 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                        v31 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v25 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraParentIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "large"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraResolution",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "resolution",
                                                                                                            "plural": false,
                                                                                                            "selections": v59 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraResolutionField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedSprintsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSprint",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "sprintId"
                                                                                                                                },
                                                                                                                                v25 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "state"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "endDate"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSprintField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v18 /*: any*/ ,
                                                                                                                v50 /*: any*/ ,
                                                                                                                v51 /*: any*/ ,
                                                                                                                v25 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                v52 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v25 /*: any*/ ,
                                                                                                        v60 /*: any*/ ,
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v39 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v59 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraRichText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "richText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraADF",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "adfValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRichTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "requestType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v25 /*: any*/ ,
                                                                                                                v63 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "first",
                                                                                                                    "value": 1
                                                                                                                }
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLinkConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v45 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v65 /*: any*/ ,
                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": [
                                                                                                                                                {
                                                                                                                                                    "kind": "Literal",
                                                                                                                                                    "name": "ids",
                                                                                                                                                    "value": [
                                                                                                                                                        "statusCategory"
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "fieldsById",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v18 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v30 /*: any*/ 
                                                                                                                                                                    ],
                                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                                },
                                                                                                                                                                v19 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                        },
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "relationName"
                                                                                                                                },
                                                                                                                                v19 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "issueLinkConnection(first:1)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isStoryPointField"
                                                                                                        },
                                                                                                        v67 /*: any*/ ,
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                v67 /*: any*/ ,
                                                                                                                v68 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                v67 /*: any*/ ,
                                                                                                                v25 /*: any*/ ,
                                                                                                                v68 /*: any*/ ,
                                                                                                                v38 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraNumberField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGroupsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroupEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGroup",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v25 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "groupId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleGroupPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraFlag",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "flag",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "isFlagged"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraFlagField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraWatch",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "watch",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "count"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWatching"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraWatchesField"
                                                                                                },
                                                                                                v55 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v49 /*: any*/ ,
                                                                                                                        v55 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v47 /*: any*/ ,
                                                                                                                v19 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": v48 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        },
                                                                        v55 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "isConditionalFormattingEnabled",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": v39 /*: any*/ ,
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "componentId"
                                                                                                                                        },
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedUsersConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                        v50 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraPriority",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "priority",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "priorityId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraPriorityField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraProject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "project",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "projectId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraProjectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "version",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v54 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v66 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraIssueTypeField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": v39 /*: any*/ ,
                                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedVersionsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v54 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v69 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValues",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSelectableValueEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v69 /*: any*/ 
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraRadioSelectField"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "condition": "shouldQueryHasChildren",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "filterByProjectKeys",
                                                                    "variableName": "projectKeys"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "hasChildren"
                                                        },
                                                        {
                                                            "args": [
                                                                v17 /*: any*/ 
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "canHaveChildIssues"
                                                        }
                                                    ]
                                                },
                                                v55 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "firstIssuePosition"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastIssuePosition"
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "maxCursors",
                                                    "value": 7
                                                }
                                            ],
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": v72 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "last",
                                                    "plural": false,
                                                    "selections": v72 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "first",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        v70 /*: any*/ ,
                                                        v71 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "pageCursors(maxCursors:7)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalIssueSearchResultCount"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "issueSearchError",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "messages"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidJqlError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v57 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "errorType"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidSyntaxError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v58 /*: any*/ ,
                                                    "type": "JiraServerError"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCappingIssueSearchResult"
                                        },
                                        v55 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v20 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorListViewPagination__issues",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                }
                            ],
                            "type": "JiraListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "768f6ab069a36e335ff3aef06037702af80ff951e9a31bbb1efd7c4b81c76ea5",
            "metadata": {},
            "name": "IssueNavigatorListViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $kmr3r.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $7lcgt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": (0, $clCUA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default)
            }
        }
    };
}();
$df160cc2d68f433d$var$node.hash = "22a2814eefaacda9ce108e2fd8c70777";
var $df160cc2d68f433d$export$2e2bcd8739ae039 = $df160cc2d68f433d$var$node;

});


parcelRegister("5RSPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d6489ff355cb88f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b570b3e0f8f4461c72a50b219c951065>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $8uCGo = parcelRequire("8uCGo");
const $2d6489ff355cb88f$var$node = function() {
    var v0 = [
        "groups"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "kind": "RootArgument",
                "name": "isPaginating"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "saveJQLToUserHistory"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $8uCGo.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_groupedListViewData",
        "selections": [
            {
                "alias": "groups",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "concreteType": "JiraSpreadsheetGroupConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorGroupedListViewPagination__groups_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_groupResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraGroupedListView"
    };
}();
$2d6489ff355cb88f$var$node.hash = "7ad0fe727d1d7bbb1a71e7c82422f2c4";
var $2d6489ff355cb88f$export$2e2bcd8739ae039 = $2d6489ff355cb88f$var$node;

});
parcelRegister("8uCGo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cbb3fd77e3869fa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<360a6824ae8f82b6fa43a80d99c9c048>>
 * @relayHash 7892fbec0e7a9b93865c54c74025c1b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ccf7c9b2e8899b6e97bfb1ed151d746ea01b237031ddcf240c3bd6da7500e55

var $kZq2R = parcelRequire("kZq2R");

var $bFEtW = parcelRequire("bFEtW");

var $hHOEN = parcelRequire("hHOEN");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $hRj2m = parcelRequire("hRj2m");

var $jvWSl = parcelRequire("jvWSl");

var $2HLoK = parcelRequire("2HLoK");

var $bU8Sj = parcelRequire("bU8Sj");

var $gDQIG = parcelRequire("gDQIG");

var $clCUA = parcelRequire("clCUA");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");

var $7lcgt = parcelRequire("7lcgt");

var $iOvkB = parcelRequire("iOvkB");
const $7cbb3fd77e3869fa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "saveJQLToUserHistory"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "Variable",
        "name": "settings",
        "variableName": "settings"
    }, v19 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "groupBy",
            "variableName": "groupBy"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "saveJQLToUserHistory",
            "variableName": "saveJQLToUserHistory"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        v18 /*: any*/ 
    ], v20 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v21 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v22 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v23 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v24 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v25 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v24 /*: any*/ 
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "name"
    }, v27 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v17 /*: any*/ 
        ]
    }, v28 = [
        v26 /*: any*/ ,
        v27 /*: any*/ 
    ], v29 = {
        "kind": "ScalarField",
        "name": "groupId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v31 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v32 = {
        "kind": "ScalarField",
        "name": "value"
    }, v33 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v35 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v37 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v38 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v39 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v40 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v39 /*: any*/ 
        ]
    }, v41 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v39 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v42 = {
        "kind": "ScalarField",
        "name": "number"
    }, v43 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v44 = [
        v17 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "sprintId"
        },
        v26 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "state"
        },
        {
            "kind": "ScalarField",
            "name": "endDate"
        }
    ], v45 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "label",
                                "plural": false,
                                "selections": v28 /*: any*/ 
                            }
                        ],
                        "type": "JiraJqlLabelFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "group",
                                "plural": false,
                                "selections": [
                                    v17 /*: any*/ ,
                                    v29 /*: any*/ ,
                                    v26 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlGroupFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v17 /*: any*/ ,
                                    v30 /*: any*/ ,
                                    v26 /*: any*/ 
                                ]
                            },
                            v31 /*: any*/ 
                        ],
                        "type": "JiraJqlVersionFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v31 /*: any*/ ,
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "option",
                                "plural": false,
                                "selections": [
                                    v32 /*: any*/ ,
                                    v17 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlOptionFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueTypes",
                                "plural": true,
                                "selections": [
                                    v26 /*: any*/ ,
                                    v33 /*: any*/ ,
                                    v17 /*: any*/ ,
                                    v34 /*: any*/ ,
                                    v35 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlIssueTypeFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v31 /*: any*/ ,
                            {
                                "concreteType": "JiraResolution",
                                "kind": "LinkedField",
                                "name": "resolution",
                                "plural": false,
                                "selections": [
                                    v17 /*: any*/ ,
                                    v26 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlResolutionFieldValue"
                    }
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "priorityId"
                            },
                            v26 /*: any*/ ,
                            v36 /*: any*/ 
                        ]
                    },
                    v31 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v16 /*: any*/ ,
                            v17 /*: any*/ ,
                            v37 /*: any*/ ,
                            v26 /*: any*/ ,
                            v38 /*: any*/ 
                        ]
                    },
                    v31 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ ,
                            v26 /*: any*/ ,
                            v40 /*: any*/ 
                        ]
                    },
                    v31 /*: any*/ ,
                    v41 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ 
                ],
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ ,
                            v43 /*: any*/ ,
                            v32 /*: any*/ ,
                            v27 /*: any*/ 
                        ]
                    },
                    v31 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": v44 /*: any*/ 
                    },
                    v31 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            }
                        ]
                    },
                    v31 /*: any*/ 
                ],
                "type": "JiraJqlGoalsFieldValue"
            }
        ]
    }, v46 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v47 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v48 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v49 = {
        "kind": "ScalarField",
        "name": "message"
    }, v50 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "fieldSetsScope"
        },
        v18 /*: any*/ 
    ], v51 = {
        "kind": "ScalarField",
        "name": "key"
    }, v52 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v53 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v54 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v55 = {
        "kind": "ScalarField",
        "name": "type"
    }, v56 = [
        v32 /*: any*/ ,
        v17 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v57 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v58 = {
        "kind": "ClientExtension",
        "selections": [
            v57 /*: any*/ 
        ]
    }, v59 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v60 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v61 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v62 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v63 = {
        "kind": "ScalarField",
        "name": "text"
    }, v64 = {
        "kind": "InlineFragment",
        "selections": [
            v63 /*: any*/ ,
            v26 /*: any*/ ,
            v58 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v65 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v66 = [
        v65 /*: any*/ 
    ], v67 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v68 = {
        "kind": "ClientExtension",
        "selections": [
            v53 /*: any*/ 
        ]
    }, v69 = {
        "kind": "ScalarField",
        "name": "href"
    }, v70 = [
        v26 /*: any*/ ,
        v17 /*: any*/ 
    ], v71 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v72 = [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                v33 /*: any*/ ,
                v26 /*: any*/ ,
                v17 /*: any*/ 
            ]
        }
    ], v73 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v63 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v74 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v27 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v75 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v76 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v75 /*: any*/ ,
                    v26 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            },
            v17 /*: any*/ 
        ]
    }, v77 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v78 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorGroupedListViewPaginationQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "projectKey",
                                    "variableName": "projectKey"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_groupedListViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorGroupedListViewPaginationQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v19 /*: any*/ ,
                                    "concreteType": "JiraSpreadsheetGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "groups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraSpreadsheetGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v45 /*: any*/ ,
                                                        v46 /*: any*/ 
                                                    ]
                                                },
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                v47 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                v48 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "groupByField"
                                        },
                                        v21 /*: any*/ ,
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "statusCode"
                                                        }
                                                    ]
                                                },
                                                v49 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "isPaginating",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSpreadsheetGroup",
                                                    "kind": "LinkedField",
                                                    "name": "firstGroup",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        {
                                                            "args": v50 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v16 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssue",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v16 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                v51 /*: any*/ ,
                                                                                v52 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isResolved"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueTypeField",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v35 /*: any*/ ,
                                                                                                v17 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v17 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueTypeField",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v26 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ClientExtension",
                                                                                    "selections": [
                                                                                        v53 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isHighlightedIssueRow"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraStatusField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "statusField",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                v54 /*: any*/ ,
                                                                                                v17 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "ids",
                                                                                                    "value": [
                                                                                                        "status"
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldsById",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v16 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v54 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusField"
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 500
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSets",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldSet",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v55 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fields",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v16 /*: any*/ ,
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v55 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "TypeDiscriminator",
                                                                                                                            "abstractKey": "__isJiraIssueField"
                                                                                                                        },
                                                                                                                        v17 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraAffectedServiceConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedAffectedServicesConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraAffectedServiceEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraAffectedService",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "serviceId"
                                                                                                                                                        },
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v17 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraAffectedServicesField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCascadingOption",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "cascadingOption",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "parentOptionValue",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": v56 /*: any*/ 
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "childOptionValue",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": v56 /*: any*/ 
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v58 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraCascadingSelectField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": v59 /*: any*/ ,
                                                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "selectedComponentsConnection",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v60 /*: any*/ ,
                                                                                                                                                                v61 /*: any*/ ,
                                                                                                                                                                v17 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                                        },
                                                                                                                                        v58 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraComponentsField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v62 /*: any*/ ,
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v58 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                                                },
                                                                                                                                v64 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCommentSummary",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "commentSummary",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "canAddComment"
                                                                                                                                                },
                                                                                                                                                v65 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraCommentSummaryField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "uri"
                                                                                                                                        },
                                                                                                                                        v58 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraUrlField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraOption",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "fieldOption",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v32 /*: any*/ ,
                                                                                                                                                v27 /*: any*/ ,
                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                v43 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "fieldOptions",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": v66 /*: any*/ 
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v58 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraSingleSelectField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "selectedOptions",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraOption",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                                v32 /*: any*/ ,
                                                                                                                                                                v43 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v58 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraMultipleSelectField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "selectedOptions",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraOption",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                                v32 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v58 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraCheckboxesField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraUserConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "selectedUsersConnection",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraUserEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v16 /*: any*/ ,
                                                                                                                                                                v37 /*: any*/ ,
                                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                                v38 /*: any*/ ,
                                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                                v67 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "email"
                                                                                                                                                                        }
                                                                                                                                                                    ],
                                                                                                                                                                    "type": "AtlassianAccountUser"
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v58 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraMultipleSelectUserPickerField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraTeamView",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "selectedTeam",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "jiraSuppliedId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "jiraSuppliedName"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v58 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraTeamViewField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraTimeTrackingField",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "timeTrackingField",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraEstimate",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "originalEstimate",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                                    "name": "timeInSeconds"
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraTimeTrackingSettings",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "timeTrackingSettings",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                                    "name": "workingHoursPerDay"
                                                                                                                                                                },
                                                                                                                                                                {
                                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                                    "name": "workingDaysPerWeek"
                                                                                                                                                                },
                                                                                                                                                                {
                                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                                    "name": "defaultFormat"
                                                                                                                                                                },
                                                                                                                                                                {
                                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                                    "name": "defaultUnit"
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        },
                                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v55 /*: any*/ ,
                                                                                                                                                        v58 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                v17 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraOriginalTimeEstimateField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraOption",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "selectedOption",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "alias": "label",
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "value"
                                                                                                                                                },
                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                v60 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v58 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraRadioSelectField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": v59 /*: any*/ ,
                                                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "selectedVersionsConnection",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                                v60 /*: any*/ ,
                                                                                                                                                                v61 /*: any*/ ,
                                                                                                                                                                v30 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                                                        },
                                                                                                                                        v58 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v17 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "args": v59 /*: any*/ ,
                                                                                                                                            "concreteType": "JiraGoalConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "selectedGoals",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraGoalEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraGoal",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                                v51 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                v68 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "storageKey": "selectedGoals(first:1000)"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ClientExtension",
                                                                                                                                            "selections": [
                                                                                                                                                v53 /*: any*/ ,
                                                                                                                                                v57 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraGoalsField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": v59 /*: any*/ ,
                                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "confluenceRemoteIssueLinks",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                                v69 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                                                                    "kind": "Condition",
                                                                                                                                                                    "passingValue": true,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "pageContent",
                                                                                                                                                                            "plural": false,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                v16 /*: any*/ ,
                                                                                                                                                                                {
                                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        v69 /*: any*/ 
                                                                                                                                                                                    ],
                                                                                                                                                                                    "type": "JiraConfluencePageContentDetails"
                                                                                                                                                                                }
                                                                                                                                                                            ]
                                                                                                                                                                        }
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                v65 /*: any*/ 
                                                                                                                                            ],
                                                                                                                                            "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                                                        },
                                                                                                                                        v58 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbObjectConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedCmdbObjectsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCmdbObjectEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraCmdbObject",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "objectId"
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "label"
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraCmdbAvatar",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "avatar",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "mediaClientConfig",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "clientId"
                                                                                                                                                                        },
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "fileId"
                                                                                                                                                                        },
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "mediaBaseUrl"
                                                                                                                                                                        },
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "mediaJwtToken"
                                                                                                                                                                        }
                                                                                                                                                                    ]
                                                                                                                                                                },
                                                                                                                                                                {
                                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                                    "name": "url48"
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "concreteType": "QueryError",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "errors",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                v49 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraCMDBField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "alias": "componentsOld",
                                                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "selectedComponentsConnection",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": v70 /*: any*/ 
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraComponentsField"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        v63 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "date"
                                                                                                                                },
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v71 /*: any*/ ,
                                                                                                                                v58 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraDatePickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v62 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraDateTimePickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraEpic",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "epic",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v51 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "summary"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "color"
                                                                                                                                        },
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraEpicLinkField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "renderedFieldHtml"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraFallbackField"
                                                                                                                        },
                                                                                                                        v64 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusCategory",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v39 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "status",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "statusId"
                                                                                                                                        },
                                                                                                                                        v41 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraStatusField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "args": v59 /*: any*/ ,
                                                                                                                                    "concreteType": "JiraLabelConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedLabelsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraLabelEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraLabel",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": v28 /*: any*/ 
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v65 /*: any*/ 
                                                                                                                                    ],
                                                                                                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                                                },
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v58 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraLabelsField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": v72 /*: any*/ 
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": false,
                                                                                                                                    "selections": v72 /*: any*/ 
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "parentIssue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v51 /*: any*/ ,
                                                                                                                                        v73 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "parentIssue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v51 /*: any*/ ,
                                                                                                                                                v74 /*: any*/ ,
                                                                                                                                                v76 /*: any*/ ,
                                                                                                                                                v73 /*: any*/ ,
                                                                                                                                                v17 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "parentIssue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v51 /*: any*/ ,
                                                                                                                                                v74 /*: any*/ ,
                                                                                                                                                v76 /*: any*/ ,
                                                                                                                                                v73 /*: any*/ ,
                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                v52 /*: any*/ ,
                                                                                                                                                v77 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                                                    "kind": "Condition",
                                                                                                                                                    "passingValue": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "args": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "Literal",
                                                                                                                                                                    "name": "ids",
                                                                                                                                                                    "value": [
                                                                                                                                                                        "issuetype",
                                                                                                                                                                        "project",
                                                                                                                                                                        "summary",
                                                                                                                                                                        "status"
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ],
                                                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "fieldsById",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "edges",
                                                                                                                                                                    "plural": true,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "node",
                                                                                                                                                                            "plural": false,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                v16 /*: any*/ ,
                                                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                                                {
                                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                                                                        v63 /*: any*/ 
                                                                                                                                                                                    ],
                                                                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                                                                },
                                                                                                                                                                                {
                                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                                                                        {
                                                                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                                            "name": "issueType",
                                                                                                                                                                                            "plural": false,
                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                                                                v34 /*: any*/ ,
                                                                                                                                                                                                v26 /*: any*/ ,
                                                                                                                                                                                                v75 /*: any*/ ,
                                                                                                                                                                                                v35 /*: any*/ 
                                                                                                                                                                                            ]
                                                                                                                                                                                        }
                                                                                                                                                                                    ],
                                                                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                                                                },
                                                                                                                                                                                {
                                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                                                                        {
                                                                                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                                            "name": "status",
                                                                                                                                                                                            "plural": false,
                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                                                                v40 /*: any*/ 
                                                                                                                                                                                            ]
                                                                                                                                                                                        }
                                                                                                                                                                                    ],
                                                                                                                                                                                    "type": "JiraStatusField"
                                                                                                                                                                                }
                                                                                                                                                                            ]
                                                                                                                                                                        }
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ],
                                                                                                                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                                                    "kind": "Condition",
                                                                                                                                                    "passingValue": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issueTypeField",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v22 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "issueType",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v34 /*: any*/ ,
                                                                                                                                                                        v35 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ]
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraSingleLineTextField",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "summaryField",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v22 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatusField",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "statusField",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v17 /*: any*/ ,
                                                                                                                                                                v22 /*: any*/ ,
                                                                                                                                                                v54 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v58 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraParentIssueField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraPriority",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "priority",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v36 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v58 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraPriorityField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraProject",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "project",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v51 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraAvatar",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "avatar",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "large"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraProjectField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraResolution",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "resolution",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v70 /*: any*/ 
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraResolutionField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraSprintConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedSprintsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraSprintEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraSprint",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": v44 /*: any*/ 
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v58 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSprintField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "user",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                        v38 /*: any*/ ,
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                        v67 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                v71 /*: any*/ ,
                                                                                                                                v58 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "args": v59 /*: any*/ ,
                                                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedVersionsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": v70 /*: any*/ 
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraRichText",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "richText",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraADF",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "adfValue",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "convertedPlainText",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "plainText"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraRichTextField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraServiceManagementRequestType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "requestType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v75 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraServiceManagementRequestTypeField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "first",
                                                                                                                                            "value": 1
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueLinkConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueLinkConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v65 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueLinkEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueLink",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssue",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issue",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v77 /*: any*/ ,
                                                                                                                                                                v51 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "args": [
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "Literal",
                                                                                                                                                                            "name": "ids",
                                                                                                                                                                            "value": [
                                                                                                                                                                                "statusCategory"
                                                                                                                                                                            ]
                                                                                                                                                                        }
                                                                                                                                                                    ],
                                                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "fieldsById",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "edges",
                                                                                                                                                                            "plural": true,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                {
                                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                                    "name": "node",
                                                                                                                                                                                    "plural": false,
                                                                                                                                                                                    "selections": [
                                                                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                                                                        {
                                                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                                                            "selections": [
                                                                                                                                                                                                v41 /*: any*/ 
                                                                                                                                                                                            ],
                                                                                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                                                                                        },
                                                                                                                                                                                        v17 /*: any*/ 
                                                                                                                                                                                    ]
                                                                                                                                                                                }
                                                                                                                                                                            ]
                                                                                                                                                                        }
                                                                                                                                                                    ],
                                                                                                                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                                                },
                                                                                                                                                                v17 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                            "name": "relationName"
                                                                                                                                                        },
                                                                                                                                                        v17 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "issueLinkConnection(first:1)"
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraIssueLinkField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "isStoryPointField"
                                                                                                                                },
                                                                                                                                v42 /*: any*/ ,
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": false,
                                                                                                                                    "selections": [
                                                                                                                                        v42 /*: any*/ ,
                                                                                                                                        v78 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                                    "kind": "Condition",
                                                                                                                                    "passingValue": true,
                                                                                                                                    "selections": [
                                                                                                                                        v42 /*: any*/ ,
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v78 /*: any*/ ,
                                                                                                                                        v58 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v58 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraNumberField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v26 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "selectedGroupsConnection",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                                        v29 /*: any*/ 
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v58 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraFlag",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "flag",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "isFlagged"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraFlagField"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraWatch",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "watch",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "count"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "isWatching"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraWatchesField"
                                                                                                                        },
                                                                                                                        v68 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": v66 /*: any*/ 
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldSets(first:500)"
                                                                        },
                                                                        v68 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v47 /*: any*/ ,
                                                                        v48 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "totalIssueSearchResultCount"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isCappingIssueSearchResult"
                                                                },
                                                                v68 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v50 /*: any*/ ,
                                                            "filters": [
                                                                "fieldSetsInput",
                                                                "scope",
                                                                "settings"
                                                            ],
                                                            "handle": "connection",
                                                            "key": "firstGroupSection_nativeIssueTable__issues",
                                                            "kind": "LinkedHandle",
                                                            "name": "issues"
                                                        },
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v45 /*: any*/ ,
                                                        v46 /*: any*/ ,
                                                        v25 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v68 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v19 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorGroupedListViewPagination__groups",
                                    "kind": "LinkedHandle",
                                    "name": "groups"
                                }
                            ],
                            "type": "JiraGroupedListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2ccf7c9b2e8899b6e97bfb1ed151d746ea01b237031ddcf240c3bd6da7500e55",
            "metadata": {},
            "name": "IssueNavigatorGroupedListViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider": (0, $bFEtW.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $7lcgt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": (0, $clCUA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default)
            }
        }
    };
}();
$7cbb3fd77e3869fa$var$node.hash = "7ad0fe727d1d7bbb1a71e7c82422f2c4";
var $7cbb3fd77e3869fa$export$2e2bcd8739ae039 = $7cbb3fd77e3869fa$var$node;

});


parcelRegister("f5p42", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f72bbe489fa60ce$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fa9214c1542fa735b5b526d1e402e5ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $34Uv8 = parcelRequire("34Uv8");
const $2f72bbe489fa60ce$var$node = function() {
    var v0 = [
        "issues"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "saveJQLToUserHistory"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $34Uv8.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_detailedViewData",
        "selections": [
            {
                "alias": "issues",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorDetailedViewPagination__issues_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "selectedIssue_issueNavigator"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isConditionalFormattingEnabled",
                                "variableName": "isConditionalFormattingEnabled"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Literal",
                                "name": "shouldQueryHasChildren",
                                "value": false
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraDetailedView"
    };
}();
$2f72bbe489fa60ce$var$node.hash = "a94b8cf7516b80e2a57d7d4c570bbfaf";
var $2f72bbe489fa60ce$export$2e2bcd8739ae039 = $2f72bbe489fa60ce$var$node;

});
parcelRegister("34Uv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c97399cca3e554b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3558c5e8bceea32157e81d4029097824>>
 * @relayHash f086626bc0b891e545c90dd8baee83f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8aa9994954fe45447668c6a7f1e8b5bef965d51959cccc4173b2f92aa0aa3c36

var $kZq2R = parcelRequire("kZq2R");

var $hHOEN = parcelRequire("hHOEN");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $hRj2m = parcelRequire("hRj2m");

var $jvWSl = parcelRequire("jvWSl");

var $2HLoK = parcelRequire("2HLoK");

var $kmr3r = parcelRequire("kmr3r");

var $bU8Sj = parcelRequire("bU8Sj");

var $gDQIG = parcelRequire("gDQIG");

var $clCUA = parcelRequire("clCUA");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");

var $7lcgt = parcelRequire("7lcgt");

var $iOvkB = parcelRequire("iOvkB");
const $8c97399cca3e554b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "saveJQLToUserHistory"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v14 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "id"
    }, v17 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "saveJQLToUserHistory",
            "variableName": "saveJQLToUserHistory"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "settings",
            "variableName": "settings"
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v19 = {
        "kind": "ScalarField",
        "name": "key"
    }, v20 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v21 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "name"
    }, v23 = [
        v22 /*: any*/ 
    ], v24 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v25 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v27 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v28 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v27 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v30 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "type"
    }, v32 = {
        "kind": "ScalarField",
        "name": "value"
    }, v33 = [
        v32 /*: any*/ ,
        v16 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v34 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v35 = {
        "kind": "ClientExtension",
        "selections": [
            v34 /*: any*/ 
        ]
    }, v36 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v37 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v38 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v39 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v40 = {
        "kind": "ScalarField",
        "name": "text"
    }, v41 = {
        "kind": "InlineFragment",
        "selections": [
            v40 /*: any*/ ,
            v22 /*: any*/ ,
            v35 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v42 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v43 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v16 /*: any*/ 
        ]
    }, v44 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v45 = [
        v42 /*: any*/ 
    ], v46 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            v32 /*: any*/ 
        ]
    }, v47 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v48 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v49 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v50 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    }, v51 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v52 = {
        "kind": "ClientExtension",
        "selections": [
            v24 /*: any*/ 
        ]
    }, v53 = {
        "kind": "ScalarField",
        "name": "href"
    }, v54 = {
        "kind": "ScalarField",
        "name": "message"
    }, v55 = [
        v54 /*: any*/ 
    ], v56 = [
        v22 /*: any*/ ,
        v16 /*: any*/ 
    ], v57 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v58 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v59 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v43 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v60 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v61 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v60 /*: any*/ ,
                    v22 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            },
            v16 /*: any*/ 
        ]
    }, v62 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v63 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v64 = {
        "kind": "ScalarField",
        "name": "number"
    }, v65 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v66 = [
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v67 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v68 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v69 = [
        v67 /*: any*/ ,
        v18 /*: any*/ ,
        v68 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorDetailedViewPaginationQuery",
            "selections": [
                {
                    "args": v14 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isConditionalFormattingEnabled",
                                    "variableName": "isConditionalFormattingEnabled"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectKey",
                                    "variableName": "projectKey"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_detailedViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorDetailedViewPaginationQuery",
            "selections": [
                {
                    "args": v14 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isResolved"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v16 /*: any*/ 
                                                                    ]
                                                                },
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": v23 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                v24 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isHighlightedIssueRow"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraStatusField",
                                                                    "kind": "LinkedField",
                                                                    "name": "statusField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v25 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v16 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                                "status"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v15 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v25 /*: any*/ ,
                                                                                                v28 /*: any*/ 
                                                                                            ],
                                                                                            "type": "JiraStatusField"
                                                                                        },
                                                                                        v16 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"status\"])"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v29 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v30 /*: any*/ ,
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": v23 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v15 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 500
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v31 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldSetId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                v25 /*: any*/ ,
                                                                                                v31 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "TypeDiscriminator",
                                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                                },
                                                                                                v16 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "serviceId"
                                                                                                                                },
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                v16 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraAffectedServicesField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "cascadingOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "parentOptionValue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v33 /*: any*/ 
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "childOptionValue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v33 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v35 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraCascadingSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v36 /*: any*/ ,
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                        v38 /*: any*/ ,
                                                                                                                                        v16 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                },
                                                                                                                v35 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v39 /*: any*/ ,
                                                                                                                v22 /*: any*/ ,
                                                                                                                v35 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraDateTimePickerField"
                                                                                                        },
                                                                                                        v41 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "commentSummary",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "canAddComment"
                                                                                                                        },
                                                                                                                        v42 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraCommentSummaryField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "uri"
                                                                                                                },
                                                                                                                v35 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraUrlField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        v43 /*: any*/ ,
                                                                                                                        v16 /*: any*/ ,
                                                                                                                        v44 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldOptions",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v45 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v35 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                        v32 /*: any*/ ,
                                                                                                                                        v44 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v35 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                v46 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v35 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraCheckboxesField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedUsersConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v15 /*: any*/ ,
                                                                                                                                        v47 /*: any*/ ,
                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                        v48 /*: any*/ ,
                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                        v49 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "email"
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v35 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraTeamView",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedTeam",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "jiraSuppliedId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "jiraSuppliedName"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v35 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraTeamViewField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraEstimate",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "originalEstimate",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "timeInSeconds"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "timeTrackingSettings",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "workingHoursPerDay"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "workingDaysPerWeek"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "defaultFormat"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "defaultUnit"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v25 /*: any*/ ,
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                v31 /*: any*/ ,
                                                                                                                                v35 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v16 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v50 /*: any*/ ,
                                                                                                                        v16 /*: any*/ ,
                                                                                                                        v37 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v35 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraRadioSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v36 /*: any*/ ,
                                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedVersionsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                        v37 /*: any*/ ,
                                                                                                                                        v38 /*: any*/ ,
                                                                                                                                        v51 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                                },
                                                                                                                v35 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v16 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v36 /*: any*/ ,
                                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedGoals",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v52 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ClientExtension",
                                                                                                                    "selections": [
                                                                                                                        v24 /*: any*/ ,
                                                                                                                        v34 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraGoalsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v36 /*: any*/ ,
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                        v53 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "pageContent",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v15 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v53 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v42 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                                },
                                                                                                                v35 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "objectId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "label"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "mediaClientConfig",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "clientId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "fileId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaBaseUrl"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaJwtToken"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "url48"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "QueryError",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "errors",
                                                                                                                    "plural": true,
                                                                                                                    "selections": v55 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCMDBField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": "componentsOld",
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v56 /*: any*/ 
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v40 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "date"
                                                                                                        },
                                                                                                        v22 /*: any*/ ,
                                                                                                        v57 /*: any*/ ,
                                                                                                        v35 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDatePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v39 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraEpic",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "epic",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                v29 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "color"
                                                                                                                },
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraEpicLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "renderedFieldHtml"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFallbackField"
                                                                                                },
                                                                                                v41 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v26 /*: any*/ ,
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusId"
                                                                                                                },
                                                                                                                v27 /*: any*/ ,
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v36 /*: any*/ ,
                                                                                                            "concreteType": "JiraLabelConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedLabelsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraLabel",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                v43 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v42 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                        },
                                                                                                        v22 /*: any*/ ,
                                                                                                        v35 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraLabelsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v30 /*: any*/ ,
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                v58 /*: any*/ ,
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v59 /*: any*/ ,
                                                                                                                        v61 /*: any*/ ,
                                                                                                                        v58 /*: any*/ ,
                                                                                                                        v16 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v59 /*: any*/ ,
                                                                                                                        v61 /*: any*/ ,
                                                                                                                        v58 /*: any*/ ,
                                                                                                                        v16 /*: any*/ ,
                                                                                                                        v20 /*: any*/ ,
                                                                                                                        v62 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "issuetype",
                                                                                                                                                "project",
                                                                                                                                                "summary",
                                                                                                                                                "status"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v15 /*: any*/ ,
                                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v25 /*: any*/ ,
                                                                                                                                                                v40 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v25 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "issueType",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                                                        v63 /*: any*/ ,
                                                                                                                                                                        v22 /*: any*/ ,
                                                                                                                                                                        v60 /*: any*/ ,
                                                                                                                                                                        v21 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v25 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "status",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                                                        {
                                                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "statusCategory",
                                                                                                                                                                            "plural": false,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                v16 /*: any*/ ,
                                                                                                                                                                                v26 /*: any*/ 
                                                                                                                                                                            ]
                                                                                                                                                                        }
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueTypeField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v25 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueType",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v63 /*: any*/ ,
                                                                                                                                                v21 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "summaryField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v25 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v16 /*: any*/ ,
                                                                                                                                        v25 /*: any*/ ,
                                                                                                                                        v28 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v22 /*: any*/ ,
                                                                                                                v35 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraParentIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v22 /*: any*/ ,
                                                                                                        v35 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "large"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraResolution",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "resolution",
                                                                                                            "plural": false,
                                                                                                            "selections": v56 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraResolutionField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedSprintsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSprint",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "sprintId"
                                                                                                                                },
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "state"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "endDate"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v22 /*: any*/ ,
                                                                                                        v35 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSprintField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v15 /*: any*/ ,
                                                                                                                v47 /*: any*/ ,
                                                                                                                v48 /*: any*/ ,
                                                                                                                v22 /*: any*/ ,
                                                                                                                v16 /*: any*/ ,
                                                                                                                v49 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v22 /*: any*/ ,
                                                                                                        v57 /*: any*/ ,
                                                                                                        v35 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v36 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v56 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraRichText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "richText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraADF",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "adfValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRichTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "requestType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v60 /*: any*/ ,
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "first",
                                                                                                                    "value": 1
                                                                                                                }
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLinkConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v42 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v62 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": [
                                                                                                                                                {
                                                                                                                                                    "kind": "Literal",
                                                                                                                                                    "name": "ids",
                                                                                                                                                    "value": [
                                                                                                                                                        "statusCategory"
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "fieldsById",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v15 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v27 /*: any*/ 
                                                                                                                                                                    ],
                                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                                },
                                                                                                                                                                v16 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                        },
                                                                                                                                        v16 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "relationName"
                                                                                                                                },
                                                                                                                                v16 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "issueLinkConnection(first:1)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isStoryPointField"
                                                                                                        },
                                                                                                        v64 /*: any*/ ,
                                                                                                        v22 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                v64 /*: any*/ ,
                                                                                                                v65 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                v64 /*: any*/ ,
                                                                                                                v22 /*: any*/ ,
                                                                                                                v65 /*: any*/ ,
                                                                                                                v35 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v35 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraNumberField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGroupsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroupEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGroup",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v16 /*: any*/ ,
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "groupId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v35 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleGroupPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraFlag",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "flag",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "isFlagged"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraFlagField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraWatch",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "watch",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "count"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWatching"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraWatchesField"
                                                                                                },
                                                                                                v52 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v46 /*: any*/ ,
                                                                                                                        v52 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v44 /*: any*/ ,
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": v45 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        },
                                                                        v52 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "isConditionalFormattingEnabled",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": v36 /*: any*/ ,
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "componentId"
                                                                                                                                        },
                                                                                                                                        v16 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedUsersConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v15 /*: any*/ ,
                                                                                                                                        v47 /*: any*/ ,
                                                                                                                                        v16 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraPriority",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "priority",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "priorityId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraPriorityField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraProject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "project",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "projectId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraProjectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "version",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v51 /*: any*/ ,
                                                                                                                        v16 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v63 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraIssueTypeField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": v36 /*: any*/ ,
                                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedVersionsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v51 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v66 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValues",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSelectableValueEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v66 /*: any*/ 
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v50 /*: any*/ ,
                                                                                                                        v16 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraRadioSelectField"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                v52 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "firstIssuePosition"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastIssuePosition"
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "maxCursors",
                                                    "value": 7
                                                }
                                            ],
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": v69 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "last",
                                                    "plural": false,
                                                    "selections": v69 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "first",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v67 /*: any*/ ,
                                                        v68 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "pageCursors(maxCursors:7)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalIssueSearchResultCount"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "issueSearchError",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "messages"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidJqlError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v54 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "errorType"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidSyntaxError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v55 /*: any*/ ,
                                                    "type": "JiraServerError"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCappingIssueSearchResult"
                                        },
                                        v52 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v17 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorDetailedViewPagination__issues",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                }
                            ],
                            "type": "JiraDetailedView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8aa9994954fe45447668c6a7f1e8b5bef965d51959cccc4173b2f92aa0aa3c36",
            "metadata": {},
            "name": "IssueNavigatorDetailedViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $kmr3r.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $7lcgt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": (0, $clCUA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default)
            }
        }
    };
}();
$8c97399cca3e554b$var$node.hash = "a94b8cf7516b80e2a57d7d4c570bbfaf";
var $8c97399cca3e554b$export$2e2bcd8739ae039 = $8c97399cca3e554b$var$node;

});


parcelRegister("gqVni", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2654a22c88579ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b234734531c7f2d39a532edeaa756fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $koarv = parcelRequire("koarv");
const $a2654a22c88579ab$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "isConditionalFormattingEnabled",
        "variableName": "isConditionalFormattingEnabled"
    }, v1 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v2 = {
        "kind": "Variable",
        "name": "projectKeys",
        "variableName": "projectKeys"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "isPaginating"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "saveJQLToUserHistory"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryHasChildren"
            },
            {
                "kind": "RootArgument",
                "name": "staticViewInput"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            },
            {
                "kind": "RootArgument",
                "name": "viewQueryInput"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $koarv.default)
            }
        },
        "name": "main_issueNavigator_IssueNavigator_refetchQuery",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Variable",
                                "name": "filterId",
                                "variableName": "filterId"
                            },
                            {
                                "kind": "Variable",
                                "name": "issueSearchInput",
                                "variableName": "issueSearchInput"
                            },
                            {
                                "kind": "Variable",
                                "name": "namespace",
                                "variableName": "namespace"
                            },
                            {
                                "kind": "Variable",
                                "name": "viewConfigInput",
                                "variableName": "staticViewInput"
                            },
                            {
                                "kind": "Variable",
                                "name": "viewId",
                                "variableName": "viewId"
                            },
                            {
                                "kind": "Variable",
                                "name": "viewQueryInput",
                                "variableName": "viewQueryInput"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "jiraIssueSearchView",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__typename"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "issueSearch_issueNavigatorGrouping"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "main_issueNavigator_IssueNavigatorUI_jiraView"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "selectedView_issueNavigator_SelectedViewContainer"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": [
                                            v0 /*: any*/ ,
                                            v1 /*: any*/ ,
                                            v2 /*: any*/ 
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "main_issueNavigator_IssueNavigator_detailedViewData"
                                    }
                                ],
                                "type": "JiraDetailedView"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": [
                                            v1 /*: any*/ ,
                                            v2 /*: any*/ 
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "main_issueNavigator_IssueNavigator_groupedListViewData"
                                    }
                                ],
                                "type": "JiraGroupedListView"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": [
                                            v0 /*: any*/ ,
                                            v1 /*: any*/ ,
                                            v2 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "shouldQueryHasChildren",
                                                "variableName": "shouldQueryHasChildren"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "main_issueNavigator_IssueNavigator_listViewData"
                                    }
                                ],
                                "type": "JiraListView"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$a2654a22c88579ab$var$node.hash = "ab679a6833ea41671bd2fba044ae7d78";
var $a2654a22c88579ab$export$2e2bcd8739ae039 = $a2654a22c88579ab$var$node;

});
parcelRegister("koarv", function(module, exports) {

$parcel$export(module.exports, "default", () => $16a31e55c3f4e905$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0558400aff61c507806739571db33168>>
 * @relayHash 89f5701246ec3194b2febc500ef5e53d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f6d0582326f4ed867245d680d330c8709ac0e699603d07dfa105127c47bf5614

var $kZq2R = parcelRequire("kZq2R");

var $bFEtW = parcelRequire("bFEtW");

var $lcRgI = parcelRequire("lcRgI");

var $hHOEN = parcelRequire("hHOEN");

var $2Z4v6 = parcelRequire("2Z4v6");

var $eylLg = parcelRequire("eylLg");

var $4MVMw = parcelRequire("4MVMw");

var $iiQfx = parcelRequire("iiQfx");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $hRj2m = parcelRequire("hRj2m");

var $jvWSl = parcelRequire("jvWSl");

var $2HLoK = parcelRequire("2HLoK");

var $kmr3r = parcelRequire("kmr3r");

var $bU8Sj = parcelRequire("bU8Sj");

var $gDQIG = parcelRequire("gDQIG");

var $clCUA = parcelRequire("clCUA");

var $8Qoc7 = parcelRequire("8Qoc7");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");

var $cqnj8 = parcelRequire("cqnj8");

var $7lcgt = parcelRequire("7lcgt");

var $iOvkB = parcelRequire("iOvkB");
const $16a31e55c3f4e905$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "saveJQLToUserHistory"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "settings"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewQueryInput"
    }, v25 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v26 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v27 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v28 = {
        "kind": "ScalarField",
        "name": "message"
    }, v29 = [
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v27 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        },
        v28 /*: any*/ 
    ], v30 = {
        "kind": "ScalarField",
        "name": "id"
    }, v31 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "fieldSetsScope"
    }, v32 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        },
        v31 /*: any*/ 
    ], v33 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v34 = {
        "kind": "ScalarField",
        "name": "savedViewId"
    }, v35 = {
        "kind": "Variable",
        "name": "settings",
        "variableName": "settings"
    }, v36 = {
        "kind": "Variable",
        "name": "groupBy",
        "variableName": "groupBy"
    }, v37 = [
        v36 /*: any*/ ,
        v26 /*: any*/ ,
        v35 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v38 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v39 = {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraField",
                "kind": "LinkedField",
                "name": "groupByField",
                "plural": false,
                "selections": [
                    v38 /*: any*/ ,
                    v30 /*: any*/ 
                ]
            }
        ]
    }, v40 = {
        "kind": "ScalarField",
        "name": "hideDone"
    }, v41 = {
        "kind": "ScalarField",
        "name": "isHierarchyEnabled"
    }, v42 = [
        v34 /*: any*/ 
    ], v43 = {
        "kind": "ScalarField",
        "name": "isGroupingEnabled"
    }, v44 = {
        "kind": "ScalarField",
        "name": "canEnableGrouping"
    }, v45 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v46 = {
        "kind": "ScalarField",
        "name": "type"
    }, v47 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v48 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v49 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v50 = {
        "kind": "ClientExtension",
        "selections": [
            v49 /*: any*/ 
        ]
    }, v51 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v42 /*: any*/ 
    }, v52 = {
        "kind": "ScalarField",
        "name": "canEnableHierarchy"
    }, v53 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v54 = {
        "kind": "ScalarField",
        "name": "name"
    }, v55 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v56 = {
        "kind": "Variable",
        "name": "before",
        "variableName": "before"
    }, v57 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v58 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v59 = {
        "kind": "Variable",
        "name": "last",
        "variableName": "last"
    }, v60 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v61 = {
        "kind": "Variable",
        "name": "saveJQLToUserHistory",
        "variableName": "saveJQLToUserHistory"
    }, v62 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v63 = [
        v55 /*: any*/ ,
        v56 /*: any*/ ,
        v57 /*: any*/ ,
        v58 /*: any*/ ,
        v26 /*: any*/ ,
        v59 /*: any*/ ,
        v60 /*: any*/ ,
        v61 /*: any*/ ,
        v62 /*: any*/ ,
        v35 /*: any*/ 
    ], v64 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v65 = {
        "kind": "ScalarField",
        "name": "key"
    }, v66 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v67 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v68 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v69 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v68 /*: any*/ ,
                    v30 /*: any*/ 
                ]
            },
            v30 /*: any*/ 
        ]
    }, v70 = [
        v54 /*: any*/ 
    ], v71 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueType",
                        "plural": false,
                        "selections": v70 /*: any*/ 
                    }
                ]
            }
        ]
    }, v72 = {
        "kind": "ClientExtension",
        "selections": [
            v49 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isHighlightedIssueRow"
            }
        ]
    }, v73 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v74 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v73 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v75 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v74 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v76 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraStatusField",
                "kind": "LinkedField",
                "name": "statusField",
                "plural": false,
                "selections": [
                    v38 /*: any*/ ,
                    v75 /*: any*/ ,
                    v30 /*: any*/ 
                ]
            }
        ]
    }, v77 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "ids",
                        "value": [
                            "status"
                        ]
                    }
                ],
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fieldsById",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v27 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v38 /*: any*/ ,
                                            v75 /*: any*/ 
                                        ],
                                        "type": "JiraStatusField"
                                    },
                                    v30 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "fieldsById(ids:[\"status\"])"
            }
        ]
    }, v78 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v79 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v80 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v27 /*: any*/ ,
            v30 /*: any*/ ,
            v65 /*: any*/ ,
            v66 /*: any*/ ,
            v67 /*: any*/ ,
            v69 /*: any*/ ,
            v71 /*: any*/ ,
            v72 /*: any*/ ,
            v76 /*: any*/ ,
            v77 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v78 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v79 /*: any*/ ,
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": v70 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v81 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v82 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v83 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v54 /*: any*/ ,
                                    v30 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v84 = {
        "kind": "ScalarField",
        "name": "value"
    }, v85 = [
        v84 /*: any*/ ,
        v30 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v86 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v87 = {
        "kind": "ClientExtension",
        "selections": [
            v86 /*: any*/ 
        ]
    }, v88 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v89 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v90 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v91 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v92 = {
        "kind": "ScalarField",
        "name": "text"
    }, v93 = {
        "kind": "InlineFragment",
        "selections": [
            v92 /*: any*/ ,
            v54 /*: any*/ ,
            v87 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v94 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v30 /*: any*/ 
        ]
    }, v95 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v96 = [
        v45 /*: any*/ 
    ], v97 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v84 /*: any*/ 
        ]
    }, v98 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v99 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v100 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v101 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    }, v102 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v103 = {
        "kind": "ScalarField",
        "name": "href"
    }, v104 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "concreteType": "JiraCascadingOption",
                        "kind": "LinkedField",
                        "name": "cascadingOption",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "parentOptionValue",
                                "plural": false,
                                "selections": v85 /*: any*/ 
                            },
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "childOptionValue",
                                "plural": false,
                                "selections": v85 /*: any*/ 
                            }
                        ]
                    },
                    v87 /*: any*/ 
                ],
                "type": "JiraCascadingSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "args": v88 /*: any*/ ,
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v89 /*: any*/ ,
                                            v90 /*: any*/ ,
                                            v30 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedComponentsConnection(first:1000)"
                    },
                    v87 /*: any*/ 
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v91 /*: any*/ ,
                    v54 /*: any*/ ,
                    v87 /*: any*/ 
                ],
                "type": "JiraDateTimePickerField"
            },
            v93 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraCommentSummary",
                        "kind": "LinkedField",
                        "name": "commentSummary",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "canAddComment"
                            },
                            v45 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraCommentSummaryField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "uri"
                    },
                    v87 /*: any*/ 
                ],
                "type": "JiraUrlField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "fieldOption",
                        "plural": false,
                        "selections": [
                            v84 /*: any*/ ,
                            v94 /*: any*/ ,
                            v30 /*: any*/ ,
                            v95 /*: any*/ 
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionConnection",
                                "kind": "LinkedField",
                                "name": "fieldOptions",
                                "plural": false,
                                "selections": v96 /*: any*/ 
                            }
                        ]
                    },
                    v87 /*: any*/ 
                ],
                "type": "JiraSingleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v30 /*: any*/ ,
                                            v84 /*: any*/ ,
                                            v95 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v87 /*: any*/ 
                ],
                "type": "JiraMultipleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    v97 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v87 /*: any*/ 
                ],
                "type": "JiraCheckboxesField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "concreteType": "JiraUserConnection",
                        "kind": "LinkedField",
                        "name": "selectedUsersConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v27 /*: any*/ ,
                                            v98 /*: any*/ ,
                                            v54 /*: any*/ ,
                                            v99 /*: any*/ ,
                                            v30 /*: any*/ ,
                                            v100 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "email"
                                                    }
                                                ],
                                                "type": "AtlassianAccountUser"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v87 /*: any*/ 
                ],
                "type": "JiraMultipleSelectUserPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "concreteType": "JiraTeamView",
                        "kind": "LinkedField",
                        "name": "selectedTeam",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedName"
                            }
                        ]
                    },
                    v87 /*: any*/ 
                ],
                "type": "JiraTeamViewField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v30 /*: any*/ ,
                                    {
                                        "concreteType": "JiraEstimate",
                                        "kind": "LinkedField",
                                        "name": "originalEstimate",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "timeInSeconds"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraTimeTrackingSettings",
                                        "kind": "LinkedField",
                                        "name": "timeTrackingSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingHoursPerDay"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingDaysPerWeek"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultFormat"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultUnit"
                                            }
                                        ]
                                    },
                                    v38 /*: any*/ ,
                                    v54 /*: any*/ ,
                                    v46 /*: any*/ ,
                                    v87 /*: any*/ 
                                ]
                            },
                            v30 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraOriginalTimeEstimateField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "selectedOption",
                        "plural": false,
                        "selections": [
                            v101 /*: any*/ ,
                            v30 /*: any*/ ,
                            v89 /*: any*/ 
                        ]
                    },
                    v87 /*: any*/ 
                ],
                "type": "JiraRadioSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "args": v88 /*: any*/ ,
                        "concreteType": "JiraVersionConnection",
                        "kind": "LinkedField",
                        "name": "selectedVersionsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraVersionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v30 /*: any*/ ,
                                            v54 /*: any*/ ,
                                            v89 /*: any*/ ,
                                            v90 /*: any*/ ,
                                            v102 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedVersionsConnection(first:1000)"
                    },
                    v87 /*: any*/ 
                ],
                "type": "JiraMultipleVersionPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            v30 /*: any*/ 
                        ]
                    },
                    {
                        "args": v88 /*: any*/ ,
                        "concreteType": "JiraGoalConnection",
                        "kind": "LinkedField",
                        "name": "selectedGoals",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v30 /*: any*/ ,
                                            v65 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            v50 /*: any*/ 
                        ],
                        "storageKey": "selectedGoals(first:1000)"
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            v49 /*: any*/ ,
                            v86 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraGoalsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "args": v88 /*: any*/ ,
                        "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                        "kind": "LinkedField",
                        "name": "confluenceRemoteIssueLinks",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v30 /*: any*/ ,
                                            v103 /*: any*/ ,
                                            {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "pageContent",
                                                        "plural": false,
                                                        "selections": [
                                                            v27 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v103 /*: any*/ 
                                                                ],
                                                                "type": "JiraConfluencePageContentDetails"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v45 /*: any*/ 
                        ],
                        "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                    },
                    v87 /*: any*/ 
                ],
                "type": "JiraConfluenceRemoteIssueLinksField"
            }
        ]
    }, v105 = [
        v28 /*: any*/ 
    ], v106 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": v105 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v107 = [
        v54 /*: any*/ ,
        v30 /*: any*/ 
    ], v108 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "componentsOld",
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": v107 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v92 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v109 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v110 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v54 /*: any*/ ,
            v109 /*: any*/ ,
            v87 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v111 = {
        "kind": "InlineFragment",
        "selections": [
            v91 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v112 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v65 /*: any*/ ,
                    v78 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v30 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v113 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v114 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v54 /*: any*/ ,
                    v73 /*: any*/ ,
                    v30 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v115 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v74 /*: any*/ ,
                    v30 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v116 = [
        v54 /*: any*/ ,
        v94 /*: any*/ 
    ], v117 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v88 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v116 /*: any*/ 
                            }
                        ]
                    },
                    v45 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v54 /*: any*/ ,
            v87 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v118 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v92 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v119 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v94 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v120 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v121 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v120 /*: any*/ ,
                    v54 /*: any*/ ,
                    v30 /*: any*/ 
                ]
            },
            v30 /*: any*/ 
        ]
    }, v122 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v123 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v124 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v73 /*: any*/ 
        ]
    }, v125 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v65 /*: any*/ ,
                    v118 /*: any*/ ,
                    v30 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v65 /*: any*/ ,
                            v119 /*: any*/ ,
                            v121 /*: any*/ ,
                            v118 /*: any*/ ,
                            v30 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v65 /*: any*/ ,
                            v119 /*: any*/ ,
                            v121 /*: any*/ ,
                            v118 /*: any*/ ,
                            v30 /*: any*/ ,
                            v66 /*: any*/ ,
                            v122 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "ids",
                                                "value": [
                                                    "issuetype",
                                                    "project",
                                                    "summary",
                                                    "status"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldsById",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v27 /*: any*/ ,
                                                            v30 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v38 /*: any*/ ,
                                                                    v92 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v38 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v30 /*: any*/ ,
                                                                            v123 /*: any*/ ,
                                                                            v54 /*: any*/ ,
                                                                            v120 /*: any*/ ,
                                                                            v68 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraIssueTypeField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v38 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v30 /*: any*/ ,
                                                                            v124 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraStatusField"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                    }
                                ]
                            },
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueTypeField",
                                        "kind": "LinkedField",
                                        "name": "issueTypeField",
                                        "plural": false,
                                        "selections": [
                                            v38 /*: any*/ ,
                                            {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "issueType",
                                                "plural": false,
                                                "selections": [
                                                    v123 /*: any*/ ,
                                                    v68 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraSingleLineTextField",
                                        "kind": "LinkedField",
                                        "name": "summaryField",
                                        "plural": false,
                                        "selections": [
                                            v38 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraStatusField",
                                        "kind": "LinkedField",
                                        "name": "statusField",
                                        "plural": false,
                                        "selections": [
                                            v30 /*: any*/ ,
                                            v38 /*: any*/ ,
                                            v75 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v54 /*: any*/ ,
                    v87 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v126 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v127 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v54 /*: any*/ ,
                    v126 /*: any*/ ,
                    v30 /*: any*/ 
                ]
            },
            v54 /*: any*/ ,
            v87 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v128 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v54 /*: any*/ ,
                    v65 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v30 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v129 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v107 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v130 = [
        v30 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "sprintId"
        },
        v54 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "state"
        },
        {
            "kind": "ScalarField",
            "name": "endDate"
        }
    ], v131 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v130 /*: any*/ 
                            }
                        ]
                    }
                ]
            },
            v54 /*: any*/ ,
            v87 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v132 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v27 /*: any*/ ,
                    v98 /*: any*/ ,
                    v99 /*: any*/ ,
                    v54 /*: any*/ ,
                    v30 /*: any*/ ,
                    v100 /*: any*/ 
                ]
            },
            v54 /*: any*/ ,
            v109 /*: any*/ ,
            v87 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v133 = {
        "kind": "InlineFragment",
        "selections": [
            v54 /*: any*/ ,
            {
                "args": v88 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v107 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v134 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v135 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v54 /*: any*/ ,
                    v120 /*: any*/ ,
                    v30 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v136 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v45 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v122 /*: any*/ ,
                                            v65 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v27 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v74 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v30 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v30 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v30 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v137 = {
        "kind": "ScalarField",
        "name": "number"
    }, v138 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v139 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v137 /*: any*/ ,
            v54 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    v137 /*: any*/ ,
                    v138 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v137 /*: any*/ ,
                    v54 /*: any*/ ,
                    v138 /*: any*/ ,
                    v87 /*: any*/ 
                ]
            },
            v87 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v140 = {
        "kind": "ScalarField",
        "name": "groupId"
    }, v141 = {
        "kind": "InlineFragment",
        "selections": [
            v54 /*: any*/ ,
            {
                "concreteType": "JiraGroupConnection",
                "kind": "LinkedField",
                "name": "selectedGroupsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v30 /*: any*/ ,
                                    v54 /*: any*/ ,
                                    v140 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v87 /*: any*/ 
        ],
        "type": "JiraMultipleGroupPickerField"
    }, v142 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraFlag",
                        "kind": "LinkedField",
                        "name": "flag",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFlagged"
                            }
                        ]
                    }
                ],
                "type": "JiraFlagField"
            }
        ]
    }, v143 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraWatch",
                "kind": "LinkedField",
                "name": "watch",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isWatching"
                    }
                ]
            }
        ],
        "type": "JiraWatchesField"
    }, v144 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v96 /*: any*/ 
    }, v145 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v146 = [
        v27 /*: any*/ ,
        v30 /*: any*/ 
    ], v147 = {
        "args": v81 /*: any*/ ,
        "concreteType": "JiraIssueFieldSetConnection",
        "kind": "LinkedField",
        "name": "fieldSets",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v46 /*: any*/ ,
                            v33 /*: any*/ ,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v27 /*: any*/ ,
                                                    v38 /*: any*/ ,
                                                    v46 /*: any*/ ,
                                                    v82 /*: any*/ ,
                                                    v30 /*: any*/ ,
                                                    v83 /*: any*/ ,
                                                    v104 /*: any*/ ,
                                                    v106 /*: any*/ ,
                                                    v108 /*: any*/ ,
                                                    v110 /*: any*/ ,
                                                    v111 /*: any*/ ,
                                                    v112 /*: any*/ ,
                                                    v113 /*: any*/ ,
                                                    v93 /*: any*/ ,
                                                    v114 /*: any*/ ,
                                                    v115 /*: any*/ ,
                                                    v117 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v54 /*: any*/ ,
                                                                    v79 /*: any*/ ,
                                                                    v30 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v125 /*: any*/ ,
                                                    v127 /*: any*/ ,
                                                    v128 /*: any*/ ,
                                                    v129 /*: any*/ ,
                                                    v131 /*: any*/ ,
                                                    v132 /*: any*/ ,
                                                    v133 /*: any*/ ,
                                                    v134 /*: any*/ ,
                                                    v135 /*: any*/ ,
                                                    v136 /*: any*/ ,
                                                    v139 /*: any*/ ,
                                                    v141 /*: any*/ ,
                                                    v142 /*: any*/ ,
                                                    v143 /*: any*/ ,
                                                    v50 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOptionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOptions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOptionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v97 /*: any*/ ,
                                                                            v50 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraCheckboxesField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "fieldOption",
                                                                "plural": false,
                                                                "selections": [
                                                                    v95 /*: any*/ ,
                                                                    v30 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectField"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v144 /*: any*/ 
                                ]
                            },
                            v50 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "isConditionalFormattingEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "args": v88 /*: any*/ ,
                                                                        "concreteType": "JiraComponentConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedComponentsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraComponentEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraComponent",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "componentId"
                                                                                            },
                                                                                            v30 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "selectedComponentsConnection(first:1000)"
                                                                    }
                                                                ],
                                                                "type": "JiraComponentsField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraUserConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedUsersConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraUserEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v27 /*: any*/ ,
                                                                                            v98 /*: any*/ ,
                                                                                            v30 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraMultipleSelectUserPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraPriority",
                                                                        "kind": "LinkedField",
                                                                        "name": "priority",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v145 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraPriorityField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "projectId"
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraProjectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraVersion",
                                                                        "kind": "LinkedField",
                                                                        "name": "version",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v102 /*: any*/ ,
                                                                            v30 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraSingleVersionPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v123 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraIssueTypeField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "args": v88 /*: any*/ ,
                                                                        "concreteType": "JiraVersionConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedVersionsConnection",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraVersionEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraVersion",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v102 /*: any*/ 
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "storageKey": "selectedVersionsConnection(first:1000)"
                                                                    }
                                                                ],
                                                                "type": "JiraMultipleVersionPickerField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedValue",
                                                                        "plural": false,
                                                                        "selections": v146 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "JiraSingleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSelectableValueConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedValues",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSelectableValueEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": v146 /*: any*/ 
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraMultipleSelectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOption",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedOption",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v101 /*: any*/ ,
                                                                            v30 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraRadioSelectField"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldSets(first:500)"
    }, v148 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v149 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v150 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v148 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            v149 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            }
        ]
    }, v151 = {
        "concreteType": "JiraIssueNavigatorPageInfo",
        "kind": "LinkedField",
        "name": "issueNavigatorPageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "firstIssuePosition"
            },
            {
                "kind": "ScalarField",
                "name": "lastIssuePosition"
            }
        ]
    }, v152 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v153 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v154 = [
        v152 /*: any*/ ,
        v64 /*: any*/ ,
        v153 /*: any*/ 
    ], v155 = {
        "args": [
            {
                "kind": "Literal",
                "name": "maxCursors",
                "value": 7
            }
        ],
        "concreteType": "JiraPageCursors",
        "kind": "LinkedField",
        "name": "pageCursors",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": v154 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "last",
                "plural": false,
                "selections": v154 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "first",
                "plural": false,
                "selections": [
                    v64 /*: any*/ ,
                    v152 /*: any*/ ,
                    v153 /*: any*/ 
                ]
            }
        ],
        "storageKey": "pageCursors(maxCursors:7)"
    }, v156 = {
        "kind": "ScalarField",
        "name": "totalIssueSearchResultCount"
    }, v157 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v27 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v28 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ],
                "type": "JiraInvalidSyntaxError"
            },
            {
                "kind": "InlineFragment",
                "selections": v105 /*: any*/ ,
                "type": "JiraServerError"
            }
        ]
    }, v158 = {
        "kind": "ScalarField",
        "name": "isCappingIssueSearchResult"
    }, v159 = [
        "issueSearchInput"
    ], v160 = [
        v55 /*: any*/ ,
        v56 /*: any*/ ,
        v58 /*: any*/ ,
        v36 /*: any*/ ,
        v26 /*: any*/ ,
        v59 /*: any*/ ,
        v61 /*: any*/ ,
        v62 /*: any*/ ,
        v35 /*: any*/ 
    ], v161 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v162 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v33 /*: any*/ 
        ]
    }, v163 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v27 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v48 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "label",
                                "plural": false,
                                "selections": v116 /*: any*/ 
                            }
                        ],
                        "type": "JiraJqlLabelFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraGroup",
                                "kind": "LinkedField",
                                "name": "group",
                                "plural": false,
                                "selections": [
                                    v30 /*: any*/ ,
                                    v140 /*: any*/ ,
                                    v54 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlGroupFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v30 /*: any*/ ,
                                    v102 /*: any*/ ,
                                    v54 /*: any*/ 
                                ]
                            },
                            v47 /*: any*/ 
                        ],
                        "type": "JiraJqlVersionFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v47 /*: any*/ ,
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "option",
                                "plural": false,
                                "selections": [
                                    v84 /*: any*/ ,
                                    v30 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlOptionFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueTypes",
                                "plural": true,
                                "selections": [
                                    v54 /*: any*/ ,
                                    v79 /*: any*/ ,
                                    v30 /*: any*/ ,
                                    v123 /*: any*/ ,
                                    v68 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlIssueTypeFieldValue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v47 /*: any*/ ,
                            {
                                "concreteType": "JiraResolution",
                                "kind": "LinkedField",
                                "name": "resolution",
                                "plural": false,
                                "selections": [
                                    v30 /*: any*/ ,
                                    v54 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "JiraJqlResolutionFieldValue"
                    }
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            v30 /*: any*/ ,
                            v145 /*: any*/ ,
                            v54 /*: any*/ ,
                            v126 /*: any*/ 
                        ]
                    },
                    v47 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v27 /*: any*/ ,
                            v30 /*: any*/ ,
                            v98 /*: any*/ ,
                            v54 /*: any*/ ,
                            v99 /*: any*/ 
                        ]
                    },
                    v47 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v30 /*: any*/ ,
                            v54 /*: any*/ ,
                            v124 /*: any*/ 
                        ]
                    },
                    v47 /*: any*/ ,
                    v74 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v137 /*: any*/ 
                ],
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v30 /*: any*/ ,
                            v95 /*: any*/ ,
                            v84 /*: any*/ ,
                            v94 /*: any*/ 
                        ]
                    },
                    v47 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": v130 /*: any*/ 
                    },
                    v47 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v30 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            }
                        ]
                    },
                    v47 /*: any*/ 
                ],
                "type": "JiraJqlGoalsFieldValue"
            }
        ]
    }, v164 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v165 = [
        v57 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        v31 /*: any*/ ,
        v35 /*: any*/ 
    ], v166 = [
        {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "issueType",
            "plural": false,
            "selections": [
                v79 /*: any*/ ,
                v54 /*: any*/ ,
                v30 /*: any*/ 
            ]
        }
    ], v167 = [
        v55 /*: any*/ ,
        v56 /*: any*/ ,
        v57 /*: any*/ ,
        v58 /*: any*/ ,
        v26 /*: any*/ ,
        v59 /*: any*/ ,
        v60 /*: any*/ ,
        v61 /*: any*/ ,
        v62 /*: any*/ ,
        v35 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isConditionalFormattingEnabled",
                            "variableName": "isConditionalFormattingEnabled"
                        },
                        v25 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_refetchQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "filterId",
                                    "variableName": "filterId"
                                },
                                v26 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "namespace",
                                    "variableName": "namespace"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewConfigInput",
                                    "variableName": "staticViewInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewId",
                                    "variableName": "viewId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "viewQueryInput",
                                    "variableName": "viewQueryInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "jiraIssueSearchView",
                            "plural": false,
                            "selections": [
                                v27 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraView"
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "error",
                                    "plural": false,
                                    "selections": v29 /*: any*/ 
                                },
                                v30 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "viewId"
                                        },
                                        {
                                            "args": v32 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraFieldSetPreferences",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetPreferences",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isFrozen"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canPublishViewConfig"
                                                },
                                                v34 /*: any*/ ,
                                                {
                                                    "args": [
                                                        v35 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "isViewConfigModified"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v37 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                v40 /*: any*/ ,
                                                                v41 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": v42 /*: any*/ 
                                        }
                                    ],
                                    "type": "JiraIssueSearchViewMetadata",
                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v37 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                            "kind": "LinkedField",
                                            "name": "viewSettings",
                                            "plural": false,
                                            "selections": [
                                                v43 /*: any*/ ,
                                                v44 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v40 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": [
                                                        v31 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "hasDefaultFieldSets"
                                                },
                                                {
                                                    "args": v32 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v46 /*: any*/ ,
                                                                        v47 /*: any*/ ,
                                                                        v48 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v47 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "aliases"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldsMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueSearchMetadataField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canBeConfigured"
                                                                                                        },
                                                                                                        v38 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v50 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v51 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v37 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "viewSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v41 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        v44 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSpreadsheetView",
                                                            "abstractKey": "__isJiraSpreadsheetView"
                                                        }
                                                    ]
                                                },
                                                v51 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v37 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v40 /*: any*/ ,
                                                                v52 /*: any*/ ,
                                                                v39 /*: any*/ ,
                                                                v41 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canEnableReranking"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                v50 /*: any*/ 
                                            ],
                                            "type": "JiraIssueSearchViewMetadata",
                                            "abstractKey": "__isJiraIssueSearchViewMetadata"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v53 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "filterId"
                                                        },
                                                        {
                                                            "args": v37 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroupByConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "groupByConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraField",
                                                                            "kind": "LinkedField",
                                                                            "name": "groupByField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v54 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "typeKey"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                }
                                            ],
                                            "type": "JiraView",
                                            "abstractKey": "__isJiraView"
                                        }
                                    ],
                                    "type": "JiraSpreadsheetView",
                                    "abstractKey": "__isJiraSpreadsheetView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v63 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v64 /*: any*/ ,
                                                        v80 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        v147 /*: any*/ ,
                                                        v50 /*: any*/ 
                                                    ]
                                                },
                                                v150 /*: any*/ ,
                                                v151 /*: any*/ ,
                                                v155 /*: any*/ ,
                                                v156 /*: any*/ ,
                                                v157 /*: any*/ ,
                                                v53 /*: any*/ ,
                                                v158 /*: any*/ ,
                                                v50 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v63 /*: any*/ ,
                                            "filters": v159 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorDetailedViewPagination__issues",
                                            "kind": "LinkedHandle",
                                            "name": "issues"
                                        }
                                    ],
                                    "type": "JiraDetailedView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v160 /*: any*/ ,
                                            "concreteType": "JiraSpreadsheetGroupConnection",
                                            "kind": "LinkedField",
                                            "name": "groups",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSpreadsheetGroupEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v64 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroup",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v53 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                v161 /*: any*/ ,
                                                                v162 /*: any*/ ,
                                                                v163 /*: any*/ ,
                                                                v164 /*: any*/ 
                                                            ]
                                                        },
                                                        v27 /*: any*/ 
                                                    ]
                                                },
                                                v150 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "groupByField"
                                                },
                                                v53 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v29 /*: any*/ 
                                                },
                                                {
                                                    "condition": "isPaginating",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroup",
                                                            "kind": "LinkedField",
                                                            "name": "firstGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "args": v165 /*: any*/ ,
                                                                    "concreteType": "JiraIssueConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v27 /*: any*/ ,
                                                                                v64 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v30 /*: any*/ ,
                                                                                        v65 /*: any*/ ,
                                                                                        v66 /*: any*/ ,
                                                                                        v67 /*: any*/ ,
                                                                                        v69 /*: any*/ ,
                                                                                        v71 /*: any*/ ,
                                                                                        v72 /*: any*/ ,
                                                                                        v76 /*: any*/ ,
                                                                                        v77 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "args": v81 /*: any*/ ,
                                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldSets",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v46 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fields",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v27 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v46 /*: any*/ ,
                                                                                                                                v82 /*: any*/ ,
                                                                                                                                v30 /*: any*/ ,
                                                                                                                                v83 /*: any*/ ,
                                                                                                                                v104 /*: any*/ ,
                                                                                                                                v106 /*: any*/ ,
                                                                                                                                v108 /*: any*/ ,
                                                                                                                                v110 /*: any*/ ,
                                                                                                                                v111 /*: any*/ ,
                                                                                                                                v112 /*: any*/ ,
                                                                                                                                v113 /*: any*/ ,
                                                                                                                                v93 /*: any*/ ,
                                                                                                                                v114 /*: any*/ ,
                                                                                                                                v115 /*: any*/ ,
                                                                                                                                v117 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                                                                    "kind": "Condition",
                                                                                                                                                    "passingValue": true,
                                                                                                                                                    "selections": v166 /*: any*/ 
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": false,
                                                                                                                                            "selections": v166 /*: any*/ 
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                },
                                                                                                                                v125 /*: any*/ ,
                                                                                                                                v127 /*: any*/ ,
                                                                                                                                v128 /*: any*/ ,
                                                                                                                                v129 /*: any*/ ,
                                                                                                                                v131 /*: any*/ ,
                                                                                                                                v132 /*: any*/ ,
                                                                                                                                v133 /*: any*/ ,
                                                                                                                                v134 /*: any*/ ,
                                                                                                                                v135 /*: any*/ ,
                                                                                                                                v136 /*: any*/ ,
                                                                                                                                v139 /*: any*/ ,
                                                                                                                                v141 /*: any*/ ,
                                                                                                                                v142 /*: any*/ ,
                                                                                                                                v143 /*: any*/ ,
                                                                                                                                v50 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v144 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "fieldSets(first:500)"
                                                                                },
                                                                                v50 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "PageInfo",
                                                                            "kind": "LinkedField",
                                                                            "name": "pageInfo",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v148 /*: any*/ ,
                                                                                v149 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v156 /*: any*/ ,
                                                                        v158 /*: any*/ ,
                                                                        v50 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": v165 /*: any*/ ,
                                                                    "filters": [
                                                                        "fieldSetsInput",
                                                                        "scope",
                                                                        "settings"
                                                                    ],
                                                                    "handle": "connection",
                                                                    "key": "firstGroupSection_nativeIssueTable__issues",
                                                                    "kind": "LinkedHandle",
                                                                    "name": "issues"
                                                                },
                                                                v53 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                v161 /*: any*/ ,
                                                                v163 /*: any*/ ,
                                                                v164 /*: any*/ ,
                                                                v162 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v50 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v160 /*: any*/ ,
                                            "filters": v159 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorGroupedListViewPagination__groups",
                                            "kind": "LinkedHandle",
                                            "name": "groups"
                                        }
                                    ],
                                    "type": "JiraGroupedListView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v167 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v64 /*: any*/ ,
                                                        v80 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        v147 /*: any*/ ,
                                                        {
                                                            "condition": "shouldQueryHasChildren",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "filterByProjectKeys",
                                                                            "variableName": "projectKeys"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "hasChildren"
                                                                },
                                                                {
                                                                    "args": [
                                                                        v25 /*: any*/ 
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "canHaveChildIssues"
                                                                }
                                                            ]
                                                        },
                                                        v50 /*: any*/ 
                                                    ]
                                                },
                                                v150 /*: any*/ ,
                                                v151 /*: any*/ ,
                                                v155 /*: any*/ ,
                                                v156 /*: any*/ ,
                                                v157 /*: any*/ ,
                                                v53 /*: any*/ ,
                                                v158 /*: any*/ ,
                                                v50 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v167 /*: any*/ ,
                                            "filters": v159 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorListViewPagination__issues",
                                            "kind": "LinkedHandle",
                                            "name": "issues"
                                        }
                                    ],
                                    "type": "JiraListView"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f6d0582326f4ed867245d680d330c8709ac0e699603d07dfa105127c47bf5614",
            "metadata": {},
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": (0, $iiQfx.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx": (0, $lcRgI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider": (0, $eylLg.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $7lcgt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider": (0, $4MVMw.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider": (0, $cqnj8.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $kmr3r.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": (0, $2HLoK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $iOvkB.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $hHOEN.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": (0, $clCUA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": (0, $gDQIG.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider": (0, $bFEtW.default)
            }
        }
    };
}();
$16a31e55c3f4e905$var$node.hash = "ab679a6833ea41671bd2fba044ae7d78";
var $16a31e55c3f4e905$export$2e2bcd8739ae039 = $16a31e55c3f4e905$var$node;

});


parcelRegister("hvATp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d130483f9c16df38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3bf5ab4011d52937be39190a9cf1bc26>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d130483f9c16df38$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_issueQuery",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigator_refetchQuery"
        }
    ],
    "type": "Query"
};
$d130483f9c16df38$var$node.hash = "8c05992acdea71bbce4724d5223762c7";
var $d130483f9c16df38$export$2e2bcd8739ae039 = $d130483f9c16df38$var$node;

});

parcelRegister("gHKwt", function(module, exports) {

$parcel$export(module.exports, "SidebarContainer", () => $e04239c887251cad$export$f39f3f768bc98e3d);
$parcel$export(module.exports, "useSidebar", () => $e04239c887251cad$export$54c70f22f548bff8);
$parcel$export(module.exports, "useSidebarActions", () => $e04239c887251cad$export$685a45ff9d61633f);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $ftN6c = parcelRequire("ftN6c");


var $gRiLa = parcelRequire("gRiLa");
const $e04239c887251cad$export$dbc37fcbd226eb52 = (0, $6E16M.createContainer)();
const $e04239c887251cad$export$f39f3f768bc98e3d = ({ children: children, scope: scope, sidebarId: sidebarId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e04239c887251cad$export$dbc37fcbd226eb52, {
        scope: scope,
        sidebarId: sidebarId,
        createAnalyticsEvent: createAnalyticsEvent
    }, children);
};
const $e04239c887251cad$var$Store = (0, $GtRbT.createStore)({
    name: (0, $e8c1aaa176754652$export$cd79d01fb3d2f506),
    containedBy: $e04239c887251cad$export$dbc37fcbd226eb52,
    initialState: {
        id: null,
        content: null
    },
    actions: $gRiLa.actions
});
const $e04239c887251cad$export$54c70f22f548bff8 = (0, $iJq0l.createHook)($e04239c887251cad$var$Store);
const $e04239c887251cad$export$685a45ff9d61633f = (0, $iJq0l.createActionsHook)($e04239c887251cad$var$Store);

});
const $e8c1aaa176754652$export$cd79d01fb3d2f506 = 'JiraPlatformSidebarStore';
const $e8c1aaa176754652$export$b8b9d90f9e5bd72b = 'jiraPlatformSidebar';

parcelRegister("gRiLa", function(module, exports) {

$parcel$export(module.exports, "actions", () => $c346f43c05bbe3c6$export$e324594224ef24da);

var $gCeeo = parcelRequire("gCeeo");

var $eSnSE = parcelRequire("eSnSE");
const $c346f43c05bbe3c6$var$fireSidebarAnalytics = (experienceId, analyticsProps, eventType)=>{
    const { sidebarId: sidebarId, createAnalyticsEvent: createAnalyticsEvent } = analyticsProps;
    const sidebarLocationId = `jira${sidebarId}SidebarExperience`;
    try {
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), `${sidebarLocationId} ${eventType}`, {
            experienceId: experienceId
        });
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraPlatformSidebar', error instanceof Error ? error.message : `Error firing analytics event for sidebar with id ${sidebarId}`);
    }
};
const $c346f43c05bbe3c6$var$fireStartSidebarAnalytics = (experienceId, analyticsProps)=>{
    $c346f43c05bbe3c6$var$fireSidebarAnalytics(experienceId, analyticsProps, 'started');
};
const $c346f43c05bbe3c6$var$fireCloseSidebarAnalytics = (experienceId, analyticsProps)=>{
    $c346f43c05bbe3c6$var$fireSidebarAnalytics(experienceId, analyticsProps, 'ended');
};
const $c346f43c05bbe3c6$var$setExperienceId = (id)=>({ setState: setState, getState: getState }, analyticsProps)=>{
        const state = getState();
        const newState = {
            id: id,
            content: null
        };
        const newId = newState.id;
        const previousId = state.id;
        if (analyticsProps.sidebarId) {
            $c346f43c05bbe3c6$var$fireStartSidebarAnalytics(newId, analyticsProps);
            if (previousId != null) $c346f43c05bbe3c6$var$fireCloseSidebarAnalytics(previousId, analyticsProps);
        }
        setState({
            ...state,
            ...newState
        });
    };
const $c346f43c05bbe3c6$var$closeSidebar = ()=>({ setState: setState, getState: getState }, analyticsProps)=>{
        const state = getState();
        const newState = {
            id: null,
            content: null
        };
        if (analyticsProps.sidebarId && state.id) $c346f43c05bbe3c6$var$fireCloseSidebarAnalytics(state.id, analyticsProps);
        setState({
            ...state,
            ...newState
        });
    };
const $c346f43c05bbe3c6$var$setStaticSidebarContent = (id, content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content,
            id: id
        });
    };
const $c346f43c05bbe3c6$export$e324594224ef24da = {
    setExperienceId: $c346f43c05bbe3c6$var$setExperienceId,
    closeSidebar: $c346f43c05bbe3c6$var$closeSidebar,
    setStaticSidebarContent: $c346f43c05bbe3c6$var$setStaticSidebarContent
};

});


parcelRegister("l8Ydr", function(module, exports) {

$parcel$export(module.exports, "ConditionalFormatting", () => $992f817aa72576bf$export$6d44d4a22d5bca7a);

var $dQmPH = parcelRequire("dQmPH");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $dQ1Tp = parcelRequire("dQ1Tp");
const $992f817aa72576bf$export$e0edc1ee012e4c7e = ({ project: project, children: children })=>{
    const projectData = (0, $j4oe4.useFragment)((0, $dQmPH.default), project);
    if (projectData?.key != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dQ1Tp.MaybeMemoConditionalFormattingEntryPointProvider), {
        project: projectData,
        projectKey: projectData.key
    }, children);
    return children;
};
const $992f817aa72576bf$export$6d44d4a22d5bca7a = ({ isEnabled: isEnabled, ...rest })=>{
    if (isEnabled && (0, $7jTnu.fg)('jira_list_conditional_formatting')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($992f817aa72576bf$export$e0edc1ee012e4c7e, rest);
    return rest.children;
};

});
parcelRegister("dQmPH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f981f4a50e6f169f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b637ffcb0e08eddc4ae6c6ce804392c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f981f4a50e6f169f$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ],
    "kind": "Fragment",
    "name": "container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "kind": "FragmentSpread",
            "name": "entrypointContext_issueNavigatorActionConditionalFormatting_ConditionalFormattingEntrypointProvider"
        }
    ],
    "type": "JiraProject"
};
$f981f4a50e6f169f$var$node.hash = "5fb1babc3ffe013540ee86e7cec73956";
var $f981f4a50e6f169f$export$2e2bcd8739ae039 = $f981f4a50e6f169f$var$node;

});

parcelRegister("dQ1Tp", function(module, exports) {

$parcel$export(module.exports, "MaybeMemoConditionalFormattingEntryPointProvider", () => $858a3a21e9efe6f6$export$bb104d692666a581);
$parcel$export(module.exports, "useConditionalFormattingEntryPoint", () => $858a3a21e9efe6f6$export$4dc7c6c366f5d2ba);

var $lMcM9 = parcelRequire("lMcM9");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $LFmXM = parcelRequire("LFmXM");

var $f2JN3 = parcelRequire("f2JN3");

var $bbdV2 = parcelRequire("bbdV2");

var $7jTnu = parcelRequire("7jTnu");

var $kEUB1 = parcelRequire("kEUB1");

var $7IX73 = parcelRequire("7IX73");

var $glYyE = parcelRequire("glYyE");
const $858a3a21e9efe6f6$var$defaultEntrypointActions = {
    cancelPreload: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    load: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    preload: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    unload: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $858a3a21e9efe6f6$export$561daba77e18236 = (0, $LFmXM.default)((0, $7IX73.serialiseJql), (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj))));
const $858a3a21e9efe6f6$var$ConditionalFormattingEntryPointContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    getEntryPointActions: ()=>$858a3a21e9efe6f6$var$defaultEntrypointActions,
    entryPointReferenceSubject: {
        getValue: ()=>null,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        subscribe: ()=>()=>{}
    }
});
const $858a3a21e9efe6f6$export$ea15b2e6192c5d4b = ({ children: children, project: project, projectKey: // Passing key instead of extracting from fragment to not need to handle null case
projectKey })=>{
    const projectData = (0, $j4oe4.useFragment)((0, $lMcM9.default), project);
    const hydrateJql = (0, $eJOHy.useMemo)(()=>{
        const formattingRulesByProject = projectData?.conditionalFormattingRules;
        if (!formattingRulesByProject) return '';
        if ((projectData?.conditionalFormattingRules.edges?.length ?? 0) === 0 && (0, $7jTnu.fg)('jira_list_conditional_formatting_no_serialized_jql')) return '';
        const rulesJqlInput = {};
        formattingRulesByProject.edges?.forEach((edge)=>{
            const rule = edge?.node;
            if (rule == null) return;
            let fieldId = null;
            let value;
            switch(rule.expression.__typename){
                case 'JiraFormattingSingleValueOperand':
                    ({ value: value, fieldId: fieldId } = rule.expression);
                    break;
                case 'JiraFormattingMultipleValueOperand':
                    value = rule.expression.values;
                    fieldId = rule.expression.fieldId;
                    break;
                case 'JiraFormattingNoValueOperand':
                    fieldId = rule.expression.fieldId;
                    break;
                default:
                    break;
            }
            if (fieldId == null) return;
            // input to serialise jql input
            const DUMMY_VALUE = '-';
            if (!rulesJqlInput[fieldId]) rulesJqlInput[fieldId] = [];
            const values = Array.isArray(value) ? value : [
                value
            ];
            values.forEach((ruleValue)=>{
                if (fieldId) rulesJqlInput[fieldId]?.push({
                    value: ruleValue ?? DUMMY_VALUE,
                    label: ruleValue ?? DUMMY_VALUE
                });
            });
        });
        const jql = (0, $7jTnu.fg)('jira_list_conditional_formatting_memo_serialized') ? $858a3a21e9efe6f6$export$561daba77e18236(rulesJqlInput) : (0, $7IX73.serialiseJql)(rulesJqlInput);
        if (jql !== '') return `project = '${projectKey}' AND ${jql}`;
        return '';
    }, [
        projectData?.conditionalFormattingRules,
        projectKey
    ]);
    const cloudId = (0, $kEUB1.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $glYyE.conditionalFormattingSidebarEntryPoint), {
        projectKey: projectKey,
        cloudId: cloudId,
        hydrateJql: hydrateJql
    });
    const entryPointActionsRef = (0, $eJOHy.useRef)(entryPointActions);
    (0, $eJOHy.useEffect)(()=>{
        entryPointActionsRef.current = entryPointActions;
    }, [
        entryPointActions
    ]);
    const getEntryPointActions = (0, $eJOHy.useCallback)(()=>{
        return entryPointActionsRef.current;
    }, []);
    const value = (0, $eJOHy.useMemo)(()=>({
            entryPointReferenceSubject: entryPointReferenceSubject,
            getEntryPointActions: getEntryPointActions
        }), [
        entryPointReferenceSubject,
        getEntryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($858a3a21e9efe6f6$var$ConditionalFormattingEntryPointContext.Provider, {
        value: value
    }, children);
};
const $858a3a21e9efe6f6$var$MemoConditionalFormattingEntrypointProvider = /*#__PURE__*/ (0, $eJOHy.memo)($858a3a21e9efe6f6$export$ea15b2e6192c5d4b);
const $858a3a21e9efe6f6$export$bb104d692666a581 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jira_list_conditional_formatting_memo_serialized'), $858a3a21e9efe6f6$var$MemoConditionalFormattingEntrypointProvider, $858a3a21e9efe6f6$export$ea15b2e6192c5d4b);
const $858a3a21e9efe6f6$export$4dc7c6c366f5d2ba = ()=>(0, $eJOHy.useContext)($858a3a21e9efe6f6$var$ConditionalFormattingEntryPointContext);

});
parcelRegister("lMcM9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d9260919d9e9f90$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<763d7e9510b79b6e949e27a32d6a46d0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4d9260919d9e9f90$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "name": "entrypointContext_issueNavigatorActionConditionalFormatting_ConditionalFormattingEntrypointProvider",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "first"
                    }
                ],
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "expression",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "JiraFormattingSingleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "values"
                                                    }
                                                ],
                                                "type": "JiraFormattingMultipleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ 
                                                ],
                                                "type": "JiraFormattingNoValueOperand"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
}();
$4d9260919d9e9f90$var$node.hash = "31a078cda2cbef262e87df8f16169099";
var $4d9260919d9e9f90$export$2e2bcd8739ae039 = $4d9260919d9e9f90$var$node;

});

parcelRegister("7IX73", function(module, exports) {

$parcel$export(module.exports, "serialiseJql", () => $cbb24f8df5864967$export$e1718e1e441cb0f6);
$parcel$export(module.exports, "extractAnalyticsFilterDataFromJQL", () => $cbb24f8df5864967$export$9ee6085825c9cbfa);

var $8dH3d = parcelRequire("8dH3d");

var $9yn2r = parcelRequire("9yn2r");

var $8RQlO = parcelRequire("8RQlO");

var $bUEDu = parcelRequire("bUEDu");

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $d7m1k = parcelRequire("d7m1k");
const $cbb24f8df5864967$var$START_DATE_JQL = 'Start date[Date]';
const $cbb24f8df5864967$var$EMPTY = 'EMPTY';
const $cbb24f8df5864967$var$getQuotedFieldName = (fieldName)=>`"${fieldName}"`;
const $cbb24f8df5864967$var$getFieldNameForJqlRaw = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldName.indexOf('customfield_') === 0) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
    // the "to" fieldName for the date range will be transformed to "due" in the "serialiseJql" function
    // where "const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;"
    if (fieldName === 'dateRange') return $cbb24f8df5864967$var$START_DATE_JQL;
    return fieldName;
};
const $cbb24f8df5864967$var$getFieldNameForJql = (fieldName)=>$cbb24f8df5864967$var$getQuotedFieldName($cbb24f8df5864967$var$getFieldNameForJqlRaw(fieldName));
const $cbb24f8df5864967$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($9yn2r)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $cbb24f8df5864967$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $cbb24f8df5864967$var$sanitizeWord = (word)=>word.replace(/(["\\])/g, '\\$1');
const $cbb24f8df5864967$var$sanitizeWordOld = (word)=>word.replace(/'/g, "\\'");
const $cbb24f8df5864967$export$e1718e1e441cb0f6 = (filters)=>{
    const jqlQuery = (0, $f26C8.default).query();
    Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(options.value)))).forEach(([fieldId, options])=>{
        const fieldName = $cbb24f8df5864967$var$getFieldNameForJqlRaw(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;
            if (options.value.to != null) {
                const toDate = (0, $bUEDu.default)((0, $8RQlO.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                jqlQuery.appendClause((0, $f26C8.default).terminalClause((0, $f26C8.default).field(toFieldName), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_LT)), (0, $f26C8.default).valueOperand(toDate)), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
            }
            if (options.value.from != null) jqlQuery.appendClause((0, $f26C8.default).terminalClause((0, $f26C8.default).field(fieldName), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_GT_EQUALS)), (0, $f26C8.default).valueOperand(options.value.from)), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
            return;
        }
        if (Array.isArray(options)) {
            const operands = options.map((option)=>{
                if (option.isEmptyOption) return (0, $f26C8.default).valueOperand((0, $862dfd240457f00b$export$1c46dca02aac24dd));
                if (option.value) // Currently, the AST does not sanatize all values correctly (no \ or JQL keywords), so we need to manually wrap in quotes
                // We can remove this once https://jplat.jira.atlassian.cloud/browse/EM-6563 is implemented
                return (0, $f26C8.default).byText.valueOperand(`"${$cbb24f8df5864967$var$sanitizeWord(option.value)}"`);
                return null;
            }).filter((operand)=>operand != null);
            if (operands.length === 1) jqlQuery.appendClause((0, $f26C8.default).terminalClause((0, $f26C8.default).field(fieldName), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), operands[0]), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
            else if (operands.length > 1) jqlQuery.appendClause((0, $f26C8.default).terminalClause((0, $f26C8.default).field(fieldName), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_IN)), (0, $f26C8.default).listOperand(operands)), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
        }
    });
    const jast = (0, $f26C8.default).jast(jqlQuery);
    return (0, $1jiqw.print)(jast, {
        operatorCase: 'upper',
        printWidth: null
    });
};
const $cbb24f8df5864967$export$5bd6a523f48a18cd = (filters)=>{
    const pairs = Object.entries(filters).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(options.value)))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([fieldId, options])=>{
        const fieldName = $cbb24f8df5864967$var$getFieldNameForJql(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? $cbb24f8df5864967$var$getQuotedFieldName('due') : fieldName;
            let toDate;
            if (options.value.to) toDate = (0, $bUEDu.default)((0, $8RQlO.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
            else toDate = options.value.to;
            if (options.value.from != null && options.value.to != null) return `${fieldName} >= ${options.value.from} AND ${toFieldName} < ${toDate}`;
            if (options.value.from != null) return `${fieldName} >= ${options.value.from}`;
            return `${toFieldName} < ${toDate}`;
        }
        if (Array.isArray(options)) {
            const values = options.map((option)=>// make sure we don't wrap EMPTY with quotation marks
                option.value === (0, $d7m1k.EMPTY_FILTER_VALUE) ? $cbb24f8df5864967$var$EMPTY : `'${$cbb24f8df5864967$var$sanitizeWordOld(option.value)}'`).join(',');
            if (options.length > 1) return `${fieldName} in (${values})`;
            if (options.length === 1) return `${fieldName} = ${values}`;
        }
        return null;
    });
    return pairs.join(' AND ');
};
const $cbb24f8df5864967$var$extractField = (statement)=>{
    let fieldId;
    const dateOperatorRegex = />=|</;
    if (dateOperatorRegex.test(statement)) {
        const operator = statement.includes('>=') ? ' >= ' : ' < ';
        [fieldId] = statement.split(operator);
    }
    if (statement.includes(' = ')) [fieldId] = statement.split(/ = /);
    if (statement.includes(' in ')) [fieldId] = statement.split(' in ');
    if (fieldId) return $cbb24f8df5864967$var$getFieldIdFromJql(fieldId);
};
const $cbb24f8df5864967$export$9ee6085825c9cbfa = (jql)=>{
    if (!jql) return {};
    return jql.split(/ AND | OR /).map($cbb24f8df5864967$var$extractField).reduce((acc, curr)=>{
        if (curr) acc[curr] = true;
        return acc;
    }, {});
};

});
parcelRegister("9yn2r", function(module, exports) {

var $wkcOI = parcelRequire("wkcOI");

var $d1tIC = parcelRequire("d1tIC");

var $j4Djm = parcelRequire("j4Djm");

var $goN3t = parcelRequire("goN3t");

var $8KovM = parcelRequire("8KovM");

var $gsm7J = parcelRequire("gsm7J");

var $cz1WF = parcelRequire("cz1WF");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $6f4928facf5fd86d$var$trim(string, chars, guard) {
    string = $cz1WF(string);
    if (string && (guard || chars === undefined)) return $d1tIC(string);
    if (!string || !(chars = $wkcOI(chars))) return string;
    var strSymbols = $gsm7J(string), chrSymbols = $gsm7J(chars), start = $8KovM(strSymbols, chrSymbols), end = $goN3t(strSymbols, chrSymbols) + 1;
    return $j4Djm(strSymbols, start, end).join('');
}
module.exports = $6f4928facf5fd86d$var$trim;

});
parcelRegister("goN3t", function(module, exports) {

var $kEE3x = parcelRequire("kEE3x");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $bf04f089e91d946a$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $kEE3x(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $bf04f089e91d946a$var$charsEndIndex;

});

parcelRegister("8KovM", function(module, exports) {

var $kEE3x = parcelRequire("kEE3x");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $65e5a21662e297d6$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $kEE3x(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $65e5a21662e297d6$var$charsStartIndex;

});


const $f6415dda43b7f459$export$6d6d48d210d3ca97 = 'and';
const $f6415dda43b7f459$export$7b8f0a728d79a753 = 'or';

const $862dfd240457f00b$export$38accfc5a5d1c113 = 'value';
const $862dfd240457f00b$export$f6049126fd97001f = 'keyword';
const $862dfd240457f00b$export$19c7c729db381f9d = 'function';
const $862dfd240457f00b$export$fabec4aebba3f4df = 'list';
const $862dfd240457f00b$export$1c46dca02aac24dd = 'empty';

parcelRegister("d7m1k", function(module, exports) {

$parcel$export(module.exports, "OPTIMISTIC_ID", () => $6e5c1ccb850ad968$export$6e40821019289c70);
$parcel$export(module.exports, "CREATE_FILTER_EXPERIENCE", () => $6e5c1ccb850ad968$export$d6ceedee35ae2c19);
$parcel$export(module.exports, "UPDATE_FILTER_EXPERIENCE", () => $6e5c1ccb850ad968$export$ca3691ea47eec823);
$parcel$export(module.exports, "DELETE_FILTER_EXPERIENCE", () => $6e5c1ccb850ad968$export$2a5fce320f18ac6c);
$parcel$export(module.exports, "STAR_FILTER_EXPERIENCE", () => $6e5c1ccb850ad968$export$b0ec8deb6068dc3b);
$parcel$export(module.exports, "SAVED_FILTER_EXPERIENCE", () => $6e5c1ccb850ad968$export$6c99c87a0ac0052a);
$parcel$export(module.exports, "EMPTY_FILTER_VALUE", () => $6e5c1ccb850ad968$export$9ebaf9fe814731d3);
$parcel$export(module.exports, "SIMPLE_SEARCH_PARAM", () => $6e5c1ccb850ad968$export$9b72011e2eb8d7d0);
const $6e5c1ccb850ad968$export$b8b9d90f9e5bd72b = 'jiraBusinessFilters';
const $6e5c1ccb850ad968$export$6e40821019289c70 = 'optimistic-filter-id';
const $6e5c1ccb850ad968$export$d6ceedee35ae2c19 = {
    experience: 'filtersCreateSavedFilters',
    packageName: $6e5c1ccb850ad968$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $6e5c1ccb850ad968$export$ca3691ea47eec823 = {
    experience: 'filtersUpdateSavedFilters',
    packageName: $6e5c1ccb850ad968$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $6e5c1ccb850ad968$export$2a5fce320f18ac6c = {
    experience: 'filtersDeleteSavedFilters',
    packageName: $6e5c1ccb850ad968$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $6e5c1ccb850ad968$export$b0ec8deb6068dc3b = {
    experience: 'filtersStarSavedFilters',
    packageName: $6e5c1ccb850ad968$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $6e5c1ccb850ad968$export$6c99c87a0ac0052a = {
    experience: 'filtersLoadSavedFilters',
    packageName: $6e5c1ccb850ad968$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $6e5c1ccb850ad968$export$9ebaf9fe814731d3 = null;
const $6e5c1ccb850ad968$export$9b72011e2eb8d7d0 = 'text';

});


parcelRegister("glYyE", function(module, exports) {

$parcel$export(module.exports, "conditionalFormattingSidebarEntryPoint", () => $59b5375152cbfeaa$export$99130db9e4ffd320);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $hhys4 = parcelRequire("hhys4");

var $1pGNU = parcelRequire("1pGNU");

const $59b5375152cbfeaa$export$99130db9e4ffd320 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("l50eo")), {
        moduleId: "3a70fb0d",
        priority: "interaction"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId, hydrateJql: hydrateJql })=>({
            queries: {
                listViewFormattingRulesQuery: {
                    parameters: (0, $1pGNU.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: 20
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                },
                listViewFormattingRulesHydrateJqlQuery: {
                    parameters: (0, $hhys4.default),
                    variables: {
                        cloudId: cloudId,
                        jql: hydrateJql
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("hhys4", function(module, exports) {

$parcel$export(module.exports, "default", () => $52ff87e5b96f8fe5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cf2a5937304c56bb7549189c31072c6d>>
 * @relayHash d8a8efd1cb47ad24fa1b3fa450a8af48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 906d5c6c7bc5f1968ae4fdf299101b0f46b453ffda598a4e8bb0b8df1ecba23a
const $52ff87e5b96f8fe5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        }
    ], v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RuleListOldHydrateJqlQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v3 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "hydrateJqlQuery",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "FieldValueDataOld_query"
                                                        }
                                                    ],
                                                    "type": "JiraJqlHydratedQuery"
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jqlBuilder.hydrateJqlQuery"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RuleListOldHydrateJqlQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraJqlField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v6 /*: any*/ ,
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "accountId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlUserFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "priorityId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlPriorityFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprint",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "sprint",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "sprintId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlSprintFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGroup",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "group",
                                                                                                    "plural": false,
                                                                                                    "selections": v9 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlGroupFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlStatusFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "projectId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlProjectFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueTypes",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "issueTypeId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersion",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "version",
                                                                                                    "plural": false,
                                                                                                    "selections": v9 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlVersionFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponent",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "component",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "componentId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlComponentFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "option",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "optionId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlOptionFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        },
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "906d5c6c7bc5f1968ae4fdf299101b0f46b453ffda598a4e8bb0b8df1ecba23a",
            "metadata": {},
            "name": "RuleListOldHydrateJqlQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$52ff87e5b96f8fe5$var$node.hash = "36901797867bdd80222eaa66a102d160";
var $52ff87e5b96f8fe5$export$2e2bcd8739ae039 = $52ff87e5b96f8fe5$var$node;

});

parcelRegister("1pGNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a10341ae106253f9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<858f41d1580c23f32193e36a49d2af40>>
 * @relayHash 6626bf83d450628f75fb33f1947114a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f910d48577b9ef4ff80ae056284b71da3a925be565e0dac64fd7ad9797080692
const $a10341ae106253f9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v8 = [
        v7 /*: any*/ 
    ], v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RuleListOldQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "args": v5 /*: any*/ ,
                                            "concreteType": "JiraFormattingRuleConnection",
                                            "kind": "LinkedField",
                                            "name": "conditionalFormattingRules",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRuleEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFormattingRule",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "expression",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v8 /*: any*/ ,
                                                                            "type": "JiraFormattingMultipleValueOperand"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v8 /*: any*/ ,
                                                                            "type": "JiraFormattingSingleValueOperand"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v8 /*: any*/ ,
                                                                            "type": "JiraFormattingNoValueOperand"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "FragmentSpread",
                                                                    "name": "RuleItemOld_formatting_rule"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RuleListOldQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "expression",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "alias": "multipleValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "values"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingMultipleValueOperand"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "alias": "singleValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingSingleValueOperand"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "alias": "noValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingNoValueOperand"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "colorKey"
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "formattingArea"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f910d48577b9ef4ff80ae056284b71da3a925be565e0dac64fd7ad9797080692",
            "metadata": {},
            "name": "RuleListOldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a10341ae106253f9$var$node.hash = "c3dbceccba6d7e1e2300a44caf482a55";
var $a10341ae106253f9$export$2e2bcd8739ae039 = $a10341ae106253f9$var$node;

});

parcelRegister("l50eo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("4pZBy")
]).then(()=>parcelRequire('chwK5'));

});




parcelRegister("9edpF", function(module, exports) {

$parcel$export(module.exports, "ConditionalFormattingSidebarContainer", () => $60421b022fb4846c$export$dfaa75aa91cf4532);

var $2Cd8B = parcelRequire("2Cd8B");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $4EbIU = parcelRequire("4EbIU");
const $60421b022fb4846c$export$dbba6b660a937f11 = ({ project: project, children: children })=>{
    const projectData = (0, $j4oe4.useFragment)((0, $2Cd8B.default), project);
    if (projectData?.key != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EbIU.MaybeMemoConditionalFormattingEntryPointProvider), {
        project: projectData,
        projectKey: projectData.key
    }, children);
    return children;
};
const $60421b022fb4846c$export$dfaa75aa91cf4532 = ({ isEnabled: isEnabled, ...rest })=>{
    if (isEnabled && (0, $7jTnu.fg)('jira_list_conditional_formatting')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($60421b022fb4846c$export$dbba6b660a937f11, rest);
    return rest.children;
};

});
parcelRegister("2Cd8B", function(module, exports) {

$parcel$export(module.exports, "default", () => $3334d53bf8c34548$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<db0d7b4449c82f1fa2c4eacf90feb219>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3334d53bf8c34548$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ],
    "kind": "Fragment",
    "name": "ConditionalFormattingSidebarContainer_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "kind": "FragmentSpread",
            "name": "ConditionalFormattingEntrypointProvider_project"
        }
    ],
    "type": "JiraProject"
};
$3334d53bf8c34548$var$node.hash = "122bf496388bea23293bf790ee51265a";
var $3334d53bf8c34548$export$2e2bcd8739ae039 = $3334d53bf8c34548$var$node;

});

parcelRegister("4EbIU", function(module, exports) {

$parcel$export(module.exports, "MaybeMemoConditionalFormattingEntryPointProvider", () => $08c898f3533bf7bc$export$bb104d692666a581);
$parcel$export(module.exports, "useConditionalFormattingEntryPoint", () => $08c898f3533bf7bc$export$4dc7c6c366f5d2ba);

var $8C8Yh = parcelRequire("8C8Yh");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $LFmXM = parcelRequire("LFmXM");

var $f2JN3 = parcelRequire("f2JN3");

var $bbdV2 = parcelRequire("bbdV2");

var $7jTnu = parcelRequire("7jTnu");

var $kEUB1 = parcelRequire("kEUB1");

var $7IX73 = parcelRequire("7IX73");

var $2TGyJ = parcelRequire("2TGyJ");
const $08c898f3533bf7bc$var$defaultEntrypointActions = {
    cancelPreload: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    load: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    preload: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    unload: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $08c898f3533bf7bc$export$561daba77e18236 = (0, $LFmXM.default)((0, $7IX73.serialiseJql), (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj))));
const $08c898f3533bf7bc$var$ConditionalFormattingEntryPointContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    getEntryPointActions: ()=>$08c898f3533bf7bc$var$defaultEntrypointActions,
    entryPointReferenceSubject: {
        getValue: ()=>null,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        subscribe: ()=>()=>{}
    }
});
const $08c898f3533bf7bc$export$ea15b2e6192c5d4b = ({ children: children, project: project, projectKey: // Passing key instead of extracting from fragment to not need to handle null case
projectKey })=>{
    const projectData = (0, $j4oe4.useFragment)((0, $8C8Yh.default), project);
    const hydrateJql = (0, $eJOHy.useMemo)(()=>{
        const formattingRulesByProject = projectData?.conditionalFormattingRules;
        if (!formattingRulesByProject) return '';
        if ((projectData?.conditionalFormattingRules.edges?.length ?? 0) === 0 && (0, $7jTnu.fg)('jira_list_conditional_formatting_no_serialized_jql')) return '';
        const rulesJqlInput = {};
        formattingRulesByProject.edges?.forEach((edge)=>{
            const rule = edge?.node;
            if (rule == null) return;
            let fieldId = null;
            let value;
            switch(rule.expression.__typename){
                case 'JiraFormattingSingleValueOperand':
                    ({ value: value, fieldId: fieldId } = rule.expression);
                    break;
                case 'JiraFormattingMultipleValueOperand':
                    value = rule.expression.values;
                    fieldId = rule.expression.fieldId;
                    break;
                case 'JiraFormattingNoValueOperand':
                    fieldId = rule.expression.fieldId;
                    break;
                default:
                    break;
            }
            if (fieldId == null) return;
            // input to serialise jql input
            const DUMMY_VALUE = '-';
            if (!rulesJqlInput[fieldId]) rulesJqlInput[fieldId] = [];
            const values = Array.isArray(value) ? value : [
                value
            ];
            values.forEach((ruleValue)=>{
                if (fieldId) rulesJqlInput[fieldId]?.push({
                    value: ruleValue ?? DUMMY_VALUE,
                    label: ruleValue ?? DUMMY_VALUE
                });
            });
        });
        const jql = (0, $7jTnu.fg)('jira_list_conditional_formatting_memo_serialized') ? $08c898f3533bf7bc$export$561daba77e18236(rulesJqlInput) : (0, $7IX73.serialiseJql)(rulesJqlInput);
        if (jql !== '') return `project = '${projectKey}' AND ${jql}`;
        return '';
    }, [
        projectData?.conditionalFormattingRules,
        projectKey
    ]);
    const cloudId = (0, $kEUB1.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $2TGyJ.formatRulesEntryPoint), {
        projectKey: projectKey,
        cloudId: cloudId,
        hydrateJql: hydrateJql
    });
    const entryPointActionsRef = (0, $eJOHy.useRef)(entryPointActions);
    (0, $eJOHy.useEffect)(()=>{
        entryPointActionsRef.current = entryPointActions;
    }, [
        entryPointActions
    ]);
    const getEntryPointActions = (0, $eJOHy.useCallback)(()=>{
        return entryPointActionsRef.current;
    }, []);
    const value = (0, $eJOHy.useMemo)(()=>({
            entryPointReferenceSubject: entryPointReferenceSubject,
            getEntryPointActions: getEntryPointActions
        }), [
        entryPointReferenceSubject,
        getEntryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08c898f3533bf7bc$var$ConditionalFormattingEntryPointContext.Provider, {
        value: value
    }, children);
};
const $08c898f3533bf7bc$var$MemoConditionalFormattingEntrypointProvider = /*#__PURE__*/ (0, $eJOHy.memo)($08c898f3533bf7bc$export$ea15b2e6192c5d4b);
const $08c898f3533bf7bc$export$bb104d692666a581 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jira_list_conditional_formatting_memo_serialized'), $08c898f3533bf7bc$var$MemoConditionalFormattingEntrypointProvider, $08c898f3533bf7bc$export$ea15b2e6192c5d4b);
const $08c898f3533bf7bc$export$4dc7c6c366f5d2ba = ()=>(0, $eJOHy.useContext)($08c898f3533bf7bc$var$ConditionalFormattingEntryPointContext);

});
parcelRegister("8C8Yh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b5c822c8f5ed45b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<196ea29c8ccec935a1f238cd913937e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2b5c822c8f5ed45b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "name": "ConditionalFormattingEntrypointProvider_project",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "first"
                    }
                ],
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "expression",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "JiraFormattingSingleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "values"
                                                    }
                                                ],
                                                "type": "JiraFormattingMultipleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ 
                                                ],
                                                "type": "JiraFormattingNoValueOperand"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
}();
$2b5c822c8f5ed45b$var$node.hash = "1bcc1e151890801eeebc87422fccaf15";
var $2b5c822c8f5ed45b$export$2e2bcd8739ae039 = $2b5c822c8f5ed45b$var$node;

});

parcelRegister("2TGyJ", function(module, exports) {

$parcel$export(module.exports, "formatRulesEntryPoint", () => $54b34ea8443372a8$export$a812fb5060f92ae9);

var $1H4jz = parcelRequire("1H4jz");

var $iq4Jb = parcelRequire("iq4Jb");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $54b34ea8443372a8$export$a812fb5060f92ae9 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("g84hp")), {
        moduleId: "98b3f9d8",
        moduleName: "ConditionalFormattingSidebarApp",
        priority: "interaction"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId, hydrateJql: hydrateJql })=>({
            queries: {
                listViewFormattingRulesQuery: {
                    parameters: (0, $iq4Jb.default),
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        first: 20
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'store-or-network'
                    }
                },
                listViewFormattingRulesHydrateJqlQuery: {
                    parameters: (0, $1H4jz.default),
                    variables: {
                        cloudId: cloudId,
                        jql: hydrateJql
                    },
                    options: {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("1H4jz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3ffc21c5ed07565$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a9dcbfd36cd4494260af60a432128e82>>
 * @relayHash 64bda5fe8f75c33ca5fe4775fbb35f30
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bffe80e7f34e038150f826b8f8ea18b117aece9dc9ebc1ec015a264da87e1275
const $f3ffc21c5ed07565$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        }
    ], v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RuleListHydrateJqlQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v3 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "hydrateJqlQuery",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "FieldValueData_query"
                                                        }
                                                    ],
                                                    "type": "JiraJqlHydratedQuery"
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jqlBuilder.hydrateJqlQuery"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RuleListHydrateJqlQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraJqlField",
                                                                    "kind": "LinkedField",
                                                                    "name": "field",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v6 /*: any*/ ,
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "accountId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlUserFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraPriority",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "priority",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "priorityId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlPriorityFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprint",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "sprint",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "sprintId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlSprintFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraGroup",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "group",
                                                                                                    "plural": false,
                                                                                                    "selections": v9 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlGroupFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatus",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "status",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "statusId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlStatusFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "projectId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlProjectFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueTypes",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "issueTypeId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersion",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "version",
                                                                                                    "plural": false,
                                                                                                    "selections": v9 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlVersionFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraComponent",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "component",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "componentId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlComponentFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraOption",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "option",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "optionId"
                                                                                                        },
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlOptionFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        },
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bffe80e7f34e038150f826b8f8ea18b117aece9dc9ebc1ec015a264da87e1275",
            "metadata": {},
            "name": "RuleListHydrateJqlQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f3ffc21c5ed07565$var$node.hash = "e75d55566094513eb3a65b01d3642bac";
var $f3ffc21c5ed07565$export$2e2bcd8739ae039 = $f3ffc21c5ed07565$var$node;

});

parcelRegister("iq4Jb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d231a572ef4db930$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fe2de9e6041ac0a59f55aa0d4c4431c3>>
 * @relayHash daf66e46013fda4b2d21c36fa6645fde
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52d196a78321980ee93aa1e09c273bb43c438b4246d2927977ec6ac8b55b2948
const $d231a572ef4db930$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v8 = [
        v7 /*: any*/ 
    ], v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RuleListQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "args": v5 /*: any*/ ,
                                            "concreteType": "JiraFormattingRuleConnection",
                                            "kind": "LinkedField",
                                            "name": "conditionalFormattingRules",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRuleEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFormattingRule",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "expression",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v8 /*: any*/ ,
                                                                            "type": "JiraFormattingMultipleValueOperand"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v8 /*: any*/ ,
                                                                            "type": "JiraFormattingSingleValueOperand"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v8 /*: any*/ ,
                                                                            "type": "JiraFormattingNoValueOperand"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "FragmentSpread",
                                                                    "name": "RuleItem_formatting_rule"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RuleListQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "expression",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "alias": "multipleValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "values"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingMultipleValueOperand"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "alias": "singleValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingSingleValueOperand"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "alias": "noValueOperator",
                                                                            "kind": "ScalarField",
                                                                            "name": "operator"
                                                                        }
                                                                    ],
                                                                    "type": "JiraFormattingNoValueOperand"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "colorKey"
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "formattingArea"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "52d196a78321980ee93aa1e09c273bb43c438b4246d2927977ec6ac8b55b2948",
            "metadata": {},
            "name": "RuleListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d231a572ef4db930$var$node.hash = "4d83b6dcddd13e5dd174c74a42515190";
var $d231a572ef4db930$export$2e2bcd8739ae039 = $d231a572ef4db930$var$node;

});

parcelRegister("g84hp", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("1mPu2")
]).then(()=>parcelRequire('4NVTr'));

});




parcelRegister("61oZD", function(module, exports) {

$parcel$export(module.exports, "useAppContextualAnalyticsActions", () => $e3511e28b01b7a77$export$8aad1a4e4d637906);
$parcel$export(module.exports, "AppContextualAnalytics", () => $e3511e28b01b7a77$export$2942dddca20a92ac);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $4xbv3 = parcelRequire("4xbv3");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $e3511e28b01b7a77$var$Container = (0, $6E16M.createContainer)();
const $e3511e28b01b7a77$var$Store = (0, $GtRbT.createStore)({
    name: 'AppContextualAnalyticsStore',
    containedBy: $e3511e28b01b7a77$var$Container,
    initialState: {
        issueNavigatorSearchSessionId: undefined
    },
    actions: {
        onJourneyStart: ()=>({ setState: setState })=>{
                const issueNavigatorSearchSessionId = (0, $aXKmr.v4)();
                setState({
                    issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
                });
                return {
                    issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
                };
            }
    }
});
const $e3511e28b01b7a77$export$e1e7a4797df1a656 = (0, $iJq0l.createHook)($e3511e28b01b7a77$var$Store, {
    selector: (state)=>state.issueNavigatorSearchSessionId
});
const $e3511e28b01b7a77$export$8aad1a4e4d637906 = (0, $iJq0l.createActionsHook)($e3511e28b01b7a77$var$Store);
const $e3511e28b01b7a77$var$AppContextualAnalyticsData = ({ children: children })=>{
    const [issueNavigatorSearchSessionId] = $e3511e28b01b7a77$export$e1e7a4797df1a656();
    const attributes = (0, $eJOHy.useMemo)(()=>({
            issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
        }), [
        issueNavigatorSearchSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "issueNavigator",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        attributes: attributes
    }, children);
};
const $e3511e28b01b7a77$export$2942dddca20a92ac = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3511e28b01b7a77$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3511e28b01b7a77$var$AppContextualAnalyticsData, null, children));

});
// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("fwKw5", function(module, exports) {

$parcel$export(module.exports, "useActiveJql", () => $09ad01b3dea0b6f0$export$caeaf867313163e4);
$parcel$export(module.exports, "ActiveJqlProvider", () => $09ad01b3dea0b6f0$export$c69a9a3114157ae7);
$parcel$export(module.exports, "useResolvedJql", () => $09ad01b3dea0b6f0$export$23e17984875d36b4);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $82cqT = parcelRequire("82cqT");
const $09ad01b3dea0b6f0$var$ActiveJqlContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    jql: ''
});
$09ad01b3dea0b6f0$var$ActiveJqlContext.displayName = 'ActiveJqlContext';
const $09ad01b3dea0b6f0$export$caeaf867313163e4 = ()=>(0, $eJOHy.useContext)($09ad01b3dea0b6f0$var$ActiveJqlContext);
const $09ad01b3dea0b6f0$export$c69a9a3114157ae7 = ({ initialJql: initialJql, jql: jql, filterId: filterId, isFilterEditable: isFilterEditable, filterJql: filterJql, children: children })=>{
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            initialJql: initialJql,
            jql: jql,
            filterId: filterId,
            isFilterEditable: isFilterEditable,
            filterJql: filterJql
        }), [
        initialJql,
        jql,
        filterId,
        isFilterEditable,
        filterJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09ad01b3dea0b6f0$var$ActiveJqlContext.Provider, {
        value: contextValue
    }, children);
};
const $09ad01b3dea0b6f0$export$23e17984875d36b4 = ()=>{
    const { jql: jql, filterJql: filterJql } = $09ad01b3dea0b6f0$export$caeaf867313163e4();
    const filter = filterJql !== undefined ? filterJql : '';
    return jql !== undefined ? jql : filter;
};
const $09ad01b3dea0b6f0$export$5d3c8489d1ae8bee = ()=>{
    const { filterId: filterId, jql: jql } = $09ad01b3dea0b6f0$export$caeaf867313163e4();
    return `/issues/?${(0, $b5RwB.stringify)({
        jql: jql,
        ...(0, $82cqT.isFilterId)(filterId) ? {
            filter: filterId
        } : {}
    })}`;
};

});

parcelRegister("cJdYi", function(module, exports) {

$parcel$export(module.exports, "useFilterQuery", () => $5ba88ead355bead9$export$5576614cd48b552);
$parcel$export(module.exports, "FilterQueryProvider", () => $5ba88ead355bead9$export$78b7af8c530bd7a4);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $82cqT = parcelRequire("82cqT");

var $l2h78 = parcelRequire("l2h78");

var $8oKDI = parcelRequire("8oKDI");

var $ftN6c = parcelRequire("ftN6c");

var $4ihOZ = parcelRequire("4ihOZ");

var $kEUB1 = parcelRequire("kEUB1");
const $5ba88ead355bead9$var$FilterQueryContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    filterQueryIsFetching: false,
    filterQueryIsNetworkError: false
});
$5ba88ead355bead9$var$FilterQueryContext.displayName = 'FilterQueryContext';
const $5ba88ead355bead9$export$5576614cd48b552 = ()=>(0, $eJOHy.useContext)($5ba88ead355bead9$var$FilterQueryContext);
const $5ba88ead355bead9$export$78b7af8c530bd7a4 = ({ refetch: refetch, query: query, children: children, filterId: filterId })=>{
    const [filterQueryIsFetching, setFilterQueryIsFetching] = (0, $eJOHy.useState)(false);
    const [filterQueryIsNetworkError, setFilterQueryNetworkError] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const activationId = (0, $4ihOZ.useActivationId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const inFlightRequest = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        if (filterId !== undefined && (0, $82cqT.isFilterId)(filterId)) {
            // Prevent race condition from multiple requests in progress
            // (ex. if user clicks quickly on different filters)
            inFlightRequest.current?.unsubscribe();
            const variables = {
                filterAri: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }),
                includeFilter: true
            };
            setFilterQueryIsFetching(true);
            setFilterQueryNetworkError(false);
            inFlightRequest.current = (0, $j4oe4.fetchQuery)(environment, query, variables, {
                fetchPolicy: 'store-or-network'
            }).subscribe({
                complete: ()=>{
                    refetch(variables, {
                        fetchPolicy: 'store-only'
                    });
                    setFilterQueryIsFetching(false);
                },
                error: ()=>{
                    setFilterQueryIsFetching(false);
                    setFilterQueryNetworkError(true);
                }
            });
        } else // Need to refetch when filter is undefined so it reset filterData to empty
        refetch({
            includeFilter: false,
            filterAri: ''
        }, {
            fetchPolicy: 'store-or-network'
        });
    }, [
        activationId,
        cloudId,
        environment,
        filterId,
        query,
        refetch,
        setFilterQueryIsFetching,
        setFilterQueryNetworkError
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (filterId !== undefined && (0, $82cqT.isFilterId)(filterId)) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $l2h78.addFilterToRecent)(filterId, analyticsEvent);
        }
    }, [
        filterId,
        createAnalyticsEvent
    ]);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            filterQueryIsFetching: filterQueryIsFetching,
            filterQueryIsNetworkError: filterQueryIsNetworkError
        }), [
        filterQueryIsFetching,
        filterQueryIsNetworkError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5ba88ead355bead9$var$FilterQueryContext.Provider, {
        value: contextValue
    }, children);
};

});
parcelRegister("l2h78", function(module, exports) {

$parcel$export(module.exports, "addFilterToRecent", () => $a11574fb8c1677f2$export$1f166118234b128e);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

const $a11574fb8c1677f2$export$1f166118234b128e = async (filterId, analyticsEvent)=>{
    try {
        await (0, $jGzN3.performPostRequest)((0, $d179eb0ac817e6bb$export$3fdeac1311ebf841) + filterId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            event: analyticsEvent,
            meta: {
                id: 'addFilterToRecent',
                packageName: 'jiraIssueNavigatorCustomFilters'
            }
        });
    }
};

});
const $d179eb0ac817e6bb$export$3fdeac1311ebf841 = '/rest/issueNav/1/history/saveFilter/';



parcelRegister("1Puj1", function(module, exports) {

$parcel$export(module.exports, "IssueSearch", () => $fe7de2c920d9c496$export$ce2913cefc6e57dc);

var $auZ5c = parcelRequire("auZ5c");

var $ctdwU = parcelRequire("ctdwU");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $7jTnu = parcelRequire("7jTnu");

var $82cqT = parcelRequire("82cqT");

var $kEUB1 = parcelRequire("kEUB1");

var $iZsVo = parcelRequire("iZsVo");

var $4ihOZ = parcelRequire("4ihOZ");

var $kfvK2 = parcelRequire("kfvK2");

var $epTsa = parcelRequire("epTsa");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $fwKw5 = parcelRequire("fwKw5");

var $5Ijz5 = parcelRequire("5Ijz5");

var $48isi = parcelRequire("48isi");

var $4o2sx = parcelRequire("4o2sx");

var $5lUfC = parcelRequire("5lUfC");

var $aaLZH = parcelRequire("aaLZH");

var $jHM2W = parcelRequire("jHM2W");
const $fe7de2c920d9c496$var$useViewItemId = (0, $kfvK2.createRouterSelector)((state)=>state.match?.params?.itemId);
const $fe7de2c920d9c496$var$searchErrorFlagId = (0, $hrodw.toFlagId)('ISSUE_NAVIGATOR_SEARCH_ERROR_FLAG');
const $fe7de2c920d9c496$var$searchErrorFlag = {
    id: $fe7de2c920d9c496$var$searchErrorFlagId,
    type: 'error',
    title: (0, $jHM2W.default).searchFailedTitle,
    description: (0, $jHM2W.default).searchFailedDescription,
    messageId: `issue-navigator.ui.issue-search.searchErrorFlag.${$fe7de2c920d9c496$var$searchErrorFlagId}`,
    messageType: 'transactional'
};
const $fe7de2c920d9c496$var$isFieldPresentInJql = (query, fieldName)=>{
    const regex = new RegExp(`\\b${fieldName}\\s*(=\\s*[^\\s]+|IN\\s*\\([^\\)]+\\))`, 'i');
    return regex.test(query);
};
const $fe7de2c920d9c496$export$ce2913cefc6e57dc = ({ children: children, onPageDataLoad: onPageDataLoad, refetch: refetch, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, jiraView: jiraView, issueTableProps: issueTableProps, project: project })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const activationId = (0, $4ihOZ.useActivationId)();
    const { jql: jql, filterId: filterId } = (0, $fwKw5.useActiveJql)();
    const issueSearchInput = (0, $eJOHy.useMemo)(()=>jql === undefined && (0, $82cqT.isFilterId)(filterId) ? {
            filterId: filterId
        } : {
            jql: jql
        }, [
        filterId,
        jql
    ]);
    if ((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
        const isLabelsFieldPresentInJql = $fe7de2c920d9c496$var$isFieldPresentInJql(issueSearchInput?.jql || '', 'labels');
        isLabelsFieldPresentInJql && (0, $gCeeo.fireTrackAnalyticsDeferred)(createAnalyticsEvent({}), 'labelsFilter used');
    }
    const setSelectedView = (0, $5lUfC.useSelectedViewMutation)();
    const viewItemId = (0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fe7de2c920d9c496$var$useViewItemId() : undefined;
    const jiraViewData = (0, $j4oe4.useFragment)((0, $ctdwU.default), jiraView);
    const projectData = (0, $j4oe4.useFragment)((0, $auZ5c.default), project);
    const groupedByField = jiraViewData?.viewSettings?.groupByConfig?.groupByField?.fieldId ?? null;
    const isGroupingEnabled = Boolean(issueTableProps?.isGroupingSupported) && Boolean(jiraViewData?.viewSettings?.isGroupingEnabled) && Boolean(jiraViewData?.viewSettings?.canEnableGrouping);
    const isHierarchyEnabled = Boolean(isIssueHierarchySupportEnabled && jiraViewData?.viewSettings?.isHierarchyEnabled);
    const isHideDoneEnabled = Boolean(jiraViewData?.viewSettings?.hideDone);
    const maybeViewId = jiraViewData?.viewId;
    const onRefetchStart = (0, $eJOHy.useCallback)(()=>{
        // Hide any search error flags currently visible
        dismissFlag($fe7de2c920d9c496$var$searchErrorFlagId);
    }, [
        dismissFlag
    ]);
    const viewId = (0, $eibCx.parseIssueNavigatorViewIdOrDefault)(maybeViewId);
    const { onIssueSearchFail: onIssueSearchFail } = (0, $5Ijz5.useExperienceAnalytics)(onPageDataLoad, {
        ...isGroupingEnabled ? {
            experienceId: (0, $iRahl.GROUPED_LIST_EXPERIENCE_ID)
        } : {},
        isBifrost: !!(0, $iZsVo.ssr).getFeatureFlags()?.ssrViaBifrost
    });
    const onRefetchError = (0, $eJOHy.useCallback)((error, refetchView)=>{
        onIssueSearchFail(`${(0, $iRahl.PACKAGE_NAME)}.issue-search-refetch`, error, refetchView);
        showFlag($fe7de2c920d9c496$var$searchErrorFlag);
    }, [
        onIssueSearchFail,
        showFlag
    ]);
    const projectContext = issueTableProps?.projectContext;
    (0, $48isi.useMainIssueNavigatorQueryShadowRequest)({
        first: 50,
        amountOfColumns: 500,
        cloudId: cloudId,
        issueSearchInput: issueSearchInput,
        atlassianIntelligenceProductFeature: 'NATURAL_LANGUAGE_TO_JQL',
        projectKey: projectContext ?? '',
        shouldQueryProject: false,
        shouldQueryConditionalFormatting: false,
        shouldQueryConditionalFormattingFromSavedView: false,
        filterId: filterId ?? null,
        viewConfigInput: {
            viewInput: {
                namespace: 'ISSUE_NAVIGATOR'
            }
        },
        fieldSetsInput: {
            viewInput: {
                namespace: 'ISSUE_NAVIGATOR',
                filterId: filterId ?? null
            }
        },
        shouldQueryHasChildren: true
    }, viewId);
    const isConditionalFormattingEnabled = (0, $7jTnu.fg)('jira_list_conditional_formatting') && // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $aaLZH.useIssueNavigatorFeatures)().isConditionalFormattingEnabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4o2sx.IssueSearchServiceContainer), {
        cloudId: cloudId,
        environment: environment,
        issueSearchInput: issueSearchInput,
        viewId: viewId,
        filterId: filterId,
        onPageDataLoad: onPageDataLoad,
        onRefetchStart: onRefetchStart,
        onRefetchError: onRefetchError,
        onSelectedViewMutation: setSelectedView,
        refetch: refetch,
        projectContext: projectContext,
        isHierarchyEnabled: isHierarchyEnabled,
        isHideDoneEnabled: isHideDoneEnabled,
        groupedByField: groupedByField,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        isConditionalFormattingEnabled: isConditionalFormattingEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        activationId: activationId,
        projectId: projectData?.projectId,
        viewItemId: viewItemId
    }, children);
};

});
parcelRegister("auZ5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b3315f3cef1b7b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<357ec52c93a85365f801d4f74701c98c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2b3315f3cef1b7b4$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "issueSearch_issueNavigatorProject",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "projectId"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$2b3315f3cef1b7b4$var$node.hash = "6a2aab5ab5f6ad8d0e23c840e0239294";
var $2b3315f3cef1b7b4$export$2e2bcd8739ae039 = $2b3315f3cef1b7b4$var$node;

});

parcelRegister("ctdwU", function(module, exports) {

$parcel$export(module.exports, "default", () => $84cce370a7dec0fc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47c400dc6eb21c75f18a183597271b22>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $84cce370a7dec0fc$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "issueSearch_issueNavigatorGrouping",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "viewId"
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isGroupingEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEnableGrouping"
                        },
                        {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "groupByField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isHierarchyEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$84cce370a7dec0fc$var$node.hash = "81fbda7b72e3b8d3632b955fb3bccae3";
var $84cce370a7dec0fc$export$2e2bcd8739ae039 = $84cce370a7dec0fc$var$node;

});

parcelRegister("5Ijz5", function(module, exports) {

$parcel$export(module.exports, "useExperienceAnalytics", () => $df800b8d721dc559$export$523b242362f30838);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2aY2d = parcelRequire("2aY2d");

var $bRJAs = parcelRequire("bRJAs");

var $7jTnu = parcelRequire("7jTnu");

var $8vyDv = parcelRequire("8vyDv");

var $a9ldn = parcelRequire("a9ldn");

var $jiTA8 = parcelRequire("jiTA8");

var $iRahl = parcelRequire("iRahl");
/**
 * This debouncer is shared between both the success and fail calls so that the last one called in the current event
 * loop tick is the one that gets logged. This helps us overcome weaknesses in the Relay-based rendering where an error
 * being thrown taks an additional render cycle to reach the component managing the analytics.
 */ const $df800b8d721dc559$var$sharedDebouncer = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((action)=>action(), 0);
const $df800b8d721dc559$export$523b242362f30838 = (/**
	 * Event emitted when page data has loaded and the key experience is interactive.
	 */ onPageDataLoad, /**
	 * Analytics attributes to be emitted as part of success/fail experience events.
	 */ attributes)=>{
    let analyticsAttributes = attributes;
    if ((0, $7jTnu.fg)('jira_nin_smart_link')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const isEmbed = (0, $jiTA8.useIsEmbedMode)();
        analyticsAttributes = {
            ...analyticsAttributes,
            isEmbed: isEmbed
        };
    }
    if ((0, $7jTnu.fg)('improve_nin_slo_events')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: project } = (0, $2aY2d.useProjectContext)();
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const appEditions = (0, $8vyDv.useAppEditions)();
        const application = project?.projectType ? (0, $bRJAs.getApplicationForProject)(project.projectType) : null;
        const edition = application ? (0, $a9ldn.getEdition)(application, appEditions) : null;
        analyticsAttributes = {
            ...analyticsAttributes,
            application: application,
            edition: edition
        };
    }
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $iRahl.EXPERIENCE_NAME),
        experienceId: undefined,
        analyticsSource: (0, $iRahl.ANALYTICS_SOURCE)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $iRahl.EXPERIENCE_NAME),
        attributes: analyticsAttributes
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $iRahl.EXPERIENCE_NAME),
        attributes: analyticsAttributes
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onFireUIAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'screen'
        });
        (0, $gCeeo.fireUIAnalytics)(event, 'issueSearchResults', attributes ?? {});
    }, [
        attributes,
        createAnalyticsEvent
    ]);
    const onIssueSearchSuccess = (0, $eJOHy.useCallback)((view)=>{
        $df800b8d721dc559$var$sharedDebouncer(()=>{
            onExperienceStart();
            onExperienceSuccess();
            onFireUIAnalyticsEvent();
        });
        onPageDataLoad && onPageDataLoad(view);
    }, [
        onExperienceStart,
        onExperienceSuccess,
        onFireUIAnalyticsEvent,
        onPageDataLoad
    ]);
    const onIssueSearchFail = (0, $eJOHy.useCallback)((location, error, view)=>{
        $df800b8d721dc559$var$sharedDebouncer(()=>{
            onExperienceStart();
            onExperienceFail(location, error);
        });
        onPageDataLoad && onPageDataLoad(view);
    }, [
        onExperienceFail,
        onExperienceStart,
        onPageDataLoad
    ]);
    return {
        onIssueSearchSuccess: onIssueSearchSuccess,
        onIssueSearchFail: onIssueSearchFail
    };
};

});

parcelRegister("48isi", function(module, exports) {

$parcel$export(module.exports, "fetchIssueNavigatorIssueSearchRefetchQueryShadow", () => $9869109181fc67fc$export$460584db8358ab3e);
$parcel$export(module.exports, "useMainIssueNavigatorQueryShadowRequest", () => $9869109181fc67fc$export$d0a69cc9f9c06a41);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $iRahl = parcelRequire("iRahl");
const $9869109181fc67fc$export$a5981df6f2a66c20 = async (variables, query, operationName)=>{
    try {
        await (0, $1Ozm9.default)('/gateway/api/graphql', {
            method: 'POST',
            headers: {
                'X-ExperimentalApi': 'JiraIssueSearch, JiraProject'
            },
            body: JSON.stringify({
                operationName: operationName,
                query: query,
                variables: {
                    ...variables,
                    namespace: 'ISSUE_NAVIGATOR',
                    amountOfColumns: 500,
                    scope: {
                        operationScope: (0, $iRahl.NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE)
                    },
                    isLinkRelationshipFieldEnabled: false,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider: 1,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiralistinlineeditingrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider: (0, $epTsa.expVal)('jira-itr-m4-exp-3', 'isEnabled', false),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: (0, $7jTnu.fg)('frontier-currency-field-d1'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider: (0, $7jTnu.fg)('empanada_remove_singleselect_readview_fieldoptions'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisninsavedfiltersenabledrelayprovider: (0, $7jTnu.fg)('nin-saved-filters'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider: (0, $7jTnu.fg)('jira_platform_issue_realtime_updates_used_in_nin'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider: (0, $7jTnu.fg)('dfo_remove_fields_by_id'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider: (0, $7jTnu.fg)('jira_timeline_analytics_harmonization'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider: (0, $7jTnu.fg)('jira_preview_panel_m_1_rollout')
                }
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            attributes: {
                message: `Shadow request for nin issue search ${operationName} failed`
            },
            meta: {
                id: 'shadow-request-for-nin-issue-search',
                packageName: 'jiraIssueNavigator',
                teamName: 'empanada'
            }
        });
    }
};

const $9869109181fc67fc$var$getIssueNavigatorIssueSearchRefetchQueryShadowOperation = (isGrouping = false)=>{
    const operation = (parcelRequire("zozlI")).then((module)=>{
        const operationName = `IssueNavigatorIssueSearchRefetch${isGrouping ? 'Grouping' : ''}QueryShadow`;
        return {
            operationName: operationName,
            operation: module.operation.replace('IssueNavigatorIssueSearchRefetchQuery', operationName)
        };
    });
    return operation;
};

const $9869109181fc67fc$var$getMainIssueNavigatorQueryShadowOperation = (isGrouping = false)=>{
    const operation = (parcelRequire("a9rnC")).then((module)=>{
        const operationName = `main_IssueNavigator${isGrouping ? 'Grouping' : ''}QueryShadow`;
        return {
            operationName: operationName,
            operation: module.operation.replace('main_IssueNavigatorQuery', operationName)
        };
    });
    return operation;
};
const $9869109181fc67fc$var$catchedCallback = (cb)=>{
    return (...args)=>{
        try {
            cb(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                error: error,
                attributes: {
                    message: 'Queue shadow request for nin issue search failed'
                },
                meta: {
                    id: 'queue-shadow-request-for-nin-issue-search',
                    packageName: 'jiraIssueNavigator',
                    teamName: 'empanada'
                }
            });
        }
    };
};
const $9869109181fc67fc$var$catchedCallbackAsync = (cb)=>{
    return async (...args)=>{
        try {
            await cb(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                error: error,
                attributes: {
                    message: 'Queue shadow request for nin issue search failed'
                },
                meta: {
                    id: 'queue-shadow-request-for-nin-issue-search',
                    packageName: 'jiraIssueNavigator',
                    teamName: 'empanada'
                }
            });
        }
    };
};
const $9869109181fc67fc$export$8ca28e57c08b20c8 = $9869109181fc67fc$var$catchedCallback((getOperation, variables)=>{
    if (false) return;
    // requestIdleCallback is not supported in Safari, so we need a workaround.
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback !== 'undefined') window.requestIdleCallback($9869109181fc67fc$var$catchedCallback(()=>setTimeout($9869109181fc67fc$var$catchedCallback(()=>{
            window.requestIdleCallback($9869109181fc67fc$var$catchedCallbackAsync(async ()=>{
                const query = await getOperation();
                $9869109181fc67fc$export$a5981df6f2a66c20(variables, query.operation, query.operationName);
            }));
        }), 5000)));
});
const $9869109181fc67fc$export$460584db8358ab3e = (variables, isGrouping)=>{
    $9869109181fc67fc$export$8ca28e57c08b20c8(()=>$9869109181fc67fc$var$getIssueNavigatorIssueSearchRefetchQueryShadowOperation(isGrouping), variables);
};
const $9869109181fc67fc$export$d0a69cc9f9c06a41 = (variables, viewId)=>{
    (0, $eJOHy.useEffect)(()=>{
        if (variables.projectKey && viewId !== 'detail') {
            if ((0, $7jTnu.fg)('jira_list_group_shadow_requests')) {
                const groupByFields = [
                    'status',
                    'assignee',
                    'priority',
                    'com.atlassian.jira.plugin.system.customfieldtypes:float',
                    'com.pyxis.greenhopper.jira:jsw-story-points',
                    'com.pyxis.greenhopper.jira:gh-sprint',
                    'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category'
                ];
                // Switch between the main query with refactor enabled and with group by overrides
                const variableOverrides = (0, $7jTnu.fg)('jira_list_main_shadow_query_group_overrides') ? {
                    staticViewInput: {
                        isHierarchyEnabled: false,
                        isGroupingEnabled: true
                    },
                    viewConfigInput: {
                        staticViewInput: {
                            isHierarchyEnabled: false,
                            isGroupingEnabled: true
                        }
                    },
                    // Randomly select a groupBy field to test the shadow request
                    groupBy: groupByFields[Math.floor(Math.random() * groupByFields.length)]
                } : {};
                $9869109181fc67fc$export$8ca28e57c08b20c8(()=>$9869109181fc67fc$var$getMainIssueNavigatorQueryShadowOperation(true), {
                    ...variables,
                    ...variableOverrides
                });
            } else if ((0, $7jTnu.fg)('jsc_shadow_requests_for_project_column_config')) {
                const operationScope = (0, $iRahl.NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE);
                const variableOverrides = {
                    fieldSetsScope: {
                        operationScope: operationScope,
                        projectKey: variables.projectKey
                    }
                };
                $9869109181fc67fc$export$8ca28e57c08b20c8($9869109181fc67fc$var$getMainIssueNavigatorQueryShadowOperation, {
                    ...variables,
                    ...variableOverrides
                });
            } else if ((0, $7jTnu.fg)('jira_list_conditional_formatting_shadow_request')) {
                const variableOverrides = {
                    shouldQueryProject: true,
                    shouldQueryConditionalFormatting: true
                };
                $9869109181fc67fc$export$8ca28e57c08b20c8($9869109181fc67fc$var$getMainIssueNavigatorQueryShadowOperation, {
                    ...variables,
                    ...variableOverrides
                });
            }
        }
    // We only want to fetch the main query once, so we don't need to add any dependencies here
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("zozlI", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("gfsdl").then(()=>parcelRequire('7tlUM'));

});

parcelRegister("a9rnC", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("c5rFF").then(()=>parcelRequire('6lj4W'));

});


parcelRegister("4o2sx", function(module, exports) {

$parcel$export(module.exports, "IssueSearchServiceContainer", () => $4b62de4f25567cba$export$3744f0b7d0dd1936);
$parcel$export(module.exports, "Store", () => $4b62de4f25567cba$export$390f32400eaf98c9);

var $aXKmr = parcelRequire("aXKmr");

var $fsisP = parcelRequire("fsisP");

var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $38YP1 = parcelRequire("38YP1");
const $4b62de4f25567cba$var$initialState = {
    disposables: [],
    isFetching: false,
    isFetchingView: false,
    isRefreshing: false,
    isNetworkError: false,
    searchKey: '',
    totalIssueCount: null,
    totalIssueCountIsFetching: false,
    totalIssueCountIsError: false
};
const $4b62de4f25567cba$export$3744f0b7d0dd1936 = (0, $6E16M.createContainer)();
const $4b62de4f25567cba$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    name: 'IssueSearchServiceStore',
    initialState: $4b62de4f25567cba$var$initialState,
    actions: $38YP1.actions,
    containedBy: $4b62de4f25567cba$export$3744f0b7d0dd1936,
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    searchKey: (0, $aXKmr.v4)()
                });
            },
        onContainerUpdate: (nextProps, prevProps)=>({ dispatch: dispatch })=>{
                if (!(0, $fsisP.isShallowEqual)(nextProps.issueSearchInput, prevProps.issueSearchInput)) dispatch((0, $38YP1.handleSearchInputUpdate)());
            },
        onDestroy: ()=>({ getState: getState })=>{
                const { disposables: disposables } = getState();
                // Dispose of any manually retained operations when the container is unmounted
                disposables.forEach((disposable)=>disposable.dispose());
            }
    }
});

});
parcelRegister("38YP1", function(module, exports) {

$parcel$export(module.exports, "handleSearchInputUpdate", () => $9724564c3e5356c1$export$9c870f2e3983e32a);
$parcel$export(module.exports, "actions", () => $9724564c3e5356c1$export$e324594224ef24da);

var $6HFEN = parcelRequire("6HFEN");

var $37Ewn = parcelRequire("37Ewn");

var $aXKmr = parcelRequire("aXKmr");

var $7jTnu = parcelRequire("7jTnu");

var $82cqT = parcelRequire("82cqT");

var $awWeA = parcelRequire("awWeA");

var $koarv = parcelRequire("koarv");

var $9S9Cb = parcelRequire("9S9Cb");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $48isi = parcelRequire("48isi");
const $9724564c3e5356c1$export$9c870f2e3983e32a = ()=>({ dispatch: dispatch }, { issueSearchInput: issueSearchInput, filterId: filterId, viewId: viewId })=>{
        const shouldLoadWithFilterViewId = viewId !== 'detail' && issueSearchInput.filterId && (0, $82cqT.isCustomFilter)(issueSearchInput.filterId);
        const isCurrentViewIdInvalid = (0, $eibCx.isFilterViewId)(viewId) && viewId !== `list_filter_${filterId}`;
        let variables = {};
        if (issueSearchInput.filterId && shouldLoadWithFilterViewId) {
            const issueNavigatorViewId = (0, $eibCx.convertFilterIdToIssueNavigatorId)(issueSearchInput.filterId);
            variables = {
                viewId: issueNavigatorViewId,
                fieldSetsInput: {
                    viewInput: {
                        namespace: 'ISSUE_NAVIGATOR',
                        viewId: issueNavigatorViewId
                    }
                }
            };
        } else if (isCurrentViewIdInvalid) variables = {
            viewId: (0, $iRahl.DEFAULT_VIEW_ID),
            fieldSetsInput: {
                viewInput: {
                    namespace: 'ISSUE_NAVIGATOR',
                    viewId: (0, $iRahl.DEFAULT_VIEW_ID)
                }
            }
        };
        dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch(variables));
    };
const $9724564c3e5356c1$export$9eb6b63e55022ba0 = ()=>({ setState: setState })=>{
        setState({
            totalIssueCount: null,
            totalIssueCountIsFetching: false,
            totalIssueCountIsError: false
        });
    };
const $9724564c3e5356c1$export$e324594224ef24da = {
    changeView: (viewId)=>({ dispatch: dispatch }, { onSelectedViewMutation: onSelectedViewMutation, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, activationId: activationId, cloudId: cloudId, projectId: projectId, viewItemId: viewItemId, issueSearchInput: issueSearchInput })=>{
            let viewARI = '';
            if ((0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding')) {
                const layout = viewId === 'detail' ? 'detail' : 'list';
                viewARI = (0, $9S9Cb.createViewAri)({
                    activationId: activationId,
                    cloudId: cloudId,
                    layout: layout,
                    projectId: projectId,
                    viewItemId: viewItemId
                });
            }
            onSelectedViewMutation(viewId, viewARI);
            dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch({
                viewId: viewId,
                fieldSetsInput: {
                    viewInput: {
                        namespace: 'ISSUE_NAVIGATOR',
                        viewId: viewId
                    }
                },
                ...(isIssueHierarchySupportEnabled || (0, $7jTnu.fg)('jsc_hide_done_view_config_fix')) && {
                    viewConfigInput: {
                        viewInput: {
                            namespace: 'ISSUE_NAVIGATOR',
                            viewId: viewId
                        }
                    },
                    shouldQueryHasChildren: isIssueHierarchySupportEnabled ? viewId !== 'detail' : false,
                    staticViewInput: null
                },
                ...(0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding') ? {
                    settings: {
                        jql: issueSearchInput.jql
                    }
                } : {}
            }));
        },
    resetView: ()=>({ dispatch: dispatch }, { activationId: activationId, cloudId: cloudId, projectId: projectId, viewItemId: viewItemId })=>{
            dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch({
                fieldSetsInput: {
                    viewInput: {
                        namespace: 'ISSUE_NAVIGATOR'
                    }
                },
                settings: null,
                staticViewInput: null,
                viewConfigInput: null,
                viewQueryInput: {
                    viewAri: (0, $9S9Cb.createViewAri)({
                        activationId: activationId,
                        cloudId: cloudId,
                        projectId: projectId,
                        viewItemId: viewItemId
                    })
                }
            }));
        },
    changeHierarchy: (nextIsHierarchyEnabled)=>({ dispatch: dispatch }, { isHierarchyEnabled: isHierarchyEnabled, groupedByField: groupedByField, isHideDoneEnabled: isHideDoneEnabled, issueSearchInput: issueSearchInput })=>{
            if (nextIsHierarchyEnabled !== isHierarchyEnabled) {
                const staticViewInput = {
                    isHierarchyEnabled: nextIsHierarchyEnabled,
                    isGroupingEnabled: !!groupedByField,
                    ...(0, $7jTnu.fg)('jsc_list_hide_done_items') ? {
                        isHideDoneEnabled: isHideDoneEnabled
                    } : {}
                };
                const settings = {
                    hideDone: isHideDoneEnabled,
                    hierarchyEnabled: nextIsHierarchyEnabled,
                    groupBy: groupedByField,
                    jql: issueSearchInput.jql
                };
                dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch({
                    staticViewInput: staticViewInput,
                    viewConfigInput: {
                        staticViewInput: staticViewInput
                    },
                    shouldQueryHasChildren: Boolean(nextIsHierarchyEnabled),
                    ...(0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding') ? {
                        settings: settings
                    } : {}
                }));
            }
        },
    changeGroupedByField: (nextGroupedByField)=>({ dispatch: dispatch }, { isHierarchyEnabled: isHierarchyEnabled, isHideDoneEnabled: isHideDoneEnabled, issueSearchInput: issueSearchInput })=>{
            const staticViewInput = {
                isHierarchyEnabled: isHierarchyEnabled,
                isGroupingEnabled: !!nextGroupedByField,
                ...(0, $7jTnu.fg)('jsc_list_hide_done_items') ? {
                    isHideDoneEnabled: isHideDoneEnabled
                } : {}
            };
            const settings = {
                hideDone: isHideDoneEnabled,
                hierarchyEnabled: isHierarchyEnabled,
                groupBy: nextGroupedByField ?? null,
                jql: issueSearchInput.jql
            };
            dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch({
                groupBy: nextGroupedByField,
                staticViewInput: staticViewInput,
                viewConfigInput: {
                    staticViewInput: staticViewInput
                },
                ...(0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding') ? {
                    settings: settings
                } : {}
            }));
        },
    changeHideDone: (nextIsHideDoneEnabled)=>({ dispatch: dispatch }, { isHierarchyEnabled: isHierarchyEnabled, groupedByField: groupedByField, isHideDoneEnabled: isHideDoneEnabled, issueSearchInput: issueSearchInput })=>{
            if (nextIsHideDoneEnabled !== isHideDoneEnabled) {
                const staticViewInput = {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isGroupingEnabled: !!groupedByField,
                    isHideDoneEnabled: nextIsHideDoneEnabled
                };
                const settings = {
                    hideDone: nextIsHideDoneEnabled,
                    hierarchyEnabled: isHierarchyEnabled,
                    groupBy: groupedByField,
                    jql: issueSearchInput.jql
                };
                dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch({
                    staticViewInput: staticViewInput,
                    viewConfigInput: {
                        staticViewInput: staticViewInput
                    },
                    shouldQueryHasChildren: Boolean(isHierarchyEnabled),
                    ...(0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding') ? {
                        settings: settings
                    } : {}
                }));
            }
        },
    refetch: (variables = {}, options = {})=>({ dispatch: dispatch, getState: getState, setState: setState }, { cloudId: cloudId, environment: environment, issueSearchInput: issueSearchInput, onRefetchStart: onRefetchStart, onRefetchError: onRefetchError, refetch: refetch, viewId: viewId, isHierarchyEnabled: isHierarchyEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, projectContext: projectContext, groupedByField: groupedByField, isHideDoneEnabled: isHideDoneEnabled, activationId: activationId, projectId: projectId, viewItemId: viewItemId })=>{
            let { inFlightRequest: inFlightRequest } = getState();
            // Some consumers may fire refetch queries before in-flight query
            // has been completed (e.g. while user is toggling columns on and off in
            // the column picker). In these situations, we always want to fetch latest
            // data from the API as column configuration may have changed for the user.
            // To do that, we disable Relay's automatic de-deduping of requests.
            inFlightRequest?.unsubscribe();
            const staticViewInput = {
                isHierarchyEnabled: isHierarchyEnabled,
                isGroupingEnabled: !!groupedByField,
                isHideDoneEnabled: isHideDoneEnabled
            };
            const settings = {
                hideDone: isHideDoneEnabled,
                hierarchyEnabled: isHierarchyEnabled,
                groupBy: groupedByField,
                jql: issueSearchInput.jql
            };
            let operationScope;
            if (isInlineFieldConfigEnabled) operationScope = (0, $awWeA.getOperationScope)(projectContext);
            else if (projectContext) operationScope = (0, $iRahl.NIN_PROJECT_OPERATION_SCOPE);
            else operationScope = (0, $iRahl.NIN_GLOBAL_OPERATION_SCOPE);
            let fieldSetsScope;
            if ((0, $7jTnu.fg)('set_fieldsetsscope_to_null')) {
                if (isInlineFieldConfigEnabled) fieldSetsScope = {
                    operationScope: operationScope,
                    projectKey: projectContext
                };
                else fieldSetsScope = null;
            }
            const finalVariables = {
                cloudId: cloudId,
                issueSearchInput: issueSearchInput,
                first: (0, $iRahl.MAX_ISSUES_PER_PAGE),
                after: null,
                namespace: 'ISSUE_NAVIGATOR',
                viewId: viewId,
                options: null,
                shouldQueryHasChildren: isHierarchyEnabled || false,
                fieldSetsInput: {
                    viewInput: {
                        namespace: 'ISSUE_NAVIGATOR',
                        viewId: viewId
                    }
                },
                amountOfColumns: (0, $iRahl.MAX_AMOUNT_OF_COLUMNS),
                ...(0, $7jTnu.fg)('jsc_nin_operation_scope_fe') && {
                    scope: {
                        operationScope: operationScope,
                        ...projectContext && isInlineFieldConfigEnabled ? {
                            projectKey: projectContext ?? null
                        } : {}
                    }
                },
                filterId: null,
                staticViewInput: staticViewInput,
                viewConfigInput: {
                    staticViewInput: staticViewInput
                },
                ...(0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding') ? {
                    settings: settings
                } : {},
                groupBy: groupedByField,
                isPaginating: false,
                projectKeys: projectContext ? [
                    projectContext
                ] : null,
                projectKey: projectContext ?? null,
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                ...isInlineFieldConfigEnabled && !(0, $7jTnu.fg)('set_fieldsetsscope_to_null') && {
                    fieldSetsScope: {
                        operationScope: operationScope,
                        projectKey: projectContext
                    }
                },
                ...(0, $7jTnu.fg)('set_fieldsetsscope_to_null') && {
                    fieldSetsScope: fieldSetsScope
                },
                ...(0, $7jTnu.fg)('jira_nin_last_used_jql') ? {
                    saveJQLToUserHistory: true
                } : {
                    saveJQLToUserHistory: false
                },
                ...variables
            };
            if (finalVariables.viewQueryInput == null && (0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding')) {
                let layout = 'list';
                if (finalVariables.viewId === 'detail') layout = 'detail';
                else if (finalVariables.groupBy != null) layout = 'grouped';
                finalVariables.viewQueryInput = {
                    viewAri: (0, $9S9Cb.createViewAri)({
                        activationId: activationId,
                        cloudId: cloudId,
                        layout: layout,
                        projectId: projectId,
                        viewItemId: viewItemId
                    })
                };
            }
            inFlightRequest = (0, $37Ewn.fetchQuery)(environment, (0, $koarv.default), finalVariables, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                complete: ()=>{
                    /**
         * fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
         * data will remain saved in the Relay store at any point after the request completes.
         * We need to explicitly retain the operation to ensure it doesn't get deleted.
         * See https://relay.dev/docs/api-reference/fetch-query/#behavior
         */ const operation = (0, $37Ewn.createOperationDescriptor)((0, $37Ewn.getRequest)((0, $koarv.default)), finalVariables);
                    const { disposables: disposables } = getState();
                    setState({
                        disposables: disposables.concat([
                            environment.retain(operation)
                        ])
                    });
                    let hasStoreRefetchCompleted = false;
                    const storeRefetch = ()=>{
                        refetch(finalVariables, {
                            fetchPolicy: 'store-only',
                            onComplete: ()=>{
                                /**
               * Relay will dispose the cached operation after a 5m timeout, in which case it will
               * refetch the query from the store and retrigger the onComplete callback. We need to
               * ensure this callback is invoked strictly once to prevent unexpected side effects,
               * e.g. https://jira.atlassian.com/browse/JRACLOUD-84106.
               */ if (hasStoreRefetchCompleted) return;
                                hasStoreRefetchCompleted = true;
                                /**
               * A very difficult to debug race condition emerges when setState is called in the same
               * update cycle as our refetch function. It appears to be related to useSyncExternalStore
               * (used internally by RSS) internal state becoming out of sync which prevents it from
               * correctly notifying listeners (i.e. hooks consumers) when an update is made. Scheduling
               * the update at the end of the event loop is the simplest way of mitigating the bug,
               * but we should revisit this once React concurrent rendering is enabled.
               *
               * Bug this fixes: When clicking "refresh" button multiple times, the shaded loading
               * state on the table will only appear the first time.
               */ queueMicrotask(()=>{
                                    setState({
                                        isFetching: false,
                                        isFetchingView: false,
                                        searchKey: (0, $aXKmr.v4)()
                                    });
                                    dispatch($9724564c3e5356c1$export$9eb6b63e55022ba0());
                                    options.onComplete?.();
                                });
                            }
                        });
                    };
                    /**
         * Delaying the store refetch until the next tick in order to avoid a race condition that occurs
         * when react concurrent mode is enabled. In the future (once concurrent mode rollout is
         * complete), we should replace this suspenseless refetch pattern with transitions.
         *
         * Bug this fixes: Features that perform state updates shortly after the refetch (like toggling
         * hierarchy or grouping) can result in a flicker between old results an new results.
         */ setTimeout(storeRefetch, 0);
                    if (projectContext && viewId !== 'detail') {
                        if ((0, $7jTnu.fg)('jira_list_group_shadow_requests')) {
                            const groupByFields = (0, $7jTnu.fg)('jira_list_main_shadow_query_group_overrides') ? [
                                'status',
                                'assignee',
                                'priority',
                                'com.atlassian.jira.plugin.system.customfieldtypes:float',
                                'com.pyxis.greenhopper.jira:jsw-story-points',
                                'com.pyxis.greenhopper.jira:gh-sprint',
                                'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category'
                            ] : [
                                'status',
                                'assignee',
                                'priority'
                            ];
                            (0, $48isi.fetchIssueNavigatorIssueSearchRefetchQueryShadow)({
                                ...finalVariables,
                                staticViewInput: {
                                    ...(0, $7jTnu.fg)('jsc_list_hide_done_items') ? finalVariables.staticViewInput : {},
                                    isHierarchyEnabled: false,
                                    isGroupingEnabled: true
                                },
                                viewConfigInput: {
                                    staticViewInput: {
                                        ...finalVariables.viewConfigInput && (0, $7jTnu.fg)('jsc_list_hide_done_items') ? finalVariables.viewConfigInput.staticViewInput : {},
                                        isHierarchyEnabled: false,
                                        isGroupingEnabled: true
                                    }
                                },
                                // Randomly select a groupBy field to test the shadow request
                                groupBy: groupByFields[Math.floor(Math.random() * groupByFields.length)]
                            }, true);
                        } else if ((0, $7jTnu.fg)('jsc_shadow_requests_for_project_column_config')) {
                            const fsOperationScope = (0, $iRahl.NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE);
                            const variableOverrides = {
                                fieldSetsScope: {
                                    operationScope: fsOperationScope,
                                    projectKey: projectContext
                                }
                            };
                            (0, $48isi.fetchIssueNavigatorIssueSearchRefetchQueryShadow)({
                                ...finalVariables,
                                ...variableOverrides
                            }, false);
                        }
                    }
                },
                error: (error)=>{
                    setState({
                        isFetching: false,
                        isFetchingView: false,
                        isNetworkError: true
                    });
                    options.onError?.();
                    onRefetchError?.(error, (0, $eibCx.parseIssueNavigatorViewIdOrDefault)(finalVariables.viewId));
                },
                unsubscribe: ()=>{
                    options.onUnsubscribe?.();
                }
            });
            onRefetchStart?.();
            setState({
                inFlightRequest: inFlightRequest,
                isFetching: true,
                isFetchingView: viewId !== finalVariables.viewId,
                isNetworkError: false
            });
        },
    refresh: ()=>({ setState: setState, dispatch: dispatch })=>{
            setState({
                isRefreshing: true
            });
            const onFinish = ()=>{
                setState({
                    isRefreshing: false
                });
            };
            dispatch($9724564c3e5356c1$export$e324594224ef24da.refetch({}, {
                onComplete: onFinish,
                onError: onFinish,
                onUnsubscribe: onFinish
            }));
        },
    fetchTotalIssueCount: ()=>({ setState: setState }, { environment: environment, cloudId: cloudId, issueSearchInput: issueSearchInput, isHierarchyEnabled: isHierarchyEnabled, isHideDoneEnabled: isHideDoneEnabled, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled })=>{
            setState({
                totalIssueCount: null,
                totalIssueCountIsFetching: true,
                totalIssueCountIsError: false
            });
            const viewConfigInput = isIssueHierarchySupportEnabled || isHideDoneEnabled && (0, $7jTnu.fg)('jsc_list_hide_done_items') ? {
                staticViewInput: {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isHideDoneEnabled: isHideDoneEnabled
                }
            } : null;
            (0, $37Ewn.fetchQuery)(environment, (0, $6HFEN.default), {
                cloudId: cloudId,
                issueSearchInput: issueSearchInput,
                viewConfigInput: viewConfigInput
            }, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                next: (data)=>{
                    const totalIssueCount = data?.jira?.issueSearchTotalCount ?? null;
                    const totalIssueCountIsError = totalIssueCount === null;
                    setState({
                        totalIssueCount: totalIssueCount,
                        totalIssueCountIsFetching: false,
                        totalIssueCountIsError: totalIssueCountIsError
                    });
                },
                error: ()=>{
                    setState({
                        totalIssueCount: null,
                        totalIssueCountIsFetching: false,
                        totalIssueCountIsError: true
                    });
                }
            });
        }
};

});
parcelRegister("6HFEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1794bbcbe60605cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9244a250ea116e05fe626bb9ce17a42e>>
 * @relayHash de122fab1f76e33de979655b8a8c56c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f9cc42e6580b3f106e3737ff40b96eca4407846844604fe1c42ce16bba8fc5d
const $1794bbcbe60605cf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewConfigInput"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewConfigInput",
                            "variableName": "viewConfigInput"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "issueSearchTotalCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "actions_issueSearchTotalCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "actions_issueSearchTotalCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2f9cc42e6580b3f106e3737ff40b96eca4407846844604fe1c42ce16bba8fc5d",
            "metadata": {},
            "name": "actions_issueSearchTotalCountQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1794bbcbe60605cf$var$node.hash = "82fd57c594d13d97ce59735d9e84149d";
var $1794bbcbe60605cf$export$2e2bcd8739ae039 = $1794bbcbe60605cf$var$node;

});



parcelRegister("5lUfC", function(module, exports) {

$parcel$export(module.exports, "useSelectedViewMutation", () => $71afd6653e17f6b3$export$765f658bb8bac50f);

var $8cH7P = parcelRequire("8cH7P");

var $ce0tg = parcelRequire("ce0tg");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $gYnSx = parcelRequire("gYnSx");

var $kEUB1 = parcelRequire("kEUB1");

var $iRahl = parcelRequire("iRahl");
const $71afd6653e17f6b3$export$5786a571e562003d = (view)=>view.startsWith('list_') ? 'LIST' : 'DETAIL';
const $71afd6653e17f6b3$export$765f658bb8bac50f = ()=>{
    const userCloudId = (0, $kEUB1.useCloudId)();
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $ce0tg.default));
    const [commit] = (0, $j4oe4.useMutation)((0, $8cH7P.default));
    return (0, $eJOHy.useCallback)((view, viewARI)=>{
        if ((0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding')) commit({
            variables: {
                input: {
                    viewId: viewARI,
                    viewLayout: $71afd6653e17f6b3$export$5786a571e562003d(view)
                }
            },
            onError: (error)=>{
                (0, $gYnSx.default)({
                    sendToPrivacyUnsafeSplunk: true,
                    error: error,
                    meta: {
                        id: 'mainSelectedViewMutation',
                        packageName: (0, $iRahl.PACKAGE_NAME),
                        teamName: (0, $iRahl.TEAM_NAME)
                    }
                });
            },
            optimisticResponse: {
                jira_setIssueSearchViewLayout: {
                    success: true,
                    errors: []
                }
            }
        });
        else commitMutation({
            variables: {
                cloudId: userCloudId,
                searchLayout: $71afd6653e17f6b3$export$5786a571e562003d(view)
            },
            onError: (error)=>{
                (0, $gYnSx.default)({
                    sendToPrivacyUnsafeSplunk: true,
                    error: error,
                    meta: {
                        id: 'mainSelectedViewMutation',
                        packageName: (0, $iRahl.PACKAGE_NAME),
                        teamName: (0, $iRahl.TEAM_NAME)
                    }
                });
            },
            optimisticResponse: {
                jira: {
                    userPreferences: {
                        setIssueNavigatorSearchLayout: {
                            success: true,
                            errors: [],
                            issueNavigatorSearchLayout: $71afd6653e17f6b3$export$5786a571e562003d(view)
                        }
                    }
                }
            }
        });
    }, [
        commit,
        commitMutation,
        userCloudId
    ]);
};

});
parcelRegister("8cH7P", function(module, exports) {

$parcel$export(module.exports, "default", () => $5326bead980dcff2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e7189ca0884fb6a2778f8230b6eb5c66>>
 * @relayHash 741cb5df6adfcaa4c4e00bf870fcc0c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f332c502a8d6c3f21250ad8d9e08058c42cb19c588d63f4ea5818ad100a18f9
const $5326bead980dcff2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "JiraSetIssueSearchViewLayoutPayload",
            "kind": "LinkedField",
            "name": "jira_setIssueSearchViewLayout",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSelectedViewMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSelectedViewMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "5f332c502a8d6c3f21250ad8d9e08058c42cb19c588d63f4ea5818ad100a18f9",
            "metadata": {},
            "name": "useSelectedViewMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$5326bead980dcff2$var$node.hash = "65b41e477de41628cbbb17392e93350d";
var $5326bead980dcff2$export$2e2bcd8739ae039 = $5326bead980dcff2$var$node;

});

parcelRegister("ce0tg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1982e60e250656f5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a3bc6510292ce94117d6582f5f11dc6>>
 * @relayHash a9f32b8a40e62d50ea93109e8a20f2cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb739b5da2438ed07259ec682dabb897bf77f788cc0ef58a85897005e02467e5
const $1982e60e250656f5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchLayout"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserPreferencesMutation",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "searchLayout",
                                    "variableName": "searchLayout"
                                }
                            ],
                            "concreteType": "JiraIssueNavigatorSearchLayoutMutationPayload",
                            "kind": "LinkedField",
                            "name": "setIssueNavigatorSearchLayout",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueNavigatorSearchLayout"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSelectedViewMutationOldMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSelectedViewMutationOldMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "fb739b5da2438ed07259ec682dabb897bf77f788cc0ef58a85897005e02467e5",
            "metadata": {},
            "name": "useSelectedViewMutationOldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$1982e60e250656f5$var$node.hash = "fc5879cd5e3ff3110514f54a88b6d958";
var $1982e60e250656f5$export$2e2bcd8739ae039 = $1982e60e250656f5$var$node;

});


parcelRegister("aaLZH", function(module, exports) {

$parcel$export(module.exports, "useIssueNavigatorFeatures", () => $e6a83fe9a48197d6$export$403fe21e578d284c);
$parcel$export(module.exports, "useIssueNavigatorFeature", () => $e6a83fe9a48197d6$export$caa5cde5243e13a8);
$parcel$export(module.exports, "IssueNavigatorFeatureProvider", () => $e6a83fe9a48197d6$export$682e7a54b8447684);
$parcel$export(module.exports, "IssueNavigatorFeatureGuard", () => $e6a83fe9a48197d6$export$7b56b3a54a98f99c);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $bJscI = parcelRequire("bJscI");
const $e6a83fe9a48197d6$var$defaultFeatureContext = {
    isViewSwitcherEnabled: true,
    isOnboardingEnabled: true,
    isExportMenuEnabled: true,
    isRowContextMenuEnabled: true,
    isSaveFilterButtonEnabled: true,
    isBulkChangeWorkItemsEnabled: true,
    isImportWorkItemsFromCSVEnabled: true,
    isViewAsChartEnabled: true,
    isConditionalFormattingEnabled: false,
    isProjectQuickstartOnboardingEnabled: false
};
const $e6a83fe9a48197d6$var$IssueNavigatorFeatureContext = /*#__PURE__*/ (0, $eJOHy.createContext)($e6a83fe9a48197d6$var$defaultFeatureContext);
const $e6a83fe9a48197d6$export$403fe21e578d284c = ()=>(0, $eJOHy.useContext)($e6a83fe9a48197d6$var$IssueNavigatorFeatureContext);
const $e6a83fe9a48197d6$export$caa5cde5243e13a8 = (featureKey)=>$e6a83fe9a48197d6$export$403fe21e578d284c()[featureKey];
const $e6a83fe9a48197d6$var$IssueNavigatorFeatureOldProvider = ({ children: children, ...props })=>{
    const value = (0, $eJOHy.useMemo)(()=>({
            ...$e6a83fe9a48197d6$var$defaultFeatureContext,
            ...props
        }), [
        props
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e6a83fe9a48197d6$var$IssueNavigatorFeatureContext.Provider, {
        value: value
    }, children);
};
const $e6a83fe9a48197d6$var$IssueNavigatorFeatureNewProvider = ({ children: children, isBulkChangeWorkItemsEnabled: isBulkChangeWorkItemsEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled, isExportMenuEnabled: isExportMenuEnabled, isImportWorkItemsFromCSVEnabled: isImportWorkItemsFromCSVEnabled, isOnboardingEnabled: isOnboardingEnabled, isProjectQuickstartOnboardingEnabled: isProjectQuickstartOnboardingEnabled, isRowContextMenuEnabled: isRowContextMenuEnabled, isSaveFilterButtonEnabled: isSaveFilterButtonEnabled, isViewAsChartEnabled: isViewAsChartEnabled, isViewSwitcherEnabled: isViewSwitcherEnabled })=>{
    const value = (0, $eJOHy.useMemo)(()=>({
            isBulkChangeWorkItemsEnabled: isBulkChangeWorkItemsEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isBulkChangeWorkItemsEnabled,
            isConditionalFormattingEnabled: isConditionalFormattingEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isConditionalFormattingEnabled,
            isExportMenuEnabled: isExportMenuEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isExportMenuEnabled,
            isImportWorkItemsFromCSVEnabled: isImportWorkItemsFromCSVEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isImportWorkItemsFromCSVEnabled,
            isOnboardingEnabled: isOnboardingEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isOnboardingEnabled,
            isProjectQuickstartOnboardingEnabled: isProjectQuickstartOnboardingEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isProjectQuickstartOnboardingEnabled,
            isRowContextMenuEnabled: isRowContextMenuEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isRowContextMenuEnabled,
            isSaveFilterButtonEnabled: isSaveFilterButtonEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isSaveFilterButtonEnabled,
            isViewAsChartEnabled: isViewAsChartEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isViewAsChartEnabled,
            isViewSwitcherEnabled: isViewSwitcherEnabled ?? $e6a83fe9a48197d6$var$defaultFeatureContext.isViewSwitcherEnabled
        }), [
        isBulkChangeWorkItemsEnabled,
        isConditionalFormattingEnabled,
        isExportMenuEnabled,
        isImportWorkItemsFromCSVEnabled,
        isOnboardingEnabled,
        isProjectQuickstartOnboardingEnabled,
        isRowContextMenuEnabled,
        isSaveFilterButtonEnabled,
        isViewAsChartEnabled,
        isViewSwitcherEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e6a83fe9a48197d6$var$IssueNavigatorFeatureContext.Provider, {
        value: value
    }, children);
};
const $e6a83fe9a48197d6$export$682e7a54b8447684 = (0, $bJscI.componentWithFG)('jira_list_conditional_formatting_feature_context', $e6a83fe9a48197d6$var$IssueNavigatorFeatureNewProvider, $e6a83fe9a48197d6$var$IssueNavigatorFeatureOldProvider);
const $e6a83fe9a48197d6$var$IssueNavigatorFeatureGuard = ({ featureKey: featureKey, on: on, off: off })=>{
    const feature = $e6a83fe9a48197d6$export$caa5cde5243e13a8(featureKey);
    return feature ? on : off;
};
const $e6a83fe9a48197d6$export$7b56b3a54a98f99c = ({ fallback: fallback, ...props })=>{
    return (0, $7jTnu.fg)('jira_nin_smart_link') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e6a83fe9a48197d6$var$IssueNavigatorFeatureGuard, props) : fallback;
};

});

parcelRegister("jHM2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c7f4aafd27e2e4c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4c7f4aafd27e2e4c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    searchFailedTitle: {
        "id": "issue-navigator.issue-search.search-failed-title",
        "defaultMessage": "We couldn't load your search results"
    },
    searchFailedDescription: {
        "id": "issue-navigator.issue-search.search-failed-description",
        "defaultMessage": "Refresh and try again."
    }
});

});


parcelRegister("2kVBT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5861a3b1095a50f$export$2e2bcd8739ae039);

var $iPbI8 = parcelRequire("iPbI8");

var $ePndi = parcelRequire("ePndi");

var $9bJRg = parcelRequire("9bJRg");

var $gQwl3 = parcelRequire("gQwl3");

var $6tVNx = parcelRequire("6tVNx");

var $k1M6e = parcelRequire("k1M6e");

var $5lLtn = parcelRequire("5lLtn");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $dLR8J = parcelRequire("dLR8J");

var $8l1NO = parcelRequire("8l1NO");

var $ap5Bt = parcelRequire("ap5Bt");

var $8NIGX = parcelRequire("8NIGX");

var $80Alx = parcelRequire("80Alx");

var $8nw3F = parcelRequire("8nw3F");

var $iZsVo = parcelRequire("iZsVo");

var $C81Q0 = parcelRequire("C81Q0");

var $bbdV2 = parcelRequire("bbdV2");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $1uIew = parcelRequire("1uIew");

var $lRq8t = parcelRequire("lRq8t");

var $82cqT = parcelRequire("82cqT");

var $lHHP1 = parcelRequire("lHHP1");

var $cGA2b = parcelRequire("cGA2b");

var $3TtKq = parcelRequire("3TtKq");

var $3cJQz = parcelRequire("3cJQz");

var $6d9QY = parcelRequire("6d9QY");

var $iqtgH = parcelRequire("iqtgH");

var $9WMzW = parcelRequire("9WMzW");

var $9bIo2 = parcelRequire("9bIo2");

var $iRahl = parcelRequire("iRahl");

var $cZHhU = parcelRequire("cZHhU");

var $fAgUF = parcelRequire("fAgUF");

var $51pSU = parcelRequire("51pSU");

var $1wL9i = parcelRequire("1wL9i");

var $HiS1C = parcelRequire("HiS1C");

var $fwKw5 = parcelRequire("fwKw5");

var $cJdYi = parcelRequire("cJdYi");

var $3kDjB = parcelRequire("3kDjB");

var $lvpZz = parcelRequire("lvpZz");

var $7EogO = parcelRequire("7EogO");

var $6Al27 = parcelRequire("6Al27");

var $aaLZH = parcelRequire("aaLZH");

var $l7VRV = parcelRequire("l7VRV");

var $cZQDI = parcelRequire("cZQDI");

var $7ZGNh = parcelRequire("7ZGNh");

var $cPfqZ = parcelRequire("cPfqZ");

var $e78V2 = parcelRequire("e78V2");

var $l5sqM = parcelRequire("l5sqM");

var $1TTSy = parcelRequire("1TTSy");

var $dpNFU = parcelRequire("dpNFU");

var $78img = parcelRequire("78img");

var $2cvR1 = parcelRequire("2cvR1");

var $f7hID = parcelRequire("f7hID");

var $5eCXQ = parcelRequire("5eCXQ");
const $a5861a3b1095a50f$var$SidebarLayout = ({ children: children, project: project })=>{
    const projectData = (0, $j4oe4.useFragment)((0, $5lLtn.default), project);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9WMzW.SidebarLayout), {
        defaultRatio: 0.3,
        minWidth: 360,
        maxRatio: 0.75,
        teamName: "empanada",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7hID.SidebarExperienceRegistryWithErrorBoundary), {
            project: projectData ?? null
        })
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2cvR1.SidebarCloserController), null));
};
const $a5861a3b1095a50f$var$staticEntrypointParams = {
    cloudId: undefined,
    projectKey: undefined
}; // Creating this here to always use the same reference when has rules regardles os memo deps
const $a5861a3b1095a50f$export$397fa57fff06920f = ({ CustomHeader: CustomHeader, ActionMenu: ActionMenu, HeaderSkeletonImage: HeaderSkeletonImage, filter: filter, onPageDataLoad: onPageDataLoad, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onChangeIssue: onChangeIssue, onChangeFilter: onChangeFilter, defaultJql: defaultJql, onRefinement: onRefinement, onIssueFlatListUpdated: onIssueFlatListUpdated, issueResults: issueResults, groupResults: groupResults, project: project, userPreferences: userPreferences, jqlBuilderProps: jqlBuilderProps, jqlBuilderWithAiKey: jqlBuilderWithAiKey, issueTableProps: issueTableProps, isGridNavigationEnabled: isGridNavigationEnabled, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled, isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, jiraView: jiraView, initialQueryAsJql: initialQueryAsJql, isInitialized: isInitialized })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_NAVIGATOR_UI_START);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_NAVIGATOR_UI_END);
    }, []);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)(); // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const setJql = (0, $7jTnu.fg)('saved_list_view_technical_changes') ? (0, $7EogO.useSetJql)() : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    const [caughtIssueSearchError, setCaughtIssueSearchError] = (0, $eJOHy.useState)();
    const { filterId: filterId } = (0, $fwKw5.useActiveJql)();
    const resolvedJql = (0, $fwKw5.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $cJdYi.useFilterQuery)();
    const searchKey = (0, $3kDjB.useSearchKey)();
    const previousData = (0, $6d9QY.usePrevious)(searchKey);
    const hasSearchChanged = Boolean(searchKey && searchKey !== previousData);
    const [{ view: selectedView }] = (0, $HiS1C.useSelectedViewState)();
    const issueResultsData = (0, $j4oe4.useFragment)((0, $k1M6e.default), issueResults);
    const groupResultsData = (0, $j4oe4.useFragment)((0, $6tVNx.default), groupResults);
    const jiraViewData = (0, $j4oe4.useFragment)((0, $gQwl3.default), jiraView);
    const hasStickyColumn = (0, $7jTnu.fg)('issue_table_frozen_columns') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>jiraViewData?.fieldSets?.edges?.some((edge)=>edge?.node?.fieldSetPreferences?.isFrozen === true) ?? false, [
        jiraViewData?.fieldSets?.edges
    ]) : false;
    const handleChangeJql = (0, $eJOHy.useCallback)((jql, clearFilter)=>{
        onChangeJql?.(jql, clearFilter);
        if ((0, $7jTnu.fg)('saved_list_view_technical_changes')) {
            const savedViewId = jiraViewData?.savedViewId;
            if (savedViewId == null) throw new Error('Missing saved view ID');
            setJql({
                jql: jql,
                viewARI: savedViewId
            });
        }
    }, [
        jiraViewData?.savedViewId,
        onChangeJql,
        setJql
    ]);
    const onChange = (0, $eJOHy.useCallback)((jql)=>{
        onRefinement && onRefinement();
        handleChangeJql(jql, !filterQueryIsFetching && filter === null && (0, $82cqT.isFilterId)(filterId));
    }, [
        filter,
        filterId,
        filterQueryIsFetching,
        handleChangeJql,
        onRefinement
    ]);
    const handleReset = (0, $eJOHy.useCallback)((isResetToFilter = false)=>{
        if (isResetToFilter) onChangeFilter && onChangeFilter();
        else handleChangeJql(defaultJql, true);
    }, [
        onChangeFilter,
        handleChangeJql,
        defaultJql
    ]);
    const viewResultError = (0, $eJOHy.useMemo)(()=>{
        if (!jiraViewData) return undefined;
        const message = jiraViewData.error?.message ?? '';
        const statusCode = jiraViewData.error?.extensions?.[0].statusCode;
        if (typeof statusCode !== 'number') return;
        return new (0, $1uIew.default)(statusCode, message);
    }, [
        jiraViewData
    ]);
    const userPreferencesData = (0, $j4oe4.useFragment)((0, $9bJRg.default), userPreferences);
    const jqlBuilderWithAiData = (0, $j4oe4.useFragment)((0, $ePndi.default), jqlBuilderWithAiKey);
    const projectData = (0, $j4oe4.useFragment)((0, $iPbI8.default), project);
    const isConditionalFormattingEnabled = (0, $7jTnu.fg)('jira_list_conditional_formatting') && // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $aaLZH.useIssueNavigatorFeatures)().isConditionalFormattingEnabled;
    const hasFormattingRules = (projectData?.conditionalFormattingRules?.edges?.length ?? 0) > 0;
    const isGrouping = (0, $eJOHy.useMemo)(()=>issueTableProps?.isGroupingSupported && jiraViewData?.viewSettings?.isGroupingEnabled && jiraViewData?.viewSettings?.canEnableGrouping, [
        issueTableProps?.isGroupingSupported,
        jiraViewData?.viewSettings?.canEnableGrouping,
        jiraViewData?.viewSettings?.isGroupingEnabled
    ]);
    const screenEventAttributes = (0, $eJOHy.useMemo)(()=>{
        if (!(0, $7jTnu.fg)('jira_list_conditional_formatting') && !(0, $7jTnu.fg)('issue_table_frozen_columns') && !(0, $7jTnu.fg)('group_by_any_fields_technical')) return undefined;
        return {
            ...(0, $7jTnu.fg)('jira_list_conditional_formatting') && {
                isConditionalFormattingEnabled: isConditionalFormattingEnabled,
                hasFormattingRules: hasFormattingRules
            },
            ...(0, $7jTnu.fg)('issue_table_frozen_columns') && {
                isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled,
                hasStickyColumn: hasStickyColumn
            },
            ...(0, $7jTnu.fg)('group_by_any_fields_technical') && {
                isGrouping: isGrouping
            }
        };
    }, [
        hasFormattingRules,
        hasStickyColumn,
        isConditionalFormattingEnabled,
        isFrozenColumnSupportEnabled,
        isGrouping
    ]);
    const shouldAnnounceInfo = (0, $eJOHy.useMemo)(()=>hasSearchChanged && (isGrouping ? groupResultsData !== null : issueResultsData !== null && typeof issueResultsData?.totalIssueSearchResultCount === 'number'), [
        hasSearchChanged,
        isGrouping,
        groupResultsData,
        issueResultsData
    ]);
    const [isAiEnabled, setIsAiEnabled] = (0, $eJOHy.useState)(false);
    const onToggleAi = (0, $eJOHy.useCallback)((isEnabled)=>{
        setIsAiEnabled(isEnabled);
    }, []);
    const serverError = (0, $eJOHy.useMemo)(()=>{
        if (issueResultsData?.issueSearchError?.__typename === 'JiraServerError') return new Error(issueResultsData.issueSearchError.message ?? 'Unknown issue search error');
        if (groupResultsData?.errors?.length) {
            const firstError = groupResultsData.errors.find(({ extensions: extensions })=>!extensions?.some(({ statusCode: statusCode })=>typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500));
            return firstError ? new Error(firstError.message ?? 'Unknown group results error') : undefined;
        }
    }, [
        groupResultsData?.errors,
        issueResultsData?.issueSearchError
    ]);
    const hasServerError = (0, $7jTnu.fg)('empanada_nin_more_issue_search_fail_attributes') ? !!serverError : issueResultsData?.issueSearchError?.__typename === 'JiraServerError' || (groupResultsData?.errors ?? []).some(({ extensions: extensions })=>!extensions?.some(({ statusCode: statusCode })=>typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500));
    const hasViewNotFoundError = !!viewResultError && viewResultError.statusCode === 404;
    const noFilterReason = (0, $eJOHy.useMemo)(()=>{
        if (!filterQueryIsFetching && filter === null && (0, $82cqT.isFilterId)(filterId)) return 'Filter query mismatch';
        if (hasViewNotFoundError) return 'Filter not found in view result';
        return undefined;
    }, [
        filter,
        filterId,
        filterQueryIsFetching,
        hasViewNotFoundError
    ]);
    const IssueNavigatorTopBar = (0, $eJOHy.useMemo)(()=>{
        const jqlBuilder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e78V2.default), {
            onChangeJql: onChange,
            defaultJql: defaultJql,
            filter: filter,
            onReset: handleReset,
            onFilterSave: onChangeFilter,
            groupResults: groupResultsData ?? null,
            issueResults: issueResultsData ?? null,
            onToggleAi: onToggleAi,
            jqlBuilderWithAiKey: jqlBuilderWithAiData ?? null,
            jqlBuilderProps: jqlBuilderProps,
            initialQueryAsJql: initialQueryAsJql,
            disableBackToFilterButton: !!projectData
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $7jTnu.fg)('nin_blindspot_fixes_fy26') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "issue-navigator-top-bar",
            hold: !ActionMenu && !CustomHeader
        }), ActionMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78img.default), {
            ActionMenu: ActionMenu,
            isGroupingSupported: issueTableProps?.isGroupingSupported,
            filter: filter,
            issueResults: issueResultsData ?? null,
            HeaderSkeletonImage: HeaderSkeletonImage,
            jqlBuilder: jqlBuilder,
            jiraViewResult: jiraViewData ?? null,
            projectResult: (0, $7jTnu.fg)('nin-saved-filters') ? projectData ?? null : null,
            onChangeFilter: onChangeFilter,
            onChangeJql: handleChangeJql,
            isGridNavigationEnabled: isGridNavigationEnabled,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            defaultJql: defaultJql
        }), CustomHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ZGNh.default), {
            CustomHeader: CustomHeader,
            filter: filter,
            issueResults: issueResultsData ?? null,
            HeaderSkeletonImage: HeaderSkeletonImage,
            jiraViewResult: jiraViewData ?? null,
            isGroupingSupported: issueTableProps?.isGroupingSupported,
            onChangeFilter: onChangeFilter
        }), jqlBuilder));
    }, [
        onChange,
        defaultJql,
        filter,
        handleReset,
        onChangeFilter,
        groupResultsData,
        issueResultsData,
        onToggleAi,
        jqlBuilderWithAiData,
        jqlBuilderProps,
        initialQueryAsJql,
        projectData,
        ActionMenu,
        CustomHeader,
        issueTableProps?.isGroupingSupported,
        HeaderSkeletonImage,
        jiraViewData,
        handleChangeJql,
        isGridNavigationEnabled,
        isInlineFieldConfigEnabled
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $C81Q0.asyncBulkOpsCoreEntryPoint), $a5861a3b1095a50f$var$staticEntrypointParams);
    let setFlatListIssueIds = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ setFlatListIssueIds: setFlatListIssueIds } = (0, $lvpZz.useFlatListIssuesActions)());
    const handleIssueFlatListUpdated = (0, $eJOHy.useCallback)((newFlatKeyList, newFlatIdList)=>{
        setFlatListIssueIds(newFlatIdList);
        if (onIssueFlatListUpdated) onIssueFlatListUpdated(newFlatKeyList, newFlatIdList);
    }, [
        setFlatListIssueIds,
        onIssueFlatListUpdated
    ]);
    const { isDeleteIssueModalOpen: isDeleteIssueModalOpen, isDeletingIssue: isDeletingIssue, issueId: issueId, issueKey: issueKey, didIssueDeleteFail: didIssueDeleteFail, workType: workType, isIssueArchivalEnabled: isIssueArchivalEnabled, onTriggerDeleteRequest: onTriggerDeleteRequest } = (0, $8l1NO.useDeleteIssueModalStates)();
    const { closeDeleteIssueModal: closeDeleteIssueModal } = (0, $9bIo2.useDeleteIssueModalActions)();
    const isTriggeredFromNINView = (0, $eJOHy.useMemo)(()=>{
        return {
            isIssueArchivalEnabled: isIssueArchivalEnabled,
            isTriggeredFromNINView: true
        };
    }, [
        isIssueArchivalEnabled
    ]);
    let IssueNavigatorContent = (0, $eJOHy.useMemo)(()=>{
        const getAnnouncerMessage = ()=>{
            if (isGrouping) return formatMessage((0, $l5sqM.default).screenReaderGroupResultInfo);
            let message;
            if (issueResultsData?.isCappingIssueSearchResult) message = (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l5sqM.default).screenReaderSearchResultMoreInfoIssueTermRefresh : (0, $l5sqM.default).screenReaderSearchResultMoreInfo;
            else message = (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l5sqM.default).screenReaderSearchResultInfoIssueTermRefresh : (0, $l5sqM.default).screenReaderSearchResultInfo;
            return formatMessage(message, {
                total: issueResultsData?.totalIssueSearchResultCount
            });
        };
        const HierarchyOnboardingProviderComponent = (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? (0, $3cJQz.HierarchyOnboardingProvider) : (0, $eJOHy.Fragment);
        const HideDoneOnboardingProviderComponent = (0, $7jTnu.fg)('jsc_list_hide_done_items') ? (0, $8NIGX.HideDoneOnboardingProvider) : (0, $eJOHy.Fragment);
        const InlineFieldConfigProviderComponent = isInlineFieldConfigEnabled ? (0, $6Al27.IFCEntryPointContextProvider) : (0, $eJOHy.Fragment);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3TtKq.IssueTableSelectedIssuesContainer), {
            onIssueSelected: entryPointActions.load
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $80Alx.IssueFieldStatisticsEntrypointProvider), {
            jql: resolvedJql,
            view: selectedView
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a5861a3b1095a50f$var$SidebarLayout, {
            project: projectData ?? null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l7VRV.BulkOperationsWrapper // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        ), {
            // @ts-ignore - error TS2322: - type mismatch
            bulkOpsCoreEntryPointReference: entryPointReferenceSubject,
            fragmentRef: issueResultsData ?? null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HierarchyOnboardingProviderComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(InlineFieldConfigProviderComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a5861a3b1095a50f$var$IssueNavigatorContentContainer, {
            selectedView: selectedView,
            "data-vc": `issue-navigator-content${false ? '-ssr' : ''}`,
            ...false && {
                'data-ssr-placeholder': 'issue-navigator-content-placeholder'
            },
            ...!false && {
                'data-ssr-placeholder-replace': 'issue-navigator-content-placeholder'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HideDoneOnboardingProviderComponent, null, IssueNavigatorTopBar), (0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cGA2b.JQLDebuggerRenderSlot), null) : null, !filterQueryIsFetching && filter === null && (0, $82cqT.isFilterId)(filterId) || hasViewNotFoundError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZHhU.NoFilter), {
            reason: noFilterReason
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nw3F.AnnouncerV2), {
            message: getAnnouncerMessage(),
            shouldAnnounce: shouldAnnounceInfo,
            testId: "issue-navigator.ui.search-announcer"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cPfqZ.default), {
            hasServerError: hasServerError,
            onChangeColumnConfiguration: onChangeColumnConfiguration,
            onChangeJql: handleChangeJql,
            onCaughtIssueSearchError: setCaughtIssueSearchError,
            issueResults: issueResultsData ?? null,
            jiraView: jiraViewData ?? null,
            project: projectData ?? null,
            rankField: jqlBuilderWithAiData ?? null,
            groupResults: groupResultsData ?? null,
            issueTableProps: issueTableProps,
            isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
            isIssueRankingSupportEnabled: isIssueRankingSupportEnabled,
            isMergedColumnSupportEnabled: isMergedColumnSupportEnabled,
            isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
            onIssueFlatListUpdated: handleIssueFlatListUpdated,
            filter: filter
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dpNFU.default), {
            hasIssueResults: !!issueResultsData?.totalIssueSearchResultCount,
            userPreferences: userPreferencesData ?? null,
            isAiEnabled: isAiEnabled
        }))))))));
    }, [
        isInlineFieldConfigEnabled,
        entryPointActions.load,
        resolvedJql,
        selectedView,
        projectData,
        entryPointReferenceSubject,
        issueResultsData,
        IssueNavigatorTopBar,
        filterQueryIsFetching,
        filter,
        filterId,
        hasViewNotFoundError,
        noFilterReason,
        shouldAnnounceInfo,
        hasServerError,
        onChangeColumnConfiguration,
        handleChangeJql,
        jiraViewData,
        jqlBuilderWithAiData,
        groupResultsData,
        issueTableProps,
        isIssueHierarchySupportEnabled,
        isIssueRankingSupportEnabled,
        isMergedColumnSupportEnabled,
        isFrozenColumnSupportEnabled,
        isInBetweenColumnPickerEnabled,
        handleIssueFlatListUpdated,
        userPreferencesData,
        isAiEnabled,
        isGrouping,
        formatMessage
    ]);
    const isFullPageIssueAppMode = (0, $1wL9i.useIsFullPageIssueAppMode)();
    if (isFullPageIssueAppMode) {
        const view = jiraViewData && (0, $iRahl.isJiraIssueSearchViewMetadata)(jiraViewData) ? jiraViewData : null;
        IssueNavigatorContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZQDI.default), {
            onChangeIssue: onChangeIssue,
            issueResults: issueResultsData ?? null,
            view: view,
            ...(0, $7jTnu.fg)('add-attribute-required-for-colorful-labels-expe') ? {
                projectType: projectData?.projectType
            } : {}
        });
    }
    (0, $lHHP1.useGlobalScopeOptInFlag)();
    const hasIssueResultsData = !!issueResultsData;
    const hasGroupResultsData = !!groupResultsData;
    const hasJiraViewData = !!jiraViewData;
    const hasIssueSearchError = !!caughtIssueSearchError;
    const hasViewResultError = !!viewResultError;
    const hasSearchError = hasServerError || hasIssueSearchError;
    const hasSearchResults = hasIssueResultsData || hasGroupResultsData;
    const isFailedIssueSearch = !hasSearchResults || hasSearchError || !hasJiraViewData || !!viewResultError && viewResultError.statusCode !== 404;
    const isBifrost = !!(0, $iZsVo.ssr).getFeatureFlags()?.ssrViaBifrost;
    return (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, IssueNavigatorContent, (0, $7jTnu.fg)('jira_list_nin_merge') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5eCXQ.SpotlightExploreListClickListener), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1TTSy.default), null), isInitialized && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
            attributes: screenEventAttributes
        }), isFailedIssueSearch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51pSU.IssueSearchFail), {
            location: `${(0, $iRahl.PACKAGE_NAME)}.ui`,
            error: caughtIssueSearchError || viewResultError || ((0, $7jTnu.fg)('empanada_nin_more_issue_search_fail_attributes') ? serverError || new Error('There was an unknown error searching for issues') : new Error('There was an error searching for issues')),
            onPageDataLoad: onPageDataLoad,
            attributes: {
                isAiEnabled: isAiEnabled,
                ...isGrouping ? {
                    experienceId: (0, $iRahl.GROUPED_LIST_EXPERIENCE_ID)
                } : {},
                isBifrost: isBifrost,
                ...(0, $7jTnu.fg)('empanada_nin_more_issue_search_fail_attributes') ? {
                    hasIssueSearchError: hasIssueSearchError,
                    hasViewResultError: hasViewResultError,
                    hasServerError: hasServerError,
                    hasIssueResultsData: hasIssueResultsData,
                    hasGroupResultsData: hasGroupResultsData,
                    hasJiraViewData: hasJiraViewData
                } : {}
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51pSU.IssueSearchSuccess), {
            onPageDataLoad: onPageDataLoad,
            attributes: {
                isAiEnabled: isAiEnabled,
                ...isGrouping ? {
                    experienceId: (0, $iRahl.GROUPED_LIST_EXPERIENCE_ID)
                } : {},
                isBifrost: isBifrost
            }
        }), (0, $7jTnu.fg)('issue_deletion_two_step_process_free_standard') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ap5Bt.default), {
            issueId: issueId,
            isDeleteIssueModalOpen: isDeleteIssueModalOpen,
            isDeletingIssue: isDeletingIssue,
            issueKey: issueKey,
            workTypeKey: workType,
            isSimplifiedProject: false,
            shouldShowChildSpecificCopy: true,
            didIssueDeleteFail: didIssueDeleteFail,
            triggerDeleteRequest: onTriggerDeleteRequest,
            triggerCloseDeleteIssueModal: closeDeleteIssueModal,
            ...(0, $7jTnu.fg)('additional-check-for-trigger-from-nin-view') ? {
                isTriggeredFromNINView: isTriggeredFromNINView
            } : {
                isIssueArchivalEnabled: isIssueArchivalEnabled
            }
        })), [
        IssueNavigatorContent,
        isInitialized,
        screenEventAttributes,
        isFailedIssueSearch,
        caughtIssueSearchError,
        viewResultError,
        serverError,
        onPageDataLoad,
        isAiEnabled,
        isGrouping,
        isBifrost,
        hasIssueSearchError,
        hasViewResultError,
        hasServerError,
        hasIssueResultsData,
        hasGroupResultsData,
        hasJiraViewData,
        issueId,
        isDeleteIssueModalOpen,
        isDeletingIssue,
        issueKey,
        workType,
        didIssueDeleteFail,
        onTriggerDeleteRequest,
        closeDeleteIssueModal,
        isTriggeredFromNINView,
        isIssueArchivalEnabled
    ]);
};
// re-render regression detection
$a5861a3b1095a50f$export$397fa57fff06920f.whyDidYouRender = true;
var $a5861a3b1095a50f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eJOHy.memo)($a5861a3b1095a50f$export$397fa57fff06920f);
const $a5861a3b1095a50f$var$IssueNavigatorContentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedView: selectedView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _4t3i1osq _19pkidpf _2hwxxy5q _otyridpf _18u0xy5q",
            __cmplp.selectedView !== 'detail' && "_n3tdv47k _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iPbI8", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb89000ff387b465$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<364ea40f465fa2ec3e23b0ccfeddc74b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cb89000ff387b465$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "isConditionalFormattingEnabled",
        "variableName": "isConditionalFormattingEnabled"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisninsavedfiltersenabledrelayprovider"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isConditionalFormattingEnabled"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "isSavedViewConditionalFormattingEnabled"
            }
        ],
        "kind": "Fragment",
        "name": "main_issueNavigator_IssueNavigatorUI_project",
        "selections": [
            {
                "args": [
                    v0 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "main_issueNavigator_IssueResults_project"
            },
            {
                "args": [
                    v0 /*: any*/ ,
                    {
                        "kind": "Variable",
                        "name": "isSavedViewConditionalFormattingEnabled",
                        "variableName": "isSavedViewConditionalFormattingEnabled"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "main_issueNavigator_SidebarLayout_project"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisninsavedfiltersenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "topBar_issueNavigator_projectResult"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "projectType"
            },
            {
                "condition": "isConditionalFormattingEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 20
                            }
                        ],
                        "concreteType": "JiraFormattingRuleConnection",
                        "kind": "LinkedField",
                        "name": "conditionalFormattingRules",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRuleEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "conditionalFormattingRules(first:20)"
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
}();
$cb89000ff387b465$var$node.hash = "f39a7579f8da2088af549a56d56f3c8a";
var $cb89000ff387b465$export$2e2bcd8739ae039 = $cb89000ff387b465$var$node;

});

parcelRegister("ePndi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fb0c6d714e8b46f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3785c8aa73a3094fbd32da405a0fb86d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0fb0c6d714e8b46f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_rankField"
        }
    ],
    "type": "JiraQuery"
};
$0fb0c6d714e8b46f$var$node.hash = "fc51caf86d12b11398947bb77ddb49ca";
var $0fb0c6d714e8b46f$export$2e2bcd8739ae039 = $0fb0c6d714e8b46f$var$node;

});

parcelRegister("9bJRg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cc59aa9e2f25209$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1da52f0913815b9fe1e6847953ff7bea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3cc59aa9e2f25209$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_userPreferences",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "spotlight_issueNavigator_IssueNavigatorSpotlight"
        }
    ],
    "type": "JiraUserPreferences"
};
$3cc59aa9e2f25209$var$node.hash = "aa84b2b1589fd8e695aa782c018fd60c";
var $3cc59aa9e2f25209$export$2e2bcd8739ae039 = $3cc59aa9e2f25209$var$node;

});

parcelRegister("gQwl3", function(module, exports) {

$parcel$export(module.exports, "default", () => $51580bd06a38fd8b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<992603286fdaed2482d8310cc8992ecb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $51580bd06a38fd8b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsScope"
        },
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_jiraView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "error",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Header_jiraViewResult"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_jiraView"
        },
        {
            "kind": "FragmentSpread",
            "name": "topBar_issueNavigator_jiraViewResult"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_FullPageIssueApp_view"
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "savedViewId"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                                "fieldSetSelectedState": "SELECTED"
                            }
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "amountOfColumns"
                        },
                        {
                            "kind": "Variable",
                            "name": "scope",
                            "variableName": "fieldSetsScope"
                        }
                    ],
                    "concreteType": "JiraIssueSearchFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFieldSetPreferences",
                                            "kind": "LinkedField",
                                            "name": "fieldSetPreferences",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isFrozen"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isGroupingEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEnableGrouping"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$51580bd06a38fd8b$var$node.hash = "f5401bf3cdbd42b3263e9e725d556f32";
var $51580bd06a38fd8b$export$2e2bcd8739ae039 = $51580bd06a38fd8b$var$node;

});

parcelRegister("6tVNx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8504176efdd55087$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bccaea827099599c35efdd1a65270e81>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8504176efdd55087$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_groupResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_groupResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults"
        },
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$8504176efdd55087$var$node.hash = "5d6a696ce62196724f5906b5a505895e";
var $8504176efdd55087$export$2e2bcd8739ae039 = $8504176efdd55087$var$node;

});

parcelRegister("k1M6e", function(module, exports) {

$parcel$export(module.exports, "default", () => $588f7e726fca0343$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<76ec630fe070875ea7ed75df2af721df>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $588f7e726fca0343$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "topBar_issueNavigator_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Header_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_FullPageIssueApp_issueResults"
        },
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ],
                    "type": "JiraServerError"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        },
        {
            "kind": "FragmentSpread",
            "name": "bulkOperationsWrapper_issueNavigator_LoadBulkOpsCore"
        }
    ],
    "type": "JiraIssueConnection"
};
$588f7e726fca0343$var$node.hash = "7928dc287b6910e369b48bee9eadbe37";
var $588f7e726fca0343$export$2e2bcd8739ae039 = $588f7e726fca0343$var$node;

});

parcelRegister("5lLtn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9edc2fcac239460$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e0d1ef8d96795a5ae26e4e46076a222>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e9edc2fcac239460$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isSavedViewConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_SidebarLayout_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isSavedViewConditionalFormattingEnabled",
                    "variableName": "isSavedViewConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project"
        }
    ],
    "type": "JiraProject"
};
$e9edc2fcac239460$var$node.hash = "9bc206d240f48026ed29dd23bb0b3787";
var $e9edc2fcac239460$export$2e2bcd8739ae039 = $e9edc2fcac239460$var$node;

});

parcelRegister("8l1NO", function(module, exports) {

$parcel$export(module.exports, "useDeleteIssueModalStates", () => $5bc5b9600e63a861$export$d45f9f69a51ec7b1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $9bIo2 = parcelRequire("9bIo2");
const $5bc5b9600e63a861$export$d45f9f69a51ec7b1 = (0, $iJq0l.createStateHook)((0, $9bIo2.DeleteIssueModalStore));

});
parcelRegister("9bIo2", function(module, exports) {

$parcel$export(module.exports, "DeleteIssueModalStore", () => $f7f926b9046bb506$export$d1e440480df04);
$parcel$export(module.exports, "useDeleteIssueModalActions", () => $f7f926b9046bb506$export$ec8cd1345f95f9aa);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $ha2c5 = parcelRequire("ha2c5");

var $koLmH = parcelRequire("koLmH");
const $f7f926b9046bb506$export$d1e440480df04 = (0, $GtRbT.createStore)({
    initialState: $koLmH.initialState,
    actions: (0, $ha2c5.DeleteIssueModalActions),
    name: 'DeleteIssueModalStore'
});
const $f7f926b9046bb506$export$ec8cd1345f95f9aa = (0, $iJq0l.createActionsHook)($f7f926b9046bb506$export$d1e440480df04);

});
parcelRegister("ha2c5", function(module, exports) {

$parcel$export(module.exports, "DeleteIssueModalActions", () => $b92588e4aaa777f4$export$af54eec6d7dd9751);
const $b92588e4aaa777f4$var$noop = ()=>{
    return null;
};
const $b92588e4aaa777f4$export$af54eec6d7dd9751 = {
    openDeleteIssueModal: ({ isIssueArchivalEnabled: isIssueArchivalEnabled, workType: workType, issueKey: issueKey, issueId: issueId, onIssueDeleteSuccess: onIssueDeleteSuccess, onIssueDeleteFailure: onIssueDeleteFailure, onTriggerDeleteRequest: onTriggerDeleteRequest })=>({ setState: setState })=>{
            setState({
                isDeleteIssueModalOpen: true,
                isIssueArchivalEnabled: isIssueArchivalEnabled,
                workType: workType,
                issueKey: issueKey,
                issueId: issueId,
                onIssueDeleteSuccess: onIssueDeleteSuccess,
                onIssueDeleteFailure: onIssueDeleteFailure,
                onTriggerDeleteRequest: onTriggerDeleteRequest
            });
        },
    closeDeleteIssueModal: ()=>({ setState: setState })=>{
            setState({
                isDeleteIssueModalOpen: false,
                didIssueDeleteFail: false,
                isDeletingIssue: false,
                issueKey: '',
                issueId: '',
                isIssueArchivalEnabled: false,
                workType: null,
                onIssueDeleteSuccess: $b92588e4aaa777f4$var$noop,
                onIssueDeleteFailure: $b92588e4aaa777f4$var$noop,
                onTriggerDeleteRequest: $b92588e4aaa777f4$var$noop
            });
        },
    startDeleteIssue: ()=>({ setState: setState })=>{
            setState({
                isDeletingIssue: true
            });
        },
    endDeleteIssue: ({ didIssueDeleteFail: didIssueDeleteFail })=>({ setState: setState })=>{
            setState({
                isDeletingIssue: false,
                didIssueDeleteFail: didIssueDeleteFail
            });
        }
};

});

parcelRegister("koLmH", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $a810b026a0078b26$export$d4c72bab9d6cc13a);
const $a810b026a0078b26$var$noop = ()=>{
    return null;
};
const $a810b026a0078b26$export$d4c72bab9d6cc13a = {
    isDeleteIssueModalOpen: false,
    didIssueDeleteFail: false,
    isDeletingIssue: false,
    issueKey: '',
    issueId: '',
    workType: null,
    isIssueArchivalEnabled: false,
    onIssueDeleteSuccess: $a810b026a0078b26$var$noop,
    onIssueDeleteFailure: $a810b026a0078b26$var$noop,
    onTriggerDeleteRequest: $a810b026a0078b26$var$noop
};

});



parcelRegister("ap5Bt", function(module, exports) {

$parcel$export(module.exports, "default", () => $24ddc61e55bdf0a6$export$2e2bcd8739ae039);

var $9y9gy = parcelRequire("9y9gy");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $ftN6c = parcelRequire("ftN6c");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $cDJ0f = parcelRequire("cDJ0f");

var $6J9k6 = parcelRequire("6J9k6");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $aewX5 = parcelRequire("aewX5");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $sY9BV = parcelRequire("sY9BV");

var $a7u9w = parcelRequire("a7u9w");

var $BwaQq = parcelRequire("BwaQq");

var $jtIA2 = parcelRequire("jtIA2");

var $2ZGUP = parcelRequire("2ZGUP");

var $h47gY = parcelRequire("h47gY");

var $7jTnu = parcelRequire("7jTnu");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $d8Kze = parcelRequire("d8Kze");

var $53YBU = parcelRequire("53YBU");

var $4FabQ = parcelRequire("4FabQ");

var $3ibpe = parcelRequire("3ibpe");

var $6d9QY = parcelRequire("6d9QY");

var $gCeeo = parcelRequire("gCeeo");

var $bNexr = parcelRequire("bNexr");

var $fgJkD = parcelRequire("fgJkD");

var $U4tkh = parcelRequire("U4tkh");

var $epTsa = parcelRequire("epTsa");

var $eaTQ3 = parcelRequire("eaTQ3");

var $814y1 = parcelRequire("814y1");

var $5ogVm = parcelRequire("5ogVm");

var $eMR3W = parcelRequire("eMR3W");

var $b5KyQ = parcelRequire("b5KyQ");

const $24ddc61e55bdf0a6$var$isTriggeredFromNINViewDefaults = {
    isIssueArchivalEnabled: false,
    isTriggeredFromNINView: false
}; /** New custom hook for mutation
    * TODO: This can be removed ONLY once the Redux integration with this component is decoupled.
    * It will return a Promise to the issue-delete-epic observable, which will be resolved or rejected based on the response from the graphql mutation.
    * */ 
const $24ddc61e55bdf0a6$export$69ad9d938199d98b = ()=>{
    const [commit, isMutationInFlight] = (0, $j4oe4.useMutation)((0, $9y9gy.default));
    const deleteIssue = (0, $eJOHy.useCallback)(async (issueID)=>{
        return new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        id: issueID,
                        deleteSubtasks: true
                    }
                },
                onCompleted: ()=>resolve(),
                onError: (error)=>reject(new Error(error?.message || 'Delete issue mutation failed'))
            });
        });
    }, [
        commit
    ]);
    return {
        deleteIssue: deleteIssue,
        isDeleting: isMutationInFlight
    };
};
const $24ddc61e55bdf0a6$var$DeleteIssueViewWithErrorBoundaryOld = (0, $BwaQq.AnalyticsSource)('issueDelete', (0, $466f60259c330878$export$1171103ea9083ffa))(({ issueId: issueId, isDeleteIssueModalOpen: isDeleteIssueModalOpen, isDeletingIssue: isDeletingIssue, issueKey: issueKey, isSimplifiedProject: isSimplifiedProject, shouldShowChildSpecificCopy: shouldShowChildSpecificCopy, didIssueDeleteFail: didIssueDeleteFail, triggerDeleteRequest: triggerDeleteRequest, triggerCloseDeleteIssueModal: triggerCloseDeleteIssueModal, deleteCancelAnalytics: deleteCancelAnalytics, deleteConfirmAnalytics: deleteConfirmAnalytics, onIssueDeleteSuccess: onIssueDeleteSuccess, onIssueDeleteFailure: onIssueDeleteFailure, onClose: onClose })=>{
    if (!isDeleteIssueModalOpen) return null;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const previousIsDeletingIssue = (0, $6d9QY.usePrevious)(isDeletingIssue);
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const application = (0, $bNexr.useApplication)(projectKey, true);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const [workType] = (0, $U4tkh.useIssueTypeName)();
    (0, $eJOHy.useEffect)(()=>{
        const didDeletionFinish = !isDeletingIssue && previousIsDeletingIssue;
        if (didDeletionFinish) {
            if (!didIssueDeleteFail) {
                triggerCloseDeleteIssueModal();
                onIssueDeleteSuccess?.({
                    issueId: issueId,
                    issueKey: issueKey
                });
                onClose?.();
            } else onIssueDeleteFailure?.({
                issueId: issueId,
                issueKey: issueKey
            });
        }
    }, [
        didIssueDeleteFail,
        isDeletingIssue,
        issueId,
        issueKey,
        onClose,
        onIssueDeleteFailure,
        onIssueDeleteSuccess,
        previousIsDeletingIssue,
        triggerCloseDeleteIssueModal
    ]);
    const { deleteIssue: deleteIssue } = $24ddc61e55bdf0a6$export$69ad9d938199d98b();
    const onConfirmDeleteIssue = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        deleteConfirmAnalytics?.(analyticsEvent);
        const deleteReq = (0, $7jTnu.fg)('relay-migration-issue-view-delete-issue') && deleteIssue(issueKey);
        triggerDeleteRequest(issueKey, analyticsEvent, application, edition, deleteReq);
    }, [
        application,
        deleteConfirmAnalytics,
        deleteIssue,
        edition,
        issueKey,
        triggerDeleteRequest
    ]);
    const onCancel = (event, analyticsEvent)=>{
        deleteCancelAnalytics?.(analyticsEvent);
        triggerCloseDeleteIssueModal();
    };
    const getChildConditionalDeleteHeading = ()=>{
        if (workType && (0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $5ogVm.default).deleteHeadingIssueTerminologyRefreshM4;
        const deleteWithChildrenHeadingMessage = (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $5ogVm.default).deleteWithChildrenHeadingIssueTermRefresh : (0, $5ogVm.default).deleteWithChildrenHeading;
        if (shouldShowChildSpecificCopy) return isSimplifiedProject ? deleteWithChildrenHeadingMessage : (0, $5ogVm.default).deleteWithSubtasksHeading;
        return (0, $5ogVm.default).deleteHeading;
    };
    const getDeleteWithChildrenWarningMessage = ()=>{
        if (workType && (0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $5ogVm.default).deleteWithChildrenWarningIssueTerminologyRefreshM4;
        if ((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3')) return (0, $5ogVm.default).deleteWithChildrenWarningIssueTermRefresh;
        return (0, $5ogVm.default).deleteWithChildrenWarning;
    };
    const getDeleteWithSubtasksWarningMessage = ()=>{
        if (workType && (0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $5ogVm.default).deleteWithSubtasksWarningIssueTerminologyRefreshM4;
        if ((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3')) return (0, $5ogVm.default).deleteWithSubtasksWarningIssueTermRefresh;
        return (0, $5ogVm.default).deleteWithSubtasksWarning;
    };
    const getChildConditionalDeleteWarning = ()=>{
        if (shouldShowChildSpecificCopy) return isSimplifiedProject ? getDeleteWithChildrenWarningMessage() : getDeleteWithSubtasksWarningMessage();
        return (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $5ogVm.default).deleteWarningIssueTermRefresh : (0, $5ogVm.default).deleteWarning;
    };
    const cancelButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        onClick: onCancel,
        testId: "issue-view-foundation.issue-actions.delete-issue.cancel-button",
        isDisabled: isDeletingIssue,
        key: "cancelButton",
        interactionName: "auto-generated.issue.views.issue-base.foundation.issue-actions.delete-issue.cancel-button.button"
    }, formatMessage((0, $5ogVm.default).cancel));
    const deleteButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "danger",
        onClick: onConfirmDeleteIssue,
        testId: "issue.views.issue-base.foundation.issue-actions.delete-issue.confirm-button",
        disabled: isDeletingIssue,
        iconAfter: isDeletingIssue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small"
        }) : null,
        key: "deleteButton",
        interactionName: "auto-generated.issue.views.issue-base.foundation.issue-actions.delete-issue.confirm-button.button1"
    }, formatMessage((0, $5ogVm.default).delete));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtIA2.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog), {
        messageId: "issue-view-foundation.issue-actions.delete-issue.modal-dialog",
        messageType: "transactional",
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "danger"
    }, formatMessage(getChildConditionalDeleteHeading(), {
        issueKey: issueKey,
        workType: workType
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p"
    }, formatMessage(getChildConditionalDeleteWarning(), {
        workType: workType
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p"
    }, !(0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false) && formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $5ogVm.default).deleteRecommendationIssueTermRefresh : (0, $5ogVm.default).deleteRecommendation))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, cancelButton, deleteButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a7u9w.MountEvent), {
        onMount: ()=>{
            (0, $3ibpe.sendExperienceAnalytics)({
                experience: 'issueViewDeleteIssueModalRender',
                wasExperienceSuccesful: true,
                analyticsSource: 'issueViewIssueActionsDeleteIssue',
                application: application ?? null,
                edition: edition ?? null
            });
        }
    }));
});
const $24ddc61e55bdf0a6$var$DeleteIssueViewWithErrorBoundaryNew = (0, $BwaQq.AnalyticsSource)('issueDelete', (0, $466f60259c330878$export$1171103ea9083ffa))(({ issueId: issueId, isDeleteIssueModalOpen: isDeleteIssueModalOpen, isDeletingIssue: isDeletingIssue, issueKey: issueKey, isSimplifiedProject: isSimplifiedProject, shouldShowChildSpecificCopy: shouldShowChildSpecificCopy, didIssueDeleteFail: didIssueDeleteFail, triggerDeleteRequest: triggerDeleteRequest, triggerCloseDeleteIssueModal: triggerCloseDeleteIssueModal, deleteCancelAnalytics: deleteCancelAnalytics, deleteConfirmAnalytics: deleteConfirmAnalytics, onIssueDeleteSuccess: onIssueDeleteSuccess, onIssueDeleteFailure: onIssueDeleteFailure, onClose: onClose, workTypeKey: workTypeKey, isIssueArchivalEnabled: isIssueArchivalEnabled = false, isTriggeredFromNINView: isTriggeredFromNINView = $24ddc61e55bdf0a6$var$isTriggeredFromNINViewDefaults })=>{
    if (!isDeleteIssueModalOpen) return null;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const previousIsDeletingIssue = (0, $6d9QY.usePrevious)(isDeletingIssue);
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const application = (0, $bNexr.useApplication)(projectKey, true);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const [inputValue, setInputValue] = (0, $eJOHy.useState)('');
    const { archiveIssue: archiveIssue } = (0, $53YBU.useArchiveIssue)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isIssueArchivalFromNINViewEnabled = ((0, $7jTnu.fg)('additional-check-for-trigger-from-nin-view') ? isTriggeredFromNINView.isIssueArchivalEnabled : isIssueArchivalEnabled) && (0, $epTsa.expVal)('issue_deletion_two_step_process_for_free_standard', 'isIssueDeleteExperimentFreemiumEnabled', false);
    const isDeleteIssueExperimentEnabled = (0, $eMR3W.useIsDeleteIssueExperimentEnabled)();
    const isEligibleForIssueArchival = (0, $7jTnu.fg)('additional-check-for-trigger-from-nin-view') ? !isTriggeredFromNINView?.isTriggeredFromNINView && isDeleteIssueExperimentEnabled || isIssueArchivalFromNINViewEnabled : isDeleteIssueExperimentEnabled || isIssueArchivalFromNINViewEnabled;
    const isTwoStepIssueDeleteFreemiumExperimentEnabled = (0, $7jTnu.fg)('issue_deletion_two_step_process_free_standard') && (0, $b5KyQ.useIsTwoStepIssueDeleteFreemiumExperimentEnabled)({
        isIssueArchivalEnabled: isEligibleForIssueArchival
    });
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const archiveIssueUrl = (0, $d8Kze.useArchiveIssueUrl)();
    const [issueType] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $814y1.ISSUE_TYPE)
    });
    const workType = issueType?.name || workTypeKey;
    (0, $eJOHy.useEffect)(()=>{
        const didDeletionFinish = !isDeletingIssue && previousIsDeletingIssue;
        if (didDeletionFinish) {
            if (!didIssueDeleteFail) {
                triggerCloseDeleteIssueModal();
                onIssueDeleteSuccess?.({
                    issueId: issueId,
                    issueKey: issueKey
                });
                onClose?.();
            } else onIssueDeleteFailure?.({
                issueId: issueId,
                issueKey: issueKey
            });
        }
    }, [
        didIssueDeleteFail,
        isDeletingIssue,
        issueId,
        issueKey,
        onClose,
        onIssueDeleteFailure,
        onIssueDeleteSuccess,
        previousIsDeletingIssue,
        triggerCloseDeleteIssueModal
    ]);
    const { deleteIssue: deleteIssue } = $24ddc61e55bdf0a6$export$69ad9d938199d98b();
    const onConfirmDeleteIssue = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        deleteConfirmAnalytics?.(analyticsEvent);
        const deleteReq = (0, $7jTnu.fg)('relay-migration-issue-view-delete-issue') && deleteIssue(issueKey);
        triggerDeleteRequest(issueKey, analyticsEvent, application, edition, deleteReq);
    }, [
        application,
        deleteConfirmAnalytics,
        deleteIssue,
        edition,
        issueKey,
        triggerDeleteRequest
    ]);
    const onCancel = (event, analyticsEvent)=>{
        (0, $7jTnu.fg)('issue_deletion_two_step_process_free_standard') && (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'CancelButton');
        deleteCancelAnalytics?.(analyticsEvent);
        triggerCloseDeleteIssueModal();
    };
    const onArchivalFailure = ()=>{
        showFlag({
            messageId: 'issue-view-foundation.issue-actions.delete-issue.show-flag.error.issue-archival-error',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $5ogVm.default).issueArchivalErrorFlagTitleIssueTermRefresh : (0, $5ogVm.default).issueArchivalErrorFlagTitle, {
                issueKey: issueKey
            }),
            testId: 'jira-issue-archive.modal.error-flag'
        });
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({
            action: 'archived',
            actionSubject: 'issue',
            attributes: {
                triggerPointKey: 'DeleteIssueModal'
            }
        }), 'archiveIssue Failed');
        triggerCloseDeleteIssueModal();
    };
    const onArchivalSuccess = ()=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({
            action: 'archived',
            actionSubject: 'issue',
            attributes: {
                triggerPointKey: 'DeleteIssueModal'
            }
        }), 'archiveIssue Successful');
        if ((0, $4FabQ.isIssueViewPage)()) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
        showFlag({
            messageId: 'issue-view-foundation.issue-actions.delete-issue.show-flag.success.issue-archival-success',
            messageType: 'transactional',
            type: 'success',
            title: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $5ogVm.default).issueArchivalSuccessFlagTitleIssueTermRefresh : (0, $5ogVm.default).issueArchivalSuccessFlagTitle, {
                issueKey: issueKey
            }),
            testId: 'jira-issue-archive.modal.success-flag',
            actions: [
                {
                    content: (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $5ogVm.default).issueArchivalSuccessFlagActionViewIssueIssueTermRefresh : (0, $5ogVm.default).issueArchivalSuccessFlagActionViewIssue,
                    href: `/browse/${issueKey}`
                },
                {
                    content: (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $5ogVm.default).issueArchivalSuccessFlagActionViewInArchiveIssueTermRefresh : (0, $5ogVm.default).issueArchivalSuccessFlagActionViewInArchive,
                    href: archiveIssueUrl
                }
            ]
        });
        onIssueDeleteSuccess?.({
            issueId: issueId,
            issueKey: issueKey
        });
    };
    const onArchive = ()=>{
        archiveIssue([
            issueKey
        ], onArchivalSuccess, onArchivalFailure);
        onClose?.();
        triggerCloseDeleteIssueModal();
    };
    const getChildConditionalDeleteWarning = ()=>{
        const deleteWithChildrenWarningMessage = (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $5ogVm.default).deleteOrArchiveWithChildrenWarningIssueTermRefresh : (0, $5ogVm.default).deleteOrArchiveWithChildrenWarning;
        const deleteWithSubtasksWarningMessage = (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $5ogVm.default).deleteOrArchiveWithSubtasksWarningIssueTermRefresh : (0, $5ogVm.default).deleteOrArchiveWithSubtasksWarning;
        if (isTwoStepIssueDeleteFreemiumExperimentEnabled) return (0, $5ogVm.default).deleteWarningForTwoStepDeleteFreemiumExperiment;
        if (shouldShowChildSpecificCopy) return isSimplifiedProject ? deleteWithChildrenWarningMessage : deleteWithSubtasksWarningMessage;
        return (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $5ogVm.default).deleteOrArchiveWarningIssueTermRefresh : (0, $5ogVm.default).deleteOrArchiveWarning;
    };
    const archiveButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        onClick: onArchive,
        testId: "issue.views.issue-base.foundation.issue-actions.delete-issue.archive-button" // @ts-expect-error - TS2322 - Type '{ children: string; appearance: "subtle"; onClick: (event: SyntheticEvent<Element, Event>, analyticsEvent: UIAnalyticsEventInterface) => void; testId: string; disabled: boolean; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
        ,
        disabled: isDeletingIssue,
        key: "archiveButton",
        interactionName: "auto-generated.issue.views.issue-base.foundation.issue-actions.delete-issue.archive-button.button"
    }, formatMessage((0, $5ogVm.default).archive));
    const cancelButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        onClick: onCancel,
        testId: "issue-view-foundation.issue-actions.delete-issue.cancel-button",
        isDisabled: isDeletingIssue,
        key: "cancelButton",
        interactionName: "auto-generated.issue.views.issue-base.foundation.issue-actions.delete-issue.cancel-button.button"
    }, formatMessage((0, $5ogVm.default).cancel));
    const handleInputChange = (e)=>{
        const value = e.target.value;
        setInputValue(value);
    };
    const deleteButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: inputValue.trim().toLowerCase() !== formatMessage((0, $5ogVm.default).deleteTextToEquateForTextbox).toLowerCase() ? 'primary' : 'danger',
        isDisabled: inputValue.trim().toLowerCase() !== formatMessage((0, $5ogVm.default).deleteTextToEquateForTextbox).toLowerCase() || isDeletingIssue,
        onClick: onConfirmDeleteIssue,
        testId: "issue.views.issue-base.foundation.issue-actions.delete-issue.confirm-button",
        disabled: isDeletingIssue,
        iconAfter: isDeletingIssue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small"
        }) : null,
        key: "deleteButton",
        interactionName: "auto-generated.issue.views.issue-base.foundation.issue-actions.delete-issue.confirm-button.button1"
    }, formatMessage((0, $5ogVm.default).delete));
    if (!isEligibleForIssueArchival && !isTwoStepIssueDeleteFreemiumExperimentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($24ddc61e55bdf0a6$var$DeleteIssueViewWithErrorBoundaryOld, {
        issueId: issueId,
        isDeleteIssueModalOpen: isDeleteIssueModalOpen,
        isDeletingIssue: isDeletingIssue,
        issueKey: issueKey,
        isSimplifiedProject: isSimplifiedProject,
        shouldShowChildSpecificCopy: shouldShowChildSpecificCopy,
        didIssueDeleteFail: didIssueDeleteFail,
        triggerDeleteRequest: triggerDeleteRequest,
        triggerCloseDeleteIssueModal: triggerCloseDeleteIssueModal,
        deleteCancelAnalytics: deleteCancelAnalytics,
        deleteConfirmAnalytics: deleteConfirmAnalytics,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueDeleteFailure: onIssueDeleteFailure,
        onClose: onClose
    });
    if (isTwoStepIssueDeleteFreemiumExperimentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtIA2.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog), {
        messageId: "issue-view-foundation.issue-actions.delete-issue.modal-dialog.two-step-delete",
        messageType: "transactional",
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aewX5.default), {
        gap: "space.250",
        templateAreas: [
            'title close'
        ],
        xcss: $24ddc61e55bdf0a6$var$gridStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $24ddc61e55bdf0a6$var$titleContainerStyles,
        justifyContent: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "danger"
    }, formatMessage((0, $5ogVm.default).deleteHeadingWithWorkType, {
        workType: workType,
        issueKey: issueKey
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p"
    }, formatMessage(getChildConditionalDeleteWarning())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockStart: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p"
    }, formatMessage((0, $5ogVm.default).deleteConfirmationForTwoStepDeleteFreemiumExperiment))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
        htmlFor: "Textfield"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_k48pi7a9"
        ])
    }, formatMessage((0, $5ogVm.default).deleteTextFieldLabelMessage, {
        strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                size: "small",
                as: "strong"
            }, chunks.join(''))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        label: formatMessage((0, $5ogVm.default).deleteTextFieldLabelMessage),
        value: inputValue,
        onChange: handleInputChange,
        width: "352",
        height: "36",
        id: "Textfield",
        testId: (0, $4ca9625b839f10bc$export$a97e1a5849845ab3)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, cancelButton, deleteButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a7u9w.MountEvent), {
        onMount: ()=>{
            (0, $3ibpe.sendExperienceAnalytics)({
                experience: 'issueViewDeleteIssueModalRender',
                wasExperienceSuccesful: true,
                analyticsSource: 'issueViewIssueActionsDeleteIssue',
                application: application ?? null,
                edition: edition ?? null
            });
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jtIA2.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog), {
        messageId: "issue-view-foundation.issue-actions.delete-issue.modal-dialog.new",
        messageType: "transactional",
        width: "small",
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aewX5.default), {
        gap: "space.250",
        templateAreas: [
            'title close'
        ],
        xcss: $24ddc61e55bdf0a6$var$gridStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $24ddc61e55bdf0a6$var$titleContainerStyles,
        justifyContent: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "danger"
    }, formatMessage((0, $5ogVm.default).deleteOrArchiveHeading, {
        issueKey: issueKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $24ddc61e55bdf0a6$var$closeContainerStyles,
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))),
        label: formatMessage((0, $5ogVm.default).iconButtonLabel),
        onClick: onCancel
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p"
    }, formatMessage(getChildConditionalDeleteWarning())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
        htmlFor: "Textfield"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        className: (0, $hcewu.default)([
            "_k48pi7a9"
        ])
    }, formatMessage((0, $5ogVm.default).deleteTextFieldLabelMessage, {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                size: "small",
                as: "strong"
            }, chunks.join(''))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        label: formatMessage((0, $5ogVm.default).deleteTextFieldLabelMessage),
        value: inputValue,
        onChange: handleInputChange,
        width: "352",
        height: "36",
        testId: (0, $4ca9625b839f10bc$export$a97e1a5849845ab3)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, archiveButton, deleteButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a7u9w.MountEvent), {
        onMount: ()=>{
            (0, $3ibpe.sendExperienceAnalytics)({
                experience: 'issueViewDeleteIssueModalRender',
                wasExperienceSuccesful: true,
                analyticsSource: 'issueViewIssueActionsDeleteIssue',
                application: application ?? null,
                edition: edition ?? null
            });
        }
    }));
});
const $24ddc61e55bdf0a6$export$7836eafbab9e4b99 = (0, $BwaQq.AnalyticsSource)('issueDelete', (0, $466f60259c330878$export$1171103ea9083ffa))((props)=>{
    const { issueKey: issueKey } = props;
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const application = (0, $bNexr.useApplication)(projectKey, true);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue.issue-view-foundation.issue-actions.delete-issue",
        onError: (location, error, attributes)=>{
            const { componentStack: componentStack } = attributes;
            (0, $3ibpe.sendExperienceAnalytics)({
                experience: 'issueViewDeleteIssueModalRender',
                wasExperienceSuccesful: false,
                analyticsSource: 'issueViewIssueActionsDeleteIssue',
                application: application ?? null,
                edition: edition ?? null,
                additionalAttributes: {
                    errorMessage: error?.message || 'UNKNOWN_ERROR',
                    location: location,
                    ...componentStack && {
                        componentStack: componentStack
                    }
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($24ddc61e55bdf0a6$var$DeleteIssueViewWithErrorBoundaryNew, props));
});
var $24ddc61e55bdf0a6$export$2e2bcd8739ae039 = $24ddc61e55bdf0a6$export$7836eafbab9e4b99;
const $24ddc61e55bdf0a6$var$SpanStyle = null;
const $24ddc61e55bdf0a6$var$closeContainerStyles = (0, $1DXK0.xcss)({
    gridArea: 'close'
});
const $24ddc61e55bdf0a6$var$titleContainerStyles = (0, $1DXK0.xcss)({
    gridArea: 'title'
});
const $24ddc61e55bdf0a6$var$gridStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("9y9gy", function(module, exports) {

$parcel$export(module.exports, "default", () => $727d555019c6ea55$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47d0bcce75a38dbae4de7e3775f1e5f7>>
 * @relayHash 9e6bae8a1942ce883a3d1fc7f5b26901
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e0bf4c698824530ba4bb0e11da2085d347499bce2d6efad6337c1a84ab677d7
const $727d555019c6ea55$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "deleteIssueView_deleteIssue_Mutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraIssueDeletePayload",
                    "kind": "LinkedField",
                    "name": "jira_deleteIssue",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "deleteIssueView_deleteIssue_Mutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraIssueDeletePayload",
                    "kind": "LinkedField",
                    "name": "jira_deleteIssue",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3e0bf4c698824530ba4bb0e11da2085d347499bce2d6efad6337c1a84ab677d7",
            "metadata": {},
            "name": "deleteIssueView_deleteIssue_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$727d555019c6ea55$var$node.hash = "ece7ea5729fe469a4366ac87e287255e";
var $727d555019c6ea55$export$2e2bcd8739ae039 = $727d555019c6ea55$var$node;

});

parcelRegister("a7u9w", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $ca85b8e348ac962b$export$2c6963927dbc68f1);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");
class $ca85b8e348ac962b$var$MountEventComponent extends (0, $eJOHy.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $ca85b8e348ac962b$var$MountEventComponentWithHOC = (0, $4J0ad.default)()($ca85b8e348ac962b$var$MountEventComponent);
const $ca85b8e348ac962b$export$2c6963927dbc68f1 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($ca85b8e348ac962b$var$MountEventComponentWithHOC, {
        ...props
    });

});

parcelRegister("d8Kze", function(module, exports) {

$parcel$export(module.exports, "useArchiveIssueUrl", () => $e0381d0b5b1855ef$export$d1ca368e1ad6dfeb);

var $ln6Iy = parcelRequire("ln6Iy");

var $2aY2d = parcelRequire("2aY2d");
const $e0381d0b5b1855ef$export$d1ca368e1ad6dfeb = ()=>{
    // TODO: Check if this is the correct way to get the project context and will always be available, it shouldn't be behind any feature flag
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const { projectType: projectType, simplified: simplified, projectKey: projectKey } = projectContext || {};
    switch(projectType){
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            if (simplified) return `/jira/software/projects/${projectKey}/archived-work-items`;
            return `/jira/software/c/projects/${projectKey}/archived-work-items`;
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return `/jira/servicedesk/projects/${projectKey}/archived-work-items`;
        case 0, $ln6Iy.CORE_PROJECT:
            return `/jira/core/projects/${projectKey}/archived-work-items`;
        case 0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT:
            return `/jira/product-discovery/projects/${projectKey}/issues/archive`;
        default:
            // TODO: Throw an error
            return '/jira/issues/archive';
    }
};

});

parcelRegister("53YBU", function(module, exports) {

$parcel$export(module.exports, "useArchiveIssue", () => $a28cfc5b847f0c99$export$8726fa65ba085232);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");

var $1oMOM = parcelRequire("1oMOM");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7BKle = parcelRequire("7BKle");
const $a28cfc5b847f0c99$var$MAXIMUM_POLL_DURATION = 300000;
const $a28cfc5b847f0c99$var$DEFAULT_POLLING_DURATION = 2000;
const $a28cfc5b847f0c99$var$HTTP_ACCEPTED_STATUS_CODE = 202;
const $a28cfc5b847f0c99$export$8726fa65ba085232 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const pollForArchiveTaskStatus = (0, $eJOHy.useCallback)((urlForPollingStatus, onSuccess, onError, analyticsEvent)=>{
        const pollingStartTime = Date.now();
        let isPollingCompleted = false;
        const intervalId = setInterval(async ()=>{
            try {
                const pollingStatus = await (0, $jGzN3.performGetRequest)(urlForPollingStatus);
                if (pollingStatus?.status === 'COMPLETED' || pollingStatus?.progress >= 100) {
                    clearInterval(intervalId);
                    onSuccess(analyticsEvent);
                    isPollingCompleted = true;
                } else if (pollingStatus?.status === 'FAILED') {
                    clearInterval(intervalId);
                    onError(analyticsEvent);
                    isPollingCompleted = true;
                }
                if (Date.now() - pollingStartTime >= $a28cfc5b847f0c99$var$MAXIMUM_POLL_DURATION) {
                    clearInterval(intervalId);
                    isPollingCompleted = true;
                }
            } catch  {
                clearInterval(intervalId);
                onError(analyticsEvent);
                isPollingCompleted = true;
            }
        }, $a28cfc5b847f0c99$var$DEFAULT_POLLING_DURATION);
        if (isPollingCompleted) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'polling completed', {
            action: 'issueArchivalUsingJQL',
            duration: Date.now() - pollingStartTime
        });
    }, [
        createAnalyticsEvent
    ]);
    const archiveAlongWithChildIssuesUsingJQL = (0, $eJOHy.useCallback)(async (parentIssueKey, onSuccess, onError, analyticsEvent)=>{
        try {
            const response = await fetch((0, $7BKle.ISSUE_ARCHIVE_API), {
                method: 'POST',
                ...(0, $1oMOM.getDefaultOptions)((0, $7BKle.ISSUE_ARCHIVE_API)),
                body: JSON.stringify({
                    jql: `parent = ${parentIssueKey} OR issue = ${parentIssueKey}`
                })
            });
            const responseStatus = response.status;
            if (responseStatus !== $a28cfc5b847f0c99$var$HTTP_ACCEPTED_STATUS_CODE) {
                onError(analyticsEvent);
                return;
            }
            const urlForPollingStatus = await response.text();
            pollForArchiveTaskStatus(urlForPollingStatus, onSuccess, onError, analyticsEvent);
        } catch  {
            onError(analyticsEvent);
        }
    }, [
        pollForArchiveTaskStatus
    ]);
    const archiveIssue = (0, $eJOHy.useCallback)(async (issueKeys, onSuccess, onError, analyticsEvent)=>{
        try {
            await (0, $jGzN3.performPutRequest)((0, $7BKle.ISSUE_ARCHIVE_API), {
                body: JSON.stringify({
                    issueIdsOrKeys: issueKeys
                })
            });
            onSuccess(analyticsEvent);
        } catch  {
            onError(analyticsEvent);
        }
    }, []);
    return {
        archiveIssue: archiveIssue,
        archiveAlongWithChildIssuesUsingJQL: archiveAlongWithChildIssuesUsingJQL
    };
};

});
parcelRegister("7BKle", function(module, exports) {

$parcel$export(module.exports, "ARCHIVE_ISSUE_MODAL_WIDTH_CATEGORY", () => $2582ae2409307da1$export$2ac06baa43be057);
$parcel$export(module.exports, "ESC_KEY", () => $2582ae2409307da1$export$45f4d5e73efcfde8);
$parcel$export(module.exports, "ISSUE_VIEW_URL_REGEX", () => $2582ae2409307da1$export$cbf34536d6076514);
$parcel$export(module.exports, "ISSUE_ARCHIVE_API", () => $2582ae2409307da1$export$1c9d135d7bb1047);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_ISSUE_VIEW", () => $2582ae2409307da1$export$501c618f5224bbb);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_ISSUE_NAVIGATOR", () => $2582ae2409307da1$export$f64573f447a64548);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_BOARD_VIEW", () => $2582ae2409307da1$export$a1eb5fb00be2a7d1);
const $2582ae2409307da1$export$2ac06baa43be057 = 'small';
const $2582ae2409307da1$export$45f4d5e73efcfde8 = 'Escape';
const $2582ae2409307da1$export$cbf34536d6076514 = /.*\/browse\/[^/]+/;
const $2582ae2409307da1$export$1c9d135d7bb1047 = '/rest/api/2/issue/archive';
const $2582ae2409307da1$export$501c618f5224bbb = 'issue-view';
const $2582ae2409307da1$export$f64573f447a64548 = 'issue-navigator';
const $2582ae2409307da1$export$a1eb5fb00be2a7d1 = 'board-view';

});


parcelRegister("4FabQ", function(module, exports) {

$parcel$export(module.exports, "isIssueViewPage", () => $71da4e2a837c85d3$export$d121412a48c6ebc0);

var $gRw8I = parcelRequire("gRw8I");

var $7BKle = parcelRequire("7BKle");
const $71da4e2a837c85d3$export$d121412a48c6ebc0 = ()=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.location.pathname.match((0, $7BKle.ISSUE_VIEW_URL_REGEX));
};

});

parcelRegister("eaTQ3", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $626f51b4fb1f2379$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $626f51b4fb1f2379$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $626f51b4fb1f2379$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $626f51b4fb1f2379$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $626f51b4fb1f2379$export$612d9bcb0c9d8976);

var $eJOHy = parcelRequire("eJOHy");

var $1O6Yz = parcelRequire("1O6Yz");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $626f51b4fb1f2379$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $626f51b4fb1f2379$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $626f51b4fb1f2379$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $626f51b4fb1f2379$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $626f51b4fb1f2379$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState()[issueKey], fields)
        });
    };
const $626f51b4fb1f2379$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState(), newIssues));
    };
const $626f51b4fb1f2379$var$actions = {
    setFieldValue: $626f51b4fb1f2379$var$setFieldValue,
    getFieldValue: $626f51b4fb1f2379$var$getFieldValue,
    setIssue: $626f51b4fb1f2379$var$setIssue,
    mergeIssue: $626f51b4fb1f2379$var$mergeIssue,
    setIssues: $626f51b4fb1f2379$var$setIssues,
    mergeIssues: $626f51b4fb1f2379$export$11aa02e14fdf7753
};
// this is a global store
const $626f51b4fb1f2379$var$store = (0, $GtRbT.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $626f51b4fb1f2379$var$actions
});
const $626f51b4fb1f2379$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $626f51b4fb1f2379$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$626f51b4fb1f2379$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $626f51b4fb1f2379$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $626f51b4fb1f2379$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $626f51b4fb1f2379$var$getAllFields = (state, issueKey)=>state[issueKey];
const $626f51b4fb1f2379$export$b79fae7fbe3ac392 = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValueSelector
});
const $626f51b4fb1f2379$export$25b73e671fe7a8fa = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getAllFields
});
const $626f51b4fb1f2379$export$ac289b84121829df = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValuesForIssuesSelector
});
const $626f51b4fb1f2379$export$915cdeec521b54f7 = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getMultiFieldValuesForIssuesSelector
});
const $626f51b4fb1f2379$export$4e5f1f4ed08d155e = (0, $ht3nQ.createSubscriber)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValueSelector
});
const $626f51b4fb1f2379$var$useFieldValueStoreActions = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: null
});
const $626f51b4fb1f2379$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $626f51b4fb1f2379$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eJOHy.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("5ogVm", function(module, exports) {

$parcel$export(module.exports, "default", () => $100db1e9c490ef2c$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7qGN1 = parcelRequire("7qGN1");
var $100db1e9c490ef2c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    archive: {
        "id": "issue.archive.confirm",
        "defaultMessage": "Archive"
    },
    delete: {
        "id": "issue.delete.confirm",
        "defaultMessage": "Delete"
    },
    deleteHeading: {
        "id": "issue.delete-heading",
        "defaultMessage": "Delete {issueKey}?"
    },
    deleteHeadingWithWorkType: {
        "id": "issue.delete-heading-with-issue-type",
        "defaultMessage": "Delete {workType} {issueKey}"
    },
    deleteHeadingIssueTerminologyRefreshM4: {
        "id": "issue.delete-heading.issue-terminology-refresh-m4",
        "defaultMessage": "Permanently delete {workType} {issueKey}?"
    },
    deleteOrArchiveHeading: {
        "id": "issue.delete-or-archive-heading",
        "defaultMessage": "Delete or archive {issueKey}?"
    },
    deleteWithSubtasksHeading: {
        "id": "issue.delete-with-subtasks-heading",
        "defaultMessage": "Delete {issueKey} and its subtasks?"
    },
    deleteWithChildrenHeading: {
        "id": "issue.delete-with-children-heading",
        "defaultMessage": "Delete {issueKey} and its child issues?"
    },
    cancel: {
        "id": "issue.delete.cancel",
        "defaultMessage": "Cancel"
    },
    deleteWarning: {
        "id": "issue.delete-warning",
        "defaultMessage": "You're about to permanently delete this issue, its comments and attachments, and all of its data."
    },
    deleteOrArchiveWarning: {
        "id": "issue.delete-or-archive-warning",
        "defaultMessage": "You can choose to delete or archive this issue. Deleting is irreversible. It permanently removes the issue, comments and attachments."
    },
    deleteOrArchiveWarningIssueTermRefresh: {
        "id": "issue.delete-or-archive-warning-issue-term-refresh",
        "defaultMessage": "You can choose to delete or archive this work item. Deleting is irreversible. It permanently removes the work item, comments and attachments."
    },
    deleteWithSubtasksWarning: {
        "id": "issue.delete-with-subtasks-warning",
        "defaultMessage": "You're about to permanently delete this issue and all its subtasks, its comments and attachments, and all of its data. You should move any subtasks you don't want to delete to another parent issue."
    },
    deleteWithChildrenWarning: {
        "id": "issue.delete-with-children-warning",
        "defaultMessage": "You're about to permanently delete this issue and all its child issues, its comments and attachments, and all of its data. You should move any child issues you don't want to delete to another parent issue."
    },
    deleteRecommendation: {
        "id": "issue.delete-recommendation",
        "defaultMessage": "If you're not sure, you can resolve or close this issue instead."
    },
    deleteWithChildrenHeadingIssueTermRefresh: {
        "id": "issue.delete-with-children-heading-issue-term-refresh",
        "defaultMessage": "Delete {issueKey} and its child work items?"
    },
    deleteWarningIssueTermRefresh: {
        "id": "issue.delete-warning-issue-term-refresh",
        "defaultMessage": "You're about to permanently delete this work item, its comments and attachments, and all of its data."
    },
    deleteWarningForTwoStepDeleteFreemiumExperiment: {
        "id": "issue.delete.two-step-delete-freemium",
        "defaultMessage": "You're about to permanently delete this work item, its comments and attachments, and all its data. This is irreversible."
    },
    deleteConfirmationForTwoStepDeleteFreemiumExperiment: {
        "id": "issue.delete-warning.two-step-delete-freemium",
        "defaultMessage": "If you're not sure, you can resolve or close this item instead."
    },
    deleteWithSubtasksWarningIssueTermRefresh: {
        "id": "issue.delete-with-subtasks-warning-issue-term-refresh",
        "defaultMessage": "You're about to permanently delete this work item and all its subtasks, comments and attachments, and data. You should move any subtasks you don't want to delete to another work item."
    },
    deleteWithSubtasksWarningIssueTerminologyRefreshM4: {
        "id": "issue.delete-with-subtasks-warning-issue-terminology-refresh-m4",
        "defaultMessage": "This {workType} and all its subtasks, comments, attachments, and data will be permanently deleted. Move any subtasks you don\u2019t want to delete."
    },
    deleteOrArchiveWithSubtasksWarning: {
        "id": "issue.delete-or-archive-with-subtasks-warning",
        "defaultMessage": "You can choose to delete or archive this issue and all its subtasks. Deleting is irreversible. It permanently removes the issue, subtasks, comments and attachments. To keep subtasks move them to a different parent."
    },
    deleteOrArchiveWithSubtasksWarningIssueTermRefresh: {
        "id": "issue.delete-or-archive-with-subtasks-warning-issue-term-refresh",
        "defaultMessage": "You can choose to delete or archive this work item and all its subtasks. Deleting is irreversible. It permanently removes the work item, subtasks, comments and attachments. To keep subtasks move them to a different parent."
    },
    deleteWithChildrenWarningIssueTermRefresh: {
        "id": "issue.delete-with-children-warning-issue-term-refresh",
        "defaultMessage": "You're about to permanently delete this work item and all its child work items, comments and attachments, and data. You should move any child work items you don't want to delete to another work items."
    },
    deleteWithChildrenWarningIssueTerminologyRefreshM4: {
        "id": "issue.delete-with-children-warning-issue-terminology-refresh-m4",
        "defaultMessage": "This {workType} and all its child work items, comments, attachments, and data will be permanently deleted. Move any child work item you don\u2019t want to delete."
    },
    deleteOrArchiveWithChildrenWarning: {
        "id": "issue.delete-or-archive-with-children-warning",
        "defaultMessage": "You can choose to delete or archive this issue and all its child issues. Deleting is irreversible. It permanently removes the issue, child issues, comments and attachments. To keep child issues move them to a different parent."
    },
    deleteOrArchiveWithChildrenWarningIssueTermRefresh: {
        "id": "issue.delete-or-archive-with-children-warning-issue-term-refresh",
        "defaultMessage": "You can choose to delete or archive this work item and all its child work items. Deleting is irreversible. It permanently removes the work item, child work items, comments and attachments. To keep child work items move them to a different parent."
    },
    deleteRecommendationIssueTermRefresh: {
        "id": "issue.delete-recommendation-issue-term-refresh",
        "defaultMessage": "If you're not sure, you can resolve or close this work item instead."
    },
    deleteErrorMessage: {
        "id": "issue.delete-error-message",
        "defaultMessage": "The value entered does not match"
    },
    deleteTextFieldLabelMessage: {
        "id": "issue.delete-textfield-label-message",
        "defaultMessage": "Type <strong>delete</strong> to continue"
    },
    deleteLabelMessage: {
        "id": "issue.delete-label-message",
        "defaultMessage": "Type delete to continue"
    },
    iconButtonLabel: {
        "id": "issue.icon-button-label",
        "defaultMessage": "Close Modal"
    },
    issueArchivalSuccessFlagTitle: {
        "id": "issue-archival-modal.issue-archival-success-flag-title",
        "defaultMessage": "We've archived the issue {issueKey}."
    },
    issueArchivalSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-archival-modal.issue-archival-success-flag-title-issue-term-refresh",
        "defaultMessage": "We've archived the work item {issueKey}."
    },
    issueArchivalSuccessFlagActionViewIssue: {
        "id": "issue-archival-modal.issue-archival-success-flag-action-view-issue",
        "defaultMessage": "View issue"
    },
    issueArchivalSuccessFlagActionViewIssueIssueTermRefresh: {
        "id": "issue-archival-modal.issue-archival-success-flag-action-view-issue-issue-term-refresh",
        "defaultMessage": "View work item"
    },
    issueArchivalSuccessFlagActionViewInArchive: {
        "id": "issue-archival-modal.issue-archival-success-flag-action-view-in-archive",
        "defaultMessage": "View all archived issues"
    },
    issueArchivalSuccessFlagActionViewInArchiveIssueTermRefresh: {
        "id": "issue-archival-modal.issue-archival-success-flag-action-view-in-archive-issue-term-refresh",
        "defaultMessage": "View all archived work items"
    },
    issueArchivalErrorFlagTitle: {
        "id": "issue-archival-modal.issue-archival-error-flag-title",
        "defaultMessage": "We couldn\u2019t archive the issue {issueKey}. Wait a few moments, then try again."
    },
    issueArchivalErrorFlagTitleIssueTermRefresh: {
        "id": "issue-archival-modal.issue-archival-error-flag-title-issue-term-refresh",
        "defaultMessage": "We couldn\u2019t archive the work item {issueKey}. Wait a few moments, then try again."
    },
    deleteTextToEquateForTextbox: {
        "id": "issue-delete-modal.issue-delete-text-to-equate-for-textbox",
        "defaultMessage": "delete"
    }
});

});

parcelRegister("eMR3W", function(module, exports) {

$parcel$export(module.exports, "useIsDeleteIssueExperimentEnabled", () => $f813dea020055a09$export$5f61d2ccec0586e);

var $epTsa = parcelRequire("epTsa");

var $bmoS1 = parcelRequire("bmoS1");

var $bmoS1 = parcelRequire("bmoS1");

var $eaTQ3 = parcelRequire("eaTQ3");

var $bNexr = parcelRequire("bNexr");

var $f5OzW = parcelRequire("f5OzW");

var $a9ldn = parcelRequire("a9ldn");

var $7jTnu = parcelRequire("7jTnu");
const $f813dea020055a09$export$5f61d2ccec0586e = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const isPremium = edition === (0, $a9ldn.PREMIUM_EDITION);
    const [permissions] = (0, $f5OzW.useProjectPermissions)(projectKey);
    const isArchived = (0, $bmoS1.useIsArchived)();
    const [issueType] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: 'issuetype'
    });
    const isSubtask = issueType?.subtask;
    const isEligibleForArchivalWithoutLicenseCheck = !isSubtask && !isArchived && permissions.canArchiveIssue;
    const isEligibleForArchivalWithLicenseCheck = !isSubtask && !isArchived && permissions.canArchiveIssue && isPremium;
    const isEligibleForIssueArchival = (0, $7jTnu.fg)('extend_issue_archival_for_free_and_standard') ? isEligibleForArchivalWithoutLicenseCheck : isEligibleForArchivalWithLicenseCheck;
    return isEligibleForIssueArchival && (0, $epTsa.expVal)('issue_deletion_a_two_step_process_ga', 'isDeleteTwoStepGaEnabled', false);
};

});
parcelRegister("f5OzW", function(module, exports) {

$parcel$export(module.exports, "useProjectPermissions", () => $9392c16d11e1d8d6$export$c6c6b35628cf47a8);
$parcel$export(module.exports, "useCanAdministerProject", () => $9392c16d11e1d8d6$export$f39ed5a161efa614);
$parcel$export(module.exports, "useCanAdministerJira", () => $9392c16d11e1d8d6$export$ec12ddafd19b95ac);
$parcel$export(module.exports, "useCanConfigureIssue", () => $9392c16d11e1d8d6$export$e7267b8a084eadb3);
$parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", () => $9392c16d11e1d8d6$export$756d7c97077a2f76);
$parcel$export(module.exports, "useCanUseCustomerServiceAgentFeatures", () => $9392c16d11e1d8d6$export$a9aa002e3fe96518);
$parcel$export(module.exports, "useCanDownloadAttachments", () => $9392c16d11e1d8d6$export$d47dad3a7e3265ea);
$parcel$export(module.exports, "useProjectPermissionsActions", () => $9392c16d11e1d8d6$export$86c656cdb87052cd);

var $eJOHy = parcelRequire("eJOHy");

var $lvKO5 = parcelRequire("lvKO5");

var $iW0U8 = parcelRequire("iW0U8");

var $cmy2V = parcelRequire("cmy2V");
const $9392c16d11e1d8d6$export$c6c6b35628cf47a8 = (projectKey)=>{
    const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        permissions,
        actions
    ];
};
const $9392c16d11e1d8d6$export$f39ed5a161efa614 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerProject;
};
const $9392c16d11e1d8d6$export$ec12ddafd19b95ac = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerJira;
};
const $9392c16d11e1d8d6$export$e7267b8a084eadb3 = (projectKey)=>{
    const canConfigureAdministerProject = $9392c16d11e1d8d6$export$f39ed5a161efa614(projectKey);
    const canAdministerJira = $9392c16d11e1d8d6$export$ec12ddafd19b95ac(projectKey);
    return canConfigureAdministerProject || canAdministerJira;
};
const $9392c16d11e1d8d6$export$756d7c97077a2f76 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { appPermissions: appPermissions } = (0, $lvKO5.useTenantContext)();
    return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
};
const $9392c16d11e1d8d6$export$a9aa002e3fe96518 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $iW0U8.useApplicationPermissions)();
    return permissions.canUseServiceDeskAgentFeatures && hasCustomerServiceAccess;
};
const $9392c16d11e1d8d6$export$d47dad3a7e3265ea = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canExportIssue;
};
const $9392c16d11e1d8d6$export$86c656cdb87052cd = ()=>{
    const [, { setProjectPermissions: setProjectPermissions }] = (0, $cmy2V.useProjectPermissionsStoreActions)();
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("cmy2V", function(module, exports) {

$parcel$export(module.exports, "defaultPermissions", () => $872d4887d895f20d$export$ccfee65526b322ca);
$parcel$export(module.exports, "useProjectPermissionsStore", () => $872d4887d895f20d$export$4919fa09a3d81224);
$parcel$export(module.exports, "useProjectPermissionsStoreActions", () => $872d4887d895f20d$export$e8436ef485b33bdb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $g2Hwr = parcelRequire("g2Hwr");
const $872d4887d895f20d$export$ccfee65526b322ca = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteAllWorklogs: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canDeleteOwnWorklogs: false,
    canEditAllComments: false,
    canEditAllWorklogs: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canEditOwnWorklogs: false,
    canLinkIssues: false,
    canLogWork: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canUseServiceDeskAgentFeatures: false,
    canBrowseUsers: false,
    canViewDevTools: false,
    canViewWatchers: false,
    canViewVoters: false,
    canCreateIssuesInClassicProjectEpic: false,
    canResolveIssues: false,
    canExportIssue: false,
    canArchiveIssue: false,
    canUnarchiveIssue: false
};
const $872d4887d895f20d$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'project-permissions',
    initialState: {},
    actions: $g2Hwr
});
const $872d4887d895f20d$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $872d4887d895f20d$export$ccfee65526b322ca;
const $872d4887d895f20d$export$4919fa09a3d81224 = (0, $iJq0l.createHook)($872d4887d895f20d$export$6f57813fe9f31bf9, {
    selector: $872d4887d895f20d$var$getProjectPermissionSelector
});
const $872d4887d895f20d$export$e8436ef485b33bdb = (0, $iJq0l.createHook)($872d4887d895f20d$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("g2Hwr", function(module, exports) {

$parcel$export(module.exports, "setProjectPermissions", () => $d904843c11c916e5$export$53f5cc27627e5fe3);
const $d904843c11c916e5$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [projectKey]: permissions
        });
    };

});




parcelRegister("b5KyQ", function(module, exports) {

$parcel$export(module.exports, "useIsTwoStepIssueDeleteFreemiumExperimentEnabled", () => $0ee9610658376d00$export$484c253d81a91400);

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");

var $f5OzW = parcelRequire("f5OzW");

var $a9ldn = parcelRequire("a9ldn");

var $eaTQ3 = parcelRequire("eaTQ3");
const $0ee9610658376d00$export$484c253d81a91400 = ({ isIssueArchivalEnabled: isIssueArchivalEnabled = false })=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const edition = (0, $bNexr.useEdition)(projectKey, true);
    const isArchived = (0, $bmoS1.useIsArchived)();
    const [issueType] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: 'issuetype'
    });
    const [permissions] = (0, $f5OzW.useProjectPermissions)(projectKey);
    const isSubtask = issueType?.subtask;
    const isUneligibleForArchivalWithLicenseCheck = edition === (0, $a9ldn.FREE_EDITION) || edition === (0, $a9ldn.STANDARD_EDITION) || !isIssueArchivalEnabled;
    const isUneligibleForArchivalWithoutLicenseCheck = !(permissions.canArchiveIssue && !isSubtask && !isArchived) && !isIssueArchivalEnabled;
    const isUneligibleForIssueArchival = (0, $7jTnu.fg)('extend_issue_archival_for_free_and_standard') ? isUneligibleForArchivalWithoutLicenseCheck : isUneligibleForArchivalWithLicenseCheck;
    return isUneligibleForIssueArchival && (0, $epTsa.expVal)('issue_deletion_two_step_process_for_free_standard', 'isIssueDeleteExperimentFreemiumEnabled', false);
};

});

const $4ca9625b839f10bc$export$a97e1a5849845ab3 = 'issue-view-foundation.issue-actions.delete-issue.textfield';


parcelRegister("8NIGX", function(module, exports) {

$parcel$export(module.exports, "HideDoneOnboardingProvider", () => $8dd7fd4d32607adc$export$a84c251717c39a3e);
$parcel$export(module.exports, "useHideDoneOnboarding", () => $8dd7fd4d32607adc$export$df78f68a5cea98eb);
$parcel$export(module.exports, "HideDoneOnboarding", () => $8dd7fd4d32607adc$export$48041c15f880aebf);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $7UDun = parcelRequire("7UDun");

var $ftN6c = parcelRequire("ftN6c");

var $3CprG = parcelRequire("3CprG");

var $gCeeo = parcelRequire("gCeeo");

var $9zZj0 = parcelRequire("9zZj0");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $9HHOs = parcelRequire("9HHOs");

var $kEUB1 = parcelRequire("kEUB1");

var $g1NZW = parcelRequire("g1NZW");


var $97LIC = parcelRequire("97LIC");
const $8dd7fd4d32607adc$export$a611c8ca1952c1b5 = 'jira-nin-hide-done-onboarding-stg';
const $8dd7fd4d32607adc$export$3d8a20f97116832b = 'jira-nin-hide-done-onboarding';
const $8dd7fd4d32607adc$var$ENV_STAGING = 'staging';
const $8dd7fd4d32607adc$var$STARGATE_URL = '/gateway/api';
const $8dd7fd4d32607adc$var$HideDoneOnboardingContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $8dd7fd4d32607adc$export$a84c251717c39a3e = ({ children: children })=>{
    const [showHideDoneOnboarding, setShowHideDoneOnboarding] = (0, $eJOHy.useState)(false);
    const value = (0, $eJOHy.useMemo)(()=>({
            showHideDoneOnboarding: showHideDoneOnboarding,
            setShowHideDoneOnboarding: setShowHideDoneOnboarding
        }), [
        showHideDoneOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8dd7fd4d32607adc$var$HideDoneOnboardingContext.Provider, {
        value: value
    }, children);
};
const $8dd7fd4d32607adc$export$51d637936c6abe6f = ()=>{
    const hierarchyContext = (0, $eJOHy.useContext)($8dd7fd4d32607adc$var$HideDoneOnboardingContext);
    if (!hierarchyContext) {
        (0, $gYnSx.default)({
            meta: {
                id: 'issueTableHideDoneOnboarding',
                packageName: (0, $54713f11448e89c8$export$b8b9d90f9e5bd72b),
                teamName: (0, $54713f11448e89c8$export$d57b6b390e78d90f)
            },
            error: new Error('useHideDoneOnboardingContext must be used within a HideDoneOnboardingProvider'),
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            showHideDoneOnboarding: false,
            setShowHideDoneOnboarding: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    return hierarchyContext;
};
const $8dd7fd4d32607adc$export$df78f68a5cea98eb = ({ isHideDoneSupportEnabled: isHideDoneSupportEnabled })=>{
    const { showHideDoneOnboarding: showHideDoneOnboarding, setShowHideDoneOnboarding: setShowHideDoneOnboarding } = $8dd7fd4d32607adc$export$51d637936c6abe6f();
    const ONBOARDING_ENGAGEMENT_ID = (0, $g1NZW.useEnvironment)() === $8dd7fd4d32607adc$var$ENV_STAGING ? $8dd7fd4d32607adc$export$a611c8ca1952c1b5 : $8dd7fd4d32607adc$export$3d8a20f97116832b;
    const cloudId = (0, $kEUB1.useCloudId)();
    /*
   * Onboarding Experience is loaded manually on page load via EP's CoordinationClient class
   * Once loaded, if the message is active for this particular context, only then the HideDone_ONBOARDING will be loaded and displayed
   */ const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, $8dd7fd4d32607adc$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isEnrolled, stopEnrolment] = (0, $7UDun.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    (0, $eJOHy.useEffect)(()=>{
        if (isEnrolled && isHideDoneSupportEnabled) {
            stopEnrolment(false);
            setShowHideDoneOnboarding(true);
        }
    }, [
        isEnrolled,
        isHideDoneSupportEnabled,
        setShowHideDoneOnboarding,
        stopEnrolment
    ]);
    return {
        showHideDoneOnboarding: showHideDoneOnboarding,
        setShowHideDoneOnboarding: setShowHideDoneOnboarding
    };
};
const $8dd7fd4d32607adc$export$48041c15f880aebf = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eJOHy.useState)(true);
    const { showHideDoneOnboarding: showHideDoneOnboarding, setShowHideDoneOnboarding: setShowHideDoneOnboarding } = $8dd7fd4d32607adc$export$51d637936c6abe6f();
    const onCloseSpotlight = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'hideDoneOnboardingButton');
        setIsSpotlightActive(false);
        setShowHideDoneOnboarding(false);
    }, [
        createAnalyticsEvent,
        setShowHideDoneOnboarding
    ]);
    if (!showHideDoneOnboarding || !isSpotlightActive) return;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CprG.ChoreographerContextProvider), {
        isChoreographed: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        messageId: "issue-table-hide-done-toggle.ui.onboarding.jira-spotlight.nin-hide-done-toggle-spotlight",
        messageType: "engagement",
        dialogPlacement: "left top",
        actions: [
            {
                onClick: onCloseSpotlight,
                text: formatMessage((0, $97LIC.default).ok)
            }
        ],
        dialogWidth: 270,
        heading: formatMessage((0, $97LIC.default).onboardingHeading),
        target: "nin-hide-done-toggle-spotlight",
        key: "nin-hide-done-toggle-spotlight",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)"
    }, formatMessage((0, $97LIC.default).onboardingDescription)));
};

});
const $54713f11448e89c8$export$b8b9d90f9e5bd72b = 'jiraIssueTableHideDoneToggle';
const $54713f11448e89c8$export$d57b6b390e78d90f = 'keystone';
const $54713f11448e89c8$export$6a7d6ab86cfdfcdc = 'hideDoneToggle';
const $54713f11448e89c8$export$f7109619a5e9e0d6 = 'jira-native-issue-table';

parcelRegister("97LIC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f9b6ff3c08f860d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6f9b6ff3c08f860d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    onboardingHeading: {
        "id": "jira-issue-table-hide-done-toggle.onboarding.onboarding-heading",
        "defaultMessage": "Hide done work items"
    },
    onboardingDescription: {
        "id": "jira-issue-table-hide-done-toggle.onboarding.onboarding-description",
        "defaultMessage": "Quickly hide work that's done without adding a filter."
    },
    ok: {
        "id": "jira-issue-table-hide-done-toggle.onboarding.done",
        "defaultMessage": "OK"
    }
});

});


parcelRegister("80Alx", function(module, exports) {

$parcel$export(module.exports, "IssueFieldStatisticsEntrypointProvider", () => $2b43f7c4a6ad1a70$export$2043a5b19c8c0e7f);
$parcel$export(module.exports, "useIssueFieldStatisticsEntryPoint", () => $2b43f7c4a6ad1a70$export$8e48443ccac1a85f);

var $eJOHy = parcelRequire("eJOHy");

var $bbdV2 = parcelRequire("bbdV2");

var $kEUB1 = parcelRequire("kEUB1");

var $kuFbR = parcelRequire("kuFbR");

var $5mHmY = parcelRequire("5mHmY");

var $5VcRg = parcelRequire("5VcRg");
const $2b43f7c4a6ad1a70$var$IssueFieldStatisticsEntrypointContext = (0, $kuFbR.createUseEntryPointContext)();
const $2b43f7c4a6ad1a70$export$2043a5b19c8c0e7f = ({ children: children, jql: jql, view: view })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            jql: jql,
            view: view,
            namespace: (0, $5mHmY.ISSUE_SEARCH_NAMESPACE)
        }), [
        cloudId,
        jql,
        view
    ]);
    const createObjectEntryPoint = (0, $bbdV2.useEntryPoint)((0, $5VcRg.issueFieldStatisticsStatisticsSidebarEntryPoint), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2b43f7c4a6ad1a70$var$IssueFieldStatisticsEntrypointContext.Provider, {
        value: createObjectEntryPoint
    }, children);
};
const $2b43f7c4a6ad1a70$export$8e48443ccac1a85f = ()=>(0, $eJOHy.useContext)($2b43f7c4a6ad1a70$var$IssueFieldStatisticsEntrypointContext);

});
parcelRegister("kuFbR", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $38dc9eb5446138c0$export$41bce2223126846b);

var $eJOHy = parcelRequire("eJOHy");
const $38dc9eb5446138c0$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $eJOHy.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});

parcelRegister("5mHmY", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_EXPERIENCE_NAME", () => $f390676630d49e3d$export$716d68d214fad041);
$parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", () => $f390676630d49e3d$export$de2495608df10495);

var $7mF43 = parcelRequire("7mF43");
const $f390676630d49e3d$export$716d68d214fad041 = 'issue-field-statistics';
const $f390676630d49e3d$export$6d9ce65a72493aac = 'statistics';
const $f390676630d49e3d$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
const $f390676630d49e3d$var$AUTO_OPEN_SIDEBAR_KEY = 'sidebar';
const $f390676630d49e3d$export$b229a6bf782d77e7 = 'statistics-field';
const $f390676630d49e3d$export$c4ec2849fcb32515 = 'statistics-chart';
const $f390676630d49e3d$export$70a91e824238865d = (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))($f390676630d49e3d$export$b229a6bf782d77e7);
const $f390676630d49e3d$export$60179bff81db3578 = (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))($f390676630d49e3d$export$c4ec2849fcb32515);
const $f390676630d49e3d$export$1816113812ed602d = Object.freeze({
    [$f390676630d49e3d$var$AUTO_OPEN_SIDEBAR_KEY]: undefined,
    [$f390676630d49e3d$export$70a91e824238865d]: undefined,
    [$f390676630d49e3d$export$60179bff81db3578]: undefined
});

});

parcelRegister("5VcRg", function(module, exports) {

$parcel$export(module.exports, "issueFieldStatisticsStatisticsSidebarEntryPoint", () => $25c7d86746b7bf57$export$89d0b9a4111dd3ef);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $42MDl = parcelRequire("42MDl");

const $25c7d86746b7bf57$export$89d0b9a4111dd3ef = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("aRdJM")), {
        moduleId: "4940af1a",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, jql: jql, view: view, namespace: namespace })=>({
            queries: {
                issueFieldStatistics: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $42MDl.default,
                    variables: {
                        cloudId: cloudId,
                        jql: jql,
                        view: view,
                        namespace: namespace
                    }
                }
            }
        })
});

});
parcelRegister("42MDl", function(module, exports) {

$parcel$export(module.exports, "default", () => $51392df4997bf6dc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a8004fa45eb0b812b77be54fd002799>>
 * @relayHash f30148119addea651a9b8860c7c557f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b33dff432f340c6c68b9ae784353feca7ff3fcc20bd2bcdf7edabe537ad1a7b
const $51392df4997bf6dc$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7b33dff432f340c6c68b9ae784353feca7ff3fcc20bd2bcdf7edabe537ad1a7b",
        "metadata": {},
        "name": "ui_StatisticsSidebarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $51392df4997bf6dc$export$2e2bcd8739ae039 = $51392df4997bf6dc$var$node;

});

parcelRegister("aRdJM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lzCBW").then(()=>parcelRequire('1Pbhb'));

});



parcelRegister("C81Q0", function(module, exports) {

$parcel$export(module.exports, "asyncBulkOpsCoreEntryPoint", () => $085cd2d3be43b631$export$d90d57132636bb1);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $085cd2d3be43b631$export$d90d57132636bb1 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("8vYW1")), {
        moduleId: "f81933b6",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8vYW1", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("6X94G").then(()=>parcelRequire('9YtPn'));

});


parcelRegister("lHHP1", function(module, exports) {

$parcel$export(module.exports, "NinChangeboardingContext", () => $c026bf20b22e170d$export$b349f970aff316d8);
$parcel$export(module.exports, "EnableNinChangeboardingProvider", () => $c026bf20b22e170d$export$dd1deacfc61c978a);
$parcel$export(module.exports, "NinChangeboardingTourTarget", () => $c026bf20b22e170d$export$eb95770b90ecc1f3);
$parcel$export(module.exports, "NinChangeboardingTourCard", () => $c026bf20b22e170d$export$7c27d65549066b5);
$parcel$export(module.exports, "useGlobalScopeOptInFlag", () => $c026bf20b22e170d$export$9e9f507adee88e58);

var $eJOHy = parcelRequire("eJOHy");

var $epTsa = parcelRequire("epTsa");

var $bILK0 = parcelRequire("bILK0");

var $ecCxV = parcelRequire("ecCxV");

var $4elgJ = parcelRequire("4elgJ");

var $7jTnu = parcelRequire("7jTnu");

var $9ncIL = parcelRequire("9ncIL");

var $5Rrlj = parcelRequire("5Rrlj");

var $hqX3Z = parcelRequire("hqX3Z");

var $5gIAR = parcelRequire("5gIAR");
const $c026bf20b22e170d$var$sessionStorageProvider = (0, $4elgJ.createSessionStorageProvider)('', false);
const $c026bf20b22e170d$export$b349f970aff316d8 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $c026bf20b22e170d$export$dd1deacfc61c978a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c026bf20b22e170d$export$b349f970aff316d8.Provider, {
        value: true
    }, children);
const $c026bf20b22e170d$export$eb95770b90ecc1f3 = ({ children: children, engagementId: engagementId })=>{
    const isTourEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    if (!isTourEnabled) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hqX3Z.default), {
        engagementId: engagementId
    }, children);
};
const $c026bf20b22e170d$export$7c27d65549066b5 = ({ mode: mode, view: view, hasIssueResults: hasIssueResults, isAiEnabled: isAiEnabled })=>{
    const isTourEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    if (!isTourEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Rrlj.AsyncSpotlightCard), {
        mode: mode,
        view: view,
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
const $c026bf20b22e170d$export$9e9f507adee88e58 = ()=>{
    const isFlagEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const onOpenInProductHelpArticle = (0, $ecCxV.useHelpPanelLink)();
    const onLearnMore = (0, $eJOHy.useCallback)(()=>{
        onOpenInProductHelpArticle((0, $9ncIL.LEARN_MORE_IPH_ARTICLE_ID));
    }, [
        onOpenInProductHelpArticle
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const shouldShowOptInFlag = (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $c026bf20b22e170d$var$sessionStorageProvider.get('showNinOptInFlag') : sessionStorage.getItem('showNinOptInFlag');
        if (isFlagEnabled && shouldShowOptInFlag === 'true') {
            showFlag({
                type: 'success',
                title: (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5gIAR.default).successOptInTitleIssueTermRefresh : (0, $5gIAR.default).successOptInTitle,
                description: (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5gIAR.default).successOptInDescIssueTermRefresh : (0, $5gIAR.default).successOptInDesc,
                messageId: 'issue-navigator-changeboarding.controllers.enable-nin-changeboarding.show-flag.success',
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $5gIAR.default).successActionLearnMoreLink,
                        onClick: onLearnMore
                    }
                ],
                isAutoDismiss: false,
                testId: 'issue-navigator-changeboarding.optin-success-flag'
            });
            (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $c026bf20b22e170d$var$sessionStorageProvider.remove('showNinOptInFlag') : sessionStorage.removeItem('showNinOptInFlag');
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("ecCxV", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "HelpPanelLink", () => $ceecb2ae691c2ef9$export$5a09250ffddd7fd1);
$parcel$export(module.exports, "default", () => $ceecb2ae691c2ef9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $eJ9f5 = parcelRequire("eJ9f5");

var $7jTnu = parcelRequire("7jTnu");

var $hLzUY = parcelRequire("hLzUY");

var $3VPsL = parcelRequire("3VPsL");

var $dfP3D = parcelRequire("dfP3D");

var $epTsa = parcelRequire("epTsa");
const $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $3VPsL.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $hLzUY.HELP_PANEL_ID), (0, $hLzUY.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $ceecb2ae691c2ef9$export$5a09250ffddd7fd1 = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $7jTnu.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    if ((0, $7jTnu.fg)('help_panel_as_link')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default",
        testId: props.testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $epTsa.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $epTsa.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var /**
 * @deprecated Use named export instead.
 */ $ceecb2ae691c2ef9$export$2e2bcd8739ae039 = $ceecb2ae691c2ef9$export$5a09250ffddd7fd1;
const $ceecb2ae691c2ef9$var$buttonWrapperStyles = null;
const $ceecb2ae691c2ef9$var$buttonWrapperSubtleStyles = null;

});

parcelRegister("9ncIL", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_SUPPORT_ARTICLE", () => $1b1bba2c09c1943d$export$ff66aa7a4971d979);
$parcel$export(module.exports, "LEARN_MORE_IPH_ARTICLE_ID", () => $1b1bba2c09c1943d$export$88d16e35389ab3c6);
$parcel$export(module.exports, "getEngagementPlatformlMessageId", () => $1b1bba2c09c1943d$export$91074f0ada4f4533);
$parcel$export(module.exports, "TOUR_MESSAGE_ID", () => $1b1bba2c09c1943d$export$4ac775bda929f47);
$parcel$export(module.exports, "views", () => $1b1bba2c09c1943d$export$d0079916fe6800ac);
const $1b1bba2c09c1943d$export$ff66aa7a4971d979 = 'https://support.atlassian.com/jira-software-cloud/docs/search-for-issues-in-jira/';
const $1b1bba2c09c1943d$export$88d16e35389ab3c6 = '3FGQv6n7fB93yWWTYqY0hq';
const $1b1bba2c09c1943d$export$91074f0ada4f4533 = (id)=>`${id}-march2024`;
const $1b1bba2c09c1943d$export$4ac775bda929f47 = 'nin-changeboarding-start';
const $1b1bba2c09c1943d$export$6c69c3d1b5f6fe55 = {
    basic: 'basic',
    advanced: 'advanced'
};
const $1b1bba2c09c1943d$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};

});

parcelRegister("5Rrlj", function(module, exports) {

$parcel$export(module.exports, "AsyncSpotlightCard", () => $09a720f6524e2b48$export$40e85aa59c198f98);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $09a720f6524e2b48$var$SpotlightCard = (0, $bQWwW.lazy)(// we want both these types of spotlights to be within the same webpack chunk
()=>(parcelRequire("ePPqq")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/common/ui/spotlight/spotlight-card/index.tsx"
});
const $09a720f6524e2b48$export$40e85aa59c198f98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-spotlight-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-spotlight-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09a720f6524e2b48$var$SpotlightCard, props)));

});
parcelRegister("ePPqq", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("2ymnl").then(()=>parcelRequire('knqHM'));

});


parcelRegister("hqX3Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $a165742ed253731e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $guChT = parcelRequire("guChT");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a165742ed253731e$var$EngagementSpotlightAsync = (0, $bQWwW.lazy)(()=>(parcelRequire("fbCP6")).then(({ EngagementSpotlight: EngagementSpotlight })=>EngagementSpotlight), {
    ssr: false,
    moduleId: "../platform/packages/personalization/engagekit-ts/src/index.ts"
});
const $a165742ed253731e$var$SpotlightTourTarget = ({ children: children, engagementId: engagementId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: engagementId
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-engagement-spotlight",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-engagement-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a165742ed253731e$var$EngagementSpotlightAsync, {
        engagementId: engagementId
    }))));
var $a165742ed253731e$export$2e2bcd8739ae039 = $a165742ed253731e$var$SpotlightTourTarget;

});
parcelRegister("fbCP6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("66OvY")
]).then(()=>parcelRequire('cf0I9'));

});


parcelRegister("5gIAR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b48b63ba324164d9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b48b63ba324164d9$var$messages = (0, $7qGN1.defineMessages)({
    successOptInTitle: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title",
        "defaultMessage": "You've switched to the new issue search"
    },
    successOptInDesc: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for issues across Jira."
    },
    successActionLearnMoreLink: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-action-learn-more-link",
        "defaultMessage": "Learn more"
    },
    successOptInTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title-issue-term-refresh",
        "defaultMessage": "You've switched to the new search"
    },
    successOptInDescIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc-issue-term-refresh",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for work across Jira."
    }
});
var $b48b63ba324164d9$export$2e2bcd8739ae039 = $b48b63ba324164d9$var$messages;

});


parcelRegister("cGA2b", function(module, exports) {

$parcel$export(module.exports, "JQLDebuggerRenderSlotAsync", () => $640a0e4290061413$export$222c67ffe33f4fa4);
$parcel$export(module.exports, "JQLDebuggerRenderSlot", () => $640a0e4290061413$export$a3144a6f75ce69fe);

var $eJOHy = parcelRequire("eJOHy");

var $bQWwW = parcelRequire("bQWwW");
var $eSXqs = parcelRequire("eSXqs");

var $1KdDN = parcelRequire("1KdDN");

var $bJscI = parcelRequire("bJscI");

var $bUnif = parcelRequire("bUnif");

var $13f5n = parcelRequire("13f5n");

var $kbhn6 = parcelRequire("kbhn6");

const $640a0e4290061413$export$222c67ffe33f4fa4 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("iPjZi")), {
    moduleId: "./src/packages/jql-builder/jql-debugger/src/ui/index.tsx"
});
function $640a0e4290061413$export$e8398d4933a4ab21() {
    const [debuggerState] = (0, $bUnif.useDebuggerStatus)();
    const debuggerActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const [isAiEnabled] = (0, $bUnif.useIsAiEnabled)();
    // Don't render the render slot when AI is not enabled
    if (!isAiEnabled) return null;
    // Don't render the render slot when the feature is at initial state
    if (debuggerState === 'INIT') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).FIX_WITH_AI_MODAL,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: "unmount",
        onError: ()=>{
            // On error, set the feature state to be JS_ERROR, so that such scenarios can be handled without
            // interfering with the feature initial state nor with the AI event instrumentation
            debuggerActions.setStatus('JS_ERROR');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eSXqs.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($640a0e4290061413$export$222c67ffe33f4fa4, null)));
}
const $640a0e4290061413$export$a3144a6f75ce69fe = (0, $bJscI.componentWithFG)('gravityai-2283-jql-debugger-rll-to-entrypoints', (0, $kbhn6.JQLPanelRenderSlotForIssueView), $640a0e4290061413$export$e8398d4933a4ab21);

});
parcelRegister("bUnif", function(module, exports) {

$parcel$export(module.exports, "useJqlDebuggerStoreActions", () => $225b1cd3961a99bb$export$661ee98a2d30a450);
$parcel$export(module.exports, "useStoreData", () => $225b1cd3961a99bb$export$544efe5ac05fc17);
$parcel$export(module.exports, "useDebuggerStatus", () => $225b1cd3961a99bb$export$e4c2322c66a3dea5);
$parcel$export(module.exports, "useJqlErrors", () => $225b1cd3961a99bb$export$d959fd60596bfa67);
$parcel$export(module.exports, "useJqlEditorOnSearch", () => $225b1cd3961a99bb$export$ba3a4678e5df092c);
$parcel$export(module.exports, "useJqlQuery", () => $225b1cd3961a99bb$export$ec027c329b94fe67);
$parcel$export(module.exports, "useIsAiEnabled", () => $225b1cd3961a99bb$export$742ce7b41314d513);
$parcel$export(module.exports, "useErrorComponentTestId", () => $225b1cd3961a99bb$export$afd1b99522ddeae9);
$parcel$export(module.exports, "useErrorComponentValidationId", () => $225b1cd3961a99bb$export$9c84149290836e7);
$parcel$export(module.exports, "useIsReadyForProactive", () => $225b1cd3961a99bb$export$1da2ac60b06e42d1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");
const $225b1cd3961a99bb$var$initialState = {
    jqlQuery: '',
    userQueryError: [],
    onSearch: ()=>undefined,
    status: 'INIT',
    jqlDiffTokens: [],
    isAiEnabled: false,
    syntaxCorrectionAttemptErrors: [],
    singleInstrumentationID: '',
    errorSectionTestId: '',
    onAiInteractionDismissed () {
    // do nothing
    },
    exitNaturalLanguageMode () {
    // do nothing
    },
    onJsError () {
    // do nothing
    },
    jqlErrors: [],
    errorComponentValidationId: '',
    errorComponentTestId: '',
    isReadyForProactive: false
};
const $225b1cd3961a99bb$var$Store = (0, $GtRbT.createStore)({
    initialState: $225b1cd3961a99bb$var$initialState,
    // actions that trigger store mutation
    actions: {
        setJqlQuery: (jqlQuery)=>({ setState: setState })=>{
                setState({
                    jqlQuery: jqlQuery
                });
            },
        setOnSearch: (onSearch)=>({ setState: setState })=>{
                setState({
                    onSearch: onSearch
                });
            },
        setStatus: (status)=>({ setState: setState, getState: getState })=>{
                if (status === 'JS_ERROR') getState().onJsError();
                setState({
                    status: status
                });
            },
        setIssueNavigatorSearchMode: (issueNavigatorSearchMode)=>({ setState: setState })=>{
                setState({
                    issueNavigatorSearchMode: issueNavigatorSearchMode
                });
            },
        resetStatus: (source, newJqlQuery)=>({ setState: setState, getState: getState })=>{
                if (source === 'ON_ENTER_NL_MODE') setState({
                    issueNavigatorSearchMode: 'NL2JQL'
                });
                if (getState().status !== 'INIT') {
                    if ((0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button')) // AI modal gets dismissed when we accept a suggestion
                    // However, we don't want to fire the `aiInteraction Dismissed` event in that case
                    // We pass the status in as if we are viewing a result and close the panel, it should be a discarded event, not a dismissed event
                    {
                        if (source !== 'ACCEPT_FIX') {
                            if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) // On a new JQL search, we do not dismiss the AI interaction if the JQL query hasn't changed
                            {
                                if (!(source === 'ON_NEW_JQL_SEARCH' && getState().jqlQuery === newJqlQuery)) getState().onAiInteractionDismissed(source, getState().status);
                            } else getState().onAiInteractionDismissed(source, getState().status);
                        }
                    } else if (source !== 'ACCEPT_FIX') {
                        // AI modal gets dismissed when we accept a suggestion
                        // However, we don't want to fire the `aiInteraction Dismissed` event in that case
                        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) // On a new JQL search, we do not dismiss the AI interaction if the JQL query hasn't changed
                        {
                            if (!(source === 'ON_NEW_JQL_SEARCH' && getState().jqlQuery === newJqlQuery)) getState().onAiInteractionDismissed(source);
                        } else getState().onAiInteractionDismissed(source);
                    }
                    // Reset the status and aiInteractionDismissed handler so that duplicate events won't be fired
                    setState({
                        status: 'INIT',
                        onAiInteractionDismissed: $225b1cd3961a99bb$var$initialState.onAiInteractionDismissed
                    });
                }
            },
        setStateOnFeatureInvoke: (initialDataOnInvoke)=>({ setState: setState })=>{
                setState({
                    ...initialDataOnInvoke,
                    status: 'LOADING_RESULT'
                });
            },
        setJqlErorCorrectionData: (data)=>({ setState: setState })=>{
                setState({
                    ...data,
                    status: 'VIEW_RESULT'
                });
            },
        setIsAiEnabled: (isAiEnabled)=>({ setState: setState })=>{
                setState({
                    isAiEnabled: isAiEnabled
                });
            },
        setOnAiInteractionDismissed: (onAiInteractionDismissed)=>({ setState: setState })=>{
                setState({
                    onAiInteractionDismissed: onAiInteractionDismissed
                });
            },
        setOnJsError: (onJsError)=>({ setState: setState })=>{
                setState({
                    onJsError: onJsError
                });
            },
        exitNaturalLanguageMode: ()=>({ getState: getState })=>{
                getState().exitNaturalLanguageMode?.();
            },
        setExitNaturalLanguageMode: (exitNaturalLanguageMode)=>({ setState: setState })=>{
                setState({
                    exitNaturalLanguageMode: exitNaturalLanguageMode
                });
            },
        setJqlErrors: (jqlErrors)=>({ setState: setState })=>setState({
                    jqlErrors: jqlErrors
                }),
        setErrorComponentValidationId: (errorComponentValidationId)=>({ setState: setState })=>setState({
                    errorComponentValidationId: errorComponentValidationId
                }),
        setErrorComponentTestId: (errorComponentValidationId)=>({ setState: setState })=>setState({
                    errorComponentValidationId: errorComponentValidationId
                }),
        setIsReadyForProactive: (isReadyForProactive)=>({ setState: setState })=>{
                setState({
                    isReadyForProactive: isReadyForProactive
                });
            }
    }
});
const $225b1cd3961a99bb$export$661ee98a2d30a450 = (0, $iJq0l.createActionsHook)($225b1cd3961a99bb$var$Store);
const $225b1cd3961a99bb$export$544efe5ac05fc17 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store);
const $225b1cd3961a99bb$export$e4c2322c66a3dea5 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.status
});
const $225b1cd3961a99bb$export$d959fd60596bfa67 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.jqlErrors
});
const $225b1cd3961a99bb$export$ba3a4678e5df092c = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.onSearch
});
const $225b1cd3961a99bb$export$ec027c329b94fe67 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.jqlQuery
});
const $225b1cd3961a99bb$export$742ce7b41314d513 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.isAiEnabled
});
const $225b1cd3961a99bb$export$afd1b99522ddeae9 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.errorComponentTestId
});
const $225b1cd3961a99bb$export$9c84149290836e7 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.errorComponentValidationId
});
const $225b1cd3961a99bb$export$1da2ac60b06e42d1 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.isReadyForProactive && state.issueNavigatorSearchMode !== 'NL2JQL'
});
const $225b1cd3961a99bb$export$a416100e9df4f9b1 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.syntaxCorrectionAttemptErrors
});

});

parcelRegister("13f5n", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_JQL_DEBUGGER", () => $4d08bf51bcedf53e$export$efcb4634ee5c0cb9);
$parcel$export(module.exports, "TEAM_NAME", () => $4d08bf51bcedf53e$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ERROR_BOUNDARY_IDS", () => $4d08bf51bcedf53e$export$2d2d5df8a192a41a);
$parcel$export(module.exports, "CLOSED_AI_MODAL_ABORT_REASON_MESSAGE", () => $4d08bf51bcedf53e$export$8714ae84b437fe97);
$parcel$export(module.exports, "CLOSED_AI_MODAL_ABORT_REASON_NAME", () => $4d08bf51bcedf53e$export$1e71032fcb7b8730);
$parcel$export(module.exports, "JS_ERROR_ABORT_REASON_NAME", () => $4d08bf51bcedf53e$export$64c672172b01336);
$parcel$export(module.exports, "AI_RESULT_ERROR_CATEGORIES", () => $4d08bf51bcedf53e$export$ad3b2223714b1ed9);
const $4d08bf51bcedf53e$export$efcb4634ee5c0cb9 = 'jira-jql-debugger';
const $4d08bf51bcedf53e$export$d57b6b390e78d90f = 'jira-ai-gravity';
const $4d08bf51bcedf53e$export$2d2d5df8a192a41a = {
    TRIGGER_BUTTON: 'jira-jql-debugger-trigger-button',
    FIX_WITH_AI_MODAL: 'jira-jql-debugger-fix-with-ai-modal',
    COMMON_ENTRY_JQL_BUILDER: 'jira-jql-debugger-common-entry-jql-builder',
    COMMON_ENTRY_ISSUE_VIEW: 'jira-jql-debugger-common-entry-issue-view'
};
const $4d08bf51bcedf53e$export$8714ae84b437fe97 = 'AI Modal was closed before the fetch completed';
const $4d08bf51bcedf53e$export$1e71032fcb7b8730 = 'AI_MODAL_CLOSED';
const $4d08bf51bcedf53e$export$64c672172b01336 = 'JS_ERROR';
const $4d08bf51bcedf53e$export$ad3b2223714b1ed9 = {
    FIXED_JQL_HAS_ERRORS: 'fixed-jql-has-errors',
    SERVER_ERROR: 'server-error'
};

});

parcelRegister("kbhn6", function(module, exports) {

$parcel$export(module.exports, "JQLPanelRenderSlotForJQLEditor", () => $30ee3d17c3a559f0$export$79179285687e80ca);
$parcel$export(module.exports, "JQLPanelRenderSlotForIssueView", () => $30ee3d17c3a559f0$export$1efeb13e93a829bf);

var $eJOHy = parcelRequire("eJOHy");

var $1DXK0 = parcelRequire("1DXK0");

var $880Uc = parcelRequire("880Uc");

var $fUDzs = parcelRequire("fUDzs");

var $1KdDN = parcelRequire("1KdDN");

var $bUnif = parcelRequire("bUnif");

var $lfAG2 = parcelRequire("lfAG2");

var $k0Jpn = parcelRequire("k0Jpn");

var $13f5n = parcelRequire("13f5n");

var $lg8UF = parcelRequire("lg8UF");
function $30ee3d17c3a559f0$var$JqlDebuggerLayoutSwitcher(props) {
    const layoutQuery = props.fullWidthLayout ? 'below.lg' : 'above.lg';
    const showProp = (0, $eJOHy.useMemo)(()=>props.fullWidthLayout ? {
            below: 'lg'
        } : {
            above: 'lg'
        }, [
        props.fullWidthLayout
    ]);
    const [matches, setMatches] = (0, $eJOHy.useState)(null);
    const mq = (0, $fUDzs.UNSAFE_useMediaQuery)(layoutQuery, (e)=>{
        setMatches(e.matches);
    });
    return matches ?? mq?.matches ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $880Uc.Show), {
        ...showProp,
        xcss: props.xcss ? [
            $30ee3d17c3a559f0$var$showContainerStyles,
            props.xcss
        ] : $30ee3d17c3a559f0$var$showContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k0Jpn.JQLDebuggerCommonEntry), null)) : null;
}
const $30ee3d17c3a559f0$export$793a24421ebe4e74 = (props)=>{
    const { errorMessages: errorMessages, testId: testId, validationId: validationId } = props;
    const jqlDebuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const [isReady] = (0, $lfAG2.useIsContextReady)();
    const renderSyncActions = (0, $lfAG2.useRenderSynchronizerStoreActions)();
    const [isAiEnabled] = (0, $bUnif.useIsAiEnabled)();
    const [status] = (0, $bUnif.useDebuggerStatus)();
    /**
	 * When the JQL Editor unmounts for whatever reason, we want to mark jql editor as not ready
	 * So that JQLPanelRenderSlotForIssueView doesn't try to accidentally render any error messages
	 *
	 * For example, this happens when we enter NL-to-JQL AI mode while the regular JQL editor has an error
	 */ (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            renderSyncActions.setJqlEditorReady(false);
        };
    }, [
        renderSyncActions
    ]);
    if (!errorMessages?.length || !isReady || !isAiEnabled || status === 'UNRECOVERABLE_ERROR') {
        renderSyncActions.setJqlEditorReady(false);
        return props.children;
    }
    jqlDebuggerStoreActions.setJqlErrors(errorMessages.map((0, $lg8UF.extractTextFromReactElement)));
    jqlDebuggerStoreActions.setErrorComponentTestId(testId);
    jqlDebuggerStoreActions.setErrorComponentValidationId(validationId);
    renderSyncActions.setJqlEditorReady(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($30ee3d17c3a559f0$var$JqlDebuggerLayoutSwitcher, {
        fullWidthLayout: false,
        xcss: $30ee3d17c3a559f0$var$jqlBuilderContainerStyles
    });
};
const $30ee3d17c3a559f0$export$79179285687e80ca = (props)=>{
    const { children: children } = props;
    const ChildrenFallback = (0, $eJOHy.useCallback)(()=>children, [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).COMMON_ENTRY_JQL_BUILDER,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: ChildrenFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($30ee3d17c3a559f0$export$793a24421ebe4e74, props));
};
const $30ee3d17c3a559f0$export$1efeb13e93a829bf = ()=>{
    const [isReady] = (0, $lfAG2.useIsContextReady)();
    const [isJqlEditorReady] = (0, $lfAG2.useIsJqlEditorReady)();
    const storeActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    if (!isReady || !isJqlEditorReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).COMMON_ENTRY_ISSUE_VIEW,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: ()=>null,
        onError: ()=>{
            storeActions.setStatus('UNRECOVERABLE_ERROR');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($30ee3d17c3a559f0$var$JqlDebuggerLayoutSwitcher, {
        fullWidthLayout: true,
        xcss: $30ee3d17c3a559f0$var$issueViewContainerStyles
    }));
};
const $30ee3d17c3a559f0$var$jqlBuilderContainerStyles = (0, $1DXK0.xcss)({
    // When we are rendering in JQL builder, we want to add the space between the editor and panel
    // This space is already present in the issue view
    marginTop: 'space.100'
});
const $30ee3d17c3a559f0$var$issueViewContainerStyles = (0, $1DXK0.xcss)({
    // When we are rendering in JQL builder, we want to add the space between the editor and panel
    // This space is already present in the issue view
    marginTop: 'space.negative.100'
});
const $30ee3d17c3a559f0$var$showContainerStyles = (0, $1DXK0.xcss)({
    width: '100%',
    marginBottom: 'space.100'
});

});
parcelRegister("880Uc", function(module, exports) {

$parcel$export(module.exports, "Show", () => $f800bab042621a59$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $1DXK0 = parcelRequire("1DXK0");

var $j14qM = parcelRequire("j14qM");
function $f800bab042621a59$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f800bab042621a59$var$showAboveQueries = (0, $j14qM.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $f800bab042621a59$var$showBelowQueries = (0, $j14qM.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $f800bab042621a59$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $f800bab042621a59$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1DXK0.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $1NIU8.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $f800bab042621a59$var$defaultHiddenStyles,
            above && $f800bab042621a59$var$showAboveQueries[above],
            below && $f800bab042621a59$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};

});
parcelRegister("j14qM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $58139abb853d4481$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $58139abb853d4481$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $fvncH = parcelRequire("fvncH");

var $6efFi = parcelRequire("6efFi");
const $58139abb853d4481$export$918f8818cfbbeb2c = (input)=>{
    return (0, $fvncH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $6efFi.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $58139abb853d4481$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $fvncH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $6efFi.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("fvncH", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $5a3422a08c082ecc$export$2d293d9871c38e91);
const $5a3422a08c082ecc$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $5a3422a08c082ecc$export$2d293d9871c38e91 = Object.keys($5a3422a08c082ecc$export$e5ee4fe8b989fd09);
const $5a3422a08c082ecc$export$b7ed752a57b4177b = $5a3422a08c082ecc$export$2d293d9871c38e91[0];

});



parcelRegister("lfAG2", function(module, exports) {

$parcel$export(module.exports, "useRenderSynchronizerStoreActions", () => $7b22efe6dcaae164$export$60f8cec0dff6824c);
$parcel$export(module.exports, "useIsContextReady", () => $7b22efe6dcaae164$export$7668b8e8d8c22896);
$parcel$export(module.exports, "useIsJqlEditorReady", () => $7b22efe6dcaae164$export$7f34a2b12380537d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $7b22efe6dcaae164$var$initialState = {
    isContextReady: false,
    isJqlEditorReady: false
};
const $7b22efe6dcaae164$var$Store = (0, $GtRbT.createStore)({
    initialState: $7b22efe6dcaae164$var$initialState,
    actions: {
        setIsContextReady: (isContextReady)=>({ setState: setState })=>{
                setState({
                    isContextReady: isContextReady
                });
            },
        setJqlEditorReady: (isJqlEditorReady)=>({ setState: setState })=>{
                setState({
                    isJqlEditorReady: isJqlEditorReady
                });
            }
    }
});
const $7b22efe6dcaae164$export$60f8cec0dff6824c = (0, $iJq0l.createActionsHook)($7b22efe6dcaae164$var$Store);
const $7b22efe6dcaae164$export$7668b8e8d8c22896 = (0, $iJq0l.createHook)($7b22efe6dcaae164$var$Store, {
    selector: (state)=>state.isContextReady
});
const $7b22efe6dcaae164$export$7f34a2b12380537d = (0, $iJq0l.createHook)($7b22efe6dcaae164$var$Store, {
    selector: (state)=>state.isJqlEditorReady
});

});

parcelRegister("k0Jpn", function(module, exports) {

$parcel$export(module.exports, "JQLDebuggerCommonEntry", () => $182505dbe4321118$export$61b6653f41aa971b);

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $9skjA = parcelRequire("9skjA");

var $bbdV2 = parcelRequire("bbdV2");

var $cBavF = parcelRequire("cBavF");

var $ftN6c = parcelRequire("ftN6c");

var $epTsa = parcelRequire("epTsa");

var $bUnif = parcelRequire("bUnif");

var $bqGal = parcelRequire("bqGal");

var $iNmbB = parcelRequire("iNmbB");

var $13f5n = parcelRequire("13f5n");

var $awW5u = parcelRequire("awW5u");
function $182505dbe4321118$var$OnError() {
    const debuggerActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    (0, $eJOHy.useEffect)(()=>{
        // On error, set the feature state to be JS_ERROR, so that such scenarios can be handled without
        // interfering with the feature initial state nor with the AI event instrumentation
        debuggerActions.setStatus('JS_ERROR');
    }, [
        debuggerActions
    ]);
    return null;
}
const $182505dbe4321118$export$61b6653f41aa971b = ()=>{
    const [status] = (0, $bUnif.useDebuggerStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const debuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const [query] = (0, $bUnif.useJqlQuery)();
    const [jqlErrors] = (0, $bUnif.useJqlErrors)();
    const [onSearch] = (0, $bUnif.useJqlEditorOnSearch)();
    const [isReadyForProactive] = (0, $bUnif.useIsReadyForProactive)();
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $bbdV2.useEntryPoint)((0, $iNmbB.SuggestedFixContentEntrypoint), {});
    // For the proactive experience, we call the API through a useEffect for each applicable render
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) {
            if (status === 'INIT') {
                if (!isReadyForProactive) (0, $awW5u.preloadApiCall)(query, jqlErrors);
                else (0, $awW5u.onClick)({
                    testId: 'jql-debugger-common-entry',
                    createAnalyticsEvent: createAnalyticsEvent,
                    debuggerStoreActions: debuggerStoreActions,
                    query: query,
                    jqlErrors: jqlErrors,
                    onSearch: onSearch,
                    isReadyForProactive: isReadyForProactive
                });
            }
        }
    }, [
        isReadyForProactive,
        status,
        createAnalyticsEvent,
        debuggerStoreActions,
        jqlErrors,
        onSearch,
        query
    ]);
    /*
		We load the entrypoint conditionally here as the JQL debugger panel is rendered underneath the JQL builder for large screen sizes,
		and across the issue view for smaller screen sizes - their visibilty is controlled by a <Show>, but they are two separately
		rendered components. As a result, if we are switching from one screen size or issue view to another, the newly rendered version of the
		JQL debugger will not have a loaded entry point, so we load it here to ensure the content is still visible across different views.

		Example of behaviour without this conditional:
		https://www.loom.com/share/725438e2ea16481591bbe510815e9ca3?sid=b3dc286e-9c37-4cf9-a2c9-f55d3561a166
	*/ if (status !== 'INIT') entryPointActions?.load();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9skjA.default), {
        spacing: "none",
        hasNewBorderExperience: true,
        shouldFitContainer: true,
        isLoading: status === 'LOADING_RESULT'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        padding: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bqGal.ErrorSection), {
        entryPointActions: entryPointActions
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {},
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).FIX_WITH_AI_MODAL,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: null,
        errorFallback: $182505dbe4321118$var$OnError
    }));
};

});
parcelRegister("9skjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c22c6f11d6c3191$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $58yRG = parcelRequire("58yRG");

var $dPMMf = parcelRequire("dPMMf");

var $7jTnu = parcelRequire("7jTnu");
let $7c22c6f11d6c3191$var$namespaceUUID = 0;
const $7c22c6f11d6c3191$var$newPalette = {
    dark: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    },
    light: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    }
};
const $7c22c6f11d6c3191$var$AFTER_LOAD_DURATION = 3000;
const $7c22c6f11d6c3191$var$AnimatedSvgContainer = ({ isLoading: isLoading, isBlurred: isBlurred, isShadow: isShadow, isBorderGrey: isBorderGrey, hasNewBorderExperience: hasNewBorderExperience, components: { SvgComponent: SvgComponent = $7c22c6f11d6c3191$var$SvgContainer } = {} })=>{
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const svgRef = (0, $eJOHy.useRef)(null);
    const namespaceId = (0, $eJOHy.useRef)();
    const [showRainbowBorder, setShowRainbowBorder] = (0, $eJOHy.useState)(false);
    const paletteForTheme = colorMode === 'dark' ? $7c22c6f11d6c3191$var$newPalette.dark : $7c22c6f11d6c3191$var$newPalette.light;
    if (namespaceId.current === undefined) {
        namespaceId.current = $7c22c6f11d6c3191$var$namespaceUUID;
        // eslint-disable-next-line react-hooks/react-compiler
        $7c22c6f11d6c3191$var$namespaceUUID += 1;
    }
    (0, $eJOHy.useEffect)(()=>{
        if (isLoading) {
            const svg = svgRef.current;
            hasNewBorderExperience && setShowRainbowBorder(true); // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isLoading,
        hasNewBorderExperience
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // we keep the rainbow border without animations for at 3 seconds after load. After that we show the grey border
        if (hasNewBorderExperience && !isLoading && showRainbowBorder) {
            const timeoutId = setTimeout(()=>setShowRainbowBorder(false), $7c22c6f11d6c3191$var$AFTER_LOAD_DURATION);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        hasNewBorderExperience,
        showRainbowBorder,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SvgComponent, {
        isBlurred: isBlurred,
        isShadow: isShadow,
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), isBorderGrey || hasNewBorderExperience && !showRainbowBorder && !isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M0 0h24v24H0Z",
        vectorEffect: "non-scaling-stroke",
        fill: (0, $7jTnu.fg)('jira_jif_jam_ai_container_ui_fix') ? 'none' : undefined
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    }))));
};
const $7c22c6f11d6c3191$var$AIContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isLoading: isLoading, isShadow: isShadow = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', testId: testId, isBorderGrey: isBorderGrey, components: { ContainerComponent: ContainerComponent = $7c22c6f11d6c3191$var$Container, ContentComponent: ContentComponent = $7c22c6f11d6c3191$var$Content, SvgComponent: SvgComponent = $7c22c6f11d6c3191$var$SvgContainer } = {}, hasNewBorderExperience: hasNewBorderExperience = false, borderless: borderless = false, zIndex: zIndex = (0, $dPMMf.layers).card }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContainerComponent, {
        "data-testid": testId,
        testId: testId,
        shouldFitContainer: shouldFitContainer,
        zIndex: zIndex
    }, (!(0, $7jTnu.fg)('similar_items_in_gic_ui_fixes') || !borderless) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c22c6f11d6c3191$var$AnimatedSvgContainer, {
        isShadow: isShadow,
        isLoading: isLoading,
        isBorderGrey: isBorderGrey,
        hasNewBorderExperience: hasNewBorderExperience,
        components: {
            SvgComponent: SvgComponent
        }
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c22c6f11d6c3191$var$AnimatedSvgContainer, {
        isLoading: isLoading,
        isBlurred: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContentComponent, {
        ref: ref,
        spacing: spacing
    }, children));
});
var $7c22c6f11d6c3191$export$2e2bcd8739ae039 = $7c22c6f11d6c3191$var$AIContainer;
$7c22c6f11d6c3191$var$AIContainer.displayName = 'AIContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainer: shouldFitContainer, zIndex: zIndex, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w1vr8s": (0, $awdRS.default)(__cmplp.zIndex || (0, $dPMMf.layers).card)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1pbypt6a",
            __cmplp.shouldFitContainer ? "_1bsb1wug" : "_1bsb1ns9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w1vr8s": (0, $awdRS.default)(__cmplp.zIndex || (0, $dPMMf.layers).card)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoi2wt _bfhkvuon _16jlkb7n _1pbypt6a _1bsb1osq",
            __cmplp.spacing === 'default' && "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$SvgContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isShadow: isShadow, isBlurred: isBlurred, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoftgi _kqswstnw",
            __cmplp.isShadow ? "_16qs9g9j" : "_16qsglyw",
            __cmplp.isBlurred ? "_1bsb5cnj _4t3i5cnj _154iu2gc _1ltvu2gc _kdam7b89" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7c22c6f11d6c3191$export$71abc632aa29e6fe = {
    ContainerComponent: $7c22c6f11d6c3191$var$Container,
    ContentComponent: $7c22c6f11d6c3191$var$Content,
    SvgComponent: $7c22c6f11d6c3191$var$SvgContainer
};

});

parcelRegister("bqGal", function(module, exports) {

$parcel$export(module.exports, "ErrorSection", () => $a9f0cd966e577c81$export$b0bceea2ea86179a);

var $eJOHy = parcelRequire("eJOHy");

var $6zhpo = parcelRequire("6zhpo");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $80DPg = parcelRequire("80DPg");

var $jdqdp = parcelRequire("jdqdp");

var $Ay1uj = parcelRequire("Ay1uj");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $9n5mq = parcelRequire("9n5mq");

var $f6eza = parcelRequire("f6eza");

var $bUnif = parcelRequire("bUnif");

var $kCNym = parcelRequire("kCNym");

var $fHqkT = parcelRequire("fHqkT");
function $a9f0cd966e577c81$export$b0bceea2ea86179a(props) {
    const { entryPointActions: entryPointActions } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [query] = (0, $bUnif.useJqlQuery)();
    const [status] = (0, $bUnif.useDebuggerStatus)();
    const [jqlErrors] = (0, $bUnif.useJqlErrors)();
    const [onSearch] = (0, $bUnif.useJqlEditorOnSearch)();
    const [errorComponentTestId] = (0, $bUnif.useErrorComponentTestId)();
    const [errorComponentValidationId] = (0, $bUnif.useErrorComponentValidationId)();
    const jqlDebuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const [{ syntaxCorrectionAttemptErrors: syntaxCorrectionAttemptErrors, singleInstrumentationID: singleInstrumentationID }] = (0, $bUnif.useStoreData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isReadyForProactive] = (0, $bUnif.useIsReadyForProactive)();
    const showDiscardButton = status === 'VIEW_RESULT' || status === 'RESULT_ERROR';
    // The Fix error button should be shown when:
    // The user has not invoked any action to make the experience ready for proactive, or
    // the user returns from dismissing a proactive AI result
    const showFixErrorButton = status === 'RESULT_DISCARDED' || status === 'INIT' && !isReadyForProactive;
    const onDiscardClick = ()=>{
        // The close button can be clicked from either a succesful result view, or an error view (server error or JQL couldn't be corrected)
        const closedFromSource = status === 'RESULT_ERROR' || status === 'VIEW_RESULT' && syntaxCorrectionAttemptErrors.length > 0 ? 'error_view' : 'result_view';
        // Fire `aiResult discarded` event when the close button is clicked in a successful result view
        // https://atlassian.slack.com/archives/C07B7SJR0CT/p1744736278862629?thread_ts=1744328109.644489&cid=C07B7SJR0CT
        if (status === 'VIEW_RESULT' && syntaxCorrectionAttemptErrors.length === 0) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult discarded', {
            ...(0, $9n5mq.getAiAttributes)({
                singleInstrumentationID: singleInstrumentationID,
                ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                    isReadyForProactive: isReadyForProactive
                } : {}
            })
        });
        // Fire an event for the close button being clicked in all cases
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'closeButton clicked', 'jqlDebugger', {
            closedFromSource: closedFromSource
        });
        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) jqlDebuggerStoreActions.setStatus('RESULT_DISCARDED');
        else jqlDebuggerStoreActions.setStatus('INIT');
    };
    if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.200",
        xcss: $a9f0cd966e577c81$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "start",
        spread: "space-between",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "h5",
        xcss: $a9f0cd966e577c81$var$jqlErrorHeadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        color: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        weight: "bold"
    }, formatMessage(jqlErrors?.length > 1 ? (0, $fHqkT.default).jqlDebuggerHeadingPluralNonFinal : (0, $fHqkT.default).jqlDebuggerHeadingNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: errorComponentTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "alert",
        id: errorComponentValidationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "ul",
        xcss: $a9f0cd966e577c81$var$errorBoxStyles,
        testId: "jql-debugger.ui.error-section.error-list"
    }, jqlErrors.map((error)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "li",
            key: error,
            xcss: $a9f0cd966e577c81$var$listItemStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            color: "color.text.accent.red"
        }, error))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button') ? $a9f0cd966e577c81$var$headerEndStylesWithCross : $a9f0cd966e577c81$var$headerEndStyles
    }, status === 'VIEW_RESULT' && !(0, $7jTnu.fg)('gravityai-3165-jql-fixer-ga') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $fHqkT.default).betaLozenge)) : null, showFixErrorButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f6eza.FixErrorButton), {
        testId: "jql-debugger.ui.error-section.trigger-button",
        jqlErrors: jqlErrors,
        onSearch: onSearch,
        query: query,
        entryPointActions: entryPointActions
    }), (0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button') ? showDiscardButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        testId: "jql-debugger.ui.error-section.close-button",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $fHqkT.default).discardSuggestionNonFinal),
        onClick: onDiscardClick,
        isTooltipDisabled: false
    }) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.200",
        xcss: $a9f0cd966e577c81$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "start",
        spread: "space-between",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "h5",
        xcss: $a9f0cd966e577c81$var$jqlErrorHeadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        color: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        weight: "bold"
    }, formatMessage(jqlErrors?.length > 1 ? (0, $fHqkT.default).jqlDebuggerHeadingPluralNonFinal : (0, $fHqkT.default).jqlDebuggerHeadingNonFinal))), status === 'LOADING_RESULT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kCNym.GeneratingAnimation), {
        alt: formatMessage((0, $fHqkT.default).jqlDebuggerLoadingNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, formatMessage((0, $fHqkT.default).jqlDebuggerLoadingNonFinal))) : // The wrappers around the ul element try to closely resemble the same structure as the default error message in the platform package
    // See: platform/packages/jql/jql-editor/src/ui/jql-editor-footer-content/jql-messages/errors/index.tsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: errorComponentTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "alert",
        id: errorComponentValidationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "ul",
        xcss: $a9f0cd966e577c81$var$errorBoxStyles,
        testId: "jql-debugger.ui.error-section.error-list"
    }, jqlErrors.map((error)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "li",
            key: error,
            xcss: $a9f0cd966e577c81$var$listItemStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            color: "color.text.accent.red"
        }, error))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button') ? $a9f0cd966e577c81$var$headerEndStylesWithCross : $a9f0cd966e577c81$var$headerEndStyles
    }, status === 'VIEW_RESULT' && !(0, $7jTnu.fg)('gravityai-3165-jql-fixer-ga') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $fHqkT.default).betaLozenge)) : null, status === 'INIT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f6eza.FixErrorButton), {
        testId: "jql-debugger.ui.error-section.trigger-button",
        jqlErrors: jqlErrors,
        onSearch: onSearch,
        query: query,
        entryPointActions: entryPointActions
    }), (0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button') ? showDiscardButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        testId: "jql-debugger.ui.error-section.close-button",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $fHqkT.default).discardSuggestionNonFinal),
        onClick: onDiscardClick,
        isTooltipDisabled: false
    }) : null));
}
const $a9f0cd966e577c81$var$containerStyles = (0, $1DXK0.xcss)({
    minHeight: "var(--ds-space-400, 32px)"
});
const $a9f0cd966e577c81$var$errorBoxStyles = (0, $1DXK0.xcss)({
    flex: 1,
    marginBlockStart: '0',
    paddingInlineStart: 'space.025'
});
const $a9f0cd966e577c81$var$headerEndStyles = (0, $1DXK0.xcss)({
    alignSelf: 'flex-start'
});
const $a9f0cd966e577c81$var$headerEndStylesWithCross = (0, $1DXK0.xcss)({
    alignSelf: 'flex-start',
    display: 'flex',
    gap: 'space.075',
    alignItems: 'center'
});
const $a9f0cd966e577c81$var$listItemStyle = (0, $1DXK0.xcss)({
    listStyle: 'none'
});
const $a9f0cd966e577c81$var$jqlErrorHeadingStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    gap: 'space.075'
});

});
parcelRegister("9n5mq", function(module, exports) {

$parcel$export(module.exports, "getAiAttributes", () => $93c2edddc4531c15$export$1dc69577c8d8f632);
function $93c2edddc4531c15$export$1dc69577c8d8f632({ singleInstrumentationID: singleInstrumentationID, isReadyForProactive: isReadyForProactive = false }) {
    const userGeneratedAI = isReadyForProactive ? 0 : 1;
    const proactiveAIGenerated = isReadyForProactive ? 1 : 0;
    return {
        aiFeatureName: 'JQL_Debugger',
        userGeneratedAI: userGeneratedAI,
        proactiveAIGenerated: proactiveAIGenerated,
        isAIFeature: 1,
        singleInstrumentationID: singleInstrumentationID
    };
}

});

parcelRegister("f6eza", function(module, exports) {

$parcel$export(module.exports, "FixErrorButton", () => $048c101372748c1a$export$94f98890cd333316);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $gn1zL = parcelRequire("gn1zL");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $bUnif = parcelRequire("bUnif");

var $29xoF = parcelRequire("29xoF");

function $048c101372748c1a$var$useImportOnClickHandler() {
    const importer = (0, $eJOHy.useCallback)(()=>{
        return Promise.resolve((parcelRequire("awW5u")));
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        importer();
    }, [
        importer
    ]);
    return importer;
}
function $048c101372748c1a$export$94f98890cd333316(props) {
    const { testId: testId, jqlErrors: jqlErrors, onSearch: onSearch, query: query, entryPointActions: entryPointActions } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const debuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const importer = $048c101372748c1a$var$useImportOnClickHandler();
    const [isReadyForProactive] = (0, $bUnif.useIsReadyForProactive)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fixWithAiButton viewed', {
            debuggerPanel: true
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gn1zL))),
        onMouseOver: ()=>{
            entryPointActions?.preload();
        },
        testId: "jql-debugger.ui.fix-error-button.button",
        onClick: async ()=>{
            entryPointActions?.load();
            const { onClick: onClick } = await importer();
            onClick({
                testId: testId,
                query: query || '',
                jqlErrors: jqlErrors,
                onSearch: onSearch,
                createAnalyticsEvent: createAnalyticsEvent,
                debuggerStoreActions: debuggerStoreActions,
                isReadyForProactive: isReadyForProactive
            });
        }
    }, formatMessage((0, $29xoF.default).fixErrorWithAiNonFinal));
}

});
parcelRegister("29xoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fbc607cb38fb1a6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4fbc607cb38fb1a6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    fixErrorWithAiNonFinal: {
        "id": "jql-debugger.trigger-button.fix-error-with-ai-non-final",
        "defaultMessage": "Fix error"
    },
    jsErrorNonFinal: {
        "id": "jql-debugger.trigger-button.js-error-non-final",
        "defaultMessage": "Something went wrong"
    },
    errorIconLabelNonFinal: {
        "id": "jql-debugger.trigger-button.error-icon-label-non-final",
        "defaultMessage": "Error Icon"
    }
});

});

parcelRegister("awW5u", function(module, exports) {

$parcel$export(module.exports, "endpoint", () => $bfd85cc389cc53db$export$125e2b775860041f);
$parcel$export(module.exports, "apiCache", () => $bfd85cc389cc53db$export$fd9779c86130d7b0);
$parcel$export(module.exports, "preloadApiCall", () => $bfd85cc389cc53db$export$2797ffd2e0fc155);
$parcel$export(module.exports, "onClick", () => $bfd85cc389cc53db$export$1d5a917feb871989);

var $aXKmr = parcelRequire("aXKmr");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $9n5mq = parcelRequire("9n5mq");

var $13f5n = parcelRequire("13f5n");

var $gPSc4 = parcelRequire("gPSc4");

var $gJUBb = parcelRequire("gJUBb");
const $bfd85cc389cc53db$export$125e2b775860041f = (0, $gPSc4.createConvoAiEndpoint)({
    url: '/gateway/api/assist/api/v1/plugin/execute',
    method: 'POST',
    experienceId: 'jira-nl-to-jql-errors',
    product: 'jira'
});
const $bfd85cc389cc53db$export$fd9779c86130d7b0 = (0, $gJUBb.LruCache)();
const $bfd85cc389cc53db$export$2797ffd2e0fc155 = (query, jqlErrors, abortController = new AbortController())=>{
    const promise = $bfd85cc389cc53db$export$fd9779c86130d7b0.get(query)?.value || $bfd85cc389cc53db$export$125e2b775860041f({
        name: 'jirajqldebug',
        schema: {
            type: 'jirajqldebug',
            userQuery: query,
            userQueryError: jqlErrors?.join('. \n') || ''
        }
    }, {
        abortControllerSignal: abortController.signal
    });
    $bfd85cc389cc53db$export$fd9779c86130d7b0.set(query, promise);
    return promise;
};
async function $bfd85cc389cc53db$export$1d5a917feb871989({ testId: testId, createAnalyticsEvent: createAnalyticsEvent, query: query, debuggerStoreActions: debuggerStoreActions, jqlErrors: jqlErrors, onSearch: onSearch, isReadyForProactive: isReadyForProactive = false }) {
    const singleInstrumentationID = (0, $aXKmr.v4)();
    try {
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction initiated', (0, $9n5mq.getAiAttributes)({
            singleInstrumentationID: singleInstrumentationID,
            ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                isReadyForProactive: isReadyForProactive
            } : {}
        }));
        const abortController = new AbortController();
        // When we trigger the JQL Debugger within NL-to-JQL, we want to exit the natural language mode
        // This is because two AI features cannot be nested within each other
        // Attempting to show two AI features at once also interferes with non functional aspects such as loading states, analytics and feedback collector
        debuggerStoreActions.exitNaturalLanguageMode();
        debuggerStoreActions.setStateOnFeatureInvoke({
            jqlQuery: query,
            singleInstrumentationID: singleInstrumentationID,
            errorSectionTestId: testId
        });
        // Register callback to be called when there is a javascript error
        // Currently all it does is aborting any pending API calls
        debuggerStoreActions.setOnJsError(()=>{
            abortController?.abort(new DOMException((0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_MESSAGE), (0, $13f5n.JS_ERROR_ABORT_REASON_NAME)));
        });
        // Register callback to be used when the AI modal is dismissed
        debuggerStoreActions.setOnAiInteractionDismissed((dismissReason, status)=>{
            // Abort any pending API calls
            abortController?.abort(new DOMException((0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_MESSAGE), (0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_NAME)));
            if ((0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button')) {
                // When a successful result is shown, the AI result is discarded, not dismissed by definition on
                // single instrumentation docs: https://hello.atlassian.net/wiki/x/gqTA4
                if (status === 'VIEW_RESULT') (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult discarded', {
                    ...(0, $9n5mq.getAiAttributes)({
                        singleInstrumentationID: singleInstrumentationID,
                        ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                            isReadyForProactive: isReadyForProactive
                        } : {}
                    })
                });
                else // Fire the singleInstrumentation event
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction dismissed', {
                    ...(0, $9n5mq.getAiAttributes)({
                        singleInstrumentationID: singleInstrumentationID,
                        ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                            isReadyForProactive: isReadyForProactive
                        } : {}
                    }),
                    dismissReason: dismissReason
                });
            } else // Fire the singleInstrumentation event
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction dismissed', {
                ...(0, $9n5mq.getAiAttributes)({
                    singleInstrumentationID: singleInstrumentationID,
                    ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                        isReadyForProactive: isReadyForProactive
                    } : {}
                }),
                dismissReason: dismissReason
            });
        });
        let response = null;
        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) {
            const promise = $bfd85cc389cc53db$export$2797ffd2e0fc155(query, jqlErrors, abortController);
            response = await promise;
        } else response = await $bfd85cc389cc53db$export$125e2b775860041f({
            name: 'jirajqldebug',
            schema: {
                type: 'jirajqldebug',
                userQuery: query,
                userQueryError: jqlErrors?.join('. \n') || ''
            }
        }, {
            abortControllerSignal: abortController?.signal
        });
        /**
		 * Set the API response data on the store, so that the data can be consumed by the JQLDebuggerRenderSlot
		 *
		 * This is because the trigger and the render slot are used in two different packages
		 *  - Trigger is rendered inside the JQL Builder
		 *  - Render slot is in Issue Navigator
		 *
		 * By keeping these two components loosely coupled, we can style them independent of each other
		 * Yet they are highly cohesive, so that one can be controlled by the other by updating data on the store
		 *
		 * This approach also allows us to minimise the javascript bundles loaded for each component in their specific circumstances
		 * For example, the render-slot chunk is not loaded until the users hover over the trigger button
		 * Similarly the trigger-button chunk is not loaded unless there are errors in the jql-editor
		 */ const syntaxCorrectionAttemptErrors = response?.metadata?.value?.errors || [];
        if (syntaxCorrectionAttemptErrors.length) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', {
            ...(0, $9n5mq.getAiAttributes)({
                singleInstrumentationID: singleInstrumentationID,
                ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                    isReadyForProactive: isReadyForProactive
                } : {}
            }),
            aiResultErrorCategory: (0, $13f5n.AI_RESULT_ERROR_CATEGORIES).FIXED_JQL_HAS_ERRORS
        });
        debuggerStoreActions.setJqlErorCorrectionData({
            userQueryError: jqlErrors || [],
            onSearch: onSearch || (()=>undefined),
            jqlDiffTokens: response?.metadata?.value?.diff || [],
            syntaxCorrectionAttemptErrors: syntaxCorrectionAttemptErrors
        });
    } catch (e) {
        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) $bfd85cc389cc53db$export$fd9779c86130d7b0.delete(query);
        const isNetworkCallAbort = e instanceof DOMException;
        (0, $gYnSx.default)({
            event: createAnalyticsEvent({}),
            meta: {
                id: 'JQL_Debugger',
                packageName: '@atlassian/jira-jql-debugger',
                teamName: 'gravity-ai'
            },
            attributes: {
                ...(0, $9n5mq.getAiAttributes)({
                    singleInstrumentationID: singleInstrumentationID,
                    ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                        isReadyForProactive: isReadyForProactive
                    } : {}
                }),
                isNetworkCallAbort: isNetworkCallAbort
            },
            error: e instanceof Error ? e : undefined,
            // When the network call is aborted due to dismissing the modal, then we don't want to send the error to Sentry as
            // it is not necessarily an error (e.g, a user could simply be searching for a different query)
            skipSentry: isNetworkCallAbort && e.name === (0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_NAME)
        });
        if (isNetworkCallAbort) {
            // When network call is aborted due to a javascript error, then don't change the feature state
            if (e.name === (0, $13f5n.JS_ERROR_ABORT_REASON_NAME)) return;
            // When network call is aborted due to dismissing the modal, then we reset the feature state to initial state
            if (e.name === (0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_NAME)) {
                debuggerStoreActions.resetStatus('NETWORK_CALL_ABORT');
                return;
            }
        }
        // Do not fire the unified ai anlytics event for aiResult error when the API call is aborted
        // i.e. the interaction was dismissed, but not necessarily resulted in an error
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', {
            ...(0, $9n5mq.getAiAttributes)({
                singleInstrumentationID: singleInstrumentationID,
                ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                    isReadyForProactive: isReadyForProactive
                } : {}
            }),
            aiResultErrorCategory: (0, $13f5n.AI_RESULT_ERROR_CATEGORIES).SERVER_ERROR
        });
        // Explicitly update the status to be RESULT_ERROR in the fallthrough case
        debuggerStoreActions.setStatus('RESULT_ERROR');
    }
}

});
parcelRegister("gPSc4", function(module, exports) {

$parcel$export(module.exports, "createConvoAiEndpoint", () => $78102f89db9e576c$export$f8ba6757167c2aba);
const $78102f89db9e576c$export$f8ba6757167c2aba = (initArgs)=>async (body, options)=>{
        const response = await fetch(initArgs.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': initArgs.product,
                'X-Experience-Id': initArgs.experienceId
            },
            body: JSON.stringify(body),
            signal: options.abortControllerSignal
        });
        if (!response.ok) throw new Error(`API call failed: ${response.status}`);
        const result = await response.json();
        return result;
    };

});

parcelRegister("gJUBb", function(module, exports) {

$parcel$export(module.exports, "LruCache", () => $3a4833cdaf1c1f06$export$ec63a4108685a0aa);
function $3a4833cdaf1c1f06$export$ec63a4108685a0aa(limit = 5) {
    const cache = new Map();
    return {
        get: (key)=>cache.get(key),
        set: (key, value)=>{
            cache.set(key, {
                lastAccessed: Date.now(),
                value: value
            });
            if (cache.size <= limit) return;
            // limit the cache size based on the oldest entry based on lastAccessed time
            let oldestKey = null;
            let oldestLastAccessed = null;
            for (const [key_, value_] of cache.entries())if (oldestLastAccessed === null || value_.lastAccessed < oldestLastAccessed) {
                oldestKey = key_;
                oldestLastAccessed = value_.lastAccessed;
            }
            if (oldestKey) cache.delete(oldestKey);
        },
        delete: (key)=>{
            cache.delete(key);
        },
        clear: ()=>{
            cache.clear();
        }
    };
}

});



parcelRegister("kCNym", function(module, exports) {

$parcel$export(module.exports, "GeneratingAnimation", () => $dc78dc961c2fbf63$export$483f53d5a0354a30);

var $eJOHy = parcelRequire("eJOHy");
const $dc78dc961c2fbf63$export$483f53d5a0354a30 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "20",
        viewBox: "0 2 24 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("title", null, props.alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));

});

parcelRegister("fHqkT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dfe1ae393dfab8a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0dfe1ae393dfab8a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    jqlDebuggerHeadingNonFinal: {
        "id": "jql-debugger-panel.header.text-non-final",
        "defaultMessage": "JQL error"
    },
    jqlDebuggerHeadingPluralNonFinal: {
        "id": "jql-debugger-panel.header.plural-text-non-final",
        "defaultMessage": "JQL errors"
    },
    jqlDebuggerLoadingNonFinal: {
        "id": "jql-debugger-panel.header.loading-non-final",
        "defaultMessage": "Generating query fixes"
    },
    betaLozenge: {
        "id": "jql-debugger-panel.header.beta-lozenge",
        "defaultMessage": "Beta"
    },
    discardSuggestionNonFinal: {
        "id": "jql-debugger-panel.error-section.discard-suggestion-non-final",
        "defaultMessage": "Discard and close"
    }
});

});


parcelRegister("iNmbB", function(module, exports) {

$parcel$export(module.exports, "SuggestedFixContentEntrypoint", () => $5a5654ca917f495c$export$9b2c3d0b37e41ae9);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $5a5654ca917f495c$export$9b2c3d0b37e41ae9 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("fA9m5")), {
        moduleId: "2d263a55",
        priority: "interaction"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("fA9m5", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("66nqw").then(()=>parcelRequire('d16oc'));

});



parcelRegister("lg8UF", function(module, exports) {

$parcel$export(module.exports, "extractTextFromReactElement", () => $91bb6ebc41ba1a5e$export$98ee087174ba8894);

var $eJOHy = parcelRequire("eJOHy");
function $91bb6ebc41ba1a5e$export$98ee087174ba8894(element) {
    let result = '';
    function traverse(node) {
        if (typeof node === 'string' || typeof node === 'number') result += node.toString();
        else if (/*#__PURE__*/ (0, $eJOHy.isValidElement)(node)) (0, $eJOHy.Children).forEach(node.props.children, (child)=>{
            traverse(child);
        });
    }
    traverse(element);
    return result;
}

});


parcelRegister("iPjZi", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("dYjcw").then(()=>parcelRequire('rBzAY'));

});


parcelRegister("3TtKq", function(module, exports) {

$parcel$export(module.exports, "IssueTableSelectedIssuesContainer", () => $8531abba95832313$export$b11112517798dbed);
$parcel$export(module.exports, "useIssueTableSelectedIssuesActions", () => $8531abba95832313$export$b4602482fdfd31ed);
$parcel$export(module.exports, "useIssueTableSelectedIssues", () => $8531abba95832313$export$ad5f97924b14314b);
$parcel$export(module.exports, "useIsIssueSelected", () => $8531abba95832313$export$cfefd69fc8a5ac52);
$parcel$export(module.exports, "useAreAllIssuesSelected", () => $8531abba95832313$export$949e47631f4a60a5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $1hqwo = parcelRequire("1hqwo");
const $8531abba95832313$export$b11112517798dbed = (0, $6E16M.createContainer)();
const $8531abba95832313$var$Store = (0, $GtRbT.createStore)({
    initialState: $1hqwo.initialState,
    actions: $1hqwo.actions,
    name: 'jira-native-issue-table-selected-issues-state',
    containedBy: $8531abba95832313$export$b11112517798dbed
});
const $8531abba95832313$export$b4602482fdfd31ed = (0, $iJq0l.createActionsHook)($8531abba95832313$var$Store);
const $8531abba95832313$var$getSelectedIssueIdsSelector = (state)=>{
    return Array.from(state.selectedIssueIds);
};
const $8531abba95832313$export$ad5f97924b14314b = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getSelectedIssueIdsSelector
});
const $8531abba95832313$var$getIsIssueIdSelectedSelector = (state, issueId)=>{
    return state.selectedIssueIds.has(issueId);
};
const $8531abba95832313$export$cfefd69fc8a5ac52 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getIsIssueIdSelectedSelector
});
const $8531abba95832313$var$getAreAllIssuesSelectedSelector = (state, issueIds)=>{
    const selectedIssueIds = $8531abba95832313$var$getSelectedIssueIdsSelector(state);
    return issueIds.length > 0 && issueIds.every((issueId)=>selectedIssueIds.includes(issueId));
};
const $8531abba95832313$export$949e47631f4a60a5 = (0, $iJq0l.createStateHook)($8531abba95832313$var$Store, {
    selector: $8531abba95832313$var$getAreAllIssuesSelectedSelector
});

});
parcelRegister("1hqwo", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $d2b10d6e7ee3216e$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $d2b10d6e7ee3216e$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d2b10d6e7ee3216e$export$d4c72bab9d6cc13a = {
    selectedIssueIds: new Set([]),
    lastSelectedRowIndex: null
};
const $d2b10d6e7ee3216e$export$e324594224ef24da = {
    insertSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            onIssueSelected?.(selectedIssueIds);
            setState({
                selectedIssueIds: new Set([
                    ...currentState.selectedIssueIds,
                    ...selectedIssueIds
                ])
            });
        },
    removeSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            selectedIssueIds.forEach((selectedIssueId)=>{
                updatedSelectedIssueIds.delete(selectedIssueId);
            });
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    insertSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.add(selectedIssueId);
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    removeSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.delete(selectedIssueId);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    selectedOnlyIssueId: (selectedIssueId)=>({ setState: setState }, { onIssueSelected: onIssueSelected })=>{
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: new Set([
                    selectedIssueId
                ])
            });
        },
    updateLastSelectedRowIndex: (lastSelectedRowIndex)=>({ setState: setState })=>{
            setState({
                lastSelectedRowIndex: lastSelectedRowIndex
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState($d2b10d6e7ee3216e$export$d4c72bab9d6cc13a);
        },
    checkIssueRow: (issueId, isChecked, isShiftPressed, flatList)=>({ dispatch: dispatch, getState: getState })=>{
            const selectedIssueIds = [
                issueId
            ];
            const currentState = getState();
            const currentCheckedIndex = flatList.findIndex((id)=>id === issueId);
            if (isShiftPressed && currentState.lastSelectedRowIndex !== null) {
                const start = Math.min(currentState.lastSelectedRowIndex, currentCheckedIndex);
                const end = Math.max(currentState.lastSelectedRowIndex, currentCheckedIndex);
                selectedIssueIds.push(...flatList.slice(start, end + 1).filter((id)=>id !== issueId));
            }
            dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.updateLastSelectedRowIndex(currentCheckedIndex));
            if (isChecked) dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.insertSelectedIssueIds(selectedIssueIds));
            else dispatch($d2b10d6e7ee3216e$export$e324594224ef24da.removeSelectedIssueIds(selectedIssueIds));
        }
};

});


parcelRegister("3cJQz", function(module, exports) {

$parcel$export(module.exports, "HierarchyOnboardingProvider", () => $e4b1171d87a4cba5$export$61ea399940cf79d6);
$parcel$export(module.exports, "useHierarchyOnboardingContext", () => $e4b1171d87a4cba5$export$34916c588fba606d);
$parcel$export(module.exports, "HierarchyOnboarding", () => $e4b1171d87a4cba5$export$19eb9bdb0cf578f5);
$parcel$export(module.exports, "HierarchyToggleOnboarding", () => $e4b1171d87a4cba5$export$e350c43a524c2f15);

var $eJOHy = parcelRequire("eJOHy");

var $7UDun = parcelRequire("7UDun");

var $d2s5v = parcelRequire("d2s5v");

var $3CprG = parcelRequire("3CprG");

var $9zZj0 = parcelRequire("9zZj0");

var $lRq8t = parcelRequire("lRq8t");

var $9HHOs = parcelRequire("9HHOs");

var $kEUB1 = parcelRequire("kEUB1");

var $g1NZW = parcelRequire("g1NZW");

var $epTsa = parcelRequire("epTsa");

var $domHz = parcelRequire("domHz");
const $e4b1171d87a4cba5$export$2d29273a16589c02 = 'jira-nin-hierarchy-onboarding-stg';
const $e4b1171d87a4cba5$export$e7deeb52c7c3e7a9 = 'jira-list-nin-hierarchy-onboarding';
const $e4b1171d87a4cba5$var$ENV_STAGING = 'staging';
const $e4b1171d87a4cba5$var$STARGATE_URL = '/gateway/api';
const $e4b1171d87a4cba5$var$HierarchyOnboardingContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $e4b1171d87a4cba5$export$61ea399940cf79d6 = ({ children: children })=>{
    const [showToggleOnboarding, setShowToggleOnboarding] = (0, $eJOHy.useState)(false);
    const value = (0, $eJOHy.useMemo)(()=>({
            showToggleOnboarding: showToggleOnboarding,
            setShowToggleOnboarding: setShowToggleOnboarding
        }), [
        showToggleOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4b1171d87a4cba5$var$HierarchyOnboardingContext.Provider, {
        value: value
    }, children);
};
const $e4b1171d87a4cba5$export$34916c588fba606d = ()=>{
    const hierarchyContext = (0, $eJOHy.useContext)($e4b1171d87a4cba5$var$HierarchyOnboardingContext);
    if (!hierarchyContext) throw new Error('useHierarchyOnboardingContext must be used within a HierarchyOnboardingProvider');
    return hierarchyContext;
};
const $e4b1171d87a4cba5$export$19eb9bdb0cf578f5 = ()=>{
    const ONBOARDING_ENGAGEMENT_ID = (0, $g1NZW.useEnvironment)() === $e4b1171d87a4cba5$var$ENV_STAGING ? $e4b1171d87a4cba5$export$2d29273a16589c02 : $e4b1171d87a4cba5$export$e7deeb52c7c3e7a9;
    const { setShowToggleOnboarding: setShowToggleOnboarding } = $e4b1171d87a4cba5$export$34916c588fba606d();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $kEUB1.useCloudId)();
    /**
   * Onboarding Experience is loaded manually on page load via EP's CoordinationClient class
   * Once loaded, if the message is active for this particular context, only then the HIERARCHY_ONBOARDING will be loaded and displayed
   */ const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, $e4b1171d87a4cba5$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eJOHy.useState)(false);
    const [isEnrolled, stopEnrolment] = (0, $7UDun.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    (0, $eJOHy.useEffect)(()=>{
        if (isEnrolled) {
            stopEnrolment(false);
            setIsSpotlightActive(true);
        }
    }, [
        isEnrolled,
        stopEnrolment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CprG.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, isEnrolled && isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        messageId: "issue-table-hierarchy.ui.hierarchy-onboarding.jira-spotlight.expand-column-header",
        messageType: "engagement",
        actionsBeforeElement: "1/2",
        actions: [
            {
                onClick: ()=>{
                    setIsSpotlightActive(false);
                    setShowToggleOnboarding(true);
                },
                text: formatMessage((0, $domHz.default).next)
            },
            {
                appearance: 'subtle',
                onClick: ()=>setIsSpotlightActive(false),
                text: formatMessage((0, $domHz.default).dismiss)
            }
        ],
        dialogWidth: 320,
        heading: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $domHz.default).onboardingHeadingIssueTermRefresh : (0, $domHz.default).onboardingHeading),
        target: "expand-column-header",
        key: "expand-column-header",
        targetRadius: 3
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $domHz.default).onboardingDescriptionIssueTermRefresh : (0, $domHz.default).onboardingDescription))));
};
const $e4b1171d87a4cba5$export$e350c43a524c2f15 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showToggleOnboarding: showToggleOnboarding, setShowToggleOnboarding: setShowToggleOnboarding } = $e4b1171d87a4cba5$export$34916c588fba606d();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eJOHy.useState)(true);
    if (!isSpotlightActive || !showToggleOnboarding) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        messageId: "issue-table-hierarchy.ui.hierarchy-onboarding.jira-spotlight.hierarchy-feature-toggle",
        messageType: "engagement",
        actionsBeforeElement: "2/2",
        actions: [
            {
                onClick: ()=>{
                    setShowToggleOnboarding(false);
                    setIsSpotlightActive(false);
                },
                text: formatMessage((0, $domHz.default).ok)
            }
        ],
        dialogWidth: 320,
        target: "hierarchy-feature-toggle",
        key: "hierarchy-feature-toggle",
        targetRadius: 3
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $domHz.default).toggleOnboardingIssueTermRefresh : (0, $domHz.default).toggleOnboarding)));
};

});
parcelRegister("domHz", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb46e101bc25a0ef$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $eb46e101bc25a0ef$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    onboardingHeading: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading",
        "defaultMessage": "View issue hierarchy"
    },
    onboardingHeadingIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading-issue-term-refresh",
        "defaultMessage": "View hierarchy"
    },
    onboardingDescription: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description",
        "defaultMessage": "Collapse or expand the hierarchy to see parent and child issues."
    },
    onboardingDescriptionIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description-issue-term-refresh",
        "defaultMessage": "Collapse or expand the hierarchy to see parent and child work items."
    },
    next: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.next",
        "defaultMessage": "Next"
    },
    toggleOnboarding: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding",
        "defaultMessage": "Use the toggle to show or hide the issue hierarchy."
    },
    toggleOnboardingIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding-issue-term-refresh",
        "defaultMessage": "Use the toggle to show or hide the hierarchy."
    },
    ok: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.done",
        "defaultMessage": "Ok"
    },
    dismiss: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("9WMzW", function(module, exports) {

$parcel$export(module.exports, "SidebarLayout", () => $3d4052942a7691d5$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");

var $d5C8k = parcelRequire("d5C8k");

var $1KdDN = parcelRequire("1KdDN");

var $gHKwt = parcelRequire("gHKwt");

const $3d4052942a7691d5$export$8295a33ab8a36876 = ({ children: children, content: content, teamName: teamName, defaultRatio: defaultRatio, minWidth: minWidth, minRatio: minRatio, maxRatio: maxRatio })=>{
    const [{ id: id }, { closeSidebar: closeSidebar }] = (0, $gHKwt.useSidebar)();
    // reset sidebar content on view unmount
    (0, $eJOHy.useEffect)(()=>()=>{
            closeSidebar();
        }, [
        closeSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        testId: "platform-sidebar.ui.sidebar-layout",
        xcss: $3d4052942a7691d5$var$styles.wrapper,
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $3d4052942a7691d5$var$styles.childContentContainer
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "sidebarWrapper",
        packageName: (0, $e8c1aaa176754652$export$b8b9d90f9e5bd72b),
        teamName: teamName,
        fallback: "flag",
        attributes: {
            sidebarExperienceId: id
        }
    }, id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d5C8k.default), {
        defaultRatio: defaultRatio,
        minWidth: minWidth,
        minRatio: minRatio,
        maxRatio: maxRatio
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            ...props,
            className: (0, $hcewu.default)([
                $3d4052942a7691d5$var$styles.sidebarContentContainer
            ])
        }, content)) : null));
};
const $3d4052942a7691d5$var$styles = {
    wrapper: "_4t3i1osq _18m91wug",
    sidebarContentContainer: "_16qs1cd0 _18u0xmi2",
    childContentContainer: "_16jlkb7n _1o9zkb7n _i0dlidpf _18m91wug"
};

});
parcelRegister("d5C8k", function(module, exports) {

$parcel$export(module.exports, "default", () => $7012978e78c939c3$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kjGDT = parcelRequire("kjGDT");

var $4nS5e = parcelRequire("4nS5e");

var $9NK7W = parcelRequire("9NK7W");
var $7012978e78c939c3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const { children: children, ...resizerProps } = props;
    const { minRatio: minRatio = 0, maxRatio: maxRatio = 1, minWidth: minWidth, maxWidth: maxWidth, initialRatio: initialRatio, defaultRatio: defaultRatio, extraWidth: extraWidth, position: position = 'left', resizeHandleAsOverlay: resizeHandleAsOverlay, collapsed: collapsed, additionalStyles: additionalStyles } = resizerProps;
    // Ensure the ratio which is initially set to the flex-basis style is bounded between the min/max ratios
    // The css properties handles max-width and min-width
    const ratio = (0, $eJOHy.useRef)((0, $4nS5e.clampValue)({
        value: initialRatio ?? defaultRatio,
        minValue: minRatio,
        maxValue: maxRatio
    }));
    /** If resizer is expanded and the ratio is 0, set the ratio to the initial ratio.
   *  This logic would need to change if we allow users to "uncollapse" the resizer manually, because currently this code will reset the ratio to the initial ratio.
   */ if (!collapsed && ratio.current === 0) ratio.current = (0, $4nS5e.clampValue)({
        value: initialRatio ?? defaultRatio,
        minValue: minRatio,
        maxValue: maxRatio
    });
    const container = (0, $eJOHy.useRef)(null);
    const renderHandle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9NK7W.default), {
            additionalStyles: additionalStyles,
            ...resizerProps,
            ...initialRatio !== undefined ? {
                initialRatio: ratio.current,
                defaultRatio: (0, $4nS5e.clampValue)({
                    value: defaultRatio,
                    minValue: minRatio,
                    maxValue: maxRatio
                })
            } : {
                defaultRatio: ratio.current
            },
            childrenContainerRef: container
        });
    const renderResizer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, position === 'left' && renderHandle(), typeof children === 'function' ? children({
            ref: (r)=>{
                container.current = r;
            },
            style: (0, $4nS5e.getChildrenStyle)(ratio.current, minWidth, maxWidth, extraWidth, collapsed)
        }) : children, position === 'right' && renderHandle());
    return resizeHandleAsOverlay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7012978e78c939c3$export$c7990a6594835e51, {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $4nS5e.getChildrenStyle)(ratio.current, minWidth, maxWidth, extraWidth, collapsed),
        ref: container,
        "data-testid": "flex-resizer.ui.resize-wrapper"
    }, renderResizer()) : renderResizer();
});
const $7012978e78c939c3$export$c7990a6594835e51 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1e0c1txw _lcxv1wug _q0u0kb7n _2e98kb7n _12rof1ug",
            __cmplp.className
        ])
    });
});
const $7012978e78c939c3$export$70af81d424c0709 = (0, $kjGDT.resizerStyleOverrides);

});
parcelRegister("kjGDT", function(module, exports) {

$parcel$export(module.exports, "resizerStyleOverrides", () => $ff0b8bd6b1597acb$export$70af81d424c0709);
const $ff0b8bd6b1597acb$export$70af81d424c0709 = {
    ISSUE_VIEW_MARGIN_OFFSET: 'issue-view-margin-offset'
};

});

parcelRegister("4nS5e", function(module, exports) {

$parcel$export(module.exports, "RESIZE_HANDLE_WIDTH", () => $a93c3f899c271ccd$export$45f504201feb6ea6);
$parcel$export(module.exports, "useAnimationFrameThrottle", () => $a93c3f899c271ccd$export$9d3ed311e5db6a6f);
$parcel$export(module.exports, "useDoubleClick", () => $a93c3f899c271ccd$export$b1d0a5c81935127f);
$parcel$export(module.exports, "clampValue", () => $a93c3f899c271ccd$export$31ee16100cde6ce2);
$parcel$export(module.exports, "calculateNewRatio", () => $a93c3f899c271ccd$export$58e1996e98bfba9e);
$parcel$export(module.exports, "getChildrenStyle", () => $a93c3f899c271ccd$export$f2a5e228fabed40b);

var $eJOHy = parcelRequire("eJOHy");

var $dPMMf = parcelRequire("dPMMf");
const $a93c3f899c271ccd$export$45f504201feb6ea6 = 3 * (0, $dPMMf.gridSize) + 2;
const $a93c3f899c271ccd$export$9d3ed311e5db6a6f = (callback)=>{
    const token = (0, $eJOHy.useRef)(null);
    const lastArgs = (0, $eJOHy.useRef)(null);
    const hasTriggered = (0, $eJOHy.useRef)(false);
    const handleFrame = (0, $eJOHy.useCallback)(()=>{
        lastArgs.current = null;
        hasTriggered.current = false;
    }, []);
    const throttle = (0, $eJOHy.useCallback)((...args)=>{
        lastArgs.current = args;
        if (hasTriggered.current) return;
        callback(...args);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        token.current = window.requestAnimationFrame(handleFrame);
        hasTriggered.current = true;
    }, [
        handleFrame,
        callback
    ]);
    const cancel = (0, $eJOHy.useCallback)(()=>{
        if (token.current) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.cancelAnimationFrame(token.current);
        if (!hasTriggered.current && lastArgs.current !== null) callback(...lastArgs.current);
        token.current = null;
        lastArgs.current = null;
        hasTriggered.current = false;
    }, [
        callback
    ]);
    (0, $eJOHy.useEffect)(()=>()=>cancel(), [
        callback,
        cancel
    ]);
    return [
        throttle,
        cancel
    ];
};
const $a93c3f899c271ccd$export$b1d0a5c81935127f = (callback)=>{
    const lastClickTime = (0, $eJOHy.useRef)(0);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        const now = Date.now();
        if (now - lastClickTime.current < 500) {
            lastClickTime.current = 0;
            callback();
            return true;
        }
        lastClickTime.current = now;
        return false;
    }, [
        callback
    ]);
    return handleClick;
};
const $a93c3f899c271ccd$export$29ae71364f84a225 = (element)=>{
    const style = getComputedStyle(element);
    const paddingX = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    return paddingX;
};
const $a93c3f899c271ccd$export$31ee16100cde6ce2 = ({ value: value, minValue: minValue, maxValue: maxValue })=>Math.min(Math.max(value, minValue), maxValue);
const $a93c3f899c271ccd$export$58e1996e98bfba9e = ({ parentWidth: parentWidth, currentWidth: currentWidth, deltaX: deltaX, minWidth: minWidth, minRatio: minRatio, maxWidth: maxWidth, maxRatio: maxRatio, baseWidth: baseWidth, position: position })=>{
    const targetWidth = Math.min(Math.max(currentWidth - baseWidth + (position === 'left' ? deltaX : deltaX * -1), minWidth), maxWidth);
    return $a93c3f899c271ccd$export$31ee16100cde6ce2({
        value: targetWidth / parentWidth,
        minValue: minRatio,
        maxValue: maxRatio
    });
};
const $a93c3f899c271ccd$export$f2a5e228fabed40b = (ratio, minWidth, maxWidth, extraWidth = 0, collapsed = false)=>({
        boxSizing: 'border-box',
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: (()=>{
            if (collapsed) return '0%';
            return extraWidth > 0 ? `calc(${ratio * 100}% + ${extraWidth}px)` : `${ratio * 100}%`;
        })(),
        minWidth: (()=>{
            if (collapsed) return 0;
            return minWidth !== undefined ? minWidth : null;
        })(),
        maxWidth: (()=>{
            if (collapsed) return 0;
            return maxWidth !== undefined ? maxWidth : null;
        })()
    });

});

parcelRegister("9NK7W", function(module, exports) {

$parcel$export(module.exports, "default", () => $83bac0df6a44b069$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $36Qom = parcelRequire("36Qom");

var $gV40x = parcelRequire("gV40x");
var $83bac0df6a44b069$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "async.issue.view.resizer",
        packageName: "async.issue.view.resizer",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gV40x.ResizeHandle), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $36Qom.default), props)));

});
parcelRegister("36Qom", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ae4e693bfab32cf$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $o0Fzr = parcelRequire("o0Fzr");

var $dB1eP = parcelRequire("dB1eP");

var $hlJ0R = parcelRequire("hlJ0R");

var $k71qx = parcelRequire("k71qx");

var $6fs4r = parcelRequire("6fs4r");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $4nS5e = parcelRequire("4nS5e");

var $guiml = parcelRequire("guiml");

var $eIXlM = parcelRequire("eIXlM");

var $gJzIA = parcelRequire("gJzIA");

var $gV40x = parcelRequire("gV40x");
const $0ae4e693bfab32cf$var$RESIZE_ICON_TEST_ID = 'flex-resizer.ui.handle.resize-icon';
const $0ae4e693bfab32cf$var$RESIZE_CHEVRON_ICON = 'flex-resizer.ui.handle.chevron-';
const $0ae4e693bfab32cf$var$resizeCursorCollapsed = null;
const $0ae4e693bfab32cf$var$resizeCursor = null;
const $0ae4e693bfab32cf$var$grabAreaStyles = {
    root: "_1bsbo7ao _4t3i1osq _kqswstnw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz3acm _bfhk18uv _k8m01ylx _1oec1yx9 _1lww5cps _vp7g1p6i _30l31p6i _1dr21ylx _1s5z1ylx _1cg4fnf5 _le1bfnf5 _1gglglyw _9h8h1p6i"
};
const $0ae4e693bfab32cf$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbyh40 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e02cy7w"
};
const $0ae4e693bfab32cf$var$TooltipWrapper = ({ toolTipContent: toolTipContent, children: children })=>{
    if (toolTipContent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: toolTipContent,
        hideTooltipOnClick: true
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $0ae4e693bfab32cf$var$Resizer = ({ childrenContainerRef: childrenContainerRef, initialRatio: initialRatio, defaultRatio: defaultRatio, minWidth: minWidth, minRatio: minRatio = 0, maxWidth: maxWidth, maxRatio: maxRatio = 1, extraWidth: extraWidth = 0, position: position = 'left', resizeHandleAsOverlay: resizeHandleAsOverlay, resizeHandleZIndex: resizeHandleZIndex, onRatioChange: onRatioChange, onRatioReset: onRatioReset, onResizeStart: onResizeStart, chevronDirection: chevronDirection, persistResizeIcon: persistResizeIcon, onResizeHandleClick: onResizeHandleClick, collapsed: collapsed, minWidthLeftContainer: minWidthLeftContainer, minWidthRightContainer: minWidthRightContainer, toolTipContent: toolTipContent })=>{
    const startX = (0, $eJOHy.useRef)(0);
    const startWidth = (0, $eJOHy.useRef)(0);
    const parentWidth = (0, $eJOHy.useRef)(0);
    const onResizeStartStableRef = (0, $eJOHy.useRef)(onResizeStart);
    const onResizeEndStableRef = (0, $eJOHy.useRef)(onRatioChange);
    const [rangeInputValue, setRangeInputValue] = (0, $eJOHy.useState)(maxRatio - (initialRatio ?? defaultRatio));
    const [inputRange, setInputRange] = (0, $eJOHy.useState)({
        min: 0,
        max: 1
    }); /*
           onRatioChange calls setFlexBasisProp from the parent component. Even if the slider value changes to 0 there are
        chances the line splitter can min go upto 0.2. If, user performs keyboard navigation the user will not see any movement
        if the value was 0 unless it reaches to 0.2 lets say
      	  To avoid this, lineSplitterRef.current.getBoundingClientRect -> returns width giving the exact position of the line and we
        can thus update the ratio which we are doing on handleSliderFocus
      */ 
    const lineSplitterRef = (0, $eJOHy.useRef)(null);
    const [keyboardResizeManager] = (0, $eJOHy.useState)(()=>(0, $gJzIA.createKeyboardResizeManager)({
            onResizeStart: ()=>onResizeStartStableRef.current?.(),
            onResizeEnd: (...args)=>{
                return onResizeEndStableRef.current?.(...args);
            }
        }));
    const prevChevronDirection = (0, $6d9QY.usePreviousWithInitial)(chevronDirection);
    const nextRatio = (0, $eJOHy.useRef)(initialRatio ?? defaultRatio);
    const styleElement = (0, $eJOHy.useRef)(null);
    const labelId = (0, $o0Fzr.useUID)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        /*
    initialRatio is 0 means Panel splitter is completely closed
          When it is collapsed and initialRatio is 0, next time when we expand,
    range should take defaultRatio
           Else
           If initialRatio is > 0, when we collapse the panel and expand, range should take initialRatio.
          */ if (collapsed && (0, $7jTnu.fg)('jira_a11y_pannel_splitter_navigations')) setRangeInputValue(maxRatio - (initialRatio && initialRatio !== 0 ? initialRatio : defaultRatio));
    }, [
        collapsed,
        initialRatio,
        defaultRatio,
        maxRatio
    ]);
    const setFlexBasisProp = (0, $eJOHy.useCallback)((ratio, setNextRatio)=>{
        // This will force-fix any in consistencies in the ratio value if ratio is set from parent components
        if (setNextRatio !== undefined) nextRatio.current = setNextRatio;
        if (childrenContainerRef.current) childrenContainerRef.current.style.setProperty('flex-basis', extraWidth > 0 ? `calc(${ratio * 100}% + ${extraWidth}px)` : `${ratio * 100}%`);
    }, [
        childrenContainerRef,
        extraWidth
    ]);
    const resetDetector = (0, $4nS5e.useDoubleClick)((0, $eJOHy.useCallback)(()=>{
        const targetRatio = (0, $4nS5e.clampValue)({
            value: defaultRatio * parentWidth.current,
            minValue: Math.max(minWidth ?? 0, minRatio * parentWidth.current),
            maxValue: Math.min(maxWidth ?? Infinity, maxRatio * parentWidth.current)
        }) / parentWidth.current;
        nextRatio.current = targetRatio;
        setFlexBasisProp(targetRatio);
        onRatioReset?.(targetRatio);
    }, [
        defaultRatio,
        minWidth,
        minRatio,
        maxWidth,
        maxRatio,
        setFlexBasisProp,
        onRatioReset
    ]));
    const [onPointerMoveThrottled, cancelPointerMove] = (0, $4nS5e.useAnimationFrameThrottle)((0, $eJOHy.useCallback)((e)=>{
        const r = (0, $4nS5e.calculateNewRatio)({
            parentWidth: parentWidth.current,
            currentWidth: startWidth.current,
            deltaX: startX.current - e.pageX,
            minWidth: minWidth ?? 0,
            minRatio: minRatio,
            maxWidth: maxWidth ?? Infinity,
            maxRatio: maxRatio,
            baseWidth: extraWidth,
            position: position
        });
        nextRatio.current = r;
        setFlexBasisProp(r);
    }, [
        extraWidth,
        maxRatio,
        maxWidth,
        minRatio,
        minWidth,
        position,
        setFlexBasisProp
    ]));
    const onPointerMove = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        onPointerMoveThrottled(e);
    }, [
        onPointerMoveThrottled
    ]);
    const onPointerUp = (0, $eJOHy.useCallback)(()=>{
        const r = nextRatio.current;
        const resetTriggered = resetDetector();
        if (!resetTriggered) onRatioChange?.(r, nextRatio.current * parentWidth.current, setFlexBasisProp);
         // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('pointermove', onPointerMove, {
            capture: true
        }); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('pointerup', onPointerUp, {
            capture: true
        });
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            stylesheet.deleteRule(1);
            stylesheet.deleteRule(0);
        }
        cancelPointerMove();
        if ((0, $7jTnu.fg)('jira_a11y_pannel_splitter_navigations')) setRangeInputValue(maxRatio - r);
    }, [
        cancelPointerMove,
        onPointerMove,
        onRatioChange,
        resetDetector,
        setFlexBasisProp,
        maxRatio
    ]);
    const onPointerDown = (0, $eJOHy.useCallback)((e)=>{
        // Check if the chevron icon was clicked and prevent dragging
        if (onResizeHandleClick && e.target instanceof HTMLElement) {
            const target = (e.target.getAttribute('data-testid') || '').indexOf($0ae4e693bfab32cf$var$RESIZE_CHEVRON_ICON) > -1 ? 'chevron' : 'resizer';
            if (!onResizeHandleClick?.(target, setFlexBasisProp, e)) {
                e.preventDefault();
                return;
            }
        } // Prevent resize when the resizer is collapsed
        if (collapsed) return; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('pointermove', onPointerMove, {
            capture: true
        }); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('pointerup', onPointerUp, {
            capture: true
        });
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            // There is a chromium bug which forces all scrollbars to be visible when 'pointer-events: none' is added.
            // Chromium bug: https://bugs.chromium.org/p/chromium/issues/detail?id=1280013&q=pointer-events%20scrollbar&can=2
            // The previously implemented workarounds for this issue didn't solve all use cases, i.e., horizontal scrollbars,
            // thus, 'user-select: none' is used to prevent text-highlighting but allows hover events, unlike 'pointer-events'.
            stylesheet.insertRule('body { user-select: none; }', 0); // Set the dragging cursor (higher than disabled pointer events)
            stylesheet.insertRule('#jira { cursor: ew-resize; }', 1);
        }
        const currentContainer = childrenContainerRef.current;
        const parentContainer = currentContainer?.parentElement;
        if (!currentContainer || !parentContainer) return;
        startWidth.current = currentContainer.getBoundingClientRect().width;
        parentWidth.current = parentContainer.getBoundingClientRect().width ?? 0;
        onResizeStart?.();
        startX.current = e.pageX; // This is preventing popups from closing when the resize handle is dragged
        if (!onResizeHandleClick) e.preventDefault();
    }, [
        onPointerMove,
        onPointerUp,
        childrenContainerRef,
        onResizeStart,
        onResizeHandleClick,
        collapsed,
        setFlexBasisProp
    ]);
    const handleSliderFocus = (0, $eJOHy.useCallback)(()=>{
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            // There is a chromium bug which forces all scrollbars to be visible when 'pointer-events: none' is added.
            // Chromium bug: https://bugs.chromium.org/p/chromium/issues/detail?id=1280013&q=pointer-events%20scrollbar&can=2
            // The previously implemented workarounds for this issue didn't solve all use cases, i.e., horizontal scrollbars,
            // thus, 'user-select: none' is used to prevent text-highlighting but allows hover events, unlike 'pointer-events'.
            stylesheet.insertRule('body { user-select: none; }', 0); // Set the dragging cursor (higher than disabled pointer events)
            stylesheet.insertRule('#jira { cursor: ew-resize; }', 1);
        }
        const currentContainer = childrenContainerRef.current;
        const parentContainer = currentContainer?.parentElement;
        if (!currentContainer || !parentContainer) return;
        startWidth.current = currentContainer.getBoundingClientRect().width;
        parentWidth.current = parentContainer.getBoundingClientRect().width ?? 0; /*
                                                                                    calculate the range only when the user actually wants navigate via
                                                                                    keyboard and save the computation at initial render
                                                                                    */ 
        setInputRange((prev)=>({
                ...prev,
                min: minWidthLeftContainer ? minWidthLeftContainer / parentWidth.current : minRatio,
                max: minWidthRightContainer ? maxRatio - minWidthRightContainer / parentWidth.current : maxRatio
            }));
        onResizeStart?.();
    }, [
        onResizeStart,
        childrenContainerRef,
        maxRatio,
        minRatio,
        minWidthLeftContainer,
        minWidthRightContainer
    ]);
    const handleSliderInputChange = (0, $eJOHy.useCallback)((e)=>{
        const value = parseFloat(e.target.value);
        setRangeInputValue(value); // doing this maxRatio - value because current drag has left as 100% and right as 0% alternative to input range
        nextRatio.current = maxRatio - value;
        setFlexBasisProp(maxRatio - value);
        keyboardResizeManager.onResize({
            ratio: maxRatio - value,
            width: (maxRatio - value) * parentWidth.current,
            flexBasis: setFlexBasisProp
        });
    }, [
        setFlexBasisProp,
        maxRatio,
        keyboardResizeManager
    ]);
    const handleSliderBlur = (0, $eJOHy.useCallback)(()=>{
        const r = maxRatio - nextRatio.current;
        const resetTriggered = resetDetector();
        if (!resetTriggered) onRatioChange?.(r, r * parentWidth.current, setFlexBasisProp);
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            const ruleCount = stylesheet.cssRules.length; // Delete rules safely by checking the number of existing rules
            if (ruleCount > 1) stylesheet.deleteRule(1);
            if (ruleCount > 0) stylesheet.deleteRule(0);
        }
    }, [
        onRatioChange,
        resetDetector,
        setFlexBasisProp,
        maxRatio
    ]);
    const ariaValueText = (0, $eJOHy.useMemo)(()=>`${(0, $eIXlM.getPercentageWithinPixelBounds)({
            currentWidth: collapsed ? maxRatio : rangeInputValue,
            minRatio: minRatio,
            maxRatio: maxRatio
        })}% width`, [
        rangeInputValue,
        minRatio,
        maxRatio,
        collapsed
    ]);
    const ResizeBar = (0, $eJOHy.useCallback)(()=>{
        const directionDidChange = chevronDirection !== prevChevronDirection;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gV40x.ResizeHandle), {
            tabIndex: 0,
            role: "separator",
            "aria-orientation": "vertical",
            "data-testid": "flex-resizer.ui.handle.resizer",
            onPointerDown: onPointerDown,
            position: position,
            resizeHandleZIndex: resizeHandleZIndex,
            resizeHandleAsOverlay: resizeHandleAsOverlay,
            "aria-valuenow": Math.floor(nextRatio.current * 100),
            collapsed: collapsed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gV40x.ResizeBorder), {
            triggerAnimation: directionDidChange,
            collapsed: collapsed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ae4e693bfab32cf$var$TooltipWrapper, {
            toolTipContent: toolTipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gV40x.ResizeIcon), {
            triggerAnimation: directionDidChange,
            "data-testid": $0ae4e693bfab32cf$var$RESIZE_ICON_TEST_ID,
            persistResizeIcon: persistResizeIcon,
            onResizeHandleClick: onResizeHandleClick
        }, chevronDirection === 'LEFT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hlJ0R))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            testId: `${$0ae4e693bfab32cf$var$RESIZE_CHEVRON_ICON}left`,
            size: "small"
        }), chevronDirection === 'RIGHT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dB1eP))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            testId: `${$0ae4e693bfab32cf$var$RESIZE_CHEVRON_ICON}right`,
            size: "small"
        })))));
    }, [
        onPointerDown,
        position,
        resizeHandleZIndex,
        resizeHandleAsOverlay,
        collapsed,
        chevronDirection,
        prevChevronDirection,
        persistResizeIcon,
        onResizeHandleClick,
        toolTipContent
    ]);
    const renderKeyboardNavigation = (0, $eJOHy.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            ref: lineSplitterRef,
            className: (0, $hcewu.default)([
                $0ae4e693bfab32cf$var$grabAreaStyles.root,
                collapsed ? "_1gavfnf5" : "_d0aluf7j _1gavfnf5"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6fs4r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            id: labelId,
            type: "range",
            value: rangeInputValue,
            step: "0.01",
            min: inputRange.min,
            max: inputRange.max,
            "aria-valuetext": ariaValueText,
            onChange: handleSliderInputChange,
            onFocus: handleSliderFocus,
            onBlur: handleSliderBlur
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("label", {
            htmlFor: labelId
        }, formatMessage((0, $guiml.default).resizer))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
            className: (0, $hcewu.default)([
                $0ae4e693bfab32cf$var$lineStyles.root
            ])
        }));
    }, [
        ariaValueText,
        formatMessage,
        handleSliderFocus,
        handleSliderInputChange,
        handleSliderBlur,
        labelId,
        rangeInputValue,
        inputRange.max,
        inputRange.min,
        collapsed
    ]);
    const renderResizeBar = (0, $eJOHy.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gV40x.ResizeHandle), {
            "data-testid": "flex-resizer.ui.handle.resizer",
            onPointerDown: onPointerDown,
            position: position,
            resizeHandleZIndex: resizeHandleZIndex,
            resizeHandleAsOverlay: resizeHandleAsOverlay,
            collapsed: collapsed
        }, renderKeyboardNavigation(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gV40x.ResizeBorder), {
            triggerAnimation: chevronDirection !== prevChevronDirection,
            collapsed: collapsed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0ae4e693bfab32cf$var$TooltipWrapper, {
            toolTipContent: toolTipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gV40x.ResizeIcon), {
            triggerAnimation: chevronDirection !== prevChevronDirection,
            "data-testid": $0ae4e693bfab32cf$var$RESIZE_ICON_TEST_ID,
            persistResizeIcon: persistResizeIcon,
            onResizeHandleClick: onResizeHandleClick
        }, chevronDirection === 'LEFT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hlJ0R))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            testId: `${$0ae4e693bfab32cf$var$RESIZE_CHEVRON_ICON}left`,
            size: "small"
        }), chevronDirection === 'RIGHT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dB1eP))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            testId: `${$0ae4e693bfab32cf$var$RESIZE_CHEVRON_ICON}right`,
            size: "small"
        })))));
    }, [
        onPointerDown,
        position,
        resizeHandleZIndex,
        resizeHandleAsOverlay,
        persistResizeIcon,
        onResizeHandleClick,
        collapsed,
        renderKeyboardNavigation,
        chevronDirection,
        prevChevronDirection,
        toolTipContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $7jTnu.fg)('jira_a11y_pannel_splitter_navigations') ? renderResizeBar() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ResizeBar, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        ref: styleElement
    }));
};
var $0ae4e693bfab32cf$export$2e2bcd8739ae039 = $0ae4e693bfab32cf$var$Resizer;

});
parcelRegister("hlJ0R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed67385932c28268624e9041c909717e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca17507535f10485$var$_react = $ca17507535f10485$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ca17507535f10485$var$_chevronLeft = $ca17507535f10485$var$_interopRequireDefault((parcelRequire("8PCRQ")));

var $ca17507535f10485$var$_chevronLeft2 = $ca17507535f10485$var$_interopRequireDefault((parcelRequire("6teG9")));
function $ca17507535f10485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca17507535f10485$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $ca17507535f10485$var$_react.default.createElement($ca17507535f10485$var$_chevronLeft.default, Object.assign({
        name: "ChevronLeftIcon",
        LEGACY_fallbackIcon: $ca17507535f10485$var$_chevronLeft2.default
    }, props));
$ca17507535f10485$var$ChevronLeftIcon.displayName = 'ChevronLeftIconMigration';
var $ca17507535f10485$var$_default = module.exports.default = $ca17507535f10485$var$ChevronLeftIcon;

});
parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});

parcelRegister("6teG9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b60d666a5230484$var$_react = $4b60d666a5230484$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4b60d666a5230484$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4b60d666a5230484$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $4b60d666a5230484$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props));
$4b60d666a5230484$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $4b60d666a5230484$var$_default = module.exports.default = $4b60d666a5230484$var$ChevronLeftIcon;

});


parcelRegister("guiml", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9b256e157596d2c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b9b256e157596d2c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    resizer: {
        "id": "flex-resizer.handle.resizer",
        "defaultMessage": "Resize work item view side panel"
    }
});

});

parcelRegister("eIXlM", function(module, exports) {

$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $533a4d0abeef5763$export$b5423678cdf09f5);
function $533a4d0abeef5763$export$b5423678cdf09f5({ currentWidth: currentWidth, minRatio: minRatio, maxRatio: maxRatio }) {
    const resizeRange = maxRatio - minRatio;
    const widthAsPercentage = (currentWidth - minRatio) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("gJzIA", function(module, exports) {

$parcel$export(module.exports, "createKeyboardResizeManager", () => $465d5cbfeab08391$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $465d5cbfeab08391$var$resizeCallbackDebounceTimeMs = 500;
function $465d5cbfeab08391$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ ratio: ratio, width: width, flexBasis: flexBasis }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd?.(ratio, width, flexBasis);
            resizingState = {
                type: 'idle'
            };
        }, $465d5cbfeab08391$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: width,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ ratio: ratio, width: width, flexBasis: flexBasis }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart();
            startResizeEndTimer({
                ratio: ratio,
                width: width,
                flexBasis: flexBasis
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                ratio: ratio,
                width: width,
                flexBasis: flexBasis
            });
        }
    }
    return {
        onResize: onResize
    };
}

});

parcelRegister("gV40x", function(module, exports) {

$parcel$export(module.exports, "ResizeHandle", () => $025d21548e404657$export$33f2411a0ad35be7);
$parcel$export(module.exports, "ResizeIcon", () => $025d21548e404657$export$8a1e762806b47a07);
$parcel$export(module.exports, "ResizeBorder", () => $025d21548e404657$export$a6c16750034505be);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");
const $025d21548e404657$var$resizeHandleSelectorName = 'jira-issue-view-common-component-resize-handle';
const $025d21548e404657$export$3cd44ff7e3089142 = `[data-component-selector="${$025d21548e404657$var$resizeHandleSelectorName}"]`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $025d21548e404657$var$ResizeHandleComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { collapsed: collapsed, resizeHandleZIndex: resizeHandleZIndex, position: position, resizeHandleAsOverlay: resizeHandleAsOverlay, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_yzp60g": (0, $awdRS.default)(__cmplp.collapsed && "var(--ds-space-300, 24px)"),
            "--_1ravlqm": (0, $awdRS.default)(__cmplp.resizeHandleZIndex),
            "--_1o4cubd": (0, $awdRS.default)(__cmplp.position === 'left' ? 'translate3d(-50%, 0, 0)' : 'translate3d(50%, 0, 0)')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _1bsb1ejb _1wpz1fhb _1e0c1txw _1bah1h6o _2hwxyrq6 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.collapsed ? "_80omtlke" : "_80omuf7j",
            __cmplp.resizeHandleZIndex && "_1pby7mzf",
            __cmplp.position === 'left' ? "_1ltvidpf" : "_1xi2idpf",
            __cmplp.resizeHandleAsOverlay && "_154iidpf _kqswstnw _4t3i1osq _t9ec1jw3",
            __cmplp.className
        ])
    });
});
const $025d21548e404657$export$33f2411a0ad35be7 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($025d21548e404657$var$ResizeHandleComponent, {
        "data-component-selector": $025d21548e404657$var$resizeHandleSelectorName,
        ...props
    }));
const $025d21548e404657$var$appearAnimationBorder = null;
const $025d21548e404657$var$appearAnimationIcon = null;
const $025d21548e404657$var$ResizeIconBaseStyles = null;
const $025d21548e404657$var$ResizeIconRefreshStyles = null;
const $025d21548e404657$var$PointerStyle = null;
const $025d21548e404657$var$OpacityStyle1 = null;
const $025d21548e404657$var$OpacityStyle0 = null;
const $025d21548e404657$var$AnimationDuration1S = null;
const $025d21548e404657$var$AnimationDuration0S = null;
const $025d21548e404657$var$ResizeIconCompiled = ({ isRefreshVariant: isRefreshVariant = false, triggerAnimation: triggerAnimation, persistResizeIcon: persistResizeIcon, children: children, onResizeHandleClick: onResizeHandleClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_2rko1rr0 _kqswstnw _154ixy5q _4t3i1tcg _1bsb1tcg _1ltvxmi2 _16qs1cd0 _j7hq1s2f _1pgl1ytf _bfhkvuon _irr3108i",
            isRefreshVariant && "_1e0c1txw _4cvr1h6o _1bah1h6o",
            triggerAnimation && "_5sag9cwz",
            !triggerAnimation && "_5sagru3m",
            persistResizeIcon && "_tzy4kb7n",
            !persistResizeIcon && "_tzy4idpf",
            !!onResizeHandleClick && "_80omtlke"
        ])
    }, children);
};
const $025d21548e404657$export$8a1e762806b47a07 = (0, $f2JN3.componentWithCondition)(()=>(0, $6XJko.isVisualRefreshEnabled)(), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($025d21548e404657$var$ResizeIconCompiled, {
        isRefreshVariant: true,
        ...props
    }), $025d21548e404657$var$ResizeIconCompiled);
const $025d21548e404657$export$a6c16750034505be = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { triggerAnimation: triggerAnimation, collapsed: collapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v56419xe _1bsbyh40 _1wpz1fhb _j7hq1f9b _1pgl1ytf _kqswh2mm _17cdkb7n _vhr0kb7n _1sankb7n _lew41p6i _1ld91p6i _18fi1p6i",
            __cmplp.triggerAnimation ? "_5sag9cwz" : "_5sagru3m",
            __cmplp.collapsed ? "_bfhkmuej" : "_bfhk1p6i",
            __cmplp.collapsed ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});





parcelRegister("cZHhU", function(module, exports) {

$parcel$export(module.exports, "NoFilter", () => $acf3a3ec36143335$export$fba2cdeecf4e314d);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $epTsa = parcelRequire("epTsa");

var $7uL8m = parcelRequire("7uL8m");

var $kKCMK = parcelRequire("kKCMK");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");

var $6XJko = parcelRequire("6XJko");

var $2dA31 = parcelRequire("2dA31");
const $acf3a3ec36143335$var$ANOTHER_FILTER_LINK = '/jira/filters';
const $acf3a3ec36143335$export$fba2cdeecf4e314d = ({ reason: reason })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "noFilter",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        attributes: reason ? {
            reason: reason
        } : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $2dA31.default).weCouldntFindThisFilter),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $2dA31.default).filterNoExistOrNoPermissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2dA31.default).tryAnotherFilterIssueTermRefresh : (0, $2dA31.default).tryAnotherFilter))),
        secondaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            href: $acf3a3ec36143335$var$ANOTHER_FILTER_LINK
        }, formatMessage((0, $2dA31.default).viewFilters)),
        primaryAction: // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            href: window.location.pathname
        }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2dA31.default).searchIssuesIssueTermRefresh : (0, $2dA31.default).searchIssues)),
        renderImage: ()=>(0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $acf3a3ec36143335$var$ImageWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKCMK.default), {
                alt: ""
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $acf3a3ec36143335$var$ImageWrapperStylesOld
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7uL8m.default), {
                alt: ""
            }))
    }));
};
var $acf3a3ec36143335$export$2e2bcd8739ae039 = $acf3a3ec36143335$export$fba2cdeecf4e314d;
const $acf3a3ec36143335$var$ImageWrapperStylesOld = (0, $1DXK0.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});
const $acf3a3ec36143335$var$ImageWrapperStyles = (0, $1DXK0.xcss)({
    maxHeight: '165px',
    maxWidth: '150px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("7uL8m", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a8498e45c2fcae9$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $c4huj = parcelRequire("c4huj");

var $lGiXj = parcelRequire("lGiXj");

var $dIBgP = parcelRequire("dIBgP");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $8a8498e45c2fcae9$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($dIBgP)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($lGiXj))
});
var $8a8498e45c2fcae9$export$2e2bcd8739ae039 = $8a8498e45c2fcae9$var$Illustration;
// for advanced use only
const $8a8498e45c2fcae9$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("lGiXj", function(module, exports) {
module.exports = new URL("search-no-results-old-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("dIBgP", function(module, exports) {
module.exports = new URL("search-no-results-old.10b14394.svg", import.meta.url).toString();

});


parcelRegister("kKCMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaae219acd4147f1$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $c4huj = parcelRequire("c4huj");

var $js5cg = parcelRequire("js5cg");

var $hj82Y = parcelRequire("hj82Y");
const $aaae219acd4147f1$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hj82Y)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($js5cg))
});
var $aaae219acd4147f1$export$2e2bcd8739ae039 = $aaae219acd4147f1$var$Illustration;
// for advanced use only
const $aaae219acd4147f1$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    184
];

});
parcelRegister("js5cg", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.c66ae5fb.svg", import.meta.url).toString();

});

parcelRegister("hj82Y", function(module, exports) {
module.exports = new URL("search-no-results.1d478205.svg", import.meta.url).toString();

});


parcelRegister("2dA31", function(module, exports) {

$parcel$export(module.exports, "default", () => $590b7368a30ac0df$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $590b7368a30ac0df$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    weCouldntFindThisFilter: {
        "id": "issue-navigator.common.no-filter.we-couldnt-find-this-filter",
        "defaultMessage": "We couldn't find this filter"
    },
    filterNoExistOrNoPermissions: {
        "id": "issue-navigator.common.no-filter.filter-no-exist-or-no-permissions",
        "defaultMessage": "This filter may not exist, or you don\u2019t have permissions to view it."
    },
    tryAnotherFilter: {
        "id": "issue-navigator.common.no-filter.try-another-filter",
        "defaultMessage": "Try searching for another filter, or start a new issue search."
    },
    viewFilters: {
        "id": "issue-navigator.common.no-filter.view-filters",
        "defaultMessage": "View filters"
    },
    searchIssues: {
        "id": "issue-navigator.common.no-filter.search-issues",
        "defaultMessage": "Search issues"
    },
    tryAnotherFilterIssueTermRefresh: {
        "id": "issue-navigator.common.no-filter.try-another-filter-issue-term-refresh",
        "defaultMessage": "Try searching for another filter, or start a new search."
    },
    searchIssuesIssueTermRefresh: {
        "id": "issue-navigator.common.no-filter.search-issues-issue-term-refresh",
        "defaultMessage": "Search work items"
    }
});

});


parcelRegister("51pSU", function(module, exports) {

$parcel$export(module.exports, "IssueSearchSuccess", () => $e264e4f6ae230ba0$export$3ee6d2830e5ead03);
$parcel$export(module.exports, "IssueSearchFail", () => $e264e4f6ae230ba0$export$91886a55521e4fad);

var $eJOHy = parcelRequire("eJOHy");

var $6d9QY = parcelRequire("6d9QY");

var $5Ijz5 = parcelRequire("5Ijz5");

var $3kDjB = parcelRequire("3kDjB");

var $HiS1C = parcelRequire("HiS1C");
const $e264e4f6ae230ba0$export$3ee6d2830e5ead03 = ({ attributes: attributes, onPageDataLoad: onPageDataLoad })=>{
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const { onIssueSearchSuccess: onIssueSearchSuccess } = (0, $5Ijz5.useExperienceAnalytics)(onPageDataLoad, attributes);
    const isFetching = (0, $3kDjB.useIsFetching)();
    const isNetworkError = (0, $3kDjB.useIsNetworkError)();
    const prevIsFetching = (0, $6d9QY.usePrevious)(isFetching);
    (0, $eJOHy.useEffect)(()=>{
        if (prevIsFetching !== isFetching && !isFetching && !isNetworkError) onIssueSearchSuccess(view);
    }, [
        isFetching,
        isNetworkError,
        onIssueSearchSuccess,
        prevIsFetching,
        view
    ]);
    return null;
};
const $e264e4f6ae230ba0$export$91886a55521e4fad = ({ attributes: attributes, location: location, error: error, onPageDataLoad: onPageDataLoad })=>{
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const { onIssueSearchFail: onIssueSearchFail } = (0, $5Ijz5.useExperienceAnalytics)(onPageDataLoad, attributes);
    const isFetching = (0, $3kDjB.useIsFetching)();
    const prevIsFetching = (0, $6d9QY.usePrevious)(isFetching);
    (0, $eJOHy.useEffect)(()=>{
        if (prevIsFetching !== isFetching && !isFetching) onIssueSearchFail(location, error, view);
    }, [
        error,
        isFetching,
        location,
        onIssueSearchFail,
        prevIsFetching,
        view
    ]);
    return null;
};

});
parcelRegister("3kDjB", function(module, exports) {

$parcel$export(module.exports, "useSearchKey", () => $c05fb16140fafdb8$export$89b7d8d2a901e7f3);
$parcel$export(module.exports, "useIsFetching", () => $c05fb16140fafdb8$export$625b2ff71316bcd3);
$parcel$export(module.exports, "useIsFetchingView", () => $c05fb16140fafdb8$export$bb4d69b04e77d5fc);
$parcel$export(module.exports, "useIsNetworkError", () => $c05fb16140fafdb8$export$e42540e6c753cf0d);
$parcel$export(module.exports, "useIsRefreshing", () => $c05fb16140fafdb8$export$f0abaf46a1fbe05d);
$parcel$export(module.exports, "useTotalIssueCount", () => $c05fb16140fafdb8$export$2913c5459976c260);
$parcel$export(module.exports, "useTotalIssueCountIsFetching", () => $c05fb16140fafdb8$export$597fd4c2a21a6427);
$parcel$export(module.exports, "useTotalIssueCountIsError", () => $c05fb16140fafdb8$export$8ca94746675b8a5f);
$parcel$export(module.exports, "useIssueSearchActions", () => $c05fb16140fafdb8$export$77a801a298598c57);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $4o2sx = parcelRequire("4o2sx");
const $c05fb16140fafdb8$export$89b7d8d2a901e7f3 = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.searchKey
});
const $c05fb16140fafdb8$export$625b2ff71316bcd3 = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.isFetching
});
const $c05fb16140fafdb8$export$bb4d69b04e77d5fc = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.isFetchingView
});
const $c05fb16140fafdb8$export$e42540e6c753cf0d = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.isNetworkError
});
const $c05fb16140fafdb8$export$f0abaf46a1fbe05d = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.isRefreshing
});
const $c05fb16140fafdb8$export$2913c5459976c260 = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.totalIssueCount
});
const $c05fb16140fafdb8$export$597fd4c2a21a6427 = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.totalIssueCountIsFetching
});
const $c05fb16140fafdb8$export$8ca94746675b8a5f = (0, $iJq0l.createStateHook)((0, $4o2sx.Store), {
    selector: (state)=>state.totalIssueCountIsError
});
const $c05fb16140fafdb8$export$77a801a298598c57 = (0, $iJq0l.createActionsHook)((0, $4o2sx.Store));

});

parcelRegister("HiS1C", function(module, exports) {

$parcel$export(module.exports, "Container", () => $908d0d6f8a933313$export$42a852a2b6b56249);
$parcel$export(module.exports, "useSelectedViewState", () => $908d0d6f8a933313$export$b94206faaa871f9e);
$parcel$export(module.exports, "useSelectedViewActions", () => $908d0d6f8a933313$export$15849666d3b54d24);
$parcel$export(module.exports, "useSelectedView", () => $908d0d6f8a933313$export$639584d6e9163827);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $iRahl = parcelRequire("iRahl");
const $908d0d6f8a933313$export$42a852a2b6b56249 = (0, $6E16M.createContainer)();
const $908d0d6f8a933313$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        view: (0, $iRahl.DEFAULT_VIEW_ID)
    },
    containedBy: $908d0d6f8a933313$export$42a852a2b6b56249,
    actions: {
        setView: (view, issueKey)=>({ setState: setState }, { onSetView: onSetView, onIssueSearchForView: onIssueSearchForView })=>{
                setState({
                    view: view
                });
                onSetView(view, issueKey);
                onIssueSearchForView && onIssueSearchForView(view);
            }
    },
    handlers: {
        onInit: ()=>({ setState: setState }, { view: view })=>{
                setState({
                    view: view
                });
            },
        onContainerUpdate: (nextProps, prevProps)=>({ setState: setState })=>{
                if (nextProps.view !== prevProps.view) setState({
                    view: nextProps.view
                });
            }
    },
    name: 'IssueNavigatorSelectedViewStateNew'
});
const $908d0d6f8a933313$export$b94206faaa871f9e = (0, $iJq0l.createHook)($908d0d6f8a933313$var$Store);
const $908d0d6f8a933313$export$15849666d3b54d24 = (0, $iJq0l.createActionsHook)($908d0d6f8a933313$var$Store);
const $908d0d6f8a933313$export$639584d6e9163827 = (0, $iJq0l.createStateHook)($908d0d6f8a933313$var$Store, {
    selector: (state)=>state.view
});

});


parcelRegister("1wL9i", function(module, exports) {

$parcel$export(module.exports, "useSelectedIssueIndex", () => $d13b4ab197b94f75$export$a4b375f8f9b094ad);
$parcel$export(module.exports, "useNextIssueKey", () => $d13b4ab197b94f75$export$a357f91232534409);
$parcel$export(module.exports, "usePreviousIssueKey", () => $d13b4ab197b94f75$export$ee05f65713c12ae3);
$parcel$export(module.exports, "useIssuesCount", () => $d13b4ab197b94f75$export$b8578d9ea1fc9bc);
$parcel$export(module.exports, "useSelectedIssueKey", () => $d13b4ab197b94f75$export$7cedcbfb2da7e49d);
$parcel$export(module.exports, "useIsSelectedIssue", () => $d13b4ab197b94f75$export$ccd07516e284d793);
$parcel$export(module.exports, "useSelectedIssueDebouncedState", () => $d13b4ab197b94f75$export$ed5cb04ac9d88e95);
$parcel$export(module.exports, "useIssueKeys", () => $d13b4ab197b94f75$export$a5d72277eb099991);
$parcel$export(module.exports, "useIsFullPageIssueAppMode", () => $d13b4ab197b94f75$export$988cbddd89e853c0);
$parcel$export(module.exports, "useSelectedIssueActions", () => $d13b4ab197b94f75$export$d1c4608e18de4f02);

var $iJq0l = parcelRequire("iJq0l");

var $eibCx = parcelRequire("eibCx");

var $7681X = parcelRequire("7681X");

var $6fUhZ = parcelRequire("6fUhZ");
const $d13b4ab197b94f75$export$a4b375f8f9b094ad = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: (0, $6fUhZ.getSelectedIssueIndex)
});
const $d13b4ab197b94f75$export$a357f91232534409 = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: (0, $6fUhZ.getNextIssueKey)
});
const $d13b4ab197b94f75$export$ee05f65713c12ae3 = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: (0, $6fUhZ.getPreviousIssueKey)
});
const $d13b4ab197b94f75$export$b8578d9ea1fc9bc = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: (0, $6fUhZ.getIssuesCount)
});
const $d13b4ab197b94f75$export$7cedcbfb2da7e49d = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: ({ selectedIssueKey: selectedIssueKey })=>selectedIssueKey
});
const $d13b4ab197b94f75$export$ccd07516e284d793 = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: ({ selectedIssueKey: selectedIssueKey }, issueKey)=>selectedIssueKey === issueKey
});
const $d13b4ab197b94f75$export$ed5cb04ac9d88e95 = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: (0, $eibCx.createRememoizeSelector)((state)=>state, ({ selectedIssueKey: selectedIssueKey })=>selectedIssueKey)
});
const $d13b4ab197b94f75$export$a5d72277eb099991 = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: ({ issueKeys: issueKeys })=>issueKeys
});
const $d13b4ab197b94f75$export$988cbddd89e853c0 = (0, $iJq0l.createStateHook)((0, $7681X.Store), {
    selector: ({ isFullPageIssueAppMode: isFullPageIssueAppMode })=>isFullPageIssueAppMode
});
const $d13b4ab197b94f75$export$d1c4608e18de4f02 = (0, $iJq0l.createActionsHook)((0, $7681X.Store));

});
parcelRegister("7681X", function(module, exports) {

$parcel$export(module.exports, "SelectedIssueContainer", () => $49e7deabafdde676$export$8b7bb55917259a5d);
$parcel$export(module.exports, "Store", () => $49e7deabafdde676$export$390f32400eaf98c9);

var $ljej9 = parcelRequire("ljej9");

var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $iRahl = parcelRequire("iRahl");

var $31wJU = parcelRequire("31wJU");
const $49e7deabafdde676$export$8b7bb55917259a5d = (0, $6E16M.createContainer)();
const $49e7deabafdde676$var$initialState = {
    _rememoize: Date.now(),
    selectedIssueKey: (0, $ljej9.toIssueKey)(''),
    isFullPageIssueAppMode: false,
    issueKeys: []
};
const $49e7deabafdde676$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    name: 'SelectedIssueStore',
    containedBy: $49e7deabafdde676$export$8b7bb55917259a5d,
    initialState: $49e7deabafdde676$var$initialState,
    actions: $31wJU.default,
    handlers: {
        onInit: ()=>({ setState: setState, dispatch: dispatch }, { selectedIssueKey: selectedIssueKey, view: view, issueKeys: issueKeys })=>{
                dispatch((0, $31wJU.privateActions).onContainerUpdate());
                const isFullPageIssueAppMode = Boolean(selectedIssueKey) && view === (0, $iRahl.views).list;
                const initialIssueKey = selectedIssueKey || issueKeys[0] || (0, $ljej9.toIssueKey)('');
                setState({
                    _rememoize: Date.now(),
                    selectedIssueKey: initialIssueKey,
                    isFullPageIssueAppMode: isFullPageIssueAppMode
                });
            },
        onContainerUpdate: ({ searchKey: searchKey, selectedIssueKey: selectedIssueKey }, prevProps)=>({ dispatch: dispatch })=>{
                dispatch((0, $31wJU.privateActions).onContainerUpdate());
                if (searchKey !== prevProps.searchKey) dispatch((0, $31wJU.privateActions).resetSelectedIssue());
                else if (selectedIssueKey && selectedIssueKey !== prevProps.selectedIssueKey) {
                    dispatch($49e7deabafdde676$export$390f32400eaf98c9.actions.setSelectedIssueByKey(selectedIssueKey, {
                        shouldDebounce: false,
                        shouldNotifyOnChange: false,
                        isSelectedByUserInteraction: false
                    }));
                    // If an issue key has been specified while in list view then enter full page issue app mode.
                    if (dispatch((0, $31wJU.privateActions).isListViewWithoutIssueApp())) dispatch($49e7deabafdde676$export$390f32400eaf98c9.actions.enterFullPageIssueAppMode());
                // TODO JSC-185 Fetch next/previous page when last/first issue is selected
                } else if (!selectedIssueKey && dispatch((0, $31wJU.privateActions).isListViewWithIssueAppAndKey())) dispatch($49e7deabafdde676$export$390f32400eaf98c9.actions.exitFullPageIssueAppMode());
            }
    }
});

});
parcelRegister("31wJU", function(module, exports) {

$parcel$export(module.exports, "privateActions", () => $5de2eb3fb1196457$export$3f1be494d407b77a);
$parcel$export(module.exports, "default", () => $5de2eb3fb1196457$export$2e2bcd8739ae039);

var $3s8bj = parcelRequire("3s8bj");

var $ljej9 = parcelRequire("ljej9");

var $iRahl = parcelRequire("iRahl");

var $6fUhZ = parcelRequire("6fUhZ");
const $5de2eb3fb1196457$var$doSideEffectUpdate = ({ getState: getState, setState: setState }, { onChange: onChange, shouldNotifyOnChange: shouldNotifyOnChange = true, isSelectedByUserInteraction: isSelectedByUserInteraction = true, viewActivity: viewActivity })=>{
    const { selectedIssueKey: selectedIssueKey } = getState();
    setState({
        _rememoize: Date.now()
    });
    shouldNotifyOnChange && onChange && onChange(selectedIssueKey, isSelectedByUserInteraction, viewActivity);
};
const $5de2eb3fb1196457$var$doDebouncedSideEffectUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))($5de2eb3fb1196457$var$doSideEffectUpdate, 600);
const $5de2eb3fb1196457$var$doSideEffectUpdates = (actions, options)=>{
    options.shouldDebounce ? $5de2eb3fb1196457$var$doDebouncedSideEffectUpdate(actions, options) : $5de2eb3fb1196457$var$doSideEffectUpdate(actions, options);
};
const $5de2eb3fb1196457$var$setSelectedIssueByKey = (selectedIssueKey, options = {})=>(actions, { onChange: onChange })=>{
        if (!selectedIssueKey.length) return false;
        actions.setState({
            selectedIssueKey: selectedIssueKey
        });
        $5de2eb3fb1196457$var$doSideEffectUpdates(actions, {
            ...options,
            onChange: onChange
        });
        return true;
    };
const $5de2eb3fb1196457$var$setSelectedIssueByIndex = (issueIndex, options)=>({ dispatch: dispatch }, { issueKeys: issueKeys })=>{
        return dispatch($5de2eb3fb1196457$var$setSelectedIssueByKey(issueKeys[issueIndex] ?? (0, $ljej9.toIssueKey)(''), options));
    };
/**
 * Select the next issue in the search results (if there is a valid selection). Returns `true` if an issue was selected,
 * otherwise `false`.
 */ const $5de2eb3fb1196457$var$selectNextIssue = (shouldDebounce)=>({ dispatch: dispatch, getState: getState })=>{
        return dispatch($5de2eb3fb1196457$var$setSelectedIssueByKey((0, $6fUhZ.getNextIssueKey)(getState()) ?? (0, $ljej9.toIssueKey)(''), {
            shouldDebounce: shouldDebounce
        }));
    };
/**
 * Select the previous issue in the search results (if there is a valid selection). Returns `true` if an issue was
 * selected, otherwise `false`.
 */ const $5de2eb3fb1196457$var$selectPreviousIssue = (shouldDebounce)=>({ dispatch: dispatch, getState: getState })=>{
        return dispatch($5de2eb3fb1196457$var$setSelectedIssueByKey((0, $6fUhZ.getPreviousIssueKey)(getState()) ?? (0, $ljej9.toIssueKey)(''), {
            shouldDebounce: shouldDebounce
        }));
    };
const $5de2eb3fb1196457$var$deselectIssue = (options)=>(actions, { onChange: onChange })=>{
        actions.setState({
            selectedIssueKey: (0, $ljej9.toIssueKey)('')
        });
        $5de2eb3fb1196457$var$doSideEffectUpdates(actions, {
            ...options,
            onChange: onChange
        });
    };
const $5de2eb3fb1196457$var$enterFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: true
        });
const $5de2eb3fb1196457$var$exitFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: false
        });
/**
 * Return true if we're in default list view mode without the full page issue app visible.
 */ const $5de2eb3fb1196457$var$isListViewWithoutIssueApp = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode } = getState();
        return view === (0, $iRahl.views).list && !isFullPageIssueAppMode;
    };
/**
 * Return true if we're in default list view mode with the full page issue app visible and a selected issue key.
 */ const $5de2eb3fb1196457$var$isListViewWithIssueAppAndKey = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode, selectedIssueKey: selectedIssueKey } = getState();
        return view === (0, $iRahl.views).list && isFullPageIssueAppMode && !!selectedIssueKey;
    };
/**
 * Reset the selected issue to the first issue in the connection.
 */ const $5de2eb3fb1196457$var$resetSelectedIssue = ()=>({ dispatch: dispatch })=>{
        // We only want to update issue key in the URL if our view mode uses external issue key selection, i.e. detail
        // view or full page issue app in list view. For the default list view mode we want to keep the selected issue
        // state internal.
        const shouldNotifyOnChange = !dispatch($5de2eb3fb1196457$var$isListViewWithoutIssueApp());
        dispatch($5de2eb3fb1196457$var$setSelectedIssueByIndex(0, {
            shouldDebounce: false,
            shouldNotifyOnChange: shouldNotifyOnChange,
            isSelectedByUserInteraction: false
        }));
    };
const $5de2eb3fb1196457$export$ab8f0de40a3a2d2d = ()=>({ setState: setState }, { issueKeys: issueKeys })=>{
        setState({
            issueKeys: issueKeys
        });
    };
const $5de2eb3fb1196457$export$e324594224ef24da = {
    setSelectedIssueByKey: $5de2eb3fb1196457$var$setSelectedIssueByKey,
    setSelectedIssueByIndex: $5de2eb3fb1196457$var$setSelectedIssueByIndex,
    selectNextIssue: $5de2eb3fb1196457$var$selectNextIssue,
    selectPreviousIssue: $5de2eb3fb1196457$var$selectPreviousIssue,
    deselectIssue: $5de2eb3fb1196457$var$deselectIssue,
    enterFullPageIssueAppMode: $5de2eb3fb1196457$var$enterFullPageIssueAppMode,
    exitFullPageIssueAppMode: $5de2eb3fb1196457$var$exitFullPageIssueAppMode
};
const $5de2eb3fb1196457$export$3f1be494d407b77a = {
    isListViewWithoutIssueApp: $5de2eb3fb1196457$var$isListViewWithoutIssueApp,
    isListViewWithIssueAppAndKey: $5de2eb3fb1196457$var$isListViewWithIssueAppAndKey,
    resetSelectedIssue: $5de2eb3fb1196457$var$resetSelectedIssue,
    onContainerUpdate: $5de2eb3fb1196457$export$ab8f0de40a3a2d2d
};
var $5de2eb3fb1196457$export$2e2bcd8739ae039 = $5de2eb3fb1196457$export$e324594224ef24da;

});
parcelRegister("6fUhZ", function(module, exports) {

$parcel$export(module.exports, "getSelectedIssueIndex", () => $b490591c01d668ee$export$b5bba5025e9754c0);
$parcel$export(module.exports, "getNextIssueKey", () => $b490591c01d668ee$export$2a413bfa3aeed781);
$parcel$export(module.exports, "getPreviousIssueKey", () => $b490591c01d668ee$export$5e257a264fce89f7);
$parcel$export(module.exports, "getIssuesCount", () => $b490591c01d668ee$export$af7642e9bc434b70);

var $4MchI = parcelRequire("4MchI");
const $b490591c01d668ee$export$b5bba5025e9754c0 = (0, $4MchI.createSelector)((state)=>state.selectedIssueKey, (state)=>state.issueKeys, (selectedIssueKey, issueKeys)=>issueKeys.indexOf(selectedIssueKey));
const $b490591c01d668ee$export$2a413bfa3aeed781 = (state)=>{
    const index = $b490591c01d668ee$export$b5bba5025e9754c0(state);
    const { issueKeys: issueKeys } = state;
    return index > -1 && index < issueKeys.length - 1 ? issueKeys[index + 1] : null;
};
const $b490591c01d668ee$export$5e257a264fce89f7 = (state)=>{
    const index = $b490591c01d668ee$export$b5bba5025e9754c0(state);
    const { issueKeys: issueKeys } = state;
    return index > 0 ? issueKeys[index - 1] : null;
};
const $b490591c01d668ee$export$af7642e9bc434b70 = (state)=>{
    return state.issueKeys.length;
};

});




parcelRegister("lvpZz", function(module, exports) {

$parcel$export(module.exports, "FlatListIssuesContainer", () => $b8491aab06161461$export$60cae405c8bdaa87);
$parcel$export(module.exports, "useFlatListIssuesActions", () => $b8491aab06161461$export$14d48bac80618630);
$parcel$export(module.exports, "useFlatListIssues", () => $b8491aab06161461$export$a53e6810bcedfe4d);
$parcel$export(module.exports, "useFlatListIssueIds", () => $b8491aab06161461$export$440fc5b87687d980);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $b8491aab06161461$export$60cae405c8bdaa87 = (0, $6E16M.createContainer)();
const $b8491aab06161461$var$initialState = {
    flatListIssues: [],
    flatListIssueIds: []
};
const $b8491aab06161461$var$actions = {
    setFlatListIssueIds: (flatListIssueIds)=>({ setState: setState })=>{
            setState({
                flatListIssueIds: flatListIssueIds
            });
        },
    setFlatListIssues: (flatListIssues)=>({ setState: setState })=>{
            setState({
                flatListIssues: flatListIssues
            });
        }
};
const $b8491aab06161461$var$Store = (0, $GtRbT.createStore)({
    containedBy: $b8491aab06161461$export$60cae405c8bdaa87,
    initialState: $b8491aab06161461$var$initialState,
    actions: $b8491aab06161461$var$actions,
    name: 'jira-native-issue-table-flat-list-issues-store'
});
const $b8491aab06161461$export$14d48bac80618630 = (0, $iJq0l.createActionsHook)($b8491aab06161461$var$Store);
const $b8491aab06161461$export$2868636f0c1a29ec = (0, $iJq0l.createHook)($b8491aab06161461$var$Store);
const $b8491aab06161461$var$getFlatListIssuesSelector = (state)=>state.flatListIssues;
const $b8491aab06161461$export$a53e6810bcedfe4d = (0, $iJq0l.createStateHook)($b8491aab06161461$var$Store, {
    selector: $b8491aab06161461$var$getFlatListIssuesSelector
});
const $b8491aab06161461$var$getFlatListIssueIdsSelector = (state)=>state.flatListIssueIds;
const $b8491aab06161461$export$440fc5b87687d980 = (0, $iJq0l.createStateHook)($b8491aab06161461$var$Store, {
    selector: $b8491aab06161461$var$getFlatListIssueIdsSelector
});

});

parcelRegister("7EogO", function(module, exports) {

$parcel$export(module.exports, "useSetJql", () => $2eab1b44c4fd2709$export$9d7223d88c9d8536);

var $7y2Eh = parcelRequire("7y2Eh");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $K4WWF = parcelRequire("K4WWF");
const $2eab1b44c4fd2709$export$9d7223d88c9d8536 = ()=>{
    const [commit] = (0, $j4oe4.useMutation)((0, $7y2Eh.default));
    return (0, $eJOHy.useCallback)(({ jql: jql, viewARI: viewARI })=>{
        const handleError = (error)=>{
            (0, $gYnSx.default)({
                sendToPrivacyUnsafeSplunk: true,
                error: error,
                meta: {
                    id: 'setJqlMutation',
                    packageName: 'jiraIssueNavigator',
                    teamName: 'empanada'
                }
            });
        };
        commit({
            variables: {
                input: {
                    jql: jql,
                    viewId: viewARI
                }
            },
            onError: handleError,
            onCompleted (response) {
                if (response.jira_setIssueSearchJql?.success !== true) {
                    const error = response.jira_setIssueSearchJql?.errors?.[0];
                    const statusCode = error?.extensions?.statusCode ?? 0;
                    const isClientError = statusCode >= 400 && statusCode < 500;
                    /*
           * The mutation will return a validation error if the provided JQL string is not syntactically correct.
           * This is already handled by the filter component, so we don't need to handle it here.
           */ if (!isClientError) {
                        const mutationError = new (0, $K4WWF.MutationErrorCollection)(response.jira_setIssueSearchJql?.errors);
                        handleError(mutationError);
                    }
                }
            }
        });
    }, [
        commit
    ]);
};

});
parcelRegister("7y2Eh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee870bcc029adfd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cce1804fdef0b42eb3a31531aed52f55>>
 * @relayHash 050c4c1a18ae3e6423b1092f20b0a143
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9740d3bdc782b2bd679b29fe3690aa38460f5633d020ea9c91f52f6308c116a5
const $0ee870bcc029adfd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setJqlMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetIssueSearchJqlPayload",
                    "kind": "LinkedField",
                    "name": "jira_setIssueSearchJql",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setJqlMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetIssueSearchJqlPayload",
                    "kind": "LinkedField",
                    "name": "jira_setIssueSearchJql",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9740d3bdc782b2bd679b29fe3690aa38460f5633d020ea9c91f52f6308c116a5",
            "metadata": {},
            "name": "setJqlMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0ee870bcc029adfd$var$node.hash = "3c85daac11a42bc3abe49021df8b3785";
var $0ee870bcc029adfd$export$2e2bcd8739ae039 = $0ee870bcc029adfd$var$node;

});

parcelRegister("K4WWF", function(module, exports) {

$parcel$export(module.exports, "MutationErrorCollection", () => $2cd8a73f7b8deda9$export$d22c6cedeb9f13e);

var $emHXA = parcelRequire("emHXA");
class $2cd8a73f7b8deda9$export$d22c6cedeb9f13e extends Error {
    constructor(errors){
        const errorMessage = (0, $emHXA.combineErrorMessages)(errors) ?? 'Unknown error';
        super(errorMessage);
        this.message = errorMessage;
    }
}

});
parcelRegister("emHXA", function(module, exports) {

$parcel$export(module.exports, "combineErrorMessages", () => $fbde4ab0161d07a6$export$8a753d214a739485);
/**
 * Formats a mutation error payload into a readable error message string.
 *
 * @param error - The mutation error payload which can be of type `MutationErrorPayload`, `null`, or `undefined`.
 * @returns A formatted error message string.
 *
 * The formatted message includes:
 * - The `__typename` from the `extensions` property, if available, enclosed in parentheses.
 * - The `errorType` from the `extensions` property, if available, enclosed in square brackets.
 * - The `statusCode` from the `extensions` property, if available, prefixed with "HTTP".
 * - The main error message.
 *
 * The parts are concatenated with spaces and any `null` or `undefined` values are filtered out.
 */ function $fbde4ab0161d07a6$var$formatErrorMessage(error) {
    const { message: message, extensions: extensions } = error ?? {};
    return [
        extensions?.__typename && `(${extensions.__typename})`,
        extensions?.errorType && `[${extensions.errorType}]`,
        extensions?.statusCode && `HTTP ${extensions.statusCode}:`,
        message
    ].filter(Boolean).join(' ').trim();
}
function $fbde4ab0161d07a6$export$8a753d214a739485(errors) {
    return errors?.map($fbde4ab0161d07a6$var$formatErrorMessage)?.filter(Boolean)?.join('; ') || undefined;
}

});



parcelRegister("6Al27", function(module, exports) {

$parcel$export(module.exports, "IFCEntryPointContextProvider", () => $c662cbd253f72d54$export$b1528524caf51b8b);
$parcel$export(module.exports, "useIFCEntryPointContext", () => $c662cbd253f72d54$export$caffdf0d268fddd7);

var $eJOHy = parcelRequire("eJOHy");

var $kuFbR = parcelRequire("kuFbR");

var $bbdV2 = parcelRequire("bbdV2");

var $hwgUG = parcelRequire("hwgUG");
const $c662cbd253f72d54$export$ed5ff4845085aae5 = (0, $kuFbR.createUseEntryPointContext)();
const $c662cbd253f72d54$var$entryPointParams = {};
const $c662cbd253f72d54$export$b1528524caf51b8b = ({ children: children })=>{
    const entryPointResult = (0, $bbdV2.useEntryPoint)((0, $hwgUG.ifcEntryPoint), $c662cbd253f72d54$var$entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c662cbd253f72d54$export$ed5ff4845085aae5.Provider, {
        value: entryPointResult
    }, children);
};
const $c662cbd253f72d54$export$caffdf0d268fddd7 = ()=>{
    return (0, $eJOHy.useContext)($c662cbd253f72d54$export$ed5ff4845085aae5);
};

});
parcelRegister("hwgUG", function(module, exports) {

$parcel$export(module.exports, "ifcEntryPoint", () => $00a87beeb64e5a63$export$26521842160defa7);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $00a87beeb64e5a63$export$26521842160defa7 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("7RiP4")), {
        moduleId: "6c18a40d",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7RiP4", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("kNFvF"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("lyxWA")
]).then(()=>parcelRequire('dEmav'));

});



parcelRegister("l7VRV", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsWrapper", () => $ddbcdd795fd2ca39$export$88a2a475d15f0a71);

var $ep7EZ = parcelRequire("ep7EZ");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $gkScf = parcelRequire("gkScf");

var $i8Pje = parcelRequire("i8Pje");

var $3TtKq = parcelRequire("3TtKq");

var $7jTnu = parcelRequire("7jTnu");

var $6d9QY = parcelRequire("6d9QY");

var $lvpZz = parcelRequire("lvpZz");

var $HiS1C = parcelRequire("HiS1C");

var $fwKw5 = parcelRequire("fwKw5");
const $ddbcdd795fd2ca39$var$EMPTY_ARRAY = [];
const $ddbcdd795fd2ca39$var$LoadBulkOpsCore = ({ bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference, fragmentRef: fragmentRef })=>{
    const selectedIssues = (0, $3TtKq.useIssueTableSelectedIssues)();
    const { reset: reset, insertSelectedIssueIds: insertSelectedIssueIds } = (0, $3TtKq.useIssueTableSelectedIssuesActions)();
    const view = (0, $HiS1C.useSelectedView)();
    const { jql: jql } = (0, $fwKw5.useActiveJql)();
    const previousJql = (0, $6d9QY.usePrevious)(jql);
    (0, $eJOHy.useEffect)(()=>{
        if (jql !== previousJql && previousJql !== undefined) reset();
    }, [
        jql,
        previousJql,
        reset
    ]);
    let issuesFlatListIds = $ddbcdd795fd2ca39$var$EMPTY_ARRAY;
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    issuesFlatListIds = (0, $lvpZz.useFlatListIssueIds)();
    const data = (0, $j4oe4.useFragment)((0, $ep7EZ.default), fragmentRef);
    // we don't need to read issueIds for grouping from the query because we already have them in the flat list
    const issueIds = (0, $eJOHy.useMemo)(()=>{
        if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) return {
            strings: issuesFlatListIds,
            numbers: issuesFlatListIds.map((issueId)=>Number(issueId))
        };
        const strings = data?.edges?.map((edge)=>edge?.node?.issueId).filter(Boolean) ?? [];
        return {
            strings: strings,
            numbers: strings.map((issueId)=>Number(issueId))
        };
    }, [
        data?.edges,
        issuesFlatListIds
    ]);
    const onSelectAll = (0, $eJOHy.useCallback)(()=>{
        insertSelectedIssueIds(issueIds.strings);
    }, [
        issueIds.strings,
        insertSelectedIssueIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8Pje.AsyncBulkOpsCoreFull), {
        bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference,
        selectedIssueIds: selectedIssues.map((issue)=>Number(issue)),
        onClearAll: reset,
        onSelectAll: onSelectAll,
        selectableIssueIds: issueIds.numbers,
        onClearAllVisible: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        shouldHideToolbar: view === 'detail'
    });
};
const $ddbcdd795fd2ca39$export$88a2a475d15f0a71 = ({ children: children, bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference, fragmentRef: fragmentRef })=>{
    const isBulkOpsInProgress = (0, $gkScf.useIsBulkOperationsInProgress)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $ddbcdd795fd2ca39$var$wrapperStyles,
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $ddbcdd795fd2ca39$var$childContainerStyles,
            isBulkOpsInProgress && $ddbcdd795fd2ca39$var$childContainerDisabledStyles
        ]
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ddbcdd795fd2ca39$var$LoadBulkOpsCore, {
        fragmentRef: fragmentRef,
        bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference
    }));
};
const $ddbcdd795fd2ca39$var$wrapperStyles = (0, $1DXK0.xcss)({
    height: '100%',
    overflowY: 'auto'
});
const $ddbcdd795fd2ca39$var$childContainerStyles = (0, $1DXK0.xcss)({
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    overflowY: 'auto'
});
const $ddbcdd795fd2ca39$var$childContainerDisabledStyles = (0, $1DXK0.xcss)({
    opacity: 0.5,
    pointerEvents: 'none'
});

});
parcelRegister("ep7EZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2df61609193315f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9447c66ceb43590970549d094be1fa98>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b2df61609193315f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "bulkOperationsWrapper_issueNavigator_LoadBulkOpsCore",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$b2df61609193315f$var$node.hash = "3ef50a3a9b158093691740d555608365";
var $b2df61609193315f$export$2e2bcd8739ae039 = $b2df61609193315f$var$node;

});

parcelRegister("gkScf", function(module, exports) {

$parcel$export(module.exports, "useBulkOperations", () => $1ef65add752592bf$export$940587be18a93fc4);
$parcel$export(module.exports, "useBulkOperationsActions", () => $1ef65add752592bf$export$355499dfde532d1a);
$parcel$export(module.exports, "useIsBulkOperationsInProgress", () => $1ef65add752592bf$export$760458c2204457a1);
$parcel$export(module.exports, "useShouldRenderSpotlight", () => $1ef65add752592bf$export$4a165cf2377f023a);
$parcel$export(module.exports, "useBulkTransitionsStage", () => $1ef65add752592bf$export$b3afff39a0c663ad);
$parcel$export(module.exports, "useBulkOperationInForm", () => $1ef65add752592bf$export$6794339387d6d562);
$parcel$export(module.exports, "useBulkOperationType", () => $1ef65add752592bf$export$4289f82da677ffac);
$parcel$export(module.exports, "useCancelDialogTrigger", () => $1ef65add752592bf$export$babceeeb2408337b);
$parcel$export(module.exports, "useCurrentView", () => $1ef65add752592bf$export$8ce7af7b2f8c770);

var $gCeeo = parcelRequire("gCeeo");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7jTnu = parcelRequire("7jTnu");

var $1oPJB = parcelRequire("1oPJB");

var $d9gBN = parcelRequire("d9gBN");
const $1ef65add752592bf$export$d4c72bab9d6cc13a = {
    operationType: null,
    isSidebarOpen: false,
    cancelDialogTrigger: undefined,
    currentView: 'edit',
    firstFieldId: undefined,
    operationStartTime: null,
    isInProgress: false
};
const $1ef65add752592bf$var$actions = {
    setSummaryView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'summary'
            });
        },
    setFirstFieldId: (firstFieldId)=>({ setState: setState })=>{
            setState({
                firstFieldId: firstFieldId
            });
        },
    setEditView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'edit'
            });
        },
    setCancelDialogTrigger: (newTrigger = 'user-triggered')=>({ setState: setState, getState: getState })=>{
            const { cancelDialogTrigger: currentTrigger } = getState();
            /* Sometimes both events can be fired (route change & onclick) in one loop
					We need to prioritise route-change event  */ if (currentTrigger === 'route-change' && newTrigger === 'user-triggered') return;
            setState({
                cancelDialogTrigger: newTrigger
            });
        },
    clearDialogTrigger: ()=>({ setState: setState })=>{
            setState({
                cancelDialogTrigger: undefined
            });
        },
    startEdit: (args)=>({ setState: setState })=>{
            const { shouldRenderSpotlight: shouldRenderSpotlight } = args || {
                shouldRenderSpotlight: false
            };
            setState({
                operationType: {
                    type: (0, $d9gBN.BulkOperationsTypes).BULK_EDIT
                },
                shouldRenderSpotlight: shouldRenderSpotlight,
                isSidebarOpen: true,
                operationStartTime: performance.now(),
                isInProgress: (0, $7jTnu.fg)('dee-7206-add-bulk-ops-type-to-analytics')
            });
        },
    loadTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $d9gBN.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $d9gBN.BulkTransitionsStage).LOAD_BULK_TRANSITIONS
                },
                isSidebarOpen: false,
                isInProgress: (0, $7jTnu.fg)('dee-7206-add-bulk-ops-type-to-analytics')
            });
        },
    startQuickTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $d9gBN.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $d9gBN.BulkTransitionsStage).START_QUICK_TRANSITIONS
                },
                isSidebarOpen: false,
                operationStartTime: performance.now(),
                isInProgress: (0, $7jTnu.fg)('dee-7206-add-bulk-ops-type-to-analytics')
            });
        },
    startSidebarTransition: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $d9gBN.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $d9gBN.BulkTransitionsStage).START_SIDEBAR_TRANSITION
                },
                isSidebarOpen: true,
                operationStartTime: performance.now(),
                isInProgress: (0, $7jTnu.fg)('dee-7206-add-bulk-ops-type-to-analytics')
            });
        },
    startTransitionScreen: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $d9gBN.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $d9gBN.BulkTransitionsStage).START_TRANSITION_SCREEN
                },
                isSidebarOpen: true,
                isInProgress: (0, $7jTnu.fg)('dee-7206-add-bulk-ops-type-to-analytics')
            });
        },
    dismissBulkOperation: ({ createAnalyticsEvent: createAnalyticsEvent, dismissType: dismissType })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const analyticsEvent = createAnalyticsEvent({});
            const operationEndTime = performance.now();
            const operationTimeTaken = currentState.operationStartTime ? operationEndTime - currentState.operationStartTime : null;
            (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'dismissed bulkOperations', {
                dismissType: dismissType,
                operationTimeTaken: operationTimeTaken
            });
            (0, $1oPJB.extraFormDataService).clear();
            // we want the operation type to persist after a submit
            // so that is still available for the success flag analytics
            // so we are only toggling isInProgress here to make the UI interactable again
            if ((0, $d9gBN.BulkOperationsDismissSubmit).includes(dismissType) && (0, $7jTnu.fg)('dee-7206-add-bulk-ops-type-to-analytics')) setState({
                ...currentState,
                isInProgress: false
            });
            else setState($1ef65add752592bf$export$d4c72bab9d6cc13a);
        },
    setBulkOperation: (bulkOperationType)=>({ setState: setState })=>{
            setState({
                isSidebarOpen: false,
                operationType: {
                    type: bulkOperationType
                },
                operationStartTime: performance.now(),
                isInProgress: true
            });
        },
    resetState: ()=>({ setState: setState })=>{
            setState($1ef65add752592bf$export$d4c72bab9d6cc13a);
        }
};
const $1ef65add752592bf$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    initialState: $1ef65add752592bf$export$d4c72bab9d6cc13a,
    actions: $1ef65add752592bf$var$actions,
    name: 'bulk-operations-store'
});
const $1ef65add752592bf$export$940587be18a93fc4 = (0, $iJq0l.createHook)($1ef65add752592bf$export$6f57813fe9f31bf9);
const $1ef65add752592bf$export$355499dfde532d1a = (0, $iJq0l.createActionsHook)($1ef65add752592bf$export$6f57813fe9f31bf9);
const $1ef65add752592bf$export$760458c2204457a1 = (0, $iJq0l.createStateHook)($1ef65add752592bf$export$6f57813fe9f31bf9, {
    selector: (state)=>(0, $7jTnu.fg)('dee-7206-add-bulk-ops-type-to-analytics') ? state.isInProgress : state.operationType !== null
});
const $1ef65add752592bf$export$4a165cf2377f023a = (0, $iJq0l.createStateHook)($1ef65add752592bf$export$6f57813fe9f31bf9, {
    selector: (state)=>!!state.shouldRenderSpotlight
});
const $1ef65add752592bf$export$b3afff39a0c663ad = (0, $iJq0l.createStateHook)($1ef65add752592bf$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        const { operationType: operationType } = state;
        if (operationType?.type === (0, $d9gBN.BulkOperationsTypes).BULK_TRANSITION) return operationType.stage;
        return null;
    }
});
const $1ef65add752592bf$export$6794339387d6d562 = (0, $iJq0l.createStateHook)($1ef65add752592bf$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        if (state.isSidebarOpen && state.isInProgress && (0, $7jTnu.fg)('dee-7206-add-bulk-ops-type-to-analytics')) return state.operationType.type;
        if (state.isSidebarOpen && state.operationType && !(0, $7jTnu.fg)('dee-7206-add-bulk-ops-type-to-analytics')) return state.operationType.type;
        return null;
    }
});
const $1ef65add752592bf$export$4289f82da677ffac = (0, $iJq0l.createStateHook)($1ef65add752592bf$export$6f57813fe9f31bf9, {
    selector: (state)=>state.operationType
});
const $1ef65add752592bf$export$babceeeb2408337b = (0, $iJq0l.createStateHook)($1ef65add752592bf$export$6f57813fe9f31bf9, {
    selector: (state)=>state.cancelDialogTrigger
});
const $1ef65add752592bf$export$8ce7af7b2f8c770 = (0, $iJq0l.createStateHook)($1ef65add752592bf$export$6f57813fe9f31bf9, {
    selector: (state)=>state.currentView
});

});
parcelRegister("1oPJB", function(module, exports) {

$parcel$export(module.exports, "extraFormDataService", () => $a326de00f3659dc2$export$3cd9d97d155e8e66);
class $a326de00f3659dc2$var$ExtraFormData {
    clear() {
        this.data = {};
    }
    addByKey(key, value) {
        this.data[key] = value;
    }
    getByKey(key) {
        return this.data[key];
    }
    getAll() {
        return this.data;
    }
    constructor(){
        this.data = {};
    }
}
const $a326de00f3659dc2$var$extraFormData = new $a326de00f3659dc2$var$ExtraFormData();
const $a326de00f3659dc2$var$addDataByKey = (key, value)=>{
    $a326de00f3659dc2$var$extraFormData.addByKey(key, value);
};
const $a326de00f3659dc2$var$clear = ()=>{
    $a326de00f3659dc2$var$extraFormData.clear();
};
const $a326de00f3659dc2$var$getDataByKey = (key)=>$a326de00f3659dc2$var$extraFormData.getByKey(key);
const $a326de00f3659dc2$var$getData = ()=>$a326de00f3659dc2$var$extraFormData.getAll();
const $a326de00f3659dc2$export$3cd9d97d155e8e66 = {
    addDataByKey: $a326de00f3659dc2$var$addDataByKey,
    getDataByKey: $a326de00f3659dc2$var$getDataByKey,
    clear: $a326de00f3659dc2$var$clear,
    getData: $a326de00f3659dc2$var$getData
};

});

parcelRegister("d9gBN", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsTypes", () => $16677cc8a1f3f684$export$7ec2782f56bb6e02);
$parcel$export(module.exports, "BulkTransitionsStage", () => $16677cc8a1f3f684$export$a6f51fa6c8971716);
$parcel$export(module.exports, "BulkOperationsDismissSubmit", () => $16677cc8a1f3f684$export$b3f88f42a8b7de67);
const $16677cc8a1f3f684$export$7ec2782f56bb6e02 = {
    BULK_EDIT: 'BULK_EDIT',
    BULK_TRANSITION: 'BULK_TRANSITION',
    BULK_DELETE: 'BULK_DELETE',
    BULK_WATCH: 'BULK_WATCH',
    BULK_UNWATCH: 'BULK_UNWATCH'
};
const $16677cc8a1f3f684$export$a6f51fa6c8971716 = {
    LOAD_BULK_TRANSITIONS: 'LOAD_BULK_TRANSITIONS',
    START_QUICK_TRANSITIONS: 'START_QUICK_TRANSITIONS',
    START_SIDEBAR_TRANSITION: 'START_SIDEBAR_TRANSITION',
    START_TRANSITION_SCREEN: 'START_TRANSITION_SCREEN'
};
const $16677cc8a1f3f684$export$1550a2cc6d56ae33 = {
    // ERRORS //
    ERROR_BULK_EDIT: 'ERROR_BULK_EDIT',
    ERROR_BULK_TRANSITION: 'ERROR_BULK_TRANSITION',
    ERROR_BULK_TRANSITION_SCREEN_MOUNT: 'ERROR_BULK_TRANSITION_SCREEN_MOUNT',
    ERROR_BULK_DELETE: 'ERROR_BULK_DELETE',
    // BULK EDIT //
    EDIT_FORM_PRISTINE_CANCEL: 'EDIT_FORM_PRISTINE_CANCEL',
    EDIT_FORM_DIRTY_CANCEL: 'EDIT_FORM_DIRTY_CANCEL',
    EDIT_FORM_SUMMARY_CANCEL: 'EDIT_FORM_SUMMARY_CANCEL',
    EDIT_ATTEMPT_SUBMIT: 'EDIT_ATTEMPT_SUBMIT',
    // TRANSITION DIALOG //
    TRANSITION_DIALOG_PRISTINE_CANCEL: 'TRANSITION_DIALOG_PRISTINE_CANCEL',
    TRANSITION_DIALOG_DIRTY_CANCEL: 'TRANSITION_DIALOG_DIRTY_CANCEL',
    TRANSITION_DIALOG_CANT_CONTINUE_WARNING: 'TRANSITION_DIALOG_CANT_CONTINUE_WARNING',
    TRANSITION_DIALOG_ATTEMPT_SUBMIT: 'TRANSITION_DIALOG_ATTEMPT_SUBMIT',
    // TRANSITION FORM //
    TRANSITION_FORM_PRISTINE_CANCEL: 'TRANSITION_FORM_PRISTINE_CANCEL',
    TRANSITION_FORM_DIRTY_CANCEL: 'TRANSITION_FORM_DIRTY_CANCEL',
    TRANSITION_FORM_ATTEMPT_SUBMIT: 'TRANSITION_FORM_ATTEMPT_SUBMIT',
    // TRANSITION WITH SCREEN //
    TRANSITION_WITH_SCREEN_LEGACY_LINK: 'TRANSITION_WITH_SCREEN_LEGACY_LINK',
    TRANSITION_WITH_SCREEN_SUMMARY_CANCEL: 'TRANSITION_WITH_SCREEN_SUMMARY_CANCEL',
    TRANSITION_WITH_SCREEN_CANCEL: 'TRANSITION_WITH_SCREEN_CANCEL',
    TRANSITION_WITH_SCREEN_CANCEL_REQUIRED_ERROR: 'TRANSITION_WITH_SCREEN_CANCEL_REQUIRED_ERROR',
    // BULK DELETE //
    DELETE_ATTEMPT_SUBMIT: 'DELETE_ATTEMPT_SUBMIT',
    DELETE_ATTEMPT_CANCEL: 'DELETE_CANCEL',
    // BULK WATCH //
    WATCH_ATTEMPT_SUBMIT: 'WATCH_ATTEMPT_SUBMIT',
    // BULK UNWATCH //
    UNWATCH_ATTEMPT_SUBMIT: 'UNWATCH_ATTEMPT_SUBMIT',
    // OTHER //
    NAVIGATION: 'NAVIGATION',
    DESELECT_ALL_ISSUES: 'DESELECT_ALL_ISSUES'
};
const $16677cc8a1f3f684$export$b3f88f42a8b7de67 = [
    'EDIT_ATTEMPT_SUBMIT',
    'TRANSITION_DIALOG_ATTEMPT_SUBMIT',
    'TRANSITION_FORM_ATTEMPT_SUBMIT',
    'DELETE_ATTEMPT_SUBMIT',
    'DESELECT_ALL_ISSUES',
    'WATCH_ATTEMPT_SUBMIT',
    'UNWATCH_ATTEMPT_SUBMIT'
];

});


parcelRegister("i8Pje", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkOpsCoreFull", () => $28aacd361882ee10$export$5a522923c01d18f2);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $kEUB1 = parcelRequire("kEUB1");

var $6dASY = parcelRequire("6dASY");
const $28aacd361882ee10$export$5a522923c01d18f2 = (props)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $6dASY.asyncBulkOpsCoreFullEntryPoint), entryPointParams);
    // This type conversion fixes the below CI build error
    // Type 'Omit<BulkOperationsCoreLoader<TEntryPoint>, "hasBulkEditPermission">' is not assignable to type 'Omit<BulkOperationsCoreLoader<AnyEntryPoint | undefined>, "hasBulkEditPermission">'
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fixedEntryPointReferenceSubject = entryPointReferenceSubject;
    // this is to reduce the load to NIN when adding bulk ops
    // we should revisit later to remove this and load bulk ops same as the way backlog loads
    // https://hello.jira.atlassian.cloud/browse/DEE-6353
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira.backlog.bulk.operations.core.full",
        packageName: "jiraBulkOperationsCoreFull",
        entryPointReferenceSubject: fixedEntryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        runtimeProps: props
    });
};

});
parcelRegister("6dASY", function(module, exports) {

$parcel$export(module.exports, "asyncBulkOpsCoreFullEntryPoint", () => $c8340555c6e3ab55$export$4586bee469e9f8fc);

var $4mRrV = parcelRequire("4mRrV");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $c8340555c6e3ab55$export$4586bee469e9f8fc = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("l5cuW")), {
        moduleId: "6ba164f7",
        moduleName: "EntryPointContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                permissionsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $4mRrV.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("4mRrV", function(module, exports) {

$parcel$export(module.exports, "default", () => $56ee1cca44831962$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ff206ebda9a705400bfa93f15db0e6c>>
 * @relayHash 47b6bed432e93d293b71d554de9d22cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e6818c1b5edb7793a16ffa9f89aef19e1986ebf11c163e4b84b6c6c60cf8d8d
const $56ee1cca44831962$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "8e6818c1b5edb7793a16ffa9f89aef19e1986ebf11c163e4b84b6c6c60cf8d8d",
        "metadata": {},
        "name": "EntryPointContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $56ee1cca44831962$export$2e2bcd8739ae039 = $56ee1cca44831962$var$node;

});

parcelRegister("l5cuW", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("l0KDU").then(()=>parcelRequire('bxZ8e'));

});




parcelRegister("cZQDI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4d70ecffed600f0$export$2e2bcd8739ae039);

var $3dxCR = parcelRequire("3dxCR");

var $ae3vc = parcelRequire("ae3vc");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $b5RwB = parcelRequire("b5RwB");

var $goZPP = parcelRequire("goZPP");

var $3IF6p = parcelRequire("3IF6p");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $ljej9 = parcelRequire("ljej9");

var $4Oene = parcelRequire("4Oene");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");

var $ivzXw = parcelRequire("ivzXw");

var $iRahl = parcelRequire("iRahl");

var $6Bi4o = parcelRequire("6Bi4o");

var $1wL9i = parcelRequire("1wL9i");

var $7emTO = parcelRequire("7emTO");

var $3kDjB = parcelRequire("3kDjB");

var $bICwA = parcelRequire("bICwA");
const $c4d70ecffed600f0$var$useAnalyticsAttributes = (type)=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    return (0, $eJOHy.useMemo)(()=>{
        if (!type) return;
        const projectType = (0, $ln6Iy.toProjectType)(type.toLowerCase());
        if (!projectType) return;
        const edition = (0, $a9ldn.getEditionForProject)(projectType, appEditions);
        if (!edition) return;
        return {
            edition: edition
        };
    }, [
        appEditions,
        type
    ]);
};
const $c4d70ecffed600f0$var$FullPageIssueApp = ({ onChangeIssue: onChangeIssue, issueResults: issueResults, view: view, projectType: projectType, routePathname: routePathname, routeSearch: routeSearch })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isFetching = (0, $3kDjB.useIsFetching)();
    const { exitFullPageIssueAppMode: exitFullPageIssueAppMode, selectNextIssue: selectNextIssue, selectPreviousIssue: selectPreviousIssue } = (0, $1wL9i.useSelectedIssueActions)();
    const onBackToSearch = (0, $eJOHy.useCallback)(()=>{
        // Clear the selected issue key from the URL and return to normal view mode
        onChangeIssue((0, $ljej9.toIssueKey)(''), true);
        exitFullPageIssueAppMode();
    }, [
        exitFullPageIssueAppMode,
        onChangeIssue
    ]);
    const onBackToSearchByButton = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent.clone(), 'returnToSearch');
        onBackToSearch();
    }, [
        onBackToSearch
    ]);
    const onBackToSearchByKeyboardShortcut = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'issue'
        }), 'returnToSearch', {
            keyPressed: 'z',
            keyboardShortcut: true
        });
        onBackToSearch();
    }, [
        onBackToSearch,
        createAnalyticsEvent
    ]);
    const onNextIssue = (0, $eJOHy.useCallback)(()=>{
        if (selectNextIssue()) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'nextIssue', {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        selectNextIssue
    ]);
    const onPreviousIssue = (0, $eJOHy.useCallback)(()=>{
        if (selectPreviousIssue()) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'previousIssue', {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        selectPreviousIssue
    ]);
    // If a new search is being run and we do not have forced issue selection (i.e. issue app pagination) then return to
    // normal view mode. This can happen when a filter is clicked in the sidebar or browser history navigation.
    (0, $eJOHy.useEffect)(()=>{
        if (isFetching) exitFullPageIssueAppMode();
    }, [
        exitFullPageIssueAppMode,
        isFetching
    ]);
    const backToSearch = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        testId: "issue-navigator.ui.full-page-issue-app.return-to-search",
        onClick: onBackToSearchByButton,
        interactionName: "issue-navigator-full-page-issue-app-return-to-search"
    }, formatMessage((0, $bICwA.default).returnText));
    const issueResultsData = (0, $j4oe4.useFragment)((0, $ae3vc.default), issueResults);
    const viewData = (0, $j4oe4.useFragment)((0, $3dxCR.default), view);
    const fieldSetIds = (0, $eJOHy.useMemo)(()=>viewData?.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData?.fieldSets?.edges
    ]);
    const { hasPrevious: hasPrevious, isLoadingPrevious: isLoadingPrevious, onLoadPrevious: onLoadPrevious, hasNext: hasNext, isLoadingNext: isLoadingNext, onLoadNext: onLoadNext } = (0, $7emTO.useInfiniteScroll)({
        fieldSetIds: fieldSetIds,
        view: null
    });
    const selectedIssueKey = (0, $1wL9i.useSelectedIssueKey)();
    const edges = issueResultsData?.edges ?? [];
    const isFirstIssueSelected = edges[0]?.node?.key === selectedIssueKey;
    const isLastIssueSelected = edges[edges.length - 1]?.node?.key === selectedIssueKey;
    // Automatically fetch previous and next pages while navigating issues in full page mode
    (0, $eJOHy.useEffect)(()=>{
        if (isFirstIssueSelected && hasPrevious && !isLoadingPrevious) onLoadPrevious?.();
    }, [
        hasPrevious,
        isFirstIssueSelected,
        isLoadingPrevious,
        onLoadPrevious
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isLastIssueSelected && hasNext && !isLoadingNext) onLoadNext?.();
    }, [
        hasNext,
        isLastIssueSelected,
        isLoadingNext,
        onLoadNext
    ]);
    let attributes;
    if ((0, $7jTnu.fg)('add-attribute-required-for-colorful-labels-expe')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    attributes = $c4d70ecffed600f0$var$useAnalyticsAttributes(projectType);
    let backButtonUrl;
    if ((0, $7jTnu.fg)('empanada_nin_migrate_full_page_issue_nav')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    backButtonUrl = (0, $eJOHy.useMemo)(()=>{
        // Not using browser parsing API because it changes spaces to `+`
        const params = (0, $b5RwB.parse)(routeSearch);
        delete params.selectedIssue;
        return `${routePathname}?${(0, $b5RwB.stringify)(params)}`;
    }, [
        routeSearch,
        routePathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "full-page-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: (0, $iRahl.ANALYTICS_LIST_VIEW_SOURCE_NAME),
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        ...attributes ? {
            attributes: attributes
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3IF6p.default), {
        keyMap: {
            z: {
                callback: onBackToSearchByKeyboardShortcut
            },
            j: {
                callback: onNextIssue
            },
            k: {
                callback: onPreviousIssue
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Bi4o.default), {
        isEmbedView: false,
        extraHeaderActions: backToSearch,
        issueResults: issueResultsData ?? null,
        view: viewData ?? null,
        backButtonUrl: backButtonUrl,
        routePathname: routePathname,
        routeSearch: routeSearch,
        ...(0, $7jTnu.fg)('nin_fix_document_title_in_detail_view') && {
            analyticsSource: (0, $iRahl.ANALYTICS_SOURCE)
        }
    })));
};
const $c4d70ecffed600f0$var$MemoizedFullPageIssueApp = /*#__PURE__*/ (0, $eJOHy.memo)($c4d70ecffed600f0$var$FullPageIssueApp);
const $c4d70ecffed600f0$var$FullPageIssueAppWithRouter = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivzXw.RouterSubscriber), null, ({ location: location })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c4d70ecffed600f0$var$MemoizedFullPageIssueApp, {
            ...props,
            routePathname: location.pathname,
            routeSearch: location.search
        });
    });
};
var $c4d70ecffed600f0$export$2e2bcd8739ae039 = $c4d70ecffed600f0$var$FullPageIssueAppWithRouter;

});
parcelRegister("3dxCR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6fb76dcaef757c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6ce74782ae0a54866642080a61a9fa9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e6fb76dcaef757c3$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsScope"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_FullPageIssueApp_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_view"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                },
                {
                    "kind": "Variable",
                    "name": "scope",
                    "variableName": "fieldSetsScope"
                }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$e6fb76dcaef757c3$var$node.hash = "064f112e625b1650c56fe569682b1195";
var $e6fb76dcaef757c3$export$2e2bcd8739ae039 = $e6fb76dcaef757c3$var$node;

});

parcelRegister("ae3vc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e72e00e13c9de34$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e191fe8f978a91a8364f661a75b25c8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e72e00e13c9de34$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_FullPageIssueApp_issueResults",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_issueResults"
        }
    ],
    "type": "JiraIssueConnection"
};
$7e72e00e13c9de34$var$node.hash = "c76ea1c159a6e1be56c13b6262324ca3";
var $7e72e00e13c9de34$export$2e2bcd8739ae039 = $7e72e00e13c9de34$var$node;

});

parcelRegister("3IF6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac4ee5f40705d91a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $hrKgE = parcelRequire("hrKgE");

var $kvNWh = parcelRequire("kvNWh");

var $676Hn = parcelRequire("676Hn");

var $b2ThO = parcelRequire("b2ThO");

var $dM9A7 = parcelRequire("dM9A7");

var $2ZGUP = parcelRequire("2ZGUP");

var $iUli2 = parcelRequire("iUli2");
let $ac4ee5f40705d91a$var$shortcutsCount = 0;
let $ac4ee5f40705d91a$var$subscription = null;
const $ac4ee5f40705d91a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eJOHy.useContext)((0, $2ZGUP.ShortcutRegistryContext)) || (0, $dM9A7.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const addKeyMap = (0, $eJOHy.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $iUli2.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $ac4ee5f40705d91a$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $ac4ee5f40705d91a$var$shortcutsCount -= 1;
            if ($ac4ee5f40705d91a$var$subscription && $ac4ee5f40705d91a$var$shortcutsCount === 0) {
                $ac4ee5f40705d91a$var$subscription.unsubscribe();
                $ac4ee5f40705d91a$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $ac4ee5f40705d91a$var$subscription = $ac4ee5f40705d91a$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $b2ThO.default)().subscribe((0, $676Hn.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
const $ac4ee5f40705d91a$var$Shortcuts = ({ useKeyboardShortcutsToggle: // eslint-disable-next-line react-hooks/react-compiler
useKeyboardShortcutsToggle = (0, $kvNWh.useKeyboardShortcutsToggle), ...unstableProps })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    const props = (0, $hrKgE.useShallowStableReference)(unstableProps, (0, $7jTnu.fg)('jfp-magma-concurrent-keyboard-shortcuts-fix-2'));
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ac4ee5f40705d91a$var$ShortcutsSubscriber, props) : null;
};
var $ac4ee5f40705d91a$export$2e2bcd8739ae039 = $ac4ee5f40705d91a$var$Shortcuts;

});
parcelRegister("kvNWh", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $28efcafdf90afd66$export$a33a81f1fc5458ad);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $hWeHP = parcelRequire("hWeHP");

var $gCeeo = parcelRequire("gCeeo");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $28efcafdf90afd66$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $28efcafdf90afd66$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$28efcafdf90afd66$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $jGzN3.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $gYnSx.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $28efcafdf90afd66$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $hWeHP.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $28efcafdf90afd66$export$b62f67be35e65859
    }
});
const $28efcafdf90afd66$export$a33a81f1fc5458ad = (0, $iJq0l.createHook)($28efcafdf90afd66$var$Store);

});

parcelRegister("676Hn", function(module, exports) {

$parcel$export(module.exports, "default", () => $29a82f2f140805e4$export$2e2bcd8739ae039);

var $b2ThO = parcelRequire("b2ThO");

var $dM9A7 = parcelRequire("dM9A7");
const $29a82f2f140805e4$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
/**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ const $29a82f2f140805e4$var$handler = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $dM9A7.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $b2ThO.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($29a82f2f140805e4$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $b2ThO.flush)();
    }
};
var $29a82f2f140805e4$export$2e2bcd8739ae039 = $29a82f2f140805e4$var$handler;

});
parcelRegister("b2ThO", function(module, exports) {

$parcel$export(module.exports, "flush", () => $bb63e776564d4094$export$4909b86c8034bf73);
$parcel$export(module.exports, "default", () => $bb63e776564d4094$export$2e2bcd8739ae039);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $7kixv = parcelRequire("7kixv");

var $6WhQS = parcelRequire("6WhQS");
parcelRequire("7SsGX");
parcelRequire("hnYRz");
parcelRequire("llumX");
parcelRequire("lVRem");
parcelRequire("1o2WJ");
parcelRequire("8rm0O");
parcelRequire("9Zsih");
parcelRequire("lf3vd");

var $aBrUN = parcelRequire("aBrUN");
const $bb63e776564d4094$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $bb63e776564d4094$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb63e776564d4094$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$bb63e776564d4094$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb63e776564d4094$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$bb63e776564d4094$var$isEditable(e.target) && !$bb63e776564d4094$var$ignoredKeys[e.key]);
const $bb63e776564d4094$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $bb63e776564d4094$var$key$;
const $bb63e776564d4094$var$flush$ = new (0, $6WhQS.Subject)();
const $bb63e776564d4094$var$createSequences = ()=>{
    if (!$bb63e776564d4094$var$key$) {
        $bb63e776564d4094$var$key$ = false ? new (0, $6WhQS.Subject)() : (0, $7kixv.Observable).fromEvent(document, 'keydown').filter($bb63e776564d4094$var$isRelevantKeyEvent).filter($bb63e776564d4094$export$25d1b8252b4c49b7).map((0, $aBrUN.toKeyWithModifiers));
        const sequence$ = $bb63e776564d4094$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $bb63e776564d4094$var$key$ = $bb63e776564d4094$var$key$.debounceTime(1000).startWith(null).merge($bb63e776564d4094$var$flush$).switchMapTo(sequence$);
    }
    return $bb63e776564d4094$var$key$;
};
const $bb63e776564d4094$export$4909b86c8034bf73 = ()=>{
    $bb63e776564d4094$var$flush$.next();
};
var $bb63e776564d4094$export$2e2bcd8739ae039 = $bb63e776564d4094$var$createSequences;

});


parcelRegister("iUli2", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $0344ad6591542af9$export$77477772a9b904da);

var $eSnSE = parcelRequire("eSnSE");

var $gCeeo = parcelRequire("gCeeo");

var $7jTnu = parcelRequire("7jTnu");
const $0344ad6591542af9$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent && (0, $7jTnu.fg)('log-hotkey-analytics')) (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $0344ad6591542af9$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $0344ad6591542af9$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});


parcelRegister("6Bi4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3917d6bd4592205$export$2e2bcd8739ae039);

var $gIHMD = parcelRequire("gIHMD");

var $4xca3 = parcelRequire("4xca3");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $b5RwB = parcelRequire("b5RwB");

var $16sa1 = parcelRequire("16sa1");

var $5tyYu = parcelRequire("5tyYu");

var $87NxD = parcelRequire("87NxD");

var $d6KFY = parcelRequire("d6KFY");

var $juAwR = parcelRequire("juAwR");

var $4xbv3 = parcelRequire("4xbv3");

var $ljej9 = parcelRequire("ljej9");

var $dTqD3 = parcelRequire("dTqD3");

var $bQWwW = parcelRequire("bQWwW");

var $7jTnu = parcelRequire("7jTnu");

var $6XJko = parcelRequire("6XJko");

var $bJscI = parcelRequire("bJscI");

var $j2oKY = parcelRequire("j2oKY");

var $1wL9i = parcelRequire("1wL9i");

var $ijD5s = parcelRequire("ijD5s");

var $1aawv = parcelRequire("1aawv");

var $iRahl = parcelRequire("iRahl");

var $fAgUF = parcelRequire("fAgUF");

var $ccZ0S = parcelRequire("ccZ0S");

var $6IA67 = parcelRequire("6IA67");
const $f3917d6bd4592205$var$MaybeUFOSegment = (0, $bJscI.componentWithFG)('nin_blindspot_fixes_fy26', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-app-container"
    }, children), (0, $eJOHy.Fragment)); // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences

const $f3917d6bd4592205$var$AsyncIssueAppComponent = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("iToTs")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $f3917d6bd4592205$var$AsyncIssueAppUsingLoadingPhases = ({ isEmbedView: isEmbedView, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d6KFY.IssueBoundary), {
        packageName: "issue-navigator",
        isEmbedView: isEmbedView,
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5tyYu.UnknownErrorView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f3917d6bd4592205$var$AsyncIssueAppComponent, rest)); // oxlint-disable-next-line prefer-set-has
const $f3917d6bd4592205$var$issueCardChangeExcludedEventTypes = [
    (0, $87NxD.ChangeEventTypes).FIELD_CHANGE_REQUESTED,
    (0, $87NxD.ChangeEventTypes).FIELD_CHANGE_FAILED,
    (0, $87NxD.ChangeEventTypes).CHILD_ISSUE_ADDED,
    (0, $87NxD.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED
];
const $f3917d6bd4592205$var$useJSCM1CompatibleActions = (connectionId, fieldSetIds)=>{
    const { deselectIssue: deselectIssue, exitFullPageIssueAppMode: exitFullPageIssueAppMode, setSelectedIssueByKey: setSelectedIssueByKey } = (0, $1wL9i.useSelectedIssueActions)();
    const onDeleteIssue = (0, $ijD5s.useOnDeleteIssue)(connectionId);
    const onIssueByFieldsRefetch = (0, $1aawv.useIssueByFieldsRefetch)(fieldSetIds);
    return {
        deselectIssue: deselectIssue,
        exitFullPageIssueAppMode: exitFullPageIssueAppMode,
        setSelectedIssueByKey: setSelectedIssueByKey,
        onDeleteIssue: onDeleteIssue,
        onIssueByFieldsRefetch: onIssueByFieldsRefetch
    };
};
const $f3917d6bd4592205$var$IssueAppWithData = ({ IssueApp: IssueApp = $f3917d6bd4592205$var$AsyncIssueAppUsingLoadingPhases, analyticsSource: analyticsSource, extraHeaderActions: extraHeaderActions, isEmbedView: isEmbedView, issueResults: issueResults, view: view, backButtonUrl: backButtonUrl, routePathname: routePathname, routeSearch: routeSearch })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_APP_START);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_APP_END);
    }, []);
    const selectedIssueKey = (0, $1wL9i.useSelectedIssueDebouncedState)();
    const issueResultsData = (0, $j4oe4.useFragment)((0, $4xca3.default), issueResults);
    const viewData = (0, $j4oe4.useFragment)((0, $gIHMD.default), view);
    const fieldSetIds = (0, $eJOHy.useMemo)(()=>viewData?.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData?.fieldSets?.edges
    ]);
    const { onInteractive: onInteractive } = (0, $j2oKY.useStartNinIssueAppAnalytics)(selectedIssueKey);
    const issueAppMetrics = (0, $eJOHy.useMemo)(()=>({
            onInteractive: onInteractive
        }), [
        onInteractive
    ]);
    const { deselectIssue: deselectIssue, exitFullPageIssueAppMode: exitFullPageIssueAppMode, setSelectedIssueByKey: setSelectedIssueByKey, onDeleteIssue: onDeleteIssue, onIssueByFieldsRefetch: onIssueByFieldsRefetch } = $f3917d6bd4592205$var$useJSCM1CompatibleActions(issueResultsData?.__id, fieldSetIds);
    const refetchCallback = (0, $eJOHy.useRef)(onIssueByFieldsRefetch);
    refetchCallback.current = onIssueByFieldsRefetch;
    const onIssueDeleteSuccess = (0, $eJOHy.useCallback)(({ issueKey: deletedIssueKey })=>{
        const issueKeyToSelect = onDeleteIssue(deletedIssueKey);
        if (!issueKeyToSelect.length) {
            deselectIssue(); // Return to list view if we were in full page mode
            exitFullPageIssueAppMode();
        } else setSelectedIssueByKey((0, $ljej9.toIssueKey)(issueKeyToSelect));
    }, [
        deselectIssue,
        exitFullPageIssueAppMode,
        onDeleteIssue,
        setSelectedIssueByKey
    ]);
    const onIssueKeyChange = (0, $eJOHy.useCallback)((issueKeys)=>{
        setSelectedIssueByKey(issueKeys.toIssueKey);
    }, [
        setSelectedIssueByKey
    ]); // When we're in non-embedded view (i.e. full page) we need to define a max width to ensure correct full page
    // styling within the issue app.
    const maxWidth = !isEmbedView ? (0, $juAwR.getIssueContainerIncreasedMaxWidth)() : undefined;
    let isFullPageIssueAppMode = false;
    if ((0, $6XJko.isVisualRefreshEnabled)()) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isFullPageIssueAppMode = (0, $1wL9i.useIsFullPageIssueAppMode)();
    const shouldWrapMargin = !isFullPageIssueAppMode && (0, $6XJko.isVisualRefreshEnabled)();
    if ((0, $7jTnu.fg)('jsc_inline_editing_field_refactor')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $6IA67.useScrollToActivityFeed)(selectedIssueKey);
    let issueNavigatorData;
    if ((0, $7jTnu.fg)('empanada_nin_migrate_full_page_issue_nav')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const getIssueUrl = (0, $eJOHy.useCallback)((issueKey)=>{
            // Not using browser parsing API because it changes spaces to `+`
            const params = (0, $b5RwB.parse)(routeSearch);
            params.selectedIssue = issueKey;
            return `${routePathname}?${(0, $b5RwB.stringify)(params)}`;
        }, [
            routeSearch,
            routePathname
        ]); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const issueKeys = (0, $1wL9i.useIssueKeys)(); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const issuesCount = (0, $1wL9i.useIssuesCount)(); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        issueNavigatorData = (0, $eJOHy.useMemo)(()=>({
                issueKey: selectedIssueKey,
                issueKeys: issueKeys,
                knownIssueKeys: issueKeys,
                issuesCount: issuesCount,
                getIssueUrl: getIssueUrl
            }), [
            selectedIssueKey,
            issueKeys,
            issuesCount,
            getIssueUrl
        ]);
    }
    if (!selectedIssueKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStatePageErrorReady), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f3917d6bd4592205$var$MaybeUFOSegment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f3917d6bd4592205$var$IssueAppContainer, {
        "data-vc": "issue-app-container",
        isEmbedView: isEmbedView || (0, $7jTnu.fg)('empanada_nin_migrate_full_page_issue_nav'),
        shouldWrapMargin: shouldWrapMargin
    }, !(0, $7jTnu.fg)('empanada_nin_migrate_full_page_issue_nav') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ccZ0S.default), {
        issueResults: issueResultsData ?? null,
        extraHeaderActions: extraHeaderActions,
        isEmbedView: isEmbedView,
        maxWidth: maxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f3917d6bd4592205$var$IssueAppHeightAdjustment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "issueNavigatorEmbeddedIssueView",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IssueApp, {
        metrics: issueAppMetrics,
        key: selectedIssueKey,
        isEmbedView: isEmbedView,
        analyticsSource: (0, $7jTnu.fg)('nin_fix_document_title_in_detail_view') ? analyticsSource || (0, $iRahl.ANALYTICS_SOURCE) : (0, $iRahl.ANALYTICS_SOURCE),
        issueKey: (0, $ljej9.toIssueKey)(selectedIssueKey),
        issueMaxWidth: maxWidth,
        onIssueKeyChange: onIssueKeyChange,
        onChange: (event)=>{
            if (event && !$f3917d6bd4592205$var$issueCardChangeExcludedEventTypes.includes(event.type)) refetchCallback.current(String(selectedIssueKey));
        },
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        shouldSetInitialFocus: false,
        backButtonUrl: backButtonUrl,
        issueNavigatorData: issueNavigatorData
    })))));
};
var $f3917d6bd4592205$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f3917d6bd4592205$var$IssueAppWithData;
const $f3917d6bd4592205$var$IssueAppContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldWrapMargin: shouldWrapMargin, isEmbedView: isEmbedView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _16jlkb7n _4t3i1osq _1ul9idpf _1e0c1txw _2lx21bp4 _vchhusvi",
            __cmplp.shouldWrapMargin && "_2hwx10v4",
            !__cmplp.isEmbedView && "_ca0qxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f3917d6bd4592205$var$IssueAppHeightAdjustment = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _1tkeidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gIHMD", function(module, exports) {

$parcel$export(module.exports, "default", () => $af18185c15522e50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b57212afd88a65d6ab1b44dd40c60183>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $af18185c15522e50$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsScope"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueAppWithData_view",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                },
                {
                    "kind": "Variable",
                    "name": "scope",
                    "variableName": "fieldSetsScope"
                }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$af18185c15522e50$var$node.hash = "741c31d0c1ebc1e3fdeb37896e791449";
var $af18185c15522e50$export$2e2bcd8739ae039 = $af18185c15522e50$var$node;

});

parcelRegister("4xca3", function(module, exports) {

$parcel$export(module.exports, "default", () => $01a5f45c271e2586$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1eb167471fb64a02bbc7a0985243c9bc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $01a5f45c271e2586$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueAppWithData_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "headerActions_issueNavigator"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$01a5f45c271e2586$var$node.hash = "267fadd3844f360bfc7e5d9f255f3ee7";
var $01a5f45c271e2586$export$2e2bcd8739ae039 = $01a5f45c271e2586$var$node;

});

parcelRegister("5tyYu", function(module, exports) {

$parcel$export(module.exports, "UnknownErrorView", () => $3321c5fa4308c9dc$export$f23f26771420affd);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6MnLl = parcelRequire("6MnLl");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $djHV9 = parcelRequire("djHV9");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");

var $9fUwN = parcelRequire("9fUwN");

var $cxWcr = parcelRequire("cxWcr");
const $3321c5fa4308c9dc$var$ErrorImage = ()=>{
    return (0, $7jTnu.fg)('replace_error_display_with_empty_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3321c5fa4308c9dc$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $djHV9.default), {
        width: 90,
        height: 130,
        alt: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $djHV9.default), {
        width: 90,
        height: 130,
        alt: ""
    });
};
const $3321c5fa4308c9dc$export$f23f26771420affd = ()=>{
    const unknownErrorDescriptionIssueTermRefreshGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $cxWcr.messages).unknownErrorDescriptionIssueTermRefreshGalaxia : (0, $cxWcr.messages).unknownErrorDescriptionIssueTermRefresh;
    const intl = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "unknownError",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        attributes: {
            errorType: 'unknown',
            source: globalThis.window?.location?.pathname ?? '',
            referrer: globalThis.document?.referrer ?? '',
            timestamp: new Date().toISOString(),
            userAgent: globalThis.navigator?.userAgent ?? '',
            route: `${globalThis.window?.location?.pathname ?? ''}${globalThis.window?.location?.search ?? ''}`
        }
    }, (0, $7jTnu.fg)('replace_error_display_with_empty_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        testId: "issue-view-errors.ui.unknown-error-view.unknown-error-view",
        header: intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cxWcr.messages).unknownErrorHeaderIssueTermRefresh : (0, $cxWcr.messages).unknownErrorHeader),
        description: intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? unknownErrorDescriptionIssueTermRefreshGalaxia : (0, $cxWcr.messages).unknownErrorDescription),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3321c5fa4308c9dc$var$ErrorImage, null)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9fUwN.ErrorDisplay), {
        header: intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cxWcr.messages).unknownErrorHeaderIssueTermRefresh : (0, $cxWcr.messages).unknownErrorHeader),
        description: intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? unknownErrorDescriptionIssueTermRefreshGalaxia : (0, $cxWcr.messages).unknownErrorDescription),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3321c5fa4308c9dc$var$ErrorImage, null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null));
};
const $3321c5fa4308c9dc$var$imageWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

});
parcelRegister("djHV9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c86612ca91962ff4$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $e1jMX = parcelRequire("e1jMX");
const $c86612ca91962ff4$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($e1jMX)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($e1jMX))
});
var $c86612ca91962ff4$export$2e2bcd8739ae039 = $c86612ca91962ff4$var$Illustration;
// for advanced use only
const $c86612ca91962ff4$export$a179c88182cb9d56 = [
    0,
    0,
    104,
    140
];

});
parcelRegister("e1jMX", function(module, exports) {
module.exports = new URL("empty-search-error-colour.f0aa9e5e.svg", import.meta.url).toString();

});


parcelRegister("9fUwN", function(module, exports) {

$parcel$export(module.exports, "ErrorDisplay", () => $eeb20530bb997417$export$d56b0569bceb92ae);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $eeb20530bb997417$export$d56b0569bceb92ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eeb20530bb997417$var$Container, {
        "data-testid": "issue-view-errors.common.ui.error-display.permission-error-display"
    }, props.image, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eeb20530bb997417$var$Heading, null, props.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eeb20530bb997417$var$Description, null, props.description), props.children);
$eeb20530bb997417$export$d56b0569bceb92ae.defaultProps = {
    description: undefined,
    children: null
};
/**
 * Duplicated from `src/packages/issue/issue-view/src/views/issue-details/issue-modal/styled.tsx`
 *
 * TODO: Derive properly on `src/packages/issue/issue-view/src/views/issue-details/error` cleanup
 */ const $eeb20530bb997417$var$modalDialogContainerSelectorName = 'jira.issue-view.issue-details.modal-dialog-container';
const $eeb20530bb997417$var$MODAL_DIALOG_CONTAINER_COMPONENT_SELECTOR = `[data-component-selector="${$eeb20530bb997417$var$modalDialogContainerSelectorName}"]`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eeb20530bb997417$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1h6o _2lx21bp4 _syaz1fxt _1e0c1txw _1bah1h6o _4cvr1h6o _ca0qxncg _17ipxncg _1ksgidpf",
            __cmplp.className
        ])
    });
});
const $eeb20530bb997417$var$Heading = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8lodh _19pkutpp _otyrutpp _p12f1osq",
            __cmplp.className
        ])
    });
});
const $eeb20530bb997417$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cxWcr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cb0f4ae2f63ad8b4$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $cb0f4ae2f63ad8b4$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    unknownErrorHeader: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-header",
        "defaultMessage": "We couldn't connect to that issue"
    },
    unknownErrorDescription: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-description",
        "defaultMessage": "Make sure that this issue actually exists in that project. If it does, try again in a few minutes. If you still can't link to the issue, contact your Jira admin."
    },
    unknownErrorHeaderIssueTermRefresh: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-header-issue-term-refresh",
        "defaultMessage": "We couldn't connect to that work item."
    },
    unknownErrorDescriptionIssueTermRefresh: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-description-issue-term-refresh",
        "defaultMessage": "Make sure that this work item actually exists in that project. If it does, try again in a few minutes. If you still can't link to the work item, contact your Jira admin."
    },
    unknownErrorDescriptionIssueTermRefreshGalaxia: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-description-issue-term-refresh-galaxia",
        "defaultMessage": "Make sure that this work item actually exists in that space. If it does, try again in a few minutes. If you still can't link to the work item, contact your Jira admin."
    }
});

});


parcelRegister("87NxD", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $bd046dbdd7555f37$export$8db21fc94823e1cc);
const $bd046dbdd7555f37$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $bd046dbdd7555f37$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $bd046dbdd7555f37$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $bd046dbdd7555f37$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $bd046dbdd7555f37$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $bd046dbdd7555f37$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $bd046dbdd7555f37$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $bd046dbdd7555f37$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $bd046dbdd7555f37$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $bd046dbdd7555f37$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $bd046dbdd7555f37$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $bd046dbdd7555f37$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $bd046dbdd7555f37$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $bd046dbdd7555f37$export$8db21fc94823e1cc = {
    [$bd046dbdd7555f37$var$FIELD_CHANGE_REQUESTED]: $bd046dbdd7555f37$var$FIELD_CHANGE_REQUESTED,
    [$bd046dbdd7555f37$var$FIELD_CHANGE_FAILED]: $bd046dbdd7555f37$var$FIELD_CHANGE_FAILED,
    [$bd046dbdd7555f37$var$FIELD_CHANGED]: $bd046dbdd7555f37$var$FIELD_CHANGED,
    [$bd046dbdd7555f37$var$ISSUE_TYPE_CHANGED]: $bd046dbdd7555f37$var$ISSUE_TYPE_CHANGED,
    [$bd046dbdd7555f37$var$ISSUE_RELATIONSHIP_UPDATED]: $bd046dbdd7555f37$var$ISSUE_RELATIONSHIP_UPDATED,
    [$bd046dbdd7555f37$var$ISSUE_LINKS_CREATED]: $bd046dbdd7555f37$var$ISSUE_LINKS_CREATED,
    [$bd046dbdd7555f37$var$ISSUE_LINK_DELETED]: $bd046dbdd7555f37$var$ISSUE_LINK_DELETED,
    [$bd046dbdd7555f37$var$CHILD_ISSUE_ADDED]: $bd046dbdd7555f37$var$CHILD_ISSUE_ADDED,
    [$bd046dbdd7555f37$var$SUBTASK_ADDED]: $bd046dbdd7555f37$var$SUBTASK_ADDED,
    [$bd046dbdd7555f37$var$ISSUE_CHILDREN_ORDER_CHANGED]: $bd046dbdd7555f37$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$bd046dbdd7555f37$var$CHILD_ISSUE_FIELD_UPDATED]: $bd046dbdd7555f37$var$CHILD_ISSUE_FIELD_UPDATED,
    [$bd046dbdd7555f37$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $bd046dbdd7555f37$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$bd046dbdd7555f37$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $bd046dbdd7555f37$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("d6KFY", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $124bf401a6603e60$export$fbf48ede0cf52b5a);
$parcel$export(module.exports, "IssuePreviewPanelBoundary", () => $124bf401a6603e60$export$8f21660b180d638b);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $dBLLk = parcelRequire("dBLLk");

var $ch9En = parcelRequire("ch9En");

var $4FfIq = parcelRequire("4FfIq");
const $124bf401a6603e60$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4FfIq.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $124bf401a6603e60$export$8f21660b180d638b = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue-preview-panel",
        packageName: "issuePreviewPanel",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-preview-panel-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4FfIq.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $124bf401a6603e60$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dBLLk.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4FfIq.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("4FfIq", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $68e48e1970e78876$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $biWZb = parcelRequire("biWZb");

var $f2JN3 = parcelRequire("f2JN3");

var $epTsa = parcelRequire("epTsa");

var $hwuZ0 = parcelRequire("hwuZ0");

var $4h5lX = parcelRequire("4h5lX");

var $7oQeg = parcelRequire("7oQeg");
const $68e48e1970e78876$var$fullpageStyles = null;
const $68e48e1970e78876$var$modalStyles = null;
const $68e48e1970e78876$var$customSpacingStyles = null;
/**
 * Renders a placeholder for the Issue View that adapts its layout and styling to different contexts such as embedding or modal presentation, ensuring a consistent user experience during content loading.
 */ const $68e48e1970e78876$var$IssueViewSkeletonWithRightStatus = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $68e48e1970e78876$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $68e48e1970e78876$var$fullpageStyles : null,
        isModalView === true ? $68e48e1970e78876$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biWZb.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4h5lX))),
        className: (0, $hcewu.default)([
            "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};
const $68e48e1970e78876$var$IssueViewSkeletonWithLeftStatus = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $68e48e1970e78876$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $68e48e1970e78876$var$fullpageStyles : null,
        isModalView === true ? $68e48e1970e78876$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biWZb.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7oQeg))),
        className: (0, $hcewu.default)([
            "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};
const $68e48e1970e78876$export$49addbcdecb6e6ff = (0, $f2JN3.componentWithCondition)(()=>(0, $epTsa.expVal)('move_status_to_summary_ga', 'isEnabled', false), $68e48e1970e78876$var$IssueViewSkeletonWithLeftStatus, $68e48e1970e78876$var$IssueViewSkeletonWithRightStatus);

});
parcelRegister("biWZb", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $b77d47f9e4eb67f9$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $b77d47f9e4eb67f9$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $b77d47f9e4eb67f9$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");


var $8BpnG = parcelRequire("8BpnG");

var $gCY1z = parcelRequire("gCY1z");

var $coXKe = parcelRequire("coXKe");

var $cZpx8 = parcelRequire("cZpx8");
const $b77d47f9e4eb67f9$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const { Provider: $b77d47f9e4eb67f9$var$Provider, Consumer: $b77d47f9e4eb67f9$var$Consumer } = $b77d47f9e4eb67f9$export$37eeac5cc5245b18;
const $b77d47f9e4eb67f9$export$55a90a8e865a39b5 = 700;
const $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$b77d47f9e4eb67f9$export$55a90a8e865a39b5}px)`;
const $b77d47f9e4eb67f9$export$ddd398a95f85cd75 = 850;
const $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL = `(max-width: ${$b77d47f9e4eb67f9$export$ddd398a95f85cd75}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $b77d47f9e4eb67f9$var$useRouteKey() {
    const [routeState] = (0, $gCY1z.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $b77d47f9e4eb67f9$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $b77d47f9e4eb67f9$var$useRouteKey();
    (0, $cZpx8.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $cZpx8.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $548198843509795c$export$ee15e0cd1efafcb4);
        (0, $cZpx8.setCachedIsCompactValue)(defaultState, key);
    }
    const { isInDiscussionLayoutExperiment: isInDiscussionLayoutExperiment } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const query = isInDiscussionLayoutExperiment ? $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL : $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY;
    const [isCompact, setIsCompact] = (0, $eJOHy.useState)(defaultState);
    const onChange = (0, $fAZgY.useCallbackWithCondition)((state)=>{
        (0, $cZpx8.setCachedIsCompactValue)(state, key);
        setIsCompact(state);
    }, [
        key
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b77d47f9e4eb67f9$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8BpnG.ContainerQueryObserver), {
        query: query,
        onChange: onChange,
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b77d47f9e4eb67f9$var$Provider, {
        value: isCompact
    }, children));
};
const $b77d47f9e4eb67f9$export$20feb77b5b617e44 = $b77d47f9e4eb67f9$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b77d47f9e4eb67f9$var$StyledWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $548198843509795c$export$ee15e0cd1efafcb4 = false;

parcelRegister("8BpnG", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $b45aeffccc0e4b84$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $b45aeffccc0e4b84$var$QueryContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
let $b45aeffccc0e4b84$var$currentIdSeed = 0;
function $b45aeffccc0e4b84$var$generateAttributeValue() {
    return `indicator-span-${$b45aeffccc0e4b84$var$currentIdSeed++}`;
}
function $b45aeffccc0e4b84$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $548198843509795c$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $eJOHy.useState)(defaultState);
    const handleQueryStatusChange = (0, $eJOHy.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $b45aeffccc0e4b84$export$b66a67697973e01() {
    const currentState = (0, $eJOHy.useContext)($b45aeffccc0e4b84$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $b45aeffccc0e4b84$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $eJOHy.useMemo)(()=>$b45aeffccc0e4b84$var$generateAttributeValue(), []);
    const spanRef = (0, $eJOHy.useRef)(null);
    const containerRef = (0, $eJOHy.useRef)(null);
    const currentState = $b45aeffccc0e4b84$export$b66a67697973e01();
    (0, $eJOHy.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b45aeffccc0e4b84$var$ContainerToBeQueried = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("coXKe", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainers", () => $3b984a26137eed7b$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $3b984a26137eed7b$export$5f49a43487b268);
$parcel$export(module.exports, "useLayoutContainerByTypeMemoised", () => $3b984a26137eed7b$export$ef5966e43b13b4a9);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $3b984a26137eed7b$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $3b984a26137eed7b$export$5962da0433486667);
$parcel$export(module.exports, "useUserPreferredWorkItemLayout", () => $3b984a26137eed7b$export$9889eea62fdfa091);
$parcel$export(module.exports, "useIssueLayoutActions", () => $3b984a26137eed7b$export$1e5e9fc877a47cd9);

var $eJOHy = parcelRequire("eJOHy");

var $fAZgY = parcelRequire("fAZgY");

var $pz0Wh = parcelRequire("pz0Wh");

var $kfvK2 = parcelRequire("kfvK2");

var $epTsa = parcelRequire("epTsa");

var $cs58I = parcelRequire("cs58I");

var $hbF3h = parcelRequire("hbF3h");

var $bmoS1 = parcelRequire("bmoS1");

var $2cfd4 = parcelRequire("2cfd4");


var $bNexr = parcelRequire("bNexr");

var $7jTnu = parcelRequire("7jTnu");

var $ln6Iy = parcelRequire("ln6Iy");

var $16PQW = parcelRequire("16PQW");

var $eSnSE = parcelRequire("eSnSE");

var $l7Alo = parcelRequire("l7Alo");

var $lpEwy = parcelRequire("lpEwy");

var $co62F = parcelRequire("co62F");
const $3b984a26137eed7b$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $3b984a26137eed7b$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
        ], [
        container?.items.nodes,
        fieldsHiddenByUim
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $3b984a26137eed7b$export$ef5966e43b13b4a9 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    const filteredItems = (0, $eJOHy.useMemo)(()=>{
        return (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim);
    }, [
        container,
        fieldsHiddenByUim
    ]);
    return [
        filteredItems
    ];
};
const $3b984a26137eed7b$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $lpEwy.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $3b984a26137eed7b$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $lpEwy.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $a85d9f0dd63c9b50$export$39aaf586c7ee5202));
    const isMobile = (0, $l7Alo.default)();
    const locale = (0, $2cfd4.useLocale)();
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $7jTnu.fg)('issue_view_layout_experiment_feature_gate') && !(0, $7jTnu.fg)('issue_view_tab_layout_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isSoftwareOrBusiness = projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || projectType === (0, $ln6Iy.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $7jTnu.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $epTsa.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        let userSelectedLayout = userLayoutType;
        if (!(0, $7jTnu.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${JSON.stringify({
            error: error,
            isMobile: isMobile,
            isFullIssueView: isFullIssueView,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            userPreferredLayout: userPreferredLayout,
            locale: locale,
            isInWideLayoutExperiment: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isInDiscussionLayoutExperiment: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff = ()=>{
    try {
        // if neither tab layout nor issue view layout experiment is enabled return defaults
        if (!(0, $7jTnu.fg)('issue_view_layout_experiment_feature_gate') && !(0, $7jTnu.fg)('issue_view_tab_layout_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        // eslint-disable-next-line react-hooks/react-compiler
        /* eslint-disable react-hooks/rules-of-hooks */ const issueKey = (0, $bmoS1.useIssueKey)();
        const projectKey = (0, $bNexr.useProjectKey)(issueKey);
        const projectType = (0, $bNexr.useProjectType)(projectKey);
        const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
        const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $a85d9f0dd63c9b50$export$39aaf586c7ee5202));
        const isMobile = (0, $l7Alo.default)();
        const isSoftwareOrBusiness = projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || projectType === (0, $ln6Iy.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        const shouldBeInLayoutExperimentAndTabLayoutEnabled = (0, $7jTnu.fg)('issue_view_tab_layout_feature_gate') && shouldBeInLayoutExperiment;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInTabLayoutExperiment = shouldBeInLayoutExperimentAndTabLayoutEnabled && (0, $epTsa.expVal)('issue_view_tab_layout_experiment', 'isTabLayoutEnabled', false);
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment || isInTabLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        /* eslint-enable react-hooks/rules-of-hooks */ let userSelectedLayout = userLayoutType;
        if (!(0, $7jTnu.fg)('thor-make-layout-options-work-together')) {
            if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
            if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        }
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${error}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$export$9889eea62fdfa091 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('issue_layout_rule_of_hook_fix'), $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn, $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff);
const $3b984a26137eed7b$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $lpEwy.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $eJOHy.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $eJOHy.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $eJOHy.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};
/**
 * useRouteToGetQueryParams hook
 * This hook retrieves the current query parameters from the router state.
 * It is used to access the active tab and other query parameters in the issue view layout.
 */ const $3b984a26137eed7b$var$useRouteToGetQueryParams = (0, $kfvK2.createRouterSelector)((state)=>{
    return state.query;
});
const $3b984a26137eed7b$export$b027791af8c9b114 = ()=>{
    const { activeTab: activeTab = (0, $16PQW.defaultActiveTab), ...otherQueryParams } = $3b984a26137eed7b$var$useRouteToGetQueryParams();
    const { updateQueryParam: updateQueryParam } = (0, $kfvK2.useRouterStoreActions)();
    const setActiveTab = (0, $eJOHy.useCallback)((tab)=>{
        if (activeTab !== tab) updateQueryParam({
            ...otherQueryParams,
            activeTab: tab
        }, 'replace');
    }, [
        activeTab,
        otherQueryParams,
        updateQueryParam
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            setDescriptionAsActive: ()=>setActiveTab((0, $16PQW.Tabs).Description),
            setWorkItemsAsActive: ()=>setActiveTab((0, $16PQW.Tabs).WorkItems),
            setIntegrationsAsActive: ()=>setActiveTab((0, $16PQW.Tabs).Integrations),
            setResourcesAsActive: ()=>setActiveTab((0, $16PQW.Tabs).Resources),
            currentActiveTab: activeTab
        }), [
        activeTab,
        setActiveTab
    ]);
};

});
parcelRegister("pz0Wh", function(module, exports) {

$parcel$export(module.exports, "useEnabledHiddenFields", () => $437c493a8e065bc6$export$bb6c2b9159c3f32b);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $i7n3g = parcelRequire("i7n3g");

var $4Swsy = parcelRequire("4Swsy");
const $437c493a8e065bc6$export$bb6c2b9159c3f32b = ()=>{
    (0, $gRw8I.di)((0, $i7n3g.useAdjustmentsEnabled), (0, $4Swsy.useHiddenFields));
    const adjustmentsAreEnabled = (0, $i7n3g.useAdjustmentsEnabled)();
    const hiddenFields = (0, $4Swsy.useHiddenFields)();
    return (0, $eJOHy.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("i7n3g", function(module, exports) {

$parcel$export(module.exports, "store", () => $35b1fa370eb6f514$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $35b1fa370eb6f514$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $35b1fa370eb6f514$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $35b1fa370eb6f514$export$5eb9c167b683d125);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $35b1fa370eb6f514$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $35b1fa370eb6f514$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($35b1fa370eb6f514$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $35b1fa370eb6f514$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-adjustments-context',
    initialState: $35b1fa370eb6f514$var$initialState,
    actions: $35b1fa370eb6f514$export$e324594224ef24da
});
const $35b1fa370eb6f514$export$a12f82a132dee079 = (0, $iJq0l.createHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$358ad850b2f6d6fe = (0, $iJq0l.createStateHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $35b1fa370eb6f514$export$4f2729981f4b81d2 = (0, $iJq0l.createActionsHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$5eb9c167b683d125 = (0, $6E16M.createContainer)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("4Swsy", function(module, exports) {

$parcel$export(module.exports, "useHiddenFields", () => $8e2f20b0b0e23b91$export$de6fdc67c945e596);

var $4MchI = parcelRequire("4MchI");
var $iJq0l = parcelRequire("iJq0l");

var $ixrOr = parcelRequire("ixrOr");
const $8e2f20b0b0e23b91$var$selectHiddenFields = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $8e2f20b0b0e23b91$export$de6fdc67c945e596 = (0, $iJq0l.createStateHook)((0, $ixrOr.store), {
    selector: $8e2f20b0b0e23b91$var$selectHiddenFields
});

});
parcelRegister("ixrOr", function(module, exports) {

$parcel$export(module.exports, "store", () => $3142574379bc5921$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $3142574379bc5921$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $3142574379bc5921$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $3142574379bc5921$export$677b3e34bd14c681);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4XahM = parcelRequire("4XahM");

var $4CM51 = parcelRequire("4CM51");

var $aub9z = parcelRequire("aub9z");

var $cJU1r = parcelRequire("cJU1r");

var $2A1rz = parcelRequire("2A1rz");

var $jfSsT = parcelRequire("jfSsT");

var $hUz0e = parcelRequire("hUz0e");

var $8ZmJu = parcelRequire("8ZmJu");

var $cXMA2 = parcelRequire("cXMA2");

var $5qpxn = parcelRequire("5qpxn");

var $9w3dh = parcelRequire("9w3dh");

var $fkUIk = parcelRequire("fkUIk");

var $bfBqP = parcelRequire("bfBqP");

var $fY47y = parcelRequire("fY47y");

var $dmz3j = parcelRequire("dmz3j");
const $3142574379bc5921$var$name = 'issue-adjustments';
const $3142574379bc5921$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $3142574379bc5921$var$triggerFieldInitializationKey, viewType: $3142574379bc5921$var$scopedViewType, numberOfSupportedFields: $3142574379bc5921$var$numberOfSupportedFields, ...$3142574379bc5921$var$stateForResetAllFields } = $3142574379bc5921$export$d4c72bab9d6cc13a;
const $3142574379bc5921$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $5qpxn.processChange,
    setFieldValue: $fkUIk.setFieldValue,
    initializeField: $jfSsT.initializeField,
    initializeFields: $jfSsT.initializeFields,
    startFieldsInitialisationTimeout: $2A1rz.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $2A1rz.successFieldsInitalisation,
    registerFields: $9w3dh.registerFields,
    unregisterFields: $9w3dh.unregisterFields,
    updateFields: $fY47y.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($3142574379bc5921$var$stateForResetAllFields);
        },
    setError: $cJU1r.setError,
    resetError: $cJU1r.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $4XahM.setAppErrors,
    resetAppErrors: $4XahM.resetAppErrors,
    addAppsErrors: $4XahM.addAppsErrors,
    initializeNoScreenTab: $hUz0e.initializeNoScreenTab,
    initializeScreenTabs: $8ZmJu.initializeScreenTabs,
    updateScreenTabs: $dmz3j.updateScreenTabs,
    updateActiveScreenTab: $bfBqP.updateActiveScreenTab,
    detectAppliedChangesConflicts: $4CM51.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $aub9z.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $aub9z.collectFieldsAppliedChangesHistory,
    setNotification: $cXMA2.setNotification,
    resetNotification: $cXMA2.resetNotification
};
const $3142574379bc5921$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: $3142574379bc5921$var$name,
    initialState: $3142574379bc5921$export$d4c72bab9d6cc13a,
    actions: $3142574379bc5921$export$e324594224ef24da
});
const $3142574379bc5921$export$37792a602e748c08 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$var$stableEmptyFieldFromIframe = {};
const $3142574379bc5921$export$c76e674a29843e21 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $3142574379bc5921$export$df4b0714e8177e0e = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $3142574379bc5921$var$stableEmptyFieldFromIframe
});
const $3142574379bc5921$export$cb9a014ec14556d8 = (0, $iJq0l.createActionsHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$export$677b3e34bd14c681 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("4XahM", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $5579267a84760bc0$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $5579267a84760bc0$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $5579267a84760bc0$export$24c821207687a907);
const $5579267a84760bc0$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $5579267a84760bc0$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $5579267a84760bc0$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("4CM51", function(module, exports) {

$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $8731ff5311f46f9c$export$90d94f20d157e756);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $4XahM = parcelRequire("4XahM");

var $cXMA2 = parcelRequire("cXMA2");

var $7Agw7 = parcelRequire("7Agw7");
const $8731ff5311f46f9c$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $8731ff5311f46f9c$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $8731ff5311f46f9c$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $e65702a72ab5ec3d$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $7Agw7.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $4XahM.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $cXMA2.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("jgvEH", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $cbc5413d6b6dbcfa$export$a1fb57756f0de62b);

var $5fWw9 = parcelRequire("5fWw9");


const $cbc5413d6b6dbcfa$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $5fWw9.default)((0, $0390845c0b61b1a1$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $e9db81972dce4ebc$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

const $0390845c0b61b1a1$export$8280e5c6104c5b40 = 'ui-modifications';


const $e65702a72ab5ec3d$export$415cc1afa6445f90 = 'onInitChangeId';
const $e65702a72ab5ec3d$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("cXMA2", function(module, exports) {

$parcel$export(module.exports, "setNotification", () => $c89e780a89ca3c37$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $c89e780a89ca3c37$export$caafa3945f199bc7);
const $c89e780a89ca3c37$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $c89e780a89ca3c37$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("7Agw7", function(module, exports) {

$parcel$export(module.exports, "collectConflicts", () => $6ecf22ae7e9f4956$export$a06103ec99e4e394);

var $jFHCE = parcelRequire("jFHCE");


var $5sAot = parcelRequire("5sAot");

const $6ecf22ae7e9f4956$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $6ecf22ae7e9f4956$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $702a64456849b1c0$export$f674b7a3bbd94b5)) return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $5sAot.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $6ecf22ae7e9f4956$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $6ecf22ae7e9f4956$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $585e8f7167f61808$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $585e8f7167f61808$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $585e8f7167f61808$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $585e8f7167f61808$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $585e8f7167f61808$export$e4ac32edd5da2ee7 = 'FIELD';
const $585e8f7167f61808$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("5sAot", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $2728f69de31c50a0$export$e1cc7da28a1c4bb7);
const $2728f69de31c50a0$var$SET_NAME_METHOD = 'setName';
const $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $2728f69de31c50a0$var$SET_VISIBLE_METHOD = 'setVisible';
const $2728f69de31c50a0$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $2728f69de31c50a0$var$SET_VALUE_METHOD = 'setValue';
const $2728f69de31c50a0$var$SET_REQUIRED_METHOD = 'setRequired';
const $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $2728f69de31c50a0$export$8325709d137b2606 = {
    fieldName: $2728f69de31c50a0$var$SET_NAME_METHOD,
    description: $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD,
    isVisible: $2728f69de31c50a0$var$SET_VISIBLE_METHOD,
    isReadOnly: $2728f69de31c50a0$var$SET_READ_ONLY_METHOD,
    value: $2728f69de31c50a0$var$SET_VALUE_METHOD,
    isRequired: $2728f69de31c50a0$var$SET_REQUIRED_METHOD,
    optionsVisibility: $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $2728f69de31c50a0$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $2728f69de31c50a0$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $702a64456849b1c0$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $702a64456849b1c0$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("aub9z", function(module, exports) {

$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $94bb1a042906c320$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $94bb1a042906c320$export$7d0f534e5b16dcc9);


var $gD9lZ = parcelRequire("gD9lZ");
const $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $94bb1a042906c320$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $702a64456849b1c0$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $94bb1a042906c320$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $gD9lZ.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("gD9lZ", function(module, exports) {

$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $b80c31bd414cd9d4$export$8a23b3e9a1749620);

const $b80c31bd414cd9d4$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $702a64456849b1c0$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $b80c31bd414cd9d4$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $b80c31bd414cd9d4$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("cJU1r", function(module, exports) {

$parcel$export(module.exports, "setError", () => $60a309f31f0bb435$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $60a309f31f0bb435$export$7e5930c6217b1d4e);
const $60a309f31f0bb435$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $60a309f31f0bb435$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("2A1rz", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $601c25cd313fe741$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $601c25cd313fe741$export$cf768a695e83eefa);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");

var $ieQ0v = parcelRequire("ieQ0v");

var $cJU1r = parcelRequire("cJU1r");
const $601c25cd313fe741$var$getTimeout = ()=>50000;
const $601c25cd313fe741$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $601c25cd313fe741$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $601c25cd313fe741$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($601c25cd313fe741$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $601c25cd313fe741$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $601c25cd313fe741$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status) || (0, $ieQ0v.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $cJU1r.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $601c25cd313fe741$var$getTimeout(),
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $601c25cd313fe741$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("ieQ0v", function(module, exports) {

$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $d3350efc4111ec81$export$4cadeedb8c3f31f7);

var $4MchI = parcelRequire("4MchI");
const $d3350efc4111ec81$export$4cadeedb8c3f31f7 = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("jfSsT", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $a40b94674a995fd7$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $a40b94674a995fd7$export$4a6b4707110b0552);

var $37MnT = parcelRequire("37MnT");
const $a40b94674a995fd7$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $a40b94674a995fd7$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("37MnT", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $cc8ab347810a3948$export$50806045b617d116);

var $gRw8I = parcelRequire("gRw8I");

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $cc8ab347810a3948$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gRw8I.di)((0, $1qarT.fireErrorAnalytics), (0, $82wKS.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $1qarT.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("1qarT", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $7486f28a569b9ec0$export$a27c21aa3ed8f0f1);

var $7U6OJ = parcelRequire("7U6OJ");

var $cMdIN = parcelRequire("cMdIN");
const $7486f28a569b9ec0$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $7486f28a569b9ec0$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $cMdIN.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $7U6OJ.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $7486f28a569b9ec0$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("cMdIN", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $c511a0dff3897a12$export$e19f9f08a6d79fd2);

var $l58EO = parcelRequire("l58EO");
const $c511a0dff3897a12$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $c511a0dff3897a12$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $c511a0dff3897a12$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $c511a0dff3897a12$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $c511a0dff3897a12$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $c511a0dff3897a12$export$89a175d4190df42e = 'Invoke value functions failed:';
const $c511a0dff3897a12$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $c511a0dff3897a12$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $c511a0dff3897a12$var$BAD_REQUEST = 400;
const $c511a0dff3897a12$var$REQUEST_TIMEOUT = 408;
const $c511a0dff3897a12$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $c511a0dff3897a12$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $c511a0dff3897a12$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($c511a0dff3897a12$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $c511a0dff3897a12$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($c511a0dff3897a12$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($c511a0dff3897a12$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($c511a0dff3897a12$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $l58EO.isClientFetchError)(error)) return $c511a0dff3897a12$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("l58EO", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $cd5265fc67dbb6eb$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cd5265fc67dbb6eb$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cd5265fc67dbb6eb$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cd5265fc67dbb6eb$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cd5265fc67dbb6eb$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cd5265fc67dbb6eb$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.cause.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("82wKS", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $0757a5b98ef450f3$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $0757a5b98ef450f3$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $0757a5b98ef450f3$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $0757a5b98ef450f3$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $0757a5b98ef450f3$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $0757a5b98ef450f3$export$ef45e4471aa21b27);

var $1qarT = parcelRequire("1qarT");

var $6beFf = parcelRequire("6beFf");
const $0757a5b98ef450f3$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $0757a5b98ef450f3$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $6beFf.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $0757a5b98ef450f3$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$0757a5b98ef450f3$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $1qarT.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $0757a5b98ef450f3$export$e4330d77fd93d1de = (viewType)=>$0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $0757a5b98ef450f3$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $0757a5b98ef450f3$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $0757a5b98ef450f3$export$20eabd2b3ada6bf3(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $0757a5b98ef450f3$export$b768d6a95f7a930(context) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $0757a5b98ef450f3$export$b0297573c90085aa(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $0757a5b98ef450f3$export$c0728caa743a409e(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $0757a5b98ef450f3$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $0757a5b98ef450f3$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("6beFf", function(module, exports) {

$parcel$export(module.exports, "getViewConfiguration", () => $9cd8cd98b7c2eeee$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");
const $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS = new Map();
const $9cd8cd98b7c2eeee$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.has(viewType)) $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $9cd8cd98b7c2eeee$export$176b6e68da08ffa2 = (viewType)=>$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.get(viewType);
const $9cd8cd98b7c2eeee$export$e8091eff40c4f16e = ()=>{
    $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.clear();
};
const $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gRw8I.di)($9cd8cd98b7c2eeee$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $eJOHy.useState)(()=>{
        $9cd8cd98b7c2eeee$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("hUz0e", function(module, exports) {

$parcel$export(module.exports, "initializeNoScreenTab", () => $7faac090c61abadc$export$93459ad9bfd6c380);
const $7faac090c61abadc$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("8ZmJu", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $5faefcecd8cba222$export$7f7be235f64f029b);
const $5faefcecd8cba222$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("5qpxn", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $bbbbfc09b273134e$export$352dfcce04d66748);

var $9UJzd = parcelRequire("9UJzd");

var $gRw8I = parcelRequire("gRw8I");

var $82wKS = parcelRequire("82wKS");

var $5ldku = parcelRequire("5ldku");
const $bbbbfc09b273134e$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($9UJzd))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($9UJzd)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("9UJzd", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/** Used to generate unique IDs. */ var $737cb0a939387270$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $737cb0a939387270$var$uniqueId(prefix) {
    var id = ++$737cb0a939387270$var$idCounter;
    return $cz1WF(prefix) + id;
}
module.exports = $737cb0a939387270$var$uniqueId;

});

parcelRegister("5ldku", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0);

var $cSmYj = parcelRequire("cSmYj");

var $37MnT = parcelRequire("37MnT");
const $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("9w3dh", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $60e092cfdd3e6be9$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $60e092cfdd3e6be9$export$1ca69a85bb7273de);

var $jFHCE = parcelRequire("jFHCE");

var $jvwCK = parcelRequire("jvwCK");
const $60e092cfdd3e6be9$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $60e092cfdd3e6be9$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("fkUIk", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $adb039aa861139a2$export$6556d46d2662453c);

var $5ldku = parcelRequire("5ldku");
const $adb039aa861139a2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("bfBqP", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $910f8611d1056e54$export$21363496760d39cd);
const $910f8611d1056e54$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("fY47y", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $e5c83e79d4f29b58$export$cceae62fd4d1ef0a);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $81O8J = parcelRequire("81O8J");

var $cfL5m = parcelRequire("cfL5m");

var $3JMvu = parcelRequire("3JMvu");

var $82idB = parcelRequire("82idB");

var $lKslV = parcelRequire("lKslV");

var $4XahM = parcelRequire("4XahM");

var $aub9z = parcelRequire("aub9z");

var $TiFiE = parcelRequire("TiFiE");
const $e5c83e79d4f29b58$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $aub9z.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $cfL5m.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $4XahM.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $7f80bdb4337734ff$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $7f80bdb4337734ff$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $7f80bdb4337734ff$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $TiFiE.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $lKslV.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $3JMvu.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(errorsByField)) throw new (0, $81O8J.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $82idB.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $aub9z.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $7f80bdb4337734ff$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $7f80bdb4337734ff$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $7f80bdb4337734ff$export$f5d5f6bb902f1027 = '-1';
const $7f80bdb4337734ff$export$106087dcfd4fb129 = 100;

parcelRegister("81O8J", function(module, exports) {

$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $b784ee4f71bce498$export$9e8b5e552e255163);

var $607Dw = parcelRequire("607Dw");
class $b784ee4f71bce498$export$9e8b5e552e255163 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("607Dw", function(module, exports) {

$parcel$export(module.exports, "UiModificationsValidationError", () => $8683b9e27ffb2718$export$6e8165c81a6a65df);
class $8683b9e27ffb2718$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("cfL5m", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegistered", () => $84902f345f4d9ec2$export$fbe9157c12cb4e7b);
const $84902f345f4d9ec2$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("3JMvu", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $7a07bba1139035a5$export$460820f27643954e);

var $82wKS = parcelRequire("82wKS");
const $7a07bba1139035a5$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("82idB", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $b396c3e05312c1f7$export$e1fce51bc5be90b7);
const $b396c3e05312c1f7$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("lKslV", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $fb1c6d2f11d8a679$export$aa453854f74fab);

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $fb1c6d2f11d8a679$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("TiFiE", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $0fdd9846971f3713$export$d14f85c01e334a1);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $6rtzq = parcelRequire("6rtzq");

var $82wKS = parcelRequire("82wKS");


var $5sAot = parcelRequire("5sAot");

var $gOp4r = parcelRequire("gOp4r");

var $i9dWk = parcelRequire("i9dWk");
const $0fdd9846971f3713$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gRw8I.di)((0, $82wKS.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $gOp4r.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $gOp4r.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $6rtzq.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $585e8f7167f61808$export$d1996cb46a690190),
                        method: (0, $5sAot.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $i9dWk.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $i9dWk.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("6rtzq", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a);
class $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("gOp4r", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $af0c126b48130091$export$ee79e3ab53b8db79);
const $af0c126b48130091$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("i9dWk", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $d76dab7db88ac392$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $d76dab7db88ac392$export$ddd005554aecd409);
const $d76dab7db88ac392$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $d76dab7db88ac392$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("dmz3j", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $d4a266f6d4506eb1$export$131c67fd312b8a11);

var $gRw8I = parcelRequire("gRw8I");

var $9WNAv = parcelRequire("9WNAv");

var $iGhbB = parcelRequire("iGhbB");

var $aub9z = parcelRequire("aub9z");

var $2TFQ7 = parcelRequire("2TFQ7");
const $d4a266f6d4506eb1$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gRw8I.di)((0, $aub9z.collectScreenTabsAppliedChangesHistory), (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $2TFQ7.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $2TFQ7.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $aub9z.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $9WNAv.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $iGhbB.toScreenTabsValidationError))
        });
    };

});
parcelRegister("9WNAv", function(module, exports) {

$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $5a1018b8bae0ac45$export$faf1f1824ee0a136);

var $607Dw = parcelRequire("607Dw");
class $5a1018b8bae0ac45$export$faf1f1824ee0a136 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("iGhbB", function(module, exports) {

$parcel$export(module.exports, "toScreenTabsValidationError", () => $609355188438e567$export$b2675440ade984fb);

const $609355188438e567$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $585e8f7167f61808$export$fd26696d109785a0)
    });

});

parcelRegister("2TFQ7", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $e157d25468b560b0$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $e157d25468b560b0$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $e157d25468b560b0$export$62d63af83dac7315);

var $eGOwo = parcelRequire("eGOwo");
const $e157d25468b560b0$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $e157d25468b560b0$var$isValidScreenTabId = (internalScreenTabs, id)=>$e157d25468b560b0$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $e157d25468b560b0$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, id) && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && $e157d25468b560b0$var$isValidScreenTabIsActive(isActive);
const $e157d25468b560b0$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $e157d25468b560b0$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $e157d25468b560b0$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $e157d25468b560b0$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if ((0, $eGOwo.fg)('ditto_uim_error_cb_screen_tabs')) screenTabsFromApp.forEach((tab)=>{
        if (!$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, tab)) {
            if (!$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, tab.id)) errors.push(`Screen tab with id ${tab.id} does not exist in the current view.`);
            if (!$e157d25468b560b0$var$isValidScreenTabIsVisible(tab.isVisible)) errors.push(`Visible state for tab with id ${tab.id} should be a boolean.`);
            if (!$e157d25468b560b0$var$isValidScreenTabIsActive(tab.isActive)) errors.push(`Active state for tab with id ${tab.id} should be a boolean.`);
        }
    });
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("cs58I", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesValue", () => $22623340bdbf14f6$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $22623340bdbf14f6$export$eefe4b2985e8203e);

var $eJOHy = parcelRequire("eJOHy");

var $jkWf0 = parcelRequire("jkWf0");

var $etbP7 = parcelRequire("etbP7");
const $22623340bdbf14f6$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $jkWf0.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $eJOHy.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, newValue);
    }, [
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $eJOHy.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
    }, [
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    const setUserPreferences = (0, $eJOHy.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue
        }), [
        setValue,
        deleteValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $22623340bdbf14f6$export$eefe4b2985e8203e = ()=>{
    const [, actions] = (0, $jkWf0.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $eJOHy.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("jkWf0", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $97758271cd46a4b8$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $97758271cd46a4b8$export$4d156074562bac9a);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $i64h0 = parcelRequire("i64h0");
const $97758271cd46a4b8$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $i64h0.actions
});
const $97758271cd46a4b8$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $97758271cd46a4b8$export$46e7eeb2fc34fab8 = (0, $iJq0l.createHook)($97758271cd46a4b8$export$6f57813fe9f31bf9, {
    selector: $97758271cd46a4b8$var$getUserPreference
});
const $97758271cd46a4b8$export$4d156074562bac9a = (0, $iJq0l.createHook)($97758271cd46a4b8$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("i64h0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $343d470acbc8bd87$export$e324594224ef24da);
const $343d470acbc8bd87$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $343d470acbc8bd87$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $343d470acbc8bd87$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $343d470acbc8bd87$export$df0a4f67b9888111 = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $343d470acbc8bd87$export$e324594224ef24da = {
    setUserPreferenceValue: $343d470acbc8bd87$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $343d470acbc8bd87$var$deleteUserPreferenceValue,
    setUserPreferences: $343d470acbc8bd87$var$setUserPreferences,
    getUserPreferenceValue: $343d470acbc8bd87$export$df0a4f67b9888111
};

});


parcelRegister("etbP7", function(module, exports) {

$parcel$export(module.exports, "saveUserPreferenceValue", () => $a9cf1c440643deff$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $a9cf1c440643deff$export$a60a810760d07867);

var $keOPi = parcelRequire("keOPi");
const $a9cf1c440643deff$export$bebe1b9e9f4cbf16 = async (userPreferenceKey, value)=>(0, $keOPi.performIssuePutRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    }, 'user-preferences-services/src/utils');
const $a9cf1c440643deff$export$a60a810760d07867 = async (userPreferenceKey)=>(0, $keOPi.performIssueDeleteRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, undefined, 'user-preferences-services/src/utils');

});
parcelRegister("keOPi", function(module, exports) {

$parcel$export(module.exports, "performIssuePostRequest", () => $1d9dfe6a518cff33$export$f0d7c3d034d5811a);
$parcel$export(module.exports, "performIssuePutRequest", () => $1d9dfe6a518cff33$export$2167f099a5e216f1);
$parcel$export(module.exports, "performIssueDeleteRequest", () => $1d9dfe6a518cff33$export$cf3e603eb3bc78ab);
$parcel$export(module.exports, "performIssueGetRequest", () => $1d9dfe6a518cff33$export$36671e08961872af);

var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");

var $biGll = parcelRequire("biGll");
const $1d9dfe6a518cff33$export$f0d7c3d034d5811a = async (url, options = {}, path)=>{
    if ((0, $7jTnu.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $jGzN3.performPostRequest), url, options, path);
    return (0, $jGzN3.performPostRequest)(url, options);
};
const $1d9dfe6a518cff33$export$2167f099a5e216f1 = async (url, options = {}, path)=>{
    if ((0, $7jTnu.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $jGzN3.performPutRequest), url, options, path);
    return (0, $jGzN3.performPutRequest)(url, options);
};
const $1d9dfe6a518cff33$export$cf3e603eb3bc78ab = async (url, options = {}, path)=>{
    if ((0, $7jTnu.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $jGzN3.performDeleteRequest), url, options, path);
    return (0, $jGzN3.performDeleteRequest)(url, options);
};
const $1d9dfe6a518cff33$export$36671e08961872af = async (url, options = {}, path)=>{
    if ((0, $7jTnu.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $biGll.performIssueRequest)((0, $jGzN3.performGetRequest), url, options, path);
    return (0, $jGzN3.performGetRequest)(url, options);
};

});
parcelRegister("biGll", function(module, exports) {

$parcel$export(module.exports, "performIssueRequest", () => $00dfaa7a2eaf401f$export$2fba6590b0f30cb2);

var $3ibpe = parcelRequire("3ibpe");

var $1uIew = parcelRequire("1uIew");
const $00dfaa7a2eaf401f$var$isGiraUrl = (url)=>url.startsWith('/rest/gira/1/');
const $00dfaa7a2eaf401f$export$2fba6590b0f30cb2 = async (requestFn, url, options = {}, path = 'unknown')=>{
    const defaultExperienceDescription = {
        experience: $00dfaa7a2eaf401f$var$isGiraUrl(url) ? 'issueGira' : 'issueRest',
        analyticsSource: $00dfaa7a2eaf401f$var$isGiraUrl(url) ? 'issue-gira' : 'issue-rest',
        application: null,
        edition: null
    };
    try {
        const response = await requestFn(url, options);
        return response;
    } catch (error) {
        let traceId;
        let statusCode;
        let errorMessage;
        if (error instanceof Error || error instanceof (0, $1uIew.default) || error instanceof (0, $1uIew.ValidationError) || error instanceof TypeError) errorMessage = error.message;
        if (error instanceof (0, $1uIew.default) || error instanceof (0, $1uIew.ValidationError)) {
            traceId = error.traceId;
            statusCode = error.statusCode;
        }
        const additionalAttributes = {
            statusCode: statusCode || 0,
            errorMessage: errorMessage || 'unknown',
            traceId: traceId || 'unknown',
            path: path
        };
        if (statusCode && statusCode >= 400 && statusCode < 500 || error instanceof Error && error.cause instanceof TypeError) {
            (0, $3ibpe.sendExperienceAnalytics)({
                ...defaultExperienceDescription,
                action: 'taskAbort',
                additionalAttributes: additionalAttributes
            });
            throw error;
        }
        (0, $3ibpe.sendExperienceAnalytics)({
            ...defaultExperienceDescription,
            action: 'taskFail',
            additionalAttributes: additionalAttributes
        });
        throw error;
    }
};

});




const $a85d9f0dd63c9b50$export$a763454c55d057f2 = 'jira.user.issue.clickthrough-banner.lastinteracted';
const $a85d9f0dd63c9b50$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $a85d9f0dd63c9b50$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $a85d9f0dd63c9b50$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $a85d9f0dd63c9b50$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $a85d9f0dd63c9b50$export$39aaf586c7ee5202 = 'jira.user.issue.user-preferred-layouts';
const $a85d9f0dd63c9b50$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $a85d9f0dd63c9b50$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $a85d9f0dd63c9b50$export$1a08240e14f65aa = 'jira.user.issue.collapsible-sections-state';
const $a85d9f0dd63c9b50$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';

parcelRegister("16PQW", function(module, exports) {

$parcel$export(module.exports, "Tabs", () => $9af4469a8b4e550d$export$b2539bed5023c21c);
$parcel$export(module.exports, "defaultActiveTab", () => $9af4469a8b4e550d$export$7566e064a478af42);
const $9af4469a8b4e550d$export$b2539bed5023c21c = {
    Description: 'description',
    WorkItems: 'workItems',
    Resources: 'resources',
    Integrations: 'integrations'
};
const $9af4469a8b4e550d$export$7566e064a478af42 = $9af4469a8b4e550d$export$b2539bed5023c21c.Description;
const $9af4469a8b4e550d$export$d07bba395c9390f1 = 42;

});

parcelRegister("lpEwy", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $e029db5d7fe89f63$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $e029db5d7fe89f63$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $e029db5d7fe89f63$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $e029db5d7fe89f63$export$5513f3c310d101f5);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $5TQFX = parcelRequire("5TQFX");
const $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY = [];
const $e029db5d7fe89f63$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY;
const $e029db5d7fe89f63$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
const $e029db5d7fe89f63$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $5TQFX
});
const $e029db5d7fe89f63$export$5c4a1f63cea7b5b3 = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContainers
});
const $e029db5d7fe89f63$export$769bbe2bda9a43ce = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutGlance
});
const $e029db5d7fe89f63$export$3aa9017e11451546 = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel
});
const $e029db5d7fe89f63$export$5513f3c310d101f5 = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("5TQFX", function(module, exports) {

$parcel$export(module.exports, "setIssueViewContainersLayout", () => $1fee7e98aeef55ea$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $1fee7e98aeef55ea$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $1fee7e98aeef55ea$export$9a04e4b958ebc410);
const $1fee7e98aeef55ea$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $1fee7e98aeef55ea$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $1fee7e98aeef55ea$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("co62F", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $f780ca908cc08c0e$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $f780ca908cc08c0e$export$355607dae809ec65);

var $5OyZl = parcelRequire("5OyZl");
const $f780ca908cc08c0e$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $5OyZl.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $5OyZl.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $5OyZl.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $f780ca908cc08c0e$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($f780ca908cc08c0e$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $5OyZl.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $f780ca908cc08c0e$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("5OyZl", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $37dff345eecb4f05$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $37dff345eecb4f05$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $37dff345eecb4f05$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $37dff345eecb4f05$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $37dff345eecb4f05$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $37dff345eecb4f05$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $37dff345eecb4f05$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $37dff345eecb4f05$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $37dff345eecb4f05$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $37dff345eecb4f05$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $37dff345eecb4f05$export$ad3536b13febb432);
const $37dff345eecb4f05$export$99ad62164189f781 = 'ecosystemGlance';
const $37dff345eecb4f05$export$7719ef6e9283671 = 'forgeGlance';
const $37dff345eecb4f05$export$bfebea5ce2e1887a = 'ecosystemContext';
const $37dff345eecb4f05$export$be8e68fb1aed253e = 'forgeContext';
const $37dff345eecb4f05$export$7bf561e6ab380ea1 = 'context';
const $37dff345eecb4f05$export$f42c11634d75863e = 'content';
const $37dff345eecb4f05$export$b38842736b6dbc1d = 'content-request';
const $37dff345eecb4f05$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_TYPE = 'FORGE';
const $37dff345eecb4f05$export$605c43f1b33ab69 = 'SUMMARY';
const $37dff345eecb4f05$export$e655b77b9efe622f = 'CustomItem';
const $37dff345eecb4f05$export$5cf403de05e9bea = 'FieldSectionItem';
const $37dff345eecb4f05$export$30f7f9a86f182492 = 'TabLayout';
const $37dff345eecb4f05$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $37dff345eecb4f05$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $37dff345eecb4f05$export$ad3536b13febb432 = (node)=>node.type === $37dff345eecb4f05$export$5507f31126c8b283.tab;

});



parcelRegister("cZpx8", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $ae6f6bc492f6f5be$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $ae6f6bc492f6f5be$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $ae6f6bc492f6f5be$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $ae6f6bc492f6f5be$var$cachedIsCompactValues = {};
let $ae6f6bc492f6f5be$var$previousRouteKey;
function $ae6f6bc492f6f5be$export$c47621d55d10906c(key) {
    return $ae6f6bc492f6f5be$var$cachedIsCompactValues[key];
}
function $ae6f6bc492f6f5be$export$568b2dd75c2027b4(isCompactValue, key) {
    $ae6f6bc492f6f5be$var$cachedIsCompactValues[key] = isCompactValue;
}
function $ae6f6bc492f6f5be$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $ae6f6bc492f6f5be$var$previousRouteKey) {
        $ae6f6bc492f6f5be$var$previousRouteKey = currentRouteKey;
        delete $ae6f6bc492f6f5be$var$cachedIsCompactValues[$ae6f6bc492f6f5be$var$previousRouteKey];
    }
}

});


parcelRegister("4h5lX", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});

parcelRegister("7oQeg", function(module, exports) {
module.exports = new URL("issue-app-skeleton.exp.tpl.4aeaad6d.svg", import.meta.url).toString();

});



parcelRegister("juAwR", function(module, exports) {

$parcel$export(module.exports, "defaultRatioRightColumn", () => $72456224b1981159$export$7fec582ac43ca9da);
$parcel$export(module.exports, "largeScreenRatioRightColumn", () => $72456224b1981159$export$28d7967aa38f2f87);
$parcel$export(module.exports, "activitySidePanelRatio", () => $72456224b1981159$export$6695481d80b63521);
$parcel$export(module.exports, "getIssueContainerIncreasedMaxWidth", () => $72456224b1981159$export$9d883719bd435511);
$parcel$export(module.exports, "ACTIVITY_SIDE_PANEL_MIN_WIDTH", () => $72456224b1981159$export$dd2feff7666e1f68);
const $72456224b1981159$export$7fec582ac43ca9da = 0.35;
const $72456224b1981159$export$28d7967aa38f2f87 = 0.4;
const $72456224b1981159$export$6695481d80b63521 = 0.4;
const $72456224b1981159$export$7fe9ac2b6449f553 = ()=>1680;
const $72456224b1981159$export$9d883719bd435511 = ()=>1920;
const $72456224b1981159$export$dd2feff7666e1f68 = 400;

});

parcelRegister("j2oKY", function(module, exports) {

$parcel$export(module.exports, "useStartNinIssueAppAnalytics", () => $d562bf0afb5d23f6$export$39482b240f0b451f);

var $eJOHy = parcelRequire("eJOHy");

var $hqYEY = parcelRequire("hqYEY");

var $6d9QY = parcelRequire("6d9QY");

var $HiS1C = parcelRequire("HiS1C");
const $d562bf0afb5d23f6$export$b9b395b52bdc3f4a = (0, $hqYEY.metrics).pageSegmentLoad({
    key: 'new-issue-navigator.issue-app'
});
const $d562bf0afb5d23f6$export$39482b240f0b451f = (issueKey)=>{
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const previousIssueKey = (0, $6d9QY.usePrevious)(issueKey);
    // We explicitly start during render instead of an effect hook as onInteractive can be fired before the effect hook
    // has run for cached issues.
    if (issueKey !== previousIssueKey) $d562bf0afb5d23f6$export$b9b395b52bdc3f4a.start();
    const onInteractive = (0, $eJOHy.useCallback)(()=>{
        $d562bf0afb5d23f6$export$b9b395b52bdc3f4a.stop({
            customData: {
                view: view
            }
        });
    }, [
        view
    ]);
    return {
        onInteractive: onInteractive
    };
};

});

parcelRegister("ijD5s", function(module, exports) {

$parcel$export(module.exports, "useOnDeleteIssue", () => $e6a0a9ccae3b9301$export$45e2b3c3de4980ed);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");
const $e6a0a9ccae3b9301$var$getKeyForEdge = (edge)=>{
    const { NODE: NODE } = (0, $37Ewn.ConnectionInterface).get();
    return edge?.getLinkedRecord(NODE)?.getValue('key');
};
const $e6a0a9ccae3b9301$var$getFirstEdgeCursor = (connectionRecord)=>{
    const { CURSOR: CURSOR, EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
    const cursor = edges[0]?.getValue(CURSOR);
    return cursor ? String(cursor) : null;
};
const $e6a0a9ccae3b9301$var$getLastEdgeCursor = (connectionRecord)=>{
    const { CURSOR: CURSOR, EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
    const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
    const cursor = edges[edges.length - 1]?.getValue(CURSOR);
    return cursor ? String(cursor) : null;
};
const $e6a0a9ccae3b9301$var$updatePageInfoCursor = (pageInfo, pageInfoField, replacementCursor, edgeToDelete)=>{
    if (!pageInfo || !replacementCursor) return;
    const { CURSOR: CURSOR } = (0, $37Ewn.ConnectionInterface).get();
    const pageInfoCursor = pageInfo.getValue(pageInfoField);
    if (pageInfoCursor && pageInfoCursor === edgeToDelete.getValue(CURSOR)) pageInfo.setValue(replacementCursor, pageInfoField);
};
const $e6a0a9ccae3b9301$var$updatePageInfo = (connectionRecord, edgeToDelete)=>{
    const { START_CURSOR: START_CURSOR, END_CURSOR: END_CURSOR, PAGE_INFO: PAGE_INFO } = (0, $37Ewn.ConnectionInterface).get();
    const pageInfo = connectionRecord.getLinkedRecord(PAGE_INFO);
    $e6a0a9ccae3b9301$var$updatePageInfoCursor(pageInfo, START_CURSOR, $e6a0a9ccae3b9301$var$getFirstEdgeCursor(connectionRecord), edgeToDelete);
    $e6a0a9ccae3b9301$var$updatePageInfoCursor(pageInfo, END_CURSOR, $e6a0a9ccae3b9301$var$getLastEdgeCursor(connectionRecord), edgeToDelete);
};
const $e6a0a9ccae3b9301$export$45e2b3c3de4980ed = (connectionId)=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)((issueKeyToDelete)=>{
        let previousIssueKey;
        let nextIssueKey;
        (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const connectionRecord = connectionId ? store.get(connectionId) : undefined;
            if (!connectionRecord) return;
            const { EDGES: EDGES } = (0, $37Ewn.ConnectionInterface).get();
            const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
            const index = edges.findIndex((edge)=>$e6a0a9ccae3b9301$var$getKeyForEdge(edge) === issueKeyToDelete);
            if (index > -1) {
                nextIssueKey = $e6a0a9ccae3b9301$var$getKeyForEdge(edges[index + 1]);
                previousIssueKey = $e6a0a9ccae3b9301$var$getKeyForEdge(edges[index - 1]);
                // Filter out deleted record from our connection
                connectionRecord.setLinkedRecords(edges.slice(0, index).concat(edges.slice(index + 1)), EDGES);
                // Update page start/end cursors if necessary following record delete
                $e6a0a9ccae3b9301$var$updatePageInfo(connectionRecord, edges[index]);
                // Decrement the total count
                const totalCount = connectionRecord.getValue('totalIssueSearchResultCount');
                if (typeof totalCount === 'number') connectionRecord.setValue(totalCount - 1, 'totalIssueSearchResultCount');
            }
        });
        // Return the next issue key to select. If there is no next issue key then return the previous key.
        return nextIssueKey ?? previousIssueKey ?? '';
    }, [
        environment,
        connectionId
    ]);
};

});

parcelRegister("1aawv", function(module, exports) {

$parcel$export(module.exports, "useIssueByFieldsRefetch", () => $cb3ec1bae6313c34$export$a3f7fddb3e08cea5);

var $9G4Gz = parcelRequire("9G4Gz");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $lvKO5 = parcelRequire("lvKO5");

var $7jTnu = parcelRequire("7jTnu");

var $iRahl = parcelRequire("iRahl");

var $aaLZH = parcelRequire("aaLZH");
const $cb3ec1bae6313c34$export$a3f7fddb3e08cea5 = (fieldSets)=>{
    const { cloudId: cloudId } = (0, $lvKO5.useTenantContext)();
    const isConditionalFormattingEnabled = (0, $7jTnu.fg)('jira_list_conditional_formatting') && // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $aaLZH.useIssueNavigatorFeatures)().isConditionalFormattingEnabled;
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)((issuekey)=>(0, $37Ewn.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/must-colocate-fragment-spreads */ (0, $9G4Gz.default), /* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/must-colocate-fragment-spreads */ {
            cloudId: cloudId,
            issueSearchInput: {
                jql: `issueKey=${issuekey}`
            },
            fieldSetIds: fieldSets,
            amountOfColumns: (0, $iRahl.MAX_AMOUNT_OF_COLUMNS),
            isConditionalFormattingEnabled: isConditionalFormattingEnabled,
            isTimelineEnabled: false
        }, {
            fetchPolicy: 'network-only'
        }).toPromise(), [
        cloudId,
        environment,
        fieldSets,
        isConditionalFormattingEnabled
    ]);
};

});
parcelRegister("9G4Gz", function(module, exports) {

$parcel$export(module.exports, "default", () => $13564d0e05568c10$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9657f1d255d961161dcfaec46d078fdc>>
 * @relayHash 0896ad6cc79ce04083b4d4246571ca37
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1dfcb19220b245219270012c7d9e97aa8c1d654bc14469e362ab2bdff26afadb

var $kZq2R = parcelRequire("kZq2R");

var $dTrc4 = parcelRequire("dTrc4");

var $kiE1V = parcelRequire("kiE1V");

var $hRj2m = parcelRequire("hRj2m");

var $jvWSl = parcelRequire("jvWSl");

var $bU8Sj = parcelRequire("bU8Sj");

var $gCEws = parcelRequire("gCEws");

var $fHkJz = parcelRequire("fHkJz");
const $13564d0e05568c10$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConditionalFormattingEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTimelineEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v6 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        v6 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "kind": "ScalarField",
        "name": "value"
    }, v15 = [
        v14 /*: any*/ ,
        v12 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v17 = {
        "kind": "ClientExtension",
        "selections": [
            v16 /*: any*/ 
        ]
    }, v18 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v19 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v20 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v22 = {
        "kind": "ScalarField",
        "name": "text"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": [
            v22 /*: any*/ ,
            v13 /*: any*/ ,
            v17 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v24 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v25 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v12 /*: any*/ 
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v27 = [
        v24 /*: any*/ 
    ], v28 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v30 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v31 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    }, v32 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v33 = {
        "kind": "ScalarField",
        "name": "key"
    }, v34 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v35 = {
        "kind": "ClientExtension",
        "selections": [
            v34 /*: any*/ 
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "href"
    }, v37 = [
        v13 /*: any*/ ,
        v12 /*: any*/ 
    ], v38 = {
        "kind": "ScalarField",
        "name": "date"
    }, v39 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v40 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v41 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v42 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v43 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v44 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v45 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v44 /*: any*/ ,
                    v13 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v12 /*: any*/ 
        ]
    }, v46 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v47 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v48 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v49 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v50 = {
        "concreteType": "JiraStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v51 = {
        "kind": "ScalarField",
        "name": "number"
    }, v52 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v53 = [
        {
            "kind": "Literal",
            "name": "viewId",
            "value": "list_default"
        }
    ], v54 = [
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v38 /*: any*/ 
            ],
            "type": "JiraDatePickerField"
        },
        v12 /*: any*/ 
    ], v55 = [
        v10 /*: any*/ ,
        v12 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "refetchIssue_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v8 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "isConditionalFormattingEnabled",
                                                                    "variableName": "isConditionalFormattingEnabled"
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isDensityFull",
                                                                    "value": false
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isInlineEditingEnabled",
                                                                    "value": true
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isLinkRelationshipFieldEnabled",
                                                                    "value": false
                                                                },
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "isTimelineEnabled",
                                                                    "variableName": "isTimelineEnabled"
                                                                }
                                                            ],
                                                            "kind": "FragmentSpread",
                                                            "name": "IssueRow336BadPattern"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "main_issueNavigator_Card_fieldSets"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "refetchIssue_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v8 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldSetId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v10 /*: any*/ ,
                                                                                                v11 /*: any*/ ,
                                                                                                v9 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "TypeDiscriminator",
                                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                                },
                                                                                                v12 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "serviceId"
                                                                                                                                },
                                                                                                                                v13 /*: any*/ ,
                                                                                                                                v12 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraAffectedServicesField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "cascadingOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "parentOptionValue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v15 /*: any*/ 
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "childOptionValue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v15 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraCascadingSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v18 /*: any*/ ,
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v20 /*: any*/ ,
                                                                                                                                        v12 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v21 /*: any*/ ,
                                                                                                                v13 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraDateTimePickerField"
                                                                                                        },
                                                                                                        v23 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "commentSummary",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "canAddComment"
                                                                                                                        },
                                                                                                                        v24 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraCommentSummaryField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "uri"
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraUrlField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v14 /*: any*/ ,
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v12 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldOptions",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v27 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                        v14 /*: any*/ ,
                                                                                                                                        v26 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                        v14 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraCheckboxesField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedUsersConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                        v13 /*: any*/ ,
                                                                                                                                        v29 /*: any*/ ,
                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                        v30 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "email"
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraTeamView",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedTeam",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "jiraSuppliedId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "jiraSuppliedName"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraTeamViewField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v12 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraEstimate",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "originalEstimate",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "timeInSeconds"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "timeTrackingSettings",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "workingHoursPerDay"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "workingDaysPerWeek"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "defaultFormat"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "defaultUnit"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v13 /*: any*/ ,
                                                                                                                                v9 /*: any*/ ,
                                                                                                                                v17 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v12 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v31 /*: any*/ ,
                                                                                                                        v12 /*: any*/ ,
                                                                                                                        v19 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraRadioSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v18 /*: any*/ ,
                                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedVersionsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                        v13 /*: any*/ ,
                                                                                                                                        v19 /*: any*/ ,
                                                                                                                                        v20 /*: any*/ ,
                                                                                                                                        v32 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v12 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v18 /*: any*/ ,
                                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedGoals",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                        v33 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v35 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ClientExtension",
                                                                                                                    "selections": [
                                                                                                                        v34 /*: any*/ ,
                                                                                                                        v16 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraGoalsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v18 /*: any*/ ,
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                        v36 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                                                                                            "kind": "Condition",
                                                                                                                                            "passingValue": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "pageContent",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v36 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraConfluencePageContentDetails"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v24 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "objectId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "label"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "mediaClientConfig",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "clientId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "fileId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaBaseUrl"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaJwtToken"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "url48"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "QueryError",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "errors",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "message"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCMDBField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": "componentsOld",
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v37 /*: any*/ 
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v38 /*: any*/ ,
                                                                                                        v13 /*: any*/ ,
                                                                                                        v39 /*: any*/ ,
                                                                                                        v17 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDatePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraEpic",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "epic",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v33 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "summary"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "color"
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraEpicLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "renderedFieldHtml"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFallbackField"
                                                                                                },
                                                                                                v23 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                v40 /*: any*/ ,
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusId"
                                                                                                                },
                                                                                                                v41 /*: any*/ ,
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v18 /*: any*/ ,
                                                                                                            "concreteType": "JiraLabelConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedLabelsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraLabel",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v13 /*: any*/ ,
                                                                                                                                v25 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v24 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                        },
                                                                                                        v13 /*: any*/ ,
                                                                                                        v17 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraLabelsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "small"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v33 /*: any*/ ,
                                                                                                                v42 /*: any*/ ,
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v33 /*: any*/ ,
                                                                                                                        v43 /*: any*/ ,
                                                                                                                        v45 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v12 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v33 /*: any*/ ,
                                                                                                                        v43 /*: any*/ ,
                                                                                                                        v45 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v12 /*: any*/ ,
                                                                                                                        v46 /*: any*/ ,
                                                                                                                        v47 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "args": [
                                                                                                                                        {
                                                                                                                                            "kind": "Literal",
                                                                                                                                            "name": "ids",
                                                                                                                                            "value": [
                                                                                                                                                "issuetype",
                                                                                                                                                "project",
                                                                                                                                                "summary",
                                                                                                                                                "status"
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "fieldsById",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "edges",
                                                                                                                                            "plural": true,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "node",
                                                                                                                                                    "plural": false,
                                                                                                                                                    "selections": [
                                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v11 /*: any*/ ,
                                                                                                                                                                v22 /*: any*/ 
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v11 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "issueType",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                                                        v48 /*: any*/ ,
                                                                                                                                                                        v13 /*: any*/ ,
                                                                                                                                                                        v44 /*: any*/ ,
                                                                                                                                                                        v49 /*: any*/ 
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraIssueTypeField"
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                                            "selections": [
                                                                                                                                                                v11 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraStatus",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "status",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                                                        {
                                                                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                                            "name": "statusCategory",
                                                                                                                                                                            "plural": false,
                                                                                                                                                                            "selections": [
                                                                                                                                                                                v12 /*: any*/ ,
                                                                                                                                                                                v40 /*: any*/ 
                                                                                                                                                                            ]
                                                                                                                                                                        }
                                                                                                                                                                    ]
                                                                                                                                                                }
                                                                                                                                                            ],
                                                                                                                                                            "type": "JiraStatusField"
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ],
                                                                                                                                    "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueTypeField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v11 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "issueType",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v48 /*: any*/ ,
                                                                                                                                                v49 /*: any*/ 
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "summaryField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v11 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusField",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusField",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                        v11 /*: any*/ ,
                                                                                                                                        v50 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v13 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraParentIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v13 /*: any*/ ,
                                                                                                        v17 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                v33 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "large"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraResolution",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "resolution",
                                                                                                            "plural": false,
                                                                                                            "selections": v37 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraResolutionField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedSprintsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSprint",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v12 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "sprintId"
                                                                                                                                },
                                                                                                                                v13 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "state"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "endDate"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v13 /*: any*/ ,
                                                                                                        v17 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSprintField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v10 /*: any*/ ,
                                                                                                                v28 /*: any*/ ,
                                                                                                                v29 /*: any*/ ,
                                                                                                                v13 /*: any*/ ,
                                                                                                                v12 /*: any*/ ,
                                                                                                                v30 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v13 /*: any*/ ,
                                                                                                        v39 /*: any*/ ,
                                                                                                        v17 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v18 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v37 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraRichText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "richText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraADF",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "adfValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRichTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "requestType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                v44 /*: any*/ ,
                                                                                                                v12 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                v6 /*: any*/ 
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLinkConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v24 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v47 /*: any*/ ,
                                                                                                                                        v33 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": [
                                                                                                                                                {
                                                                                                                                                    "kind": "Literal",
                                                                                                                                                    "name": "ids",
                                                                                                                                                    "value": [
                                                                                                                                                        "statusCategory"
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "fieldsById",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v10 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v41 /*: any*/ 
                                                                                                                                                                    ],
                                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                                },
                                                                                                                                                                v12 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                        },
                                                                                                                                        v12 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "relationName"
                                                                                                                                },
                                                                                                                                v12 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "issueLinkConnection(first:1)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isStoryPointField"
                                                                                                        },
                                                                                                        v51 /*: any*/ ,
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                v51 /*: any*/ ,
                                                                                                                v52 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                v51 /*: any*/ ,
                                                                                                                v13 /*: any*/ ,
                                                                                                                v52 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v17 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraNumberField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraGroupConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedGroupsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroupEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGroup",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v12 /*: any*/ ,
                                                                                                                                v13 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "groupId"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v17 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraMultipleGroupPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraFlag",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "flag",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "isFlagged"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraFlagField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraWatch",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "watch",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "count"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isWatching"
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraWatchesField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "isTimelineEnabled",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v12 /*: any*/ ,
                                                                                                                        v46 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueTypeField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issueType",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v13 /*: any*/ ,
                                                                                                                                        v49 /*: any*/ ,
                                                                                                                                        v12 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v12 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraParentIssueField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "parentIssueField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "parentIssue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v46 /*: any*/ ,
                                                                                                                                        v33 /*: any*/ ,
                                                                                                                                        v12 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v12 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v33 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatusField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "statusField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v50 /*: any*/ ,
                                                                                                                                v12 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "assigneeField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "user",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v29 /*: any*/ ,
                                                                                                                                        v12 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v12 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "args": v53 /*: any*/ ,
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "startDateViewField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v54 /*: any*/ ,
                                                                                                                            "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "args": v53 /*: any*/ ,
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "endDateViewField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v54 /*: any*/ ,
                                                                                                                            "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraTimelineField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v35 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": v27 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "isConditionalFormattingEnabled",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": v18 /*: any*/ ,
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "componentId"
                                                                                                                                        },
                                                                                                                                        v12 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedUsersConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                        v12 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraPriority",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "priority",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "priorityId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraPriorityField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraProject",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "project",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "projectId"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraProjectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "version",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v32 /*: any*/ ,
                                                                                                                        v12 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v48 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraIssueTypeField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": v18 /*: any*/ ,
                                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedVersionsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v32 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v55 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSelectableValueConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedValues",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSelectableValueEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v55 /*: any*/ 
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v31 /*: any*/ ,
                                                                                                                        v12 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraRadioSelectField"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1dfcb19220b245219270012c7d9e97aa8c1d654bc14469e362ab2bdff26afadb",
            "metadata": {},
            "name": "refetchIssue_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $gCEws.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $fHkJz.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $kiE1V.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": (0, $dTrc4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": (0, $hRj2m.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $bU8Sj.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": (0, $kZq2R.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": (0, $jvWSl.default)
            }
        }
    };
}();
$13564d0e05568c10$var$node.hash = "c81f91e9b55d1fd1910e2ea62e75135e";
var $13564d0e05568c10$export$2e2bcd8739ae039 = $13564d0e05568c10$var$node;

});


parcelRegister("ccZ0S", function(module, exports) {

$parcel$export(module.exports, "default", () => $860e6b9a205b1e93$export$2e2bcd8739ae039);

var $5Ej1B = parcelRequire("5Ej1B");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $j4oe4 = parcelRequire("j4oe4");

var $ljT8M = parcelRequire("ljT8M");

var $6XJko = parcelRequire("6XJko");

var $1wL9i = parcelRequire("1wL9i");

var $04djv = parcelRequire("04djv");
/**
 * Render extraHeaderActions if provided or otherwise return an empty render.
 */ const $860e6b9a205b1e93$var$HeaderActionsFallback = ({ extraHeaderActions: extraHeaderActions, isEmbedView: isEmbedView, maxWidth: maxWidth })=>extraHeaderActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($860e6b9a205b1e93$var$HeaderActionsContainer, {
        maxWidth: maxWidth,
        isEmbedView: isEmbedView,
        isVREnabled: (0, $6XJko.isVisualRefreshEnabled)()
    }, extraHeaderActions) : null;
/**
 * Render issue pagination controls and extraHeaderActions if provided.
 */ const $860e6b9a205b1e93$var$HeaderActions = (props)=>{
    const { extraHeaderActions: extraHeaderActions, issueResults: issueResults, maxWidth: maxWidth, isEmbedView: isEmbedView } = props;
    const issueResultsData = (0, $j4oe4.useFragment)((0, $5Ej1B.default), issueResults);
    const issuesCount = (0, $1wL9i.useIssuesCount)();
    const selectedIssueIndex = (0, $1wL9i.useSelectedIssueIndex)(); // If selectedIssueIndex is negative then our selected issue key does not exist in the result set, so there
    // are no pagination controls to show.
    // If issueResultsData is null and issuesCount is not zero it means the grouping is enabled
    if (selectedIssueIndex === -1 || issueResultsData == null && issuesCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($860e6b9a205b1e93$var$HeaderActionsFallback, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($860e6b9a205b1e93$var$HeaderActionsContainer, {
        maxWidth: maxWidth,
        isEmbedView: isEmbedView,
        isVREnabled: (0, $6XJko.isVisualRefreshEnabled)()
    }, extraHeaderActions ?? null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $04djv.default), {
        issueResults: issueResultsData ?? null
    }));
};
var $860e6b9a205b1e93$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $ljT8M.withRecoverableErrorBoundary)($860e6b9a205b1e93$var$HeaderActions, {
    recoveryProp: 'issueResults',
    Fallback: $860e6b9a205b1e93$var$HeaderActionsFallback
});
const $860e6b9a205b1e93$var$HeaderActionsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEmbedView: isEmbedView, maxWidth: maxWidth, isVREnabled: isVREnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $awdRS.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _4cvr1h6o _1bahesu3 _1e0c1txw _1bsb1osq _vchhusvi _10nju2gc",
            __cmplp.isEmbedView && "_n3tdu2gc",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.isVREnabled ? "_7zw61ejb" : "_7zw6v47k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5Ej1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $b82aa42a971d766e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0bc51f9494de5d6fa2940f677e3da0a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b82aa42a971d766e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "headerActions_issueNavigator",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "issuePagination_issueNavigator"
        }
    ],
    "type": "JiraIssueConnection"
};
$b82aa42a971d766e$var$node.hash = "701bdde8a1a96783e68d573053dd8362";
var $b82aa42a971d766e$export$2e2bcd8739ae039 = $b82aa42a971d766e$var$node;

});

parcelRegister("ljT8M", function(module, exports) {

$parcel$export(module.exports, "withRecoverableErrorBoundary", () => $d012b40ebc32b030$export$c25a1c850f00ce39);

var $eJOHy = parcelRequire("eJOHy");
function $d012b40ebc32b030$export$c25a1c850f00ce39(WrappedComponent, { recoveryProp: recoveryProp, Fallback: Fallback }) {
    class RecoverableErrorBoundary extends (0, $eJOHy.Component) {
        componentDidUpdate(prevProps) {
            if (this.state.errorProps && prevProps[recoveryProp] !== this.props[recoveryProp]) this.setState({
                errorProps: null
            });
        }
        componentDidCatch(error, errorInfo) {
            this.setState({
                errorProps: {
                    error: error,
                    errorInfo: errorInfo
                }
            });
        }
        render() {
            if (this.state.errorProps) return Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Fallback, {
                ...this.props,
                ...this.state.errorProps
            }) : null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, this.props);
        }
        constructor(...args){
            super(...args), this.state = {
                errorProps: null
            };
        }
    }
    return RecoverableErrorBoundary;
}

});

parcelRegister("04djv", function(module, exports) {

$parcel$export(module.exports, "default", () => $072cb017efc64f88$export$2e2bcd8739ae039);

var $lPpdH = parcelRequire("lPpdH");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $48q59 = parcelRequire("48q59");

var $1wL9i = parcelRequire("1wL9i");

var $6mNq3 = parcelRequire("6mNq3");

var $9Ei7s = parcelRequire("9Ei7s");
const $072cb017efc64f88$var$IssuePagination = ({ issueResults: issueResults })=>{
    const issuesCount = (0, $1wL9i.useIssuesCount)();
    const issueResultsData = (0, $j4oe4.useFragment)((0, $lPpdH.default), issueResults);
    const isCappingIssueSearchResult = issueResultsData?.isCappingIssueSearchResult ?? false;
    const totalIssueSearchResultCount = issueResultsData?.totalIssueSearchResultCount || issuesCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Ei7s.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6mNq3.default), {
        totalResultCount: totalIssueSearchResultCount,
        isCappingIssueSearchResult: isCappingIssueSearchResult
    })));
};
var $072cb017efc64f88$export$2e2bcd8739ae039 = $072cb017efc64f88$var$IssuePagination;

});
parcelRegister("lPpdH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f1a91960c071cb0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cdeacb15335634351a83b6eeb614c997>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7f1a91960c071cb0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issuePagination_issueNavigator",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            },
            "action": "THROW",
            "path": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }
    ],
    "type": "JiraIssueConnection"
};
$7f1a91960c071cb0$var$node.hash = "252cad0134e2ce14b78595c597895b8f";
var $7f1a91960c071cb0$export$2e2bcd8739ae039 = $7f1a91960c071cb0$var$node;

});

parcelRegister("6mNq3", function(module, exports) {

$parcel$export(module.exports, "default", () => $43d358f5802b3035$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5lAAn = parcelRequire("5lAAn");

var $Ay1uj = parcelRequire("Ay1uj");

var $k71qx = parcelRequire("k71qx");

var $3LCex = parcelRequire("3LCex");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $1wL9i = parcelRequire("1wL9i");

var $c3Udj = parcelRequire("c3Udj");
const $43d358f5802b3035$var$TooltipTag = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($43d358f5802b3035$var$StyledTooltipTag, {
        ref: ref,
        ...props
    }));
const $43d358f5802b3035$var$IssuePaginationNextButton = ({ totalResultCount: totalResultCount, isCappingIssueSearchResult: isCappingIssueSearchResult })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const actions = (0, $1wL9i.useSelectedIssueActions)();
    const selectNextIssue = actions.selectNextIssue;
    const issueKey = (0, $1wL9i.useNextIssueKey)();
    const isDisabled = !issueKey;
    const nextIssueMessage = issueKey ? formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c3Udj.default).nextIssueTooltipIssueTermRefresh : (0, $c3Udj.default).nextIssueTooltip, {
        issueKey: issueKey
    }) : formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c3Udj.default).nextIssueWithoutKeyTooltipIssueTermRefresh : (0, $c3Udj.default).nextIssueWithoutKeyTooltip);
    const onClick = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        if (selectNextIssue()) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'nextIssue');
    }, [
        selectNextIssue
    ]);
    if (isDisabled && isCappingIssueSearchResult) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c3Udj.default).disabledButtonTooltipIssueTermRefresh : (0, $c3Udj.default).disabledButtonTooltip),
        tag: $43d358f5802b3035$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3LCex.default), {
        tabIndex: 0,
        isDisabled: true,
        "data-testid": "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button.next-disabled-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c3Udj.default).disabledButtonTooltipIssueTermRefresh : (0, $c3Udj.default).disabledButtonTooltip),
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button",
        isDisabled: isDisabled,
        spacing: "compact"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                ...iconProps,
                size: "small"
            }),
        label: isDisabled ? formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c3Udj.default).disabledButtonLabelIssueTermRefresh : (0, $c3Udj.default).disabledButtonLabel, {
            issueCount: totalResultCount
        }) : nextIssueMessage,
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button",
        isDisabled: isDisabled,
        spacing: "compact",
        isTooltipDisabled: isDisabled
    });
};
var $43d358f5802b3035$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $43d358f5802b3035$var$IssuePaginationNextButton;
const $43d358f5802b3035$var$StyledTooltipTag = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3LCex", function(module, exports) {

$parcel$export(module.exports, "default", () => $0be296db7657e907$export$2e2bcd8739ae039);

var $cdbP5 = parcelRequire("cdbP5");
/**
 * When the @atlaskit/button component is disabled it prevents mouse events being fired for the button, which prevents
 * tooltips showing https://atlassian.design/components/button/usage#disabled-buttons.
 * When you require a disabled button to show a tooltip on hover then the button should be wrapped in this element.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0be296db7657e907$var$DisabledButtonWithTooltip = /*#__PURE__*/ (0, $cdbP5.default).span.withConfig({
    componentId: "yhjexx-0"
})({
    display: 'inline-flex'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $cdbP5.css)({
        cursor: 'not-allowed',
        // Disable pointer events for the button element which means 'event.preventDefault()' will not be
        // called from AK. This allows pointer events to bubble from our wrapping span element.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> button': {
            pointerEvents: 'none'
        }
    }) : '');
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0be296db7657e907$export$2e2bcd8739ae039 = $0be296db7657e907$var$DisabledButtonWithTooltip;

});

parcelRegister("c3Udj", function(module, exports) {

$parcel$export(module.exports, "default", () => $febe232ee4404552$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $febe232ee4404552$var$messages = (0, $7qGN1.defineMessages)({
    nextIssueTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-tooltip",
        "defaultMessage": "Next issue ''{issueKey}'' (Type 'j')"
    },
    nextIssueWithoutKeyTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-without-key-tooltip",
        "defaultMessage": "Next issue (Type 'j')"
    },
    disabledButtonTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-tooltip",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    },
    disabledButtonLabel: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-label",
        "defaultMessage": "{issueCount} of {issueCount} issues, select previous issues to go back"
    },
    disabledButtonLabelIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-label-issue-term-refresh",
        "defaultMessage": "{issueCount} of {issueCount} work items, select previous work items to go back"
    },
    nextIssueTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-tooltip-issue-term-refresh",
        "defaultMessage": "Next work item ''{issueKey}'' (Type 'j')"
    },
    nextIssueWithoutKeyTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-without-key-tooltip-issue-term-refresh",
        "defaultMessage": "Next work item (Type 'j')"
    },
    disabledButtonTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-tooltip-issue-term-refresh",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more work items."
    }
});
var $febe232ee4404552$export$2e2bcd8739ae039 = $febe232ee4404552$var$messages;

});


parcelRegister("9Ei7s", function(module, exports) {

$parcel$export(module.exports, "default", () => $29eddce1ee594519$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5Z6td = parcelRequire("5Z6td");

var $Ay1uj = parcelRequire("Ay1uj");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $1wL9i = parcelRequire("1wL9i");

var $gEghF = parcelRequire("gEghF");
const $29eddce1ee594519$var$IssuePaginationPreviousButton = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const actions = (0, $1wL9i.useSelectedIssueActions)();
    const selectPreviousIssue = actions.selectPreviousIssue;
    const issueKey = (0, $1wL9i.usePreviousIssueKey)();
    const isDisabled = !issueKey;
    const previousIssueMessage = issueKey ? formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gEghF.default).previousIssueTooltipIssueTermRefresh : (0, $gEghF.default).previousIssueTooltip, {
        issueKey: issueKey
    }) : formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gEghF.default).previousIssueWithoutKeyTooltipIssueTermRefresh : (0, $gEghF.default).previousIssueWithoutKeyTooltip);
    const onClick = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        if (selectPreviousIssue()) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'previousIssue');
    }, [
        selectPreviousIssue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5Z6td))), {
                ...iconProps,
                size: "small"
            }),
        label: isDisabled ? formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gEghF.default).disabledButtonLabelIssueTermRefresh : (0, $gEghF.default).disabledButtonLabel) : previousIssueMessage,
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.previous-button",
        isDisabled: isDisabled,
        spacing: "compact",
        isTooltipDisabled: isDisabled
    });
};
var $29eddce1ee594519$export$2e2bcd8739ae039 = $29eddce1ee594519$var$IssuePaginationPreviousButton;

});
parcelRegister("5Z6td", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ecfd08ddcabb52cab7a2dca467d438ba>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45b7ab1a0123d1e3$var$_react = $45b7ab1a0123d1e3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $45b7ab1a0123d1e3$var$_chevronUp = $45b7ab1a0123d1e3$var$_interopRequireDefault((parcelRequire("1vA1E")));

var $45b7ab1a0123d1e3$var$_chevronUp2 = $45b7ab1a0123d1e3$var$_interopRequireDefault((parcelRequire("5Qxpc")));
function $45b7ab1a0123d1e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "ChevronUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $45b7ab1a0123d1e3$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $45b7ab1a0123d1e3$var$_react.default.createElement($45b7ab1a0123d1e3$var$_chevronUp.default, Object.assign({
        name: "ChevronUpIcon",
        LEGACY_fallbackIcon: $45b7ab1a0123d1e3$var$_chevronUp2.default
    }, props));
$45b7ab1a0123d1e3$var$ChevronUpIcon.displayName = 'ChevronUpIconMigration';
var $45b7ab1a0123d1e3$var$_default = module.exports.default = $45b7ab1a0123d1e3$var$ChevronUpIcon;

});
parcelRegister("5Qxpc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $441bb8b72cd3bcbc$var$_react = $441bb8b72cd3bcbc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $441bb8b72cd3bcbc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $441bb8b72cd3bcbc$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $441bb8b72cd3bcbc$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props));
$441bb8b72cd3bcbc$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $441bb8b72cd3bcbc$var$_default = module.exports.default = $441bb8b72cd3bcbc$var$ChevronUpIcon;

});


parcelRegister("gEghF", function(module, exports) {

$parcel$export(module.exports, "default", () => $33fd8162de69a63e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $33fd8162de69a63e$var$messages = (0, $7qGN1.defineMessages)({
    previousIssueTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-tooltip",
        "defaultMessage": "Previous issue ''{issueKey}'' (Type 'k')"
    },
    previousIssueWithoutKeyTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-without-key-tooltip",
        "defaultMessage": "Previous issue (Type 'k')"
    },
    disabledButtonLabel: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.disabled-button-label",
        "defaultMessage": "No previous issue, select next issue"
    },
    disabledButtonLabelIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.disabled-button-label-issue-term-refresh",
        "defaultMessage": "No previous work item, select next work item"
    },
    previousIssueTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-tooltip-issue-term-refresh",
        "defaultMessage": "Previous work item ''{issueKey}'' (Type 'k')"
    },
    previousIssueWithoutKeyTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-without-key-tooltip-issue-term-refresh",
        "defaultMessage": "Previous work item (Type 'k')"
    }
});
var $33fd8162de69a63e$export$2e2bcd8739ae039 = $33fd8162de69a63e$var$messages;

});




parcelRegister("6IA67", function(module, exports) {

$parcel$export(module.exports, "useScrollToActivityFeed", () => $bdcc23b81973c095$export$5322fd37f123913);

var $eJOHy = parcelRequire("eJOHy");

var $1aJYF = parcelRequire("1aJYF");

var $95O7y = parcelRequire("95O7y");
const $bdcc23b81973c095$var$INTERVAL = 100;
const $bdcc23b81973c095$var$TIMEOUT = 10000;
const $bdcc23b81973c095$export$f0c653cfd7dea798 = ()=>{
    return globalThis.document.getElementById((0, $1aJYF.ELID_ISSUE_ACTIVITY_FEED));
};
const $bdcc23b81973c095$export$5322fd37f123913 = (issueKey)=>{
    const viewActivity = (0, $95O7y.useQueryParam)('viewActivity')[0] === 'true';
    const intervalId = (0, $eJOHy.useRef)();
    const timeoutId = (0, $eJOHy.useRef)();
    const isTimeout = (0, $eJOHy.useRef)(false);
    const waitForElement = (0, $eJOHy.useCallback)(()=>{
        if (isTimeout.current) return;
        const ref = $bdcc23b81973c095$export$f0c653cfd7dea798();
        if (ref) // sometimes the browser can't immediately scroll,
        // so we add a small timeout here to let it render Bento first
        setTimeout(()=>{
            ref.scrollIntoView({
                block: 'start',
                inline: 'nearest'
            });
        }, 300);
        else intervalId.current = setTimeout(waitForElement, $bdcc23b81973c095$var$INTERVAL);
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (!viewActivity) return;
        clearTimeout(intervalId.current);
        clearTimeout(timeoutId.current);
        isTimeout.current = false;
        // clear the interval in case comments section never shows up
        timeoutId.current = setTimeout(()=>{
            isTimeout.current = true;
        }, $bdcc23b81973c095$var$TIMEOUT);
        // kick off the interval if issueKey changes + on mount
        intervalId.current = setTimeout(waitForElement, $bdcc23b81973c095$var$INTERVAL);
        // clear interval on unmount
        return ()=>{
            clearTimeout(intervalId.current);
            clearTimeout(timeoutId.current);
        };
    }, [
        waitForElement,
        issueKey,
        viewActivity
    ]);
};

});
parcelRegister("1aJYF", function(module, exports) {

$parcel$export(module.exports, "issueAppModalWrapperClassName", () => $9c6cc50c84aad69b$export$6bf7918be801e6c5);
$parcel$export(module.exports, "MODAL_DROPDOWN_PORTAL_CLASS_NAME", () => $9c6cc50c84aad69b$export$bab98b619b4558be);
$parcel$export(module.exports, "EDITOR_DROPDOWN_PORTAL_CLASS_NAME", () => $9c6cc50c84aad69b$export$2ec9dc4e52ec0b5d);
$parcel$export(module.exports, "EDITOR_END_CLASS_NAME", () => $9c6cc50c84aad69b$export$18cffbebfac64f6d);
$parcel$export(module.exports, "EDITOR_START_CLASS_NAME", () => $9c6cc50c84aad69b$export$ebb284f63692b8b2);
$parcel$export(module.exports, "ISSUE_DESCRIPTION_EDITOR_ID", () => $9c6cc50c84aad69b$export$b8a46c806f8a6ef3);
$parcel$export(module.exports, "GIC_ISSUE_DESCRIPTION_EDITOR_ID", () => $9c6cc50c84aad69b$export$96cae1d6f7d37701);
$parcel$export(module.exports, "ELID_ISSUE_HEADER", () => $9c6cc50c84aad69b$export$4ca9dd62cc85a6c6);
$parcel$export(module.exports, "ELID_ISSUE_HEADER_ACTIONS", () => $9c6cc50c84aad69b$export$23d48b936935fa57);
$parcel$export(module.exports, "ELID_ISSUE_ACTIVITY_FEED", () => $9c6cc50c84aad69b$export$f1f90756574f5f9b);
$parcel$export(module.exports, "AGG_ISSUE_ERROR_ANALYTICS", () => $9c6cc50c84aad69b$export$66553a9be1be2f7e);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_ADD_BUTTON_REF_KEY", () => $9c6cc50c84aad69b$export$899103370186f1a1);
$parcel$export(module.exports, "DESIGN_PANEL_HEADING_ADD_DESIGN_REF_KEY", () => $9c6cc50c84aad69b$export$736b3d7f44d56d71);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $jXX71 = parcelRequire("jXX71");

var $f96mB = parcelRequire("f96mB");











var $bTB0V = parcelRequire("bTB0V");


var $16PQW = parcelRequire("16PQW");
const $9c6cc50c84aad69b$export$6bf7918be801e6c5 = '_issue-app-modal-dialog-wrapper';
const $9c6cc50c84aad69b$export$bab98b619b4558be = 'issue-app-modal-ak-dropdown-portal';
const $9c6cc50c84aad69b$export$2ec9dc4e52ec0b5d = 'issue-app-modal-editor-dropdown-portal';
const $9c6cc50c84aad69b$export$18cffbebfac64f6d = 'issue-editor-end';
const $9c6cc50c84aad69b$export$ebb284f63692b8b2 = 'issue-editor-start';
const $9c6cc50c84aad69b$export$b8a46c806f8a6ef3 = 'issue-description-editor';
const $9c6cc50c84aad69b$export$96cae1d6f7d37701 = 'issue-create.common.ui.fields.description-field.wrapper';
const $9c6cc50c84aad69b$export$3ef7e400a3598524 = 'issue.error';
const $9c6cc50c84aad69b$export$4ca9dd62cc85a6c6 = 'jira-issue-header';
const $9c6cc50c84aad69b$export$23d48b936935fa57 = 'jira-issue-header-actions';
const $9c6cc50c84aad69b$export$f1f90756574f5f9b = 'jira-issue-activity-feed';
const $9c6cc50c84aad69b$export$66553a9be1be2f7e = 'issue.error.agg';
const $9c6cc50c84aad69b$export$899103370186f1a1 = 'quick-add-items.add-button';
const $9c6cc50c84aad69b$export$736b3d7f44d56d71 = 'design-panel.heading.add-design';

});
parcelRegister("jXX71", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_WATCHING_ERROR", () => $7d95a623c6b7866a$export$ec8031e221d27341);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_GENERIC", () => $7d95a623c6b7866a$export$78f84210a13989cb);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_INVALID", () => $7d95a623c6b7866a$export$10b0b01977598ffc);
$parcel$export(module.exports, "COMMENT_ACTION_ERROR_INVALID_PERMISSION", () => $7d95a623c6b7866a$export$8443c3b41d7f09d8);
$parcel$export(module.exports, "COMMENT_ACTION_ERROR_NON_EDITABLE_WORKFLOW_STATE", () => $7d95a623c6b7866a$export$2d541e654485e45b);
$parcel$export(module.exports, "COMMENT_DELETE_ERROR_NON_EDITABLE_WORKFLOW_STATE", () => $7d95a623c6b7866a$export$5fcc12322c6ff365);
$parcel$export(module.exports, "COMMENT_CONTENT_EXCEEDED_ERROR", () => $7d95a623c6b7866a$export$9b38ca770beaf3d0);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS_FLAG_MESSAGE", () => $7d95a623c6b7866a$export$eef81693e817e3a6);
$parcel$export(module.exports, "COMMENT_FUTURE_TIME_ERROR", () => $7d95a623c6b7866a$export$a0d4d86bde270ad6);
$parcel$export(module.exports, "COMMENT_DELETE_ERROR", () => $7d95a623c6b7866a$export$6b6cd1b99772a4a1);
$parcel$export(module.exports, "EDITOR_ERROR", () => $7d95a623c6b7866a$export$2e48be8618f1b4f8);
$parcel$export(module.exports, "ATTACHMENT_ADD_ERROR", () => $7d95a623c6b7866a$export$c060b7873ebc2eb3);
$parcel$export(module.exports, "ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR", () => $7d95a623c6b7866a$export$1f8e6f6f8d64a715);
$parcel$export(module.exports, "ATTACHMENT_ADD_SUCCESS", () => $7d95a623c6b7866a$export$1f92a25b34c4df93);
$parcel$export(module.exports, "DELETE_LINKED_ISSUE_ERROR", () => $7d95a623c6b7866a$export$d8750340852b965e);
$parcel$export(module.exports, "REMOTE_LINK_VALIDATION_ERROR", () => $7d95a623c6b7866a$export$f0962d071c2a358a);
$parcel$export(module.exports, "ATTACHMENT_DELETE_ERROR", () => $7d95a623c6b7866a$export$ef7767ceecf9097c);
$parcel$export(module.exports, "WATCH_TOGGLE_UPDATE_ERROR", () => $7d95a623c6b7866a$export$516af79f4e3b8794);
$parcel$export(module.exports, "FETCH_WATCHERS_ERROR", () => $7d95a623c6b7866a$export$cde4105f7711a10a);
$parcel$export(module.exports, "STOP_WATCHING_SUCCESS", () => $7d95a623c6b7866a$export$f674d1f44f57f99d);
$parcel$export(module.exports, "START_WATCHING_SUCCESS", () => $7d95a623c6b7866a$export$bff6b5ab70bcec53);
$parcel$export(module.exports, "REMOVE_WATCHER_ERROR", () => $7d95a623c6b7866a$export$37934e343a22c4e6);
$parcel$export(module.exports, "ADD_WATCHER_ERROR", () => $7d95a623c6b7866a$export$6a1827094c1ef6d8);
$parcel$export(module.exports, "ADD_WATCHER_PERMISSION_ERROR", () => $7d95a623c6b7866a$export$ff2029b86d44f1d4);
$parcel$export(module.exports, "SUBTASKS_REORDER_ERROR_GENERIC", () => $7d95a623c6b7866a$export$bb96d519395e5dcc);
$parcel$export(module.exports, "LOG_WORK_CONFIRM_ERROR", () => $7d95a623c6b7866a$export$18bd55ba676f8b6d);
$parcel$export(module.exports, "ASSIGN_TO_ME_SUCCESS", () => $7d95a623c6b7866a$export$1249a100986a9489);
$parcel$export(module.exports, "REMOVE_FROM_ME_SUCCESS", () => $7d95a623c6b7866a$export$6b737093486e5a4e);
$parcel$export(module.exports, "CREATE_CHILD_ISSUE_ERROR", () => $7d95a623c6b7866a$export$a2723f15441225d0);
$parcel$export(module.exports, "LINK_CHILD_ISSUE_ERROR", () => $7d95a623c6b7866a$export$569f7258d337be55);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_SUCCESS", () => $7d95a623c6b7866a$export$f92af4e9761d23b9);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_ERROR", () => $7d95a623c6b7866a$export$16dc9ff6a8822a90);
$parcel$export(module.exports, "DELETE_ISSUE_ERROR", () => $7d95a623c6b7866a$export$d4030883b7b7a04);
$parcel$export(module.exports, "ADD_WORKLOG_SUCCESS", () => $7d95a623c6b7866a$export$2519b72aefd62ee3);
$parcel$export(module.exports, "ADD_WORKLOG_FAILURE", () => $7d95a623c6b7866a$export$190e4e4a6ee2a0a2);
$parcel$export(module.exports, "ADD_WORKLOG_NON_EDITABLE_FAILURE", () => $7d95a623c6b7866a$export$2fc2c0027e184f83);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED", () => $7d95a623c6b7866a$export$f1709ebef49207cc);
$parcel$export(module.exports, "UPDATE_TIME_REMAINING_FAILURE", () => $7d95a623c6b7866a$export$bde55584c7518e8d);
$parcel$export(module.exports, "EDIT_WORKLOG_SUCCESS", () => $7d95a623c6b7866a$export$cf8d549e537c67d3);
$parcel$export(module.exports, "EDIT_WORKLOG_FAILURE", () => $7d95a623c6b7866a$export$2d33e591258e36a8);
$parcel$export(module.exports, "DELETE_WORKLOG_SUCCESS", () => $7d95a623c6b7866a$export$b595535e9bb1a2a2);
$parcel$export(module.exports, "DELETE_WORKLOG_FAILURE", () => $7d95a623c6b7866a$export$c3739a68f63b7e09);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_CONFIRM_ERROR", () => $7d95a623c6b7866a$export$6ba6cb22d5a3c521);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR", () => $7d95a623c6b7866a$export$b1a41c9183097dc);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_REQUIRED_ERROR", () => $7d95a623c6b7866a$export$67544887e2b37fbc);
$parcel$export(module.exports, "DELETE_CONFLUENCE_PAGE_LINK_FAILED", () => $7d95a623c6b7866a$export$67566c205c72838a);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_ERROR", () => $7d95a623c6b7866a$export$733fe45ab8c75209);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_SUCCESS", () => $7d95a623c6b7866a$export$9d1386a2d0651ca9);
$parcel$export(module.exports, "EDIT_EPIC_COLOUR_ERROR", () => $7d95a623c6b7866a$export$56094d7f6af14eac);
$parcel$export(module.exports, "EDIT_ISSUE_COLOUR_ERROR", () => $7d95a623c6b7866a$export$92d58445895900f9);
$parcel$export(module.exports, "FETCH_JIRA_APP_LINKS_ERROR", () => $7d95a623c6b7866a$export$75d850be4d27b98e);
$parcel$export(module.exports, "CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $7d95a623c6b7866a$export$9030bf81702823b8);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $7d95a623c6b7866a$export$a2a71fb6b193e549);
$parcel$export(module.exports, "ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $7d95a623c6b7866a$export$8c5e4d3dfe9a1c32);
$parcel$export(module.exports, "ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $7d95a623c6b7866a$export$49d11338d75de478);
$parcel$export(module.exports, "ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $7d95a623c6b7866a$export$3573d8ff428b4c8f);
$parcel$export(module.exports, "COMMENTS_LIMIT_EXCEEDED_FIELDS_LIST", () => $7d95a623c6b7866a$export$c0657c5ed1bbfed4);
const $7d95a623c6b7866a$export$ec8031e221d27341 = 'TOGGLE_WATCHING_ERROR';
const $7d95a623c6b7866a$export$78f84210a13989cb = 'COMMENT_ADD_ERROR_GENERIC';
const $7d95a623c6b7866a$export$10b0b01977598ffc = 'COMMENT_ADD_ERROR_INVALID';
const $7d95a623c6b7866a$export$8443c3b41d7f09d8 = 'COMMENT_ACTION_ERROR_INVALID_PERMISSION';
const $7d95a623c6b7866a$export$2d541e654485e45b = 'COMMENT_ACTION_ERROR_NON_EDITABLE_WORKFLOW_STATE';
const $7d95a623c6b7866a$export$5fcc12322c6ff365 = 'COMMENT_DELETE_ERROR_NON_EDITABLE_WORKFLOW_STATE';
const $7d95a623c6b7866a$export$9b38ca770beaf3d0 = 'COMMENT_CONTENT_EXCEEDED_ERROR';
const $7d95a623c6b7866a$export$eef81693e817e3a6 = 'SAVE_COMMENT_SUCCESS_FLAG_MESSAGE';
const $7d95a623c6b7866a$export$a0d4d86bde270ad6 = 'COMMENT_FUTURE_TIME_ERROR';
const $7d95a623c6b7866a$export$6b6cd1b99772a4a1 = 'COMMENT_DELETE_ERROR';
const $7d95a623c6b7866a$export$2e48be8618f1b4f8 = 'EDITOR_ERROR';
const $7d95a623c6b7866a$export$c060b7873ebc2eb3 = 'ATTACHMENT_ADD_ERROR';
const $7d95a623c6b7866a$export$1f8e6f6f8d64a715 = 'ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR';
const $7d95a623c6b7866a$export$1f92a25b34c4df93 = 'ATTACHMENT_ADD_SUCCESS';
const $7d95a623c6b7866a$export$d8750340852b965e = 'DELETE_LINKED_ISSUE_ERROR';
const $7d95a623c6b7866a$export$f0962d071c2a358a = 'REMOTE_LINK_VALIDATION_ERROR';
const $7d95a623c6b7866a$export$ef7767ceecf9097c = 'ATTACHMENT_DELETE_ERROR';
const $7d95a623c6b7866a$export$516af79f4e3b8794 = 'WATCH_TOGGLE_UPDATE_ERROR';
const $7d95a623c6b7866a$export$cde4105f7711a10a = 'FETCH_WATCHERS_ERROR';
const $7d95a623c6b7866a$export$f674d1f44f57f99d = 'STOP_WATCHING_SUCCESS';
const $7d95a623c6b7866a$export$bff6b5ab70bcec53 = 'START_WATCHING_SUCCESS';
const $7d95a623c6b7866a$export$37934e343a22c4e6 = 'REMOVE_WATCHER_ERROR';
const $7d95a623c6b7866a$export$6a1827094c1ef6d8 = 'ADD_WATCHER_ERROR';
const $7d95a623c6b7866a$export$ff2029b86d44f1d4 = 'ADD_WATCHER_PERMISSION_ERROR';
const $7d95a623c6b7866a$export$bb96d519395e5dcc = 'SUBTASKS_REORDER_ERROR_GENERIC';
const $7d95a623c6b7866a$export$18bd55ba676f8b6d = 'LOG_WORK_CONFIRM_ERROR';
const $7d95a623c6b7866a$export$1249a100986a9489 = 'ASSIGN_TO_ME_SUCCESS';
const $7d95a623c6b7866a$export$6b737093486e5a4e = 'REMOVE_FROM_ME_SUCCESS';
const $7d95a623c6b7866a$export$a2723f15441225d0 = 'CREATE_CHILD_ISSUE_ERROR';
const $7d95a623c6b7866a$export$569f7258d337be55 = 'LINK_CHILD_ISSUE_ERROR';
const $7d95a623c6b7866a$export$f92af4e9761d23b9 = 'CHANGE_ISSUE_TYPE_SUCCESS';
const $7d95a623c6b7866a$export$16dc9ff6a8822a90 = 'CHANGE_ISSUE_TYPE_ERROR';
const $7d95a623c6b7866a$export$d4030883b7b7a04 = 'DELETE_ISSUE_ERROR';
const $7d95a623c6b7866a$export$2519b72aefd62ee3 = 'ADD_WORKLOG_SUCCESS';
const $7d95a623c6b7866a$export$190e4e4a6ee2a0a2 = 'ADD_WORKLOG_FAILURE';
const $7d95a623c6b7866a$export$2fc2c0027e184f83 = 'ADD_WORKLOG_NON_EDITABLE_FAILURE';
const $7d95a623c6b7866a$export$f1709ebef49207cc = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED';
const $7d95a623c6b7866a$export$2357f9add92f1c9b = 'UPDATE_TIME_REMAINING_SUCCESS';
const $7d95a623c6b7866a$export$bde55584c7518e8d = 'UPDATE_TIME_REMAINING_FAILURE';
const $7d95a623c6b7866a$export$cf8d549e537c67d3 = 'EDIT_WORKLOG_SUCCESS';
const $7d95a623c6b7866a$export$2d33e591258e36a8 = 'EDIT_WORKLOG_FAILURE';
const $7d95a623c6b7866a$export$b595535e9bb1a2a2 = 'DELETE_WORKLOG_SUCCESS';
const $7d95a623c6b7866a$export$c3739a68f63b7e09 = 'DELETE_WORKLOG_FAILURE';
const $7d95a623c6b7866a$export$6ba6cb22d5a3c521 = 'RICH_CONTENT_FIELD_CONFIRM_ERROR';
const $7d95a623c6b7866a$export$b1a41c9183097dc = 'RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR';
const $7d95a623c6b7866a$export$67544887e2b37fbc = 'RICH_CONTENT_FIELD_REQUIRED_ERROR';
const $7d95a623c6b7866a$export$67566c205c72838a = 'DELETE_CONFLUENCE_PAGE_LINK_FAILED';
const $7d95a623c6b7866a$export$e3245a362f751a4a = 'DELETE_WEB_LINK_FAILED';
const $7d95a623c6b7866a$export$3408969e4d418350 = 'CLICKTHROUGH_BANNER_DISMISS_SUCCESS';
const $7d95a623c6b7866a$export$733fe45ab8c75209 = 'SAVE_APPROVAL_ANSWER_ERROR';
const $7d95a623c6b7866a$export$9d1386a2d0651ca9 = 'SAVE_APPROVAL_ANSWER_SUCCESS';
const $7d95a623c6b7866a$export$56094d7f6af14eac = 'EDIT_EPIC_COLOUR_ERROR';
const $7d95a623c6b7866a$export$92d58445895900f9 = 'EDIT_ISSUE_COLOUR_ERROR';
const $7d95a623c6b7866a$export$75d850be4d27b98e = 'FETCH_JIRA_APP_LINKS_ERROR';
const $7d95a623c6b7866a$export$9030bf81702823b8 = 'CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $7d95a623c6b7866a$export$a2a71fb6b193e549 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $7d95a623c6b7866a$export$2dd786d54c8f9397 = 'COMMENTS_INTERNAL_SERVER_ERROR';
const $7d95a623c6b7866a$export$8c5e4d3dfe9a1c32 = 'ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $7d95a623c6b7866a$export$49d11338d75de478 = 'ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $7d95a623c6b7866a$export$3573d8ff428b4c8f = 'ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $7d95a623c6b7866a$export$c0657c5ed1bbfed4 = [
    $7d95a623c6b7866a$export$a2a71fb6b193e549,
    $7d95a623c6b7866a$export$3573d8ff428b4c8f
];

});

parcelRegister("f96mB", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $3e9adaaa269912fe$export$89b6937a83edcaa6);
$parcel$export(module.exports, "EXCEEDED_LIMIT_INITIAL_LOAD", () => $3e9adaaa269912fe$export$763881dbba851043);
$parcel$export(module.exports, "EXCEEDED_LIMIT_AFTER_LOAD", () => $3e9adaaa269912fe$export$8a23145a6d5f95e3);
$parcel$export(module.exports, "WITHIN_LIMIT", () => $3e9adaaa269912fe$export$a7af19981a3e4baf);
$parcel$export(module.exports, "HREF", () => $3e9adaaa269912fe$export$74921a9774a80542);
$parcel$export(module.exports, "IN_PRODUCT_HELP", () => $3e9adaaa269912fe$export$cd480f5ec4739dab);
$parcel$export(module.exports, "WHAT_ARE_ISSUE_TYPES_URL", () => $3e9adaaa269912fe$export$470a531b30a8dea1);
$parcel$export(module.exports, "IN_PRODUCT_HELP_ARTICLE_IDS", () => $3e9adaaa269912fe$export$3691506c72823b65);
$parcel$export(module.exports, "DISMISSED", () => $3e9adaaa269912fe$export$6a4add537aaf5560);
$parcel$export(module.exports, "DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE", () => $3e9adaaa269912fe$export$6d6e3176028f2228);
$parcel$export(module.exports, "DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE_FE", () => $3e9adaaa269912fe$export$17d19a319fd47c32);
$parcel$export(module.exports, "GIC_CALLBACK_PAYLOAD_INLINE_CREATE_ID", () => $3e9adaaa269912fe$export$9e448086914e060);
$parcel$export(module.exports, "GIC_CALLBACK_PAYLOAD_AI_BREAKDOWN_CREATE_ID", () => $3e9adaaa269912fe$export$2dd6afd9432dbc93);

var $ln6Iy = parcelRequire("ln6Iy");
const $3e9adaaa269912fe$var$CHILD_ISSUES_LIMIT = 500;
const $3e9adaaa269912fe$export$89b6937a83edcaa6 = ()=>$3e9adaaa269912fe$var$CHILD_ISSUES_LIMIT;
const $3e9adaaa269912fe$export$763881dbba851043 = 'EXCEEDED_LIMIT_INITIAL_LOAD';
const $3e9adaaa269912fe$export$8a23145a6d5f95e3 = 'EXCEEDED_LIMIT_AFTER_LOAD';
const $3e9adaaa269912fe$export$a7af19981a3e4baf = 'WITHIN_LIMIT';
const $3e9adaaa269912fe$export$74921a9774a80542 = 'HREF';
const $3e9adaaa269912fe$export$cd480f5ec4739dab = 'IN_PRODUCT_HELP';
const $3e9adaaa269912fe$export$470a531b30a8dea1 = 'https://support.atlassian.com/jira-cloud-administration/docs/what-are-issue-types/';
const $3e9adaaa269912fe$export$3691506c72823b65 = {
    [(0, $ln6Iy.CORE_PROJECT)]: '2uhc4ieBPinkLJlWbdhXkC',
    [(0, $ln6Iy.SOFTWARE_PROJECT)]: 'z6BNb3cPucF3fi5UA85Ma',
    [(0, $ln6Iy.SERVICE_DESK_PROJECT)]: '6feRxZzkYUHez8TwHTjSut',
    [(0, $ln6Iy.CUSTOMER_SERVICE_PROJECT)]: null,
    [(0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT)]: null
};
const $3e9adaaa269912fe$export$6a4add537aaf5560 = 'dismissed';
const $3e9adaaa269912fe$export$6d6e3176028f2228 = 'The default assignee does NOT have ASSIGNABLE permission OR Unassigned issues are turned off.';
const $3e9adaaa269912fe$export$17d19a319fd47c32 = "The default assignee doesn\u2019t have the Assignable User permission, or unassigned issues are turned off.";
const $3e9adaaa269912fe$export$9e448086914e060 = 'issue-view-child-issues-panel-inline-create';
const $3e9adaaa269912fe$export$2dd6afd9432dbc93 = 'issue-view-child-issues-panel-ai-breakdown-create';

});

parcelRegister("bTB0V", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $418d903d5460862b$export$dd2d62bc7ec6ce51);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $418d903d5460862b$export$db1ab2b83dc17aa9);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $418d903d5460862b$export$940ce115dba33e55);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $418d903d5460862b$export$4ec1f3604b85d553);
$parcel$export(module.exports, "GROUP_VISIBILITY_SETTING_NOT_ENABLED", () => $418d903d5460862b$export$69483322ede4b803);
$parcel$export(module.exports, "NON_EDITABLE_WORKFLOW_STATE", () => $418d903d5460862b$export$c3d43a40ad9e5b50);
$parcel$export(module.exports, "ISSUE_LIMIT_FIELDS_ERROR_MESSAGE_LIST", () => $418d903d5460862b$export$e65b95e776ce6f27);
const $418d903d5460862b$export$dd2d62bc7ec6ce51 = 'ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $418d903d5460862b$export$db1ab2b83dc17aa9 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED: 5000';
const $418d903d5460862b$export$940ce115dba33e55 = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED: 10000';
const $418d903d5460862b$export$4ec1f3604b85d553 = 'REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $418d903d5460862b$export$69483322ede4b803 = 'GROUP_VISIBILITY_SETTING_NOT_ENABLED';
const $418d903d5460862b$export$c3d43a40ad9e5b50 = 'issue is in a non-editable workflow state.';
const $418d903d5460862b$export$e65b95e776ce6f27 = [
    $418d903d5460862b$export$dd2d62bc7ec6ce51,
    $418d903d5460862b$export$db1ab2b83dc17aa9,
    $418d903d5460862b$export$940ce115dba33e55,
    $418d903d5460862b$export$4ec1f3604b85d553
];

});

const $fc6bc8f8b3f07886$export$bd6f44214f84c29a = 4102;
const $fc6bc8f8b3f07886$export$aa53f670803b96e = 3165;



parcelRegister("iToTs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");





















module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("gVlCg"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $ewTvA("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("dZIaf")
                ]);
            }),
            $ewTvA("c687B"),
            $ewTvA("kNFvF")
        ]);
    }),
    (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $ewTvA("lw2Bw")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2lCLc")
        ]);
    }),
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $ewTvA("116M9")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("dZIaf")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            $ewTvA("fo1Iu"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF"),
            $ewTvA("fliVL")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("2tXQt"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF"),
            $ewTvA("fliVL")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $ewTvA("5g4nt"),
            $ewTvA("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("j3b6X")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20455-dev-panel-to-sync', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
                return Promise.all([
                    $ewTvA("iQLT5")
                ]);
            }, function() {
                return Promise.all([]);
            }),
            (parcelRequire("g81qY"))('create-branch-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $ewTvA("uxIZU")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("hzpoZ")
                ]);
            }),
            (parcelRequire("g81qY"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $ewTvA("lOPFD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("jjrrg")
                ]);
            }),
            (parcelRequire("g81qY"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $ewTvA("lOPFD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("jjrrg")
                ]);
            }),
            $ewTvA("d7W8O"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("7HlaD")
        ]);
    }),
    (parcelRequire("g81qY"))('ssring_affected_services_in_issue_view', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
                return Promise.all([
                    $ewTvA("f5PLD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("cahdx")
                ]);
            }),
            $ewTvA("72RZh"),
            $ewTvA("kvRbA"),
            $ewTvA("ffQaD"),
            $ewTvA("l253H"),
            $ewTvA("76n7a"),
            $ewTvA("kNFvF")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("a1MLa")
        ]);
    }),
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $ewTvA("ltVCh")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("7BIsM")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_fg', function() {
        return Promise.all([
            $ewTvA("9nhJS")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("asI48")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $ewTvA("hb7LZ")
        ]);
    }),
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $ewTvA("8LUjY"),
            $ewTvA("l253H"),
            $ewTvA("76n7a")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
                return Promise.all([
                    $ewTvA("lpg1K"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD")
                ]);
            }, function() {
                return Promise.all([
                    $ewTvA("8D3kc"),
                    $ewTvA("kvRbA"),
                    $ewTvA("ffQaD"),
                    $ewTvA("kVX56")
                ]);
            }),
            $ewTvA("jbyHU"),
            $ewTvA("l253H"),
            $ewTvA("76n7a")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $ewTvA("hb7LZ")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $ewTvA("hb7LZ")
        ]);
    }),
    $ewTvA("isfJL"),
    $ewTvA("b3QiB"),
    $ewTvA("3yAl4"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("fliVL"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kNFvF"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("lDuOD")
]).then(()=>parcelRequire('kq6nk'));

});
parcelRegister("g81qY", function(module, exports) {
"use strict";
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            console.error('Conditional dependency was not registered when executing. Falling back to synchronous bundle loading.');
            for (const url of fallback.urls)fallback.loader(url);
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});



parcelRegister("7emTO", function(module, exports) {

$parcel$export(module.exports, "InfiniteScrollProvider", () => $dcea404e26c8c740$export$f4ede5143c1d55e9);
$parcel$export(module.exports, "useInfiniteScroll", () => $dcea404e26c8c740$export$a973cef5093a8d22);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $h6i8k = parcelRequire("h6i8k");

var $7jTnu = parcelRequire("7jTnu");

var $8jOO7 = parcelRequire("8jOO7");

var $iRahl = parcelRequire("iRahl");
const $dcea404e26c8c740$var$INFINITE_SCROLL_DEFAULT_OPTIONS = {
    pageSize: (0, $iRahl.MAX_ISSUES_PER_PAGE),
    threshold: 5 * (0, $8jOO7.ROW_HEIGHT)
};
const $dcea404e26c8c740$var$INFINITE_SCROLL_INTERACTION_NAME = 'issue-navigator.infinite-scroll';
const $dcea404e26c8c740$var$InfiniteScrollContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    onLoadNext: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onLoadPrevious: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    isLoadingNext: false,
    isLoadingPrevious: false,
    hasNext: false,
    hasPrevious: false
});
const $dcea404e26c8c740$export$f4ede5143c1d55e9 = ({ onLoadNext: onLoadNext, onLoadPrevious: onLoadPrevious, isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, children: children })=>{
    const value = (0, $eJOHy.useMemo)(()=>({
            onLoadNext: onLoadNext,
            onLoadPrevious: onLoadPrevious,
            isLoadingNext: isLoadingNext,
            isLoadingPrevious: isLoadingPrevious,
            hasNext: hasNext,
            hasPrevious: hasPrevious
        }), [
        onLoadNext,
        onLoadPrevious,
        isLoadingNext,
        isLoadingPrevious,
        hasNext,
        hasPrevious
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dcea404e26c8c740$var$InfiniteScrollContext.Provider, {
        value: value
    }, children);
};
function $dcea404e26c8c740$export$a973cef5093a8d22({ fieldSetIds: fieldSetIds, view: view, groupBy: groupBy, options: options, isHierarchyEnabled: isHierarchyEnabled, isHideDoneEnabled: isHideDoneEnabled, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled }) {
    const { pageSize: pageSize, threshold: threshold } = {
        ...$dcea404e26c8c740$var$INFINITE_SCROLL_DEFAULT_OPTIONS,
        ...options
    };
    const { onLoadNext: onLoadNextProp, onLoadPrevious: onLoadPreviousProp, ...rest } = (0, $eJOHy.useContext)($dcea404e26c8c740$var$InfiniteScrollContext);
    // Extra static variables to ensure consistent field set results are returned during pagination.
    const staticPaginationVariables = (0, $eJOHy.useMemo)(()=>({
            ...isIssueHierarchySupportEnabled && {
                viewConfigInput: {
                    staticViewInput: {
                        isHierarchyEnabled: isHierarchyEnabled || false,
                        ...(0, $7jTnu.fg)('jsc_list_hide_done_items') ? {
                            isHideDoneEnabled: isHideDoneEnabled
                        } : {}
                    }
                }
            },
            fieldSetsInput: {
                fieldSetIds: fieldSetIds
            },
            groupBy: groupBy,
            isPaginating: true
        }), [
        fieldSetIds,
        groupBy,
        isHideDoneEnabled,
        isHierarchyEnabled,
        isIssueHierarchySupportEnabled
    ]);
    const onLoadNext = (0, $eJOHy.useCallback)(()=>{
        if (view && (0, $7jTnu.fg)('add_nin_press_interactions')) (0, $h6i8k.default)(`${$dcea404e26c8c740$var$INFINITE_SCROLL_INTERACTION_NAME}.${view}`);
        return onLoadNextProp(pageSize, {
            UNSTABLE_extraVariables: staticPaginationVariables
        });
    }, [
        onLoadNextProp,
        pageSize,
        staticPaginationVariables,
        view
    ]);
    const onLoadPrevious = (0, $eJOHy.useCallback)(()=>{
        if (view && (0, $7jTnu.fg)('add_nin_press_interactions')) (0, $h6i8k.default)(`${$dcea404e26c8c740$var$INFINITE_SCROLL_INTERACTION_NAME}.${view}`);
        onLoadPreviousProp(pageSize, {
            UNSTABLE_extraVariables: staticPaginationVariables
        });
    }, [
        onLoadPreviousProp,
        pageSize,
        staticPaginationVariables,
        view
    ]);
    const infiniteScrollProps = (0, $eJOHy.useMemo)(()=>({
            onLoadNext: onLoadNext,
            onLoadPrevious: onLoadPrevious,
            activationThreshold: threshold,
            ...rest
        }), [
        onLoadNext,
        onLoadPrevious,
        threshold,
        rest
    ]);
    return infiniteScrollProps;
}

});

parcelRegister("bICwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8fe4cead58850e2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f8fe4cead58850e2$var$messages = (0, $7qGN1.defineMessages)({
    returnText: {
        "id": "issue-navigator.full-page-issue-app.return-text",
        "defaultMessage": "Return to search"
    }
});
var $f8fe4cead58850e2$export$2e2bcd8739ae039 = $f8fe4cead58850e2$var$messages;

});


parcelRegister("7ZGNh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6e25c697d3b0513$export$2e2bcd8739ae039);

var $flxgl = parcelRequire("flxgl");

var $dt1oz = parcelRequire("dt1oz");

var $eZmWA = parcelRequire("eZmWA");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $g8Az8 = parcelRequire("g8Az8");

var $1tPTE = parcelRequire("1tPTE");

var $4Oene = parcelRequire("4Oene");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $2nr0r = parcelRequire("2nr0r");

var $3TtKq = parcelRequire("3TtKq");

var $a9bnL = parcelRequire("a9bnL");

var $iRahl = parcelRequire("iRahl");

var $7E6oZ = parcelRequire("7E6oZ");

var $2UTIe = parcelRequire("2UTIe");

var $HiS1C = parcelRequire("HiS1C");

var $fwKw5 = parcelRequire("fwKw5");

var $cJdYi = parcelRequire("cJdYi");

var $3kDjB = parcelRequire("3kDjB");

var $3Ssg5 = parcelRequire("3Ssg5");
const $e6e25c697d3b0513$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $e6e25c697d3b0513$var$Header = ({ CustomHeader: CustomHeader, filter: filter, issueResults: issueResults, HeaderSkeletonImage: HeaderSkeletonImage, jiraViewResult: jiraViewResult, isGroupingSupported: isGroupingSupported, onChangeFilter: onChangeFilter })=>{
    const issueResultsData = (0, $j4oe4.useFragment)((0, $eZmWA.default), issueResults);
    // Compute page data for our search results which is needed when requesting items for the legacy meatball menu
    const offset = (issueResultsData?.issueNavigatorPageInfo?.firstIssuePosition ?? 1) - 1; // offset is 0 based so subtract 1
    const pages = $e6e25c697d3b0513$var$getLastPage(issueResultsData?.pageCursors) ?? 0;
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const searchResultPageData = (0, $eJOHy.useMemo)(()=>({
            offset: offset,
            pages: pages,
            total: total
        }), [
        offset,
        pages,
        total
    ]);
    const { filterId: filterId } = (0, $fwKw5.useActiveJql)();
    const jql = (0, $fwKw5.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $cJdYi.useFilterQuery)();
    const filterData = (0, $j4oe4.useFragment)((0, $dt1oz.default), filter);
    const jiraViewData = (0, $j4oe4.useFragment)((0, $flxgl.default), jiraViewResult);
    const filterDetails = (0, $eJOHy.useMemo)(()=>filterData ? {
            filterId: filterData.filterId,
            name: filterData.name,
            jql: filterData.jql,
            isFavourite: Boolean(filterData.isFavourite)
        } : undefined, [
        filterData
    ]);
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const jiraViewResultData = jiraViewData;
    let changeHierarchy = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let changeGroupedByField = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let changeHideDone = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let resetView = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') || (0, $epTsa.expVal)('saved_list_view', 'isEnabled', false)) ({ changeHierarchy: changeHierarchy, changeGroupedByField: changeGroupedByField, changeHideDone: changeHideDone, resetView: resetView } = // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3kDjB.useIssueSearchActions)());
    const updateGroupByParam = (0, $3Ssg5.useUpdateUrlQueryParamCallback)('groupBy');
    const onChangeGroupedByField = (0, $eJOHy.useCallback)((nextGroupedByField)=>{
        changeGroupedByField(nextGroupedByField);
        updateGroupByParam(nextGroupedByField);
    }, [
        changeGroupedByField,
        updateGroupByParam
    ]);
    let hideDone = false;
    if ((0, $7jTnu.fg)('jsc_bulk_edit_hide_done_work_items')) hideDone = jiraViewData?.viewSettings?.hideDone ?? false;
    const HierarchyToggle = jiraViewResultData && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7E6oZ.HierarchyToggleItem), {
        isGroupingSupported: isGroupingSupported,
        viewResult: jiraViewResultData,
        onChangeHierarchy: changeHierarchy
    }) : null;
    let onResetSelectedIssues = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $7jTnu.fg)('jsc_list_hide_done_items')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ reset: onResetSelectedIssues } = (0, $3TtKq.useIssueTableSelectedIssuesActions)());
    const HideDoneToggle = jiraViewResultData && view !== 'detail' && (0, $7jTnu.fg)('jsc_list_hide_done_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2nr0r.HideDoneItemsToggle), {
        viewResult: jiraViewResultData,
        onChangeHideDone: changeHideDone,
        onResetSelectedIssues: onResetSelectedIssues
    }) : null;
    const GroupByDropdown = isGroupingSupported && jiraViewData && (0, $iRahl.isJiraSpreadsheetView)(jiraViewData) && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tPTE.GroupByDropdown), {
        onChangeGroupedByField: (0, $7jTnu.fg)('jsc_list_query_param_merge') ? onChangeGroupedByField : changeGroupedByField,
        spreadsheetView: jiraViewData
    }) : null;
    const saveResetViewSettingsButton = jiraViewResultData && (0, $epTsa.expVal)('saved_list_view', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9bnL.SaveResetViewSettingsButton), {
        jql: jql,
        onReset: resetView,
        viewFragment: jiraViewResultData
    });
    if (filterQueryIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderSkeletonImage, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CustomHeader, {
        jql: jql,
        filterId: filterId,
        filterDetails: filterDetails,
        searchResultPageData: searchResultPageData,
        HierarchyToggle: HierarchyToggle,
        GroupByDropdown: GroupByDropdown,
        HideDoneToggle: HideDoneToggle,
        SaveResetViewSettingsButton: saveResetViewSettingsButton,
        isHideDoneWorkItemsEnabled: hideDone,
        onChangeFilter: onChangeFilter,
        isModifiedFilter: filterDetails?.jql !== jql
    }));
};
var $e6e25c697d3b0513$export$2e2bcd8739ae039 = (0, $2UTIe.withReportErrors)($e6e25c697d3b0513$var$Header, {
    id: 'ui.header.unhandled',
    packageName: (0, $iRahl.PACKAGE_NAME),
    teamName: (0, $iRahl.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $g8Az8.isLoaderErrorAttributes)
});

});
parcelRegister("flxgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e92eeb8a5fa36867$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11ad7b1744d360a89aa3fc94d13910bf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e92eeb8a5fa36867$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_Header_jiraViewResult",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "GroupByDropdown"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SaveResetViewSettingsButton"
                        }
                    ]
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$e92eeb8a5fa36867$var$node.hash = "1a12596027d07030a765c6c1a7291467";
var $e92eeb8a5fa36867$export$2e2bcd8739ae039 = $e92eeb8a5fa36867$var$node;

});

parcelRegister("dt1oz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d80c9cbca2581ef6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a59decce3d17ede33536b0b36f9eb2f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d80c9cbca2581ef6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Header_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$d80c9cbca2581ef6$var$node.hash = "49ae72938f954e62114776575c662bd8";
var $d80c9cbca2581ef6$export$2e2bcd8739ae039 = $d80c9cbca2581ef6$var$node;

});

parcelRegister("eZmWA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2de43c7df2c1eb72$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<904e0d39da2e4e2100f94fcd59ddca44>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2de43c7df2c1eb72$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "main_issueNavigator_Header_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$2de43c7df2c1eb72$var$node.hash = "a6845643ea9e8dc218ebb8df7988c3f7";
var $2de43c7df2c1eb72$export$2e2bcd8739ae039 = $2de43c7df2c1eb72$var$node;

});

parcelRegister("1tPTE", function(module, exports) {

$parcel$export(module.exports, "GroupByDropdown", () => $27bda80728028e25$export$84685e583ac84574);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");


var $9lDcB = parcelRequire("9lDcB");
const $27bda80728028e25$export$84685e583ac84574 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-table-group-by-dropdown",
        packageName: (0, $8e6e35a2682b0ead$export$b8b9d90f9e5bd72b),
        teamName: (0, $8e6e35a2682b0ead$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9lDcB.GroupByDropdown), props)));

});
const $8e6e35a2682b0ead$export$b8b9d90f9e5bd72b = 'jiraIssueTableGroupByDropdown';
const $8e6e35a2682b0ead$export$d57b6b390e78d90f = 'jira-yurree';
const $8e6e35a2682b0ead$export$5979c086684d2404 = 'loadGroupByOptions';
const $8e6e35a2682b0ead$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
const $8e6e35a2682b0ead$export$64d8bb86ca32b86 = 'changeGroupByField';
const $8e6e35a2682b0ead$export$50d7c3ca7f7b9b40 = 'groupByDropdownLoadMoreTrigger';
const $8e6e35a2682b0ead$export$5871373bb32128e8 = 'groupByDropdownSearch';

parcelRegister("9lDcB", function(module, exports) {

$parcel$export(module.exports, "GroupByDropdown", () => $9953671bbd01655a$export$84685e583ac84574);

var $1llhn = parcelRequire("1llhn");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $kmlzw = parcelRequire("kmlzw");

var $5lAAn = parcelRequire("5lAAn");

var $5CSKW = parcelRequire("5CSKW");

var $7rjYb = parcelRequire("7rjYb");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $2gvG4 = parcelRequire("2gvG4");

var $guChT = parcelRequire("guChT");

var $epTsa = parcelRequire("epTsa");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $b8OI0 = parcelRequire("b8OI0");

var $gYnSx = parcelRequire("gYnSx");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $dpFVo = parcelRequire("dpFVo");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $7jTnu = parcelRequire("7jTnu");


var $ggyb9 = parcelRequire("ggyb9");

var $65Ij3 = parcelRequire("65Ij3");

var $5b5GI = parcelRequire("5b5GI");

var $lehTD = parcelRequire("lehTD");
const $9953671bbd01655a$var$GroupByTriggerIconAfter = ()=>{
    if ((0, $dpFVo.getWillShowNav3)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $9953671bbd01655a$var$iconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
        label: "",
        size: "small"
    }));
    return null;
};
const $9953671bbd01655a$export$84685e583ac84574 = ({ spreadsheetView: spreadsheetView, onChangeGroupedByField: onChangeGroupedByField })=>{
    const cantGroupIssuesContentIssueTermRefreshGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $lehTD.default).cantGroupIssuesContentIssueTermRefreshGalaxia : (0, $lehTD.default).cantGroupIssuesContentIssueTermRefresh;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $8e6e35a2682b0ead$export$5979c086684d2404),
        analyticsSource: (0, $8e6e35a2682b0ead$export$f7109619a5e9e0d6)
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $8e6e35a2682b0ead$export$5979c086684d2404)
    });
    (0, $eJOHy.useEffect)(()=>{
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    const data = (0, $j4oe4.useFragment)((0, $1llhn.default), spreadsheetView);
    const groupByFieldFromQuery = (0, $eJOHy.useMemo)(()=>data?.viewSettings?.groupByConfig?.groupByField ? {
            fieldId: data.viewSettings.groupByConfig.groupByField.fieldId,
            name: data.viewSettings.groupByConfig.groupByField.name
        } : null, [
        data?.viewSettings?.groupByConfig?.groupByField
    ]);
    const prevGroupByFieldFromQuery = (0, $eJOHy.useRef)(groupByFieldFromQuery);
    const [groupByField, setGroupByField] = (0, $eJOHy.useState)(groupByFieldFromQuery);
    // If group by field changes in the query response, update local state to keep it in sync
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(groupByFieldFromQuery, prevGroupByFieldFromQuery.current)) {
        prevGroupByFieldFromQuery.current = groupByFieldFromQuery;
        setGroupByField(groupByFieldFromQuery);
    }
    const onUpdateGroupByFieldAndRefetch = (0, $eJOHy.useCallback)((newGroupByField)=>{
        if (groupByField?.fieldId !== newGroupByField?.fieldId) {
            setGroupByField(newGroupByField ?? null);
            onChangeGroupedByField(newGroupByField?.fieldId);
        }
    }, [
        groupByField,
        onChangeGroupedByField
    ]);
    const issueSearchInput = data?.filterId && {
        filterId: data.filterId
    } || data?.jql && {
        jql: data.jql
    } || undefined;
    const groupByFieldId = groupByField?.fieldId;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $65Ij3.groupByDropdownEntryPoint), {
        nodeId: data.id,
        selectedFieldId: groupByFieldId,
        issueSearchInput: issueSearchInput
    });
    const buttonTrigger = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    (0, $2gvG4.addUFOCustomData)({
        groupByFieldId: data?.viewSettings?.groupByConfig?.groupByField?.typeKey,
        isGrouping: data?.viewSettings?.isGroupingEnabled
    });
    const errorFallback = (0, $eJOHy.useCallback)(({ error: error })=>{
        (0, $gYnSx.default)({
            meta: {
                id: 'issue-table-group-by-dropdown',
                packageName: (0, $8e6e35a2682b0ead$export$b8b9d90f9e5bd72b),
                teamName: (0, $8e6e35a2682b0ead$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail((0, $8e6e35a2682b0ead$export$b8b9d90f9e5bd72b), error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $9953671bbd01655a$var$errorFallbackStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, formatMessage((0, $lehTD.default).entrypointErrorContent)));
    }, [
        formatMessage,
        onExperienceFail
    ]);
    if (!data?.viewSettings?.canEnableGrouping) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, onClick: onClick, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                ...triggerProps,
                ref: triggerRef,
                iconAfter: $9953671bbd01655a$var$GroupByTriggerIconAfter,
                onClick: (event, analyticsEvent)=>{
                    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', 'issueTableGroupByDropdownDisabledTrigger');
                    onClick && onClick(event);
                }
            }, formatMessage((0, $lehTD.default).groupByLabelWithoutSelection)),
        placement: "bottom-end",
        shouldRenderToParent: true,
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9953671bbd01655a$var$cantGroupIssuesStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? cantGroupIssuesContentIssueTermRefreshGalaxia : (0, $lehTD.default).cantGroupIssuesContent))));
    if ((0, $7jTnu.fg)('group_by_any_field')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b8OI0.PopupTrigger), {
        entryPoint: (0, $5b5GI.groupByDropdownWithSearchEntryPoint),
        entryPointParams: {
            nodeId: data.id,
            issueSearchInput: issueSearchInput
        },
        entryPointProps: {
            selectedFieldId: groupByFieldId,
            onUpdateGroupByFieldAndRefetch: onUpdateGroupByFieldAndRefetch,
            savedViewId: data?.savedViewId,
            issueSearchInput: issueSearchInput
        },
        shouldRenderToParent: true,
        placement: "bottom-end",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ggyb9.LoadingContent), null),
        errorFallback: errorFallback,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
                name: "group-by-any-field-dropdown"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                ...triggerProps,
                isSelected: Boolean(groupByField) || triggerProps['aria-expanded'],
                testId: "issue-table-group-by-dropdown.ui.group-by-dropdown",
                iconAfter: $9953671bbd01655a$var$GroupByTriggerIconAfter,
                onClick: (_, analyticsEvent)=>{
                    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', 'issueTableGroupByDropdownTrigger', {
                        isGroupByAnyFieldExperimentEnabled: true
                    });
                }
            }, groupByField?.name ? formatMessage((0, $lehTD.default).groupByLabelWithASelection, {
                groupByField: groupByField.name
            }) : formatMessage((0, $lehTD.default).groupByLabelWithoutSelection)))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, onClick: onClick, isSelected: isSelected, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                ...triggerProps,
                isSelected: Boolean(groupByField) || isSelected,
                testId: "issue-table-group-by-dropdown.ui.group-by-dropdown",
                ref: (0, $kmlzw.mergeRefs)([
                    triggerRef,
                    buttonTrigger
                ]),
                iconAfter: $9953671bbd01655a$var$GroupByTriggerIconAfter,
                onClick: (event, analyticsEvent)=>{
                    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', 'issueTableGroupByDropdownTrigger');
                    onClick && onClick(event);
                }
            }, groupByField?.name ? formatMessage((0, $lehTD.default).groupByLabelWithASelection, {
                groupByField: groupByField.name
            }) : formatMessage((0, $lehTD.default).groupByLabelWithoutSelection)),
        placement: "bottom-end",
        shouldRenderToParent: true,
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "async-jira-spreadsheet-group-by-dropdown",
        packageName: (0, $8e6e35a2682b0ead$export$b8b9d90f9e5bd72b),
        teamName: (0, $8e6e35a2682b0ead$export$d57b6b390e78d90f),
        errorFallback: errorFallback,
        runtimeProps: {
            onUpdateGroupByFieldAndRefetch: onUpdateGroupByFieldAndRefetch,
            savedViewId: data?.savedViewId
        },
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ggyb9.LoadingContent), null)
    }));
};
const $9953671bbd01655a$var$cantGroupIssuesStyles = (0, $1DXK0.xcss)({
    marginInline: 'space.300',
    marginBlock: 'space.200',
    width: '250px',
    whiteSpace: 'initial'
});
const $9953671bbd01655a$var$errorFallbackStyles = (0, $1DXK0.xcss)({
    padding: 'space.200',
    width: '250px'
});
const $9953671bbd01655a$var$iconStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.negative.075'
});

});
parcelRegister("1llhn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4e19cd11ebb1ab9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5612038d121421191c02380e8fb46312>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a4e19cd11ebb1ab9$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "GroupByDropdown",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                {
                    "kind": "ScalarField",
                    "name": "filterId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canEnableGrouping"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isGroupingEnabled"
                        },
                        {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "groupByField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "typeKey"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "savedViewId"
                        }
                    ]
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$a4e19cd11ebb1ab9$var$node.hash = "355df3e29e3b255d4c5248fdc8a639c2";
var $a4e19cd11ebb1ab9$export$2e2bcd8739ae039 = $a4e19cd11ebb1ab9$var$node;

});

parcelRegister("ggyb9", function(module, exports) {

$parcel$export(module.exports, "LoadingContent", () => $050382b58c1f7d8d$export$4ab3512e4872e6ff);

var $eJOHy = parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");
const $050382b58c1f7d8d$export$4ab3512e4872e6ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $050382b58c1f7d8d$var$loadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large"
    }));
const $050382b58c1f7d8d$var$loadingStyles = (0, $1DXK0.xcss)({
    width: '250px',
    paddingBlock: 'space.500'
});

});

parcelRegister("65Ij3", function(module, exports) {

$parcel$export(module.exports, "groupByDropdownEntryPoint", () => $52f38d8054b7f8e0$export$427ad501ef456b18);

var $9rnq3 = parcelRequire("9rnq3");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $52f38d8054b7f8e0$export$427ad501ef456b18 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("1HtBO")), {
        moduleId: "9655b1ba",
        priority: "interaction"
    }),
    getPreloadProps: ({ nodeId: nodeId, selectedFieldId: selectedFieldId, issueSearchInput: issueSearchInput })=>({
            queries: {
                groupByDropdownQuery: {
                    parameters: (0, $9rnq3.default),
                    variables: {
                        nodeId: nodeId,
                        issueSearchInput: issueSearchInput
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            },
            extraProps: {
                selectedFieldId: selectedFieldId
            }
        })
});

});
parcelRegister("9rnq3", function(module, exports) {

$parcel$export(module.exports, "default", () => $13b239eb43d2d119$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<599d83fd7c713c9f0de2551a6ce478d0>>
 * @relayHash 2cff3b81ad990dfa636ab5263e0ce2aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 331596c1f4968f863f62b9350444ffc690e6bf1e0cdb60eca4a697d599789147
const $13b239eb43d2d119$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "nodeId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "nodeId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v10 = [
        {
            "kind": "RequiredField",
            "field": v4 /*: any*/ ,
            "action": "THROW",
            "path": "node.id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueSearchViewConfigSettings",
                "kind": "LinkedField",
                "name": "viewSettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v5 /*: any*/ ,
                                        "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                                        "kind": "LinkedField",
                                        "name": "availableGroupByFieldOptions",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraField",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v6 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v7 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.fieldId"
                                                                },
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "node.viewSettings.groupByConfig"
                    }
                ]
            },
            "action": "THROW",
            "path": "node.viewSettings"
        }
    ], v11 = [
        {
            "concreteType": "JiraIssueSearchViewConfigSettings",
            "kind": "LinkedField",
            "name": "viewSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSpreadsheetGroupByConfig",
                    "kind": "LinkedField",
                    "name": "groupByConfig",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                            "kind": "LinkedField",
                            "name": "availableGroupByFieldOptions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraField",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GroupByDropdownQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v10 /*: any*/ ,
                            "type": "JiraGroupedListView"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v10 /*: any*/ ,
                            "type": "JiraListView"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GroupByDropdownQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v11 /*: any*/ ,
                            "type": "JiraGroupedListView"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v11 /*: any*/ ,
                            "type": "JiraListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "331596c1f4968f863f62b9350444ffc690e6bf1e0cdb60eca4a697d599789147",
            "metadata": {},
            "name": "GroupByDropdownQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$13b239eb43d2d119$var$node.hash = "8945ecb0462c3fb7e83ba8aecf17cfd4";
var $13b239eb43d2d119$export$2e2bcd8739ae039 = $13b239eb43d2d119$var$node;

});

parcelRegister("1HtBO", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3I48u").then(()=>parcelRequire('hTzue'));

});


parcelRegister("5b5GI", function(module, exports) {

$parcel$export(module.exports, "groupByDropdownWithSearchEntryPoint", () => $55b821bd946c6219$export$413fb55bbc4cc5ba);

var $3IoNo = parcelRequire("3IoNo");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $55b821bd946c6219$export$413fb55bbc4cc5ba = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("kUJG9")), {
        moduleId: "f78c7a64",
        priority: "interaction"
    }),
    getPreloadProps: ({ nodeId: nodeId, issueSearchInput: issueSearchInput })=>({
            queries: {
                groupByDropdownQuery: {
                    parameters: (0, $3IoNo.default),
                    variables: {
                        nodeId: nodeId,
                        issueSearchInput: issueSearchInput
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("3IoNo", function(module, exports) {

$parcel$export(module.exports, "default", () => $02480e38fc688e56$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91728dabfc5b62e6ddb1bf0daef099be>>
 * @relayHash 734454485820820d7ef204871fc511d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cf9615beb4cb98a0b1392202c215a7f7b76dc2efd113b7437632d3eb0bd4437a
const $02480e38fc688e56$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "nodeId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "nodeId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "FragmentSpread",
            "name": "GroupByDropdownWithSearch412BadPattern"
        },
        {
            "kind": "FragmentSpread",
            "name": "GroupByDropdownWithSearchRecentlyUsed"
        }
    ], v6 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v7 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        },
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v11 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "availableGroupByFieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraField",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v3 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v7 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput",
                                        "filter"
                                    ],
                                    "handle": "connection",
                                    "key": "RefetchIssueTableGroupByOptionsQuery_availableGroupByFieldOptions",
                                    "kind": "LinkedHandle",
                                    "name": "availableGroupByFieldOptions"
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 5
                                        },
                                        v6 /*: any*/ 
                                    ],
                                    "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "recentlyUsed",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraField",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GroupByDropdownWithSearchQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v5 /*: any*/ ,
                            "type": "JiraGroupedListView"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v5 /*: any*/ ,
                            "type": "JiraListView"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GroupByDropdownWithSearchQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v11 /*: any*/ ,
                            "type": "JiraGroupedListView"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v11 /*: any*/ ,
                            "type": "JiraListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cf9615beb4cb98a0b1392202c215a7f7b76dc2efd113b7437632d3eb0bd4437a",
            "metadata": {},
            "name": "GroupByDropdownWithSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$02480e38fc688e56$var$node.hash = "416272e573d1dadcd379165a66e57346";
var $02480e38fc688e56$export$2e2bcd8739ae039 = $02480e38fc688e56$var$node;

});

parcelRegister("kUJG9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("Syszu").then(()=>parcelRequire('6O5BX'));

});


parcelRegister("lehTD", function(module, exports) {

$parcel$export(module.exports, "default", () => $da8ad8f060855b12$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $da8ad8f060855b12$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    groupByLabelWithoutSelection: {
        "id": "issue-table-group-by-dropdown.group-by-label-without-selection",
        "defaultMessage": "Group"
    },
    groupByLabelWithASelection: {
        "id": "issue-table-group-by-dropdown.group-by-label-with-a-selection",
        "defaultMessage": "Group: {groupByField}"
    },
    cantGroupIssuesContent: {
        "id": "issue-table-group-by-dropdown.cant-group-issues-content",
        "defaultMessage": "We can only group issues when you filter issues from one project. Update your JQL filter and try again."
    },
    cantGroupIssuesContentIssueTermRefresh: {
        "id": "issue-table-group-by-dropdown.cant-group-issues-content-issue-term-refresh",
        "defaultMessage": "We can only group work items when you filter work items from one project. Update your JQL filter and try again."
    },
    entrypointErrorContent: {
        "id": "issue-table-group-by-dropdown.entrypoint-error-content",
        "defaultMessage": "Something went wrong. Try loading the content again."
    },
    cantGroupIssuesContentIssueTermRefreshGalaxia: {
        "id": "issue-table-group-by-dropdown.cant-group-issues-content-issue-term-refresh-galaxia",
        "defaultMessage": "We can only group work items when you filter work items from one space. Update your JQL filter and try again."
    }
});

});



parcelRegister("2nr0r", function(module, exports) {

$parcel$export(module.exports, "HideDoneItemsToggle", () => $4c9fec0bc043f3fe$export$b7b414a8403ed1a2);

var $1PYqe = parcelRequire("1PYqe");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $1KdDN = parcelRequire("1KdDN");

var $bnGsL = parcelRequire("bnGsL");

const $4c9fec0bc043f3fe$export$b7b414a8403ed1a2 = (props)=>{
    const viewResultData = (0, $j4oe4.useFragment)((0, $1PYqe.default), props.viewResult);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-table-hide-done-toggle",
        packageName: (0, $54713f11448e89c8$export$b8b9d90f9e5bd72b),
        teamName: (0, $54713f11448e89c8$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bnGsL.HideDoneItemsToggle), {
        viewResult: viewResultData,
        onChangeHideDone: props.onChangeHideDone,
        onResetSelectedIssues: props.onResetSelectedIssues
    }));
};

});
parcelRegister("1PYqe", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a842fad7f305542$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<041410f89fb03c05541f12d9d6a1c834>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4a842fad7f305542$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "staticViewInput",
                    "variableName": "staticViewInput"
                }
            ],
            "kind": "FragmentSpread",
            "name": "HideDoneItemsToggle"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$4a842fad7f305542$var$node.hash = "274a446d3bfc7669c16bef632e27577f";
var $4a842fad7f305542$export$2e2bcd8739ae039 = $4a842fad7f305542$var$node;

});

parcelRegister("bnGsL", function(module, exports) {

$parcel$export(module.exports, "HideDoneItemsToggle", () => $3bde87ef85792065$export$b7b414a8403ed1a2);

var $82XFH = parcelRequire("82XFH");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $8CBYv = parcelRequire("8CBYv");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $95O7y = parcelRequire("95O7y");

var $keRDt = parcelRequire("keRDt");

var $5dWic = parcelRequire("5dWic");

var $8NIGX = parcelRequire("8NIGX");
const $3bde87ef85792065$export$b7b414a8403ed1a2 = ({ viewResult: viewResult, onChangeHideDone: onChangeHideDone, onResetSelectedIssues: onResetSelectedIssues })=>{
    const viewResultData = (0, $j4oe4.useFragment)((0, $82XFH.default), viewResult);
    const { viewSettings: viewSettings, id: id, viewId: viewId, __id: issueSearchViewId, savedViewId: savedViewId } = viewResultData;
    const { hideDone: hideDone } = viewSettings ?? {};
    const [hideDoneIsChecked, setHideDoneIsChecked] = (0, $eJOHy.useState)(hideDone);
    const [, setHideDoneParam] = (0, $95O7y.useQueryParam)('hideDone');
    const [updateHideDone, updateHideDoneOld] = (0, $keRDt.useUpdateHideDoneMutation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onChange = (0, $eJOHy.useCallback)(()=>{
        if (id) {
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'toggle clicked', 'hideDoneItems', {
                hideDone: !hideDone
            });
            setHideDoneIsChecked(!hideDone);
            if ((0, $7jTnu.fg)('jsc_list_query_param_merge')) setHideDoneParam(hideDone ? 'false' : 'true');
            if ((0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding')) {
                if (savedViewId == null) throw new Error('Missing saved view ID');
                updateHideDone({
                    isHideDoneEnabled: !hideDone,
                    issueSearchViewId: issueSearchViewId,
                    onChangeHideDone: onChangeHideDone,
                    viewARI: savedViewId
                });
            } else updateHideDoneOld({
                isHideDoneEnabled: !hideDone,
                issueSearchViewId: issueSearchViewId,
                issueSearchViewResultAri: id,
                onChangeHideDone: onChangeHideDone
            });
            // reset the selected issue for the bulk operations when chaging the toggle
            onResetSelectedIssues && onResetSelectedIssues();
        }
    }, [
        createAnalyticsEvent,
        hideDone,
        id,
        issueSearchViewId,
        onChangeHideDone,
        onResetSelectedIssues,
        savedViewId,
        setHideDoneParam,
        updateHideDone,
        updateHideDoneOld
    ]);
    const toggleId = `${viewId}_hide_done_toggle`;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("label", {
        htmlFor: toggleId
    }, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $5dWic.default).showHideDoneItems : (0, $5dWic.default).showHideDoneItemsOldTerminology)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8CBYv.default), {
        size: (0, $7jTnu.fg)('jsc-1730-adjust_toggle_size') ? undefined : 'large',
        id: toggleId,
        onChange: onChange,
        isChecked: Boolean(hideDoneIsChecked)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8NIGX.HideDoneOnboarding), null));
};

});
parcelRegister("82XFH", function(module, exports) {

$parcel$export(module.exports, "default", () => $421225b1547f822d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ccc44a47fe062c1cee6d73e800a55aa3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $421225b1547f822d$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "HideDoneItemsToggle",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "viewId"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "savedViewId"
                }
            ]
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$421225b1547f822d$var$node.hash = "3924ccb03ab55bd233479282a84dc101";
var $421225b1547f822d$export$2e2bcd8739ae039 = $421225b1547f822d$var$node;

});

parcelRegister("8CBYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b71259385cf6352$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $6XkOW = parcelRequire("6XkOW");

var $5wxTT = parcelRequire("5wxTT");

var $eGOwo = parcelRequire("eGOwo");

var $7ep4S = parcelRequire("7ep4S");

var $6fs4r = parcelRequire("6fs4r");

var $hqCmO = parcelRequire("hqCmO");
const $8b71259385cf6352$var$LOADING_LABEL = ', Loading';
const $8b71259385cf6352$var$basicStyles = null;
const $8b71259385cf6352$var$iconStyles = null;
const $8b71259385cf6352$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $8b71259385cf6352$var$noop = (0, $3Vuhz.default);
const $8b71259385cf6352$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $8b71259385cf6352$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $8b71259385cf6352$var$Toggle = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $8b71259385cf6352$var$noop, onChange: providedChange = $8b71259385cf6352$var$noop, onFocus: providedFocus = $8b71259385cf6352$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, isLoading: isLoading, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eJOHy.useState)(defaultChecked);
    const loadingLabelId = (0, $gl2vi.useId)();
    const handleBlur = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const handleFocus = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const handleChange = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const legacyIconSize = $8b71259385cf6352$var$iconSizeMap[size];
    const labelId = (0, $gl2vi.useId)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("label", {
        ...controlProps,
        className: (0, $hcewu.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31qll _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1ys4194a _krlfnqa1 _ju3dyh40 _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            size === 'large' && !(0, $eGOwo.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $8b71259385cf6352$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                id: labelId,
                hidden: true,
                children: isLoading ? `${label}${$8b71259385cf6352$var$LOADING_LABEL}` : label
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hqCmO.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: isLoading && shouldChecked ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6XkOW))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hqCmO.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: isLoading && !shouldChecked ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                    size: "xsmall",
                    appearance: "invert"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5wxTT))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            }),
            isLoading && !label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                id: loadingLabelId,
                children: $8b71259385cf6352$var$LOADING_LABEL
            })
        ]
    });
}));
$8b71259385cf6352$var$Toggle.displayName = 'Toggle';
var $8b71259385cf6352$export$2e2bcd8739ae039 = $8b71259385cf6352$var$Toggle;

});
parcelRegister("6XkOW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::600b8f5df6a73844cbfa316238c6d2e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5108674e45de2f8c$var$_react = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5108674e45de2f8c$var$_checkMark = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("lwpci")));

var $5108674e45de2f8c$var$_done = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("37Ug4")));
function $5108674e45de2f8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5108674e45de2f8c$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5108674e45de2f8c$var$_react.default.createElement($5108674e45de2f8c$var$_checkMark.default, Object.assign({
        name: "CheckMarkIcon",
        LEGACY_fallbackIcon: $5108674e45de2f8c$var$_done.default
    }, props));
$5108674e45de2f8c$var$CheckMarkIcon.displayName = 'CheckMarkIconMigration';
var $5108674e45de2f8c$var$_default = module.exports.default = $5108674e45de2f8c$var$CheckMarkIcon;

});
parcelRegister("lwpci", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab021c59a8f6419$var$_react = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fab021c59a8f6419$var$_baseNew = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fab021c59a8f6419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab021c59a8f6419$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $fab021c59a8f6419$var$_react.default.createElement($fab021c59a8f6419$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$fab021c59a8f6419$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $fab021c59a8f6419$var$_default = module.exports.default = $fab021c59a8f6419$var$CheckMarkIcon;

});

parcelRegister("37Ug4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $246daa468c067835$var$_react = $246daa468c067835$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $246daa468c067835$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $246daa468c067835$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $246daa468c067835$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props));
$246daa468c067835$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $246daa468c067835$var$_default = module.exports.default = $246daa468c067835$var$EditorDoneIcon;

});


parcelRegister("5wxTT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18cd44b40ff8809efea24ae850576bc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $405a3cd7d6c6872a$var$_react = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $405a3cd7d6c6872a$var$_cross = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6zhpo")));

var $405a3cd7d6c6872a$var$_close = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6OLN4")));
function $405a3cd7d6c6872a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $405a3cd7d6c6872a$var$CrossIcon = (props)=>/*#__PURE__*/ $405a3cd7d6c6872a$var$_react.default.createElement($405a3cd7d6c6872a$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $405a3cd7d6c6872a$var$_close.default
    }, props));
$405a3cd7d6c6872a$var$CrossIcon.displayName = 'CrossIconMigration';
var $405a3cd7d6c6872a$var$_default = module.exports.default = $405a3cd7d6c6872a$var$CrossIcon;

});
parcelRegister("6OLN4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f6c7bc606f2d15e$var$_react = $4f6c7bc606f2d15e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $4f6c7bc606f2d15e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6c7bc606f2d15e$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $4f6c7bc606f2d15e$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props));
$4f6c7bc606f2d15e$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $4f6c7bc606f2d15e$var$_default = module.exports.default = $4f6c7bc606f2d15e$var$EditorCloseIcon;

});


parcelRegister("hqCmO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d938694e808b84dc$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $d938694e808b84dc$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $d938694e808b84dc$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: (0, $6qaBj.cx)($d938694e808b84dc$var$styles.iconContainer, isHidden && (0, $eGOwo.fg)('platform-visual-refresh-icons') && $d938694e808b84dc$var$styles.hidden, size === 'regular' && $d938694e808b84dc$var$styles.iconContainerRegular, size === 'large' && $d938694e808b84dc$var$styles.iconContainerLarge, position === 'left' && $d938694e808b84dc$var$styles.left, position === 'right' && $d938694e808b84dc$var$styles.right),
        children: children
    });
};
var $d938694e808b84dc$export$2e2bcd8739ae039 = $d938694e808b84dc$var$IconContainer;

});


parcelRegister("keRDt", function(module, exports) {

$parcel$export(module.exports, "useUpdateHideDoneMutation", () => $65ad3be5a7bae7eb$export$1d65880c4ddc0209);

var $2ITdC = parcelRequire("2ITdC");

var $kiiOT = parcelRequire("kiiOT");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4SjAP = parcelRequire("4SjAP");

var $lRq8t = parcelRequire("lRq8t");

var $gYnSx = parcelRequire("gYnSx");

var $bILK0 = parcelRequire("bILK0");

var $8Uqf3 = parcelRequire("8Uqf3");

var $aqnJa = parcelRequire("aqnJa");

var $4ctwv = parcelRequire("4ctwv");

var $cECwI = parcelRequire("cECwI");

var $7jTnu = parcelRequire("7jTnu");


var $4knN1 = parcelRequire("4knN1");
const $65ad3be5a7bae7eb$export$1d65880c4ddc0209 = ()=>{
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experience: (0, $54713f11448e89c8$export$6a7d6ab86cfdfcdc),
        analyticsSource: (0, $54713f11448e89c8$export$f7109619a5e9e0d6)
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $54713f11448e89c8$export$6a7d6ab86cfdfcdc)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $54713f11448e89c8$export$6a7d6ab86cfdfcdc)
    });
    const [commitOld] = (0, $j4oe4.useMutation)((0, $kiiOT.default));
    const [commit] = (0, $j4oe4.useMutation)((0, $2ITdC.default));
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleError = (0, $eJOHy.useCallback)((error)=>{
        (0, $gYnSx.default)({
            meta: {
                id: 'issue-table-hide-done-toggle',
                packageName: (0, $54713f11448e89c8$export$b8b9d90f9e5bd72b),
                teamName: (0, $54713f11448e89c8$export$d57b6b390e78d90f)
            },
            error: error
        });
        onExperienceFail((0, $54713f11448e89c8$export$b8b9d90f9e5bd72b), error);
        showFlag({
            messageId: 'issue-table-hide-done-toggle.services.update-hide-done-toggle.show-flag.error',
            messageType: 'transactional',
            id: 'hideDoneToggleError',
            title: formatMessage((0, $4knN1.default).hideDoneErrorFlagTitle),
            description: formatMessage((0, $4knN1.default).hideDoneErrorFlagDescription),
            isAutoDismiss: true,
            type: 'error'
        });
    }, [
        formatMessage,
        onExperienceFail,
        showFlag
    ]);
    const storeUpdater = (0, $eJOHy.useCallback)(({ isHideDoneEnabled: isHideDoneEnabled, store: store, issueSearchViewId: issueSearchViewId })=>{
        const issueSearchRecord = store.get(issueSearchViewId);
        if (issueSearchRecord) {
            const viewSettingsRecord = issueSearchRecord.getLinkedRecord('viewSettings');
            if (viewSettingsRecord) viewSettingsRecord.setValue(isHideDoneEnabled, 'hideDone');
        }
    }, []);
    const updateHideDone = (0, $eJOHy.useCallback)(({ issueSearchViewId: issueSearchViewId, isHideDoneEnabled: isHideDoneEnabled, onChangeHideDone: onChangeHideDone, viewARI: viewARI })=>{
        if (isAnonymous) {
            onChangeHideDone(isHideDoneEnabled);
            return;
        }
        onExperienceStart();
        commit({
            variables: {
                input: {
                    viewId: viewARI,
                    hideDoneItems: isHideDoneEnabled
                }
            },
            optimisticUpdater (store) {
                storeUpdater({
                    store: store,
                    isHideDoneEnabled: isHideDoneEnabled,
                    issueSearchViewId: issueSearchViewId
                });
                !(0, $7jTnu.fg)('slv-203_fix_refetch_in_nin_after_hide_done_items') && onChangeHideDone(isHideDoneEnabled);
            },
            updater: (store)=>{
                storeUpdater({
                    store: store,
                    issueSearchViewId: issueSearchViewId,
                    isHideDoneEnabled: isHideDoneEnabled
                });
            },
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira_setIssueSearchHideDoneItems ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    handleError(error);
                    return;
                }
                onExperienceSuccess();
            },
            onError: handleError
        });
        (0, $7jTnu.fg)('slv-203_fix_refetch_in_nin_after_hide_done_items') && onChangeHideDone(isHideDoneEnabled);
    }, [
        commit,
        handleError,
        isAnonymous,
        onExperienceStart,
        onExperienceSuccess,
        storeUpdater
    ]);
    const updateHideDoneOld = (0, $eJOHy.useCallback)(({ issueSearchViewResultAri: issueSearchViewResultAri, issueSearchViewId: issueSearchViewId, isHideDoneEnabled: isHideDoneEnabled, onChangeHideDone: onChangeHideDone })=>{
        if (isAnonymous) {
            onChangeHideDone(isHideDoneEnabled);
            return;
        }
        onExperienceStart();
        commitOld({
            variables: {
                viewId: issueSearchViewResultAri,
                isHideDoneEnabled: isHideDoneEnabled
            },
            optimisticUpdater (store) {
                storeUpdater({
                    store: store,
                    isHideDoneEnabled: isHideDoneEnabled,
                    issueSearchViewId: issueSearchViewId
                });
                !(0, $7jTnu.fg)('slv-203_fix_refetch_in_nin_after_hide_done_items') && onChangeHideDone(isHideDoneEnabled);
            },
            updater: (store)=>{
                storeUpdater({
                    store: store,
                    issueSearchViewId: issueSearchViewId,
                    isHideDoneEnabled: isHideDoneEnabled
                });
            },
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.updateIssueSearchHideDonePreference ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $4SjAP.MutationError)(errors[0]);
                    handleError(error);
                    return;
                }
                onExperienceSuccess();
            },
            onError: handleError
        });
        (0, $7jTnu.fg)('slv-203_fix_refetch_in_nin_after_hide_done_items') && onChangeHideDone(isHideDoneEnabled);
    }, [
        commitOld,
        handleError,
        isAnonymous,
        onExperienceStart,
        onExperienceSuccess,
        storeUpdater
    ]);
    return [
        updateHideDone,
        updateHideDoneOld
    ];
};

});
parcelRegister("2ITdC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1781c41656be57be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3bfebb3bf678e0e1b69c5244627ea4c6>>
 * @relayHash 8c2a28b2742e975df8df865d5d95c688
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0eeabc09ee887c36e9f8864d01bf22bb46773618fb12f5da9972c2f73408a9fe
const $1781c41656be57be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useUpdateHideDoneMutation234Mutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetIssueSearchHideDoneItemsPayload",
                    "kind": "LinkedField",
                    "name": "jira_setIssueSearchHideDoneItems",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useUpdateHideDoneMutation234Mutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetIssueSearchHideDoneItemsPayload",
                    "kind": "LinkedField",
                    "name": "jira_setIssueSearchHideDoneItems",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0eeabc09ee887c36e9f8864d01bf22bb46773618fb12f5da9972c2f73408a9fe",
            "metadata": {},
            "name": "useUpdateHideDoneMutation234Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$1781c41656be57be$var$node.hash = "08f9d1b39c2b08023c47064c6e435618";
var $1781c41656be57be$export$2e2bcd8739ae039 = $1781c41656be57be$var$node;

});

parcelRegister("kiiOT", function(module, exports) {

$parcel$export(module.exports, "default", () => $377caf088202f2b5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11d49272643540d05658343d6d358874>>
 * @relayHash 47a9a8fe991f766b2d21dcac0ef54a1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cfe06b3d5b20c6d7101a421841c277d54d17c626f47566864f17bfb88f39a093
const $377caf088202f2b5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHideDoneEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "isHideDoneEnabled",
            "variableName": "isHideDoneEnabled"
        },
        {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateHideDoneMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueSearchHideDonePreferenceMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateIssueSearchHideDonePreference",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateHideDoneMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueSearchHideDonePreferenceMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateIssueSearchHideDonePreference",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cfe06b3d5b20c6d7101a421841c277d54d17c626f47566864f17bfb88f39a093",
            "metadata": {},
            "name": "useUpdateHideDoneMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$377caf088202f2b5$var$node.hash = "d5e39e06e60c261494c6de5b9d3d8d64";
var $377caf088202f2b5$export$2e2bcd8739ae039 = $377caf088202f2b5$var$node;

});

parcelRegister("4knN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ed3ad91b53f3861$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4ed3ad91b53f3861$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    hideDoneErrorFlagTitle: {
        "id": "issue-table-hide-done-error-flag-title",
        "defaultMessage": "Hide done preference could not be updated."
    },
    hideDoneErrorFlagDescription: {
        "id": "issue-table-hide-done-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again."
    }
});

});


parcelRegister("5dWic", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd6f7dcc32af4979$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bd6f7dcc32af4979$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showHideDoneItems: {
        "id": "issue-table-hide-done-items",
        "defaultMessage": "Hide done work items"
    },
    showHideDoneItemsOldTerminology: {
        "id": "issue-table-hide-done-items.old-terminology",
        "defaultMessage": "Hide done"
    }
});

});



parcelRegister("a9bnL", function(module, exports) {

$parcel$export(module.exports, "SaveResetViewSettingsButton", () => $0bd9b24ae4cf01c6$export$2a684f25916e98c1);

var $dNsGg = parcelRequire("dNsGg");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $1KdDN = parcelRequire("1KdDN");


var $j7OgC = parcelRequire("j7OgC");
const $0bd9b24ae4cf01c6$export$2a684f25916e98c1 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onReset: onReset, viewFragment: viewFragment, jql: jql })=>{
    const viewMetadata = (0, $j4oe4.useFragment)((0, $dNsGg.default), viewFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-navigator-save-reset-view-settings-button",
        packageName: (0, $d59435c9c2a78ff3$export$b8b9d90f9e5bd72b),
        teamName: (0, $d59435c9c2a78ff3$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j7OgC.SaveResetViewSettingsButtonCollapsible), {
        jql: jql,
        onReset: onReset,
        viewFragment: viewMetadata
    }));
});

});
parcelRegister("dNsGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cbf556c100a139c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2db70b5d990949deb789516bf2bf00fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2cbf556c100a139c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SaveResetViewSettingsButton",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SaveResetViewSettingsButtonCollapsible"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$2cbf556c100a139c$var$node.hash = "1b783a6984cd893232aea5d467008ee0";
var $2cbf556c100a139c$export$2e2bcd8739ae039 = $2cbf556c100a139c$var$node;

});

const $d59435c9c2a78ff3$export$b8b9d90f9e5bd72b = 'jiraIssueNavigatorSaveResetViewSettingsButton';
const $d59435c9c2a78ff3$export$d57b6b390e78d90f = 'wanjel';

parcelRegister("j7OgC", function(module, exports) {

$parcel$export(module.exports, "SaveResetViewSettingsButtonCollapsible", () => $0f37f611ad0613ee$export$987a12b060ce1a28);

var $2fwds = parcelRequire("2fwds");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kLorN = parcelRequire("kLorN");

var $7zccN = parcelRequire("7zccN");
const $0f37f611ad0613ee$export$987a12b060ce1a28 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onReset: onReset, viewFragment: viewFragment, jql: jql })=>{
    const viewMetadata = (0, $j4oe4.useFragment)((0, $2fwds.default), viewFragment);
    return /*#__PURE__*/ $eJOHy.createElement((0, $kLorN.Collapsible), {
        animationDuration: 260,
        direction: "horizontal",
        isExpanded: viewMetadata.isViewConfigModified ?? false
    }, /*#__PURE__*/ $eJOHy.createElement((0, $7zccN.SaveResetViewSettingsButtonUI), {
        jql: jql,
        onReset: onReset,
        viewFragment: viewMetadata
    }));
});

});
parcelRegister("2fwds", function(module, exports) {

$parcel$export(module.exports, "default", () => $37b4b8ef7542827b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d4a5de047dc708886fdd9d9f95771dc2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $37b4b8ef7542827b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "settings"
        }
    ],
    "kind": "Fragment",
    "name": "SaveResetViewSettingsButtonCollapsible",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SaveResetViewSettingsButtonUI"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "settings",
                    "variableName": "settings"
                }
            ],
            "kind": "ScalarField",
            "name": "isViewConfigModified"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$37b4b8ef7542827b$var$node.hash = "47d082e0772298390cd17586b8b85111";
var $37b4b8ef7542827b$export$2e2bcd8739ae039 = $37b4b8ef7542827b$var$node;

});

parcelRegister("kLorN", function(module, exports) {

$parcel$export(module.exports, "Collapsible", () => $26678bfdf015c2d9$export$6eb0f7ddcda6131f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");
const $26678bfdf015c2d9$var$getSize = (element, direction)=>{
    return direction === 'horizontal' ? element.scrollWidth : element.scrollHeight;
};
const $26678bfdf015c2d9$var$setCollapsedStyle = (wrapper, direction)=>{
    // set max width to 0 and opacity to 0
    wrapper.style.setProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`, '0px');
    wrapper.style.setProperty('opacity', '0');
    wrapper.style.setProperty('overflow', 'hidden');
};
const $26678bfdf015c2d9$var$setExpandedStyle = (wrapper, content, direction)=>{
    // set the max size to content size and opacity to 1
    wrapper.style.setProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`, `${$26678bfdf015c2d9$var$getSize(content, direction)}px`);
    wrapper.style.setProperty('opacity', '1');
};
const $26678bfdf015c2d9$var$resetStyle = (wrapper, direction, resetOverflow)=>{
    wrapper.style.removeProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`);
    wrapper.style.removeProperty('opacity');
    if (resetOverflow) wrapper.style.removeProperty('overflow');
};
const $26678bfdf015c2d9$export$6eb0f7ddcda6131f = ({ animationDuration: animationDuration = 250, children: children, direction: direction = 'vertical', id: id, isExpanded: isExpanded, resetOverflow: resetOverflow = true })=>{
    const didMountRef = (0, $eJOHy.useRef)(false);
    const wrapperRef = (0, $eJOHy.useRef)(null);
    const contentRef = (0, $eJOHy.useRef)(null);
    const [isRendered, setIsRendered] = (0, $eJOHy.useState)(isExpanded);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        // add the transition to the wrapper
        wrapperRef.current.style.setProperty('transition', `max-${direction === 'horizontal' ? 'width' : 'height'} ${animationDuration}ms ease-in-out, opacity ${animationDuration}ms ease-in-out`);
        if (!resetOverflow) wrapperRef.current.style.setProperty('overflow', 'hidden');
        if (!isExpanded) $26678bfdf015c2d9$var$setCollapsedStyle(wrapperRef.current, direction);
    // initial render only
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        if (isExpanded) {
            if (!isRendered) setIsRendered(true);
            else requestAnimationFrame(()=>{
                if (!wrapperRef.current || !contentRef.current) return;
                $26678bfdf015c2d9$var$setExpandedStyle(wrapperRef.current, contentRef.current, direction);
                // wait for the animation to finish before removing the overflow
                Promise.all(wrapperRef.current.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                    wrapperRef.current && $26678bfdf015c2d9$var$resetStyle(wrapperRef.current, direction, resetOverflow);
                });
            });
        } else if (isRendered) {
            if (!wrapperRef.current || !contentRef.current) return;
            $26678bfdf015c2d9$var$setExpandedStyle(wrapperRef.current, contentRef.current, direction);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!wrapperRef.current) return;
                    $26678bfdf015c2d9$var$setCollapsedStyle(wrapperRef.current, direction);
                    // wait for the animation to finish before removing the content
                    Promise.all(wrapperRef.current.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                        setIsRendered(false);
                    });
                });
            });
        }
    }, [
        direction,
        isExpanded,
        isRendered,
        resetOverflow
    ]);
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        id: id,
        ref: wrapperRef
    }, isRendered && /*#__PURE__*/ $eJOHy.createElement("div", {
        ref: contentRef
    }, children));
};

});

parcelRegister("7zccN", function(module, exports) {

$parcel$export(module.exports, "SaveResetViewSettingsButtonUI", () => $78c2efdc833859eb$export$808d70defde8c5d8);

var $gRxpk = parcelRequire("gRxpk");

var $kRKok = parcelRequire("kRKok");

var $bchQJ = parcelRequire("bchQJ");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");

var $9Gyb2 = parcelRequire("9Gyb2");

var $fwcMD = parcelRequire("fwcMD");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");
var $956it = parcelRequire("956it");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $bILK0 = parcelRequire("bILK0");

var $1UVkF = parcelRequire("1UVkF");
const $78c2efdc833859eb$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $78c2efdc833859eb$export$808d70defde8c5d8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onReset: onReset, viewFragment: viewFragment, jql: jql })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isModalOpen, setModalOpen] = (0, $eJOHy.useState)(false);
    const openModal = (0, $eJOHy.useCallback)(()=>setModalOpen(true), []);
    const closeModal = (0, $eJOHy.useCallback)(()=>setModalOpen(false), []);
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const viewMetadata = (0, $j4oe4.useFragment)((0, $bchQJ.default), viewFragment);
    const canPublishViewConfig = viewMetadata.canPublishViewConfig;
    const savedViewId = viewMetadata.savedViewId;
    if (savedViewId == null) throw new Error('Missing saved view ID');
    const [publish, publishing] = (0, $j4oe4.useMutation)((0, $kRKok.default));
    const [discard, discarding] = (0, $j4oe4.useMutation)((0, $gRxpk.default));
    const onClickSave = (0, $eJOHy.useCallback)(()=>{
        const saveSettingsSuccessMessageGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $1UVkF.default).saveSettingsSuccessMessageGalaxia : (0, $1UVkF.default).saveSettingsSuccessMessage;
        closeModal();
        const showFailureFlag = ()=>{
            showFlag({
                messageId: 'issue-navigator-save-reset-view-settings-button.ui.show-flag.error.save-settings-failed',
                messageType: 'transactional',
                title: (0, $1UVkF.default).saveSettingsFailedTitle,
                description: (0, $1UVkF.default).saveSettingsFailedMessage,
                type: 'error'
            });
        };
        const viewSettings = viewMetadata.viewSettings;
        const settings = {
            groupBy: viewSettings?.groupByConfig?.groupByField?.fieldId ?? null,
            hideDone: viewSettings?.hideDone,
            hierarchyEnabled: viewSettings?.isHierarchyEnabled,
            jql: jql
        };
        publish({
            variables: {
                input: {
                    viewId: savedViewId,
                    settings: settings
                },
                settings: settings
            },
            onError () {
                showFailureFlag();
            },
            onCompleted (response) {
                if (response.jira_publishIssueSearchConfig?.success !== true) {
                    showFailureFlag();
                    return;
                }
                showFlag({
                    messageId: 'issue-navigator-save-reset-view-settings-button.ui.show-flag.success.header.save-reset-view-settings.show-flag.success.save-settings-success',
                    messageType: 'transactional',
                    title: (0, $1UVkF.default).saveSettingsSuccessTitle,
                    description: saveSettingsSuccessMessageGalaxia,
                    type: 'success'
                });
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewSettings saved');
            }
        });
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'saveSettings');
    }, [
        closeModal,
        createAnalyticsEvent,
        jql,
        publish,
        savedViewId,
        showFlag,
        viewMetadata.viewSettings
    ]);
    const onClickReset = (0, $eJOHy.useCallback)(()=>{
        const showFailureFlag = ()=>{
            showFlag({
                messageId: 'issue-navigator-save-reset-view-settings-button.ui.show-flag.error.header.save-reset-view-settings.show-flag.error.reset-settings-failed',
                messageType: 'transactional',
                title: (0, $1UVkF.default).resetSettingsFailedTitle,
                description: (0, $1UVkF.default).resetSettingsFailedMessage,
                type: 'error'
            });
        };
        discard({
            variables: {
                input: {
                    viewId: savedViewId
                }
            },
            onError () {
                showFailureFlag();
            },
            onCompleted (response) {
                if (response.jira_discardUserIssueSearchConfig?.success !== true) {
                    showFailureFlag();
                    return;
                }
                onReset();
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewSettings reset');
            }
        });
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'resetSettings', {
            isProjectAdmin: canPublishViewConfig
        });
    }, [
        canPublishViewConfig,
        createAnalyticsEvent,
        discard,
        onReset,
        savedViewId,
        showFlag
    ]);
    if (!canPublishViewConfig) return /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $78c2efdc833859eb$var$styles.root
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $Ay1uj.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fwcMD))),
        isLoading: discarding,
        isTooltipDisabled: false,
        label: formatMessage((0, $1UVkF.default).resetViewSettingsButton),
        onClick: onClickReset,
        tooltip: $78c2efdc833859eb$var$tooltipOptions
    }));
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $78c2efdc833859eb$var$styles.root
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $eJOHy.createElement((0, $Ay1uj.default), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9Gyb2))),
                isLoading: discarding || publishing,
                isTooltipDisabled: false,
                label: formatMessage((0, $1UVkF.default).saveOrResetViewSettingsButton),
                ref: triggerRef,
                tooltip: $78c2efdc833859eb$var$tooltipOptions
            }),
        shouldRenderToParent: false
    }, /*#__PURE__*/ $eJOHy.createElement((0, $aLJ1L.default), null, /*#__PURE__*/ $eJOHy.createElement((0, $jYYbf.default), {
        onClick: openModal
    }, formatMessage((0, $1UVkF.default).saveViewSettingsMenuItem)), /*#__PURE__*/ $eJOHy.createElement((0, $jYYbf.default), {
        onClick: onClickReset
    }, formatMessage((0, $1UVkF.default).resetViewSettingsMenuItem)))), /*#__PURE__*/ $eJOHy.createElement((0, $956it.default), null, isModalOpen && /*#__PURE__*/ $eJOHy.createElement((0, $gHHv2.default), {
        onClose: closeModal,
        width: "small"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $2qG7I.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $eJOHy.createElement((0, $5a9Ro.default), null, formatMessage((0, $1UVkF.default).saveConfirmationModalTitle))), /*#__PURE__*/ $eJOHy.createElement((0, $ik0CA.default), null, formatMessage((0, $1UVkF.default).saveConfirmationModalBody)), /*#__PURE__*/ $eJOHy.createElement((0, $kseeK.default), null, /*#__PURE__*/ $eJOHy.createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: closeModal
    }, formatMessage((0, $1UVkF.default).cancelButton)), /*#__PURE__*/ $eJOHy.createElement((0, $5CSKW.default), {
        appearance: "primary",
        onClick: onClickSave
    }, formatMessage((0, $1UVkF.default).saveButton))))));
});
const $78c2efdc833859eb$var$styles = {
    root: "_1e0c1txw _19bvu2gc _1bsbzwfg"
};

});
parcelRegister("gRxpk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9de0c867f9a6e81$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<db4c5c6a8151630d7b37391460c640a0>>
 * @relayHash f557abda1cabc17ba836a51cc4ae26b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e050710552e2b21cda2300c81f90dab7cd573d24d30a1ec448daa70b36b5c0b6
const $d9de0c867f9a6e81$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraDiscardUserIssueSearchConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_discardUserIssueSearchConfig",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraDiscardUserIssueSearchConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_discardUserIssueSearchConfig",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e050710552e2b21cda2300c81f90dab7cd573d24d30a1ec448daa70b36b5c0b6",
            "metadata": {},
            "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d9de0c867f9a6e81$var$node.hash = "f580f77a915c03ac04e06dc773ca51fa";
var $d9de0c867f9a6e81$export$2e2bcd8739ae039 = $d9de0c867f9a6e81$var$node;

});

parcelRegister("kRKok", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab037f7c6c8fafc7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<93567103c56a0a71d5273938df07792a>>
 * @relayHash 3faf29afe27da22a7811d8781c1ffb05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6b34a5e3e703ee895a8ea5e1bc25fab39aac9668ff0d691bd0dd687883fd6102
const $ab037f7c6c8fafc7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "groupBy"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "settings"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "staticViewInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "Variable",
        "name": "settings",
        "variableName": "settings"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraPublishIssueSearchConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_publishIssueSearchConfig",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "view",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SaveResetViewSettingsButtonCollapsible"
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraPublishIssueSearchConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_publishIssueSearchConfig",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "view",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPublishViewConfig"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "savedViewId"
                                        },
                                        {
                                            "args": [
                                                v8 /*: any*/ 
                                            ],
                                            "kind": "ScalarField",
                                            "name": "isViewConfigModified"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "groupBy",
                                                            "variableName": "groupBy"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "issueSearchInput",
                                                            "variableName": "issueSearchInput"
                                                        },
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "Variable",
                                                            "name": "staticViewInput",
                                                            "variableName": "staticViewInput"
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                    "kind": "LinkedField",
                                                    "name": "viewSettings",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroupByConfig",
                                                            "kind": "LinkedField",
                                                            "name": "groupByConfig",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraField",
                                                                    "kind": "LinkedField",
                                                                    "name": "groupByField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldId"
                                                                        },
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hideDone"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHierarchyEnabled"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraSpreadsheetView",
                                            "abstractKey": "__isJiraSpreadsheetView"
                                        }
                                    ],
                                    "type": "JiraIssueSearchViewMetadata",
                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                }
                            ]
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v7 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6b34a5e3e703ee895a8ea5e1bc25fab39aac9668ff0d691bd0dd687883fd6102",
            "metadata": {},
            "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$ab037f7c6c8fafc7$var$node.hash = "b07abd289109b7a80f615e98f5ee071d";
var $ab037f7c6c8fafc7$export$2e2bcd8739ae039 = $ab037f7c6c8fafc7$var$node;

});

parcelRegister("bchQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $49fa3affa43b8e94$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d385a98165e4e472f2c706cc7ac2830b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $49fa3affa43b8e94$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "SaveResetViewSettingsButtonUI",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "canPublishViewConfig"
        },
        {
            "kind": "ScalarField",
            "name": "savedViewId"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "groupByField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isHierarchyEnabled"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$49fa3affa43b8e94$var$node.hash = "e9398fd7a7dbc2fe90a6aa1504316fb4";
var $49fa3affa43b8e94$export$2e2bcd8739ae039 = $49fa3affa43b8e94$var$node;

});

parcelRegister("9Gyb2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70d28c23e264903d$var$_react = $70d28c23e264903d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $70d28c23e264903d$var$_baseNew = $70d28c23e264903d$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $70d28c23e264903d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $70d28c23e264903d$var$SyncIcon = (props)=>/*#__PURE__*/ $70d28c23e264903d$var$_react.default.createElement($70d28c23e264903d$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$70d28c23e264903d$var$SyncIcon.displayName = 'SyncIcon';
var $70d28c23e264903d$var$_default = module.exports.default = $70d28c23e264903d$var$SyncIcon;

});

parcelRegister("fwcMD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd1cfcbb5080c9044de22389be7f741e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4c3c2af49004355$var$_react = $b4c3c2af49004355$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b4c3c2af49004355$var$_baseNew = $b4c3c2af49004355$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b4c3c2af49004355$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Undo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4c3c2af49004355$var$UndoIcon = (props)=>/*#__PURE__*/ $b4c3c2af49004355$var$_react.default.createElement($b4c3c2af49004355$var$_baseNew.default, Object.assign({
        name: "UndoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 4.72 3.5-3.5 1.06 1.06L3.56 4.5h6.69a4.75 4.75 0 1 1 0 9.5H8v-1.5h2.25a3.25 3.25 0 0 0 0-6.5H3.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$b4c3c2af49004355$var$UndoIcon.displayName = 'UndoIcon';
var $b4c3c2af49004355$var$_default = module.exports.default = $b4c3c2af49004355$var$UndoIcon;

});

parcelRegister("1UVkF", function(module, exports) {

$parcel$export(module.exports, "default", () => $88f7902fb7f15fb3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $88f7902fb7f15fb3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    resetViewSettingsButton: {
        "id": "issue-navigator-save-reset-view-settings-button.reset-view-settings-button",
        "defaultMessage": "Reset list back to default"
    },
    saveOrResetViewSettingsButton: {
        "id": "issue-navigator-save-reset-view-settings-button.save-or-reset-view-settings-button",
        "defaultMessage": "Save or reset view settings"
    },
    saveViewSettingsMenuItem: {
        "id": "issue-navigator-save-reset-view-settings-button.save-view-settings-menu-item",
        "defaultMessage": "Save list"
    },
    resetViewSettingsMenuItem: {
        "id": "issue-navigator-save-reset-view-settings-button.reset-view-settings-menu-item",
        "defaultMessage": "Reset to last saved"
    },
    saveSettingsSuccessTitle: {
        "id": "issue-navigator-save-reset-view-settings-button.save-settings-success-title",
        "defaultMessage": "List view saved"
    },
    saveSettingsSuccessMessage: {
        "id": "issue-navigator-save-reset-view-settings-button.save-settings-success-message",
        "defaultMessage": "This view has been updated for everyone in this project."
    },
    saveSettingsFailedTitle: {
        "id": "issue-navigator-save-reset-view-settings-button.save-settings-failed-title",
        "defaultMessage": "Unable to save your settings"
    },
    saveSettingsFailedMessage: {
        "id": "issue-navigator-save-reset-view-settings-button.save-settings-failed-message",
        "defaultMessage": "We couldn't save your settings, try refreshing the page or try again later."
    },
    resetSettingsFailedTitle: {
        "id": "issue-navigator-save-reset-view-settings-button.reset-settings-failed-title",
        "defaultMessage": "Unable to reset your settings"
    },
    resetSettingsFailedMessage: {
        "id": "issue-navigator-save-reset-view-settings-button.reset-settings-failed-message",
        "defaultMessage": "We couldn't reset your settings, try refreshing the page or try again later."
    },
    saveConfirmationModalTitle: {
        "id": "issue-navigator-save-reset-view-settings-button.save-confirmation-modal-title",
        "defaultMessage": "Save list view"
    },
    saveConfirmationModalBody: {
        "id": "issue-navigator-save-reset-view-settings-button.save-confirmation-modal-body",
        "defaultMessage": "The list will be saved for everyone in the project. They'll see the applied filters, grouping, fields, and columns."
    },
    saveButton: {
        "id": "issue-navigator-save-reset-view-settings-button.save-button",
        "defaultMessage": "Save"
    },
    cancelButton: {
        "id": "issue-navigator-save-reset-view-settings-button.cancel-button",
        "defaultMessage": "Cancel"
    },
    saveSettingsSuccessMessageGalaxia: {
        "id": "issue-navigator-save-reset-view-settings-button.save-settings-success-message-galaxia",
        "defaultMessage": "This view has been updated for everyone in this space."
    }
});

});




parcelRegister("7E6oZ", function(module, exports) {

$parcel$export(module.exports, "HierarchyToggleItem", () => $8259c4c6f12994fb$export$357080ffd90225cc);

var $FINnK = parcelRequire("FINnK");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");

var $dG1on = parcelRequire("dG1on");

var $3cJQz = parcelRequire("3cJQz");
const $8259c4c6f12994fb$export$357080ffd90225cc = ({ viewResult: viewResult, isGroupingSupported: isGroupingSupported, onChangeHierarchy: onChangeHierarchy })=>{
    const viewResultData = (0, $j4oe4.useFragment)((0, $FINnK.default), viewResult);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "hierarchy-feature-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dG1on.HierarchyToggle), {
        isGroupingSupported: isGroupingSupported,
        viewResult: viewResultData,
        onChangeHierarchy: onChangeHierarchy
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cJQz.HierarchyToggleOnboarding), null));
};

});
parcelRegister("FINnK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c1d479fe1c70f4a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<54c721a916733f30969e9cd32c06a656>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6c1d479fe1c70f4a$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "HierarchyToggle"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$6c1d479fe1c70f4a$var$node.hash = "50565f90a5a1ab73cc07255de6d01184";
var $6c1d479fe1c70f4a$export$2e2bcd8739ae039 = $6c1d479fe1c70f4a$var$node;

});

parcelRegister("dG1on", function(module, exports) {

$parcel$export(module.exports, "HierarchyToggle", () => $8ca4d80cc7a8c775$export$3954d500c5aed66);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");


var $6TY1h = parcelRequire("6TY1h");
const $8ca4d80cc7a8c775$export$3954d500c5aed66 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-table-hierarchy-toggle",
        packageName: (0, $a1c91d451c498211$export$b8b9d90f9e5bd72b),
        teamName: (0, $a1c91d451c498211$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6TY1h.HierarchyToggle), props)));

});
const $a1c91d451c498211$export$b8b9d90f9e5bd72b = 'jiraIssueTableHierarchyToggle';
const $a1c91d451c498211$export$d57b6b390e78d90f = 'empanada';

parcelRegister("6TY1h", function(module, exports) {

$parcel$export(module.exports, "HierarchyToggle", () => $3e7aee01315576e4$export$3954d500c5aed66);

var $5ZWXU = parcelRequire("5ZWXU");

var $6ihVK = parcelRequire("6ihVK");

var $gsS0I = parcelRequire("gsS0I");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $8CBYv = parcelRequire("8CBYv");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $cECwI = parcelRequire("cECwI");


var $f3Dol = parcelRequire("f3Dol");
const $3e7aee01315576e4$export$3954d500c5aed66 = ({ viewResult: viewResult, forwardRef: forwardRef, isGroupingSupported: isGroupingSupported, onChangeHierarchy: onChangeHierarchy })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const viewResultData = (0, $j4oe4.useFragment)((0, $gsS0I.default), viewResult);
    const { viewSettings: viewSettings, id: id, viewId: viewId } = viewResultData;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const toggleIssueHierarchy = $3e7aee01315576e4$export$fb4258c5b554d925();
    const { isGroupingEnabled: isGroupingEnabled, canEnableGrouping: canEnableGrouping, isHierarchyEnabled: isHierarchyEnabled, canEnableHierarchy: canEnableHierarchy } = viewSettings ?? {};
    const [checked, setChecked] = (0, $eJOHy.useState)(isHierarchyEnabled);
    const updateHierarchy = (0, $eJOHy.useCallback)((hierarchyPreference)=>{
        setChecked(hierarchyPreference);
        onChangeHierarchy && onChangeHierarchy(hierarchyPreference);
    }, [
        onChangeHierarchy
    ]);
    const onChange = (0, $eJOHy.useCallback)(()=>{
        let viewAri = id;
        if ((0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding')) {
            if (!viewResultData.savedViewId) throw new Error('Missing saved view ID');
            viewAri = viewResultData.savedViewId;
        }
        if (viewAri) {
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'hierarchyToggle clicked', {
                isHierarchyEnabled: !isHierarchyEnabled
            });
            toggleIssueHierarchy({
                viewAri: viewAri,
                isHierarchyEnabled: !isHierarchyEnabled,
                updateHierarchy: updateHierarchy
            });
        }
    }, [
        viewResultData.savedViewId,
        id,
        createAnalyticsEvent,
        isHierarchyEnabled,
        toggleIssueHierarchy,
        updateHierarchy
    ]);
    const isGrouping = isGroupingSupported && isGroupingEnabled && canEnableGrouping;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("label", {
        htmlFor: `${viewId}_hierarchy_toggle`
    }, formatMessage((0, $f3Dol.default).showHierarchy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8CBYv.default), {
        isDisabled: !canEnableHierarchy,
        isChecked: Boolean(checked && canEnableHierarchy),
        id: `${viewId}_hierarchy_toggle`,
        ref: forwardRef,
        onChange: onChange,
        size: (0, $7jTnu.fg)('jsc-1730-adjust_toggle_size') ? undefined : 'large'
    })), !canEnableHierarchy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text.subtlest",
        size: "small"
    }, isGrouping ? formatMessage((0, $f3Dol.default).hierarchyDisabledReasonGroupingAndFilters) : formatMessage((0, $f3Dol.default).hierarchyDisabledReasonFilters)));
};
const $3e7aee01315576e4$export$fb4258c5b554d925 = ()=>{
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const [commitOld] = (0, $j4oe4.useMutation)((0, $6ihVK.default));
    const [commit] = (0, $j4oe4.useMutation)((0, $5ZWXU.default));
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const commitMutation = (0, $eJOHy.useCallback)(({ viewAri: viewAri, isHierarchyEnabled: isHierarchyEnabled, updateHierarchy: updateHierarchy })=>{
        if (isAnonymous) {
            updateHierarchy(isHierarchyEnabled);
            return;
        }
        if ((0, $7jTnu.fg)('saved_list_view_technical_changes_dogfooding')) commit({
            variables: {
                input: {
                    viewId: viewAri,
                    hierarchyEnabled: isHierarchyEnabled
                }
            },
            optimisticUpdater: ()=>{
                updateHierarchy(isHierarchyEnabled);
            },
            onError: (error)=>{
                (0, $gYnSx.default)({
                    meta: {
                        id: 'issue-table-hierarchy-toggle',
                        packageName: (0, $a1c91d451c498211$export$b8b9d90f9e5bd72b),
                        teamName: (0, $a1c91d451c498211$export$d57b6b390e78d90f)
                    },
                    error: error
                });
                showFlag({
                    id: 'hierarchyToggleError',
                    title: formatMessage((0, $f3Dol.default).hierarchyErrorFlagTitle),
                    description: formatMessage((0, $f3Dol.default).hierarchyErrorFlagDescription),
                    isAutoDismiss: true,
                    type: 'error',
                    messageId: 'issue-table-hierarchy-toggle.ui.show-flag.error.hierarchy-toggle-error',
                    messageType: 'transactional'
                });
            }
        });
        else commitOld({
            variables: {
                viewId: viewAri,
                isHierarchyEnabled: isHierarchyEnabled
            },
            optimisticUpdater () {
                updateHierarchy(isHierarchyEnabled);
            },
            onError: (error)=>{
                (0, $gYnSx.default)({
                    meta: {
                        id: 'issue-table-hierarchy-toggle',
                        packageName: (0, $a1c91d451c498211$export$b8b9d90f9e5bd72b),
                        teamName: (0, $a1c91d451c498211$export$d57b6b390e78d90f)
                    },
                    error: error
                });
                showFlag({
                    id: 'hierarchyToggleError',
                    title: formatMessage((0, $f3Dol.default).hierarchyErrorFlagTitle),
                    description: formatMessage((0, $f3Dol.default).hierarchyErrorFlagDescription),
                    isAutoDismiss: true,
                    type: 'error',
                    messageId: 'issue-table-hierarchy-toggle.ui.show-flag.error.hierarchy-toggle-error.1',
                    messageType: 'transactional'
                });
            }
        });
    }, [
        commit,
        commitOld,
        formatMessage,
        isAnonymous,
        showFlag
    ]);
    return commitMutation;
};

});
parcelRegister("5ZWXU", function(module, exports) {

$parcel$export(module.exports, "default", () => $59148c71cc8b279c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9964dd874df6ecb380f9192a36e88a53>>
 * @relayHash e07f74cec024207b689b15170e612af8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ef30b6ec40fff3da836e0958ec8dcf30b34bcfc376bd76aef387674cb16cfd8
const $59148c71cc8b279c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "JiraSetIssueSearchHierarchyEnabledPayload",
            "kind": "LinkedField",
            "name": "jira_setIssueSearchHierarchyEnabled",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HierarchyToggle876BadPatternMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HierarchyToggle876BadPatternMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "3ef30b6ec40fff3da836e0958ec8dcf30b34bcfc376bd76aef387674cb16cfd8",
            "metadata": {},
            "name": "HierarchyToggle876BadPatternMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$59148c71cc8b279c$var$node.hash = "1b02bec6e4804f4d21a2c96557b7366f";
var $59148c71cc8b279c$export$2e2bcd8739ae039 = $59148c71cc8b279c$var$node;

});

parcelRegister("6ihVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $8196d1ef39fc5ace$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00c272807da160c5a86d37fa35cec730>>
 * @relayHash 719c804a5d46e940cb1520f44d19b299
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1af56c4f2d8d1e8af36fa3a5df76f5cb2e7b9680436d0662c7d242595c9830d2
const $8196d1ef39fc5ace$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHierarchyEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v2 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isHierarchyEnabled",
                            "variableName": "isHierarchyEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewId",
                            "variableName": "viewId"
                        }
                    ],
                    "concreteType": "JiraIssueSearchHierarchyPreferenceMutationPayload",
                    "kind": "LinkedField",
                    "name": "updateIssueSearchHierarchyPreference",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HierarchyToggleMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "HierarchyToggleMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "1af56c4f2d8d1e8af36fa3a5df76f5cb2e7b9680436d0662c7d242595c9830d2",
            "metadata": {},
            "name": "HierarchyToggleMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$8196d1ef39fc5ace$var$node.hash = "0f2e51063d73542d963ddf74dce88747";
var $8196d1ef39fc5ace$export$2e2bcd8739ae039 = $8196d1ef39fc5ace$var$node;

});

parcelRegister("gsS0I", function(module, exports) {

$parcel$export(module.exports, "default", () => $630429aafe2a66c7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<87c4901c98d1e54a283239a257dce7e7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $630429aafe2a66c7$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "HierarchyToggle",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "viewId"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "savedViewId"
                }
            ]
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isHierarchyEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEnableHierarchy"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isGroupingEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEnableGrouping"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$630429aafe2a66c7$var$node.hash = "ed9eb9f34d09ba8c47b3995f6e15904f";
var $630429aafe2a66c7$export$2e2bcd8739ae039 = $630429aafe2a66c7$var$node;

});

parcelRegister("f3Dol", function(module, exports) {

$parcel$export(module.exports, "default", () => $105858db56aca5b7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $105858db56aca5b7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showHierarchy: {
        "id": "issue-table-show-hierarchy",
        "defaultMessage": "Show hierarchy"
    },
    hierarchyDisabledReasonGroupingAndFilters: {
        "id": "issue-table-hierarchy-disabled-reason-grouping-and-filters",
        "defaultMessage": "Clear grouping and filters to show hierarchy"
    },
    hierarchyDisabledReasonFilters: {
        "id": "issue-table-hierarchy-disabled-reason-filters",
        "defaultMessage": "Clear filters to show hierarchy"
    },
    hierarchyErrorFlagTitle: {
        "id": "issue-table-hierarchy-error-flag-title",
        "defaultMessage": "Hierarchy preference could not be updated."
    },
    hierarchyErrorFlagDescription: {
        "id": "issue-table-hierarchy-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again."
    }
});

});




parcelRegister("2UTIe", function(module, exports) {

$parcel$export(module.exports, "withReportErrors", () => $dfb8967bd81832b8$export$89614e972c8b110);

var $eJOHy = parcelRequire("eJOHy");

var $5kYyR = parcelRequire("5kYyR");
const $dfb8967bd81832b8$export$89614e972c8b110 = (WrappedComponent, config)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), config, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, props));

});


parcelRegister("cPfqZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d772b08080c721e9$export$2e2bcd8739ae039);

var $651vr = parcelRequire("651vr");

var $bwpQR = parcelRequire("bwpQR");

var $dq7io = parcelRequire("dq7io");

var $iWYt8 = parcelRequire("iWYt8");

var $6I8Uv = parcelRequire("6I8Uv");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3aa9n = parcelRequire("3aa9n");

var $g8Az8 = parcelRequire("g8Az8");

var $1uIew = parcelRequire("1uIew");

var $4xbv3 = parcelRequire("4xbv3");

var $4Oene = parcelRequire("4Oene");

var $83DiZ = parcelRequire("83DiZ");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");

var $iRahl = parcelRequire("iRahl");

var $eUlQe = parcelRequire("eUlQe");

var $2UTIe = parcelRequire("2UTIe");

var $eibCx = parcelRequire("eibCx");

var $fAgUF = parcelRequire("fAgUF");

var $1wL9i = parcelRequire("1wL9i");

var $HiS1C = parcelRequire("HiS1C");

var $dTsrC = parcelRequire("dTsrC");

var $fwKw5 = parcelRequire("fwKw5");

var $3kDjB = parcelRequire("3kDjB");

var $aSDxj = parcelRequire("aSDxj");

var $gNBTz = parcelRequire("gNBTz");

var $bR878 = parcelRequire("bR878");
const $d772b08080c721e9$var$useAnalyticsAttributes = (type)=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    return (0, $eJOHy.useMemo)(()=>{
        if (!type) return;
        const projectType = (0, $ln6Iy.toProjectType)(type.toLowerCase());
        if (!projectType) return;
        const edition = (0, $a9ldn.getEditionForProject)(projectType, appEditions);
        if (!edition) return;
        return {
            edition: edition
        };
    }, [
        appEditions,
        type
    ]);
};
const $d772b08080c721e9$var$IssueResults = ({ hasServerError: hasServerError = false, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onCaughtIssueSearchError: onCaughtIssueSearchError, onIssueFlatListUpdated: onIssueFlatListUpdated, issueResults: issueResults, groupResults: groupResults, jiraView: jiraView, project: project, rankField: rankField, issueTableProps: issueTableProps, filter: filter, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled, isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_START);
    const [{ view: selectedView }] = (0, $HiS1C.useSelectedViewState)();
    const jql = (0, $fwKw5.useResolvedJql)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { setSelectedIssueByIndex: setSelectedIssueByIndex } = (0, $1wL9i.useSelectedIssueActions)();
    const onSelectedRowChange = (0, $eJOHy.useCallback)((rowIndex)=>{
        setSelectedIssueByIndex(rowIndex, {
            shouldDebounce: false,
            shouldNotifyOnChange: false,
            isSelectedByUserInteraction: true
        });
    }, [
        setSelectedIssueByIndex
    ]);
    const isFetching = (0, $3kDjB.useIsFetching)();
    const issueResultsData = (0, $j4oe4.useFragment)((0, $6I8Uv.default), issueResults);
    const groupResultsData = (0, $j4oe4.useFragment)((0, $iWYt8.default), groupResults);
    const jiraViewData = (0, $j4oe4.useFragment)((0, $dq7io.default), jiraView);
    const projectData = (0, $j4oe4.useFragment)((0, $bwpQR.default), project);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $651vr.default), rankField);
    let attributes;
    if ((0, $7jTnu.fg)('add-attribute-required-for-colorful-labels-expe')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    attributes = $d772b08080c721e9$var$useAnalyticsAttributes(projectData?.projectType);
    const viewResultError = (0, $eJOHy.useMemo)(()=>{
        if (!jiraViewData) return undefined;
        const message = jiraViewData.error?.message ?? '';
        const statusCode = jiraViewData.error?.extensions?.[0].statusCode;
        if (typeof statusCode !== 'number') return;
        return new (0, $1uIew.default)(statusCode, message);
    }, [
        jiraViewData
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_END);
    }, []);
    const onNavigateToIssue = (0, $eJOHy.useCallback)((issueKey)=>push(`/browse/${issueKey}`), [
        push
    ]);
    const sourceName = selectedView === 'detail' ? (0, $iRahl.ANALYTICS_DETAIL_VIEW_SOURCE_NAME) : (0, $iRahl.ANALYTICS_LIST_VIEW_SOURCE_NAME);
    let viewContent = null;
    const resultsFragment = (0, $eibCx.exclusiveGroupResultsOrIssueResultsFragment)({
        groupResults: groupResultsData ?? null,
        issueResults: issueResultsData ?? null
    });
    if (!hasServerError && jiraViewData && !jiraViewData.error) {
        if (selectedView === 'detail' && jiraViewData.__typename === 'JiraDetailedView' && resultsFragment?.issueResults) viewContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aSDxj.default), {
            loading: isFetching,
            onNavigateToIssue: onNavigateToIssue,
            issueResults: resultsFragment.issueResults,
            view: jiraViewData
        });
        else if (selectedView !== 'detail' && (0, $iRahl.isJiraSpreadsheetView)(jiraViewData) && resultsFragment) viewContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bR878.default), {
            viewResultError: viewResultError,
            loading: isFetching,
            onSelectedRowChange: onSelectedRowChange,
            onIssueFlatListUpdated: onIssueFlatListUpdated,
            view: jiraViewData,
            project: projectData ?? null,
            rankField: rankFieldData ?? null,
            onChangeColumnConfiguration: onChangeColumnConfiguration,
            issueTableProps: issueTableProps,
            isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
            isIssueRankingSupportEnabled: isIssueRankingSupportEnabled,
            isMergedColumnSupportEnabled: isMergedColumnSupportEnabled,
            isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
            isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
            filter: filter,
            ...resultsFragment
        });
    }
    if (!viewContent) return isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eUlQe.ListViewSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gNBTz.default), {
        error: viewResultError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "issue-results"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: sourceName,
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        ...attributes ? {
            attributes: attributes
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gNBTz.RecoverableErrorViewBoundary), {
        recoveryProp: isFetching,
        onCaughtIssueSearchError: onCaughtIssueSearchError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTsrC.SortContainer), {
        jql: jql,
        onChangeJql: onChangeJql
    }, viewContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aa9n.default), {
        op: ()=>{
            onCaughtIssueSearchError && onCaughtIssueSearchError(undefined);
        }
    }))));
};
var $d772b08080c721e9$export$2e2bcd8739ae039 = (0, $2UTIe.withReportErrors)($d772b08080c721e9$var$IssueResults, {
    id: 'ui.issue-results.unhandled',
    packageName: (0, $iRahl.PACKAGE_NAME),
    teamName: (0, $iRahl.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $g8Az8.isLoaderErrorAttributes)
});

});
parcelRegister("651vr", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a881a3d04b502f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9c7354c69be3b347d84955aa12a6686>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $04a881a3d04b502f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_rankField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_rankField"
        }
    ],
    "type": "JiraQuery"
};
$04a881a3d04b502f$var$node.hash = "6841e7e8e6eb501774888d028077731e";
var $04a881a3d04b502f$export$2e2bcd8739ae039 = $04a881a3d04b502f$var$node;

});

parcelRegister("bwpQR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3df40ace72ed177$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4d5d381d62bc1a932f2c9a73cda20d66>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d3df40ace72ed177$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_project"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$d3df40ace72ed177$var$node.hash = "70bd33938dc6049ba8077772bdfb1c96";
var $d3df40ace72ed177$export$2e2bcd8739ae039 = $d3df40ace72ed177$var$node;

});

parcelRegister("dq7io", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d5496f6abaa3a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4aa67d431503e89ed559c9796911ad7f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $55d5496f6abaa3a9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_jiraView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "error",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_DetailView_view"
                }
            ],
            "type": "JiraDetailedView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_ListView_view"
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$55d5496f6abaa3a9$var$node.hash = "d1bfcbf5b50637766f970894f71c262d";
var $55d5496f6abaa3a9$export$2e2bcd8739ae039 = $55d5496f6abaa3a9$var$node;

});

parcelRegister("iWYt8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a687dfe88004fc9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8181ceb1b33ce238044f09e55f544564>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8a687dfe88004fc9$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isPaginating"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_groupResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isPaginating",
                    "variableName": "isPaginating"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_groupResults"
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$8a687dfe88004fc9$var$node.hash = "36093a29e9613109da41814cc200e024";
var $8a687dfe88004fc9$export$2e2bcd8739ae039 = $8a687dfe88004fc9$var$node;

});

parcelRegister("6I8Uv", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbc4252a0d975ae0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2453f2f447e1334e18243d95ba4a6511>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dbc4252a0d975ae0$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_issueResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_DetailView_issueResults"
        }
    ],
    "type": "JiraIssueConnection"
};
$dbc4252a0d975ae0$var$node.hash = "fe345a65c78509e001254c068f756164";
var $dbc4252a0d975ae0$export$2e2bcd8739ae039 = $dbc4252a0d975ae0$var$node;

});

parcelRegister("eUlQe", function(module, exports) {

$parcel$export(module.exports, "ListViewSkeleton", () => $16db559737cf802c$export$8465c21c33452ecb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $coBPg = parcelRequire("coBPg");
const $16db559737cf802c$export$8465c21c33452ecb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16db559737cf802c$var$StyledListViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coBPg.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16db559737cf802c$var$StyledListViewContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("coBPg", function(module, exports) {

$parcel$export(module.exports, "NativeIssueTableSkeleton", () => $f004264ba9491c9c$export$309a6db85e3f2aaa);
/* NativeIssueTableSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $9co9i = parcelRequire("9co9i");
const $f004264ba9491c9c$var$customCssStyles = null;
const $f004264ba9491c9c$var$containerStyles = {
    height: '448px'
};
const $f004264ba9491c9c$export$309a6db85e3f2aaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9co9i))),
        containerStyles: $f004264ba9491c9c$var$containerStyles,
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("9co9i", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton.tpl.e6209376.svg", import.meta.url).toString();

});



parcelRegister("dTsrC", function(module, exports) {

$parcel$export(module.exports, "SortContainer", () => $e5ed7a8c52259a33$export$f2d9f14f583efb1a);
$parcel$export(module.exports, "useSortFieldAndDirection", () => $e5ed7a8c52259a33$export$951ead8cec7da319);

var $eJOHy = parcelRequire("eJOHy");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7jTnu = parcelRequire("7jTnu");

var $675bx = parcelRequire("675bx");
const $e5ed7a8c52259a33$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        field: 'created',
        direction: 'DESC'
    },
    actions: {
        setField: (field, aliases)=>({ getState: getState, setState: setState }, { onChangeJql: onChangeJql, jql: jql, JqlUtils: JqlUtils })=>{
                const { field: prevField } = getState();
                if (field !== prevField) {
                    setState({
                        field: field
                    });
                    const newJql = JqlUtils?.jql(jql).setPrimarySortField(field, undefined, aliases).toJql();
                    typeof newJql === 'string' && onChangeJql && onChangeJql(newJql);
                }
            },
        setFieldAndDirection: (field, direction, aliases)=>({ getState: getState, setState: setState }, { onChangeJql: onChangeJql, jql: jql, JqlUtils: JqlUtils })=>{
                const { field: prevField, direction: prevDirection } = getState();
                if (field !== prevField || direction !== prevDirection) {
                    setState({
                        field: field,
                        direction: direction
                    });
                    if (direction !== 'NONE' || (0, $7jTnu.fg)('jsc_list_reranking_gate')) {
                        const newJql = JqlUtils?.jql(jql).setPrimarySortField(field, direction, aliases).toJql();
                        typeof newJql === 'string' && onChangeJql && onChangeJql(newJql);
                    }
                }
            }
    },
    name: 'IssueNavigatorSelectedViewState'
});
const $e5ed7a8c52259a33$export$f4b3414b22b0750b = ()=>({ getState: getState, setState: setState }, { jql: jql, JqlUtils: JqlUtils })=>{
        const field = JqlUtils?.jql(jql).getPrimarySortField();
        const direction = JqlUtils?.jql(jql).getPrimarySortDirection();
        const { field: prevField, direction: prevDirection } = getState();
        if (field !== prevField || direction !== prevDirection) setState({
            field: field,
            direction: direction
        });
    };
const $e5ed7a8c52259a33$export$42a852a2b6b56249 = (0, $6E16M.createContainer)($e5ed7a8c52259a33$var$Store, {
    onInit: $e5ed7a8c52259a33$export$f4b3414b22b0750b,
    onUpdate: $e5ed7a8c52259a33$export$f4b3414b22b0750b
});
const $e5ed7a8c52259a33$export$f2d9f14f583efb1a = (props)=>{
    const Utils = (0, $675bx.useJqlUtils)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e5ed7a8c52259a33$export$42a852a2b6b56249, {
        JqlUtils: Utils,
        ...props
    });
};
const $e5ed7a8c52259a33$export$951ead8cec7da319 = (0, $iJq0l.createHook)($e5ed7a8c52259a33$var$Store, {
    selector: ({ field: field, direction: direction })=>({
            field: field,
            direction: direction
        })
});

});
parcelRegister("675bx", function(module, exports) {

$parcel$export(module.exports, "useJqlUtils", () => $2fc338e974081e95$export$c7c2706ff288264f);

var $eJOHy = parcelRequire("eJOHy");

const $2fc338e974081e95$export$4a178a021cc96ab5 = async ()=>{
    const module = await (parcelRequire("9dg6M"));
    const { JqlUtils: JqlUtils } = module;
    return new JqlUtils();
};
const $2fc338e974081e95$export$c7c2706ff288264f = ()=>{
    const [Utils, setUtils] = (0, $eJOHy.useState)();
    const asyncEffect = async ()=>{
        const ResolvedUtils = await $2fc338e974081e95$export$4a178a021cc96ab5();
        setUtils(ResolvedUtils);
    };
    (0, $eJOHy.useEffect)(()=>{
        asyncEffect();
    }, []);
    return Utils;
};

});
parcelRegister("9dg6M", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("h9R5C").then(()=>parcelRequire('imx7a'));

});



parcelRegister("aSDxj", function(module, exports) {

$parcel$export(module.exports, "default", () => $067998940c1c16ee$export$2e2bcd8739ae039);

var $b6ISq = parcelRequire("b6ISq");

var $fKqyd = parcelRequire("fKqyd");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $g8Az8 = parcelRequire("g8Az8");

var $kbYhH = parcelRequire("kbYhH");

var $6zXPf = parcelRequire("6zXPf");

var $iqtgH = parcelRequire("iqtgH");

var $4Oene = parcelRequire("4Oene");

var $ivzXw = parcelRequire("ivzXw");

var $7jTnu = parcelRequire("7jTnu");


var $iRahl = parcelRequire("iRahl");

var $6Bi4o = parcelRequire("6Bi4o");

var $2UTIe = parcelRequire("2UTIe");

var $fAgUF = parcelRequire("fAgUF");

var $e1kKr = parcelRequire("e1kKr");

var $2Jpfu = parcelRequire("2Jpfu");
const $067998940c1c16ee$var$ConditionalContentContainer = ({ children: children })=>(0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $067998940c1c16ee$var$ContentContainerStyles
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($067998940c1c16ee$var$ContentStyledContainer, null, children);
const $067998940c1c16ee$var$DetailView = ({ IssueApp: IssueApp = (0, $6Bi4o.default), issueResults: issueResults, view: view, ...props })=>{
    const listRef = (0, $eJOHy.useRef)(null);
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_DETAIL_VIEW_START);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_DETAIL_VIEW_END);
    }, []);
    const detailViewData = (0, $j4oe4.useFragment)((0, $fKqyd.default), issueResults);
    const viewData = (0, $j4oe4.useFragment)((0, $b6ISq.default), view);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "detail-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($067998940c1c16ee$var$ConditionalContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kbYhH.ElementSizeProvider), {
        elementRef: listRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e1kKr.default), {
        issueResults: detailViewData,
        view: viewData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Jpfu.default), {
        fragment: detailViewData,
        ...props,
        listRef: listRef
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivzXw.RouterSubscriber), null, ({ location: location })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IssueApp, {
            isEmbedView: true,
            issueResults: detailViewData,
            view: viewData,
            routePathname: location.pathname,
            routeSearch: location.search,
            ...(0, $7jTnu.fg)('nin_fix_document_title_in_detail_view') && {
                analyticsSource: (0, $d851676a1c983028$export$cd2e8394c029507b)
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null)));
};
// re-render regression detection
$067998940c1c16ee$var$DetailView.whyDidYouRender = true;
var $067998940c1c16ee$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2UTIe.withReportErrors)($067998940c1c16ee$var$DetailView, {
    id: 'ui.issue-results.detail-view.unhandled',
    packageName: (0, $iRahl.PACKAGE_NAME),
    teamName: (0, $iRahl.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $g8Az8.isLoaderErrorAttributes)
});
const $067998940c1c16ee$var$ContentStyledContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $067998940c1c16ee$var$ContentContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    height: '100%',
    flexGrow: 1,
    overflow: 'hidden',
    flexBasis: 0
});

});
parcelRegister("b6ISq", function(module, exports) {

$parcel$export(module.exports, "default", () => $872f846d52d9f102$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<413e774d04809c5372ccc3674da92a96>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $872f846d52d9f102$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_DetailView_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "cardContainer_issueNavigator_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_view"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$872f846d52d9f102$var$node.hash = "68ca158b865b96f58c529de1ab919b9b";
var $872f846d52d9f102$export$2e2bcd8739ae039 = $872f846d52d9f102$var$node;

});

parcelRegister("fKqyd", function(module, exports) {

$parcel$export(module.exports, "default", () => $646115f9e22c58db$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6d20b50d30d33e809ff675bbd13cffa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $646115f9e22c58db$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_DetailView_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_CardList_fragment"
        },
        {
            "kind": "FragmentSpread",
            "name": "cardContainer_issueNavigator_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_issueResults"
        }
    ],
    "type": "JiraIssueConnection"
};
$646115f9e22c58db$var$node.hash = "6b64dddb99a963cc9fea8872d644dae0";
var $646115f9e22c58db$export$2e2bcd8739ae039 = $646115f9e22c58db$var$node;

});

parcelRegister("kbYhH", function(module, exports) {

$parcel$export(module.exports, "useElementSizeSelector", () => $815a2426d7099138$export$6af5bd31f067d7e5);
$parcel$export(module.exports, "ElementSizeProvider", () => $815a2426d7099138$export$73bf76c50625186);

var $eJOHy = parcelRequire("eJOHy");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $815a2426d7099138$export$e4c0458e30711294 = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0
};
const $815a2426d7099138$export$638cf470f916deb7 = (0, $6E16M.createContainer)({
    getIsConcurrentSafe: ()=>true
});
const $815a2426d7099138$export$3378d8ea7d02abd0 = {
    height: 0,
    width: 0
};
const $815a2426d7099138$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        }
};
const $815a2426d7099138$var$Store = (0, $GtRbT.createStore)({
    containedBy: $815a2426d7099138$export$638cf470f916deb7,
    initialState: $815a2426d7099138$export$3378d8ea7d02abd0,
    name: 'ElementSize',
    actions: $815a2426d7099138$var$actions,
    handlers: {
        onInit: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            },
        onContainerUpdate: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            }
    }
});
const $815a2426d7099138$export$6af5bd31f067d7e5 = (0, $iJq0l.createStateHook)($815a2426d7099138$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $815a2426d7099138$export$2b86bedf890eab8 = (elementRef)=>{
    const [size, setSize] = (0, $eJOHy.useState)($815a2426d7099138$export$e4c0458e30711294);
    (0, $eJOHy.useEffect)(()=>{
        const element = elementRef.current;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                setSize({
                    height: element.clientHeight,
                    width: element.clientWidth,
                    scrollHeight: element.scrollHeight,
                    scrollWidth: element.scrollWidth
                });
            });
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        elementRef
    ]);
    return size;
};
const $815a2426d7099138$export$73bf76c50625186 = ({ elementRef: elementRef, children: children })=>{
    const { width: width, height: height } = $815a2426d7099138$export$2b86bedf890eab8(elementRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($815a2426d7099138$export$638cf470f916deb7, {
        width: width,
        height: height
    }, children);
};

});

const $d851676a1c983028$export$53d41ff2666118e1 = 'agility-backlog';
const $d851676a1c983028$export$7552fe2669628499 = 'bitbucket-issue';
const $d851676a1c983028$export$41a718da0a8636f4 = 'connect-issue';
const $d851676a1c983028$export$cebf0bc8b2ccaf57 = 'core-issue';
const $d851676a1c983028$export$5e91e17726e54450 = 'jiraCalendar';
const $d851676a1c983028$export$2dac1950892123f5 = 'jiraTimeline';
const $d851676a1c983028$export$82540942fb014b0a = 'business-calendar';
const $d851676a1c983028$export$7ca28938a07e0c33 = 'business-list';
const $d851676a1c983028$export$f6cf06aaaeb58a54 = 'business-timeline';
const $d851676a1c983028$export$b2c0462ff17aa26e = 'business-board';
const $d851676a1c983028$export$a607850ebccd28ac = 'business-approvals';
const $d851676a1c983028$export$1da6cede3561048f = 'business-files';
const $d851676a1c983028$export$b19f949fb9713614 = 'full-issue';
const $d851676a1c983028$export$a5132300c5214280 = 'embed-issue';
const $d851676a1c983028$export$710114090a811b37 = 'global-issue-navigator-issue';
const $d851676a1c983028$export$ce88447986394f2d = 'mobile-issue';
const $d851676a1c983028$export$6a90d9196d330040 = 'project-issue-navigator';
const $d851676a1c983028$export$2247c9059c171db1 = 'roadmap-issue';
const $d851676a1c983028$export$cd16d39c55c569d0 = 'simple-software-board';
const $d851676a1c983028$export$f72626bf0d75dfad = 'software-backlog-issue';
const $d851676a1c983028$export$778b4609e784cb27 = 'software-deployments-issue';
const $d851676a1c983028$export$5b73d694a6048002 = 'version-detail-issue';
const $d851676a1c983028$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $d851676a1c983028$export$21b5b7189add7861 = 'software-incidents-issue';
const $d851676a1c983028$export$9c5d81b901471b27 = 'software-issue';
const $d851676a1c983028$export$1735f6ad917dc411 = 'change-calendar';
const $d851676a1c983028$export$7063ee6d0035a982 = 'queues-issue-view';
const $d851676a1c983028$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $d851676a1c983028$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $d851676a1c983028$export$14a8072f422804fd = 'issue-navigator-next';
const $d851676a1c983028$export$cd2e8394c029507b = 'issue-navigator-detail-view';
const $d851676a1c983028$export$5f3c20fe2ff6c0a2 = 'staffing-issue';
const $d851676a1c983028$export$9dac02c804d7acd8 = 'classic-software-board';

parcelRegister("e1kKr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b50a670862cb3fb4$export$2e2bcd8739ae039);

var $keYuU = parcelRequire("keYuU");

var $boo7K = parcelRequire("boo7K");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $7khpH = parcelRequire("7khpH");

var $7n9BS = parcelRequire("7n9BS");

var $6XJko = parcelRequire("6XJko");

var $iRahl = parcelRequire("iRahl");

var $6K4cv = parcelRequire("6K4cv");

var $gRqFV = parcelRequire("gRqFV");

var $7emTO = parcelRequire("7emTO");

var $haEEA = parcelRequire("haEEA");

var $eqaMC = parcelRequire("eqaMC");

var $8X4cC = parcelRequire("8X4cC");
const $b50a670862cb3fb4$var$infiniteScrollOptions = {
    threshold: 350 // Approximately 5 min-height cards tall
};
const $b50a670862cb3fb4$var$CardContainer = ({ children: children, issueResults: issueResults, view: view })=>{
    const data = (0, $j4oe4.useFragment)((0, $boo7K.default), issueResults);
    const viewData = (0, $j4oe4.useFragment)((0, $keYuU.default), view);
    const fieldSetIds = (0, $eJOHy.useMemo)(()=>viewData?.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData?.fieldSets?.edges
    ]);
    const infiniteScrollProps = (0, $7emTO.useInfiniteScroll)({
        fieldSetIds: fieldSetIds,
        options: $b50a670862cb3fb4$var$infiniteScrollOptions,
        view: (0, $iRahl.views).detail
    });
    const { isLoadingPrevious: isLoadingPrevious, isLoadingNext: isLoadingNext } = infiniteScrollProps;
    const { onScroll: onScroll, onLoadingThresholdCheck: onLoadingThresholdCheck } = (0, $7khpH.useInfiniteScrollHandler)(infiniteScrollProps);
    const scrollContainerRef = (0, $eJOHy.useRef)(null);
    const totalIssues = data.totalIssueSearchResultCount ?? 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: (0, $6XJko.isVisualRefreshEnabled)() ? undefined : 'space.025',
        grow: "fill",
        xcss: (0, $6XJko.isVisualRefreshEnabled)() ? $b50a670862cb3fb4$var$containerStyles : $b50a670862cb3fb4$var$containerStylesOld,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.styled-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.050",
        xcss: (0, $6XJko.isVisualRefreshEnabled)() ? $b50a670862cb3fb4$var$headerStyles : $b50a670862cb3fb4$var$headerStylesOld,
        alignBlock: (0, $6XJko.isVisualRefreshEnabled)() ? 'center' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eqaMC.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8X4cC.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gRqFV.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7n9BS.ScrollStateProvider), {
        scrollRef: scrollContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        grow: "fill",
        xcss: $b50a670862cb3fb4$var$loadingIndicatorContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: scrollContainerRef,
        xcss: $b50a670862cb3fb4$var$cardListStyles,
        onScroll: onScroll,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.scroll-container"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $haEEA.LoadingManager), {
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        onLoadingThresholdCheck: onLoadingThresholdCheck
    }))), totalIssues != null && totalIssues > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $b50a670862cb3fb4$var$footerStyles,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.total-count"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K4cv.default), {
        startIssueRange: -1,
        endIssueRange: -1,
        total: totalIssues,
        countExceedsMaxResults: !!data.isCappingIssueSearchResult,
        loadedIssuesCount: data.edges?.length ?? 0,
        isInfiniteScrollEnabled: true
    })));
};
var $b50a670862cb3fb4$export$2e2bcd8739ae039 = $b50a670862cb3fb4$var$CardContainer;
const $b50a670862cb3fb4$var$containerStylesOld = (0, $1DXK0.xcss)({
    borderRadius: "var(--ds-radius-small, 4px)",
    backgroundColor: 'color.background.neutral',
    boxSizing: 'content-box',
    padding: 'space.025',
    marginBottom: 'space.100',
    marginRight: 'space.200',
    minWidth: '256px',
    maxWidth: '256px'
});
const $b50a670862cb3fb4$var$containerStyles = (0, $1DXK0.xcss)({
    borderRadius: "var(--ds-radius-small, 4px)",
    backgroundColor: 'elevation.surface.sunken',
    boxSizing: 'content-box',
    paddingInline: 'space.025',
    marginBottom: 'space.100',
    marginRight: 'space.200',
    minWidth: '256px',
    maxWidth: '256px'
});
const $b50a670862cb3fb4$var$headerStylesOld = (0, $1DXK0.xcss)({
    flexGrow: 1,
    flexShrink: 0,
    height: '32px' // gridSize * 4
});
const $b50a670862cb3fb4$var$headerStyles = (0, $1DXK0.xcss)({
    flexGrow: 1,
    flexShrink: 0,
    height: '40px',
    marginBottom: 'space.negative.025',
    // Cards require small margin to show box shadow. This negative margin recenters the header.
    paddingInline: 'space.025'
});
const $b50a670862cb3fb4$var$loadingIndicatorContainerStyles = (0, $1DXK0.xcss)({
    flexGrow: '1',
    flexShrink: '1',
    flexBasis: '100vh',
    overflow: 'hidden',
    position: 'relative' // Required in order to contain loading indicator
});
const $b50a670862cb3fb4$var$cardListStyles = (0, $1DXK0.xcss)({
    flexGrow: '1',
    overflow: 'auto'
});
const $b50a670862cb3fb4$var$footerStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtlest',
    paddingBlock: 'space.050',
    textAlign: 'center'
});

});
parcelRegister("keYuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $44d44647b65ea21a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92fae5f50256e3386fc71e04131d3a3e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $44d44647b65ea21a$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsScope"
        }
    ],
    "kind": "Fragment",
    "name": "cardContainer_issueNavigator_view",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                },
                {
                    "kind": "Variable",
                    "name": "scope",
                    "variableName": "fieldSetsScope"
                }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$44d44647b65ea21a$var$node.hash = "dd030a7b614f7ff3b54a4b31d5671be2";
var $44d44647b65ea21a$export$2e2bcd8739ae039 = $44d44647b65ea21a$var$node;

});

parcelRegister("boo7K", function(module, exports) {

$parcel$export(module.exports, "default", () => $a812cf6688129a19$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<49a8b04fc3798cc5e42bb64eb7cfe233>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a812cf6688129a19$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cardContainer_issueNavigator_issueResults",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }
    ],
    "type": "JiraIssueConnection"
};
$a812cf6688129a19$var$node.hash = "a51c85a8ee17bb574907b5cd760bad2f";
var $a812cf6688129a19$export$2e2bcd8739ae039 = $a812cf6688129a19$var$node;

});

parcelRegister("7khpH", function(module, exports) {

$parcel$export(module.exports, "useInfiniteScrollHandler", () => $8f8e5c1656e840b4$export$ee8d81e7d8c9f22d);

var $eJOHy = parcelRequire("eJOHy");

var $8jOO7 = parcelRequire("8jOO7");

var $5M8i8 = parcelRequire("5M8i8");
const $8f8e5c1656e840b4$var$DEFAULT_ACTIVATION_THRESHOLD = 10 * (0, $8jOO7.ROW_HEIGHT);
const $8f8e5c1656e840b4$export$ee8d81e7d8c9f22d = ({ onLoadNext: onLoadNextProp, onLoadPrevious: onLoadPreviousProp, ...dataProps })=>{
    // Keep props as ref so the callback is stable across rerenders.
    const dataPropsRef = (0, $eJOHy.useRef)(dataProps);
    dataPropsRef.current = dataProps;
    const onLoadNext = (0, $5M8i8.useThrottle)(onLoadNextProp);
    const onLoadPrevious = (0, $5M8i8.useThrottle)(onLoadPreviousProp);
    const onLoadingThresholdCheck = (0, $eJOHy.useCallback)(({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop })=>{
        const { isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, activationThreshold: activationThreshold = $8f8e5c1656e840b4$var$DEFAULT_ACTIVATION_THRESHOLD } = dataPropsRef.current;
        const scrollBottom = scrollHeight - clientHeight - scrollTop;
        const isLoading = isLoadingNext || isLoadingPrevious;
        // Prioritising loading next over loading previous to fill results downwards first,
        // to hopefully feel more natural.
        if (hasNext && !isLoading && scrollBottom <= activationThreshold) onLoadNext?.();
        else if (hasPrevious && !isLoading && scrollTop <= activationThreshold) onLoadPrevious?.();
    }, // Ensure that the callback is not recreated when props change.
    // onLoadNext & onLoadPrevious should be throttled & stable.
    [
        onLoadNext,
        onLoadPrevious
    ]);
    const onScroll = (0, $eJOHy.useCallback)((event)=>{
        onLoadingThresholdCheck(event.currentTarget);
    }, // Ensure that the callback is not recreated when props change.
    // onLoadingThresholdCheck should be stable.
    [
        onLoadingThresholdCheck
    ]);
    return {
        onLoadingThresholdCheck: onLoadingThresholdCheck,
        onScroll: onScroll
    };
};

});
parcelRegister("5M8i8", function(module, exports) {

$parcel$export(module.exports, "useThrottle", () => $47c0698a2db18423$export$8b7b9481d6186f21);

var $eJOHy = parcelRequire("eJOHy");
const $47c0698a2db18423$export$8b7b9481d6186f21 = (fn, wait = 100)=>{
    const fnRef = (0, $eJOHy.useRef)(fn);
    fnRef.current = fn;
    const waitRef = (0, $eJOHy.useRef)(wait);
    waitRef.current = wait;
    const timeout = (0, $eJOHy.useRef)(undefined);
    const throttled = (0, $eJOHy.useCallback)(()=>{
        if (timeout.current !== undefined) return;
        fnRef.current?.();
        timeout.current = setTimeout(()=>{
            timeout.current = undefined;
        }, waitRef.current);
    // Ensure the callback is not recreated when props change,
    // dependency array should be empty.
    }, []);
    // Cleanup the timeout on unmount.
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (timeout.current !== undefined) clearTimeout(timeout.current);
        };
    }, []);
    return throttled;
};

});


parcelRegister("7n9BS", function(module, exports) {

$parcel$export(module.exports, "useScrollStateSelector", () => $fb5e49bfa6da600b$export$a2d79f83724ed591);
$parcel$export(module.exports, "useScrollElement", () => $fb5e49bfa6da600b$export$fae04c81b2201f65);
$parcel$export(module.exports, "ScrollStateProvider", () => $fb5e49bfa6da600b$export$9f9741e7dc6bdb9b);

var $eJOHy = parcelRequire("eJOHy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $fb5e49bfa6da600b$export$50b6b7783d156e1b = 200;
const $fb5e49bfa6da600b$export$f9abcb6f103965a2 = (0, $6E16M.createContainer)();
const $fb5e49bfa6da600b$var$INITIAL_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null,
    hasScrolled: false
};
const $fb5e49bfa6da600b$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        }
};
const $fb5e49bfa6da600b$var$Store = (0, $GtRbT.createStore)({
    containedBy: $fb5e49bfa6da600b$export$f9abcb6f103965a2,
    initialState: $fb5e49bfa6da600b$var$INITIAL_SCROLL_STATE,
    name: 'ScrollStateManager',
    actions: $fb5e49bfa6da600b$var$actions
});
const $fb5e49bfa6da600b$var$useScrollStateActions = (0, $iJq0l.createActionsHook)($fb5e49bfa6da600b$var$Store);
const $fb5e49bfa6da600b$export$a2d79f83724ed591 = (0, $iJq0l.createStateHook)($fb5e49bfa6da600b$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $fb5e49bfa6da600b$export$fae04c81b2201f65 = (0, $iJq0l.createStateHook)($fb5e49bfa6da600b$var$Store, {
    selector: (state)=>state.scrollElement
});
const $fb5e49bfa6da600b$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $fb5e49bfa6da600b$var$useElementScrollState = (scrollRef)=>{
    const { update: update } = $fb5e49bfa6da600b$var$useScrollStateActions();
    (0, $eJOHy.useEffect)(()=>{
        const targetEl = scrollRef.current;
        // The element should always exists as the useEffect triggers after the reference is assigned.
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            update({
                scrollWidth: targetEl.scrollWidth,
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                isScrolling: true,
                hasScrolled: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollWidth: targetEl.scrollWidth,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $fb5e49bfa6da600b$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            update({
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                height: targetEl.clientHeight,
                width: targetEl.clientWidth,
                scrollHeight: targetEl.scrollHeight,
                scrollWidth: targetEl.scrollWidth,
                isScrolling: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $fb5e49bfa6da600b$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $fb5e49bfa6da600b$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        update({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef,
        update
    ]);
};
const $fb5e49bfa6da600b$var$ScrollStateProviderInner = ({ scrollRef: scrollRef, children: children })=>{
    $fb5e49bfa6da600b$var$useElementScrollState(scrollRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $fb5e49bfa6da600b$export$9f9741e7dc6bdb9b = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb5e49bfa6da600b$export$f9abcb6f103965a2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb5e49bfa6da600b$var$ScrollStateProviderInner, props));
};

});

parcelRegister("6K4cv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9107f8cdbcabb4f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $4hQDI = parcelRequire("4hQDI");

var $g2A1K = parcelRequire("g2A1K");
const $d9107f8cdbcabb4f$var$PageText = ({ startIssueRange: startIssueRange, endIssueRange: endIssueRange, loadedIssuesCount: loadedIssuesCount, total: total, countExceedsMaxResults: countExceedsMaxResults, isInfiniteScrollEnabled: isInfiniteScrollEnabled // This is not the experiment; This is if the feature is enabled
 })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isTotalUnknown = total <= 0;
    if (isInfiniteScrollEnabled) {
        if (isTotalUnknown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, loadedIssuesCount);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4hQDI.default), {
            prependMessage: (0, $g2A1K.default).loadedIssuesTotalKnown,
            prependMessageValues: {
                loadedIssuesCount: loadedIssuesCount
            },
            stableCount: total,
            isCapped: countExceedsMaxResults
        });
    }
    if (isTotalUnknown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $g2A1K.default).issueRangeUnknown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4hQDI.default), {
        prependMessage: (0, $g2A1K.default).issueRangeKnown,
        prependMessageValues: {
            startIssueRange: startIssueRange,
            endIssueRange: endIssueRange
        },
        stableCount: total,
        isCapped: countExceedsMaxResults
    });
};
var $d9107f8cdbcabb4f$export$2e2bcd8739ae039 = $d9107f8cdbcabb4f$var$PageText;

});
parcelRegister("4hQDI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b1f20e946ddee1c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $lRq8t = parcelRequire("lRq8t");

var $1Qv0G = parcelRequire("1Qv0G");
/**
 * Display the total number of issues from a search with the ability to toggle from stable to unstable values.
 *
 * Stable vs Unstable
 *  - the **stable count** is returned from the issueSearchStable query. It will be capped at 1000 if
 *    there are more than 1000 results. This is the default count that is displayed
 *
 *  - the **unstable count** is returned from the totalIssueCountQuery query. It is the true number of results
 *    for a search and does not have a cap. This value must be requested by the user via button click.
 */ const $3b1f20e946ddee1c$var$TotalIssueCountWrapper = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "TotalIssueCount",
        packageName: "jiraIssueNavigator",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage(props.prependMessage, {
                ...props.prependMessageValues,
                totalNumberIssues: props.isCapped ? `${props.stableCount}+` : props.stableCount
            })),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Qv0G.default), props));
};
var $3b1f20e946ddee1c$export$2e2bcd8739ae039 = $3b1f20e946ddee1c$var$TotalIssueCountWrapper;

});
parcelRegister("1Qv0G", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e48f1c27257a80$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1NG86 = parcelRequire("1NG86");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");

var $k71qx = parcelRequire("k71qx");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $iqtgH = parcelRequire("iqtgH");

var $3kDjB = parcelRequire("3kDjB");

var $ald06 = parcelRequire("ald06");

var $eTKLi = parcelRequire("eTKLi");
const $a3e48f1c27257a80$var$TotalIssueCount = ({ prependMessage: prependMessage, prependMessageValues: prependMessageValues, isCapped: isCapped, stableCount: stableCount })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const totalIssueCount = (0, $3kDjB.useTotalIssueCount)();
    const totalIssueCountIsFetching = (0, $3kDjB.useTotalIssueCountIsFetching)();
    const totalIssueCountIsError = (0, $3kDjB.useTotalIssueCountIsError)();
    const { fetchTotalIssueCount: fetchTotalIssueCount } = (0, $3kDjB.useIssueSearchActions)();
    if (isCapped) {
        if (totalIssueCountIsError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: `${stableCount}+`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            position: "top",
            content: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eTKLi.default).errorTooltipTextIssueTermRefresh : (0, $eTKLi.default).errorTooltipText)
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3e48f1c27257a80$var$ErrorIconContainer, {
                ...tooltipProps,
                "data-testid": "issue-navigator.common.ui.total-issue-count.error-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                spacing: "spacious",
                label: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eTKLi.default).errorIconLabelIssueTermRefresh : (0, $eTKLi.default).errorIconLabel)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
            action: "viewed",
            actionSubject: "errorIcon",
            actionSubjectId: "totalIssueCount"
        }));
        if (totalIssueCountIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: ''
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3e48f1c27257a80$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small",
            testId: "issue-navigator.common.ui.total-issue-count.spinner"
        })));
        if (!totalIssueCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ald06.default), {
                displayText: `${stableCount}+`,
                onFetchCount: fetchTotalIssueCount
            })
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: totalIssueCount
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        as: "span"
    }, formatMessage(prependMessage, {
        ...prependMessageValues,
        totalNumberIssues: stableCount
    }));
};
var $a3e48f1c27257a80$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eJOHy.memo)($a3e48f1c27257a80$var$TotalIssueCount);
const $a3e48f1c27257a80$var$ErrorIconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _4t3i1tcg _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3e48f1c27257a80$var$SpinnerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _otyr1l7b _18u01y44",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ald06", function(module, exports) {

$parcel$export(module.exports, "default", () => $c44b18b79e6584e9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $k71qx = parcelRequire("k71qx");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $eTKLi = parcelRequire("eTKLi");
const $c44b18b79e6584e9$var$LoadUncappedCountButton = ({ onFetchCount: onFetchCount, displayText: displayText })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const fetchCount = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        onFetchCount();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'totalIssueCountButton');
    }, [
        onFetchCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eTKLi.default).cappedCountTooltipIssueTermRefresh : (0, $eTKLi.default).cappedCountTooltip),
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        tabIndex: 0,
        appearance: "link",
        spacing: "none",
        onClick: fetchCount,
        "aria-label": formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eTKLi.default).cappedCountButtonLabelIssueTermRefresh : (0, $eTKLi.default).cappedCountButtonLabel, {
            count: displayText
        }),
        testId: "issue-navigator.common.ui.total-issue-count.load-uncapped-count-button.button"
    }, displayText));
};
var $c44b18b79e6584e9$export$2e2bcd8739ae039 = $c44b18b79e6584e9$var$LoadUncappedCountButton;

});
parcelRegister("eTKLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $673f93c64d67cc98$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $673f93c64d67cc98$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorTooltipText: {
        "id": "issue-navigator.common.total-issue-count.error-tooltip-text",
        "defaultMessage": "We couldn\u2019t load the total number of issues. Refresh to try again."
    },
    errorIconLabel: {
        "id": "issue-navigator.common.total-issue-count.error-icon-label",
        "defaultMessage": "Error loading total issue count"
    },
    cappedCountTooltip: {
        "id": "issue-navigator.common.total-issue-count.capped-count-tooltip",
        "defaultMessage": "See the total number of issues."
    },
    errorTooltipTextIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.error-tooltip-text-issue-term-refresh",
        "defaultMessage": "We couldn\u2019t load the total number of work items. Refresh to try again."
    },
    errorIconLabelIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.error-icon-label-issue-term-refresh",
        "defaultMessage": "Error loading total work item count"
    },
    cappedCountTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.capped-count-tooltip-issue-term-refresh",
        "defaultMessage": "See the total number of work items."
    },
    cappedCountButtonLabel: {
        "id": "issue-navigator.common.total-issue-count.capped-count-button-label",
        "defaultMessage": "{count} See the total number of issues."
    },
    cappedCountButtonLabelIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.capped-count-button-label-issue-term-refresh",
        "defaultMessage": "{count} See the total number of work items."
    }
});

});




parcelRegister("g2A1K", function(module, exports) {

$parcel$export(module.exports, "default", () => $74cbac8c41f7e98a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $74cbac8c41f7e98a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loadedIssuesTotalKnown: {
        "id": "issue-navigator.common.page-text.loaded-issues-total-known",
        "defaultMessage": "{loadedIssuesCount} of {totalNumberIssues}"
    },
    issueRangeKnown: {
        "id": "issue-navigator.card-container.paginator.issue-range-known",
        "defaultMessage": "{startIssueRange}-{endIssueRange} of {totalNumberIssues}"
    },
    issueRangeUnknown: {
        "id": "issue-navigator.card-container.paginator.issue-range-unknown",
        "defaultMessage": "{startIssueRange}-{endIssueRange}"
    }
});

});


parcelRegister("gRqFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $399b0ebc2f4d4ea9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $i78b1 = parcelRequire("i78b1");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $3kDjB = parcelRequire("3kDjB");

var $fg4DB = parcelRequire("fg4DB");
const $399b0ebc2f4d4ea9$var$RefreshButton = ()=>{
    const isRefreshing = (0, $3kDjB.useIsRefreshing)();
    const { refresh: refresh } = (0, $3kDjB.useIssueSearchActions)();
    const handleClick = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'reloadIssueListButton');
        refresh();
    }, [
        refresh
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        onClick: handleClick,
        testId: "issue-navigator.common.ui.refresh-button.refresh-button",
        label: formatMessage((0, $fg4DB.default).tooltip),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i78b1))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #626F86)",
                LEGACY_size: "small",
                LEGACY_primaryColor: "color.icon.subtle"
            }),
        isLoading: isRefreshing
    });
};
var $399b0ebc2f4d4ea9$export$2e2bcd8739ae039 = $399b0ebc2f4d4ea9$var$RefreshButton;

});
parcelRegister("i78b1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::719d4261fb56656c74a1b6271d6f07b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2ff392db1cfed64$var$_react = $d2ff392db1cfed64$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d2ff392db1cfed64$var$_refresh = $d2ff392db1cfed64$var$_interopRequireDefault((parcelRequire("yJU5w")));

var $d2ff392db1cfed64$var$_refresh2 = $d2ff392db1cfed64$var$_interopRequireDefault((parcelRequire("96otq")));
function $d2ff392db1cfed64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RefreshIcon.
 * This component is RefreshIcon, with `UNSAFE_fallbackIcon` set to "RefreshIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2ff392db1cfed64$var$RefreshIcon = (props)=>/*#__PURE__*/ $d2ff392db1cfed64$var$_react.default.createElement($d2ff392db1cfed64$var$_refresh.default, Object.assign({
        name: "RefreshIcon",
        LEGACY_fallbackIcon: $d2ff392db1cfed64$var$_refresh2.default
    }, props));
$d2ff392db1cfed64$var$RefreshIcon.displayName = 'RefreshIconMigration';
var $d2ff392db1cfed64$var$_default = module.exports.default = $d2ff392db1cfed64$var$RefreshIcon;

});
parcelRegister("yJU5w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bacc7e4688824042b7c7acb7148b6a10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0686c89929896566$var$_react = $0686c89929896566$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0686c89929896566$var$_baseNew = $0686c89929896566$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0686c89929896566$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0686c89929896566$var$RefreshIcon = (props)=>/*#__PURE__*/ $0686c89929896566$var$_react.default.createElement($0686c89929896566$var$_baseNew.default, Object.assign({
        name: "RefreshIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$0686c89929896566$var$RefreshIcon.displayName = 'RefreshIcon';
var $0686c89929896566$var$_default = module.exports.default = $0686c89929896566$var$RefreshIcon;

});

parcelRegister("96otq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a07a88e32d8e8bc$var$_react = $6a07a88e32d8e8bc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $6a07a88e32d8e8bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6a07a88e32d8e8bc$var$RefreshIcon = (props)=>/*#__PURE__*/ $6a07a88e32d8e8bc$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props));
$6a07a88e32d8e8bc$var$RefreshIcon.displayName = 'RefreshIcon';
var $6a07a88e32d8e8bc$var$_default = module.exports.default = $6a07a88e32d8e8bc$var$RefreshIcon;

});


parcelRegister("fg4DB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e0439daacbe1e8b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var // TODO - Port i18n string translations to new module ID keys
$0e0439daacbe1e8b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltip: {
        "id": "issue-navigator.refresh-button.tooltip",
        "defaultMessage": "Refresh"
    },
    loading: {
        "id": "issue-navigator.refresh-button.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("haEEA", function(module, exports) {

$parcel$export(module.exports, "LoadingManager", () => $71f8d6b49558d935$export$99cc795e99919eed);

var $eJOHy = parcelRequire("eJOHy");

var $9cbmy = parcelRequire("9cbmy");

var $lRq8t = parcelRequire("lRq8t");

var $kbYhH = parcelRequire("kbYhH");

var $7n9BS = parcelRequire("7n9BS");

var $6d9QY = parcelRequire("6d9QY");

var $7jTnu = parcelRequire("7jTnu");

var $3VBEh = parcelRequire("3VBEh");

var $kKJ20 = parcelRequire("kKJ20");
const $71f8d6b49558d935$export$99cc795e99919eed = ({ isLoadingPrevious: isLoadingPrevious, isLoadingNext: isLoadingNext, onLoadingThresholdCheck: onLoadingThresholdCheck })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // List has height 0 during first render due to virtualization. Some checks need to wait for the list to have a height.
    const hasListHeight = (0, $kbYhH.useElementSizeSelector)((listElm)=>Boolean(listElm.height));
    const scrollContainerHeight = (0, $7n9BS.useScrollStateSelector)((scrollState)=>scrollState.height);
    const scrollElement = (0, $7n9BS.useScrollElement)();
    // #region After-load Handler
    /**
   * After initial render and any subsequent loading events, make sure that we continue loading in more issues if
   * necessary because a single load may not have enough issues to fill the scroll container.
   */ (0, $eJOHy.useEffect)(()=>{
        if (scrollElement && onLoadingThresholdCheck && hasListHeight && !isLoadingPrevious && !isLoadingNext) onLoadingThresholdCheck(scrollElement);
    }, [
        hasListHeight,
        isLoadingPrevious,
        isLoadingNext,
        onLoadingThresholdCheck,
        scrollElement
    ]);
    // #endregion
    // #region Resize Handler
    /**
   * Check the loading boundaries when resizing the scroll container, as the new size may require loading more issues.
   */ const prevHeight = (0, $6d9QY.usePreviousWithInitial)(scrollContainerHeight);
    (0, $eJOHy.useEffect)(()=>{
        if (scrollElement && onLoadingThresholdCheck && hasListHeight && scrollContainerHeight > prevHeight) onLoadingThresholdCheck(scrollElement);
    }, [
        hasListHeight,
        scrollContainerHeight,
        prevHeight,
        onLoadingThresholdCheck,
        scrollElement
    ]);
    // #endregion
    // #region Top Scroll Handler
    /**
   * A component that ensures that the scroll position is kept stable when loading previous issues.
   * This is necessary because sometimes the browser does scroll to keep existing rows in view when new rows are prepended.
   *
   * Without this, we may see issues like continuously loading all previous issues until there are none left.
   */ const prevIsLoadingPrevious = (0, $6d9QY.usePreviousWithInitial)(isLoadingPrevious);
    const hasStartedLoadingPrevious = !prevIsLoadingPrevious && isLoadingPrevious;
    const hasFinishedLoadingPrevious = prevIsLoadingPrevious && !isLoadingPrevious;
    // Hook's scrollHeight doesn't update the height information when the scroll height changes due to DOM mutations
    // Need to track this separately when loading starts
    const scrollHeightRef = (0, $eJOHy.useRef)(0);
    (0, $eJOHy.useEffect)(()=>{
        if (scrollElement && hasStartedLoadingPrevious) scrollHeightRef.current = scrollElement.scrollHeight;
    }, [
        hasStartedLoadingPrevious,
        scrollElement
    ]);
    // Ensure that the scroll is kept in place after loading previous issues - browser doesn't always handle this properly
    // Using a layout effect to make sure this happens as quickly as possible to reduce visible movement
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (scrollElement && hasFinishedLoadingPrevious) {
            const newScrollHeight = scrollElement.scrollHeight;
            if (newScrollHeight > scrollHeightRef.current) {
                const heightIncrease = newScrollHeight - scrollHeightRef.current;
                scrollElement.scrollBy(0, heightIncrease);
            }
            scrollHeightRef.current = newScrollHeight;
        }
    }, [
        hasFinishedLoadingPrevious,
        scrollElement
    ]);
    // #endregion
    // #region Loading A11y
    const prevIsLoadingNext = (0, $6d9QY.usePreviousWithInitial)(isLoadingNext);
    const hasFinishedLoadingNext = prevIsLoadingNext && !isLoadingNext;
    const loadingCompleteLiveMessage = (0, $eJOHy.useRef)(undefined);
    if (isLoadingPrevious) loadingCompleteLiveMessage.current = (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $kKJ20.default).loadStartA11YMessageTopIssueTermRefresh : (0, $kKJ20.default).loadStartA11YMessageTop;
    else if (hasFinishedLoadingPrevious) loadingCompleteLiveMessage.current = (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $kKJ20.default).loadEndA11YMessageTopIssueTermRefresh : (0, $kKJ20.default).loadEndA11YMessageTop;
    else if (isLoadingNext) loadingCompleteLiveMessage.current = (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $kKJ20.default).loadStartA11YMessageBottomIssueTermRefresh : (0, $kKJ20.default).loadStartA11YMessageBottom;
    else if (hasFinishedLoadingNext) loadingCompleteLiveMessage.current = (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $kKJ20.default).loadEndA11YMessageBottomIssueTermRefresh : (0, $kKJ20.default).loadEndA11YMessageBottom;
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isLoadingPrevious && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VBEh.LoadingIndicator), {
        position: "top"
    }), isLoadingNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VBEh.LoadingIndicator), {
        position: "bottom"
    }), loadingCompleteLiveMessage.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), {
        role: "alert",
        "aria-live": "polite"
    }, formatMessage(loadingCompleteLiveMessage.current)));
};

});
parcelRegister("3VBEh", function(module, exports) {

$parcel$export(module.exports, "LoadingIndicator", () => $871efb7dc0251ef8$export$7c20be4c1d342248);

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $2QkAA = parcelRequire("2QkAA");
const $871efb7dc0251ef8$export$7c20be4c1d342248 = ({ position: position })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignInline: "center",
        xcss: [
            $871efb7dc0251ef8$var$containerStyles,
            position === 'top' ? $871efb7dc0251ef8$var$positionTopStyles : $871efb7dc0251ef8$var$positionBottomStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center",
        grow: "hug",
        xcss: $871efb7dc0251ef8$var$loadingIndicatorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        appearance: "invert",
        size: "small",
        interactionName: (0, $7jTnu.fg)('add_nin_press_interactions') ? 'nin-detail-view-infinite-scroll-loading' : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text.inverse"
    }, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $2QkAA.default).loadingMessageIssueTermRefresh : (0, $2QkAA.default).loadingMessage))));
};
const $871efb7dc0251ef8$var$positionTopStyles = (0, $1DXK0.xcss)({
    top: 'space.0'
});
const $871efb7dc0251ef8$var$positionBottomStyles = (0, $1DXK0.xcss)({
    bottom: 'space.0'
});
const $871efb7dc0251ef8$var$loadingIndicatorStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    color: 'color.text.inverse',
    marginBlock: 'space.200',
    padding: 'space.100'
});
const $871efb7dc0251ef8$var$containerStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    width: '100%'
});

});
parcelRegister("2QkAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d90748bc6480da0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1d90748bc6480da0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loadingMessage: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.loading-indicator.loading-message",
        "defaultMessage": "Loading more issues"
    },
    loadingMessageIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.loading-indicator.loading-message-issue-term-refresh",
        "defaultMessage": "Loading more work items"
    }
});

});


parcelRegister("kKJ20", function(module, exports) {

$parcel$export(module.exports, "default", () => $16f25f2ae945dfd7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $16f25f2ae945dfd7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loadStartA11YMessageTop: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-top",
        "defaultMessage": "Loading more issues at the top of the list."
    },
    loadEndA11YMessageTop: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-top",
        "defaultMessage": "Finished loading more issues at the top of the list."
    },
    loadStartA11YMessageBottom: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-bottom",
        "defaultMessage": "Loading more issues at the bottom of the list."
    },
    loadEndA11YMessageBottom: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-bottom",
        "defaultMessage": "Finished loading more issues at the bottom of the list."
    },
    loadStartA11YMessageTopIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Loading more work items at the top of the list."
    },
    loadEndA11YMessageTopIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the top of the list."
    },
    loadStartA11YMessageBottomIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Loading more work items at the bottom of the list."
    },
    loadEndA11YMessageBottomIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the bottom of the list."
    }
});

});


parcelRegister("eqaMC", function(module, exports) {

$parcel$export(module.exports, "default", () => $20c0ff6ce7988817$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $5lAAn = parcelRequire("5lAAn");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $1pKTL = parcelRequire("1pKTL");
var $6TtH3 = parcelRequire("6TtH3");

var $aBFKZ = parcelRequire("aBFKZ");

var $epTsa = parcelRequire("epTsa");

var $dTocu = parcelRequire("dTocu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $91UnK = parcelRequire("91UnK");

var $dTsrC = parcelRequire("dTsrC");

var $dTg5r = parcelRequire("dTg5r");
const $20c0ff6ce7988817$export$e813e910f52c9aab = {
    appearance: 'subtle',
    'data-testid': 'issue-navigator.ui.issue-results.detail-view.card-container.order-dropdown.button'
};
const $20c0ff6ce7988817$var$customFieldIdPattern = /^cf\[\d+\]$/;
const $20c0ff6ce7988817$var$DropdownItemRadioWithAnalytics = (0, $aBFKZ.default)('dropdownItemRadio', {
    onClick: 'clicked'
})((0, $1pKTL.default));
class $20c0ff6ce7988817$export$50f2c227513bcdb7 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    onItemClick(order, aliases) {
        const { onChange: onChange, onBlur: onBlur } = this.props;
        onChange(order, aliases);
        onBlur();
    }
    renderItems() {
        const { intl: { formatMessage: formatMessage }, orderField: orderField } = this.props;
        return Object.values((0, $iRahl.supportedOrderFields)).filter((0, $eibCx.isNonNullish)).map(({ jqlTerm: jqlTerm, aliases: aliases })=>{
            let jqlTermForMessage = jqlTerm;
            if ([
                'issuetype'
            ].includes(jqlTermForMessage)) jqlTermForMessage = `${jqlTerm}${(0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? 'IssueTermRefresh' : ''}`;
            const messageDescriptor = (0, $dTg5r.messageLookup)[jqlTermForMessage];
            const fieldName = messageDescriptor ? formatMessage(messageDescriptor) : jqlTerm;
            const props = {
                id: jqlTerm,
                onClick: ()=>{
                    this.onItemClick(jqlTerm, aliases);
                },
                isSelected: jqlTerm === orderField || orderField && aliases.includes(orderField)
            };
            return /* @ts-expect-error - Type '{ children: string; id: string; onClick: () => void; isSelected: boolean | "" | undefined; key: string; }' is not assignable to type 'Omit<{ children: ReactNode; description?: string | Element | undefined; isDisabled?: boolean | undefined; shouldTitleWrap?: boolean | undefined; shouldDescriptionWrap?: boolean | undefined; ... 5 more ...; testId?: string | undefined; }, keyof WithAnalyticsEventsProps>'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($20c0ff6ce7988817$var$DropdownItemRadioWithAnalytics, {
                key: jqlTerm,
                ...props
            }, fieldName);
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage }, orderField: orderField, isOpen: isOpen, className: className } = this.props;
        let fallbackMessage = '';
        let fieldName = '';
        if (typeof orderField === 'string') {
            const isCustomFieldId = $20c0ff6ce7988817$var$customFieldIdPattern.test(orderField);
            const expectedOrderField = (0, $iRahl.supportedOrderFields)[(0, $iRahl.getSupportedFieldForAlias)(orderField) ?? orderField];
            const fallbackMessageDescriptor = expectedOrderField ? (0, $dTg5r.messageLookup)[expectedOrderField.jqlTerm] : null;
            if (isCustomFieldId) fallbackMessage = formatMessage((0, $dTg5r.default).customField);
            else if (expectedOrderField && fallbackMessageDescriptor) fallbackMessage = formatMessage(fallbackMessageDescriptor);
            else fieldName = orderField;
        } else fallbackMessage = formatMessage((0, $dTg5r.default).defaultLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($20c0ff6ce7988817$var$StyledContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
            isOpen: isOpen,
            onOpenChange: this.onOpenChange,
            testId: "issue-navigator.ui.issue-results.detail-view.card-container.order-dropdown",
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($20c0ff6ce7988817$var$StyledButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                    ...props,
                    appearance: "subtle",
                    ref: triggerRef,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                        label: formatMessage((0, $dTg5r.default).defaultLabel),
                        size: "small"
                    })
                }, fieldName || fallbackMessage)),
            shouldFlip: true,
            placement: "bottom-start",
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($20c0ff6ce7988817$var$StyledDropdownMenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6TtH3.default), {
            id: "sort-field-group",
            title: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dTg5r.default).fieldGroupIssueTermRefresh : (0, $dTg5r.default).fieldGroup)
        }, this.renderItems()))));
    }
    constructor(...args){
        super(...args), this.onOpenChange = ({ isOpen: isOpen } = {
            isOpen: false
        })=>{
            if (isOpen) this.props.onFocus();
            else this.props.onBlur();
        };
    }
}
const $20c0ff6ce7988817$export$f6d8103ec9453c7f = ()=>{
    const [{ isOpen: isOpen }, { open: open, close: close }] = (0, $91UnK.useOrderByOpenState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const intl = (0, $dTocu.useIntlV2)();
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $dTsrC.useSortFieldAndDirection)();
    const handleOnChange = (0, $eJOHy.useCallback)((orderField, aliases)=>{
        setFieldAndDirection(orderField, direction, aliases);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItemRadio'
        });
        const { fieldType: fieldType = null } = (0, $iRahl.supportedOrderFields)[(0, $iRahl.getSupportedFieldForAlias)(orderField) ?? orderField] ?? {};
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'sortFieldDropdownItemRadio', {
            fieldType: fieldType,
            order: direction
        });
    }, [
        createAnalyticsEvent,
        direction,
        setFieldAndDirection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($20c0ff6ce7988817$export$50f2c227513bcdb7, {
        orderField: field,
        onChange: handleOnChange,
        isOpen: isOpen,
        onFocus: open,
        onBlur: close,
        intl: intl
    });
};
var $20c0ff6ce7988817$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
 = $20c0ff6ce7988817$export$f6d8103ec9453c7f;
const $20c0ff6ce7988817$var$StyledButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1s3g12gs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20c0ff6ce7988817$var$StyledDropdownMenuContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3inklw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20c0ff6ce7988817$var$StyledContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("91UnK", function(module, exports) {

$parcel$export(module.exports, "useOrderByOpenState", () => $2986628a64ee2132$export$32869ae0582ab3ff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $2986628a64ee2132$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'IssueNavigatorOrderByOpenState'
});
const $2986628a64ee2132$export$2ba8216bf1290828 = (0, $ht3nQ.createSubscriber)($2986628a64ee2132$var$Store);
const $2986628a64ee2132$export$32869ae0582ab3ff = (0, $iJq0l.createHook)($2986628a64ee2132$var$Store);

});

parcelRegister("dTg5r", function(module, exports) {

$parcel$export(module.exports, "default", () => $dedaaba772b36be6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "messageLookup", () => $dedaaba772b36be6$export$3a16bd55b6aaaf91);

var $7qGN1 = parcelRequire("7qGN1");
const $dedaaba772b36be6$var$messages = (0, $7qGN1.defineMessages)({
    loading: {
        "id": "issue-navigator.card-container.order-dropdown.loading",
        "defaultMessage": "Loading"
    },
    fieldGroup: {
        "id": "issue-navigator.card-container.order-dropdown.field-group",
        "defaultMessage": "Order issues by"
    },
    created: {
        "id": "issue-navigator.card-container.order-dropdown.created",
        "defaultMessage": "Created"
    },
    updated: {
        "id": "issue-navigator.card-container.order-dropdown.updated",
        "defaultMessage": "Updated"
    },
    lastviewed: {
        "id": "issue-navigator.card-container.order-dropdown.lastviewed",
        "defaultMessage": "Last viewed"
    },
    status: {
        "id": "issue-navigator.card-container.order-dropdown.status",
        "defaultMessage": "Status"
    },
    priority: {
        "id": "issue-navigator.card-container.order-dropdown.priority",
        "defaultMessage": "Priority"
    },
    assignee: {
        "id": "issue-navigator.card-container.order-dropdown.assignee",
        "defaultMessage": "Assignee"
    },
    resolved: {
        "id": "issue-navigator.card-container.order-dropdown.resolved",
        "defaultMessage": "Resolved"
    },
    issuekey: {
        "id": "issue-navigator.card-container.order-dropdown.issuekey",
        "defaultMessage": "Key"
    },
    key: {
        "id": "issue-navigator.card-container.order-dropdown.key",
        "defaultMessage": "Key"
    },
    issuetype: {
        "id": "issue-navigator.card-container.order-dropdown.issuetype",
        "defaultMessage": "Issue Type"
    },
    duedate: {
        "id": "issue-navigator.card-container.order-dropdown.duedate",
        "defaultMessage": "Due date"
    },
    summary: {
        "id": "issue-navigator.card-container.order-dropdown.summary",
        "defaultMessage": "Summary"
    },
    reporter: {
        "id": "issue-navigator.card-container.order-dropdown.reporter",
        "defaultMessage": "Reporter"
    },
    customField: {
        "id": "issue-navigator.card-container.order-dropdown.custom-field",
        "defaultMessage": "Custom field"
    },
    defaultLabel: {
        "id": "issue-navigator.card-container.order-dropdown.default-label",
        "defaultMessage": "Order by"
    },
    fieldGroupIssueTermRefresh: {
        "id": "issue-navigator.card-container.order-dropdown.field-group-issue-term-refresh",
        "defaultMessage": "Order work items by"
    },
    issuetypeIssueTermRefresh: {
        "id": "issue-navigator.card-container.order-dropdown.issuetype-issue-term-refresh",
        "defaultMessage": "Work type"
    }
});
var $dedaaba772b36be6$export$2e2bcd8739ae039 = $dedaaba772b36be6$var$messages;
const $dedaaba772b36be6$export$3a16bd55b6aaaf91 = $dedaaba772b36be6$var$messages;

});


parcelRegister("8X4cC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a48f351f24839396$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $Ay1uj = parcelRequire("Ay1uj");

var $fL0In = parcelRequire("fL0In");

var $1GtTj = parcelRequire("1GtTj");

var $g48F1 = parcelRequire("g48F1");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $iRahl = parcelRequire("iRahl");

var $dTsrC = parcelRequire("dTsrC");

var $4mcU4 = parcelRequire("4mcU4");

var $2iR9v = parcelRequire("2iR9v");

var $4jM8K = parcelRequire("4jM8K");
class $a48f351f24839396$export$e464399b18ba2124 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onSort: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    shouldComponentUpdate(nextProps) {
        return this.props.sortDirection !== nextProps.sortDirection || this.props.isDisabled !== nextProps.isDisabled;
    }
    render() {
        const { intl: { formatMessage: formatMessage }, sortDirection: sortDirection, isDisabled: isDisabled } = this.props;
        const tooltipText = sortDirection === (0, $iRahl.sortDirections).ASC ? formatMessage((0, $4jM8K.default).tooltipAsc) : formatMessage((0, $4jM8K.default).tooltipDesc);
        const glyph = sortDirection === (0, $iRahl.sortDirections).ASC ? (0, $2iR9v.ArrowUpIcon) : (0, $4mcU4.ArrowDownIcon);
        const SortIcon = sortDirection === (0, $iRahl.sortDirections).ASC ? (0, (/*@__PURE__*/$parcel$interopDefault($1GtTj))) : (0, (/*@__PURE__*/$parcel$interopDefault($g48F1)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: tooltipText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            appearance: "subtle",
            onClick: this.onClick,
            testId: "issue-navigator.ui.issue-results.detail-view.card-container.sort-button.sort-button",
            isDisabled: isDisabled,
            icon: (props)=>(0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SortIcon, {
                    ...props,
                    color: "currentColor"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                    ...props,
                    size: "small",
                    glyph: glyph
                }),
            label: tooltipText
        }));
    }
    constructor(...args){
        super(...args), this.onClick = ()=>{
            const { onSort: onSort, sortDirection: sortDirection } = this.props;
            const newSortDirection = sortDirection === (0, $iRahl.sortDirections).ASC ? (0, $iRahl.sortDirections).DESC : (0, $iRahl.sortDirections).ASC;
            onSort(newSortDirection);
        };
    }
}
const $a48f351f24839396$export$86b24d49f595c6f2 = (props)=>{
    const intl = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $dTsrC.useSortFieldAndDirection)();
    const handleOnSort = (0, $eJOHy.useCallback)((newSortDirection)=>{
        typeof field === 'string' && setFieldAndDirection(field, newSortDirection, []);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const orderField = field ? (0, $iRahl.supportedOrderFields)[(0, $iRahl.getSupportedFieldForAlias)(field) ?? field] : undefined;
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'sortOrderChangeButton', {
            fieldType: orderField?.fieldType ?? null,
            sortOrder: newSortDirection
        });
        return true;
    }, [
        createAnalyticsEvent,
        field,
        setFieldAndDirection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a48f351f24839396$export$e464399b18ba2124, {
        isDisabled: typeof field !== 'string',
        sortDirection: direction,
        onSort: handleOnSort,
        ...props,
        intl: intl
    });
};
var $a48f351f24839396$export$2e2bcd8739ae039 = $a48f351f24839396$export$86b24d49f595c6f2;

});
parcelRegister("1GtTj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61f2cd3b3ce75546535a34edc6c6a407>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $13a0e6777fbb52a1$var$_react = $13a0e6777fbb52a1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $13a0e6777fbb52a1$var$_baseNew = $13a0e6777fbb52a1$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $13a0e6777fbb52a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortAscending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $13a0e6777fbb52a1$var$SortAscendingIcon = (props)=>/*#__PURE__*/ $13a0e6777fbb52a1$var$_react.default.createElement($13a0e6777fbb52a1$var$_baseNew.default, Object.assign({
        name: "SortAscendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 12.5H1V14h14zm-1.75-3.75V3.56l1.72 1.72 1.06-1.06-3-3a.75.75 0 0 0-1.06 0l-3 3 1.06 1.06 1.72-1.72v5.19zM8 7.25H1v1.5h7zM6 2H1v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$13a0e6777fbb52a1$var$SortAscendingIcon.displayName = 'SortAscendingIcon';
var $13a0e6777fbb52a1$var$_default = module.exports.default = $13a0e6777fbb52a1$var$SortAscendingIcon;

});

parcelRegister("g48F1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa40f37165b56c780c43a081b97fc51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb23bce3061d7b5e$var$_react = $bb23bce3061d7b5e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $bb23bce3061d7b5e$var$_baseNew = $bb23bce3061d7b5e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $bb23bce3061d7b5e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortDescending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb23bce3061d7b5e$var$SortDescendingIcon = (props)=>/*#__PURE__*/ $bb23bce3061d7b5e$var$_react.default.createElement($bb23bce3061d7b5e$var$_baseNew.default, Object.assign({
        name: "SortDescendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-1.75 3.75v5.19l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06 1.72 1.72V7.25zM8 8.75H1v-1.5h7zM6 14H1v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$bb23bce3061d7b5e$var$SortDescendingIcon.displayName = 'SortDescendingIcon';
var $bb23bce3061d7b5e$var$_default = module.exports.default = $bb23bce3061d7b5e$var$SortDescendingIcon;

});

parcelRegister("4mcU4", function(module, exports) {

$parcel$export(module.exports, "ArrowDownIcon", () => $84561fd9ff7046cc$export$1c939d3c9b6931b);

var $eJOHy = parcelRequire("eJOHy");
const $84561fd9ff7046cc$export$1c939d3c9b6931b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.8,4.3 C6.6,4.1 6.3,4 6,4 C5.7,4 5.4,4.1 5.2,4.3 L2.3,7.2 C1.9,7.6 1.9,8.3 2.3,8.7 C2.7,9.1 3.3,9.1 3.7,8.7 L5,7.4 L5,19.1 C5,19.6 5.4,20 6,20 C6.6,20 7,19.6 7,19.1 L7,7.4 L8.3,8.7 C8.7,9.1 9.3,9.1 9.7,8.7 C10.1,8.3 10.1,7.6 9.7,7.2 C9.04754611,6.54754611 8.5582057,6.0582057 8.23197876,5.73197876 C7.91376126,5.41376126 7.436435,4.936435 6.8,4.3 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero",
        transform: "translate(6.000000, 12.000000) rotate(180.000000) translate(-6.000000, -12.000000) "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M21,5 L13,5 C12.4,5 12,5.4 12,6 C12,6.6 12.4,7 13,7 L21,7 C21.6,7 22,6.6 22,6 C22,5.4 21.6,5 21,5 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M13,13 L18,13 C18.6,13 19,12.6 19,12 C19,11.4 18.6,11 18,11 L13,11 C12.4,11 12,11.4 12,12 C12,12.6 12.4,13 13,13 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M13,19 L16,19 C16.6,19 17,18.6 17,18 C17,17.4 16.6,17 16,17 L13,17 C12.4,17 12,17.4 12,18 C12,18.6 12.4,19 13,19 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    })));

});

parcelRegister("2iR9v", function(module, exports) {

$parcel$export(module.exports, "ArrowUpIcon", () => $f424679088530729$export$f1a507b991affc46);

var $eJOHy = parcelRequire("eJOHy");
const $f424679088530729$export$f1a507b991affc46 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7.8,4.3 C7.6,4.1 7.3,4 7,4 C6.7,4 6.4,4.1 6.2,4.3 L3.3,7.2 C2.9,7.6 2.9,8.3 3.3,8.7 C3.7,9.1 4.3,9.1 4.7,8.7 L6,7.4 L6,19.1 C6,19.6 6.4,20 7,20 C7.6,20 8,19.6 8,19.1 L8,7.4 L9.3,8.7 C9.7,9.1 10.3,9.1 10.7,8.7 C11.1,8.3 11.1,7.6 10.7,7.2 C10.0475461,6.54754611 9.5582057,6.0582057 9.23197876,5.73197876 C8.91376126,5.41376126 8.436435,4.936435 7.8,4.3 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M21,17 L13,17 C12.4,17 12,17.4 12,18 C12,18.6 12.4,19 13,19 L21,19 C21.6,19 22,18.6 22,18 C22,17.4 21.6,17 21,17 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M13,13 L18,13 C18.6,13 19,12.6 19,12 C19,11.4 18.6,11 18,11 L13,11 C12.4,11 12,11.4 12,12 C12,12.6 12.4,13 13,13 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M13,7 L16,7 C16.6,7 17,6.6 17,6 C17,5.4 16.6,5 16,5 L13,5 C12.4,5 12,5.4 12,6 C12,6.6 12.4,7 13,7 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    })));

});

parcelRegister("4jM8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c7a5e017ecb67e6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5c7a5e017ecb67e6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltipAsc: {
        "id": "issue-navigator.card-container.sort-button.tooltip-asc",
        "defaultMessage": "Sort ascending"
    },
    tooltipDesc: {
        "id": "issue-navigator.card-container.sort-button.tooltip-desc",
        "defaultMessage": "Sort descending"
    }
});

});



parcelRegister("2Jpfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad8de669773f4513$export$2e2bcd8739ae039);

var $6APjZ = parcelRequire("6APjZ");

var $g9uic = parcelRequire("g9uic");

var $eaCzE = parcelRequire("eaCzE");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $fAgUF = parcelRequire("fAgUF");

var $1wL9i = parcelRequire("1wL9i");

var $ahkvg = parcelRequire("ahkvg");

var $2nPlv = parcelRequire("2nPlv");

var $hvJLL = parcelRequire("hvJLL");

var $42ws0 = parcelRequire("42ws0");

var $3KwXP = parcelRequire("3KwXP");

var $1Gp6c = parcelRequire("1Gp6c");
const $ad8de669773f4513$var$BLANK_CARD_ANALYTICS_ID = 'blankIssueCard';
const $ad8de669773f4513$var$ISSUE_CARD_ANALYTICS_ID = 'issueCard';
const $ad8de669773f4513$var$CardWithSelectedIssue = ({ issue: issue, fieldSets: fieldSets, isFocused: isFocused, onFocus: onFocus, onBlur: onBlur })=>{
    const issueData = (0, $j4oe4.useFragment)((0, $eaCzE.default), issue);
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $g9uic.default), fieldSets);
    const { key: key } = issueData;
    const isSelected = (0, $1wL9i.useIsSelectedIssue)(key);
    const { setSelectedIssueByKey: setSelectedIssueByKey } = (0, $1wL9i.useSelectedIssueActions)();
    const onCardFocus = (0, $eJOHy.useCallback)(()=>{
        onFocus(key);
        setSelectedIssueByKey(key, {
            shouldDebounce: true
        });
    }, [
        key,
        onFocus,
        setSelectedIssueByKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad8de669773f4513$var$CardWithAnalytics, {
        issue: issueData,
        fieldSets: fieldSetsData ?? null,
        isFocused: isFocused,
        isSelected: isSelected,
        onFocus: onCardFocus,
        onBlur: onBlur
    });
};
const $ad8de669773f4513$var$CardWithAnalytics = ({ isFocused: isFocused, isSelected: isSelected, issue: issue, fieldSets: fieldSets, onFocus: onFocus, onBlur: onBlur })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cardRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (isSelected) {
            // Scroll to the card whenever it is selected and focus on it
            cardRef.current?.scrollIntoView && cardRef.current?.scrollIntoView({
                block: 'nearest'
            });
            isFocused && cardRef.current?.focus();
        }
    }, [
        isSelected,
        isFocused
    ]);
    const onClickWithAnalytics = (0, $eJOHy.useCallback)((event)=>{
        const id = issue ? $ad8de669773f4513$var$ISSUE_CARD_ANALYTICS_ID : $ad8de669773f4513$var$BLANK_CARD_ANALYTICS_ID;
        const attributes = {
            keyboardShortcut: false
        };
        if ((0, $eibCx.isNormalClick)(event)) {
            event.preventDefault();
            const analyticsEvent = createAnalyticsEvent({
                action: 'selected',
                actionSubject: 'card'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, id, attributes);
        } else {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'card'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, id, attributes);
        }
    }, [
        createAnalyticsEvent,
        issue
    ]);
    const onContextMenuHandler = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'contextMenu clicked',
            actionSubject: 'card'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, $ad8de669773f4513$var$ISSUE_CARD_ANALYTICS_ID, {
            keyboardShortcut: false
        });
    }, [
        createAnalyticsEvent
    ]);
    return issue == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hvJLL.default), {
        ref: cardRef,
        isSelected: isSelected,
        onClick: onClickWithAnalytics,
        onFocus: onFocus
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $42ws0.default), {
        ref: cardRef,
        issue: issue,
        fieldSets: fieldSets,
        onClick: onClickWithAnalytics,
        onFocus: onFocus,
        onBlur: onBlur,
        isSelected: isSelected,
        onContextMenu: onContextMenuHandler
    });
};
const $ad8de669773f4513$export$4683131014ccb7f3 = ()=>(0, $eJOHy.useState)(null);
const $ad8de669773f4513$var$CardList = ({ fragment: fragment, loading: loading, onNavigateToIssue: onNavigateToIssue, listRef: listRef })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START); // Analytics
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)(); // Main
    const [focusedIssueKey, setFocusedIssueKey] = $ad8de669773f4513$export$4683131014ccb7f3();
    const maxIssuesPerPage = (0, $iRahl.getMaxIssuesPerPage)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END);
    }, []);
    const fragmentData = (0, $j4oe4.useFragment)((0, $6APjZ.default), fragment);
    const onIssueChangeEvent = (0, $eJOHy.useCallback)((issueKey)=>{
        if (issueKey) setFocusedIssueKey(issueKey);
        const id = issueKey ? $ad8de669773f4513$var$ISSUE_CARD_ANALYTICS_ID : $ad8de669773f4513$var$BLANK_CARD_ANALYTICS_ID;
        const analyticsEvent = createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'card'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, id, {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        setFocusedIssueKey
    ]);
    const cards = (0, $eJOHy.useMemo)(()=>fragmentData?.edges?.map((edge)=>edge?.node && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad8de669773f4513$var$CardWithSelectedIssue, {
                key: edge.node.key,
                isFocused: edge.node.key === focusedIssueKey,
                issue: edge.node,
                fieldSets: edge.fieldSets ?? null,
                onFocus: setFocusedIssueKey,
                onBlur: ()=>setFocusedIssueKey(null)
            })) ?? [], [
        fragmentData?.edges,
        focusedIssueKey,
        setFocusedIssueKey
    ]);
    const focusedIssue = (0, $eJOHy.useMemo)(()=>{
        if ((0, $epTsa.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return fragmentData?.edges?.find((edge)=>edge?.node?.key === focusedIssueKey)?.node ?? null;
        return null;
    }, [
        focusedIssueKey,
        fragmentData?.edges
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad8de669773f4513$export$22a81bdd3a723b46, {
        "aria-label": formatMessage((0, $1Gp6c.default).issues)
    }, [
        ...Array(maxIssuesPerPage)
    ].map((__, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2nPlv.default), {
            key: index,
            issueIndex: index
        })));
    if (cards.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ahkvg.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3KwXP.default), {
        focusedIssueKey: focusedIssueKey,
        onIssueChangeEvent: onIssueChangeEvent,
        onNavigateToIssue: onNavigateToIssue,
        disableListControls: loading,
        focusedIssue: focusedIssue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad8de669773f4513$export$22a81bdd3a723b46, {
        ref: listRef,
        "aria-label": formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1Gp6c.default).issuesIssueTermRefresh : (0, $1Gp6c.default).issues)
    }, cards));
};
var $ad8de669773f4513$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $ad8de669773f4513$var$CardList;
const $ad8de669773f4513$export$22a81bdd3a723b46 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_qtt8glyw _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6APjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a6acacf6cc0f8c6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91a26a6ac2094feef90cf1527c78a5ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0a6acacf6cc0f8c6$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardList_fragment",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_Card_issue"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_CardWithSelectedIssue_issue"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "keyboardShortcuts_issueNavigator"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 500
                        }
                    ],
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_Card_fieldSets"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_CardWithSelectedIssue_fieldSets"
                        }
                    ],
                    "storageKey": "fieldSets(first:500)"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$0a6acacf6cc0f8c6$var$node.hash = "c325676a12fa6072040143369b5cb3e8";
var $0a6acacf6cc0f8c6$export$2e2bcd8739ae039 = $0a6acacf6cc0f8c6$var$node;

});

parcelRegister("g9uic", function(module, exports) {

$parcel$export(module.exports, "default", () => $f45cd9b9b4034919$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<624714bc7d64cade4aaede35e606ffae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f45cd9b9b4034919$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardWithSelectedIssue_fieldSets",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Card_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$f45cd9b9b4034919$var$node.hash = "5d80b931b560f2c418fca0d9f032c9a0";
var $f45cd9b9b4034919$export$2e2bcd8739ae039 = $f45cd9b9b4034919$var$node;

});

parcelRegister("eaCzE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2bfd8bb90c7ad49$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ef67c1b29917e04b29ae418c9bcc3e9d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2bfd8bb90c7ad49$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardWithSelectedIssue_issue",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Card_issue"
        }
    ],
    "type": "JiraIssue"
};
$a2bfd8bb90c7ad49$var$node.hash = "8eb4cdf2fd848d8fc193cb41d7f7d67f";
var $a2bfd8bb90c7ad49$export$2e2bcd8739ae039 = $a2bfd8bb90c7ad49$var$node;

});

parcelRegister("ahkvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8019a59b70b3caca$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gS02k = parcelRequire("gS02k");
const $8019a59b70b3caca$export$36d139f95680ab4e = ()=>// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8019a59b70b3caca$var$StyledContainer, {
        "data-testid": "issue-navigator.issue-results.detail-view.card-list.card-empty-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gS02k.default), null));
var $8019a59b70b3caca$export$2e2bcd8739ae039 = $8019a59b70b3caca$export$36d139f95680ab4e;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8019a59b70b3caca$var$StyledContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _4t3i1osq _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gS02k", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e6ac68d670762ec$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $epTsa = parcelRequire("epTsa");

var $7uL8m = parcelRequire("7uL8m");

var $kKCMK = parcelRequire("kKCMK");

var $idGBm = parcelRequire("idGBm");

var $6XJko = parcelRequire("6XJko");

var $a2bEL = parcelRequire("a2bEL");
const $9e6ac68d670762ec$export$f3f2e7ed2b6256b1 = ({ intl: { formatMessage: formatMessage } })=>{
    const noIssues = formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $a2bEL.default).noIssuesIssueTermRefresh : (0, $a2bEL.default).noIssues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9e6ac68d670762ec$var$ImageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKCMK.default), {
        alt: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9e6ac68d670762ec$var$ImageWrapperStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7uL8m.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, noIssues));
};
var /* eslint-disable-next-line jira/js/no-inject-intl-if-functional-component */ $9e6ac68d670762ec$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($9e6ac68d670762ec$export$f3f2e7ed2b6256b1);
const $9e6ac68d670762ec$var$ImageWrapperStylesOld = (0, $1DXK0.xcss)({
    height: '146px',
    width: '160px'
});
const $9e6ac68d670762ec$var$ImageWrapperStyles = (0, $1DXK0.xcss)({
    height: '165px',
    width: '150px'
});

});
parcelRegister("a2bEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d80e5c8b576dbb4b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d80e5c8b576dbb4b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noIssues: {
        "id": "issue-navigator.common.empty-list-icon.no-issues",
        "defaultMessage": "No issues were found matching your search"
    },
    noIssuesIssueTermRefresh: {
        "id": "issue-navigator.common.empty-list-icon.no-issues-issue-term-refresh",
        "defaultMessage": "There's nothing matching your search"
    }
});

});



parcelRegister("2nPlv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4961dd20e06734be$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $1NG86 = parcelRequire("1NG86");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $OrRUJ = parcelRequire("OrRUJ");

var $1vRb5 = parcelRequire("1vRb5");

var $7kd9e = parcelRequire("7kd9e");

var $ezozv = parcelRequire("ezozv");
const $4961dd20e06734be$var$shimmer = null;
// eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$SkeletonBackground = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasError: hasError, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_5sag126j _1o51q7pw _j7hq1en8 _1pglp3kn _bfhkh3tw _1itkwp5g _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.hasError ? "_tip8idpf" : "_tip812c5",
            __cmplp.className
        ])
    });
});
const $4961dd20e06734be$var$defaultIssueCardHeight = 97; // eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$SkeletonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1rbs _1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $4961dd20e06734be$var$IssueCardSkeleton = ({ hasError: hasError = false, issueIndex: issueIndex })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: (0, $6XJko.isVisualRefreshEnabled)() ? $4961dd20e06734be$var$ListItemStyle : $4961dd20e06734be$var$ListItemStyleOld,
        "aria-label": formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $7kd9e.default).issueLoadingLabelIssueTermRefresh : (0, $7kd9e.default).issueLoadingLabel, {
            number: issueIndex
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$CardContainer, {
        visualRefresh: (0, $6XJko.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$SkeletonBackground, {
        hasError: hasError,
        "data-component-selector": (0, $ezozv.skeletonBackgroundSelector)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$ColumnMask, {
        "data-component-selector": (0, $ezozv.columnMaskSelector)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$SummaryMask, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$TextLineMask, {
        fontSize: 20,
        lineHeight: 24,
        intrusion: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$TextLineMask, {
        fontSize: 20,
        lineHeight: 24,
        intrusion: 60
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$FooterMask, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$TypeMask, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$SeparatorMask, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$IssueKeyMask, null), hasError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$ErrorIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$BlankMask, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4961dd20e06734be$var$ErrorWrapper, {
        "data-component-selector": (0, $ezozv.errorWrapperSelector)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1vRb5.default), null)))));
};
var $4961dd20e06734be$export$2e2bcd8739ae039 = $4961dd20e06734be$var$IssueCardSkeleton;
const $4961dd20e06734be$var$ListItemStyleOld = (0, $1DXK0.xcss)({
    marginBlockStart: 'space.0'
});
const $4961dd20e06734be$var$ListItemStyle = (0, $1DXK0.xcss)({
    marginBlockStart: 'space.0',
    marginBlockEnd: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$CardContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $OrRUJ.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$ErrorWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cglyw _1bsb1osq _4cvr1h6o _18u0u2gc _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$ErrorIconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_bfhkvuon _16jlkb7n _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$BlankMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _bfhkvuon _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$SeparatorMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbftgi _bfhkvuon",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4961dd20e06734be$var$IssueKeyMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _4t3i1tcg _1bsb16xz",
            __cmplp.className
        ])
    });
});
const $4961dd20e06734be$var$TypeMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _4t3i1tcg _1bsb1tcg _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $4961dd20e06734be$var$TextLineMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { intrusion: intrusion, lineHeight: lineHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rjhebn": (0, $awdRS.default)(__cmplp.fontSize, "px"),
            "--_1oqupad": (0, $awdRS.default)(__cmplp.intrusion, "px"),
            "--_c633pi": (0, $awdRS.default)((__cmplp.lineHeight - __cmplp.fontSize) / 2, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1s7z87mc _x3do1cy7 _n7zl1cy7 _kqswh2mm _4t3i3gti",
            __cmplp.className
        ])
    });
});
const $4961dd20e06734be$var$FooterMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zlv4vr _x3do16sd _1e0c1txw _2lx2vrvc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $4961dd20e06734be$var$SummaryMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zl15mc",
            __cmplp.className
        ])
    });
});
const $4961dd20e06734be$var$ColumnMask = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kl715mc _1s7z15mc _kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("OrRUJ", function(module, exports) {

$parcel$export(module.exports, "CardBaseStyle", () => $1893a6410747b475$export$d10d52f6c0613cc3);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $3LCex = parcelRequire("3LCex");
const $1893a6410747b475$var$backgroundColorSelected = "var(--ds-background-selected, #E9F2FF)";
const $1893a6410747b475$var$backgroundColor = "var(--ds-surface-raised, #FFFFFF)";
const $1893a6410747b475$var$borderColor = "var(--ds-border, #091E4224)";
const $1893a6410747b475$var$boxShadowColor = `1px 0px ${"var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"}`;
const $1893a6410747b475$export$d10d52f6c0613cc3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1vy64tb": (0, $awdRS.default)(__cmplp.isSelected ? "var(--ds-background-accent-blue-subtlest, #E9F2FF)" : "var(--ds-surface-raised, #FFFFFF)"),
            "--_11cvo1a": (0, $awdRS.default)(__cmplp.isSelected ? $1893a6410747b475$var$backgroundColorSelected : $1893a6410747b475$var$backgroundColor)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1yt4u2gc _1e0c1ule _vchhusvi _1a3b18uv _4fprglyw _5goinqa1 _nt751r31 _49pcglyw _1hvw1o36 _7ehiytyo _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.visualRefresh ? "_2rko12b0 _18s8v77o _1yt4utpp _16qszucj _bfhk1sss" : "_x3doidpf _n7zlzgxb _1kl7zgxb _bfhk2rqg _1jc11j8p _14t0zgxb _e6md1se7 _13jwelmp _1tzh1y44",
            __cmplp.className
        ])
    });
});
const $1893a6410747b475$export$b15a6cf2987e4b39 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $3LCex.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1vRb5", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcbea75727fe8bd3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $epTsa = parcelRequire("epTsa");

var $idGBm = parcelRequire("idGBm");

var $iMWU7 = parcelRequire("iMWU7");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-empty-styled-expression
const $fcbea75727fe8bd3$var$InfoMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.className
        ])
    });
});
const $fcbea75727fe8bd3$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1kw7 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
class $fcbea75727fe8bd3$export$e8132eb38e030ec6 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onResetErrors: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fcbea75727fe8bd3$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fcbea75727fe8bd3$var$InfoMessage, null, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iMWU7.default).infoTextIssueTermRefresh : (0, $iMWU7.default).infoText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "link",
            onClick: this.onReloadIssueClick,
            spacing: "none"
        }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iMWU7.default).reloadIssueIssueTermRefresh : (0, $iMWU7.default).reloadIssue)));
    }
    constructor(...args){
        super(...args), // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onReloadIssueClick = (...attrs)=>{
            const analyticsEvent = attrs.pop();
            this.props.onResetErrors(analyticsEvent);
        };
    }
}
var $fcbea75727fe8bd3$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($fcbea75727fe8bd3$export$e8132eb38e030ec6);

});
parcelRegister("iMWU7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bd31243763fa77e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2bd31243763fa77e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    infoText: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.info-text",
        "defaultMessage": "We couldn't load this issue."
    },
    reloadIssue: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.reload-issue",
        "defaultMessage": "Reload issue"
    },
    infoTextIssueTermRefresh: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.info-text-issue-term-refresh",
        "defaultMessage": "We couldn't load this work item."
    },
    reloadIssueIssueTermRefresh: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.reload-issue-issue-term-refresh",
        "defaultMessage": "Reload work item"
    }
});

});


parcelRegister("7kd9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $8839731a5f0f0b99$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8839731a5f0f0b99$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    issueLoadingLabel: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card-skeleton.issue-loading-label",
        "defaultMessage": "Issue card {number} loading"
    },
    issueLoadingLabelIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card-skeleton.issue-loading-label-issue-term-refresh",
        "defaultMessage": "Work item card {number} loading"
    }
});

});

parcelRegister("ezozv", function(module, exports) {

$parcel$export(module.exports, "errorWrapperSelector", () => $d2d6f5b7a758abdd$export$a03455d77d6a4ea);
$parcel$export(module.exports, "skeletonBackgroundSelector", () => $d2d6f5b7a758abdd$export$85fe8f1edff78b98);
$parcel$export(module.exports, "columnMaskSelector", () => $d2d6f5b7a758abdd$export$67b279fb398d016e);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $d2d6f5b7a758abdd$var$defaultIssueCardHeight = 97;
const $d2d6f5b7a758abdd$export$66b8cea0c448285 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1rbs _1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$var$shimmer = null;
const $d2d6f5b7a758abdd$export$c3b0ebed856b8b1a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasError: hasError, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_5sag126j _1o51q7pw _j7hq1en8 _1pglp3kn _bfhkh3tw _1itkwp5g _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.hasError ? "_tip8idpf" : "_tip812c5",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$439b7c87164a9b43 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kl715mc _1s7z15mc _kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$792e72b41c80f830 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zl15mc",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$ab3fe3ddc5c7354f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zlv4vr _x3do16sd _1e0c1txw _2lx2vrvc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$f3e0fd2d5209f88b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { intrusion: intrusion, lineHeight: lineHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rjhebn": (0, $awdRS.default)(__cmplp.fontSize, "px"),
            "--_1oqupad": (0, $awdRS.default)(__cmplp.intrusion, "px"),
            "--_c633pi": (0, $awdRS.default)((__cmplp.lineHeight - __cmplp.fontSize) / 2, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1s7z87mc _x3do1cy7 _n7zl1cy7 _kqswh2mm _4t3i3gti",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$59d16c2cd3bc3a2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _4t3i1tcg _1bsb1tcg _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$ca1c048394ed3dbb = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _4t3i1tcg _1bsb16xz",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$bdc7d72765b181c3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbftgi _bfhkvuon",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$a1b9063b4cbc0844 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _bfhkvuon _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$90993d2d9550d725 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_bfhkvuon _16jlkb7n _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$bb27b7e39840238f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cglyw _1bsb1osq _4cvr1h6o _18u0u2gc _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $d2d6f5b7a758abdd$export$a03455d77d6a4ea = 'jira-issue-navigator-card-skeleton-error-wrapper';
const $d2d6f5b7a758abdd$export$85fe8f1edff78b98 = 'jira-issue-navigator-card-skeleton-skeleton-background';
const $d2d6f5b7a758abdd$export$67b279fb398d016e = 'jira-issue-navigator-card-skeleton-column-mask';

});


parcelRegister("hvJLL", function(module, exports) {

$parcel$export(module.exports, "default", () => $295f831da4c8a82d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $iqtgH = parcelRequire("iqtgH");

var $6XJko = parcelRequire("6XJko");

var $OrRUJ = parcelRequire("OrRUJ");

var $jGquF = parcelRequire("jGquF");
const $295f831da4c8a82d$var$EmptyCard = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isSelected: isSelected = false, onClick: onClick, onFocus: onFocus }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: $295f831da4c8a82d$var$ListItemStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($295f831da4c8a82d$var$EmptyCardContainer, {
        tabIndex: isSelected ? 0 : -1,
        ref: ref ?? undefined,
        isSelected: isSelected,
        onClick: onClick,
        href: "#",
        onFocus: onFocus,
        visualRefresh: (0, $6XJko.isVisualRefreshEnabled)()
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jGquF.default).emptyCardTextIssueTermRefresh : (0, $jGquF.default).emptyCardText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "blankIssue"
    })));
});
var $295f831da4c8a82d$export$2e2bcd8739ae039 = $295f831da4c8a82d$var$EmptyCard;
const $295f831da4c8a82d$var$textColorActiveState = "var(--ds-text-selected, #0C66E4)";
const $295f831da4c8a82d$var$textColor = "var(--ds-text, #172B4D)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $295f831da4c8a82d$var$EmptyCardContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $OrRUJ.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _80omtlke",
            __cmplp.isSelected ? "_syazaqb7" : "_syaz1fxt",
            __cmplp.isSelected ? "_f8pjaqb7 _30l3aqb7" : "_f8pj1fxt _30l31fxt",
            __cmplp.className
        ])
    });
});
const $295f831da4c8a82d$var$ListItemStyle = (0, $1DXK0.xcss)({
    marginBlockStart: 'space.0'
});

});
parcelRegister("jGquF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d48f93b7036221$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f6d48f93b7036221$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    blankText: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.blank-text",
        "defaultMessage": "We can't display this issue"
    },
    emptyCardText: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.empty-card-text",
        "defaultMessage": "This issue cannot be opened because it may have been deleted or you do not have access to it"
    },
    tooltip: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.tooltip",
        "defaultMessage": "Either this issue has been deleted, or you don\u2019t have access to it."
    },
    blankTextIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.blank-text-issue-term-refresh",
        "defaultMessage": "We can't display this work item"
    },
    emptyCardTextIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.empty-card-text-issue-term-refresh",
        "defaultMessage": "This work item cannot be opened because it may have been deleted or you do not have access to it"
    },
    tooltipIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.tooltip-issue-term-refresh",
        "defaultMessage": "Either this work item has been deleted, or you don\u2019t have access to it."
    }
});

});


parcelRegister("42ws0", function(module, exports) {

$parcel$export(module.exports, "default", () => $763439f866532d4e$export$2e2bcd8739ae039);

var $2qOcf = parcelRequire("2qOcf");

var $lnecm = parcelRequire("lnecm");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $ljej9 = parcelRequire("ljej9");

var $6XJko = parcelRequire("6XJko");

var $OrRUJ = parcelRequire("OrRUJ");

var $2xt4x = parcelRequire("2xt4x");
const $763439f866532d4e$var$backgroundColorSelected = "var(--ds-background-selected, #E9F2FF)";
const $763439f866532d4e$var$backgroundColorHovered = "var(--ds-background-neutral-subtle-hovered, #091E420F)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $763439f866532d4e$var$StyledListElement = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf",
            __cmplp.visualRefresh && "_otyr1b66",
            __cmplp.className
        ])
    });
});
const $763439f866532d4e$export$1d41361302b577a1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $OrRUJ.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _f8pj1kw7 _30l31kw7",
            __cmplp.isSelected ? "_syazaqb7" : "_syaz1kw7",
            __cmplp.isSelected ? "_irr3fg4m" : "_irr3166n",
            __cmplp.className
        ])
    });
});
const $763439f866532d4e$export$c3fc4c88db352deb = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_slp31hna _1i4q1hna _1nmz1hna",
            __cmplp.visualRefresh ? "_otyru2gc" : "_otyr1b66",
            __cmplp.className
        ])
    });
});
const $763439f866532d4e$var$Card = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ style: style, onMounted: onMounted, onClick: onClick, onFocus: onFocus, onBlur: onBlur, issue: issue, fieldSets: fieldSetsFragment, isSelected: isSelected, onContextMenu: onContextMenu }, ref)=>{
    const fragmentData = (0, $j4oe4.useFragment)((0, $lnecm.default), issue);
    const fieldSets = fieldSetsFragment;
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $2qOcf.default), fieldSets);
    const issueKey = fragmentData.key;
    (0, $eJOHy.useEffect)(()=>{
        onMounted && onMounted();
    }, [
        onMounted
    ]);
    const fieldEdges = fieldSetsData?.edges ?? null;
    const summary = (0, $2xt4x.byFieldId)(fieldEdges, 'summary', (summaryEdge)=>summaryEdge?.node?.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($763439f866532d4e$var$StyledListElement, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card.list-item",
        visualRefresh: (0, $6XJko.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($763439f866532d4e$export$1d41361302b577a1 // @ts-expect-error incorrect ref type
    , {
        ref: ref ?? undefined,
        onContextMenu: onContextMenu,
        isSelected: isSelected,
        onBlur: onBlur,
        tabIndex: isSelected ? 0 : -1,
        onClick: onClick,
        onFocus: onFocus,
        style: style,
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card",
        href: `/browse/${issueKey}`,
        visualRefresh: (0, $6XJko.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($763439f866532d4e$export$c3fc4c88db352deb, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card.summary",
        visualRefresh: (0, $6XJko.isVisualRefreshEnabled)()
    }, summary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2xt4x.Footer), {
        issueKey: (0, $ljej9.toIssueKey)(issueKey),
        isResolved: fragmentData.isResolved,
        fieldSets: fieldSetsData ?? null,
        isSelected: isSelected
    })));
});
var $763439f866532d4e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($763439f866532d4e$var$Card);

});
parcelRegister("2qOcf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63faf5f4e31796f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<665198baf0f9c2c411158353f00d7520>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b63faf5f4e31796f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Card_fieldSets",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "footer_issueNavigator_FooterInternal"
        },
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "text"
                                                        }
                                                    ],
                                                    "type": "JiraSingleLineTextField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$b63faf5f4e31796f$var$node.hash = "606cafbbef903d4ec28da2ea50226fe2";
var $b63faf5f4e31796f$export$2e2bcd8739ae039 = $b63faf5f4e31796f$var$node;

});

parcelRegister("lnecm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bd68cb7df2182d3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9095b5dd69b4238d53bbc2293313a78a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3bd68cb7df2182d3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Card_issue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "ScalarField",
            "name": "isResolved"
        }
    ],
    "type": "JiraIssue"
};
$3bd68cb7df2182d3$var$node.hash = "e3f34b125801c49c601cb9bbb61a7a14";
var $3bd68cb7df2182d3$export$2e2bcd8739ae039 = $3bd68cb7df2182d3$var$node;

});

parcelRegister("2xt4x", function(module, exports) {

$parcel$export(module.exports, "byFieldId", () => $3bf34cae533b6687$export$7a6e1e67b4eca178);
$parcel$export(module.exports, "Footer", () => $3bf34cae533b6687$export$a06f1c675e846f6f);

var $lwie7 = parcelRequire("lwie7");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $5DgXR = parcelRequire("5DgXR");

var $k71qx = parcelRequire("k71qx");

var $9cbmy = parcelRequire("9cbmy");

var $7keuM = parcelRequire("7keuM");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $jCEKQ = parcelRequire("jCEKQ");

var $6XJko = parcelRequire("6XJko");

var $eibCx = parcelRequire("eibCx");

var $aIyl4 = parcelRequire("aIyl4");
const $3bf34cae533b6687$export$7a6e1e67b4eca178 = (edges, fieldId, mapperFn)=>edges?.map((edge)=>edge?.node?.fields?.edges?.[0]).filter((edge)=>edge?.node?.fieldId === fieldId).filter((0, $eibCx.isNonNullish)).map(mapperFn)[0];
const $3bf34cae533b6687$var$FooterInternal = ({ issueKey: issueKey, isResolved: isResolvedProp, isSelected: isSelected, fieldSets: fieldSets })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const fieldSetsData = (0, $j4oe4.useFragment)((0, $lwie7.default), fieldSets);
    const fieldSetEdges = fieldSetsData?.edges;
    const assignee = $3bf34cae533b6687$export$7a6e1e67b4eca178(fieldSetEdges, 'assignee', (assigneeEdge)=>assigneeEdge?.node?.user);
    const issueType = $3bf34cae533b6687$export$7a6e1e67b4eca178(fieldSetEdges, 'issuetype', (issueTypeEdge)=>issueTypeEdge?.node?.issueType);
    const statusCategoryId = $3bf34cae533b6687$export$7a6e1e67b4eca178(fieldSetEdges, 'statusCategory', (statusCategoryEdge)=>statusCategoryEdge?.node?.statusCategory?.statusCategoryId);
    const isResolved = (0, $jCEKQ.shouldDisplayStrikethrough)(isResolvedProp ?? undefined, (0, $7keuM.statusCategoryForId)(statusCategoryId));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3bf34cae533b6687$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3bf34cae533b6687$var$TypeIcon, {
        src: issueType?.avatar?.small ?? undefined,
        alt: issueType?.name ?? undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3bf34cae533b6687$export$263c092b561e7355, {
        isSelected: isSelected,
        isResolved: isResolved,
        isVisualRefresh: (0, $6XJko.isVisualRefreshEnabled)()
    }, issueKey, isResolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), {
        role: "status"
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $aIyl4.default).screenReaderFooterKeyResolvedIssueTermRefresh : (0, $aIyl4.default).screenReaderFooterKeyResolved, {
        issueKey: issueKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3bf34cae533b6687$var$AvatarStyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: assignee?.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        src: assignee?.picture,
        name: assignee?.name,
        size: "small"
    }))));
};
const $3bf34cae533b6687$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $eJOHy.memo)($3bf34cae533b6687$var$FooterInternal); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bf34cae533b6687$var$StyledContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bf34cae533b6687$var$TypeIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkolb4i _1bsb7vkz _4t3i7vkz _2hwx1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3bf34cae533b6687$var$AvatarStyledContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1f4h _19bvu2gc _18u01wug _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3bf34cae533b6687$export$263c092b561e7355 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefresh: isVisualRefresh, isSelected: isSelected, isResolved: isResolved, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _kqswh2mm",
            __cmplp.isVisualRefresh ? "_k48p1wq8" : "_k48pmoej",
            __cmplp.isSelected ? "_syazaqb7" : __cmplp.isVisualRefresh ? "_syaz1gjq" : "_syaz1fxt",
            __cmplp.isResolved ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lwie7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1935f21e297d0bb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<54d5e2050f16aa77b0b95c4ea04b0425>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b1935f21e297d0bb$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "footer_issueNavigator_FooterInternal",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "text"
                                                            }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            v1 /*: any*/ ,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "picture"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "small"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusCategoryId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusCategoryField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$b1935f21e297d0bb$var$node.hash = "80bd71836423cbf18b560dfc0418dc69";
var $b1935f21e297d0bb$export$2e2bcd8739ae039 = $b1935f21e297d0bb$var$node;

});

parcelRegister("7keuM", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e9fafd5bde6d9f47$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e9fafd5bde6d9f47$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e9fafd5bde6d9f47$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e9fafd5bde6d9f47$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e9fafd5bde6d9f47$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e9fafd5bde6d9f47$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e9fafd5bde6d9f47$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e9fafd5bde6d9f47$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e9fafd5bde6d9f47$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e9fafd5bde6d9f47$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e9fafd5bde6d9f47$export$d928f247c903643a);
const $e9fafd5bde6d9f47$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e9fafd5bde6d9f47$export$aa456a5030160740 = 'TODO';
const $e9fafd5bde6d9f47$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e9fafd5bde6d9f47$export$71efb3495f6084f2 = 'DONE';
const $e9fafd5bde6d9f47$export$d9119300f9d9a815 = [
    $e9fafd5bde6d9f47$export$6db089fe7b26f5b6,
    $e9fafd5bde6d9f47$export$aa456a5030160740,
    $e9fafd5bde6d9f47$export$5a9ac66c2785cc13,
    $e9fafd5bde6d9f47$export$71efb3495f6084f2
];
const $e9fafd5bde6d9f47$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e9fafd5bde6d9f47$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e9fafd5bde6d9f47$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e9fafd5bde6d9f47$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e9fafd5bde6d9f47$export$71efb3495f6084f2
    }
];
const $e9fafd5bde6d9f47$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e9fafd5bde6d9f47$export$3f42f49c284d5b58 = Object.freeze({
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.NEW]: 2,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.DONE]: 3,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e9fafd5bde6d9f47$export$f3f919dc0f56d9eb = Object.values($e9fafd5bde6d9f47$export$5d42a08d46cffe7);
const $e9fafd5bde6d9f47$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e9fafd5bde6d9f47$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e9fafd5bde6d9f47$export$6db089fe7b26f5b6;
};
const $e9fafd5bde6d9f47$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e9fafd5bde6d9f47$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e9fafd5bde6d9f47$export$d928f247c903643a = (key)=>$e9fafd5bde6d9f47$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});

parcelRegister("jCEKQ", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayStrikethrough", () => $71a3d2c694c5502c$export$1e1e848245d3a6f7);

var $7keuM = parcelRequire("7keuM");
const { DONE: $71a3d2c694c5502c$var$DONE } = (0, $7keuM);
const $71a3d2c694c5502c$export$1e1e848245d3a6f7 = (isResolved, statusCategory)=>{
    if (isResolved !== undefined) return isResolved;
    // In JSW, the strikethrough must now only depend on resolution. However we have to keep
    // this logic because there is a consumer of issue-line-card in JSM that displays
    // the strikethrough based on status src/packages/servicedesk/post-incident-review/src/ui/primary-incident/index.tsx
    return statusCategory === $71a3d2c694c5502c$var$DONE;
};

});

parcelRegister("aIyl4", function(module, exports) {

$parcel$export(module.exports, "default", () => $559b2086345b8bef$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $559b2086345b8bef$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    screenReaderFooterKeyResolved: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-resolved",
        "defaultMessage": "Resolved issue: {issueKey}"
    },
    screenReaderFooterKeyDone: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-done",
        "defaultMessage": "Done issue: {issueKey}"
    },
    screenReaderFooterKeyResolvedIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-resolved-issue-term-refresh",
        "defaultMessage": "Resolved issue: {issueKey}"
    },
    screenReaderFooterKeyDoneIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-done-issue-term-refresh",
        "defaultMessage": "Done work item: {issueKey}"
    }
});

});



parcelRegister("3KwXP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec36b011b8ea78a$export$2e2bcd8739ae039);

var $bRUMm = parcelRequire("bRUMm");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3IF6p = parcelRequire("3IF6p");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $ljej9 = parcelRequire("ljej9");

var $91UnK = parcelRequire("91UnK");

var $1wL9i = parcelRequire("1wL9i");

var $hKTLi = parcelRequire("hKTLi");
const $6ec36b011b8ea78a$var$useUpdatingRef = (value)=>{
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
};
const $6ec36b011b8ea78a$var$KeyboardShortcuts = (props)=>{
    const issueData = (0, $j4oe4.useFragment)((0, $bRUMm.default), props.focusedIssue);
    const workType = issueData?.issueTypeField?.issueType?.name;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const propsRef = $6ec36b011b8ea78a$var$useUpdatingRef(props);
    const openStateRef = $6ec36b011b8ea78a$var$useUpdatingRef((0, $91UnK.useOrderByOpenState)());
    const selectedIssueKey = (0, $1wL9i.useSelectedIssueKey)();
    const selectedIssueKeyRef = $6ec36b011b8ea78a$var$useUpdatingRef(selectedIssueKey);
    const { selectNextIssue: selectNextIssue, selectPreviousIssue: selectPreviousIssue } = (0, $1wL9i.useSelectedIssueActions)();
    const nextIssueKey = (0, $1wL9i.useNextIssueKey)() ?? (0, $ljej9.toIssueKey)('');
    const nextIssueKeyRef = (0, $eJOHy.useRef)(nextIssueKey);
    nextIssueKeyRef.current = nextIssueKey;
    const handleNext = (0, $eJOHy.useCallback)(()=>{
        const { onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
        if (selectNextIssue(true)) onIssueChangeEvent && onIssueChangeEvent(nextIssueKeyRef.current);
    // Dependencies must be stable as downstream useMemo has an empty dependencies array
    }, [
        propsRef,
        selectNextIssue
    ]);
    const previousIssueKey = (0, $1wL9i.usePreviousIssueKey)() ?? (0, $ljej9.toIssueKey)('');
    const previousIssueKeyRef = (0, $eJOHy.useRef)(previousIssueKey);
    previousIssueKeyRef.current = previousIssueKey;
    const handlePrevious = (0, $eJOHy.useCallback)(()=>{
        const { onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
        if (selectPreviousIssue(true)) onIssueChangeEvent && onIssueChangeEvent(previousIssueKeyRef.current);
    // Dependencies must be stable as downstream useMemo has an empty dependencies array
    }, [
        propsRef,
        selectPreviousIssue
    ]);
    const openIssueFullScreenMessage = (()=>{
        if (workType && (0, $epTsa.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $hKTLi.default).openIssueFullScreenIssueTerminologyRefreshM4, {
            workType: workType
        });
        return formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hKTLi.default).openIssueFullScreenIssueTermRefresh : (0, $hKTLi.default).openIssueFullScreen);
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3IF6p.default), {
        keyMap: (0, $eJOHy.useMemo)(()=>({
                j: {
                    callback: ()=>{
                        const { disableListControls: disableListControls } = propsRef.current;
                        if (disableListControls === true) return;
                        // handleNext needs to be a stable function references as useMemo has an empty dependencies array
                        handleNext();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hKTLi.default).nextIssueIssueTermRefresh : (0, $hKTLi.default).nextIssue))
                },
                k: {
                    callback: ()=>{
                        const { disableListControls: disableListControls } = propsRef.current;
                        if (disableListControls === true) return;
                        // handlePrevious needs to be a stable function references as useMemo has an empty dependencies array
                        handlePrevious();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hKTLi.default).previousIssueIssueTermRefresh : (0, $hKTLi.default).previousIssue))
                },
                y: {
                    callback: ()=>{
                        const [{ isOpen: isOpen }, { open: open, close: close }] = openStateRef.current;
                        isOpen ? close() : open();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, formatMessage((0, $hKTLi.default).displaySortFields))
                },
                z: {
                    callback: ()=>{
                        if (selectedIssueKeyRef.current) propsRef.current.onNavigateToIssue(selectedIssueKeyRef.current);
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, openIssueFullScreenMessage)
                },
                arrowup: {
                    callback: ()=>{
                        const { disableListControls: disableListControls, focusedIssueKey: focusedIssueKey } = propsRef.current;
                        if (disableListControls === true) return;
                        const isSelectedIssueFocused = focusedIssueKey !== null && focusedIssueKey === selectedIssueKeyRef.current;
                        if (isSelectedIssueFocused) handlePrevious();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hKTLi.default).previousIssueIssueTermRefresh : (0, $hKTLi.default).previousIssue))
                },
                arrowdown: {
                    callback: ()=>{
                        const { disableListControls: disableListControls, focusedIssueKey: focusedIssueKey } = propsRef.current;
                        if (disableListControls === true) return;
                        const isSelectedIssueFocused = focusedIssueKey !== null && focusedIssueKey === selectedIssueKeyRef.current;
                        if (isSelectedIssueFocused) handleNext();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hKTLi.default).nextIssueIssueTermRefresh : (0, $hKTLi.default).nextIssue))
                }
            }), [] // eslint-disable-line react-hooks/exhaustive-deps
        )
    });
};
$6ec36b011b8ea78a$var$KeyboardShortcuts.defaultProps = {
    disableListControls: false
};
var $6ec36b011b8ea78a$export$2e2bcd8739ae039 = $6ec36b011b8ea78a$var$KeyboardShortcuts;

});
parcelRegister("bRUMm", function(module, exports) {

$parcel$export(module.exports, "default", () => $6919b643ced36278$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2314afbcde7d8980ae1e76ca96f70867>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6919b643ced36278$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "keyboardShortcuts_issueNavigator",
    "selections": [
        {
            "concreteType": "JiraIssueTypeField",
            "kind": "LinkedField",
            "name": "issueTypeField",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$6919b643ced36278$var$node.hash = "b6db91587551c3c9c628860986b56a99";
var $6919b643ced36278$export$2e2bcd8739ae039 = $6919b643ced36278$var$node;

});

parcelRegister("hKTLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ce29e05b5c8244f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9ce29e05b5c8244f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    nextIssue: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.next-issue",
        "defaultMessage": "Next issue"
    },
    previousIssue: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.previous-issue",
        "defaultMessage": "Previous issue"
    },
    displaySortFields: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.display-sort-fields",
        "defaultMessage": "Detail view order by"
    },
    openIssueFullScreen: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.open-issue-full-screen",
        "defaultMessage": "Open issue fullscreen"
    },
    nextIssueIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.next-issue-issue-term-refresh",
        "defaultMessage": "Next work item"
    },
    previousIssueIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.previous-issue-issue-term-refresh",
        "defaultMessage": "Previous work item"
    },
    openIssueFullScreenIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.open-issue-full-screen-issue-term-refresh",
        "defaultMessage": "Open the work item in fullscreen"
    },
    openIssueFullScreenIssueTerminologyRefreshM4: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.open-issue-full-screen-issue-terminology-refresh-m4",
        "defaultMessage": "Open the {workType} in fullscreen"
    }
});

});


parcelRegister("1Gp6c", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc3de5d2e75e68e6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bc3de5d2e75e68e6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    issues: {
        "id": "issue-navigator.issue-results.detail-view.card-list.issues",
        "defaultMessage": "Issues"
    },
    issuesIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.issues-issue-term-refresh",
        "defaultMessage": "Work items"
    }
});

});



parcelRegister("gNBTz", function(module, exports) {

$parcel$export(module.exports, "default", () => $17d1e620d8155487$export$2e2bcd8739ae039);
$parcel$export(module.exports, "RecoverableErrorViewBoundary", () => $17d1e620d8155487$export$d42c1f6e3e564ee9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $ljT8M = parcelRequire("ljT8M");

var $7uL8m = parcelRequire("7uL8m");

var $kKCMK = parcelRequire("kKCMK");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");

var $6XJko = parcelRequire("6XJko");

var $3kDjB = parcelRequire("3kDjB");

var $3wQlR = parcelRequire("3wQlR");
const $17d1e620d8155487$var$ErrorView = ({ onCaughtIssueSearchError: onCaughtIssueSearchError, error: errorProp })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { refresh: refresh } = (0, $3kDjB.useIssueSearchActions)();
    const onClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent.clone(), 'refreshFromError');
        refresh();
    }, [
        refresh
    ]);
    const error = (0, $eJOHy.useMemo)(()=>errorProp || new Error('There was an error searching for issues'), [
        errorProp
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        onCaughtIssueSearchError && onCaughtIssueSearchError(error);
    }, [
        onCaughtIssueSearchError,
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($17d1e620d8155487$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $3wQlR.default).emptyStateErrorHeader),
        description: formatMessage((0, $3wQlR.default).emptyStateErrorDescription),
        testId: "issue-navigator.ui.issue-results.error-view.error-message",
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            onClick: onClick
        }, formatMessage((0, $3wQlR.default).emptyStateErrorAction)),
        renderImage: ()=>(0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $17d1e620d8155487$var$ImageWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKCMK.default), {
                alt: ""
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $17d1e620d8155487$var$ImageWrapperStylesOld
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7uL8m.default), {
                alt: ""
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "screen",
        actionSubjectId: "issueSearchError"
    }));
};
var $17d1e620d8155487$export$2e2bcd8739ae039 = $17d1e620d8155487$var$ErrorView;
const $17d1e620d8155487$export$d42c1f6e3e564ee9 = (0, $ljT8M.withRecoverableErrorBoundary)(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children), {
    recoveryProp: 'recoveryProp',
    Fallback: $17d1e620d8155487$var$ErrorView
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $17d1e620d8155487$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jlkb7n _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $17d1e620d8155487$var$ImageWrapperStylesOld = (0, $1DXK0.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});
const $17d1e620d8155487$var$ImageWrapperStyles = (0, $1DXK0.xcss)({
    maxHeight: '165px',
    maxWidth: '150px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("3wQlR", function(module, exports) {

$parcel$export(module.exports, "default", () => $faa7481be7905ff9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $faa7481be7905ff9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyStateErrorHeader: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-header",
        "defaultMessage": "We couldn\u2019t load your search results"
    },
    emptyStateErrorDescription: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-description",
        "defaultMessage": "Refresh to try again."
    },
    emptyStateErrorAction: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-action",
        "defaultMessage": "Refresh"
    }
});

});


parcelRegister("bR878", function(module, exports) {

$parcel$export(module.exports, "default", () => $a32fd0fc63cfc134$export$2e2bcd8739ae039);

var $6hWjd = parcelRequire("6hWjd");

var $9bfTw = parcelRequire("9bfTw");

var $iLkfp = parcelRequire("iLkfp");

var $dBeX4 = parcelRequire("dBeX4");

var $6XBm8 = parcelRequire("6XBm8");

var $8YROZ = parcelRequire("8YROZ");

var $8eIYq = parcelRequire("8eIYq");

var $bHpMU = parcelRequire("bHpMU");

var $edff2 = parcelRequire("edff2");

var $2uPxJ = parcelRequire("2uPxJ");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $j4oe4 = parcelRequire("j4oe4");

var $6TdgS = parcelRequire("6TdgS");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $gYnSx = parcelRequire("gYnSx");

var $g8Az8 = parcelRequire("g8Az8");

var $epTsa = parcelRequire("epTsa");

var $bILK0 = parcelRequire("bILK0");

var $3aisD = parcelRequire("3aisD");

var $cTddL = parcelRequire("cTddL");

var $awWeA = parcelRequire("awWeA");

var $d8Dow = parcelRequire("d8Dow");

var $8jOO7 = parcelRequire("8jOO7");

var $P01So = parcelRequire("P01So");

var $9Z7uc = parcelRequire("9Z7uc");

var $aJqsk = parcelRequire("aJqsk");

var $j6nGi = parcelRequire("j6nGi");

var $6zXPf = parcelRequire("6zXPf");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $kEUB1 = parcelRequire("kEUB1");

var $cECwI = parcelRequire("cECwI");

var $4Oene = parcelRequire("4Oene");

var $7jTnu = parcelRequire("7jTnu");

var $aaLZH = parcelRequire("aaLZH");

var $iRahl = parcelRequire("iRahl");

var $2UTIe = parcelRequire("2UTIe");

var $eibCx = parcelRequire("eibCx");

var $fAgUF = parcelRequire("fAgUF");

var $7auhX = parcelRequire("7auhX");

var $gTm2i = parcelRequire("gTm2i");

var $1wL9i = parcelRequire("1wL9i");

var $HiS1C = parcelRequire("HiS1C");

var $dTsrC = parcelRequire("dTsrC");

var $fwKw5 = parcelRequire("fwKw5");

var $kGfUm = parcelRequire("kGfUm");

var $7emTO = parcelRequire("7emTO");

var $3kDjB = parcelRequire("3kDjB");

var $i99kJ = parcelRequire("i99kJ");

var $4ciTX = parcelRequire("4ciTX");

var $iZH8P = parcelRequire("iZH8P");

var $i5UAP = parcelRequire("i5UAP");

var $fOH9z = parcelRequire("fOH9z");

var $b2VjA = parcelRequire("b2VjA");

var $kg3EI = parcelRequire("kg3EI");

var $ghzkC = parcelRequire("ghzkC");

var $2PY5Q = parcelRequire("2PY5Q");

var $fwdeI = parcelRequire("fwdeI");

var $jOc90 = parcelRequire("jOc90");

var $aaQkY = parcelRequire("aaQkY");
const $a32fd0fc63cfc134$var$reorderColumnsErrorFlag = {
    type: 'error',
    title: (0, $kg3EI.default).reorderColumnsErrorTitle,
    description: (0, $kg3EI.default).columnConfigMutationErrorDescription,
    isAutoDismiss: true,
    messageId: 'issue-navigator.ui.issue-results.list-view.reorder-columns-error-flag.error',
    messageType: 'transactional'
};
const $a32fd0fc63cfc134$var$resetColumnsErrorFlag = {
    type: 'error',
    title: (0, $kg3EI.default).resetColumnsErrorTitle,
    description: (0, $kg3EI.default).columnConfigMutationErrorDescription,
    isAutoDismiss: true,
    messageId: 'issue-navigator.ui.issue-results.list-view.reset-columns-error-flag.error',
    messageType: 'transactional'
};
const $a32fd0fc63cfc134$var$TableContainer = ({ children: children })=>(0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a32fd0fc63cfc134$var$TableContainerStyles
    }, children) : children;
const $a32fd0fc63cfc134$export$b4f6a715a9e57e85 = ()=>{
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const { isFilterEditable: isFilterEditable } = (0, $fwKw5.useActiveJql)();
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const { isLoading: isLoading } = (0, $7auhX.useColumnPickerLoadingContext)();
    return !isAnonymous && (!(0, $eibCx.isFilterViewId)(view) || isFilterEditable === true) && !isLoading;
};
const $a32fd0fc63cfc134$export$539ae4acd804b244 = (onRestoreDefaultColumns, hasDefaultFieldSets, viewdataId)=>{
    const { isFilterEditable: isFilterEditable } = (0, $fwKw5.useActiveJql)();
    const [{ view: selectedView }] = (0, $HiS1C.useSelectedViewState)();
    if ((0, $7jTnu.fg)('jira_inline_field_config_gate')) return !((0, $eibCx.isFilterViewId)(selectedView) && isFilterEditable === false) && hasDefaultFieldSets === false && // check that the view id from state and store is the same
    viewdataId === selectedView ? onRestoreDefaultColumns : undefined;
    return !((0, $eibCx.isFilterViewId)(selectedView) && isFilterEditable === false) && hasDefaultFieldSets === false ? onRestoreDefaultColumns : undefined;
};
const $a32fd0fc63cfc134$export$3e7a75a1659bbaae = (onColumnsChange)=>{
    const canEditColumns = $a32fd0fc63cfc134$export$b4f6a715a9e57e85();
    return canEditColumns ? onColumnsChange : undefined;
};
const $a32fd0fc63cfc134$export$d7623a323994e4cc = (selectedColumns, isIFCEnabled, projectContext, savedViewId)=>{
    let [{ view: selectedView }] = (0, $HiS1C.useSelectedViewState)();
    const canEditColumns = $a32fd0fc63cfc134$export$b4f6a715a9e57e85();
    if (projectContext != null && (0, $7jTnu.fg)('saved_list_view_technical_changes')) selectedView = 'list_default';
    return (0, $kGfUm.useColumnLoader)(selectedView, canEditColumns, selectedColumns, (0, $7jTnu.fg)('jira_inline_field_config_gate'), isIFCEnabled, projectContext, savedViewId);
};
const $a32fd0fc63cfc134$export$90b784197d8a906f = ()=>{
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    // eslint-disable-next-line react-hooks/react-compiler
    return !isAnonymous ? $a32fd0fc63cfc134$export$d7623a323994e4cc : undefined;
};
const $a32fd0fc63cfc134$var$ListView = ({ loading: loading, onChangeColumnConfiguration: onChangeColumnConfiguration, onSelectedRowChange: onSelectedRowChange, issueResults: issueResults, groupResults: groupResults, view: view, project: project, rankField: rankField, issueTableProps: issueTableProps, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled, isFrozenColumnSupportEnabled: isFrozenColumnSupportEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, filter: filter, onIssueFlatListUpdated: onIssueFlatListUpdated, viewResultError: viewResultError })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_LIST_VIEW_START);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).ISSUE_RESULTS_LIST_VIEW_END);
    }, []);
    const resolvedJql = (0, $fwKw5.useResolvedJql)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const features = (0, $aaLZH.useIssueNavigatorFeatures)();
    const isRowContextMenuEnabled = (0, $7jTnu.fg)('jira_nin_smart_link') ? features.isRowContextMenuEnabled : true;
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const issueResultsData = (0, $j4oe4.useFragment)((0, $2uPxJ.default), issueResults);
    const groupResultsData = (0, $j4oe4.useFragment)((0, $edff2.default), groupResults);
    const viewData = (0, $j4oe4.useFragment)((0, $bHpMU.default), view);
    // manually throw error when fieldsets is null
    if (viewData.fieldSets == null) {
        (0, $gYnSx.default)({
            meta: {
                id: 'NinNullFieldSets',
                packageName: (0, $iRahl.PACKAGE_NAME),
                teamName: (0, $iRahl.TEAM_NAME)
            },
            sendToPrivacyUnsafeSplunk: false,
            skipSentry: true,
            attributes: {
                viewId: viewData.viewId,
                hasDefaultFieldSets: viewData.hasDefaultFieldSets,
                hasIssueResults: issueResultsData != null,
                hasView: view != null,
                typeName: viewData.__typename,
                viewResultError: viewResultError != null ? `${viewResultError?.statusCode} ${viewResultError?.message}` : false,
                ...isInlineFieldConfigEnabled && {
                    fieldSetsScope: {
                        operationScope: (0, $awWeA.getOperationScope)(issueTableProps?.projectContext),
                        projectKey: issueTableProps?.projectContext != null
                    }
                }
            }
        });
        throw new Error("Relay: Missing @required value at path 'fieldSets' in 'main_issueNavigator_ListView_view'.");
    }
    const projectData = (0, $j4oe4.useFragment)((0, $8eIYq.default), project);
    const filterData = (0, $j4oe4.useFragment)((0, $8YROZ.default), filter);
    const rankFieldData = (0, $j4oe4.useFragment)((0, $6XBm8.default), rankField);
    const selectedIssueKey = (0, $1wL9i.useSelectedIssueKey)();
    const selectedIssueIndex = (0, $1wL9i.useSelectedIssueIndex)();
    const currentPage = issueResultsData?.pageCursors?.around?.find((cursor)=>cursor?.isCurrent)?.pageNumber ?? 1;
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $dTsrC.useSortFieldAndDirection)();
    // TODO JSC-242 Need to figure out appropriate refetch behaviour, e.g. do we want to try keep visible issues in view?
    const { refetch: onIssueSearchForColumnConfig, refresh: refresh } = (0, $3kDjB.useIssueSearchActions)();
    const { isLoading: isColumnPickerLoading, setIsRestoringDefaultColumns: setIsRestoringDefaultColumns } = (0, $7auhX.useColumnPickerLoadingContext)();
    const onModifyColumns = (0, $eJOHy.useCallback)(()=>{
        onChangeColumnConfiguration && onChangeColumnConfiguration();
        onIssueSearchForColumnConfig();
    }, [
        onChangeColumnConfiguration,
        onIssueSearchForColumnConfig
    ]);
    const fieldSetIds = (0, $eJOHy.useMemo)(()=>viewData.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData.fieldSets?.edges
    ]);
    const stickyColumnIds = isFrozenColumnSupportEnabled && (0, $7jTnu.fg)('issue_table_frozen_columns') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>viewData.fieldSets?.edges?.filter((edge)=>edge?.node?.fieldSetPreferences?.isFrozen === true).map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData.fieldSets.edges
    ]) : [];
    const eventHandlers = (0, $aaQkY.useEventHandlers)(issueResultsData?.__id, fieldSetIds);
    const overriddenTableComponents = issueTableProps?.components;
    const projectContext = issueTableProps?.projectContext;
    const isGroupingSupported = issueTableProps?.isGroupingSupported;
    const viewSettings = viewData?.viewSettings;
    /**
   * isHierarchyEnabled reflects user preference in the current page,
   * canEnableHierarchy reflects whether the hierarchy can be enabled based on the JQL / other settings,
   * isIssueHierarchySupportEnabled reflects whether the hierarchy is supported in the experience.
   * The combination of these three values determines whether issue hierarchy is enabled in issue table.
   */ const isHierarchyEnabled = viewSettings?.isHierarchyEnabled && viewSettings.canEnableHierarchy && isIssueHierarchySupportEnabled;
    const isHideDoneEnabled = viewSettings?.hideDone ?? false;
    const groupByFieldId = viewData?.viewSettings?.groupByConfig?.groupByField?.fieldId;
    const infiniteScrollProps = (0, $7emTO.useInfiniteScroll)({
        isHierarchyEnabled: isHierarchyEnabled,
        fieldSetIds: fieldSetIds,
        groupBy: isGroupingSupported ? groupByFieldId : undefined,
        view: (0, $iRahl.views).list,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        isHideDoneEnabled: isHideDoneEnabled
    });
    const onSortOrderChange = (0, $eJOHy.useCallback)((sortField, sortDirection, aliases = [])=>setFieldAndDirection(sortField, sortDirection, aliases), [
        setFieldAndDirection
    ]);
    const hasMaxSelectedColumns = viewData?.fieldSets?.totalCount ? viewData?.fieldSets?.totalCount >= (0, $8jOO7.MAX_COLUMNS) : false;
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const [replaceSpreadsheetViewFieldSets] = (0, $j4oe4.useMutation)((0, $dBeX4.default));
    const [setFieldSets] = (0, $j4oe4.useMutation)((0, $iLkfp.default));
    const onColumnsChange = (0, $eJOHy.useCallback)((columnIds, changeType, optimisticFieldSets, onSuccessCallback, onErrorCallback, retries = 0, analyticsAttributes, skipRefetch)=>{
        let attempts = 0;
        // This handler can be called from a native event listener hence React does not batch state updates.
        // We manually batch this update for better rendering performance and more accurate measurement of
        // drag-and-drop interaction performance. We can remove this with React 18's automatic batching.
        (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).unstable_batchedUpdates(()=>{
            if (changeType === (0, $8jOO7.REORDER_COLUMNS)) (0, $jOc90.dragAndDropExperience).start();
            const variables = {
                id: viewData.id,
                amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
                fieldSetsInput: {
                    replaceFieldSetsInput: {
                        nodes: columnIds,
                        ...isInlineFieldConfigEnabled && {
                            context: {
                                projectContext: {
                                    project: projectData?.projectId
                                }
                            }
                        }
                    }
                },
                includeView: changeType === (0, $8jOO7.REORDER_COLUMNS),
                ...isInlineFieldConfigEnabled && {
                    fieldSetsScope: {
                        operationScope: (0, $awWeA.getOperationScope)(projectContext),
                        projectKey: projectData?.key
                    }
                }
            };
            const handleCompleted = (success)=>{
                if (success) {
                    const canSkipRefetch = skipRefetch && (0, $7jTnu.fg)('jira_inline_field_config_gate');
                    if (changeType === (0, $8jOO7.MODIFY_COLUMNS) && !canSkipRefetch) onModifyColumns();
                    else if (changeType === (0, $8jOO7.REORDER_COLUMNS)) (0, $jOc90.dragAndDropExperience).success();
                    if ((0, $7jTnu.fg)('jira_nin_table_column_update_analytics')) {
                        if ((0, $7jTnu.fg)('jira_inline_field_config_gate')) {
                            const eventAttributes = {
                                ...analyticsAttributes,
                                operationScope: (0, $awWeA.getOperationScope)(projectContext)
                            };
                            if (changeType === (0, $8jOO7.MODIFY_COLUMNS)) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', eventAttributes || {});
                            else if (changeType === (0, $8jOO7.REORDER_COLUMNS)) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', {
                                actionType: (0, $8jOO7.REORDER_COLUMNS),
                                operationScope: (0, $awWeA.getOperationScope)(projectContext)
                            });
                        } else {
                            const totalCount = viewData?.fieldSets?.totalCount;
                            if (changeType === (0, $8jOO7.MODIFY_COLUMNS)) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', {
                                isInline: false,
                                actionType: columnIds.length < (totalCount ?? 0) ? (0, $d8Dow.REMOVE_COLUMNS) : (0, $d8Dow.ADD_COLUMNS)
                            });
                            else if (changeType === (0, $8jOO7.REORDER_COLUMNS)) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', {
                                actionType: (0, $8jOO7.REORDER_COLUMNS)
                            });
                        }
                    }
                    if ((0, $7jTnu.fg)('jira_inline_field_config_gate')) onSuccessCallback?.();
                } else {
                    const showError = !(0, $7jTnu.fg)('jira_inline_field_config_gate') || attempts === retries;
                    if (showError) {
                        showFlag($a32fd0fc63cfc134$var$reorderColumnsErrorFlag);
                        (0, $gYnSx.default)({
                            meta: {
                                id: 'commitReplaceListViewFieldSetsMutationUnsuccessful',
                                packageName: (0, $iRahl.PACKAGE_NAME),
                                teamName: (0, $iRahl.TEAM_NAME)
                            },
                            sendToPrivacyUnsafeSplunk: true,
                            attributes: {
                                changeType: changeType,
                                retries: retries
                            }
                        });
                        if (changeType === (0, $8jOO7.REORDER_COLUMNS)) (0, $jOc90.dragAndDropExperience).failure();
                        if ((0, $7jTnu.fg)('jira_inline_field_config_gate')) onErrorCallback?.();
                    } else {
                        attempts++;
                        commitFieldSets();
                    }
                }
            };
            const handleError = (error)=>{
                const showError = !(0, $7jTnu.fg)('jira_inline_field_config_gate') || attempts === retries;
                if (showError) {
                    showFlag($a32fd0fc63cfc134$var$reorderColumnsErrorFlag);
                    (0, $gYnSx.default)({
                        meta: {
                            id: 'commitReplaceListViewFieldSetsMutationError',
                            packageName: (0, $iRahl.PACKAGE_NAME),
                            teamName: (0, $iRahl.TEAM_NAME)
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true,
                        attributes: {
                            changeType: changeType
                        }
                    });
                    if (changeType === (0, $8jOO7.REORDER_COLUMNS)) (0, $jOc90.dragAndDropExperience).failure();
                    if ((0, $7jTnu.fg)('jira_inline_field_config_gate')) onErrorCallback?.();
                } else {
                    attempts++;
                    commitFieldSets();
                }
            };
            const commitFieldSets = ()=>{
                if ((0, $7jTnu.fg)('saved_list_view_technical_changes')) {
                    const savedViewId = viewData.savedViewId;
                    if (savedViewId == null) throw new Error('Missing saved view ID');
                    const setFieldSetsVariables = {
                        input: {
                            fieldSetsInput: variables.fieldSetsInput,
                            viewId: savedViewId
                        },
                        amountOfColumns: variables.amountOfColumns,
                        includeView: variables.includeView,
                        ...isInlineFieldConfigEnabled && {
                            fieldSetsScope: {
                                operationScope: (0, $awWeA.getOperationScope)(projectContext),
                                projectKey: projectData?.key
                            }
                        }
                    };
                    setFieldSets({
                        variables: setFieldSetsVariables,
                        optimisticResponse: changeType === (0, $8jOO7.REORDER_COLUMNS) && optimisticFieldSets ? {
                            jira_setIssueSearchFieldSets: {
                                success: true,
                                view: {
                                    __typename: viewData.__typename,
                                    id: viewData.id,
                                    hasDefaultFieldSets: viewData.hasDefaultFieldSets,
                                    fieldSets: {
                                        ...optimisticFieldSets
                                    }
                                }
                            }
                        } : undefined,
                        onCompleted (data) {
                            handleCompleted(data.jira_setIssueSearchFieldSets?.success);
                        },
                        onError (error) {
                            handleError(error);
                        }
                    });
                } else replaceSpreadsheetViewFieldSets({
                    variables: variables,
                    optimisticResponse: changeType === (0, $8jOO7.REORDER_COLUMNS) && optimisticFieldSets ? {
                        jira: {
                            replaceSpreadsheetViewFieldSets: {
                                success: true,
                                view: {
                                    __typename: viewData.__typename,
                                    id: viewData.id,
                                    hasDefaultFieldSets: viewData.hasDefaultFieldSets,
                                    fieldSets: {
                                        ...optimisticFieldSets
                                    }
                                }
                            }
                        }
                    } : undefined,
                    onCompleted (data) {
                        handleCompleted(data.jira?.replaceSpreadsheetViewFieldSets?.success);
                    },
                    onError (error) {
                        handleError(error);
                    }
                });
            };
            commitFieldSets();
        });
    }, [
        viewData.id,
        viewData?.fieldSets?.totalCount,
        viewData.__typename,
        viewData.hasDefaultFieldSets,
        viewData?.savedViewId,
        projectContext,
        isInlineFieldConfigEnabled,
        projectData?.projectId,
        projectData?.key,
        onModifyColumns,
        createAnalyticsEvent,
        showFlag,
        setFieldSets,
        replaceSpreadsheetViewFieldSets
    ]);
    const [updateFieldSetPreferencesOld] = (0, $j4oe4.useMutation)((0, $9bfTw.default));
    const [updateFieldSetPreferences] = (0, $j4oe4.useMutation)((0, $6hWjd.default));
    const cloudId = (0, $kEUB1.useCloudId)();
    const updateColumnWidth = (0, $9Z7uc.useColumnWidthUpdater)(viewData.fieldSets?.__id);
    const updateColumnIsFrozen = (0, $7jTnu.fg)('issue_table_frozen_columns') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $aJqsk.useColumnIsFrozenUpdater)(viewData.fieldSets?.__id) : undefined;
    const { commitUpdateFieldSetPreferences: commitUpdateFieldSetPreferences, commitUpdateFieldSetPreferencesOld: commitUpdateFieldSetPreferencesOld } = (0, $4ciTX.useCommitFieldSetPreferences)({
        cloudId: cloudId,
        projectId: projectData?.projectId,
        viewId: viewData.id,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        updateFieldSetPreferences: updateFieldSetPreferences,
        updateFieldSetPreferencesOld: updateFieldSetPreferencesOld
    });
    const onColumnFreeze = (0, $eJOHy.useCallback)((payload)=>{
        if (!isAnonymous) {
            // TODO: Test this once the saved list view is ready. Currently, it follows the column resize implementation.
            if ((0, $7jTnu.fg)('saved_list_view_technical_changes')) {
                const savedViewId = viewData.savedViewId;
                if (savedViewId == null) throw new Error('Missing saved view ID');
                commitUpdateFieldSetPreferences(savedViewId, payload);
            } else commitUpdateFieldSetPreferencesOld(payload);
        }
        // commit local update to the store independently of the mutation result to preserve user's desired frozen state
        updateColumnIsFrozen?.(payload);
    }, [
        commitUpdateFieldSetPreferences,
        commitUpdateFieldSetPreferencesOld,
        isAnonymous,
        updateColumnIsFrozen,
        viewData.savedViewId
    ]);
    const onColumnResize = (0, $eJOHy.useCallback)((columnId, width)=>{
        // skip mutation for anonymous users as they don't have access to user preferences
        if (!isAnonymous) {
            // we intentionally don't optimistically update the store to avoid rolling back column widths
            // in case of a mutation error, which would be very jarring for the user
            if ((0, $7jTnu.fg)('saved_list_view_technical_changes')) {
                const savedViewId = viewData.savedViewId;
                if (savedViewId == null) throw new Error('Missing saved view ID');
                commitUpdateFieldSetPreferences(savedViewId, [
                    {
                        fieldSetId: columnId,
                        width: width ?? null
                    }
                ]);
            } else commitUpdateFieldSetPreferencesOld([
                {
                    fieldSetId: columnId,
                    width: width ?? null
                }
            ]);
        }
        // commit local update to the store independently of the mutation result to preserve user's desired width
        updateColumnWidth(columnId, width);
    }, [
        isAnonymous,
        updateColumnWidth,
        viewData.savedViewId,
        commitUpdateFieldSetPreferences,
        commitUpdateFieldSetPreferencesOld
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $jOc90.dragAndDropExperience).markInlineResponse();
    });
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            hasMaxSelectedColumns: hasMaxSelectedColumns,
            filterName: filterData?.name
        }), [
        filterData?.name,
        hasMaxSelectedColumns
    ]);
    const onRestoreDefaultColumns = (0, $eJOHy.useCallback)(()=>{
        setIsRestoringDefaultColumns(true);
        const variables = {
            id: viewData.id,
            amountOfColumns: (0, $8jOO7.MAX_COLUMNS),
            includeView: true,
            ...isInlineFieldConfigEnabled ? {
                fieldSetsInput: {
                    scopedResetToDefaultFieldSets: {
                        doReset: true,
                        context: {
                            projectContext: {
                                project: projectData?.projectId
                            }
                        }
                    }
                }
            } : {
                fieldSetsInput: {
                    resetToDefaultFieldSets: true
                }
            }
        };
        const handleCompleted = (success)=>{
            setIsRestoringDefaultColumns(false);
            if (success) {
                if ((0, $7jTnu.fg)('jira_nin_table_column_update_analytics')) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', {
                    actionType: (0, $8jOO7.RESTORE_COLUMNS),
                    operationScope: (0, $awWeA.getOperationScope)(projectContext)
                });
                refresh();
            } else {
                showFlag($a32fd0fc63cfc134$var$resetColumnsErrorFlag);
                (0, $gYnSx.default)({
                    meta: {
                        id: 'commitReplaceListViewUsingResetFieldSetsMutationUnsuccessful',
                        packageName: (0, $iRahl.PACKAGE_NAME),
                        teamName: (0, $iRahl.TEAM_NAME)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        const handleError = (error)=>{
            setIsRestoringDefaultColumns(false);
            showFlag($a32fd0fc63cfc134$var$resetColumnsErrorFlag);
            (0, $gYnSx.default)({
                meta: {
                    id: 'commitReplaceListViewUsingResetFieldSetsMutationError',
                    packageName: (0, $iRahl.PACKAGE_NAME),
                    teamName: (0, $iRahl.TEAM_NAME)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        };
        replaceSpreadsheetViewFieldSets({
            variables: variables,
            onCompleted (data) {
                handleCompleted(data.jira?.replaceSpreadsheetViewFieldSets?.success);
            },
            onError (error) {
                handleError(error);
            }
        });
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        setIsRestoringDefaultColumns,
        viewData.id,
        refresh,
        showFlag,
        replaceSpreadsheetViewFieldSets
    ]);
    /**
   * returns undefined if there are default field sets
   * returns undefined if the user is on filter tab but cannot edit filter
   */ const conditionalOnRestoreDefaults = $a32fd0fc63cfc134$export$539ae4acd804b244(onRestoreDefaultColumns, viewData?.hasDefaultFieldSets, (0, $7jTnu.fg)('jira_inline_field_config_gate') ? viewData?.viewId : undefined);
    const tableComponents = (0, $eJOHy.useMemo)(// We shallow merge these objects to make it easier for issue-navigator consumers to revert custom column
    // picker components, which are very NIN specific. This decision can be reconsidered if we need to introduce
    // additional nested custom components in the issue table and make those available to all consumers.
    ()=>({
            columnPicker: {
                Container: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i5UAP.ColumnPickerRemountManager), {
                        viewIdFromResponse: (0, $eibCx.parseIssueNavigatorViewIdOrDefault)(viewData.viewId)
                    }, children),
                // eslint-disable-next-line jira/ff/no-preconditioning
                ...(0, $7jTnu.fg)('saved_list_view_technical_changes') && projectContext ? {} : {
                    PopupComponent: (0, $7jTnu.fg)('jira_inline_field_config_gate') ? (0, $iZH8P.createPopupComponent)(conditionalOnRestoreDefaults) : (0, $iZH8P.default)
                }
            },
            IssueCount: $b2VjA.IssueCount,
            NoColumns: $ghzkC.NoColumns,
            NoIssues: $2PY5Q.NoIssues,
            ...overriddenTableComponents,
            ConnectionsSubscriber: ({ connections: connections, updateConnectionDetails: updateConnectionDetails })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fOH9z.BulkOpsConnectionsSubscriber), {
                    connections: connections,
                    updateConnectionDetails: updateConnectionDetails,
                    fragmentRef: issueResultsData || groupResultsData?.firstGroup?.issues || null
                })
        }), [
        projectContext,
        conditionalOnRestoreDefaults,
        overriddenTableComponents,
        viewData.viewId,
        issueResultsData,
        groupResultsData?.firstGroup?.issues
    ]);
    const conditionalOnChange = $a32fd0fc63cfc134$export$3e7a75a1659bbaae(onColumnsChange);
    const conditionalColumnLoader = $a32fd0fc63cfc134$export$90b784197d8a906f();
    const [isIFCEnabled, ifcConfig] = isInlineFieldConfigEnabled ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $i99kJ.useIFCSidebar)({
        projectKey: projectData?.key,
        projectId: projectData?.projectId
    }) : [
        false,
        undefined
    ];
    const resultsFragment = (0, $P01So.exclusiveGroupsOrIssuesFragment)({
        groups: groupResultsData ?? null,
        issues: issueResultsData ?? null
    });
    const isConditionalFormattingEnabled = features.isConditionalFormattingEnabled && (0, $7jTnu.fg)('jira_list_conditional_formatting');
    if (!resultsFragment) throw new Error('Missing groups or issues data');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "list-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cTddL.DialogContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            currentPage: currentPage,
            isAnonymous: isAnonymous
        }
    }, resultsFragment.issues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fwdeI.AsyncRegisterShortcutDialogActions), {
        issues: resultsFragment.issues,
        selectedIssueKey: selectedIssueKey,
        eventHandlers: eventHandlers
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gTm2i.ColumnPickerMessageContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32fd0fc63cfc134$var$TableContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j6nGi.default), {
        view: (0, $7jTnu.fg)('saved_list_view_technical_changes') ? viewData : null,
        columns: viewData.fieldSets,
        onColumnsChange: conditionalOnChange,
        onRestoreDefaultColumns: conditionalOnRestoreDefaults,
        useColumnLoader: conditionalColumnLoader,
        loading: loading,
        eventHandlers: eventHandlers,
        onSelectedRowChange: onSelectedRowChange,
        selectedRow: selectedIssueIndex,
        sortField: field,
        sortDirection: direction,
        onSortChange: onSortOrderChange,
        onRefetch: onIssueSearchForColumnConfig,
        components: tableComponents,
        issueSearchBaseUrl: "" // Relative to current route rendering the issue navigator
        ,
        isColumnPickerLoading: isColumnPickerLoading,
        projectContext: projectContext,
        isGroupingSupported: isGroupingSupported,
        isIssueCreateEnabled: true // It's already tied to the project context
        ,
        onColumnResize: onColumnResize,
        project: projectData,
        rankField: rankFieldData?.rankField,
        isIssueHierarchyEnabled: Boolean(isHierarchyEnabled),
        isGridNavigationEnabled: (0, $epTsa.expVal)('nin_grid_navigation_experiment', 'isGridNavigationEnabled', false),
        isInlineEditingExtendedFieldSupportEnabled: (0, $epTsa.expVal)('jira_list_inline_editing', 'isInlineEditingEnabled', false),
        isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled,
        ifcConfig: isIFCEnabled || (0, $7jTnu.fg)('jsc_list_category_editing_in_nin') ? ifcConfig : undefined,
        onIssueFlatListUpdated: onIssueFlatListUpdated,
        ...(0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') && {
            jql: resolvedJql
        },
        enableMultiSelect: true,
        ...(0, $epTsa.expVal)('jira_list_reparenting', 'isReparentingEnabled', false) && {
            isReparentingEnabled: true
        },
        ...(0, $epTsa.expVal)('jira_list_single_line_row_height', 'isEnabled', false) && {
            isSingleLineRowHeightEnabled: true
        },
        ...(0, $epTsa.expVal)('jira_list_hide_done_items', 'isEnabled', false) && {
            isHideDoneItemsEnabled: isHideDoneEnabled
        },
        isMergedColumnEnabled: isMergedColumnSupportEnabled && (0, $7jTnu.fg)('jira_list_merged_column_gate'),
        ...infiniteScrollProps,
        ...resultsFragment,
        preloadedEntryPoints: issueTableProps?.preloadedEntryPoints,
        ...(0, $7jTnu.fg)('jsc_list_reranking_gate') && {
            isIssueRankingEnabled: (isIssueRankingSupportEnabled && viewSettings?.canEnableReranking) ?? false
        },
        ...(0, $7jTnu.fg)('jira_nin_smart_link') && {
            isIssueOperationMeatballMenuEnabled: isRowContextMenuEnabled
        },
        ...isFrozenColumnSupportEnabled && (0, $7jTnu.fg)('issue_table_frozen_columns') && {
            isStickyColumnsEnabled: true,
            stickyColumnIds: stickyColumnIds,
            onColumnFreeze: onColumnFreeze,
            enableAutoUnstickyOnSmallScreen: true
        },
        isConditionalFormattingEnabled: isConditionalFormattingEnabled,
        isProjectQuickstartOnboardingEnabled: features.isProjectQuickstartOnboardingEnabled && (0, $7jTnu.fg)('jira_list_nin_merge')
    })), (0, $7jTnu.fg)('in_context_config_sidebar_changeboarding') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6TdgS.NumberFormattingChangeboardingWrapper), {
        projectId: String(projectData?.projectId),
        projectKey: projectData?.key ?? ''
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aisD.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null)));
};
// re-render regression detection
$a32fd0fc63cfc134$var$ListView.whyDidYouRender = true;
const $a32fd0fc63cfc134$var$ListViewWithColumnPickerContext = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7auhX.ColumnPickerLoadingContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32fd0fc63cfc134$var$ListView, props));
var $a32fd0fc63cfc134$export$2e2bcd8739ae039 = (0, $2UTIe.withReportErrors)($a32fd0fc63cfc134$var$ListViewWithColumnPickerContext, {
    id: 'ui.issue-results.list-view.unhandled',
    packageName: (0, $iRahl.PACKAGE_NAME),
    teamName: (0, $iRahl.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $g8Az8.isLoaderErrorAttributes)
});
const $a32fd0fc63cfc134$var$TableContainerStyles = (0, $1DXK0.xcss)({
    flexGrow: 1,
    flexBasis: 0,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    flexDirection: 'column'
});

});
parcelRegister("6hWjd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a0adc8f2fb4b219$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d71226e7021945d776875dcb36e046e7>>
 * @relayHash c6b8d697c662945f1be793b236d5268a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ebf6d75990b777e3b54020417e3b137ce036122fc4dfdaab478c4b99964a4d3d
const $4a0adc8f2fb4b219$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "JiraSetFieldSetsPreferencesPayload",
            "kind": "LinkedField",
            "name": "jira_setFieldSetsPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_setFieldSetsPreferencesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_setFieldSetsPreferencesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "ebf6d75990b777e3b54020417e3b137ce036122fc4dfdaab478c4b99964a4d3d",
            "metadata": {},
            "name": "main_setFieldSetsPreferencesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$4a0adc8f2fb4b219$var$node.hash = "66ced461f53670977bbff1972c370ba4";
var $4a0adc8f2fb4b219$export$2e2bcd8739ae039 = $4a0adc8f2fb4b219$var$node;

});

parcelRegister("9bfTw", function(module, exports) {

$parcel$export(module.exports, "default", () => $853371a224120d7a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ef9f65c833c68417d53ec99aa24b012e>>
 * @relayHash 9ea995599d5a28724f789a13cffad87f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 84a5bf8db4d5733b55ab8be4a9bac682b89dc1e3f8ab6e56f5369a3137e6aa15
const $853371a224120d7a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v4 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "context",
                            "variableName": "context"
                        },
                        {
                            "kind": "Variable",
                            "name": "fieldSetPreferencesInput",
                            "variableName": "input"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewId",
                            "variableName": "viewId"
                        }
                    ],
                    "concreteType": "JiraFieldSetPreferencesUpdatePayload",
                    "kind": "LinkedField",
                    "name": "updateUserFieldSetPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_updateFieldSetPreferencesMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_updateFieldSetPreferencesMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "84a5bf8db4d5733b55ab8be4a9bac682b89dc1e3f8ab6e56f5369a3137e6aa15",
            "metadata": {},
            "name": "main_updateFieldSetPreferencesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$853371a224120d7a$var$node.hash = "a01e3ed61486b0d7d7faf04b338c4960";
var $853371a224120d7a$export$2e2bcd8739ae039 = $853371a224120d7a$var$node;

});

parcelRegister("iLkfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $76261eddff17f6be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b0b5dbcc0ff9f6a5e045d0176bcca2ce>>
 * @relayHash 1ed28e8a653412c87db3c57b9f21c5f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44ccbd2a757f0a6eee37ce6487ae99febdc470629aad412306801243623e1a61

var $2Z4v6 = parcelRequire("2Z4v6");

var $8Qoc7 = parcelRequire("8Qoc7");
const $76261eddff17f6be$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeView"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "success"
    }, v6 = {
        "kind": "ScalarField",
        "name": "hasDefaultFieldSets"
    }, v7 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "fieldSetsScope"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v9 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v10 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_setFieldSetsMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraSetIssueSearchFieldSetsPayload",
                    "kind": "LinkedField",
                    "name": "jira_setIssueSearchFieldSets",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "condition": "includeView",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "view",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "NativeIssueTableWithSelectedIssuesProvider101BadPattern"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "main_setFieldSetsMutation",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraSetIssueSearchFieldSetsPayload",
                    "kind": "LinkedField",
                    "name": "jira_setIssueSearchFieldSets",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "condition": "includeView",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "view",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "type"
                                                                },
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "jqlTerm"
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "aliases"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isSortable"
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldSetPreferences",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetPreferences",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "width"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsMetadata",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchMetadataField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "canBeConfigured"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "fieldId"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isPlaceHolderField"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldType",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "44ccbd2a757f0a6eee37ce6487ae99febdc470629aad412306801243623e1a61",
            "metadata": {},
            "name": "main_setFieldSetsMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default)
            }
        }
    };
}();
$76261eddff17f6be$var$node.hash = "017ede0421295c141fba32d25d955788";
var $76261eddff17f6be$export$2e2bcd8739ae039 = $76261eddff17f6be$var$node;

});

parcelRegister("dBeX4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97b49e4411846d6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7f17a183383d253ab744821976488700>>
 * @relayHash d5da5a06c3e808f6b52a3e0bab8941dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 03df371d4a443ea39494953f800f2fbb8a5509b0192743df87a961b026fdf018

var $2Z4v6 = parcelRequire("2Z4v6");

var $8Qoc7 = parcelRequire("8Qoc7");
const $a97b49e4411846d6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeView"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "fieldSetsScope"
    }, v8 = {
        "args": [
            v7 /*: any*/ 
        ],
        "kind": "ScalarField",
        "name": "hasDefaultFieldSets"
    }, v9 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        },
        v7 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v12 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_replaceSpreadsheetViewFieldSetsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceSpreadsheetViewFieldSets",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "NativeIssueTableWithSelectedIssuesProvider101BadPattern"
                                                        },
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "main_replaceSpreadsheetViewFieldSetsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceSpreadsheetViewFieldSets",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v9 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jqlTerm"
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "aliases"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldsMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueSearchMetadataField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canBeConfigured"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "fieldId"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "03df371d4a443ea39494953f800f2fbb8a5509b0192743df87a961b026fdf018",
            "metadata": {},
            "name": "main_replaceSpreadsheetViewFieldSetsMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $2Z4v6.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": (0, $8Qoc7.default)
            }
        }
    };
}();
$a97b49e4411846d6$var$node.hash = "2fce5b0e271c895671b6a7c9c082bde8";
var $a97b49e4411846d6$export$2e2bcd8739ae039 = $a97b49e4411846d6$var$node;

});

parcelRegister("6XBm8", function(module, exports) {

$parcel$export(module.exports, "default", () => $74d7f8606a6d533b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<02d9b8b68b66f5f5bf32275f81a0a49d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $74d7f8606a6d533b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_rankField",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraJqlFieldWithAliases",
                    "kind": "LinkedField",
                    "name": "rankField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "NativeIssueTableWithSelectedIssuesProvider527BadPattern"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$74d7f8606a6d533b$var$node.hash = "312d4259d594db85bc82a09d5984064b";
var $74d7f8606a6d533b$export$2e2bcd8739ae039 = $74d7f8606a6d533b$var$node;

});

parcelRegister("8YROZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $295612b497098736$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b1ac4ee09aa06d0c162ef3bdadd8c445>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $295612b497098736$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$295612b497098736$var$node.hash = "42fd583d4b19e59270b0aa45271f2d67";
var $295612b497098736$export$2e2bcd8739ae039 = $295612b497098736$var$node;

});

parcelRegister("8eIYq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fae26d1cb29af711$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a49633e02cdfe9fe367414fae19fcfec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fae26d1cb29af711$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "NativeIssueTableWithSelectedIssuesProvider197BadPattern"
        }
    ],
    "type": "JiraProject"
};
$fae26d1cb29af711$var$node.hash = "2204e77d7b042a1fa9d46de7f61de808";
var $fae26d1cb29af711$export$2e2bcd8739ae039 = $fae26d1cb29af711$var$node;

});

parcelRegister("bHpMU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e732f9356510c3bb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a870de4810f3ada230b05891bc72b745>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e732f9356510c3bb$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "fieldSetsScope"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "settings"
            },
            {
                "kind": "RootArgument",
                "name": "staticViewInput"
            }
        ],
        "kind": "Fragment",
        "name": "main_issueNavigator_ListView_view",
        "selections": [
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "NativeIssueTableWithSelectedIssuesProvider"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "savedViewId"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "viewId"
                },
                "action": "THROW",
                "path": "viewId"
            },
            {
                "args": [
                    v0 /*: any*/ 
                ],
                "kind": "ScalarField",
                "name": "hasDefaultFieldSets"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                            "fieldSetSelectedState": "SELECTED"
                        }
                    },
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "amountOfColumns"
                    },
                    v0 /*: any*/ 
                ],
                "concreteType": "JiraIssueSearchFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSets",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "fieldSetId"
                                    },
                                    {
                                        "concreteType": "JiraFieldSetPreferences",
                                        "kind": "LinkedField",
                                        "name": "fieldSetPreferences",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisfrozencolumnsenabledrelayprovidertsx",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isFrozen"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "NativeIssueTableWithSelectedIssuesProvider101BadPattern"
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__id"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "groupBy",
                                "variableName": "groupBy"
                            },
                            {
                                "kind": "Variable",
                                "name": "issueSearchInput",
                                "variableName": "issueSearchInput"
                            },
                            {
                                "kind": "Variable",
                                "name": "settings",
                                "variableName": "settings"
                            },
                            {
                                "kind": "Variable",
                                "name": "staticViewInput",
                                "variableName": "staticViewInput"
                            }
                        ],
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewSettings",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "canEnableHierarchy"
                            },
                            {
                                "concreteType": "JiraSpreadsheetGroupByConfig",
                                "kind": "LinkedField",
                                "name": "groupByConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraField",
                                        "kind": "LinkedField",
                                        "name": "groupByField",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isHierarchyEnabled"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hideDone"
                            },
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "canEnableReranking"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
            }
        ],
        "type": "JiraIssueSearchViewMetadata",
        "abstractKey": "__isJiraIssueSearchViewMetadata"
    };
}();
$e732f9356510c3bb$var$node.hash = "57a4dd3e8e54a2dc99f537f05f833795";
var $e732f9356510c3bb$export$2e2bcd8739ae039 = $e732f9356510c3bb$var$node;

});

parcelRegister("edff2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9e30e7c38572a21$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a4dcb2b100082f52577dd04c17d7e2aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b9e30e7c38572a21$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "fieldSetsInput"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsScope"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isPaginating"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_groupResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isPaginating",
                    "variableName": "isPaginating"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "NativeIssueTableWithSelectedIssuesProvider950BadPattern"
        },
        {
            "condition": "isPaginating",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraSpreadsheetGroup",
                    "kind": "LinkedField",
                    "name": "firstGroup",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetsInput",
                                    "variableName": "fieldSetsInput"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 50
                                },
                                {
                                    "kind": "Variable",
                                    "name": "scope",
                                    "variableName": "fieldSetsScope"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "settings",
                                    "variableName": "settings"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ui_issueNavigatorBulkOperationsConnectionsSubscriber_BulkOpsConnectionsSubscriber"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$b9e30e7c38572a21$var$node.hash = "ff937eadea5c4ded182937be09ac2a09";
var $b9e30e7c38572a21$export$2e2bcd8739ae039 = $b9e30e7c38572a21$var$node;

});

parcelRegister("2uPxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f78b02226a657759$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dd58c607721143cd7ca1ab413e3124ca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f78b02226a657759$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "registerShortcutDialogActions_issueNavigator_RegisterShortcutsDialogActions"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "NativeIssueTableWithSelectedIssuesProvider204BadPattern"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "maxCursors",
                    "value": 7
                }
            ],
            "concreteType": "JiraPageCursors",
            "kind": "LinkedField",
            "name": "pageCursors",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraPageCursor",
                    "kind": "LinkedField",
                    "name": "around",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageNumber"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isCurrent"
                        }
                    ]
                }
            ],
            "storageKey": "pageCursors(maxCursors:7)"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_issueNavigatorBulkOperationsConnectionsSubscriber_BulkOpsConnectionsSubscriber"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$f78b02226a657759$var$node.hash = "fb2057c6e33ed06c450c8bb3fe8d1d6c";
var $f78b02226a657759$export$2e2bcd8739ae039 = $f78b02226a657759$var$node;

});

parcelRegister("6TdgS", function(module, exports) {

$parcel$export(module.exports, "NumberFormattingChangeboardingWrapper", () => $5e8d75e58d8638ec$export$10ed3f5d34ac7576);

var $eJOHy = parcelRequire("eJOHy");

var $bbdV2 = parcelRequire("bbdV2");

var $5V25X = parcelRequire("5V25X");

var $1KdDN = parcelRequire("1KdDN");

var $cBavF = parcelRequire("cBavF");

var $eU7vk = parcelRequire("eU7vk");

var $5Q8dn = parcelRequire("5Q8dn");

var $7jTnu = parcelRequire("7jTnu");

var $67Hrv = parcelRequire("67Hrv");

var $iMQSg = parcelRequire("iMQSg");


var $4gH81 = parcelRequire("4gH81");
const $5e8d75e58d8638ec$var$NumberFormattingChangeboarding = ({ projectId: projectId, projectKey: projectKey })=>{
    const { isActive: isActive } = (0, $5V25X.useTrigger)((0, $009a72c63c9d7dca$export$c2ff6ab935be7852));
    const data = (0, $iMQSg.useFetchCriteria)(projectId, projectKey, isActive && (0, $7jTnu.fg)('in_context_config_sidebar_changeboarding'));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $67Hrv.asyncNumberFormattingFlagEntryPoint), {});
    const meetsCriteria = data !== undefined && data?.hasExistingNumberFieldWithFormatStyle !== true && data?.isProjectAdmin && data?.isTMP;
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (!meetsCriteria) {
            (0, $4gH81.emitMessageEvent)({
                action: 'filter'
            });
            return;
        }
        if (isActive && !(0, $7jTnu.fg)('in_context_config_sidebar_changeboarding')) {
            (0, $4gH81.emitMessageEvent)({
                action: 'snooze'
            });
            return;
        }
        entryPointActions.load();
    }, [
        entryPointActions,
        meetsCriteria,
        data,
        isActive
    ]);
    if (!meetsCriteria || !isActive) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "number-currency-formatting-changeboarding-flag",
        packageName: "@jira/number-currency-formatting-changeboarding-flag",
        teamName: "a4t-tanuki",
        fallback: null,
        errorFallback: "unmount",
        runtimeProps: {
            projectKey: projectKey,
            projectType: data.projectType ?? undefined
        }
    });
};
const $5e8d75e58d8638ec$export$10ed3f5d34ac7576 = ({ projectId: projectId, projectKey: projectKey })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "public-forms-changeboarding-modal",
        packageName: "@atlassian/jira-public-forms-changeboarding-modal",
        teamName: "a4t-tanuki",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eU7vk.ApolloClientProvider), {
        client: (0, $5Q8dn.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5e8d75e58d8638ec$var$NumberFormattingChangeboarding, {
        projectId: projectId,
        projectKey: projectKey
    })));
};

});
parcelRegister("eU7vk", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $fbd5fc7ffb4125dd$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "resetCacheAsync", () => $fbd5fc7ffb4125dd$export$cd62f60830f74ae2);
$parcel$export(module.exports, "getClient", () => $fbd5fc7ffb4125dd$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $fbd5fc7ffb4125dd$export$8e363dbef886ff17);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $688i3 = parcelRequire("688i3");
const $fbd5fc7ffb4125dd$var$CLIENTS_CACHE = {};
const $fbd5fc7ffb4125dd$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
};
const $fbd5fc7ffb4125dd$export$cd62f60830f74ae2 = async (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    const client = $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
    delete $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
    await client?.clearStore();
};
const $fbd5fc7ffb4125dd$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($fbd5fc7ffb4125dd$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[key].extract()
        }), {});
const $fbd5fc7ffb4125dd$export$6bb76d6eba7e258c = ({ clientId: clientId, clientCreator: clientCreator })=>{
    let client = $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator();
        $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $fbd5fc7ffb4125dd$export$8e363dbef886ff17 extends (0, $eJOHy.Component) {
    getClient() {
        return $fbd5fc7ffb4125dd$export$6bb76d6eba7e258c(this.props.client);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        const client = this.getClient();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $688i3.ApolloProvider), {
            client: client
        }, children);
    }
}

});
parcelRegister("688i3", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $4769ebafec57fcc9$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $4769ebafec57fcc9$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $4769ebafec57fcc9$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $4769ebafec57fcc9$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $4769ebafec57fcc9$export$8f49e4af10703ce3);

var $eJOHy = parcelRequire("eJOHy");

var $lDEi6 = parcelRequire("lDEi6");
var $4769ebafec57fcc9$var$apolloContext;
function $4769ebafec57fcc9$export$a47505d961ee3a1() {
    if (!$4769ebafec57fcc9$var$apolloContext) $4769ebafec57fcc9$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
    return $4769ebafec57fcc9$var$apolloContext;
}
function $4769ebafec57fcc9$export$c2ee824bcc89ca6a() {
    $4769ebafec57fcc9$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
}
var $4769ebafec57fcc9$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $4769ebafec57fcc9$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $lDEi6.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $4769ebafec57fcc9$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $4769ebafec57fcc9$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $lDEi6.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $4769ebafec57fcc9$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($4769ebafec57fcc9$export$d1d99cf900472499 || ($4769ebafec57fcc9$export$d1d99cf900472499 = {}));
var $4769ebafec57fcc9$var$cache = new Map();
function $4769ebafec57fcc9$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $4769ebafec57fcc9$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $4769ebafec57fcc9$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $4769ebafec57fcc9$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $4769ebafec57fcc9$export$8f49e4af10703ce3(document) {
    var cached = $4769ebafec57fcc9$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $lDEi6.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $lDEi6.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $lDEi6.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $4769ebafec57fcc9$export$d1d99cf900472499.Query : $4769ebafec57fcc9$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $4769ebafec57fcc9$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $lDEi6.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $4769ebafec57fcc9$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("5Q8dn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2939e4856f212b8f$export$2e2bcd8739ae039);

var $9Dhvc = parcelRequire("9Dhvc");

var $ifBQy = parcelRequire("ifBQy");

var $eezJL = parcelRequire("eezJL");

var $7oe8F = parcelRequire("7oe8F");

var $i8eSF = parcelRequire("i8eSF");

var $eHpnE = parcelRequire("eHpnE");

var $a6bRt = parcelRequire("a6bRt");

var $g4okI = parcelRequire("g4okI");

var $eSnSE = parcelRequire("eSnSE");

var $1fQNI = parcelRequire("1fQNI");

var $dk1mg = parcelRequire("dk1mg");

var $gLqE0 = parcelRequire("gLqE0");


const $2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $2939e4856f212b8f$var$CACHE_NAME = `apollo-cache/${$2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID}`;
const $2939e4856f212b8f$var$LOG_NAMESPACE = `apollo.${$2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $2939e4856f212b8f$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $2939e4856f212b8f$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $2939e4856f212b8f$export$851a7159daf49c89 = new (0, $ifBQy.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($dk1mg))
});
const $2939e4856f212b8f$var$errorLink = (0, $i8eSF.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $gLqE0.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $gLqE0.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $eSnSE.default).safeErrorWithoutCustomerData($2939e4856f212b8f$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $eSnSE.default).safeErrorWithoutCustomerData($2939e4856f212b8f$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(operation.getContext(), [
            $2939e4856f212b8f$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $eSnSE.default).safeErrorWithoutCustomerData($2939e4856f212b8f$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$2939e4856f212b8f$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $2939e4856f212b8f$var$retryLinkWithFama = new (0, $a6bRt.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $gLqE0.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $2939e4856f212b8f$var$CancelableRequestLink extends (0, $7oe8F.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $7oe8F.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $2939e4856f212b8f$var$cache = new (0, $ifBQy.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $g4okI.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $2939e4856f212b8f$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$2939e4856f212b8f$var$isSsrSuccessful() && window.SPA_STATE[$2939e4856f212b8f$var$CACHE_NAME] || {});
const $2939e4856f212b8f$export$de66868aab9e79ea = (originUrl = '')=>new (0, $eezJL.ApolloClient)({
        name: $2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $2939e4856f212b8f$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $7oe8F.ApolloLink).from([
            $2939e4856f212b8f$var$retryLinkWithFama,
            $2939e4856f212b8f$var$errorLink,
            (0, $1fQNI.UFOLoggerLink),
            (0, $g4okI.fragmentLinkState)($2939e4856f212b8f$var$cache),
            ...!$2939e4856f212b8f$var$isSsrSuccessful() ? [
                new $2939e4856f212b8f$var$CancelableRequestLink()
            ] : [],
            new (0, $eHpnE.HttpLink)({
                uri: ({ operationName: operationName })=>`${originUrl}/rest/${$2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$2939e4856f212b8f$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $2939e4856f212b8f$var$cache,
        connectToDevTools: false
    });
var $2939e4856f212b8f$export$2e2bcd8739ae039 = {
    clientId: $2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $2939e4856f212b8f$export$de66868aab9e79ea
};

});
parcelRegister("ifBQy", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d496fc3ebf2f1ece$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d496fc3ebf2f1ece$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d496fc3ebf2f1ece$export$467265324939f47f);

var $dnskZ = parcelRequire("dnskZ");

var $8haCz = parcelRequire("8haCz");

var $jFDfc = parcelRequire("jFDfc");
var $hR4hP = parcelRequire("hR4hP");

var $9WJrj = parcelRequire("9WJrj");

var $lDEi6 = parcelRequire("lDEi6");
var $d496fc3ebf2f1ece$var$haveWarned = false;
function $d496fc3ebf2f1ece$var$shouldWarn() {
    var answer = !$d496fc3ebf2f1ece$var$haveWarned;
    if (!(0, $jFDfc.isTest)()) $d496fc3ebf2f1ece$var$haveWarned = true;
    return answer;
}
var $d496fc3ebf2f1ece$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d496fc3ebf2f1ece$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d496fc3ebf2f1ece$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d496fc3ebf2f1ece$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $lDEi6.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $lDEi6.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d496fc3ebf2f1ece$var$hasOwn = Object.prototype.hasOwnProperty;
var $d496fc3ebf2f1ece$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $9WJrj.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d496fc3ebf2f1ece$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d496fc3ebf2f1ece$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d496fc3ebf2f1ece$var$defaultNormalizedCacheFactory(seed) {
    return new $d496fc3ebf2f1ece$var$DepTrackingCache(seed);
}
var $d496fc3ebf2f1ece$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $9WJrj.KeyTrie)((0, $jFDfc.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $9WJrj.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $9WJrj.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $9WJrj.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jFDfc.getQueryDefinition)(query);
        variables = (0, $jFDfc.assign)({}, (0, $jFDfc.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $lDEi6.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $hR4hP.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d496fc3ebf2f1ece$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jFDfc.getMainDefinition)(query);
        var fragments = (0, $jFDfc.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jFDfc.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jFDfc.shouldInclude)(selection, variables)) return;
            if ((0, $jFDfc.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jFDfc.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jFDfc.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $lDEi6.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jFDfc.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jFDfc.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jFDfc.resultKeyNameFromField)(field),
            directives: (0, $jFDfc.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d496fc3ebf2f1ece$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d496fc3ebf2f1ece$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d496fc3ebf2f1ece$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d496fc3ebf2f1ece$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jFDfc.isIdValue)(value)) throw new (0, $lDEi6.InvariantError)(10);
}
function $d496fc3ebf2f1ece$var$defaultFragmentMatcher() {
    return true;
}
function $d496fc3ebf2f1ece$export$7a4899fe13f33235(idValue) {
    (0, $lDEi6.invariant)((0, $jFDfc.isIdValue)(idValue), 11);
}
function $d496fc3ebf2f1ece$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jFDfc.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jFDfc.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jFDfc.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d496fc3ebf2f1ece$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d496fc3ebf2f1ece$export$7e2b40d1002de152(seed) {
    return new $d496fc3ebf2f1ece$export$ee7258b8691956a3(seed);
}
var $d496fc3ebf2f1ece$export$de4e6870dc6ac801 = function(_super) {
    (0, $dnskZ.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d496fc3ebf2f1ece$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d496fc3ebf2f1ece$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d496fc3ebf2f1ece$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d496fc3ebf2f1ece$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d496fc3ebf2f1ece$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jFDfc.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jFDfc.assign)({}, (0, $jFDfc.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jFDfc.createFragmentMap)((0, $jFDfc.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d496fc3ebf2f1ece$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jFDfc.shouldInclude)(selection, variables)) return;
            if ((0, $jFDfc.isField)(selection)) {
                var resultFieldKey = (0, $jFDfc.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jFDfc.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $lDEi6.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jFDfc.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d496fc3ebf2f1ece$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jFDfc.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jFDfc.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d496fc3ebf2f1ece$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $lDEi6.invariant)(!semanticId || !$d496fc3ebf2f1ece$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d496fc3ebf2f1ece$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jFDfc.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jFDfc.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $lDEi6.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $lDEi6.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d496fc3ebf2f1ece$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $hR4hP.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d496fc3ebf2f1ece$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jFDfc.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d496fc3ebf2f1ece$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d496fc3ebf2f1ece$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jFDfc.isIdValue)(value) && $d496fc3ebf2f1ece$var$isGeneratedId(value.id) && (0, $jFDfc.isIdValue)(realValue) && !(0, $hR4hP.equal)(value, realValue) && $d496fc3ebf2f1ece$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, generated), real);
    if ((0, $hR4hP.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d496fc3ebf2f1ece$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d496fc3ebf2f1ece$var$defaultConfig = {
    fragmentMatcher: new $d496fc3ebf2f1ece$export$5d3fcf53267091de(),
    dataIdFromObject: $d496fc3ebf2f1ece$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d496fc3ebf2f1ece$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d496fc3ebf2f1ece$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d496fc3ebf2f1ece$var$OptimisticCacheLayer = function(_super) {
    (0, $dnskZ.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d496fc3ebf2f1ece$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d496fc3ebf2f1ece$export$ee7258b8691956a3);
var $d496fc3ebf2f1ece$export$467265324939f47f = function(_super) {
    (0, $dnskZ.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $9WJrj.KeyTrie)((0, $jFDfc.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, $d496fc3ebf2f1ece$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d496fc3ebf2f1ece$var$DepTrackingCache() : new $d496fc3ebf2f1ece$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d496fc3ebf2f1ece$export$eb8361c5d132fb8f();
        _this.storeReader = new $d496fc3ebf2f1ece$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $9WJrj.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $lDEi6.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d496fc3ebf2f1ece$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d496fc3ebf2f1ece$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jFDfc.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $8haCz.ApolloCache));

});
parcelRegister("8haCz", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $60682668fc3daa4e$export$5fc74f25506aa9c);

var $jFDfc = parcelRequire("jFDfc");
function $60682668fc3daa4e$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $60682668fc3daa4e$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $60682668fc3daa4e$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $60682668fc3daa4e$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $60682668fc3daa4e$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $60682668fc3daa4e$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $60682668fc3daa4e$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $60682668fc3daa4e$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $60682668fc3daa4e$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jFDfc.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jFDfc.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $60682668fc3daa4e$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $60682668fc3daa4e$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $60682668fc3daa4e$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $60682668fc3daa4e$export$94affb487e701bf2;
$60682668fc3daa4e$export$94affb487e701bf2 || ($60682668fc3daa4e$export$94affb487e701bf2 = {});

});

parcelRegister("9WJrj", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $73dcc72a68d15397$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $73dcc72a68d15397$export$4997ffc0176396a6);

var $hUWo2 = parcelRequire("hUWo2");
function $73dcc72a68d15397$var$defaultDispose() {}
var $73dcc72a68d15397$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $73dcc72a68d15397$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $73dcc72a68d15397$var$parentEntrySlot = new (0, $hUWo2.Slot)();
var $73dcc72a68d15397$var$reusableEmptyArray = [];
var $73dcc72a68d15397$var$emptySetPool = [];
var $73dcc72a68d15397$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $73dcc72a68d15397$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $73dcc72a68d15397$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $73dcc72a68d15397$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $73dcc72a68d15397$var$valueCopy(value) {
    return value.slice(0);
}
var $73dcc72a68d15397$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $73dcc72a68d15397$var$assert(!this.recomputing, "already recomputing");
        if (!$73dcc72a68d15397$var$rememberParent(this) && $73dcc72a68d15397$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $73dcc72a68d15397$var$mightBeDirty(this) ? $73dcc72a68d15397$var$reallyRecompute(this) : $73dcc72a68d15397$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $73dcc72a68d15397$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $73dcc72a68d15397$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $73dcc72a68d15397$var$forgetChildren(this).forEach($73dcc72a68d15397$var$maybeReportOrphan);
        $73dcc72a68d15397$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $73dcc72a68d15397$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $73dcc72a68d15397$var$rememberParent(child) {
    var parent = $73dcc72a68d15397$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($73dcc72a68d15397$var$mightBeDirty(child)) $73dcc72a68d15397$var$reportDirtyChild(parent, child);
        else $73dcc72a68d15397$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $73dcc72a68d15397$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $73dcc72a68d15397$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $73dcc72a68d15397$var$parentEntrySlot.withValue(entry, $73dcc72a68d15397$var$recomputeNewValue, [
        entry
    ]);
    if ($73dcc72a68d15397$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $73dcc72a68d15397$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($73dcc72a68d15397$var$maybeReportOrphan);
    return $73dcc72a68d15397$var$valueGet(entry.value);
}
function $73dcc72a68d15397$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $73dcc72a68d15397$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $73dcc72a68d15397$var$setClean(entry) {
    entry.dirty = false;
    if ($73dcc72a68d15397$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $73dcc72a68d15397$var$reportClean(entry);
}
function $73dcc72a68d15397$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $73dcc72a68d15397$var$reportDirtyChild(parent, child);
    });
}
function $73dcc72a68d15397$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $73dcc72a68d15397$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $73dcc72a68d15397$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $73dcc72a68d15397$var$assert(parent.childValues.has(child));
    $73dcc72a68d15397$var$assert($73dcc72a68d15397$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $73dcc72a68d15397$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $73dcc72a68d15397$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $73dcc72a68d15397$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $73dcc72a68d15397$var$assert(parent.childValues.has(child));
    $73dcc72a68d15397$var$assert(!$73dcc72a68d15397$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $73dcc72a68d15397$var$valueCopy(child.value));
    else if (!$73dcc72a68d15397$var$valueIs(childValue, child.value)) parent.setDirty();
    $73dcc72a68d15397$var$removeDirtyChild(parent, child);
    if ($73dcc72a68d15397$var$mightBeDirty(parent)) return;
    $73dcc72a68d15397$var$reportClean(parent);
}
function $73dcc72a68d15397$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($73dcc72a68d15397$var$emptySetPool.length < $73dcc72a68d15397$var$POOL_TARGET_SIZE) $73dcc72a68d15397$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $73dcc72a68d15397$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $73dcc72a68d15397$var$forgetChildren(parent) {
    var children = $73dcc72a68d15397$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $73dcc72a68d15397$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $73dcc72a68d15397$var$assert(parent.dirtyChildren === null);
    return children;
}
function $73dcc72a68d15397$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $73dcc72a68d15397$var$removeDirtyChild(parent, child);
}
function $73dcc72a68d15397$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $73dcc72a68d15397$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $73dcc72a68d15397$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $73dcc72a68d15397$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $73dcc72a68d15397$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $73dcc72a68d15397$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $73dcc72a68d15397$var$keyTrie = new $73dcc72a68d15397$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $73dcc72a68d15397$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $73dcc72a68d15397$var$keyTrie.lookupArray(args);
}
var $73dcc72a68d15397$var$caches = new Set();
function $73dcc72a68d15397$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $73dcc72a68d15397$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $73dcc72a68d15397$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$73dcc72a68d15397$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $73dcc72a68d15397$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $73dcc72a68d15397$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$73dcc72a68d15397$var$parentEntrySlot.hasValue()) {
            $73dcc72a68d15397$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $73dcc72a68d15397$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("hUWo2", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $d0b4f509668bceb7$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $d0b4f509668bceb7$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $d0b4f509668bceb7$var$MISSING_VALUE = {};
var $d0b4f509668bceb7$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $d0b4f509668bceb7$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $d0b4f509668bceb7$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $d0b4f509668bceb7$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $d0b4f509668bceb7$var$MISSING_VALUE) break;
                if (context_1 !== $d0b4f509668bceb7$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $d0b4f509668bceb7$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($d0b4f509668bceb7$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $d0b4f509668bceb7$var$currentContext.slots[this.id] = $d0b4f509668bceb7$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $d0b4f509668bceb7$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $d0b4f509668bceb7$var$currentContext;
            $d0b4f509668bceb7$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $d0b4f509668bceb7$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $d0b4f509668bceb7$var$currentContext;
            return function() {
                var saved = $d0b4f509668bceb7$var$currentContext;
                try {
                    $d0b4f509668bceb7$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $d0b4f509668bceb7$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($d0b4f509668bceb7$var$currentContext) {
                var saved = $d0b4f509668bceb7$var$currentContext;
                try {
                    $d0b4f509668bceb7$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $d0b4f509668bceb7$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $d0b4f509668bceb7$var$globalKey = "@wry/context:Slot";
var $d0b4f509668bceb7$var$host = Array;
var $d0b4f509668bceb7$export$8c6ed5c666ac1360 = $d0b4f509668bceb7$var$host[$d0b4f509668bceb7$var$globalKey] || function() {
    var Slot = $d0b4f509668bceb7$var$makeSlotClass();
    try {
        Object.defineProperty($d0b4f509668bceb7$var$host, $d0b4f509668bceb7$var$globalKey, {
            value: $d0b4f509668bceb7$var$host[$d0b4f509668bceb7$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $d0b4f509668bceb7$export$2385a24977818dd0 = $d0b4f509668bceb7$export$8c6ed5c666ac1360.bind, $d0b4f509668bceb7$export$9fa6f2e300a97f8 = $d0b4f509668bceb7$export$8c6ed5c666ac1360.noContext;
function $d0b4f509668bceb7$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($d0b4f509668bceb7$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $d0b4f509668bceb7$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $d0b4f509668bceb7$export$2385a24977818dd0(gen.next);
        var boundThrow = $d0b4f509668bceb7$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($d0b4f509668bceb7$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $d0b4f509668bceb7$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $d0b4f509668bceb7$var$wrappedFibers = [];
function $d0b4f509668bceb7$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($d0b4f509668bceb7$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $d0b4f509668bceb7$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $d0b4f509668bceb7$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("i8eSF", function(module, exports) {

$parcel$export(module.exports, "onError", () => $d334845f424573c9$export$2288787135a8f66e);

var $dnskZ = parcelRequire("dnskZ");

var $7oe8F = parcelRequire("7oe8F");
function $d334845f424573c9$export$2288787135a8f66e(errorHandler) {
    return new (0, $7oe8F.ApolloLink)(function(operation, forward) {
        return new (0, $7oe8F.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $d334845f424573c9$export$d2c8415987899609 = function(_super) {
    (0, $dnskZ.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $d334845f424573c9$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $7oe8F.ApolloLink));

});

parcelRegister("eHpnE", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $ab38c4d93356db03$export$f4bbf1aec241cc1);

var $dnskZ = parcelRequire("dnskZ");

var $7oe8F = parcelRequire("7oe8F");

var $1pDgh = parcelRequire("1pDgh");
var $ab38c4d93356db03$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $dnskZ.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $1pDgh.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $7oe8F.ApolloLink)(function(operation) {
        var chosenURI = (0, $1pDgh.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $dnskZ.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $1pDgh.selectHttpOptionsAndBody)(operation, (0, $1pDgh.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $1pDgh.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $ab38c4d93356db03$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $7oe8F.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $1pDgh.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $7oe8F.fromError)(parseError);
        }
        return new (0, $7oe8F.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $1pDgh.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $ab38c4d93356db03$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $1pDgh.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $1pDgh.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $ab38c4d93356db03$export$f4bbf1aec241cc1 = function(_super) {
    (0, $dnskZ.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $ab38c4d93356db03$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $7oe8F.ApolloLink));

});
parcelRegister("1pDgh", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $107694c730f3c7b9$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $107694c730f3c7b9$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $107694c730f3c7b9$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $107694c730f3c7b9$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $107694c730f3c7b9$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $107694c730f3c7b9$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $107694c730f3c7b9$export$63ccc2571850f81a);

var $dnskZ = parcelRequire("dnskZ");

var $6NFTG = parcelRequire("6NFTG");

var $lDEi6 = parcelRequire("lDEi6");
var $107694c730f3c7b9$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $107694c730f3c7b9$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $107694c730f3c7b9$var$defaultOptions = {
    method: 'POST'
};
var $107694c730f3c7b9$export$dd86f00dc866e75d = {
    http: $107694c730f3c7b9$var$defaultHttpOptions,
    headers: $107694c730f3c7b9$var$defaultHeaders,
    options: $107694c730f3c7b9$var$defaultOptions
};
var $107694c730f3c7b9$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $107694c730f3c7b9$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $107694c730f3c7b9$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $107694c730f3c7b9$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $107694c730f3c7b9$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $lDEi6.InvariantError)(1);
    }
};
var $107694c730f3c7b9$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $107694c730f3c7b9$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $dnskZ.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $dnskZ.__assign)({}, options, config.options, {
            headers: (0, $dnskZ.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $dnskZ.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $6NFTG.print)(query);
    return {
        options: options,
        body: body
    };
};
var $107694c730f3c7b9$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $lDEi6.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $107694c730f3c7b9$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("a6bRt", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $75a3aa60951dc58d$export$943d544ad120494a);

var $dnskZ = parcelRequire("dnskZ");

var $7oe8F = parcelRequire("7oe8F");
function $75a3aa60951dc58d$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $75a3aa60951dc58d$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $75a3aa60951dc58d$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $dnskZ.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $dnskZ.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $75a3aa60951dc58d$export$943d544ad120494a = function(_super) {
    (0, $dnskZ.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $75a3aa60951dc58d$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $75a3aa60951dc58d$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $75a3aa60951dc58d$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $7oe8F.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $7oe8F.ApolloLink));

});

parcelRegister("g4okI", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $bb2fe5188907aceb$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $bb2fe5188907aceb$export$3f9ecfb4d42ab23d);

var $jFDfc = parcelRequire("jFDfc");

var $fT6ea = parcelRequire("fT6ea");

var $ifBQy = parcelRequire("ifBQy");
function $bb2fe5188907aceb$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ifBQy.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jFDfc.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $bb2fe5188907aceb$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $fT6ea.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("fT6ea", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $b910d2b7906fe912$export$a13f755900e15d9e);

var $7oe8F = parcelRequire("7oe8F");

var $jFDfc = parcelRequire("jFDfc");

var $aW6ai = parcelRequire("aW6ai");

var $fhjWZ = parcelRequire("fhjWZ");
var $b910d2b7906fe912$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b910d2b7906fe912$var$graphql = $aW6ai.graphql;
var $b910d2b7906fe912$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $b910d2b7906fe912$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $b910d2b7906fe912$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $7oe8F.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fhjWZ.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jFDfc.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fhjWZ.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $b910d2b7906fe912$var$capitalizeFirstLetter(((0, $jFDfc.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $7oe8F.Observable).of({
                data: {}
            });
            return new (0, $7oe8F.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $b910d2b7906fe912$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $7oe8F.ApolloLink)))();
};

});
parcelRegister("aW6ai", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dnskZ = parcelRequire("dnskZ");

var $jFDfc = parcelRequire("jFDfc");

var $mY9dA = parcelRequire("mY9dA");
function $7f641a6fdcb80040$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jFDfc.getMainDefinition(document);
    var fragments = $jFDfc.getFragmentDefinitions(document);
    var fragmentMap = $jFDfc.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $7f641a6fdcb80040$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $7f641a6fdcb80040$var$graphql;
function $7f641a6fdcb80040$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $dnskZ.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $dnskZ.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $dnskZ.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $dnskZ.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jFDfc.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jFDfc.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $7f641a6fdcb80040$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jFDfc.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $mY9dA.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jFDfc.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $7f641a6fdcb80040$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $mY9dA.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $7f641a6fdcb80040$var$executeField(field, rootValue, execContext) {
    return $dnskZ.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $dnskZ.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jFDfc.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jFDfc.resultKeyNameFromField(field),
                        directives: $jFDfc.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $7f641a6fdcb80040$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $7f641a6fdcb80040$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $7f641a6fdcb80040$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $7f641a6fdcb80040$var$executeSubSelectedArray(field, item, execContext);
        return $7f641a6fdcb80040$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("mY9dA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jFDfc = parcelRequire("jFDfc");
function $0450b643c808decc$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jFDfc.getMainDefinition(document);
    var fragments = $jFDfc.getFragmentDefinitions(document);
    var fragmentMap = $jFDfc.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $0450b643c808decc$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $0450b643c808decc$var$graphql;
function $0450b643c808decc$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jFDfc.shouldInclude(selection, variables)) return;
        if ($jFDfc.isField(selection)) {
            var fieldResult = $0450b643c808decc$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jFDfc.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $0450b643c808decc$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jFDfc.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $0450b643c808decc$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $0450b643c808decc$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $0450b643c808decc$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jFDfc.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jFDfc.resultKeyNameFromField(field),
        directives: $jFDfc.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $0450b643c808decc$var$executeSubSelectedArray(field, result, execContext);
    return $0450b643c808decc$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $0450b643c808decc$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $0450b643c808decc$var$executeSubSelectedArray(field, item, execContext);
        return $0450b643c808decc$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $0450b643c808decc$var$hasOwn = Object.prototype.hasOwnProperty;
function $0450b643c808decc$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$0450b643c808decc$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $0450b643c808decc$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $0450b643c808decc$var$merge;

});


parcelRegister("fhjWZ", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b1f7eb4fa92dcb3d$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b1f7eb4fa92dcb3d$export$467f9c465e4ace4e);

var $6NFTG = parcelRequire("6NFTG");

var $jFDfc = parcelRequire("jFDfc");
var $b1f7eb4fa92dcb3d$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b1f7eb4fa92dcb3d$var$removed = new Map();
function $b1f7eb4fa92dcb3d$export$8eae69e876ee321e(query) {
    var cached = $b1f7eb4fa92dcb3d$var$removed.get(query);
    if (cached) return cached;
    (0, $jFDfc.checkDocument)(query);
    var docClone = (0, $jFDfc.removeDirectivesFromDocument)([
        $b1f7eb4fa92dcb3d$var$connectionRemoveConfig
    ], query);
    $b1f7eb4fa92dcb3d$var$removed.set(query, docClone);
    return docClone;
}
function $b1f7eb4fa92dcb3d$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $6NFTG.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("1fQNI", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $a01de03b371744d9$export$fb326ed954631f3f);

var $7oe8F = parcelRequire("7oe8F");

var $2QO3b = parcelRequire("2QO3b");
const $a01de03b371744d9$export$fb326ed954631f3f = new (0, $7oe8F.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $2QO3b.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("dk1mg", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardViewLayout\",\"possibleTypes\":[{\"name\":\"JiraBoardViewColumnLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraConfluencePageContent\",\"possibleTypes\":[{\"name\":\"JiraConfluencePageContentDetails\"},{\"name\":\"JiraConfluencePageContentError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldFormatConfig\",\"possibleTypes\":[{\"name\":\"JiraNumberFieldFormatConfig\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueError\",\"possibleTypes\":[{\"name\":\"JiraRemoteLinkedIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyItem\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkItem\"},{\"name\":\"JiraJourneyStatusDependency\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyTriggerConfiguration\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkdayIntegrationTriggerConfiguration\"},{\"name\":\"JiraJourneyParentIssueTriggerConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("gLqE0", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $b5b943618371ee76$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $b5b943618371ee76$export$a78ebe1911f50d41);

var $9Dhvc = parcelRequire("9Dhvc");

var $eezJL = parcelRequire("eezJL");

var $gYnSx = parcelRequire("gYnSx");
const $b5b943618371ee76$export$15d632fe38832073 = 'giraErrorAnalytics';
const $b5b943618371ee76$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$b5b943618371ee76$export$15d632fe38832073]: errorAnalytics
    });
const $b5b943618371ee76$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(context, [
        $b5b943618371ee76$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $b5b943618371ee76$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $b5b943618371ee76$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $eezJL.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $gYnSx.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("67Hrv", function(module, exports) {

$parcel$export(module.exports, "asyncNumberFormattingFlagEntryPoint", () => $5b4b7b0c33d7fdf8$export$a19a68721891aaaa);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $5b4b7b0c33d7fdf8$export$a19a68721891aaaa = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("lRBxl")), {
        moduleId: "744236cd",
        moduleName: "NumberFormattingFlag",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lRBxl", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("lsIY1").then(()=>parcelRequire('aLDUW'));

});


parcelRegister("iMQSg", function(module, exports) {

$parcel$export(module.exports, "useFetchCriteria", () => $992d850866bd2002$export$2c480b00ea27264d);

var $1fMqv = parcelRequire("1fMqv");

var $kEUB1 = parcelRequire("kEUB1");

var $3osLr = parcelRequire("3osLr");

var $6fDoI = parcelRequire("6fDoI");
const $992d850866bd2002$var$getURLPrefix = (projectType)=>{
    if (projectType === 'SOFTWARE') return 'software';
    if (projectType === 'BUSINESS') return 'core';
    return null;
};
const $992d850866bd2002$export$2c480b00ea27264d = (projectId, projectKey, enabled)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const projectAri = (0, $3osLr.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    });
    const { data: data } = (0, $1fMqv.useQuery)((0, $6fDoI.GET_NUMBER_CURRENCY_FORMATTING_CHANGEBOARDING_CRITIERA_QUERY), {
        variables: {
            projectAri: projectAri.toString(),
            projectKey: projectKey,
            first: 100
        },
        fetchPolicy: 'network-only',
        skip: !enabled
    });
    if (!data) return undefined;
    const isProjectAdmin = data.jira?.jiraProject?.administerProject?.canPerform ?? false;
    // Check if there already exists a JiraNumberField with a truthy formatConfig. This means an admin has already interacted with the new feature.
    const hasExistingNumberFieldWithFormatStyle = data.jiraBusinessAvailableFields?.edges?.some((edge)=>{
        return edge?.node?.fields?.edges?.some((fieldEdge)=>{
            const field = fieldEdge?.node;
            return field?.__typename === 'JiraNumberField' && field?.formatConfig?.formatStyle != null;
        });
    }) ?? false;
    const projectType = $992d850866bd2002$var$getURLPrefix(data.jira?.jiraProject?.projectType);
    const isTMP = Boolean(data.jira?.jiraProject?.tmpBoardId);
    return {
        isProjectAdmin: isProjectAdmin,
        hasExistingNumberFieldWithFormatStyle: hasExistingNumberFieldWithFormatStyle,
        projectType: projectType,
        isTMP: isTMP
    };
};

});
parcelRegister("1fMqv", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $0e9cc1ab166e5529$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $0e9cc1ab166e5529$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $0e9cc1ab166e5529$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $0e9cc1ab166e5529$export$eb9a56e7a29e494);

var $688i3 = parcelRequire("688i3");

var $dnskZ = parcelRequire("dnskZ");

var $eJOHy = parcelRequire("eJOHy");

var $eezJL = parcelRequire("eezJL");

var $hR4hP = parcelRequire("hR4hP");

var $lDEi6 = parcelRequire("lDEi6");
var $0e9cc1ab166e5529$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $hR4hP.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $lDEi6.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $688i3.parser)(document);
        var requiredOperationName = (0, $688i3.operationName)(type);
        var usedOperationName = (0, $688i3.operationName)(operation.type);
        (0, $lDEi6.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $0e9cc1ab166e5529$var$QueryData = function(_super) {
    (0, $dnskZ.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $eezJL.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $eezJL.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $688i3.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $dnskZ.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $hR4hP.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $hR4hP.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $hR4hP.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $eezJL.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $eezJL.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $hR4hP.equal)(this.previousOptions.query, query) && (0, $hR4hP.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($0e9cc1ab166e5529$var$OperationData);
function $0e9cc1ab166e5529$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eJOHy.useRef)();
    if (!ref.current || !(0, $hR4hP.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $0e9cc1ab166e5529$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eJOHy.useContext)((0, $688i3.getApolloContext)());
    var _a = (0, $eJOHy.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eJOHy.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $0e9cc1ab166e5529$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $0e9cc1ab166e5529$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eJOHy.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eJOHy.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $0e9cc1ab166e5529$export$dd0a697e1782aedd(query, options) {
    return $0e9cc1ab166e5529$var$useBaseQuery(query, options, false);
}
function $0e9cc1ab166e5529$export$fd83eea6ecd2d8fa(query, options) {
    return $0e9cc1ab166e5529$var$useBaseQuery(query, options, true);
}
var $0e9cc1ab166e5529$var$MutationData = function(_super) {
    (0, $dnskZ.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $688i3.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $688i3.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $dnskZ.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $dnskZ.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $eezJL.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $hR4hP.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($0e9cc1ab166e5529$var$OperationData);
function $0e9cc1ab166e5529$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eJOHy.useContext)((0, $688i3.getApolloContext)());
    var _a = (0, $eJOHy.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eJOHy.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $0e9cc1ab166e5529$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eJOHy.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $0e9cc1ab166e5529$var$SubscriptionData = function(_super) {
    (0, $dnskZ.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $hR4hP.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($0e9cc1ab166e5529$var$OperationData);
function $0e9cc1ab166e5529$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eJOHy.useContext)((0, $688i3.getApolloContext)());
    var updatedOptions = options ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eJOHy.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eJOHy.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $0e9cc1ab166e5529$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eJOHy.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eJOHy.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $0e9cc1ab166e5529$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $688i3.getApolloContext)()).client;
    (0, $lDEi6.invariant)(client, 1);
    return client;
}
function $0e9cc1ab166e5529$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $0e9cc1ab166e5529$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $0e9cc1ab166e5529$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("6fDoI", function(module, exports) {

$parcel$export(module.exports, "GET_NUMBER_CURRENCY_FORMATTING_CHANGEBOARDING_CRITIERA_QUERY", () => $5ff57059212c09df$export$375d6e56d498fe2f);
// eslint-disable-next-line jira/restricted/graphql-tag

var $kuAvn = parcelRequire("kuAvn");
const $5ff57059212c09df$export$375d6e56d498fe2f = (0, $kuAvn.default)`
	query getNumberCurrencyFormattingChangeboardingCriteria ($projectAri: ID!, $projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
		jira {
			jiraProject(id: $projectAri) {
				id
				projectId
				key
				name
				projectType
				tmpBoardId
				administerProject: action(type: EDIT_PROJECT_CONFIG) {
					canPerform
				}
			}
		}
		jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
			edges {
				node {
					issueType {
						issueTypeId
					}
					fields {
						edges {
							node {
								fieldId
								type
								... on JiraNumberField {
									fieldConfig {
										isRequired
										isEditable
									}
									formatConfig {
										... on JiraNumberFieldFormatConfig {
											formatStyle
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;

});


const $009a72c63c9d7dca$export$c2ff6ab935be7852 = 'jira-in-context-config-sidebar-changeboarding-trigger-id';
const $009a72c63c9d7dca$export$89bbc91416db6670 = 'jira-in-context-config-sidebar-changeboarding-event-id';

parcelRegister("4gH81", function(module, exports) {

$parcel$export(module.exports, "emitMessageEvent", () => $8c7b64ba40cdc0b2$export$3d0d0251b849dca6);

var $fceQU = parcelRequire("fceQU");

const $8c7b64ba40cdc0b2$export$3d0d0251b849dca6 = (eventDetails)=>{
    const event = new CustomEvent((0, $009a72c63c9d7dca$export$89bbc91416db6670), {
        detail: eventDetails
    });
    (0, $fceQU.getDocument)()?.dispatchEvent(event);
};

});


parcelRegister("3aisD", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e68baeabf38849c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dBLLk = parcelRequire("dBLLk");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e68baeabf38849c$var$AsyncAttachFileModal = (0, $bQWwW.lazy)(()=>(parcelRequire("4Ifwc")), {
    moduleId: "./src/packages/issue-navigator/issue-operations/dialogs/attach-file-dialog/src/ui/index.tsx"
});
const $1e68baeabf38849c$var$LazyAttachFileModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dBLLk.ModalBoundary), {
        id: "attach-file-dialog",
        packageName: "native-issue-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1e68baeabf38849c$var$AsyncAttachFileModal, null));
var $1e68baeabf38849c$export$2e2bcd8739ae039 = $1e68baeabf38849c$var$LazyAttachFileModal;

});
parcelRegister("4Ifwc", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7RRcE").then(()=>parcelRequire('2gnbS'));

});


parcelRegister("cTddL", function(module, exports) {

$parcel$export(module.exports, "DialogContextContainer", () => $d4ef871676e174ab$export$8e9ef3fae6d51d86);
$parcel$export(module.exports, "useIssueOperationsDialogContext", () => $d4ef871676e174ab$export$a2a00ec2da7337e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $d4ef871676e174ab$var$initialState = {
    openDialog: null,
    issueKey: null,
    issueId: null,
    workType: null,
    mediaUploadContext: null
};
const $d4ef871676e174ab$var$actions = {
    setDialogContext: (openDialog, issueId, issueKey, mediaUploadContext, workType)=>({ setState: setState })=>{
            setState({
                openDialog: openDialog,
                issueId: issueId,
                issueKey: issueKey,
                mediaUploadContext: mediaUploadContext,
                workType: workType
            });
        }
};
const $d4ef871676e174ab$var$Store = (0, $GtRbT.createStore)({
    initialState: $d4ef871676e174ab$var$initialState,
    actions: $d4ef871676e174ab$var$actions,
    name: 'IssueNavigatorIssueOperationsDialogContext'
});
const $d4ef871676e174ab$export$8e9ef3fae6d51d86 = (0, $6E16M.createContainer)($d4ef871676e174ab$var$Store);
const $d4ef871676e174ab$export$a2a00ec2da7337e = (0, $iJq0l.createHook)($d4ef871676e174ab$var$Store);

});

parcelRegister("d8Dow", function(module, exports) {

$parcel$export(module.exports, "MAX_COLUMNS", () => $0ea88860b9e82601$export$7ec4af037f372df4);
$parcel$export(module.exports, "createDebouncedColumnLoader", () => $0ea88860b9e82601$export$a6cff24b97727de1);
$parcel$export(module.exports, "REMOVE_COLUMNS", () => $0ea88860b9e82601$export$191e3e934175a609);
$parcel$export(module.exports, "ADD_COLUMNS", () => $0ea88860b9e82601$export$ccf17692f1fc979a);

var $3Zpjn = parcelRequire("3Zpjn");

const $0ea88860b9e82601$export$7ec4af037f372df4 = 500;
const $0ea88860b9e82601$export$a6cff24b97727de1 = (0, $3Zpjn.createGenericDebouncableDataLoader);
const $0ea88860b9e82601$export$191e3e934175a609 = 'REMOVE_COLUMNS';
const $0ea88860b9e82601$export$ccf17692f1fc979a = 'ADD_COLUMNS';

});
parcelRegister("3Zpjn", function(module, exports) {

$parcel$export(module.exports, "createGenericDebouncableDataLoader", () => $515f3085be272897$export$ea63a11564958c9e);

var $3s8bj = parcelRequire("3s8bj");
const $515f3085be272897$export$ea63a11564958c9e = (dataLoader)=>{
    const debouncedDataLoader = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((search, enableFullList, endCursor, cb)=>dataLoader(search, enableFullList, endCursor).then((data)=>{
            cb(data);
            return data;
        }), 500);
    return (search, enableFullList, endCursor, cb)=>{
        // No need to debounce When no search string is provided.
        // We want the initial list displaying as quickly as possible when a user reopens the dropdown.
        // It will be cached by the GraphQL client and debouncing will show an unneccessary spinner.
        if (!search) {
            debouncedDataLoader.cancel();
            return dataLoader(search, enableFullList, endCursor).then((data)=>{
                cb(data);
                return data;
            });
        }
        return debouncedDataLoader(search, enableFullList, endCursor, cb);
    };
};
var $515f3085be272897$export$2e2bcd8739ae039 = $515f3085be272897$export$ea63a11564958c9e;

});


parcelRegister("P01So", function(module, exports) {

$parcel$export(module.exports, "isNonNullish", () => $a4f78649e91890cd$export$70573498ee17fe1d);
$parcel$export(module.exports, "isKnownColumnType", () => $a4f78649e91890cd$export$e8280bcdc1c3f84);
$parcel$export(module.exports, "exclusiveGroupsOrIssuesFragment", () => $a4f78649e91890cd$export$7ac78cf15a1a4ba3);
$parcel$export(module.exports, "getProjectKeyFromIssueKey", () => $a4f78649e91890cd$export$defe38779a6b81d2);
$parcel$export(module.exports, "escapeBackslashes", () => $a4f78649e91890cd$export$fbd15c27bb7e257c);
$parcel$export(module.exports, "desanitizeField", () => $a4f78649e91890cd$export$261830fe943e88ac);

var $j8Km1 = parcelRequire("j8Km1");

function $a4f78649e91890cd$export$70573498ee17fe1d(value) {
    return value != null;
}
function $a4f78649e91890cd$export$e8280bcdc1c3f84(value) {
    return value !== undefined && Object.values((0, $j8Km1.KNOWN_COLUMN_TYPES)).includes(value);
}
function $a4f78649e91890cd$export$7ac78cf15a1a4ba3({ groups: groups, issues: issues }) {
    if (issues) return {
        groups: null,
        issues: issues
    };
    if (groups) return {
        groups: groups,
        issues: null
    };
    return null;
}
function $a4f78649e91890cd$export$defe38779a6b81d2(issueKey) {
    return issueKey.split('-')[0];
}
const $a4f78649e91890cd$export$fbd15c27bb7e257c = (text)=>text.replace(/\\/g, '\\\\');
const $a4f78649e91890cd$export$261830fe943e88ac = (field)=>{
    if (field.startsWith('"') && field.endsWith('"') || field.startsWith("'") && field.endsWith("'")) return field.slice(1, -1).toLocaleLowerCase();
    return field.toLocaleLowerCase();
};

});

parcelRegister("9Z7uc", function(module, exports) {

$parcel$export(module.exports, "useColumnWidthUpdater", () => $ff43ba53dfdeb1f7$export$e54397ae25183faf);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");
const $ff43ba53dfdeb1f7$export$e54397ae25183faf = (connectionId)=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)((columnId, width)=>{
        (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const connection = store.get(connectionId);
            const fieldSetEdges = connection?.getLinkedRecords('edges') ?? [];
            const fieldSetEdge = fieldSetEdges.find((edge)=>{
                const fieldSetId = edge?.getLinkedRecord('node')?.getValue('fieldSetId');
                return columnId === fieldSetId;
            });
            if (!fieldSetEdge) return;
            const fieldSetNode = fieldSetEdge.getLinkedRecord('node');
            if (!fieldSetNode) return;
            if (width == null) {
                fieldSetNode.setValue(null, 'fieldSetPreferences');
                return;
            }
            const fieldSetPreferences = fieldSetNode.getOrCreateLinkedRecord('fieldSetPreferences', 'JiraFieldSetPreferences');
            fieldSetPreferences.setValue(width, 'width');
        });
    }, [
        connectionId,
        environment
    ]);
};

});

parcelRegister("aJqsk", function(module, exports) {

$parcel$export(module.exports, "useColumnIsFrozenUpdater", () => $98d0ffd7ed5d8b81$export$f2cce0fcc63ce339);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");
const $98d0ffd7ed5d8b81$export$f2cce0fcc63ce339 = (connectionId)=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useCallback)((updatedColumns)=>{
        (0, $37Ewn.commitLocalUpdate)(environment, (store)=>{
            const connection = store.get(connectionId);
            if (!connection) return;
            const fieldSetEdges = connection.getLinkedRecords('edges') ?? [];
            updatedColumns.forEach(({ fieldSetId: fieldSetId, isFrozen: isFrozen })=>{
                const fieldSetEdge = fieldSetEdges.find((edge)=>{
                    const id = edge?.getLinkedRecord('node')?.getValue('fieldSetId');
                    return fieldSetId === id;
                });
                if (!fieldSetEdge) return;
                const fieldSetNode = fieldSetEdge.getLinkedRecord('node');
                if (!fieldSetNode) return;
                const fieldSetPreferences = fieldSetNode.getOrCreateLinkedRecord('fieldSetPreferences', 'JiraFieldSetPreferences');
                fieldSetPreferences.setValue(isFrozen, 'isFrozen');
            });
        });
    }, [
        connectionId,
        environment
    ]);
};

});

parcelRegister("j6nGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eaa6cd95847cbf4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $16sa1 = parcelRequire("16sa1");

var $1KdDN = parcelRequire("1KdDN");

var $2dBpR = parcelRequire("2dBpR");

var $7jTnu = parcelRequire("7jTnu");

var $5kYyR = parcelRequire("5kYyR");

var $kmIYY = parcelRequire("kmIYY");

const $0eaa6cd95847cbf4$var$AsyncNativeIssueTable = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("8ID8C")), {
    moduleId: "./src/packages/platform/ui/issue-table/issue-table/src/ui/NativeIssueTableWithSelectedIssuesProvider.tsx"
});
const $0eaa6cd95847cbf4$var$AsyncNativeIssueTableOld = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kmIYY.IssueTableSkeleton), null),
        name: "async-native-issue-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0eaa6cd95847cbf4$var$AsyncNativeIssueTable, props)));
const $0eaa6cd95847cbf4$var$AsyncNativeIssueTableNew = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const entryPointReference = props.preloadedEntryPoints?.nativeIssueTableEntryPoint;
    const ErrorBoundary = (0, $7jTnu.fg)('improve_nin_slo_events') ? (0, $5kYyR.default) : (0, $1KdDN.JSErrorBoundary);
    if (entryPointReference) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "native-issue-table-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ErrorBoundary, {
        id: "native-issue-table-entrypoint",
        packageName: "jiraNativeIssueTable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: "native-issue-table",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kmIYY.IssueTableSkeleton), null),
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // EntryPointContainer can't infer the type of props from entryPointReference correctly
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: props
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0eaa6cd95847cbf4$var$AsyncNativeIssueTableOld, props);
});
var $0eaa6cd95847cbf4$export$2e2bcd8739ae039 = $0eaa6cd95847cbf4$var$AsyncNativeIssueTableNew;

});
parcelRegister("kmIYY", function(module, exports) {

$parcel$export(module.exports, "IssueTableSkeleton", () => $d01bd5b1473e1c91$export$32020b6a5557f03e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $coBPg = parcelRequire("coBPg");
const $d01bd5b1473e1c91$export$32020b6a5557f03e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d01bd5b1473e1c91$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coBPg.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d01bd5b1473e1c91$var$SkeletonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8ID8C", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_nin_convert_issue_ops_to_entrypoint', function() {
        return Promise.all([
            $ewTvA("gD3cg")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("e01ok")
        ]);
    }),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("fliVL"),
    $ewTvA("jr04i")
]).then(()=>parcelRequire('3CqQm'));

});


parcelRegister("7auhX", function(module, exports) {

$parcel$export(module.exports, "useColumnPickerLoadingContext", () => $2142b09d72cf7255$export$bd7ab5278af9a7dd);
$parcel$export(module.exports, "ColumnPickerLoadingContextProvider", () => $2142b09d72cf7255$export$9e9936dbd6aef092);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $3kDjB = parcelRequire("3kDjB");
const $2142b09d72cf7255$var$defaultState = {
    isLoading: false,
    setIsRestoringDefaultColumns: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $2142b09d72cf7255$var$ColumnPickerLoadingContext = /*#__PURE__*/ (0, $eJOHy.createContext)($2142b09d72cf7255$var$defaultState);
const $2142b09d72cf7255$export$bd7ab5278af9a7dd = ()=>(0, $eJOHy.useContext)($2142b09d72cf7255$var$ColumnPickerLoadingContext);
const $2142b09d72cf7255$export$9e9936dbd6aef092 = ({ children: children })=>{
    const [isRestoringDefaultColumns, setIsRestoringDefaultColumns] = (0, $eJOHy.useState)(false);
    const isFetchingView = (0, $3kDjB.useIsFetchingView)();
    const isRefreshing = (0, $3kDjB.useIsRefreshing)();
    const isLoading = isRestoringDefaultColumns || isFetchingView || isRefreshing;
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            isLoading: isLoading,
            setIsRestoringDefaultColumns: setIsRestoringDefaultColumns
        }), [
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2142b09d72cf7255$var$ColumnPickerLoadingContext.Provider, {
        value: contextValue
    }, children);
};

});

parcelRegister("gTm2i", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerMessageContext", () => $24ec8e0d51fae54f$export$2f14e8286acf4660);

var $eJOHy = parcelRequire("eJOHy");
const $24ec8e0d51fae54f$var$defaultMessageContext = {
    hasMaxSelectedColumns: false
};
const $24ec8e0d51fae54f$export$2f14e8286acf4660 = /*#__PURE__*/ (0, $eJOHy.createContext)($24ec8e0d51fae54f$var$defaultMessageContext);

});

parcelRegister("kGfUm", function(module, exports) {

$parcel$export(module.exports, "useColumnLoader", () => $e32ebbab3934b1d3$export$6dc2ac601f90aafc);

var $5iSJ2 = parcelRequire("5iSJ2");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $fexQV = parcelRequire("fexQV");

var $3cMgR = parcelRequire("3cMgR");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $d8Dow = parcelRequire("d8Dow");

var $cjRWP = parcelRequire("cjRWP");

var $kEUB1 = parcelRequire("kEUB1");

var $awWeA = parcelRequire("awWeA");

var $fwKw5 = parcelRequire("fwKw5");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $1RINH = parcelRequire("1RINH");

var $iT8nA = parcelRequire("iT8nA");
const $e32ebbab3934b1d3$var$mapColumnPickerOptions = (data, search, intl, selectedColumns, canEditColumns, isColumnPickerChangesEnabled)=>{
    let totalCount = 0;
    let edges;
    let endCursor;
    const shouldUseOldQuery = !isColumnPickerChangesEnabled;
    if (shouldUseOldQuery && data?.jira.issueSearchViewByNamespaceAndViewId?.fieldSets) {
        totalCount = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount;
        edges = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges;
        endCursor = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.pageInfo?.endCursor ? data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.pageInfo.endCursor : undefined;
    }
    if (isColumnPickerChangesEnabled && data?.jira.jiraIssueSearchView?.fieldSets) {
        totalCount = data?.jira.jiraIssueSearchView.fieldSets.totalCount;
        edges = data?.jira.jiraIssueSearchView.fieldSets.edges;
        endCursor = data?.jira.jiraIssueSearchView.fieldSets.pageInfo?.endCursor ? data?.jira.jiraIssueSearchView.fieldSets.pageInfo.endCursor : undefined;
    }
    // @ts-expect-error - Argument of type '(edge: Node) => { secondaryLabel?: JSX.Element | undefined; isDisabled?: true | undefined; disabledMessage?: React.ReactNode; optionType: "option"; cursor: string; value: string; label: string; }' is not assignable to parameter of type '(value: { readonly cursor: string; readonly node: { readonly displayName: string; readonly fieldSetId: string; readonly fieldType?: { readonly displayName: string | null | undefined; } | null | undefined; readonly type: string; }; }, index: number, array: { ...; }[]) => { ...; }'.
    const options = edges?.filter((0, $eibCx.isNonNullish)).map((edge)=>{
        const fieldTypeDisplayName = edge.node.fieldType?.displayName;
        const icon = edge.node.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fexQV.FieldTypeIcon), {
            type: edge.node.type,
            size: "small"
        }) : undefined;
        const isOnlyUnselectable = (0, $iT8nA.isOnlyUnselectableField)(edge.node.type, canEditColumns);
        return {
            optionType: 'option',
            cursor: edge.cursor,
            value: edge.node.fieldSetId,
            label: edge.node.displayName,
            secondaryLabel: fieldTypeDisplayName && icon ? (0, $cjRWP.getSecondaryLabelWithIcon)(icon, fieldTypeDisplayName) : undefined,
            ...isOnlyUnselectable && {
                isOnlyUnselectable: isOnlyUnselectable,
                disabledMessage: intl.formatMessage((0, $1RINH.default).deprecatedParentyLinkMessage, {
                    field: edge.node.displayName,
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                            as: "strong",
                            color: "inherit",
                            size: "UNSAFE_small"
                        }, chunks)
                })
            },
            ...isColumnPickerChangesEnabled && {
                customWidth: edge.node.fieldSetPreferences?.width,
                type: edge.node.type
            }
        };
    });
    if (!options?.length) return {
        options: [],
        totalCount: 0
    };
    if (search.length) return {
        options: options,
        totalCount: totalCount,
        endCursor: endCursor
    };
    // total count is the count of unselected options for non-search queries
    totalCount += selectedColumns.length;
    return {
        options: [
            {
                id: (0, $iRahl.ALL_COLUMNS_ID),
                label: intl.formatMessage((0, $1RINH.default).columnGroupHeader),
                optionType: 'group',
                options: options
            }
        ],
        totalCount: totalCount,
        endCursor: endCursor
    };
};
const $e32ebbab3934b1d3$export$6dc2ac601f90aafc = (viewId, canEditColumns, selectedColumns, isColumnPickerChangesEnabled, isIFCEnabled, projectContext, savedViewId)=>{
    const intl = (0, $lRq8t.default)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const resolvedJql = isColumnPickerChangesEnabled ? (0, $fwKw5.useResolvedJql)() : '';
    // refs for selectedColumns, endCursor and search prevent outdated data in the relay store from being used
    // in cases when selected options changes & picker is paginated
    const columnsRef = (0, $eJOHy.useRef)(selectedColumns);
    const endCursorRef = (0, $eJOHy.useRef)();
    const searchRef = (0, $eJOHy.useRef)();
    const loadedOptionsRef = (0, $eJOHy.useRef)();
    return (0, $eJOHy.useMemo)(()=>(0, $d8Dow.createDebouncedColumnLoader)(async (search, renderInitialValues, endCursor)=>{
            let cursor = endCursor;
            if (!canEditColumns) {
                const options = selectedColumns ? selectedColumns.filter((col)=>col.optionType === 'option' && (search ? col.label.toLocaleLowerCase().includes(search.toLocaleLowerCase()) : true)) : [];
                return Promise.resolve({
                    options: options,
                    totalCount: options.length
                });
            }
            // calculate cursor from edges, since endCursor might not be valid anymore when last option was selected
            if (endCursor !== undefined && loadedOptionsRef.current && selectedColumns) cursor = (0, $iT8nA.getCursorOfLastUnselectedOption)(loadedOptionsRef.current, selectedColumns, search, endCursor);
            try {
                const result = await (0, $j4oe4.fetchQuery)(environment, (0, $5iSJ2.default), {
                    cloudId: cloudId,
                    namespace: (0, $iRahl.ISSUE_SEARCH_NAMESPACE),
                    viewId: viewId,
                    first: 25,
                    after: cursor,
                    filter: {
                        searchString: search,
                        fieldSetSelectedState: !search ? 'NON_SELECTED' : 'ALL'
                    },
                    shouldUseNewQuery: !!isColumnPickerChangesEnabled,
                    jql: resolvedJql,
                    ...isIFCEnabled && projectContext ? {
                        scope: {
                            operationScope: (0, $awWeA.getOperationScope)(projectContext),
                            projectKey: projectContext
                        }
                    } : {},
                    ...savedViewId && !!isColumnPickerChangesEnabled ? {
                        viewQueryInput: {
                            viewAri: savedViewId
                        }
                    } : {}
                }, {
                    fetchPolicy: columnsRef.current !== selectedColumns || endCursorRef.current !== cursor || searchRef.current !== search ? 'network-only' : 'store-or-network'
                }).toPromise();
                columnsRef.current = selectedColumns;
                endCursorRef.current = cursor;
                searchRef.current = search;
                const pickerOptions = $e32ebbab3934b1d3$var$mapColumnPickerOptions(result, search, intl, selectedColumns, canEditColumns, isColumnPickerChangesEnabled);
                loadedOptionsRef.current = pickerOptions.options || undefined;
                return pickerOptions;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gYnSx.default)({
                    meta: {
                        id: 'fetchColumnPickerOptions',
                        packageName: (0, $iRahl.PACKAGE_NAME),
                        teamName: (0, $iRahl.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                loadedOptionsRef.current = undefined;
                return {
                    options: [
                        {
                            optionType: 'error',
                            error: error,
                            onRetry: ()=>undefined
                        }
                    ],
                    totalCount: 0
                };
            }
        }), [
        canEditColumns,
        selectedColumns,
        environment,
        cloudId,
        viewId,
        isColumnPickerChangesEnabled,
        resolvedJql,
        isIFCEnabled,
        projectContext,
        intl,
        savedViewId
    ]);
};

});
parcelRegister("5iSJ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c5912434f6b31fa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cb75557034e118e705b72aa5471bb088>>
 * @relayHash aa342fa36e6ccf329bb4c4a82569957c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 596189f4cdf63f073c86027bf37be000c81010d67680caacc3fc256f319f8b36
const $4c5912434f6b31fa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldUseNewQuery"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewQueryInput"
    }, v10 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v11 = {
        "kind": "Variable",
        "name": "namespace",
        "variableName": "namespace"
    }, v12 = {
        "kind": "Variable",
        "name": "viewId",
        "variableName": "viewId"
    }, v13 = [
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v14 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v15 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v16 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v17 = [
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v18 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v19 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v21 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "type"
    }, v24 = {
        "concreteType": "JiraFieldType",
        "kind": "LinkedField",
        "name": "fieldType",
        "plural": false,
        "selections": [
            v22 /*: any*/ 
        ]
    }, v25 = [
        v10 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "jql",
                    "variableName": "jql"
                }
            ],
            "kind": "ObjectValue",
            "name": "issueSearchInput"
        },
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "viewQueryInput",
            "variableName": "viewQueryInput"
        }
    ], v26 = [
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        }
    ], v27 = {
        "concreteType": "JiraFieldSetPreferences",
        "kind": "LinkedField",
        "name": "fieldSetPreferences",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "width"
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchColumnPickerOptionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "shouldUseNewQuery",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchView",
                                            "kind": "LinkedField",
                                            "name": "issueSearchViewByNamespaceAndViewId",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "args": v17 /*: any*/ ,
                                                        "concreteType": "JiraIssueSearchFieldSetConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSets",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v18 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount"
                                                            },
                                                            v19 /*: any*/ ,
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssueSearchFieldSet",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v21 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.fieldSetId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v22 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.displayName"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v23 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.type"
                                                                                    },
                                                                                    v24 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.issueSearchViewByNamespaceAndViewId"
                                    }
                                ]
                            },
                            {
                                "condition": "shouldUseNewQuery",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v25 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "jiraIssueSearchView",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v26 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v18 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.jiraIssueSearchView.fieldSets.totalCount"
                                                                },
                                                                v19 /*: any*/ ,
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueSearchFieldSetEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v20 /*: any*/ ,
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v21 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "jira.jiraIssueSearchView.fieldSets.edges.node.fieldSetId"
                                                                                        },
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v22 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "jira.jiraIssueSearchView.fieldSets.edges.node.displayName"
                                                                                        },
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v23 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "jira.jiraIssueSearchView.fieldSets.edges.node.type"
                                                                                        },
                                                                                        v24 /*: any*/ ,
                                                                                        v27 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraIssueSearchView.fieldSets.edges.node"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.jiraIssueSearchView.fieldSets.edges"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.jiraIssueSearchView"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v8 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchColumnPickerOptionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "shouldUseNewQuery",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v13 /*: any*/ ,
                                    "concreteType": "JiraIssueSearchView",
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewByNamespaceAndViewId",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                v22 /*: any*/ ,
                                                                v23 /*: any*/ ,
                                                                v24 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "shouldUseNewQuery",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v25 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "jiraIssueSearchView",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v26 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v27 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraSpreadsheetView",
                                            "abstractKey": "__isJiraSpreadsheetView"
                                        },
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "596189f4cdf63f073c86027bf37be000c81010d67680caacc3fc256f319f8b36",
            "metadata": {},
            "name": "fetchColumnPickerOptionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4c5912434f6b31fa$var$node.hash = "4b3e3e1db4a39879bc9be7e92b974da7";
var $4c5912434f6b31fa$export$2e2bcd8739ae039 = $4c5912434f6b31fa$var$node;

});

parcelRegister("fexQV", function(module, exports) {

$parcel$export(module.exports, "fieldTypesIcons", () => $a32db5a6d1618aac$export$67f993f3bbfb364d);
$parcel$export(module.exports, "panelIcons", () => $a32db5a6d1618aac$export$4641b622f6c36f58);
$parcel$export(module.exports, "allFieldTypeGlyphs", () => $a32db5a6d1618aac$export$14355977bfae6aaa);
$parcel$export(module.exports, "StrictFieldTypeIcon", () => $a32db5a6d1618aac$export$aaac7dbe01e6025d);
$parcel$export(module.exports, "FieldTypeIcon", () => $a32db5a6d1618aac$export$87c5289d8835f589);
$parcel$export(module.exports, "default", () => $a32db5a6d1618aac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $9qes7 = parcelRequire("9qes7");

var $jlvUH = parcelRequire("jlvUH");

var $hMpZ8 = parcelRequire("hMpZ8");

var $76mtb = parcelRequire("76mtb");

var $fwfzA = parcelRequire("fwfzA");

var $7jTnu = parcelRequire("7jTnu");

var $bJscI = parcelRequire("bJscI");

var $814y1 = parcelRequire("814y1");

var $h7qTf = parcelRequire("h7qTf");

var $33mJg = parcelRequire("33mJg");
// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => ReactElement<any, string | JSXElementConstructor<any>>' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
const $a32db5a6d1618aac$var$ResizedIcon = ({ glyph: glyph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: glyph,
        size: "medium"
    });
const $a32db5a6d1618aac$var$TeamCfTypeIcon = (0, $bJscI.componentWithFG)('twcj-37_update_team_icons_and_avatars_in_jira', (0, (/*@__PURE__*/$parcel$interopDefault($fwfzA))), (0, (/*@__PURE__*/$parcel$interopDefault($hMpZ8))));
const $a32db5a6d1618aac$var$checkedFieldTypesIcons = {
    [(0, $814y1.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.numberGlyph)
    }),
    [(0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.numberGlyph)
    }),
    [(0, $814y1.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    [(0, $814y1.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    [(0, $814y1.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    [(0, $814y1.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.radioGlyph)
    }),
    [(0, $814y1.SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.MULTI_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.doubleDropdownGlyph)
    }),
    [(0, $814y1.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $h7qTf.USERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $h7qTf.MULTIUSERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.FLAGGED_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    [(0, $814y1.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    [(0, $814y1.TEAM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    // <ResizedIcon /> was introduced when SWIFT had a limited number of supported field types,
    // but it's no longer a scalable option. We should be using icons directly provided by @atlaskit,
    // and if it does not match our design constraints, then we'll need to investigate contributing to a new @atlaskit icon set.
    [(0, $814y1.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$TeamCfTypeIcon, {
        spacing: "spacious",
        label: ""
    }),
    [(0, $814y1.PARENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    [(0, $814y1.BASELINE_START_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    [(0, $814y1.BASELINE_END_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    [(0, $814y1.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.shipGlyph)
    }),
    [(0, $814y1.REQUEST_PARTICIPANTS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGroupGlyph)
    }),
    [(0, $814y1.ORGANIZATIONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.officeBuildingGlyph)
    }),
    [(0, $814y1.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.ATTACHMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.attachmentGlyph)
    }),
    [(0, $814y1.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    [(0, $814y1.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.priorityGlyph)
    }),
    [(0, $814y1.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    [(0, $814y1.TIME_ESTIMATE_CONFIG_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    [(0, $814y1.TIME_TRACKING_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeTrackingGlyph)
    }),
    [(0, $814y1.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.originalTimeEstimateGlyph)
    }),
    [(0, $814y1.ASSETS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.screenGlyph)
    }),
    [(0, $814y1.SERVICE_ENTITY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    [(0, $814y1.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.arrowRightGlyph)
    }),
    [(0, $814y1.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.shortTextGlyph)
    }),
    [(0, $h7qTf.DESCRIPTION_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.shortTextGlyph)
    }),
    [(0, $h7qTf.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.checkboxGlyph)
    }),
    [(0, $814y1.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    [(0, $h7qTf.ENVIRONMENT_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.commentGlyph)
    }),
    [(0, $814y1.APPROVERS_LIST_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.appAccessGlyph)
    }),
    [(0, $814y1.APPROVALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.appAccessGlyph)
    }),
    [(0, $814y1.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.folderGlyph)
    }),
    [(0, $814y1.MESSAGE_EDIT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.MESSAGE_VIEW_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.jwmCategoryGlyph)
    }),
    [(0, $814y1.ENTITLEMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.SENTIMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    [(0, $814y1.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }),
    [(0, $814y1.ORGANIZATION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    })
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
({
    ...$a32db5a6d1618aac$var$checkedFieldTypesIcons
});
const $a32db5a6d1618aac$export$67f993f3bbfb364d = $a32db5a6d1618aac$var$checkedFieldTypesIcons;
const $a32db5a6d1618aac$export$4641b622f6c36f58 = {
    development: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jlvUH))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    }),
    devSummary: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jlvUH))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    }),
    timetracking: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($76mtb))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    })
};
/**
 * @deprecated - consider using allFieldTypeGlyphs or FieldTypeIcon instead
 */ const $a32db5a6d1618aac$var$allIcons = {
    ...$a32db5a6d1618aac$export$67f993f3bbfb364d,
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    number: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.numberGlyph)
    }),
    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    datetime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    dropdown: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    addon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.addonGlyph)
    }),
    checkbox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.checkboxGlyph)
    }),
    user: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    radio: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.radioGlyph)
    }),
    time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.commentGlyph)
    }),
    bulletList: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.bulletListGlyph)
    }),
    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    labelpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    close: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.closeGlyph)
    }),
    assetspicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.screenGlyph)
    }),
    select: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    multiselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    cascadingselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.doubleDropdownGlyph)
    }),
    multigrouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    grouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    multiversion: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    version: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    projectpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    customField: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    })
};
const $a32db5a6d1618aac$var$checkedFieldTypesGlyphs = {
    [(0, $814y1.NUMBER_CF_TYPE)]: (0, $33mJg.numberGlyph),
    [(0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $33mJg.numberGlyph),
    [(0, $814y1.LABELS_CF_TYPE)]: (0, $33mJg.labelGlyph),
    [(0, $814y1.DATE_CF_TYPE)]: (0, $33mJg.dateGlyph),
    [(0, $814y1.DATETIME_CF_TYPE)]: (0, $33mJg.timeStampGlyph),
    [(0, $814y1.RADIO_BUTTONS_CF_TYPE)]: (0, $33mJg.radioGlyph),
    [(0, $814y1.SELECT_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.MULTI_SELECT_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.CASCADING_SELECT_CF_TYPE)]: (0, $33mJg.doubleDropdownGlyph),
    [(0, $814y1.MULTI_VERSION_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.VERSION_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.GROUP_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.MULTI_GROUP_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.USER_CF_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $h7qTf.USERPICKER_FIELD_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.MULTI_USER_CF_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $h7qTf.MULTIUSERPICKER_FIELD_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.PEOPLE_CF_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.FLAGGED_CF_TYPE)]: (0, $33mJg.timeStampGlyph),
    [(0, $814y1.URL_CF_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $814y1.TEAM_CF_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $814y1.PARENT_CF_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $814y1.BASELINE_START_CF_TYPE)]: (0, $33mJg.dateGlyph),
    [(0, $814y1.BASELINE_END_CF_TYPE)]: (0, $33mJg.dateGlyph),
    [(0, $814y1.SPRINT_TYPE)]: (0, $33mJg.shipGlyph),
    [(0, $814y1.REQUEST_PARTICIPANTS_CF_TYPE)]: (0, $33mJg.peopleGroupGlyph),
    [(0, $814y1.ORGANIZATIONS_CF_TYPE)]: (0, $33mJg.officeBuildingGlyph),
    [(0, $814y1.REPORTER_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.ATTACHMENT_TYPE)]: (0, $33mJg.attachmentGlyph),
    [(0, $814y1.ASSIGNEE_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.LABELS_TYPE)]: (0, $33mJg.labelGlyph),
    [(0, $814y1.PRIORITY_TYPE)]: (0, $33mJg.priorityGlyph),
    [(0, $814y1.DUE_DATE_TYPE)]: (0, $33mJg.dateGlyph),
    [(0, $814y1.TIME_ESTIMATE_CONFIG_TYPE)]: (0, $33mJg.timeStampGlyph),
    [(0, $814y1.TIME_TRACKING_TYPE)]: (0, $33mJg.timeTrackingGlyph),
    [(0, $814y1.TIME_ESTIMATE_TYPE)]: (0, $33mJg.originalTimeEstimateGlyph),
    [(0, $814y1.ASSETS_CF_TYPE)]: (0, $33mJg.screenGlyph),
    [(0, $814y1.SERVICE_ENTITY_CF_TYPE)]: (0, $33mJg.labelGlyph),
    [(0, $814y1.STATUS_TYPE)]: (0, $33mJg.arrowRightGlyph),
    [(0, $814y1.SUMMARY_TYPE)]: (0, $33mJg.shortTextGlyph),
    [(0, $h7qTf.DESCRIPTION_FIELD_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.TEXT_CF_TYPE)]: (0, $33mJg.shortTextGlyph),
    [(0, $h7qTf.TEXT_AREA_CF_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.MULTI_CHECKBOXES_CF_TYPE)]: (0, $33mJg.checkboxGlyph),
    [(0, $814y1.ISSUE_LINKS_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $h7qTf.ENVIRONMENT_FIELD_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.FIX_VERSIONS_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.COMMENT_TYPE)]: (0, $33mJg.commentGlyph),
    [(0, $814y1.APPROVERS_LIST_CF_TYPE)]: (0, $33mJg.appAccessGlyph),
    [(0, $814y1.APPROVALS_CF_TYPE)]: (0, $33mJg.appAccessGlyph),
    [(0, $814y1.PROJECT_PICKER_CF_TYPE)]: (0, $33mJg.folderGlyph),
    [(0, $814y1.MESSAGE_EDIT_CF_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.MESSAGE_VIEW_CF_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.CATEGORY_TYPE)]: (0, $33mJg.jwmCategoryGlyph),
    [(0, $814y1.ENTITLEMENT_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.SENTIMENT_CF_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $814y1.ORGANIZATION_CF_TYPE)]: (0, $33mJg.customFieldGlyph)
};
const $a32db5a6d1618aac$export$14355977bfae6aaa = {
    ...$a32db5a6d1618aac$var$checkedFieldTypesGlyphs,
    text: (0, $33mJg.paragraphGlyph),
    number: (0, $33mJg.numberGlyph),
    date: (0, $33mJg.dateGlyph),
    datetime: (0, $33mJg.timeStampGlyph),
    dropdown: (0, $33mJg.dropdownGlyph),
    addon: (0, $33mJg.addonGlyph),
    checkbox: (0, $33mJg.checkboxGlyph),
    user: (0, $33mJg.peopleGlyph),
    radio: (0, $33mJg.radioGlyph),
    time: (0, $33mJg.timeStampGlyph),
    message: (0, $33mJg.commentGlyph),
    bulletList: (0, $33mJg.bulletListGlyph),
    label: (0, $33mJg.labelGlyph),
    labelpicker: (0, $33mJg.labelGlyph),
    close: (0, $33mJg.closeGlyph),
    assetspicker: (0, $33mJg.screenGlyph),
    select: (0, $33mJg.dropdownGlyph),
    multiselect: (0, $33mJg.dropdownGlyph),
    cascadingselect: (0, $33mJg.doubleDropdownGlyph),
    multigrouppicker: (0, $33mJg.dropdownGlyph),
    grouppicker: (0, $33mJg.dropdownGlyph),
    multiversion: (0, $33mJg.dropdownGlyph),
    version: (0, $33mJg.dropdownGlyph),
    projectpicker: (0, $33mJg.dropdownGlyph),
    customField: (0, $33mJg.customFieldGlyph)
};
const $a32db5a6d1618aac$export$aaac7dbe01e6025d = /*#__PURE__*/ (0, $eJOHy.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $814y1.TEAMS_PLATFORM_CF_TYPE)) return (0, $7jTnu.fg)('twcj-37_update_team_icons_and_avatars_in_jira') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fwfzA))), {
        label: "",
        size: size,
        spacing: "spacious",
        testId: testId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMpZ8))), {
        label: "",
        size: size,
        testId: testId
    });
    if (type === (0, $814y1.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: $a32db5a6d1618aac$var$checkedFieldTypesGlyphs[type] || $a32db5a6d1618aac$var$checkedFieldTypesGlyphs.customField,
        size: size,
        testId: testId
    });
});
const $a32db5a6d1618aac$export$87c5289d8835f589 = /*#__PURE__*/ (0, $eJOHy.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $814y1.TEAMS_PLATFORM_CF_TYPE)) {
        const iconSpacing = size === 'small' ? 'compact' : 'spacious';
        return (0, $7jTnu.fg)('twcj-37_update_team_icons_and_avatars_in_jira') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fwfzA))), {
            label: "",
            size: size,
            spacing: iconSpacing,
            testId: testId
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMpZ8))), {
            label: "",
            size: size,
            testId: testId
        });
    }
    if (type === (0, $814y1.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: $a32db5a6d1618aac$export$14355977bfae6aaa[type] || $a32db5a6d1618aac$export$14355977bfae6aaa.customField,
        size: size,
        testId: testId
    });
});
var /**
 * @deprecated - Use allFieldTypeGlyphs or FieldTypeIcon instead.
 */ $a32db5a6d1618aac$export$2e2bcd8739ae039 = $a32db5a6d1618aac$var$allIcons;

});
parcelRegister("jlvUH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f5c3fed69a8cb0568c41e9976d2cb29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e158bbdd28450239$var$_react = $e158bbdd28450239$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e158bbdd28450239$var$_branch = $e158bbdd28450239$var$_interopRequireDefault((parcelRequire("awZZu")));

var $e158bbdd28450239$var$_branches = $e158bbdd28450239$var$_interopRequireDefault((parcelRequire("1H8nC")));
function $e158bbdd28450239$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BranchIcon.
 * This component is BranchIcon, with `UNSAFE_fallbackIcon` set to "BitbucketBranchesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e158bbdd28450239$var$BranchIcon = (props)=>/*#__PURE__*/ $e158bbdd28450239$var$_react.default.createElement($e158bbdd28450239$var$_branch.default, Object.assign({
        name: "BranchIcon",
        LEGACY_fallbackIcon: $e158bbdd28450239$var$_branches.default
    }, props));
$e158bbdd28450239$var$BranchIcon.displayName = 'BranchIconMigration';
var $e158bbdd28450239$var$_default = module.exports.default = $e158bbdd28450239$var$BranchIcon;

});
parcelRegister("awZZu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5d8d971bf9def65ea3fd98a53d2a797b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aacfa98324a1e60$var$_react = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7aacfa98324a1e60$var$_baseNew = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7aacfa98324a1e60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aacfa98324a1e60$var$BranchIcon = (props)=>/*#__PURE__*/ $7aacfa98324a1e60$var$_react.default.createElement($7aacfa98324a1e60$var$_baseNew.default, Object.assign({
        name: "BranchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$7aacfa98324a1e60$var$BranchIcon.displayName = 'BranchIcon';
var $7aacfa98324a1e60$var$_default = module.exports.default = $7aacfa98324a1e60$var$BranchIcon;

});

parcelRegister("1H8nC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $13c04eaf2d4940c0$var$_react = $13c04eaf2d4940c0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $13c04eaf2d4940c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $13c04eaf2d4940c0$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $13c04eaf2d4940c0$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props));
$13c04eaf2d4940c0$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $13c04eaf2d4940c0$var$_default = module.exports.default = $13c04eaf2d4940c0$var$BitbucketBranchesIcon;

});


parcelRegister("76mtb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e189c4a599d81ae424744c77036b157>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52ba85f679c445d8$var$_react = $52ba85f679c445d8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $52ba85f679c445d8$var$_stopwatch = $52ba85f679c445d8$var$_interopRequireDefault((parcelRequire("1x1T9")));

var $52ba85f679c445d8$var$_stopwatch2 = $52ba85f679c445d8$var$_interopRequireDefault((parcelRequire("5NWMp")));
function $52ba85f679c445d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StopwatchIcon.
 * This component is StopwatchIcon, with `UNSAFE_fallbackIcon` set to "StopwatchIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $52ba85f679c445d8$var$StopwatchIcon = (props)=>/*#__PURE__*/ $52ba85f679c445d8$var$_react.default.createElement($52ba85f679c445d8$var$_stopwatch.default, Object.assign({
        name: "StopwatchIcon",
        LEGACY_fallbackIcon: $52ba85f679c445d8$var$_stopwatch2.default
    }, props));
$52ba85f679c445d8$var$StopwatchIcon.displayName = 'StopwatchIconMigration';
var $52ba85f679c445d8$var$_default = module.exports.default = $52ba85f679c445d8$var$StopwatchIcon;

});
parcelRegister("1x1T9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::151fe33e88b0ee8f745faaf0f04d86d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $11da568a8257a9ac$var$_react = $11da568a8257a9ac$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $11da568a8257a9ac$var$_baseNew = $11da568a8257a9ac$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $11da568a8257a9ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Stopwatch".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $11da568a8257a9ac$var$StopwatchIcon = (props)=>/*#__PURE__*/ $11da568a8257a9ac$var$_react.default.createElement($11da568a8257a9ac$var$_baseNew.default, Object.assign({
        name: "StopwatchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 0h6v1.5H8.75v1.543a6.47 6.47 0 0 1 3.06 1.19l1.137-1.24 1.106 1.014-1.137 1.24a6.5 6.5 0 1 1-9.832 0l-1.137-1.24 1.106-1.014 1.137 1.24a6.47 6.47 0 0 1 3.06-1.19V1.5H5zm3 4.5a4.98 4.98 0 0 0-3.378 1.314A5 5 0 1 0 8 4.5m2.842 3.01-2.541 2.75-1.102-1.02 2.542-2.75z" clip-rule="evenodd"/>`
    }, props));
$11da568a8257a9ac$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $11da568a8257a9ac$var$_default = module.exports.default = $11da568a8257a9ac$var$StopwatchIcon;

});

parcelRegister("5NWMp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $439f1fc60d1c82c5$var$_react = $439f1fc60d1c82c5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $439f1fc60d1c82c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $439f1fc60d1c82c5$var$StopwatchIcon = (props)=>/*#__PURE__*/ $439f1fc60d1c82c5$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.587 6.988.626-.664c.203-.215.481-.324.76-.324.247 0 .496.086.694.262a.98.98 0 0 1 .063 1.414l-.565.6a7 7 0 1 1-10.33 0l-.564-.6a.98.98 0 0 1 .062-1.414A1.04 1.04 0 0 1 7.03 6c.278 0 .556.109.76.324l.624.664a7 7 0 0 1 2.582-.916L10.998 5H10.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.498l.001 1.071a7 7 0 0 1 2.584.917M12 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10m.368-4.232a.796.796 0 0 1-1.14-.018.834.834 0 0 1 .018-1.163l2.386-2.355a.796.796 0 0 1 1.14.018.834.834 0 0 1-.018 1.163z"/></svg>`
    }, props));
$439f1fc60d1c82c5$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $439f1fc60d1c82c5$var$_default = module.exports.default = $439f1fc60d1c82c5$var$StopwatchIcon;

});


parcelRegister("33mJg", function(module, exports) {

$parcel$export(module.exports, "numberGlyph", () => $845d6a4dfc3d7122$export$b368272069fe93ea);
$parcel$export(module.exports, "checkboxGlyph", () => $845d6a4dfc3d7122$export$747056db840f2e62);
$parcel$export(module.exports, "folderGlyph", () => $845d6a4dfc3d7122$export$fc939f15c0ac57d8);
$parcel$export(module.exports, "dateGlyph", () => $845d6a4dfc3d7122$export$54ae6633cc16eed1);
$parcel$export(module.exports, "dropdownGlyph", () => $845d6a4dfc3d7122$export$d298f123ec74117c);
$parcel$export(module.exports, "doubleDropdownGlyph", () => $845d6a4dfc3d7122$export$b3ea0fc10228ca3e);
$parcel$export(module.exports, "labelGlyph", () => $845d6a4dfc3d7122$export$fc64eea29ed0831d);
$parcel$export(module.exports, "paragraphGlyph", () => $845d6a4dfc3d7122$export$cbee9ded46569696);
$parcel$export(module.exports, "peopleGlyph", () => $845d6a4dfc3d7122$export$2ade78849d2113ea);
$parcel$export(module.exports, "shortTextGlyph", () => $845d6a4dfc3d7122$export$1c6cf19eb34bcc14);
$parcel$export(module.exports, "timeStampGlyph", () => $845d6a4dfc3d7122$export$98a4a461fe316fce);
$parcel$export(module.exports, "timeTrackingGlyph", () => $845d6a4dfc3d7122$export$637d50811e2b7176);
$parcel$export(module.exports, "originalTimeEstimateGlyph", () => $845d6a4dfc3d7122$export$bc2bb299bed9df91);
$parcel$export(module.exports, "arrowRightGlyph", () => $845d6a4dfc3d7122$export$3a9d3f1c52f4dab9);
$parcel$export(module.exports, "addonGlyph", () => $845d6a4dfc3d7122$export$a4cdad58220c405a);
$parcel$export(module.exports, "attachmentGlyph", () => $845d6a4dfc3d7122$export$e6e85f1bc2e23bd4);
$parcel$export(module.exports, "bulletListGlyph", () => $845d6a4dfc3d7122$export$a6a7f7b7c0399a2a);
$parcel$export(module.exports, "commentGlyph", () => $845d6a4dfc3d7122$export$835d228e2a9d6a93);
$parcel$export(module.exports, "officeBuildingGlyph", () => $845d6a4dfc3d7122$export$fdad804cb16a6544);
$parcel$export(module.exports, "peopleGroupGlyph", () => $845d6a4dfc3d7122$export$a20644de4b67f161);
$parcel$export(module.exports, "radioGlyph", () => $845d6a4dfc3d7122$export$ce87e45dceec205d);
$parcel$export(module.exports, "shipGlyph", () => $845d6a4dfc3d7122$export$d95e2215202c8556);
$parcel$export(module.exports, "priorityGlyph", () => $845d6a4dfc3d7122$export$3062e49c5521698d);
$parcel$export(module.exports, "screenGlyph", () => $845d6a4dfc3d7122$export$17d48fc8b753df77);
$parcel$export(module.exports, "closeGlyph", () => $845d6a4dfc3d7122$export$cbbe21ca62a58ed6);
$parcel$export(module.exports, "appAccessGlyph", () => $845d6a4dfc3d7122$export$8fd991b9da3a43e5);
$parcel$export(module.exports, "jwmCategoryGlyph", () => $845d6a4dfc3d7122$export$f21213fb7b480582);
$parcel$export(module.exports, "customFieldGlyph", () => $845d6a4dfc3d7122$export$88453606d7da6ff7);

var $eJOHy = parcelRequire("eJOHy");
const $845d6a4dfc3d7122$export$b368272069fe93ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$747056db840f2e62 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4 5.994C4 4.893 4.895 4 5.994 4h12.012C19.107 4 20 4.895 20 5.994v12.012A1.995 1.995 0 0 1 18.006 20H5.994A1.995 1.995 0 0 1 4 18.006V5.994zm5.707 5.299a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$fc939f15c0ac57d8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19h16zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862L12.2 6z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$54ae6633cc16eed1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.667 6.167V7A.834.834 0 0 1 7 7V5.333a.834.834 0 0 1 1.667 0v.834zm6.666 0v-.834a.834.834 0 0 1 1.667 0V7a.834.834 0 0 1-1.667 0v-.833zm2.5 0h.005c.918 0 1.662.745 1.662 1.661v10.01c0 .918-.743 1.662-1.662 1.662H6.161A1.663 1.663 0 0 1 4.5 17.838V7.828c0-.917.743-1.661 1.662-1.661h.005V7c0 .927.746 1.667 1.666 1.667C8.76 8.667 9.5 7.92 9.5 7v-.833h5V7c0 .927.746 1.667 1.667 1.667.927 0 1.666-.747 1.666-1.667v-.833zm-10 6.667H9.5v-1.667H7.833v1.667zm0 3.334H9.5V14.5H7.833v1.668zm3.334-3.334h1.666v-1.667h-1.666v1.667zm0 3.334h1.666V14.5h-1.666v1.668zm3.333-3.334h1.667v-1.667H14.5v1.667zm0 3.334h1.667V14.5H14.5v1.668z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$d298f123ec74117c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15.708 11.723L12.779 14.678C12.566 14.893 12.288 15 12.009 15C11.73 15 11.449 14.893 11.231 14.678L8.291 11.713C7.903 11.321 7.903 10.686 8.291 10.294C8.679 9.902 9.309 9.902 9.698 10.294L12.005 12.621L14.303 10.304C14.69 9.912 15.32 9.912 15.708 10.304C16.097 10.696 16.097 11.331 15.708 11.723Z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$b3ea0fc10228ca3e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM10.0543 7.95865C9.72121 7.63948 9.17412 7.63199 8.83238 7.94192C8.49064 8.25184 8.48365 8.76182 8.81678 9.08099L11.3658 11.5232C11.5389 11.689 11.7698 11.7707 11.9997 11.7675C12.2295 11.7707 12.4604 11.689 12.6335 11.5232L15.1825 9.08099C15.5156 8.76182 15.5087 8.25184 15.1669 7.94192C14.8252 7.63199 14.2781 7.63948 13.945 7.95865L11.9997 9.82242L10.0543 7.95865ZM8.83238 12.3333C9.17412 12.0234 9.72121 12.0309 10.0543 12.35L11.9997 14.2138L13.945 12.35C14.2781 12.0309 14.8252 12.0234 15.1669 12.3333C15.5087 12.6432 15.5156 13.1532 15.1825 13.4724L12.6335 15.9146C12.4604 16.0804 12.2295 16.1621 11.9997 16.1588C11.7698 16.1621 11.5389 16.0804 11.3658 15.9146L8.81678 13.4724C8.48365 13.1532 8.49064 12.6432 8.83238 12.3333Z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$fc64eea29ed0831d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.433 5.428l-4.207.6a2 2 0 0 0-1.697 1.698l-.601 4.207a1 1 0 0 0 .283.849l6.894 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283zm-.647 5.858a1.667 1.667 0 1 1-2.357-2.357 1.667 1.667 0 0 1 2.357 2.357z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$cbee9ded46569696 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7 7h11a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$2ade78849d2113ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.12 20.249a8.398 8.398 0 0 1-.39-.003A8.25 8.25 0 0 1 3.75 12 8.25 8.25 0 0 1 12 3.75 8.25 8.25 0 0 1 20.25 12a8.25 8.25 0 0 1-8.13 8.25v-.001zm4.463-3.762A6.396 6.396 0 0 0 18.417 12 6.424 6.424 0 0 0 12 5.583 6.424 6.424 0 0 0 5.583 12c0 1.745.7 3.33 1.834 4.487v-1.27a2.291 2.291 0 0 1 2.292-2.292h4.582a2.292 2.292 0 0 1 2.292 2.291v1.27zM12 12a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$1c6cf19eb34bcc14 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.72 7.178l-2.93 8.627a.5.5 0 0 0 .473.661h.842a.75.75 0 0 0 .716-.53l.581-1.887h3.425l.58 1.887a.75.75 0 0 0 .717.53h.916a.5.5 0 0 0 .473-.66L9.578 7.177a1 1 0 0 0-.946-.678h-.966a1 1 0 0 0-.947.678zm1.37 1.228h.047l1.25 4.082H6.841l1.25-4.082zm10.187 1.872v-.23a.986.986 0 1 1 1.972 0v5.433a.986.986 0 0 1-1.972 0v-.217h-.08c-.36.802-1.13 1.32-2.217 1.32-1.81 0-2.952-1.479-2.952-3.834 0-2.334 1.149-3.805 2.952-3.805 1.075 0 1.858.546 2.216 1.333h.08zm-.04 2.486c0-1.347-.63-2.203-1.61-2.203-.978 0-1.58.843-1.58 2.203 0 1.368.602 2.196 1.58 2.196.988 0 1.61-.836 1.61-2.196z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$98a4a461fe316fce = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm.787-7.674V8.944c0-.52-.402-.944-.893-.944-.492 0-.894.425-.894.944v3.777c0 .263.104.5.269.672l2.207 2.332a.862.862 0 0 0 1.263 0 .985.985 0 0 0 0-1.336l-1.952-2.063z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$637d50811e2b7176 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M17.476 9.067A6.552 6.552 0 0 1 19 13.263C19 16.983 15.866 20 12 20s-7-3.016-7-6.737c0-1.587.57-3.045 1.524-4.196l-.383-.402a.82.82 0 0 1 .054-1.19.9.9 0 0 1 1.237.052l.345.363a7.116 7.116 0 0 1 3.348-1.312v-.894h-.438a.43.43 0 0 1-.437-.42V4.42a.43.43 0 0 1 .438-.42h2.624a.43.43 0 0 1 .438.421v.842a.43.43 0 0 1-.438.421h-.437v.894a7.116 7.116 0 0 1 3.348 1.312l.345-.363a.9.9 0 0 1 1.237-.052.82.82 0 0 1 .054 1.19l-.383.402zM12 18.316c2.9 0 5.25-2.262 5.25-5.053 0-2.79-2.35-5.052-5.25-5.052s-5.25 2.262-5.25 5.052c0 2.79 2.35 5.053 5.25 5.053zm.645-4.562a.9.9 0 0 1-1.237-.02.82.82 0 0 1 .02-1.19l2.588-2.412a.9.9 0 0 1 1.238.02.82.82 0 0 1-.02 1.19l-2.589 2.412z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$bc2bb299bed9df91 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$3a9d3f1c52f4dab9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.268 4.934a.919.919 0 0 0 0 1.296l4.852 4.853H4.668A.92.92 0 0 0 3.75 12a.92.92 0 0 0 .917.917H17.12l-4.856 4.855a.917.917 0 0 0 1.296 1.296l6.416-6.415c.002 0 .003-.003.006-.004a.914.914 0 0 0 .267-.65.915.915 0 0 0-.274-.653l-6.412-6.412a.915.915 0 0 0-.648-.267.915.915 0 0 0-.648.267z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$a4cdad58220c405a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.928 6.917l4.81-2.846c.727-.429 1.8-.427 2.523 0l4.811 2.846c.726.43 1.261 1.382 1.261 2.238v5.69c0 .859-.537 1.81-1.26 2.238L13.26 19.93c-.726.429-1.799.427-2.522 0l-4.811-2.846c-.726-.43-1.261-1.382-1.261-2.238v-5.69c0-.859.537-1.81 1.26-2.238zm6.408-1.204c-.152-.09-.52-.09-.672 0L6.853 8.558c-.152.09-.336.416-.336.597v5.69c0 .18.183.507.336.597l4.81 2.845c.153.09.52.09.673 0l4.811-2.845c.152-.09.336-.416.336-.597v-5.69c0-.18-.183-.507-.336-.597l-4.81-2.845zM12 15.667a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334zm0-1.834a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$e6e85f1bc2e23bd4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.672 17.468c-1.402 1.37-3.68 1.37-5.08.004a3.458 3.458 0 0 1 .002-4.962l6.552-6.402a2.123 2.123 0 0 1 2.964-.003c.818.8.82 2.092.003 2.89L10.968 15a.599.599 0 0 1-.838-.008.568.568 0 0 1 0-.827l5.71-5.58a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.268 0l-5.71 5.58a2.294 2.294 0 0 0 0 3.307 2.423 2.423 0 0 0 3.375.008l6.145-6.005a3.735 3.735 0 0 0-.003-5.37 3.947 3.947 0 0 0-5.502.003L6.325 11.27a5.184 5.184 0 0 0-.001 7.442c2.1 2.052 5.514 2.051 7.617-.004l6.13-5.99a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.27 0l-6.129 5.99z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$a6a7f7b7c0399a2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.5 7.59a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.008v.152A1 1 0 0 1 6.659 8.75h-.152A1 1 0 0 1 5.5 7.743V7.59zm4.333 8.667a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.008h-6.678a.993.993 0 0 1-.995-1.008v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.008h-.152A1 1 0 0 1 5.5 16.409v-.152zm4.333-4.333a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.007h-.152A1 1 0 0 1 5.5 12.076v-.152zM9.833 7.59a.999.999 0 0 1 .995-1.008h6.678c.549 0 .994.439.994 1.008v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007V7.59z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$835d228e2a9d6a93 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 0 0 .164.033.515.515 0 0 0 .474-.716zM7 10c0-.552.456-1 .995-1h8.01c.55 0 .995.444.995 1 0 .552-.456 1-.995 1h-8.01A.995.995 0 0 1 7 10zm0 3c0-.552.444-1 1-1h3c.552 0 1 .444 1 1 0 .552-.444 1-1 1H8c-.552 0-1-.444-1-1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$fdad804cb16a6544 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.444 14.667V20H5.785C4.8 20 4 19.146 4 18.09V8.577c0-1.055.802-1.91 1.785-1.91h2.66v3.556H6.666V12h1.777v.889H6.667v1.778h1.777zm.89-8.894A1.78 1.78 0 0 1 11.119 4h7.096A1.78 1.78 0 0 1 20 5.773v12.454c0 .979-.802 1.773-1.785 1.773H9.333V5.773zM12 7.556v1.777h1.778V7.556H12zm0 2.666V12h1.778v-1.778H12zm0 2.667v1.778h1.778v-1.778H12zm1.778 2.667v2.666h1.778v-2.666h-1.778zm1.778-8v1.777h1.777V7.556h-1.777zm0 2.666V12h1.777v-1.778h-1.777zm0 2.667v1.778h1.777v-1.778h-1.777z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$a20644de4b67f161 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 12a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-3.228-1.667A3.333 3.333 0 0 0 9.795 12H9.5A2.501 2.501 0 0 0 7 14.497v2.469c-1.771-.147-3.333-.766-3.333-1.858V12c0-.92.74-1.667 1.666-1.667h3.439zm6.456 0h3.439c.92 0 1.666.738 1.666 1.667v3.108c0 1.092-1.562 1.711-3.333 1.858v-2.47A2.5 2.5 0 0 0 14.5 12h-.295a3.333 3.333 0 0 0 1.023-1.667zM10.306 6.63A3.332 3.332 0 0 0 8.67 9.357a2.5 2.5 0 1 1 1.636-2.728zm5.024 2.728a3.328 3.328 0 0 0-1.636-2.73 2.5 2.5 0 1 1 1.636 2.73zm-7.497 5.456c0-1.093.892-1.98 1.996-1.98h4.342a2 2 0 0 1 1.996 1.994v2.781c0 2.523-8.334 2.523-8.334 0v-2.795z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$ce87e45dceec205d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$d95e2215202c8556 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.5 12h7.333v-1.833H6.5V12zM4.667 9.242c0-.502.417-.909.919-.909h9.162c.507 0 .919.414.919.909v4.591h-11V9.242zm.458 7.341h12.828l.919-2.75H4.795l.33 2.75zm-2.287-3.677A.79.79 0 0 1 3.643 12h16.86c.504 0 .786.382.625.865l-1.565 4.686c-.16.478-.695.866-1.205.866H4.415c-.506 0-.964-.402-1.025-.906l-.552-4.605zM6.5 7.42c0-1.015.823-1.838 1.831-1.838h1.838c1.011 0 1.831.82 1.831 1.838v2.746H6.5V7.42zm3.667 0v-.004H8.331c.005 0 .002.002.002.004v.912h1.834V7.42z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$3062e49c5521698d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7.959 15.833V8.474l-2.868 2.868a.541.541 0 1 1-.766-.766l3.79-3.789.001-.004a.544.544 0 0 1 .77.003l3.791 3.792a.543.543 0 0 1 0 .766.543.543 0 0 1-.765 0l-2.87-2.87v7.36a.543.543 0 0 1-.541.541.543.543 0 0 1-.542-.542zm7-6.666v7.359l-2.868-2.868a.541.541 0 1 0-.766.766l3.79 3.789.001.004a.544.544 0 0 0 .77-.003l3.791-3.792a.543.543 0 0 0 0-.766.543.543 0 0 0-.765 0l-2.87 2.87v-7.36a.543.543 0 0 0-.541-.541.543.543 0 0 0-.542.542z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: ".5",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$17d48fc8b753df77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4 6.772C4 5.793 4.793 5 5.773 5h12.454C19.206 5 20 5.796 20 6.772v7.044c0 .979-.793 1.772-1.773 1.772H5.773A1.774 1.774 0 0 1 4 13.816V6.772zm1.778 7.052h12.444v-7.06H5.778v7.06zm8 5.294h.452c.241 0 .437.204.437.44V20H9.333v-.441c0-.244.203-.441.437-.441h.452V16.47h3.556v2.647z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$cbbe21ca62a58ed6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M16.244 6.244a.833.833 0 1 1 1.179 1.179l-4.412 4.41 4.412 4.411a.834.834 0 0 1 .074 1.093l-.074.086a.833.833 0 0 1-1.179 0l-4.411-4.412-4.41 4.412a.834.834 0 0 1-1.094.074l-.085-.074a.833.833 0 0 1 0-1.179l4.411-4.411-4.41-4.41a.834.834 0 0 1-.076-1.094l.075-.085a.833.833 0 0 1 1.179 0l4.41 4.411z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$8fd991b9da3a43e5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.682 12H5.01A2.006 2.006 0 0 0 3 14v4.446c0 2.162 4.836 2.951 8.368 2.368A5.975 5.975 0 0 1 10 17a5.994 5.994 0 0 1 2.682-5z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        fill: "currentColor",
        cx: "9",
        cy: "7",
        r: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        fill: "currentColor",
        cx: "16",
        cy: "17",
        r: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14.674 19.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3l1.406 1.405z",
        fill: "inherit"
    })));
const $845d6a4dfc3d7122$export$f21213fb7b480582 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 12zm0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 16zm0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 8z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$88453606d7da6ff7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        role: "presentation",
        focusable: "false",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H11C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6H3ZM4 16V12H20V16H4ZM2 12C2 10.8954 2.89543 10 4 10H20C21.1046 10 22 10.8954 22 12V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V12Z",
        fill: "currentColor"
    })));

});


parcelRegister("cjRWP", function(module, exports) {

$parcel$export(module.exports, "getSecondaryLabelWithIcon", () => $fe2515622481ebd0$export$de24d837eb50c435);

var $eJOHy = parcelRequire("eJOHy");
const $fe2515622481ebd0$export$de24d837eb50c435 = (icon, fieldTypeDisplayName)=>({
        label: fieldTypeDisplayName,
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, icon, fieldTypeDisplayName)
    });

});

parcelRegister("1RINH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bacb51745455db16$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bacb51745455db16$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    columnGroupHeader: {
        "id": "issue-table-column-picker.common.column-group-header",
        "defaultMessage": "All columns"
    },
    deprecatedParentyLinkMessage: {
        "id": "issue-navigator.services.fetch-column-picker-options.deprecated-parenty-link-message",
        "defaultMessage": "<strong>{field}</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    }
});

});

parcelRegister("iT8nA", function(module, exports) {

$parcel$export(module.exports, "getCursorOfLastUnselectedOption", () => $2ca386a0fde885aa$export$5918fea5c056698b);
$parcel$export(module.exports, "isOnlyUnselectableField", () => $2ca386a0fde885aa$export$bf5bbd6344a5f1aa);

var $4SJ2a = parcelRequire("4SJ2a");

var $gMbEk = parcelRequire("gMbEk");

var $iRahl = parcelRequire("iRahl");
const $2ca386a0fde885aa$var$isNotinSelectedList = (selectedOptions, option)=>{
    const optionFound = selectedOptions.find((select)=>(0, $gMbEk.isSingleValueOption)(select) && (0, $gMbEk.isSingleValueOption)(option) && select.cursor === option.cursor);
    return optionFound === undefined;
};
const $2ca386a0fde885aa$export$5918fea5c056698b = (options, selectedOptions, search, endCursor)=>{
    const flatten = options.flatMap((option)=>option.optionType === 'group' ? option.options : option);
    const lastUnselectedOption = (0, (/*@__PURE__*/$parcel$interopDefault($4SJ2a)))(flatten, (option)=>(0, $gMbEk.isSingleValueOption)(option) && !!option.cursor && $2ca386a0fde885aa$var$isNotinSelectedList(selectedOptions, option));
    let cursor = lastUnselectedOption && (0, $gMbEk.isSingleValueOption)(lastUnselectedOption) ? lastUnselectedOption?.cursor : undefined;
    // with a given search input, don't set cursor to undefined when there are only selected options in the list, because we query with 'ALL' options
    if (search && cursor === undefined && endCursor) cursor = endCursor;
    return cursor;
};
const $2ca386a0fde885aa$export$bf5bbd6344a5f1aa = (fieldType, canEditColumns)=>{
    if (fieldType === (0, $iRahl.COLUMN_TYPE_EPIC_LINK)) return canEditColumns;
    if (fieldType === (0, $iRahl.COLUMN_TYPE_PARENT_LINK)) return canEditColumns;
    return false;
};

});
parcelRegister("4SJ2a", function(module, exports) {

var $dSzgR = parcelRequire("dSzgR");

var $l1N9H = parcelRequire("l1N9H");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $38df235f722de22b$var$findLast = $dSzgR($l1N9H);
module.exports = $38df235f722de22b$var$findLast;

});
parcelRegister("dSzgR", function(module, exports) {

var $1lM9j = parcelRequire("1lM9j");

var $7H30b = parcelRequire("7H30b");

var $4c94y = parcelRequire("4c94y");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a1abad92a1851e60$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$7H30b(collection)) {
            var iteratee = $1lM9j(predicate, 3);
            collection = $4c94y(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a1abad92a1851e60$var$createFind;

});

parcelRegister("l1N9H", function(module, exports) {

var $9gUEB = parcelRequire("9gUEB");

var $1lM9j = parcelRequire("1lM9j");

var $c9FP3 = parcelRequire("c9FP3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f4efd23be3b4e43d$var$nativeMax = Math.max, $f4efd23be3b4e43d$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $f4efd23be3b4e43d$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $c9FP3(fromIndex);
        index = fromIndex < 0 ? $f4efd23be3b4e43d$var$nativeMax(length + index, 0) : $f4efd23be3b4e43d$var$nativeMin(index, length - 1);
    }
    return $9gUEB(array, $1lM9j(predicate, 3), index, true);
}
module.exports = $f4efd23be3b4e43d$var$findLastIndex;

});


parcelRegister("gMbEk", function(module, exports) {

$parcel$export(module.exports, "isSingleValueOption", () => $282a6706fedd463a$export$35faed52a6bc243e);
const $282a6706fedd463a$export$35faed52a6bc243e = (option)=>option.optionType === 'option' || option.optionType === 'avatar' || option.optionType === 'lozenge' || option.optionType === 'field';

});



parcelRegister("i99kJ", function(module, exports) {

$parcel$export(module.exports, "useIFCSidebar", () => $bfe03d5b75afff40$export$50b7b16d5dcf708b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");

var $7ep4S = parcelRequire("7ep4S");

var $gHKwt = parcelRequire("gHKwt");

var $cBavF = parcelRequire("cBavF");

var $2aY2d = parcelRequire("2aY2d");

var $gZTP9 = parcelRequire("gZTP9");

var $6rftq = parcelRequire("6rftq");

var $ciFJV = parcelRequire("ciFJV");

var $7jTnu = parcelRequire("7jTnu");

var $6Al27 = parcelRequire("6Al27");
const $bfe03d5b75afff40$var$IFCTriggerRef = ({ children: children })=>{
    const { entryPointActions: entryPointActions } = (0, $6Al27.useIFCEntryPointContext)();
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    return children({
        triggerRef: triggerRef
    });
};
const $bfe03d5b75afff40$export$50b7b16d5dcf708b = ({ projectId: projectId, projectKey: projectKey })=>{
    const ifcContext = (0, $6Al27.useIFCEntryPointContext)();
    const [, { setStaticSidebarContent: setStaticSidebarContent, closeSidebar: closeSidebar }] = (0, $gHKwt.useSidebar)();
    const isJiraAdmin = (0, $gZTP9.useIsAdmin)();
    const isProjectAdmin = (0, $6rftq.useIsProjectAdmin)();
    const isAdmin = isJiraAdmin || isProjectAdmin;
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const isIFCEnabled = Boolean(isAdmin && project?.simplified);
    const isEnabledForCategoryField = isIFCEnabled || isJiraAdmin && (0, $7jTnu.fg)('jsc_list_category_editing_in_nin');
    const onUpdate = (0, $eJOHy.useCallback)(({ fieldId: fieldId, onFieldDeleted: onFieldDeleted, onFieldUpdated: onFieldUpdated, onStartFieldUpdate: onStartFieldUpdate, onFieldUpdateError: onFieldUpdateError })=>{
        if (projectId && projectKey) setStaticSidebarContent?.('ifc-sidebar-edit', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            xcss: $bfe03d5b75afff40$var$styles.sidebarContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: ifcContext.entryPointReferenceSubject,
            id: "jira-nin-inline-field-config-sidebar",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "medium"
            })),
            runtimeProps: {
                projectId: projectId,
                projectKey: projectKey,
                onClose: closeSidebar,
                fieldId: fieldId,
                mode: 'edit',
                onFieldDeleted: onFieldDeleted,
                onFieldUpdated: onFieldUpdated,
                onStartFieldUpdate: onStartFieldUpdate,
                onFieldUpdateError: onFieldUpdateError
            }
        })));
    }, [
        closeSidebar,
        ifcContext.entryPointReferenceSubject,
        projectId,
        projectKey,
        setStaticSidebarContent
    ]);
    const onCreate = (0, $eJOHy.useCallback)((createArgs)=>{
        if (projectId && projectKey) setStaticSidebarContent?.('ifc-sidebar-create', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            xcss: $bfe03d5b75afff40$var$styles.sidebarContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: ifcContext.entryPointReferenceSubject,
            id: "jira-nin-inline-field-config-sidebar",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "medium"
            })),
            runtimeProps: {
                projectId: projectId,
                projectKey: projectKey,
                onClose: closeSidebar,
                onStartFieldCreate: createArgs?.onStartFieldCreate,
                onFieldCreated: createArgs?.onFieldCreated,
                onFieldCreateError: createArgs?.onFieldCreateError,
                mode: 'create'
            }
        })));
    }, [
        closeSidebar,
        ifcContext.entryPointReferenceSubject,
        projectId,
        projectKey,
        setStaticSidebarContent
    ]);
    return (0, $eJOHy.useMemo)(()=>[
            isIFCEnabled,
            {
                isEnabledForProject: isIFCEnabled,
                isEnabledForCategoryField: isEnabledForCategoryField,
                IFCTriggerRef: $bfe03d5b75afff40$var$IFCTriggerRef,
                onCreate: onCreate,
                onUpdate: onUpdate
            }
        ], [
        isIFCEnabled,
        isEnabledForCategoryField,
        onCreate,
        onUpdate
    ]);
};
const $bfe03d5b75afff40$var$styles = {
    sidebarContent: "_4t3i1osq _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};

});
parcelRegister("6rftq", function(module, exports) {

$parcel$export(module.exports, "useIsProjectAdmin", () => $4b16618c7781b873$export$9facd8d31b938a25);

var $2aY2d = parcelRequire("2aY2d");
const $4b16618c7781b873$export$9facd8d31b938a25 = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    return !!data?.isProjectAdmin;
};

});


parcelRegister("4ciTX", function(module, exports) {

$parcel$export(module.exports, "useCommitFieldSetPreferences", () => $a839eff91073c65d$export$180c6ccdc36e4c73);

var $eJOHy = parcelRequire("eJOHy");

var $K4WWF = parcelRequire("K4WWF");

var $gYnSx = parcelRequire("gYnSx");

var $iRahl = parcelRequire("iRahl");
const $a839eff91073c65d$export$180c6ccdc36e4c73 = ({ cloudId: cloudId, projectId: projectId, viewId: viewId, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, updateFieldSetPreferences: updateFieldSetPreferences, updateFieldSetPreferencesOld: updateFieldSetPreferencesOld })=>{
    const commitUpdateFieldSetPreferencesOld = (0, $eJOHy.useCallback)((payload)=>{
        updateFieldSetPreferencesOld({
            variables: {
                cloudId: cloudId,
                input: {
                    nodes: payload
                },
                ...isInlineFieldConfigEnabled && {
                    context: {
                        projectContext: {
                            project: projectId
                        }
                    },
                    viewId: viewId
                }
            },
            onCompleted (data) {
                if (!data.jira?.updateUserFieldSetPreferences?.success) (0, $gYnSx.default)({
                    meta: {
                        id: 'commitUpdateFieldSetPreferencesMutationUnsuccessful',
                        packageName: (0, $iRahl.PACKAGE_NAME),
                        teamName: (0, $iRahl.TEAM_NAME)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onError (error) {
                (0, $gYnSx.default)({
                    meta: {
                        id: 'commitUpdateFieldSetPreferencesMutationError',
                        packageName: (0, $iRahl.PACKAGE_NAME),
                        teamName: (0, $iRahl.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    }, [
        cloudId,
        isInlineFieldConfigEnabled,
        projectId,
        updateFieldSetPreferencesOld,
        viewId
    ]);
    const commitUpdateFieldSetPreferences = (0, $eJOHy.useCallback)((savedViewId, payload)=>{
        updateFieldSetPreferences({
            variables: {
                input: {
                    viewId: savedViewId,
                    fieldSetsPreferences: payload
                }
            },
            onCompleted (data) {
                if (!data.jira_setFieldSetsPreferences?.success) {
                    const errors = new (0, $K4WWF.MutationErrorCollection)(data.jira_setFieldSetsPreferences?.errors);
                    // silently fail as column will remain at the desired width until the next page load
                    (0, $gYnSx.default)({
                        meta: {
                            id: 'commitUpdateFieldSetPreferencesMutationUnsuccessful',
                            packageName: (0, $iRahl.PACKAGE_NAME),
                            teamName: (0, $iRahl.TEAM_NAME)
                        },
                        error: errors,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError (error) {
                // silently fail as column will remain at the desired width until the next page load
                (0, $gYnSx.default)({
                    meta: {
                        id: 'commitUpdateFieldSetPreferencesMutationError',
                        packageName: (0, $iRahl.PACKAGE_NAME),
                        teamName: (0, $iRahl.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    }, [
        updateFieldSetPreferences
    ]);
    return {
        commitUpdateFieldSetPreferences: commitUpdateFieldSetPreferences,
        commitUpdateFieldSetPreferencesOld: commitUpdateFieldSetPreferencesOld
    };
};

});

parcelRegister("iZH8P", function(module, exports) {

$parcel$export(module.exports, "createPopupComponent", () => $267f7120253f5ea5$export$7b08561157a7df33);
$parcel$export(module.exports, "default", () => $267f7120253f5ea5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $kDaaB = parcelRequire("kDaaB");

var $7jTnu = parcelRequire("7jTnu");

var $gTm2i = parcelRequire("gTm2i");

var $HiS1C = parcelRequire("HiS1C");

var $fwKw5 = parcelRequire("fwKw5");

var $h1uuU = parcelRequire("h1uuU");

var $3Ag3S = parcelRequire("3Ag3S");

var $W3OFR = parcelRequire("W3OFR");

var $cV5SD = parcelRequire("cV5SD");
const $267f7120253f5ea5$var$ColumnPickerPopupComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, onRestoreDefaults: onRestoreDefaults, ...props }, ref)=>{
    const { filterId: filterId, isFilterEditable: isFilterEditable } = (0, $fwKw5.useActiveJql)();
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const { hasMaxSelectedColumns: hasMaxSelectedColumns, filterName: filterName } = (0, $eJOHy.useContext)((0, $gTm2i.ColumnPickerMessageContext));
    let bannerMessage = null;
    if (hasMaxSelectedColumns) bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ag3S.ColumnPickerMaxSelectedColumns), null);
    else if (view === 'list_system') bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1uuU.ColumnPickerBannerMessage), {
        bannerMessage: (0, $7jTnu.fg)('jira_inline_field_config_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $cV5SD.default).listSystemWarningMessageNew) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $cV5SD.default).listSystemWarningMessage),
        type: "warning"
    });
    else if (view === `list_filter_${filterId}`) {
        if (isFilterEditable === false) bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1uuU.ColumnPickerBannerMessage), {
            type: "info",
            bannerMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
                ...(0, $cV5SD.default).listNonEditableFilterInfoMessage,
                values: {
                    // To remove @ts-expect-error below we need to upgrade intl to v6
                    // https://stackoverflow.com/questions/67884173/formattedmessage-values-chunks-using-typescript
                    // @ts-expect-error TS2322: Type '(chunks: ReactNode[]) => JSX.Element' is not assignable to type 'ReactNode'.
                    link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                            href: `/jira/filters${filterName ? `?name="${encodeURIComponent(filterName)}"` : ''}`,
                            target: "_blank"
                        }, chunks)
                }
            })
        });
        else bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1uuU.ColumnPickerBannerMessage), {
            bannerMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $cV5SD.default).listFilterWarningMessage),
            type: "warning"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($267f7120253f5ea5$var$PopupComponentContainer, {
        ...props,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $W3OFR.default), {
        onRestoreDefaults: (0, $7jTnu.fg)('jira_inline_field_config_gate') ? onRestoreDefaults : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($267f7120253f5ea5$var$TabsContentContainer, null, bannerMessage, children)));
});
const $267f7120253f5ea5$export$7b08561157a7df33 = (onRestoreDefaultColumns)=>/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($267f7120253f5ea5$var$ColumnPickerPopupComponent, {
            ...props,
            ref: ref,
            onRestoreDefaults: onRestoreDefaultColumns
        }));
var $267f7120253f5ea5$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $267f7120253f5ea5$var$ColumnPickerPopupComponent;
const $267f7120253f5ea5$var$PopupComponentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1bsb1mjv _bfhk1bhr _16qs1cd0 _1pby1nn1 _ca0q1b66 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $267f7120253f5ea5$var$TabsContentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h1uuU", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerBannerMessage", () => $2d27289c01044f61$export$3ccab74b576df308);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $i4Iw4 = parcelRequire("i4Iw4");

var $jkYbX = parcelRequire("jkYbX");
const $2d27289c01044f61$export$3ccab74b576df308 = ({ bannerMessage: bannerMessage, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d27289c01044f61$var$BannerContent, {
        type: type
    }, type === 'warning' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d27289c01044f61$var$BannerMessage, null, bannerMessage));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2d27289c01044f61$var$BannerContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _syaz1gjq",
            __cmplp.type === 'warning' ? "_bfhk1tzq" : "_bfhk33gi",
            __cmplp.className
        ])
    });
});
const $2d27289c01044f61$var$BannerMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _19pkidpf _2hwxidpf _otyridpf _18u0u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3Ag3S", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerMaxSelectedColumns", () => $c8dc02c422e2966a$export$3ec21851fe32329c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6J86O = parcelRequire("6J86O");

var $lRq8t = parcelRequire("lRq8t");

var $8jOO7 = parcelRequire("8jOO7");

var $iqtgH = parcelRequire("iqtgH");

var $1fdzB = parcelRequire("1fdzB");
const $c8dc02c422e2966a$export$3ec21851fe32329c = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c8dc02c422e2966a$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J86O))), {
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c8dc02c422e2966a$var$Message, null, formatMessage((0, $1fdzB.default).maxSelectedColumns, {
        maxColumns: (0, $8jOO7.MAX_COLUMNS)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "maxSelectedFieldsMessage",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c8dc02c422e2966a$var$MessageContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _bfhkm7j4 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _syaz1gjq _19pku2gc",
            __cmplp.className
        ])
    });
});
const $c8dc02c422e2966a$var$Message = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _19pkidpf _2hwxidpf _otyridpf _18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6J86O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be95c47a86ba406b4074b195e08f177d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e5d3c47f79fd131$var$_react = $4e5d3c47f79fd131$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4e5d3c47f79fd131$var$_statusInformation = $4e5d3c47f79fd131$var$_interopRequireDefault((parcelRequire("2R0ne")));

var $4e5d3c47f79fd131$var$_panel = $4e5d3c47f79fd131$var$_interopRequireDefault((parcelRequire("1Sm4w")));
function $4e5d3c47f79fd131$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4e5d3c47f79fd131$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $4e5d3c47f79fd131$var$_react.default.createElement($4e5d3c47f79fd131$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $4e5d3c47f79fd131$var$_panel.default
    }, props));
$4e5d3c47f79fd131$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $4e5d3c47f79fd131$var$_default = module.exports.default = $4e5d3c47f79fd131$var$StatusInformationIcon;

});
parcelRegister("1Sm4w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $15dbf4a3ad51a12e$var$_react = $15dbf4a3ad51a12e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $15dbf4a3ad51a12e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $15dbf4a3ad51a12e$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $15dbf4a3ad51a12e$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props));
$15dbf4a3ad51a12e$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $15dbf4a3ad51a12e$var$_default = module.exports.default = $15dbf4a3ad51a12e$var$EditorPanelIcon;

});


parcelRegister("1fdzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a524063f2082454$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6a524063f2082454$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    maxSelectedColumns: {
        "id": "issue-navigator.issue-results.list-view.column-picker-max-selected-columns.max-selected-columns",
        "defaultMessage": "The column limit is {maxColumns, number}. Remove and add the most important ones to your view."
    }
});

});


parcelRegister("W3OFR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a65c6ff45df8b715$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $8IeH1 = parcelRequire("8IeH1");

var $cpHe2 = parcelRequire("cpHe2");
var $7oCv0 = parcelRequire("7oCv0");
var $lcHWu = parcelRequire("lcHWu");

var $lRq8t = parcelRequire("lRq8t");

var $82cqT = parcelRequire("82cqT");

var $gCeeo = parcelRequire("gCeeo");

var $ljej9 = parcelRequire("ljej9");

var $gZTP9 = parcelRequire("gZTP9");

var $2aY2d = parcelRequire("2aY2d");

var $7jTnu = parcelRequire("7jTnu");

var $eibCx = parcelRequire("eibCx");

var $HiS1C = parcelRequire("HiS1C");

var $fwKw5 = parcelRequire("fwKw5");

var $5YHRB = parcelRequire("5YHRB");

var $fEOqD = parcelRequire("fEOqD");
const $a65c6ff45df8b715$var$styles = {
    container: "_85i5u2gc"
};
const $a65c6ff45df8b715$var$CustomTabPanel = ({ children: children })=>{
    /**
   * We can omit the tab index as our panel always contains a focusable input as the first element https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic#accessibilityfeatures.
   * > It is recommended that all tabpanel elements in a tab set are focusable if there are any panels in the set that
   * > contain content where the first element in the panel is not focusable.
   */ const { tabIndex: tabIndex, ...tabPanelAttributes } = (0, $lcHWu.useTabPanel)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", tabPanelAttributes, children);
};
const $a65c6ff45df8b715$var$ColumnPickerTabs = ({ children: children, onRestoreDefaults: onRestoreDefaults })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { filterId: filterId } = (0, $fwKw5.useActiveJql)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const [{ view: view }, { setView: setView }] = (0, $HiS1C.useSelectedViewState)();
    const isFilterTabEnabled = filterId != null && (0, $82cqT.isCustomFilter)(filterId);
    const { data: project } = (0, $7jTnu.fg)('jira_inline_field_config_gate') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2aY2d.useProjectContext)() : {
        data: null
    };
    const showRestoreDefaults = project == null || (0, $7jTnu.fg)('ifc_hide_restore_until_ready');
    const tabsMetaData = (0, $eJOHy.useMemo)(()=>{
        const resultTabs = [
            {
                key: 'Default',
                label: formatMessage((0, $5YHRB.default).pickerTabTextDefault),
                view: 'list_default',
                ...showRestoreDefaults && (0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                    onRestoreDefaults: onRestoreDefaults
                }
            }
        ];
        if (isFilterTabEnabled) {
            const filterViewId = (0, $eibCx.convertFilterIdToIssueNavigatorId)(filterId);
            if (filterViewId != null) resultTabs.push({
                key: 'Filter',
                label: formatMessage((0, $5YHRB.default).pickerTabTextFilter),
                view: filterViewId,
                onRestoreDefaults: onRestoreDefaults
            });
        }
        if (isAdmin) resultTabs.push({
            key: 'System',
            label: formatMessage((0, $5YHRB.default).pickerTabTextSystem),
            view: 'list_system',
            ...showRestoreDefaults && (0, $7jTnu.fg)('jira_inline_field_config_gate') && {
                onRestoreDefaults: onRestoreDefaults
            }
        });
        return resultTabs;
    }, [
        formatMessage,
        showRestoreDefaults,
        onRestoreDefaults,
        isFilterTabEnabled,
        isAdmin,
        filterId
    ]);
    const handleUpdate = (0, $eJOHy.useCallback)((index, event)=>{
        if (view !== tabsMetaData[index].view) {
            (0, $gCeeo.fireUIAnalytics)(event, 'columnPickerTabs', {
                tab: tabsMetaData[index].view
            });
            setView(tabsMetaData[index].view, (0, $ljej9.toIssueKey)(''));
        }
    }, [
        setView,
        tabsMetaData,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cpHe2.default), {
        id: "issue-table-column-picker.ui.column-picker.picker-tabs",
        onChange: handleUpdate,
        selected: tabsMetaData.findIndex((tab)=>tab.view === view),
        shouldUnmountTabPanelOnChange: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingInline: "space.100",
        xcss: (0, $k0ahr.cx)((0, $7jTnu.fg)('slv-117-nin-column-picker-style-updates') && $a65c6ff45df8b715$var$styles.container)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7oCv0.default), null, tabsMetaData.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fEOqD.default), {
            key: tab.key,
            label: tab.label,
            maxWidth: `${Math.floor(100 / (tabsMetaData.length || 1))}%`,
            onRestoreDefaults: tab.onRestoreDefaults
        })))), tabsMetaData.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a65c6ff45df8b715$var$CustomTabPanel, {
            key: tab.key
        }, children)));
};
var $a65c6ff45df8b715$export$2e2bcd8739ae039 = $a65c6ff45df8b715$var$ColumnPickerTabs;

});
parcelRegister("cpHe2", function(module, exports) {

$parcel$export(module.exports, "default", () => $03090e4bd6ee746b$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $4OxCz = parcelRequire("4OxCz");
const $03090e4bd6ee746b$var$baseStyles = null;
const $03090e4bd6ee746b$var$tabsStyles = null;
const $03090e4bd6ee746b$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $03090e4bd6ee746b$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        children: tabPanel
    }, index); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $03090e4bd6ee746b$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eJOHy.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eJOHy.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $eJOHy.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eJOHy.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$03090e4bd6ee746b$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $03090e4bd6ee746b$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$03090e4bd6ee746b$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabListContext).Provider, {
                value: {
                    selected: selected,
                    onChange: onChangeAnalytics,
                    tabsId: id
                },
                children: tabList
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
                children: tabPanelsWithContext
            })
        ]
    });
};
var $03090e4bd6ee746b$export$2e2bcd8739ae039 = $03090e4bd6ee746b$var$Tabs;

});
parcelRegister("4OxCz", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $079a819a44225d4e$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $079a819a44225d4e$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $079a819a44225d4e$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eJOHy = parcelRequire("eJOHy");
const $079a819a44225d4e$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $079a819a44225d4e$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $079a819a44225d4e$export$2054129d247c3102 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);

});


parcelRegister("7oCv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b96e2c7b7779acd6$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $lcHWu = parcelRequire("lcHWu");

var $4OxCz = parcelRequire("4OxCz");
const $b96e2c7b7779acd6$var$baseStyles = null;
const $b96e2c7b7779acd6$var$tabListStyles = null;
const $b96e2c7b7779acd6$var$tabListStylesOld = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $b96e2c7b7779acd6$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $lcHWu.useTabList)();
    const ref = /*#__PURE__*/ (0, $eJOHy.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eJOHy.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eJOHy.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eJOHy.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            children: tab
        }, index), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "tablist",
        ref: ref,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8zxi _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8zxi _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmz174y _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc" : "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _17hylb4i _1lzu1eqa _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1jaklb4i _1b8d1eqa _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _9r9ulb4i _rsmz1gcm _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _rfx3lb4i _1mp41kw7 _kfgt1bk5 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ]),
        children: childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))
    });
};
var $b96e2c7b7779acd6$export$2e2bcd8739ae039 = $b96e2c7b7779acd6$var$TabList;

});
parcelRegister("lcHWu", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $91221b4997543842$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $91221b4997543842$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $91221b4997543842$export$fae0121b5afe572d);

var $eJOHy = parcelRequire("eJOHy");

var $4OxCz = parcelRequire("4OxCz");
const $91221b4997543842$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eJOHy.useContext)((0, $4OxCz.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $91221b4997543842$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eJOHy.useContext)((0, $4OxCz.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $91221b4997543842$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eJOHy.useContext)((0, $4OxCz.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("5YHRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1982d1480a5b002$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d1982d1480a5b002$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    pickerTabTextDefault: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-default",
        "defaultMessage": "My defaults"
    },
    pickerTabTextFilter: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-filter",
        "defaultMessage": "Filter"
    },
    pickerTabTextSystem: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-system",
        "defaultMessage": "System"
    }
});

});

parcelRegister("fEOqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb7509b0df7f984b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lcHWu = parcelRequire("lcHWu");

var $Ay1uj = parcelRequire("Ay1uj");

var $8pnTC = parcelRequire("8pnTC");

var $buJG5 = parcelRequire("buJG5");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $kyUe2 = parcelRequire("kyUe2");

var $jZRDj = parcelRequire("jZRDj");
const $fb7509b0df7f984b$var$Tab = ({ label: label, maxWidth: maxWidth = '100%', onRestoreDefaults: onRestoreDefaults })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { labelOverflows: labelOverflows, onLabelRef: onLabelRef } = (0, $jZRDj.useLabelOverflow)();
    const tabAttributes = (0, $lcHWu.useTab)();
    const handleRestoreDefaults = (0, $eJOHy.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'filterSearchRestoreDefaults', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onRestoreDefaults && typeof onRestoreDefaults === 'function' && onRestoreDefaults();
    }, [
        onRestoreDefaults
    ]);
    if ((0, $7jTnu.fg)('jira_inline_field_config_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb7509b0df7f984b$var$TabStyled, {
        maxWidthValue: maxWidth,
        ...tabAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows,
        content: label,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fb7509b0df7f984b$var$tabStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: onLabelRef,
        xcss: $fb7509b0df7f984b$var$textStyles
    }, label), onRestoreDefaults !== undefined && typeof onRestoreDefaults === 'function' && tabAttributes['aria-selected'] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8pnTC))),
        onClick: handleRestoreDefaults,
        label: formatMessage((0, $kyUe2.default).restoreDefaults),
        appearance: "subtle",
        spacing: "compact",
        isTooltipDisabled: false
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fb7509b0df7f984b$var$TabStyled, {
        maxWidthValue: maxWidth,
        ...tabAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows,
        content: label,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: onLabelRef,
        xcss: $fb7509b0df7f984b$var$textStyles
    }, label)));
};
const $fb7509b0df7f984b$var$textStyles = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
const $fb7509b0df7f984b$var$tabStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fb7509b0df7f984b$var$TabStyled = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidthValue: maxWidthValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ocvhpw": (0, $awdRS.default)(__cmplp.maxWidthValue)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12fd0nw _vchhusvi _ae4v1h6o",
            __cmplp.className
        ])
    });
});
var $fb7509b0df7f984b$export$2e2bcd8739ae039 = $fb7509b0df7f984b$var$Tab;

});
parcelRegister("8pnTC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88b78ca28318b361f543778979c0dbc2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61f331c8b661ffec$var$_react = $61f331c8b661ffec$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $61f331c8b661ffec$var$_baseNew = $61f331c8b661ffec$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $61f331c8b661ffec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61f331c8b661ffec$var$RetryIcon = (props)=>/*#__PURE__*/ $61f331c8b661ffec$var$_react.default.createElement($61f331c8b661ffec$var$_baseNew.default, Object.assign({
        name: "RetryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 8a7 7 0 0 1 12.5-4.33V1H15v5a.75.75 0 0 1-.75.75H9.5v-1.5h3.264a5.5 5.5 0 1 0 .665 3.63l1.482.24A7.002 7.002 0 0 1 1 8" clip-rule="evenodd"/>`
    }, props));
$61f331c8b661ffec$var$RetryIcon.displayName = 'RetryIcon';
var $61f331c8b661ffec$var$_default = module.exports.default = $61f331c8b661ffec$var$RetryIcon;

});

parcelRegister("buJG5", function(module, exports) {

$parcel$export(module.exports, "ConditionalTooltip", () => $f134232f4e230d4e$export$d8abb7a1cfbd4b6b);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");
const $f134232f4e230d4e$export$d8abb7a1cfbd4b6b = ({ condition: condition, children: children, ...rest })=>// @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
    condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), rest, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);

});

parcelRegister("kyUe2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a34ba8f32ea7be9c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a34ba8f32ea7be9c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    restoreDefaults: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.tab.restore-defaults",
        "defaultMessage": "Restore defaults"
    }
});

});

parcelRegister("jZRDj", function(module, exports) {

$parcel$export(module.exports, "useLabelOverflow", () => $e72c7cfe8cc09d91$export$96d540e3e625885f);

var $eJOHy = parcelRequire("eJOHy");
const $e72c7cfe8cc09d91$export$96d540e3e625885f = ()=>{
    const [labelOverflows, setLabelOverflows] = (0, $eJOHy.useState)(false);
    const onLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) {
            const isOverflow = Boolean(node.offsetWidth < node.scrollWidth);
            isOverflow !== labelOverflows && setLabelOverflows(isOverflow);
        }
    }, [
        labelOverflows
    ]);
    return {
        labelOverflows: labelOverflows,
        onLabelRef: onLabelRef,
        setLabelOverflows: setLabelOverflows
    };
};

});



parcelRegister("cV5SD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d00fa6b7cfb4279$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4d00fa6b7cfb4279$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    listSystemWarningMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-system-warning-message",
        "defaultMessage": "Any changes here will modify columns for all users."
    },
    listSystemWarningMessageNew: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-system-warning-message-new",
        "defaultMessage": "Changes will apply to everyone."
    },
    listFilterWarningMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-filter-warning-message",
        "defaultMessage": "Any changes here will affect all users of this filter."
    },
    listNonEditableFilterInfoMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-non-editable-filter-info-message",
        "defaultMessage": "You can\u2019t modify this filter. Contact the owner using the <link>Filters directory</link> for edit permission."
    }
});

});


parcelRegister("i5UAP", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerRemountManager", () => $1884d3b6cc36bf23$export$a4237a5d372a0de2);

var $eJOHy = parcelRequire("eJOHy");

var $7auhX = parcelRequire("7auhX");

var $HiS1C = parcelRequire("HiS1C");
const $1884d3b6cc36bf23$export$a4237a5d372a0de2 = ({ children: children, viewIdFromResponse: viewIdFromResponse })=>{
    const [{ view: optimisticViewId }] = (0, $HiS1C.useSelectedViewState)();
    const { isLoading: isLoading } = (0, $7auhX.useColumnPickerLoadingContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
        key: isLoading ? 'loading' : `${optimisticViewId}${viewIdFromResponse}`
    }, children);
};

});

parcelRegister("fOH9z", function(module, exports) {

$parcel$export(module.exports, "BulkOpsConnectionsSubscriber", () => $3966942deaa09f8a$export$e722c6c8da1d5a1a);

var $eJOHy = parcelRequire("eJOHy");

var $3TtKq = parcelRequire("3TtKq");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $9wOi6 = parcelRequire("9wOi6");
const $3966942deaa09f8a$var$entryPointParams = {};
const $3966942deaa09f8a$export$e722c6c8da1d5a1a = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const selectedIssues = (0, $3TtKq.useIssueTableSelectedIssues)();
    const [hasSelectedAtLeastOnce, setHasSelectedAtLeastOnce] = (0, $eJOHy.useState)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $9wOi6.bulkOperationsConnectionsSubscriberEntryPoint), $3966942deaa09f8a$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (!hasSelectedAtLeastOnce && selectedIssues.length > 0) {
            setHasSelectedAtLeastOnce(true);
            entryPointActions.load();
        }
    }, [
        entryPointActions,
        hasSelectedAtLeastOnce,
        selectedIssues.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira.nin-bulk.operations.connections.subscriber",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
});

});
parcelRegister("9wOi6", function(module, exports) {

$parcel$export(module.exports, "bulkOperationsConnectionsSubscriberEntryPoint", () => $595e7d22fd976a14$export$f0e5693d80379467);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $595e7d22fd976a14$export$f0e5693d80379467 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("68Zby")), {
        moduleId: "a230f98b",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("68Zby", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("V5vNT").then(()=>parcelRequire('3xmZq'));

});



parcelRegister("b2VjA", function(module, exports) {

$parcel$export(module.exports, "IssueCount", () => $0e1e995c74e3ea46$export$542fba90cc9c1bd1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6XJko = parcelRequire("6XJko");

var $6K4cv = parcelRequire("6K4cv");

var $gRqFV = parcelRequire("gRqFV");
const $0e1e995c74e3ea46$export$542fba90cc9c1bd1 = (issueCountProps)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0e1e995c74e3ea46$var$IssueCountContainer, {
        "data-testid": "issue-navigator.ui.issue-results.list-view.issue-count",
        isFlexEnd: issueCountProps.isNewFooterOrderEnabled
    }, (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        testId: "issue-navigator.ui.issue-results.list-view.issue-count.text",
        xcss: $0e1e995c74e3ea46$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K4cv.default), issueCountProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": "issue-navigator.ui.issue-results.list-view.issue-count.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K4cv.default), issueCountProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gRqFV.default), null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0e1e995c74e3ea46$var$IssueCountContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexEnd: isFlexEnd, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulp1b66 _1e0c1txw _4cvr1h6o _k48p1pd9",
            __cmplp.isFlexEnd ? "_1bahesu3" : "_1bah1h6o",
            __cmplp.className
        ])
    });
});
const $0e1e995c74e3ea46$var$textStyles = (0, $1DXK0.xcss)({
    fontWeight: 'font.weight.medium',
    color: 'color.text.subtle'
});

});

parcelRegister("kg3EI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ca75450ec188479$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7ca75450ec188479$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    reorderColumnsErrorTitle: {
        "id": "issue-navigator.issue-results.list-view.reorder-columns-error-title",
        "defaultMessage": "We couldn't reorder your columns"
    },
    resetColumnsErrorTitle: {
        "id": "issue-navigator.issue-results.list-view.reset-columns-error-title",
        "defaultMessage": "We couldn't restore your default columns"
    },
    columnConfigMutationErrorDescription: {
        "id": "issue-navigator.issue-results.list-view.column-config-mutation-error-description",
        "defaultMessage": "Refresh and try again."
    }
});

});

parcelRegister("ghzkC", function(module, exports) {

$parcel$export(module.exports, "NoColumns", () => $4928523630d37d70$export$a0e9f6d02eee4aa4);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $8IeH1 = parcelRequire("8IeH1");

var $epTsa = parcelRequire("epTsa");

var $3eXrV = parcelRequire("3eXrV");

var $lRq8t = parcelRequire("lRq8t");

var $53prN = parcelRequire("53prN");

var $gCeeo = parcelRequire("gCeeo");

var $ljej9 = parcelRequire("ljej9");

var $cECwI = parcelRequire("cECwI");

var $HiS1C = parcelRequire("HiS1C");

var $iT6a0 = parcelRequire("iT6a0");
const $4928523630d37d70$var$Bold = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("b", null, children);
const $4928523630d37d70$var$NoColumnsAnonymous = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [, { setView: setView }] = (0, $HiS1C.useSelectedViewState)();
    const onClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton', {
            isAnon: true
        });
        setView('detail', (0, $ljej9.toIssueKey)(''));
    }, [
        setView
    ]);
    const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $iT6a0.default).noColumnsHeaderAnonymous),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3eXrV.FormattedI18nMessage), {
            componentsMapping: {
                bold: $4928523630d37d70$var$Bold
            },
            message: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iT6a0.default).noColumnsDescriptionAnonymousIssueTermRefresh : (0, $iT6a0.default).noColumnsDescriptionAnonymous, {
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}'
            })
        }),
        testId: "issue-navigator.ui.issue-results.list-view.no-columns.no-columns-anonymous",
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            onClick: onClick
        }, formatMessage((0, $iT6a0.default).switchView)),
        renderImage: ()=>defaultNoColumnsGlyph
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlock: "space.800"
    }, component);
};
const $4928523630d37d70$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4928523630d37d70$var$NoColumnsAnonymous, {
        defaultNoColumnsGlyph: defaultNoColumnsGlyph
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $53prN.components).NoColumns, {
        defaultNoColumnsGlyph: defaultNoColumnsGlyph,
        hasColumnConfiguration: hasColumnConfiguration
    });
};

});
parcelRegister("3eXrV", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $486cef5864159f57$export$200d7bd7633253ce);

var $eJOHy = parcelRequire("eJOHy");

var $bqTZA = parcelRequire("bqTZA");

var $ecZeq = parcelRequire("ecZeq");
const $486cef5864159f57$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eJOHy.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $ecZeq.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $ecZeq.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $ecZeq.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $bqTZA.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $ecZeq.isCloseTagDelimiter)(letter) && (0, $ecZeq.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $bqTZA.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $ecZeq.isCloseTagDelimiter)(letter) && (0, $ecZeq.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $bqTZA.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $bqTZA.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $bqTZA.MalformedMessageError)) {
                (0, $bqTZA.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $bqTZA.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("bqTZA", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $5ef7f665246dbe4e$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $5ef7f665246dbe4e$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $5ef7f665246dbe4e$export$40d900e818b9630e);

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

const $5ef7f665246dbe4e$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $5ef7f665246dbe4e$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $gYnSx.default)({
            meta: {
                packageName: packageName,
                id: (0, $fd8164d64319d2b3$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $fd8164d64319d2b3$export$f3390a0e172fee41)}`;
        (0, $eSnSE.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $5ef7f665246dbe4e$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $fd8164d64319d2b3$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("ecZeq", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $b16e90564b654123$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $b16e90564b654123$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $b16e90564b654123$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $b16e90564b654123$export$d5170904651e91b1);

const $b16e90564b654123$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $b16e90564b654123$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $b16e90564b654123$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $b16e90564b654123$export$d5170904651e91b1 = (letter)=>letter === (0, $e0cdacc17624bde2$export$a10c567c3288a6b4);

});
const $e0cdacc17624bde2$export$a10c567c3288a6b4 = '}';



parcelRegister("53prN", function(module, exports) {

$parcel$export(module.exports, "components", () => $30d976bd0a41653c$export$9b5ac10f59f76296);

var $luhKv = parcelRequire("luhKv");

var $4ohGb = parcelRequire("4ohGb");

var $dK9Sm = parcelRequire("dK9Sm");
const $30d976bd0a41653c$export$9b5ac10f59f76296 = {
    columnPicker: $luhKv.components,
    Footer: $4ohGb.Footer,
    NoColumns: $dK9Sm.NoColumns
};

});
parcelRegister("luhKv", function(module, exports) {

$parcel$export(module.exports, "components", () => $8762592adb027c9e$export$9b5ac10f59f76296);

var $7JbAM = parcelRequire("7JbAM");
const $8762592adb027c9e$export$9b5ac10f59f76296 = {
    NoOptionsMessage: $7JbAM.default
};

});
parcelRegister("7JbAM", function(module, exports) {

$parcel$export(module.exports, "default", () => $bae9d594d2745981$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1NG86 = parcelRequire("1NG86");

var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $iqtgH = parcelRequire("iqtgH");

var $6XJko = parcelRequire("6XJko");

var $3ycj9 = parcelRequire("3ycj9");
const $bae9d594d2745981$var$IconContainerConditional = ({ children: children })=>{
    if ((0, $6XJko.isVisualRefreshEnabled)()) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$IconContainer, null, children);
};
const $bae9d594d2745981$var$MessageContainer = ({ icon: icon, children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.150",
        xcss: $bae9d594d2745981$var$stackStyles,
        alignInline: "center"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text"
    }, formatMessage((0, $3ycj9.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage((0, $3ycj9.default).noOptionsSecondaryMessage)), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$Container, null, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$StyledTitle, null, formatMessage((0, $3ycj9.default).title)), children);
};
/**
 * Custom message to show when no options are visible in the column picker. This allows additional help text/content to
 * be rendered using the children prop.
 */ const $bae9d594d2745981$var$NoOptionsMessage = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$MessageContainer, {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bae9d594d2745981$var$IconContainerConditional, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
            label: "",
            color: "var(--ds-icon, #44546F)",
            LEGACY_primaryColor: "currentColor"
        }))
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "emptyState",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
var $bae9d594d2745981$export$2e2bcd8739ae039 = $bae9d594d2745981$var$NoOptionsMessage;
const $bae9d594d2745981$var$stackStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.100',
    // this is for the children additional help text/content
    color: 'color.text.subtlest'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bae9d594d2745981$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18s81gzt _syaz131l _1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $bae9d594d2745981$var$IconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyru2gc _w8l5t9kd _1752t9kd",
            __cmplp.className
        ])
    });
});
const $bae9d594d2745981$var$StyledTitle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1fxt _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3ycj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bd552da9271bc32$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6bd552da9271bc32$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-table-column-picker.column-picker.no-options-message.title",
        "defaultMessage": "We couldn\u2019t find the field you\u2019re looking for."
    },
    noOptionsPrimaryMessage: {
        "id": "issue-table-column-picker.common.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "issue-table-column-picker.common.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});

});



parcelRegister("4ohGb", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $74e7263cd9d59bbd$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $kbYhH = parcelRequire("kbYhH");

var $7n9BS = parcelRequire("7n9BS");
const $74e7263cd9d59bbd$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ start: start = $74e7263cd9d59bbd$var$SpacerElement, center: center = $74e7263cd9d59bbd$var$SpacerElement, end: end = $74e7263cd9d59bbd$var$SpacerElement }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterBase, {
        ref: ref
    }, start, center, end);
});
const $74e7263cd9d59bbd$var$FooterBase = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>{
    const tableHeight = (0, $kbYhH.useElementSizeSelector)((size)=>size.height);
    const hasShadow = (0, $7n9BS.useScrollStateSelector)((scrollState)=>{
        const { height: containerHeight, scrollTop: scrollTop } = scrollState;
        // Scroll measurements are fractional, while height measurements are integer, so we need to round before comparing
        return containerHeight < tableHeight && Math.round(scrollTop) < tableHeight - containerHeight;
    });
    return (0, $7jTnu.fg)('reduce_size_of_scroll_container_shadow') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterWrapper, null, hasShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterShadow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterContainer, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref,
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: false
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$var$FooterContainer, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref,
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: hasShadow
    }, children);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $74e7263cd9d59bbd$var$FooterWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$FooterShadow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _4t3i1y44 _lcxvglyw _16qs9g9j",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$FooterContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasShadow: hasShadow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dozgxb _1e0c1txw _2lx2vrvc _1n261q9c _kqsw1if8 _1ltvidpf _94n5idpf _bfhkvuon _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.hasShadow && "_16qsahas",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $74e7263cd9d59bbd$var$SpacerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($74e7263cd9d59bbd$export$d7a54cba636a8cd6, null);

});

parcelRegister("dK9Sm", function(module, exports) {

$parcel$export(module.exports, "NoColumns", () => $edb4c92fc13b3452$export$a0e9f6d02eee4aa4);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $8IeH1 = parcelRequire("8IeH1");

var $lRq8t = parcelRequire("lRq8t");

var $PETi0 = parcelRequire("PETi0");

var $gCeeo = parcelRequire("gCeeo");

var $5F0C9 = parcelRequire("5F0C9");
const $edb4c92fc13b3452$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ isOpen: isOpen }, actions] = (0, $PETi0.useColumnPickerOpenState)();
    const onOpenColumnPicker = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton');
        if (!isOpen) actions.open();
    }, [
        isOpen,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $5F0C9.default).noColumnsHeaderText),
        description: formatMessage((0, $5F0C9.default).noColumnsDescriptionText),
        testId: "native-issue-table.common.ui.components.no-columns.no-columns",
        primaryAction: hasColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            onClick: onOpenColumnPicker
        }, formatMessage((0, $5F0C9.default).configureColumns)) : undefined,
        renderImage: ()=>defaultNoColumnsGlyph
    }));
};

});
parcelRegister("PETi0", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerContainer", () => $3bc985482a1599b5$export$e1286e1cb3fa0dec);
$parcel$export(module.exports, "useColumnPickerOpenState", () => $3bc985482a1599b5$export$81588ffe8d9d4add);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $3bc985482a1599b5$export$e1286e1cb3fa0dec = (0, $6E16M.createContainer)();
const $3bc985482a1599b5$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'ColumnPickerOpenState',
    containedBy: $3bc985482a1599b5$export$e1286e1cb3fa0dec
});
const $3bc985482a1599b5$export$81588ffe8d9d4add = (0, $iJq0l.createHook)($3bc985482a1599b5$var$Store);

});

parcelRegister("5F0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $eacbcb43f37199f6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $eacbcb43f37199f6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noColumnsHeaderText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-header-text",
        "defaultMessage": "Configure your columns"
    },
    noColumnsDescriptionText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-description-text",
        "defaultMessage": "You haven't configured any columns yet. Add fields as columns to see search results and their information."
    },
    configureColumns: {
        "id": "native-issue-table.issue-table.no-columns.configure-columns",
        "defaultMessage": "Configure columns"
    }
});

});



parcelRegister("iT6a0", function(module, exports) {

$parcel$export(module.exports, "default", () => $473705edd52aae5f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $473705edd52aae5f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noColumnsHeaderAnonymous: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-header-anonymous",
        "defaultMessage": "The admin hasn't configured any columns"
    },
    noColumnsDescriptionAnonymous: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-description-anonymous",
        "defaultMessage": "Switch to {boldStart}Detail view{boldEnd} to see issues and their information."
    },
    switchView: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.switch-view",
        "defaultMessage": "Switch to detail view"
    },
    noColumnsDescriptionAnonymousIssueTermRefresh: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-description-anonymous-issue-term-refresh",
        "defaultMessage": "Switch to {boldStart}Detail view{boldEnd} to see work items and their information."
    }
});

});


parcelRegister("2PY5Q", function(module, exports) {

$parcel$export(module.exports, "NoIssues", () => $b374b99ab61e2d81$export$a7a61a727a1d891b);

var $eJOHy = parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $8IeH1 = parcelRequire("8IeH1");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $ip1XF = parcelRequire("ip1XF");
const $b374b99ab61e2d81$export$a7a61a727a1d891b = ({ defaultNoIssuesGlyph: defaultNoIssuesGlyph })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ip1XF.default).noIssuesIssueTermRefresh : (0, $ip1XF.default).noIssues),
        renderImage: ()=>defaultNoIssuesGlyph,
        testId: "issue-navigator.ui.issue-results.list-view.no-issues.empty-state"
    }));
};

});
parcelRegister("ip1XF", function(module, exports) {

$parcel$export(module.exports, "default", () => $747b132590479e9d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $747b132590479e9d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noIssues: {
        "id": "issue-navigator.common.empty-list-icon.no-issues",
        "defaultMessage": "No issues were found matching your search"
    },
    noIssuesIssueTermRefresh: {
        "id": "issue-navigator.issue-results.list-view.no-issues.no-issues-issue-term-refresh",
        "defaultMessage": "There's nothing matching your search"
    }
});

});


parcelRegister("fwdeI", function(module, exports) {

$parcel$export(module.exports, "AsyncRegisterShortcutDialogActions", () => $cde7bd4836a70214$export$53d5920188b673b6);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bHRpp = parcelRequire("bHRpp");

var $bQWwW = parcelRequire("bQWwW");
var $fathc = parcelRequire("fathc");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cde7bd4836a70214$var$LazyRegisterShortcutDialogActions = (0, $bQWwW.lazy)(()=>(parcelRequire("hVSGn")), {
    moduleId: "./src/packages/issue-navigator/issue-navigator/src/ui/issue-results/list-view/register-shortcut-dialog-actions/index.tsx"
});
const $cde7bd4836a70214$export$53d5920188b673b6 = (props)=>{
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }] = (0, $bHRpp.useShortcuts)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraIssueNavigator",
        id: "register-issue-actions-worklflow-shortcuts-dialog",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fathc.LazyWait), {
        until: isShortcutsDialogVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "register-shortcut-dialog-actions",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cde7bd4836a70214$var$LazyRegisterShortcutDialogActions, props))));
};

});
parcelRegister("bHRpp", function(module, exports) {

$parcel$export(module.exports, "useShortcuts", () => $5ec870659f2b42dd$export$a1ca853c6e4bb6fb);
$parcel$export(module.exports, "useShortcutsActions", () => $5ec870659f2b42dd$export$b331ee6e87b9104c);

var $fgHZ8 = parcelRequire("fgHZ8");
const $5ec870659f2b42dd$export$a1ca853c6e4bb6fb = ()=>(0, $fgHZ8.useShortcutsStore)();
const $5ec870659f2b42dd$export$b331ee6e87b9104c = ()=>{
    const [, actions] = (0, $fgHZ8.useShortcutsActionsStore)();
    return [
        undefined,
        actions
    ];
};

});
parcelRegister("fgHZ8", function(module, exports) {

$parcel$export(module.exports, "useShortcutsStore", () => $1037d55a513c4cd3$export$a14646bfc7ba8d81);
$parcel$export(module.exports, "useShortcutsActionsStore", () => $1037d55a513c4cd3$export$1a29bfef7fa09838);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $9rMca = parcelRequire("9rMca");
const $1037d55a513c4cd3$export$d4c72bab9d6cc13a = {
    shortcuts: {
        admin: {
            key: 'admin',
            label: 'ADMIN',
            options: [],
            isLoaded: false
        }
    },
    isShortcutsDialogVisible: false,
    isShortcutsLoading: false,
    hasError: false,
    isAdminLoading: false,
    selectedItemKey: null,
    header: null,
    title: undefined
};
const $1037d55a513c4cd3$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'shortcuts',
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly shortcuts: { readonly admin: { readonly key: "admin"; readonly label: "ADMIN"; readonly options: readonly []; readonly isLoaded: false; }; }; readonly isShortcutsDialogVisible: false; readonly isShortcutsLoading: false; ... 4 more ...; readonly title: undefined; }' is not assignable to type 'State'.
    $1037d55a513c4cd3$export$d4c72bab9d6cc13a,
    actions: $9rMca
});
const $1037d55a513c4cd3$export$a14646bfc7ba8d81 = (0, $iJq0l.createHook)($1037d55a513c4cd3$export$6f57813fe9f31bf9);
const $1037d55a513c4cd3$export$1a29bfef7fa09838 = (0, $iJq0l.createHook)($1037d55a513c4cd3$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("9rMca", function(module, exports) {

$parcel$export(module.exports, "registerShortcuts", () => $bd65986ef711b2b7$export$598ec0e6047cbdca);
$parcel$export(module.exports, "setShortcutsDialogVisibility", () => $bd65986ef711b2b7$export$80ab1e79e32c3021);
$parcel$export(module.exports, "setShortcutsLoading", () => $bd65986ef711b2b7$export$7ed2ac8328423043);
$parcel$export(module.exports, "setHasError", () => $bd65986ef711b2b7$export$645a7c7453685186);
$parcel$export(module.exports, "setHeader", () => $bd65986ef711b2b7$export$604ed74fb893f0e2);
$parcel$export(module.exports, "fetchAdminSections", () => $bd65986ef711b2b7$export$aec87c8c9bde62e6);
$parcel$export(module.exports, "setSelectedItemKey", () => $bd65986ef711b2b7$export$249c9d5b49cd9712);
$parcel$export(module.exports, "dropShortcutsByKeys", () => $bd65986ef711b2b7$export$9cf39adf0dec984);

var $2zs80 = parcelRequire("2zs80");

var $9FV9P = parcelRequire("9FV9P");

var $2TCxE = parcelRequire("2TCxE");
const $bd65986ef711b2b7$export$598ec0e6047cbdca = (shortcuts)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const newShortcuts = shortcuts.reduce((acc, current)=>{
            acc[current.key] = current;
            return acc;
        }, {
            ...currentState.shortcuts
        });
        setState({
            ...currentState,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };
const $bd65986ef711b2b7$export$80ab1e79e32c3021 = (isVisible)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsDialogVisible: isVisible
        });
    };
const $bd65986ef711b2b7$export$7ed2ac8328423043 = (isLoading)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsLoading: isLoading
        });
    };
const $bd65986ef711b2b7$export$645a7c7453685186 = (hasError)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            hasError: hasError
        });
    };
const $bd65986ef711b2b7$export$604ed74fb893f0e2 = (header, title)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            header: header,
            title: title
        });
    };
const $bd65986ef711b2b7$export$aec87c8c9bde62e6 = ()=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isAdminLoading: true
        });
        const result = await (0, $9FV9P.default)();
        const shortcuts = result ? (0, $2TCxE.buildAdminSections)(result) : [];
        const newState = getState();
        setState({
            ...newState,
            shortcuts: {
                ...newState.shortcuts,
                admin: {
                    ...newState.shortcuts.admin,
                    key: 'admin',
                    options: shortcuts,
                    isLoaded: true
                }
            },
            hasError: currentState.hasError || !result,
            isAdminLoading: false
        });
    };
const $bd65986ef711b2b7$export$249c9d5b49cd9712 = (item)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            selectedItemKey: item
        });
    };
const $bd65986ef711b2b7$export$9cf39adf0dec984 = (keys)=>({ getState: getState, setState: setState })=>{
        if (!keys.length) return;
        const { shortcuts: shortcuts, ...rest } = getState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newShortcuts = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(Object.keys(shortcuts), keys).reduce((acc, key)=>{
            acc[key] = shortcuts[key];
            return acc;
        }, {});
        setState({
            ...rest,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };

});
parcelRegister("9FV9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9cd1634918b3cd3$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $1Ozm9 = parcelRequire("1Ozm9");
const $e9cd1634918b3cd3$var$fetchAdminLinks = async ()=>{
    try {
        return await (0, $1Ozm9.default)('/rest/adminquicksearch/latest/links/default');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('shortcuts-dialog.fetch-admin-links', error.toString());
        return null;
    }
};
var $e9cd1634918b3cd3$export$2e2bcd8739ae039 = $e9cd1634918b3cd3$var$fetchAdminLinks;

});

parcelRegister("2TCxE", function(module, exports) {

$parcel$export(module.exports, "buildAdminSections", () => $8b2ef73b57082485$export$5f8c94ecd4c9eb76);
const $8b2ef73b57082485$export$5f8c94ecd4c9eb76 = (parent, result = [])=>{
    if (parent.sections && parent.sections.length) parent.sections.forEach((s)=>$8b2ef73b57082485$export$5f8c94ecd4c9eb76(s, result));
    if (parent.items && parent.items.length) parent.items.forEach((i)=>result.push({
            key: i.key,
            label: i.label,
            // @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(event?: Event | undefined) => Promise<undefined> | undefined'.
            onClick: ()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.location.href = i.linkUrl;
            }
        }));
    return result;
};

});




parcelRegister("hVSGn", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("kQMAD").then(()=>parcelRequire('cFlWj'));

});


parcelRegister("jOc90", function(module, exports) {

$parcel$export(module.exports, "dragAndDropExperience", () => $c40c00dcaf6b3661$export$c1eb53e51d4d0ab3);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $c40c00dcaf6b3661$export$c1eb53e51d4d0ab3 = new (0, $f39LL.UFOExperience)('jira-issue-navigator.list-view.drag-and-drop', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("aaQkY", function(module, exports) {

$parcel$export(module.exports, "useEventHandlers", () => $f78e58290b5b5276$export$8ce912bc34d0dbea);

var $eJOHy = parcelRequire("eJOHy");

var $ljej9 = parcelRequire("ljej9");

var $1wL9i = parcelRequire("1wL9i");

var $ijD5s = parcelRequire("ijD5s");

var $1aawv = parcelRequire("1aawv");
const $f78e58290b5b5276$export$8ce912bc34d0dbea = (connectionId, fieldSetIds)=>{
    const { setSelectedIssueByKey: setSelectedIssueByKey, deselectIssue: deselectIssue } = (0, $1wL9i.useSelectedIssueActions)();
    const onDeleteIssue = (0, $ijD5s.useOnDeleteIssue)(connectionId);
    const onIssueByFieldsRefetch = (0, $1aawv.useIssueByFieldsRefetch)(fieldSetIds);
    const onIssueRefetch = onIssueByFieldsRefetch;
    // While we don't have a mutation setup for inline editing, use issue refetch as a substitute
    const onUpdateCache = onIssueByFieldsRefetch;
    const onIssueDelete = (0, $eJOHy.useCallback)((deletedIssueKey)=>{
        const issueKeyToSelect = onDeleteIssue(deletedIssueKey);
        if (!issueKeyToSelect.length) {
            deselectIssue({
                shouldDebounce: false,
                shouldNotifyOnChange: false,
                isSelectedByUserInteraction: false
            });
            return;
        }
        setSelectedIssueByKey((0, $ljej9.toIssueKey)(issueKeyToSelect), {
            shouldDebounce: false,
            shouldNotifyOnChange: false,
            isSelectedByUserInteraction: false
        });
    }, [
        onDeleteIssue,
        setSelectedIssueByKey,
        deselectIssue
    ]);
    const onIssueLinkSelected = (0, $eJOHy.useCallback)((issueKey, viewActivity)=>{
        setSelectedIssueByKey((0, $ljej9.toIssueKey)(issueKey), {
            viewActivity: viewActivity
        });
        return true;
    }, [
        setSelectedIssueByKey
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            onIssueRefetch: onIssueRefetch,
            onUpdateCache: onUpdateCache,
            onIssueDelete: onIssueDelete,
            onIssueLinkSelected: onIssueLinkSelected
        }), [
        onIssueRefetch,
        onUpdateCache,
        onIssueDelete,
        onIssueLinkSelected
    ]);
};

});



parcelRegister("e78V2", function(module, exports) {

$parcel$export(module.exports, "default", () => $223373443ce3803e$export$2e2bcd8739ae039);

var $ccfQZ = parcelRequire("ccfQZ");

var $h8y3a = parcelRequire("h8y3a");

var $lzB0Q = parcelRequire("lzB0Q");

var $2nyUM = parcelRequire("2nyUM");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $1KdDN = parcelRequire("1KdDN");

var $g8Az8 = parcelRequire("g8Az8");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $5i1j5 = parcelRequire("5i1j5");

var $lzg2Z = parcelRequire("lzg2Z");

var $gVAWF = parcelRequire("gVAWF");

var $5ekXO = parcelRequire("5ekXO");

var $56qWy = parcelRequire("56qWy");

var $6zXPf = parcelRequire("6zXPf");

var $J0ugN = parcelRequire("J0ugN");

var $9LhIE = parcelRequire("9LhIE");

var $cECwI = parcelRequire("cECwI");

var $16sa1 = parcelRequire("16sa1");

var $f2JN3 = parcelRequire("f2JN3");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $fAgUF = parcelRequire("fAgUF");

var $61oZD = parcelRequire("61oZD");

var $4COCY = parcelRequire("4COCY");

var $1fmSG = parcelRequire("1fmSG");

var $fwKw5 = parcelRequire("fwKw5");

var $3kDjB = parcelRequire("3kDjB");

var $aaLZH = parcelRequire("aaLZH");

var $a8Oge = parcelRequire("a8Oge");

var $3d17F = parcelRequire("3d17F");

var $in3H6 = parcelRequire("in3H6");

var $beKwt = parcelRequire("beKwt");

var $5B9jk = parcelRequire("5B9jk");

const $223373443ce3803e$var$JQLBuilderWrapper = ({ defaultJql: defaultJql, onFilterSave: onFilterSave, onReset: onReset, onChangeJql: onChangeJql, onToggleAi: onToggleAi, groupResults: groupResults, issueResults: issueResults, filter: filter, jqlBuilderProps: jqlBuilderProps, jqlBuilderWithAiKey: jqlBuilderWithAiKey, initialQueryAsJql: initialQueryAsJql, disableBackToFilterButton: disableBackToFilterButton })=>{
    const { startJqlBuilderMetric: startJqlBuilderMetric, stopJqlBuilderMetric: stopJqlBuilderMetric, markJqlBuilderMetric: markJqlBuilderMetric } = (0, $beKwt.useJqlBuilderInstrumentation)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        startJqlBuilderMetric();
        markJqlBuilderMetric((0, $fAgUF.marks).JQL_BUILDER_START);
    }, [
        startJqlBuilderMetric,
        markJqlBuilderMetric
    ]);
    const { query: query, onSearch: onSearch } = (0, $1fmSG.useJqlSearch)(onChangeJql);
    const { maybeHydrationQueryReference: maybeHydrationQueryReference, ...restJqlBuilderProps } = jqlBuilderProps ?? {
        maybeHydrationQueryReference: undefined
    };
    const { jql: jql, filterJql: filterJql, filterId: filterId, initialJql: initialJql } = (0, $fwKw5.useActiveJql)(); /**
                       * We will only utilise a router resource HydrationQueryReference if it is the
                       * first time the component is mounted on page load.
                       * So we check whether the query hasn't changed between page load and component mount
                       */ 
    const [hydrationQueryReferenceRef] = (0, $eJOHy.useState)(()=>{
        if (!(0, $7jTnu.fg)('jracloud_85520_hydration_ref_only_on_page_load')) return undefined;
        const initialQuery = (0, $7jTnu.fg)('jira_nin_last_used_jql') ? initialJql : initialQueryAsJql;
        return initialQuery === query ? maybeHydrationQueryReference : undefined;
    });
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const isSaveFilterButtonEnabled = (0, $7jTnu.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $aaLZH.useIssueNavigatorFeatures)().isSaveFilterButtonEnabled : true;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isFetching = (0, $3kDjB.useIsFetching)();
    const groupResultsData = (0, $j4oe4.useFragment)((0, $2nyUM.default), groupResults);
    const issueResultsData = (0, $j4oe4.useFragment)((0, $lzB0Q.default), issueResults);
    const issueSearchError = issueResultsData?.issueSearchError ?? null;
    const jqlErrors = (0, $eJOHy.useMemo)(()=>{
        const groupConnectionClientErrors = (groupResultsData?.errors ?? []).filter(({ extensions: extensions })=>extensions?.some(({ statusCode: statusCode })=>typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500));
        if (!isFetching) {
            if (issueSearchError) {
                if (issueSearchError.__typename === 'JiraInvalidJqlError') return issueSearchError.messages?.filter((0, $eibCx.isNonNullish)).map((message)=>({
                        type: 'error',
                        message: message
                    })) ?? [];
                if (issueSearchError.__typename === 'JiraInvalidSyntaxError' && issueSearchError.message != null) return [
                    {
                        type: 'error',
                        message: issueSearchError.message,
                        errorType: issueSearchError.errorType ?? undefined
                    }
                ];
            } else if (groupConnectionClientErrors.length) return groupConnectionClientErrors.map(({ message: message })=>({
                    message: message,
                    type: 'error'
                }));
        }
        return undefined;
    }, [
        groupResultsData?.errors,
        isFetching,
        issueSearchError
    ]);
    const filterData = (0, $j4oe4.useFragment)((0, $h8y3a.default), filter);
    const ResetButtonControl = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $in3H6.default), {
            onReset: onReset
        }), [
        onReset
    ]);
    const GoBackToFilterButtonControl = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $in3H6.default), {
            onReset: onReset,
            isResetToFilter: true
        }), [
        onReset
    ]);
    const SaveFilterDialog = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('nin-save-filter-dialog-entry-point'), (0, $J0ugN.SaveFilterDialog), (0, $9LhIE.AsyncSaveFilterDialog));
    const SaveFilterControl = (0, $eJOHy.useCallback)(({ searchMode: searchMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($223373443ce3803e$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.save-filter-control",
            "data-vc": "jql-builder-ui-save-filter-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SaveFilterDialog, {
            jql: query,
            attributes: {
                isAdvancedModeEnabled: searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED)
            },
            onFilterSave: onFilterSave,
            buttonText: formatMessage((0, $a8Oge.default).saveFilterButton),
            title: formatMessage((0, $a8Oge.default).saveFilterDialogTitle)
        })), [
        onFilterSave,
        query,
        formatMessage,
        SaveFilterDialog
    ]);
    const SaveFilterDropdownControl = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($223373443ce3803e$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.save-filter-dropdown-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5i1j5.SaveFilterDropdown), {
            query: query,
            filterId: filterId,
            onFilterSave: onFilterSave
        })), [
        filterId,
        query,
        onFilterSave
    ]);
    const CopyFilterControl = (0, $eJOHy.useCallback)(({ searchMode: searchMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($223373443ce3803e$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.copy-filter-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SaveFilterDialog, {
            jql: query,
            filterId: filterId,
            attributes: {
                isAdvancedModeEnabled: searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED)
            },
            onFilterSave: onFilterSave,
            buttonText: formatMessage((0, $a8Oge.default).copyFilterButton),
            title: formatMessage((0, $a8Oge.default).copyFilterDialogTitle)
        })), [
        onFilterSave,
        query,
        filterId,
        formatMessage,
        SaveFilterDialog
    ]);
    const renderFilterControls = (0, $eJOHy.useCallback)(()=>{
        const extraControls = []; // Button nor dropdown should be shown when user is anonymous
        if (!isAnonymous && isSaveFilterButtonEnabled) {
            if (filterData) {
                const { isEditable: isEditable } = filterData; // Should not show neither the button nor the dropdown if jql errors
                if (!jqlErrors || jqlErrors.length === 0) {
                    if ((0, $5B9jk.isFilterJqlModified)({
                        filterJql: filterJql,
                        query: query
                    })) {
                        if (isEditable === true) extraControls.push(SaveFilterDropdownControl);
                        else extraControls.push(SaveFilterControl);
                    } else extraControls.push(CopyFilterControl);
                }
            } else extraControls.push(SaveFilterControl);
        }
        return extraControls;
    }, [
        CopyFilterControl,
        SaveFilterControl,
        SaveFilterDropdownControl,
        filterData,
        filterJql,
        isAnonymous,
        isSaveFilterButtonEnabled,
        jqlErrors,
        query
    ]);
    const renderExtraControls = (0, $eJOHy.useCallback)(()=>{
        const extraControls = []; // eslint-disable-next-line jira/ff/no-preconditioning
        const isNinSavedFiltersEnabled = (0, $7jTnu.fg)('nin-saved-filters') && (0, $7jTnu.fg)('jira_list_nin_merge');
        const showResetButton = disableBackToFilterButton && (0, $5B9jk.jqlIsDifferentToDefault)(jql, defaultJql) && isNinSavedFiltersEnabled || (0, $5B9jk.isOnlyJqlAndDifferentToDefault)(jql, defaultJql, filterJql) || (0, $5B9jk.isOnlyFilterAndDifferentToDefault)(jql, defaultJql, filterJql) || (0, $5B9jk.filterAndJqlIsTheSameAndDifferentToDefault)(jql, defaultJql, filterJql);
        const showGoBackToFilterButton = disableBackToFilterButton && isNinSavedFiltersEnabled ? false : (0, $5B9jk.jqlIsDifferentToFilter)(jql, filterJql);
        const addResetButton = ()=>showGoBackToFilterButton || showResetButton;
        if (addResetButton()) extraControls.push(showResetButton ? ResetButtonControl : GoBackToFilterButtonControl);
        extraControls.push(...renderFilterControls());
        return extraControls;
    }, [
        jql,
        defaultJql,
        filterJql,
        disableBackToFilterButton,
        renderFilterControls,
        ResetButtonControl,
        GoBackToFilterButtonControl
    ]);
    const { messages: jqlInfos } = (0, $4COCY.useJqlSearchStatus)({
        query: query,
        isSearching: isFetching
    });
    const jqlMessages = (0, $eJOHy.useMemo)(()=>[
            ...jqlErrors || [],
            ...jqlInfos || []
        ], [
        jqlErrors,
        jqlInfos
    ]);
    const onLoad = (0, $eJOHy.useCallback)((mode)=>{
        if (mode === (0, $56qWy.SEARCH_MODE_BASIC)) markJqlBuilderMetric((0, $fAgUF.marks).JQL_BUILDER_BASIC_START);
        else markJqlBuilderMetric((0, $fAgUF.marks).JQL_BUILDER_ADVANCED_START);
    }, [
        markJqlBuilderMetric
    ]);
    const onReady = (0, $eJOHy.useCallback)((mode)=>{
        if (mode === (0, $56qWy.SEARCH_MODE_BASIC)) {
            markJqlBuilderMetric((0, $fAgUF.marks).JQL_BUILDER_BASIC_END);
            markJqlBuilderMetric((0, $fAgUF.marks).JQL_BUILDER_END);
        } else {
            markJqlBuilderMetric((0, $fAgUF.marks).JQL_BUILDER_ADVANCED_END);
            markJqlBuilderMetric((0, $fAgUF.marks).JQL_BUILDER_END);
        }
        stopJqlBuilderMetric();
    }, [
        stopJqlBuilderMetric,
        markJqlBuilderMetric
    ]);
    const aiBuilderOverrides = (0, $eJOHy.useMemo)(()=>({
            // Only render filter controls (no reset action) for the AI embedded JQL builder
            renderExtraControls: renderFilterControls
        }), [
        renderFilterControls
    ]); /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ 
    const jqlBuilderWithAiData = (0, $j4oe4.useFragment)((0, $ccfQZ.default), jqlBuilderWithAiKey); /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ 
    const { onJourneyStart: onJourneyStart } = (0, $61oZD.useAppContextualAnalyticsActions)();
    const handlePerformanceMark = (0, $eJOHy.useCallback)(({ mark: mark })=>{
        markJqlBuilderMetric(mark);
    }, [
        markJqlBuilderMetric
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $223373443ce3803e$var$wrapperStyles,
            (0, $6zXPf.getWillShowNav4)() && $223373443ce3803e$var$newWrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lzg2Z.ShortcutsDialogIntegrationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5ekXO.default), {
        analyticsSource: (0, $iRahl.ANALYTICS_SOURCE),
        query: query,
        onSearch: onSearch,
        renderExtraControls: renderExtraControls,
        jqlMessages: jqlMessages,
        isSearching: isFetching,
        onReady: onReady,
        onLoad: onLoad,
        onJourneyStart: onJourneyStart,
        NoOptionComponent: (0, $3d17F.NoOptionsMessage),
        aiBuilderOverrides: aiBuilderOverrides,
        onToggleAi: onToggleAi,
        fragmentKey: jqlBuilderWithAiData ?? null,
        onPerformanceMark: handlePerformanceMark,
        ...(0, $7jTnu.fg)('jracloud_85520_hydration_ref_only_on_page_load') ? {
            maybeHydrationQueryReference: hydrationQueryReferenceRef,
            ...restJqlBuilderProps
        } : jqlBuilderProps,
        preloadedEntryPoints: {
            jqlBuilderWithAiEntryPoint: jqlBuilderProps?.preloadedEntryPoints?.jqlBuilderWithAiEntryPoint
        }
    })));
};
const $223373443ce3803e$var$JQLBuilderWrapperWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-navigator-jql-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "ui.jql-builder.error-boundary",
        packageName: (0, $iRahl.PACKAGE_NAME),
        teamName: (0, $iRahl.TEAM_NAME),
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $g8Az8.isLoaderErrorAttributes),
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gVAWF.JQLBuilderErrorBoundryFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($223373443ce3803e$var$JQLBuilderWrapper, props)));
var $223373443ce3803e$export$2e2bcd8739ae039 = $223373443ce3803e$var$JQLBuilderWrapperWithErrorBoundary;
const $223373443ce3803e$var$wrapperStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.negative.025',
    marginBottom: 'space.0'
});
const $223373443ce3803e$var$newWrapperStyles = (0, $1DXK0.xcss)({
    flexGrow: 'var(--jql-wrapper-grow, 0)',
    maxHeight: 'min-content'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $223373443ce3803e$var$SaveFilterWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ccfQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3cb921bdfb58d7b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06d45c4a967a726649440032225a9335>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f3cb921bdfb58d7b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "JQLBuilderWithAI"
        }
    ],
    "type": "JiraQuery"
};
$f3cb921bdfb58d7b$var$node.hash = "80c3394e44d3807fba8367e369569f00";
var $f3cb921bdfb58d7b$export$2e2bcd8739ae039 = $f3cb921bdfb58d7b$var$node;

});

parcelRegister("h8y3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $31436b4ae18dbd00$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a76e30faae7fd3f790cc395215820217>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $31436b4ae18dbd00$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ],
    "type": "JiraCustomFilter"
};
$31436b4ae18dbd00$var$node.hash = "46b543f50c73d7423957a8ecbe71b627";
var $31436b4ae18dbd00$export$2e2bcd8739ae039 = $31436b4ae18dbd00$var$node;

});

parcelRegister("lzB0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $4234518ff8c742bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a3182e66785e68d12090ebb9bf08695e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4234518ff8c742bf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "messages"
                        }
                    ],
                    "type": "JiraInvalidJqlError"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "errorType"
                        }
                    ],
                    "type": "JiraInvalidSyntaxError"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$4234518ff8c742bf$var$node.hash = "eeb59c3a307dc75263f7e39b4f314c7c";
var $4234518ff8c742bf$export$2e2bcd8739ae039 = $4234518ff8c742bf$var$node;

});

parcelRegister("2nyUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $13d08fcbe13c395d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2da135e56e9e45c2e5f481821656e304>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $13d08fcbe13c395d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults",
    "selections": [
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$13d08fcbe13c395d$var$node.hash = "30cd518272beee6c712a219e1b78cd63";
var $13d08fcbe13c395d$export$2e2bcd8739ae039 = $13d08fcbe13c395d$var$node;

});

parcelRegister("5i1j5", function(module, exports) {

$parcel$export(module.exports, "SaveFilterDropdown", () => $e2d596642d928dfd$export$4aae2fedc7924eed);

var $9ax8O = parcelRequire("9ax8O");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $5lAAn = parcelRequire("5lAAn");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $gYnSx = parcelRequire("gYnSx");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $lBPsC = parcelRequire("lBPsC");

var $j1qd7 = parcelRequire("j1qd7");

var $8oKDI = parcelRequire("8oKDI");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $KwCgo = parcelRequire("KwCgo");

var $7aUkH = parcelRequire("7aUkH");

var $lvKO5 = parcelRequire("lvKO5");

var $dF958 = parcelRequire("dF958");

var $7jTnu = parcelRequire("7jTnu");

var $d1S9l = parcelRequire("d1S9l");

var $3t225 = parcelRequire("3t225");
const $e2d596642d928dfd$export$a3ca021e3e6c7315 = (0, $hrodw.toFlagId)('issue-navigator-save-filter-success-flag');
const $e2d596642d928dfd$export$f5e4c120ac01b615 = (0, $hrodw.toFlagId)('issue-navigator-save-filter-error-flag');
const $e2d596642d928dfd$export$4aae2fedc7924eed = ({ defaultOpen: defaultOpen = false, filterId: filterId, query: query, onFilterSave: onFilterSave })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const [updateJiraCustomFilterJqlMutation] = (0, $j4oe4.useMutation)((0, $9ax8O.default));
    const { activationId: activationId, cloudId: cloudId } = (0, $lvKO5.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    const onSaveChanges = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'saveFilterChanges');
        filterId !== undefined && updateJiraCustomFilterJqlMutation({
            variables: {
                id: (0, $8oKDI.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }),
                jql: query
            },
            onCompleted: ({ jira: jira })=>{
                if (jira?.jiraFilterMutation?.updateJiraCustomFilterJql) {
                    const { success: success, filter: filter, errors: jiraErrors } = jira?.jiraFilterMutation?.updateJiraCustomFilterJql;
                    if (success && filter) {
                        const { name: name } = filter;
                        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({
                            actionSubject: 'issueFilterJql',
                            action: 'updated'
                        }), 'issueFilterJql updated');
                        showFlag({
                            id: $e2d596642d928dfd$export$a3ca021e3e6c7315,
                            render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1qd7.SuccessFlag), {
                                    id: $e2d596642d928dfd$export$a3ca021e3e6c7315,
                                    messageId: "issue-navigator-custom-filters.ui.save-filter-dropdown.success-flag",
                                    messageType: "transactional",
                                    filterName: name,
                                    viewUrl: `${window.location.origin}/issues/?filter=${filterId}`,
                                    analyticsEvent: createAnalyticsEvent({
                                        actionSubject: 'button',
                                        action: 'clicked'
                                    }),
                                    ...renderProps
                                })
                        });
                    } else {
                        const errors = jiraErrors ? jiraErrors.map((error)=>error.message || '') : [];
                        showFlag({
                            id: $e2d596642d928dfd$export$f5e4c120ac01b615,
                            render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lBPsC.ErrorFlag), {
                                    id: $e2d596642d928dfd$export$f5e4c120ac01b615,
                                    messageId: "issue-navigator-custom-filters.ui.save-filter-dropdown.error-flag",
                                    messageType: "transactional",
                                    errors: errors,
                                    ...renderProps
                                })
                        });
                        (0, $gYnSx.default)({
                            event: analyticsEvent,
                            error: new Error(errors[0]),
                            meta: {
                                id: 'updateFilterJqlMutation',
                                packageName: 'jiraIssueNavigatorCustomFilters',
                                teamName: 'empanada'
                            }
                        });
                    }
                }
            },
            onError: (error)=>{
                showFlag({
                    id: $e2d596642d928dfd$export$f5e4c120ac01b615,
                    render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lBPsC.ErrorFlag), {
                            id: $e2d596642d928dfd$export$f5e4c120ac01b615,
                            messageId: "issue-navigator-custom-filters.ui.save-filter-dropdown.error-flag.1",
                            messageType: "transactional",
                            ...renderProps,
                            errors: [
                                ''
                            ]
                        })
                });
                (0, $gYnSx.default)({
                    event: analyticsEvent,
                    error: error,
                    meta: {
                        id: 'updateFilterJqlMutation',
                        packageName: 'jiraIssueNavigatorCustomFilters',
                        teamName: 'empanada'
                    }
                });
                return undefined;
            }
        });
    }, [
        activationId,
        cloudId,
        createAnalyticsEvent,
        filterId,
        query,
        showFlag,
        updateJiraCustomFilterJqlMutation,
        analyticsEvent
    ]);
    const [isModalOpen, setIsModalOpen] = (0, $eJOHy.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(defaultOpen);
    const [shouldShowThirdPartyNudge, setShouldShowThirdPartyNudge] = (0, $eJOHy.useState)(false);
    const onOpenSaveFilterModal = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'saveFilterCopy');
        if (!(0, $7jTnu.fg)('nin-save-filter-dialog-entry-point')) setIsModalOpen(true);
    }, [
        createAnalyticsEvent,
        setIsModalOpen
    ]);
    const onCloseSaveFilterModal = (0, $eJOHy.useCallback)(()=>{
        setIsModalOpen(false);
    }, [
        setIsModalOpen
    ]);
    let modalProps;
    let entryPointProps;
    let entryPointParams;
    if ((0, $7jTnu.fg)('nin-save-filter-dialog-entry-point')) {
        modalProps = {
            width: 'medium',
            shouldScrollInViewport: true,
            shouldReturnFocus: false
        }; // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        entryPointProps = (0, $eJOHy.useMemo)(()=>({
                jql: query,
                filterId: filterId,
                onFilterSave: onFilterSave,
                title: formatMessage((0, $3t225.default).copyFilterDialogTitle)
            }), [
            query,
            filterId,
            onFilterSave,
            formatMessage
        ]); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        entryPointParams = (0, $eJOHy.useMemo)(()=>({
                filterAri: filterId !== null && filterId !== undefined ? (0, $8oKDI.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }) : undefined
            }), [
            filterId,
            cloudId,
            activationId
        ]);
    }
    const onTriggerClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        }), 'filterOptions');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, shouldShowThirdPartyNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dF958.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e2d596642d928dfd$var$DropdownMenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        isOpen: isDropdownOpen,
        onOpenChange: (attrs)=>{
            setIsDropdownOpen(attrs.isOpen);
            if (attrs.isOpen) {
                setShouldShowThirdPartyNudge(true);
                onTriggerClick();
            }
        },
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                appearance: "link",
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                    label: formatMessage((0, $3t225.default).saveFilter),
                    size: "small"
                })
            }, formatMessage((0, $3t225.default).saveFilter)),
        shouldRenderToParent: (0, $7jTnu.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        onClick: onSaveChanges
    }, formatMessage((0, $3t225.default).saveChanges)), (0, $7jTnu.fg)('nin-save-filter-dialog-entry-point') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d1S9l.ModalEntryPointDropdownItemTrigger), {
        onClick: onOpenSaveFilterModal,
        modalProps: modalProps,
        entryPoint: (0, $KwCgo.saveFilterDialogEntryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "jiraSaveFilterDialog.SaveFilter",
        useInternalModal: true
    }, formatMessage((0, $3t225.default).saveAsACopy)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        onClick: onOpenSaveFilterModal
    }, formatMessage((0, $3t225.default).saveAsACopy))))), !(0, $7jTnu.fg)('nin-save-filter-dialog-entry-point') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7aUkH.AsyncSaveFilterDialogContent), {
        isOpen: isModalOpen,
        jql: query,
        filterId: filterId,
        onClose: onCloseSaveFilterModal,
        onFilterSave: onFilterSave,
        title: formatMessage((0, $3t225.default).copyFilterDialogTitle)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e2d596642d928dfd$var$DropdownMenuWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k4hekqvv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9ax8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbe1c0422058152e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bfa68958cffd28f839eb1cc1261ee729>>
 * @relayHash a8b99d4e5148c557424db90f1be8215c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 33abce877d8ddf36bd3fdb295b2e91c467ceff0b718872d73a32845f7130d8d5
const $cbe1c0422058152e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraFilterMutation",
                    "kind": "LinkedField",
                    "name": "jiraFilterMutation",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "id"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "jql",
                                            "variableName": "jql"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "input"
                                }
                            ],
                            "concreteType": "JiraUpdateCustomFilterJqlPayload",
                            "kind": "LinkedField",
                            "name": "updateJiraCustomFilterJql",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraCustomFilter",
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainUpdateFilterJqlMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainUpdateFilterJqlMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "33abce877d8ddf36bd3fdb295b2e91c467ceff0b718872d73a32845f7130d8d5",
            "metadata": {},
            "name": "mainUpdateFilterJqlMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$cbe1c0422058152e$var$node.hash = "6807efed6a00f60f9cf95df455e467fd";
var $cbe1c0422058152e$export$2e2bcd8739ae039 = $cbe1c0422058152e$var$node;

});

parcelRegister("lBPsC", function(module, exports) {

$parcel$export(module.exports, "ErrorFlag", () => $53224918a80e87c9$export$518ba8e0e60f145f);

var $eJOHy = parcelRequire("eJOHy");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $hsAfg = parcelRequire("hsAfg");

var $lRq8t = parcelRequire("lRq8t");

var $cU9K7 = parcelRequire("cU9K7");
const $53224918a80e87c9$export$518ba8e0e60f145f = ({ id: id, errors: errors, messageId: messageId = 'issue-navigator-actions-common.ui.error-flag.jira-error-flag', messageType: messageType = 'transactional' })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const onDismissed = (0, $eJOHy.useCallback)(()=>dismissFlag(id), [
        dismissFlag,
        id
    ]);
    const description = (0, $eJOHy.useMemo)(()=>errors.reduce((desc, error)=>`${desc}\n${error}`), [
        errors
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hsAfg.default), {
        id: (0, $hrodw.fromFlagId)(id),
        onDismissed: onDismissed,
        title: formatMessage((0, $cU9K7.default).flagTitle),
        description: description,
        messageId: messageId,
        messageType: messageType
    });
};

});
parcelRegister("cU9K7", function(module, exports) {

$parcel$export(module.exports, "default", () => $21837d8f097bb3d5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $21837d8f097bb3d5$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    flagTitle: {
        "id": "issue-navigator-actions-common.error-flag.flag-title",
        "defaultMessage": "Filter couldn't be saved"
    }
});

});


parcelRegister("j1qd7", function(module, exports) {

$parcel$export(module.exports, "SuccessFlag", () => $228f3473b1cf795e$export$93bd4963a1d00fd5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gYnSx = parcelRequire("gYnSx");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $8w5Cq = parcelRequire("8w5Cq");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $kHc9M = parcelRequire("kHc9M");
const $228f3473b1cf795e$export$93bd4963a1d00fd5 = ({ id: id, filterName: filterName, viewUrl: viewUrl, analyticsEvent: analyticsEvent, messageId: messageId = 'issue-navigator-actions-common.ui.success-flag.jira-success-flag', messageType: messageType = 'transactional' })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const [isCopied, setCopied] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const copyToClipboard = (0, $eJOHy.useCallback)(()=>{
        try {
            globalThis.navigator.clipboard.writeText(viewUrl);
            setCopied(true);
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'copyLink'); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'copyToClipboard',
                    packageName: 'jiraIssueNavigatorActionsCommon'
                }
            });
        }
    }, [
        analyticsEvent,
        viewUrl
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>{
        const flagActions = [];
        flagActions.push({
            content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($228f3473b1cf795e$var$CopySuccess, null, formatMessage((0, $kHc9M.default).copyActionCopied)) : formatMessage((0, $kHc9M.default).copyAction),
            onClick: copyToClipboard
        });
        return flagActions;
    }, [
        copyToClipboard,
        formatMessage,
        isCopied
    ]);
    const onDismissed = (0, $eJOHy.useCallback)(()=>dismissFlag(id), [
        dismissFlag,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8w5Cq.default), {
        id: (0, $hrodw.fromFlagId)(id),
        onDismissed: onDismissed,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($228f3473b1cf795e$var$WordBreakSpan, null, formatMessage((0, $kHc9M.default).flagTitle, {
            name: filterName
        })),
        description: formatMessage((0, $kHc9M.default).flagDescription),
        messageId: messageId,
        messageType: messageType,
        actions: actions
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $228f3473b1cf795e$var$CopySuccess = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syazy73q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $228f3473b1cf795e$var$WordBreakSpan = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1nmz1hna",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $228f3473b1cf795e$export$7ed12d2a5241e393 = {
    WordBreakSpan: $228f3473b1cf795e$var$WordBreakSpan
};

});
parcelRegister("kHc9M", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a2e40dfe6da8157$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7a2e40dfe6da8157$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    flagTitle: {
        "id": "issue-navigator-actions-common.success-flag.flag-title",
        "defaultMessage": "\"{name}\" filter saved"
    },
    flagDescription: {
        "id": "issue-navigator-actions-common.success-flag.flag-description",
        "defaultMessage": "We\u2019ve saved this filter successfully."
    },
    viewAction: {
        "id": "issue-navigator-actions-common.success-flag.view-action",
        "defaultMessage": "View filter"
    },
    copyAction: {
        "id": "issue-navigator-actions-common.success-flag.copy-action",
        "defaultMessage": "Copy link"
    },
    copyActionCopied: {
        "id": "issue-navigator-actions-common.success-flag.copy-action-copied",
        "defaultMessage": "Copied"
    }
});

});


parcelRegister("dF958", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20eb83de0c2fc58$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $kg1bv = parcelRequire("kg1bv");
const $c20eb83de0c2fc58$var$runtimeProps = {};
const $c20eb83de0c2fc58$var$entryPointParams = {};
const $c20eb83de0c2fc58$var$AsyncThirdPartyNudge = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $kg1bv.thirdPartyNudgeEntryPoint), $c20eb83de0c2fc58$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "third-party-nudge-spotlight",
        packageName: "third-party-nudge",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $c20eb83de0c2fc58$var$runtimeProps,
        errorFallback: "unmount"
    });
};
var $c20eb83de0c2fc58$export$2e2bcd8739ae039 = $c20eb83de0c2fc58$var$AsyncThirdPartyNudge;

});
parcelRegister("kg1bv", function(module, exports) {

$parcel$export(module.exports, "thirdPartyNudgeEntryPoint", () => $7b3398d7aaaf0cc0$export$b751b31b276f613a);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7b3398d7aaaf0cc0$export$b751b31b276f613a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("dp2bH")), {
        moduleId: "3cb7fd8f",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dp2bH", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5WL6j").then(()=>parcelRequire('3U1SG'));

});



parcelRegister("3t225", function(module, exports) {

$parcel$export(module.exports, "default", () => $32150c77d65fbd54$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $32150c77d65fbd54$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    saveFilter: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-filter",
        "defaultMessage": "Save filter"
    },
    saveChanges: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-changes",
        "defaultMessage": "Save changes"
    },
    saveAsACopy: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-as-a-copy",
        "defaultMessage": "Save as a copy"
    },
    copyFilterDialogTitle: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    }
});

});


parcelRegister("lzg2Z", function(module, exports) {

$parcel$export(module.exports, "useIntegrateDotDialogContext", () => $cc4956edece29853$export$705d46354f301b1c);
$parcel$export(module.exports, "ShortcutsDialogIntegrationProvider", () => $cc4956edece29853$export$97e3ca22c7078b46);

var $eJOHy = parcelRequire("eJOHy");
const $cc4956edece29853$var$PRESET_VALUE = {
    DEFAULT: {
        isShortcutsDialogIntegrationAvailable: false
    },
    INTEGRATED: {
        isShortcutsDialogIntegrationAvailable: true
    }
};
const $cc4956edece29853$var$IntegrateDotDialogContext = /*#__PURE__*/ (0, $eJOHy.createContext)($cc4956edece29853$var$PRESET_VALUE.DEFAULT);
const $cc4956edece29853$export$705d46354f301b1c = ()=>(0, $eJOHy.useContext)($cc4956edece29853$var$IntegrateDotDialogContext);
const $cc4956edece29853$export$97e3ca22c7078b46 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cc4956edece29853$var$IntegrateDotDialogContext.Provider, {
        value: $cc4956edece29853$var$PRESET_VALUE.INTEGRATED
    }, children);

});

parcelRegister("gVAWF", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderErrorBoundryFallback", () => $753680c12bef645e$export$4c766016a5659721);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $iHPvF = parcelRequire("iHPvF");

var $lRq8t = parcelRequire("lRq8t");

var $hN3Oc = parcelRequire("hN3Oc");
const $753680c12bef645e$var$onRefresh = ()=>{
    if (typeof window !== 'undefined') window.location.reload();
};
const $753680c12bef645e$export$4c766016a5659721 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "error",
        testId: "jql-builder-common.ui.error-boundry-fallback.section-message"
    }, formatMessage((0, $hN3Oc.default).errorMessage, {
        link: (linkText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "link",
                spacing: "none",
                onClick: $753680c12bef645e$var$onRefresh
            }, linkText)
    }));
};

});
parcelRegister("iHPvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c4a865afee94050$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ay1uj = parcelRequire("Ay1uj");

var $806LH = parcelRequire("806LH");

var $6J9k6 = parcelRequire("6J9k6");

var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $9y5qW = parcelRequire("9y5qW");
const $1c4a865afee94050$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_19pk1i6y"
};
const $1c4a865afee94050$var$appearanceStyles = {
    information: "_bfhk33gi",
    warning: "_bfhk1tzq",
    error: "_bfhk1gly",
    success: "_bfhkmv6i",
    discovery: "_bfhk1nvp"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $1c4a865afee94050$var$SectionMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref) {
    const [dismissed, setDismissed] = (0, $eJOHy.useState)(false);
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        onDismiss?.();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $9y5qW.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, $eJOHy.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $eJOHy.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $gt9Am.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            $1c4a865afee94050$var$sectionMessageStyles.container,
            $1c4a865afee94050$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1c4a865afee94050$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $1c4a865afee94050$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $1c4a865afee94050$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: $1c4a865afee94050$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1c4a865afee94050$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$1c4a865afee94050$var$SectionMessage.displayName = 'SectionMessage';
var $1c4a865afee94050$export$2e2bcd8739ae039 = $1c4a865afee94050$var$SectionMessage;

});
parcelRegister("9y5qW", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $1656794cf4e78acc$export$e9b82d2e21ac0c1f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $ejT8C = parcelRequire("ejT8C");

var $k9Gmz = parcelRequire("k9Gmz");

var $1NG86 = parcelRequire("1NG86");

var $i4Iw4 = parcelRequire("i4Iw4");

var $3TFuO = parcelRequire("3TFuO");

var $jkYbX = parcelRequire("jkYbX");

var $eGOwo = parcelRequire("eGOwo");

const $1656794cf4e78acc$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $7bb4c1736002a04a$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $7bb4c1736002a04a$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $7bb4c1736002a04a$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $7bb4c1736002a04a$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1NG86))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $7bb4c1736002a04a$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $7bb4c1736002a04a$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($k9Gmz))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$export$147899de772240ec)})`
    },
    discoveryUpdated: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $7bb4c1736002a04a$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ejT8C))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$export$147899de772240ec)})`
    }
};
function $1656794cf4e78acc$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $1656794cf4e78acc$var$appearanceIconSchema[appearance === 'discovery' && (0, $eGOwo.fg)('platform_dst_section_message_discovery_icon') ? 'discoveryUpdated' : appearance] || $1656794cf4e78acc$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("ejT8C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5501f2ec2c7fc2907a8ddc6771935d76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cd9c4605f2f731$var$_react = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a6cd9c4605f2f731$var$_discovery = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("h4COp")));

var $a6cd9c4605f2f731$var$_note = $a6cd9c4605f2f731$var$_interopRequireDefault((parcelRequire("94404")));
function $a6cd9c4605f2f731$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cd9c4605f2f731$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $a6cd9c4605f2f731$var$_react.default.createElement($a6cd9c4605f2f731$var$_discovery.default, Object.assign({
        name: "DiscoveryIcon",
        LEGACY_fallbackIcon: $a6cd9c4605f2f731$var$_note.default
    }, props));
$a6cd9c4605f2f731$var$DiscoveryIcon.displayName = 'DiscoveryIconMigration';
var $a6cd9c4605f2f731$var$_default = module.exports.default = $a6cd9c4605f2f731$var$DiscoveryIcon;

});
parcelRegister("h4COp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84ac540d37aa7b8e7ab349dbbb474c30>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6e0eaad244db33f$var$_react = $c6e0eaad244db33f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c6e0eaad244db33f$var$_baseNew = $c6e0eaad244db33f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c6e0eaad244db33f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6e0eaad244db33f$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $c6e0eaad244db33f$var$_react.default.createElement($c6e0eaad244db33f$var$_baseNew.default, Object.assign({
        name: "DiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$c6e0eaad244db33f$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $c6e0eaad244db33f$var$_default = module.exports.default = $c6e0eaad244db33f$var$DiscoveryIcon;

});

parcelRegister("94404", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6997971b5d08dbe2$var$_react = $6997971b5d08dbe2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $6997971b5d08dbe2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6997971b5d08dbe2$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $6997971b5d08dbe2$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$6997971b5d08dbe2$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $6997971b5d08dbe2$var$_default = module.exports.default = $6997971b5d08dbe2$var$EditorNoteIcon;

});


var $7bb4c1736002a04a$exports = {};

$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';



parcelRegister("hN3Oc", function(module, exports) {

$parcel$export(module.exports, "default", () => $26ab64dd92055a31$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $26ab64dd92055a31$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "jql-builder-common.error-boundry-fallback.error-message",
        "defaultMessage": "We couldn't load your search criteria. <link>Refresh the page</link> to try again."
    }
});

});


parcelRegister("5ekXO", function(module, exports) {

$parcel$export(module.exports, "default", () => $89cd9a6ccae01711$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $16sa1 = parcelRequire("16sa1");

var $ch9En = parcelRequire("ch9En");

var $aF4Or = parcelRequire("aF4Or");

var $bQWwW = parcelRequire("bQWwW");

var $2dBpR = parcelRequire("2dBpR");

var $1KdDN = parcelRequire("1KdDN");

var $bJscI = parcelRequire("bJscI");

const $89cd9a6ccae01711$var$JQLBuilderWithAIAsync = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("eBcrM")), {
    moduleId: "./src/packages/jql-builder/with-ai/src/ui/JQLBuilderWithAI.tsx"
});
const $89cd9a6ccae01711$var$JQLBuilderWithAIWithRLL = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-jql-builder-with-ai",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aF4Or.IssueNavigatorJQLBuilderSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89cd9a6ccae01711$var$JQLBuilderWithAIAsync, props));
const $89cd9a6ccae01711$var$JQLBuilderWithAIWithEntrypoint = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const entryPointReference = props.preloadedEntryPoints?.jqlBuilderWithAiEntryPoint;
    if (entryPointReference) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "jql-builder-with-ai-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jql-builder-with-ai-entrypoint",
        packageName: "jiraJQLBuilderWithAI"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointReferencePlaceholder), {
        name: "jql-builder-with-ai",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aF4Or.IssueNavigatorJQLBuilderSkeleton), null),
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: props
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89cd9a6ccae01711$var$JQLBuilderWithAIWithRLL, props);
});
const $89cd9a6ccae01711$var$JQLBuilderWithAI = (0, $bJscI.componentWithFG)('jql_builder_basic_ssr_stability_fixes', $89cd9a6ccae01711$var$JQLBuilderWithAIWithEntrypoint, $89cd9a6ccae01711$var$JQLBuilderWithAIWithRLL);
var $89cd9a6ccae01711$export$2e2bcd8739ae039 = $89cd9a6ccae01711$var$JQLBuilderWithAI;

});
parcelRegister("aF4Or", function(module, exports) {

$parcel$export(module.exports, "IssueNavigatorJQLBuilderSkeleton", () => $8cf3c2e2df07d003$export$5be82223ddc28851);
/* jql-builder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $2uUhz = parcelRequire("2uUhz");
const $8cf3c2e2df07d003$var$customCssStyles = null;
const $8cf3c2e2df07d003$var$containerStyles = {
    height: '52px'
};
const $8cf3c2e2df07d003$export$5be82223ddc28851 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2uUhz))),
        containerStyles: $8cf3c2e2df07d003$var$containerStyles,
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("2uUhz", function(module, exports) {
module.exports = new URL("issue-navigator-jql-builder-skeleton.tpl.20beba3c.svg", import.meta.url).toString();

});


parcelRegister("eBcrM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("iuOzF")
]).then(()=>parcelRequire('3rNQG'));

});


parcelRegister("56qWy", function(module, exports) {

$parcel$export(module.exports, "SEARCH_MODE_BASIC", () => $8645a6ff5f3a8efb$export$f963d14b266e4d2e);
$parcel$export(module.exports, "SEARCH_MODE_ADVANCED", () => $8645a6ff5f3a8efb$export$aad1d9eb9b751555);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_BASIC", () => $8645a6ff5f3a8efb$export$87c41a6b3123c00f);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_ADVANCED", () => $8645a6ff5f3a8efb$export$a7a000706ebc3ba8);
$parcel$export(module.exports, "DEFAULT_SEARCH_MODE", () => $8645a6ff5f3a8efb$export$e1eb2ddab803c5ec);
$parcel$export(module.exports, "mapSearchModeToAnalyticAtribute", () => $8645a6ff5f3a8efb$export$70c8f980e4a50682);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_LEFT_LOCATION", () => $8645a6ff5f3a8efb$export$4dab29e715a4e6fb);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_RIGHT_LOCATION", () => $8645a6ff5f3a8efb$export$59848395da0b4bcb);
$parcel$export(module.exports, "PACKAGE_NAME", () => $8645a6ff5f3a8efb$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $8645a6ff5f3a8efb$export$d57b6b390e78d90f);
const $8645a6ff5f3a8efb$export$f963d14b266e4d2e = 'basic';
const $8645a6ff5f3a8efb$export$aad1d9eb9b751555 = 'advanced';
const $8645a6ff5f3a8efb$export$87c41a6b3123c00f = 'BASIC';
const $8645a6ff5f3a8efb$export$a7a000706ebc3ba8 = 'ADVANCED';
const $8645a6ff5f3a8efb$export$e1eb2ddab803c5ec = $8645a6ff5f3a8efb$export$f963d14b266e4d2e;
const $8645a6ff5f3a8efb$export$70c8f980e4a50682 = {
    [$8645a6ff5f3a8efb$export$f963d14b266e4d2e]: $8645a6ff5f3a8efb$export$f963d14b266e4d2e,
    [$8645a6ff5f3a8efb$export$aad1d9eb9b751555]: 'JQL'
};
const $8645a6ff5f3a8efb$export$4dab29e715a4e6fb = 'Left';
const $8645a6ff5f3a8efb$export$59848395da0b4bcb = 'Right';
const $8645a6ff5f3a8efb$export$b8b9d90f9e5bd72b = 'jiraJqlBuilder';
const $8645a6ff5f3a8efb$export$d57b6b390e78d90f = 'empanada';

});

parcelRegister("J0ugN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "SaveFilterDialog", () => $0c5b99e69ba2acd0$export$935f6430ba933614);
$parcel$export(module.exports, "default", () => $0c5b99e69ba2acd0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $7jTnu = parcelRequire("7jTnu");

var $f7Yza = parcelRequire("f7Yza");

var $8oKDI = parcelRequire("8oKDI");

var $gCeeo = parcelRequire("gCeeo");

var $4ihOZ = parcelRequire("4ihOZ");

var $kEUB1 = parcelRequire("kEUB1");

var $KwCgo = parcelRequire("KwCgo");

var $7aUkH = parcelRequire("7aUkH");
const $0c5b99e69ba2acd0$export$935f6430ba933614 = ({ buttonText: buttonText, filterId: filterId, ...props })=>{
    if (!(0, $7jTnu.fg)('nin-save-filter-dialog-entry-point')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const openModal = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'saveFilterDialog');
            setIsOpen(true);
        }, [
            setIsOpen
        ]);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const closeModal = (0, $eJOHy.useCallback)(()=>setIsOpen(false), [
            setIsOpen
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            onClick: openModal,
            appearance: "link",
            testId: "save-filter-dialog.ui.save-filter-dialog.button"
        }, buttonText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7aUkH.AsyncSaveFilterDialogContent), {
            onClose: closeModal,
            filterId: filterId,
            ...props,
            isOpen: isOpen
        }));
    }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 'medium',
            shouldScrollInViewport: true
        }), []);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            filterId: filterId,
            ...props
        }), [
        filterId,
        props
    ]);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const cloudId = (0, $kEUB1.useCloudId)();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const activationId = (0, $4ihOZ.useActivationId)();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            filterAri: filterId !== null && filterId !== undefined ? (0, $8oKDI.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'filter',
                resourceId: filterId,
                activationId: activationId
            }) : undefined
        }), [
        filterId,
        cloudId,
        activationId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
        modalProps: modalProps,
        entryPoint: (0, $KwCgo.saveFilterDialogEntryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "jiraSaveFilterDialog.SaveFilter",
        useInternalModal: true
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            onClick: (_, analyticsEvent)=>(0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'saveFilterDialog'),
            appearance: "link",
            testId: "save-filter-dialog.ui.save-filter-dialog.button",
            ref: ref
        }, buttonText));
};
var $0c5b99e69ba2acd0$export$2e2bcd8739ae039 = $0c5b99e69ba2acd0$export$935f6430ba933614;

});

parcelRegister("9LhIE", function(module, exports) {

$parcel$export(module.exports, "AsyncSaveFilterDialog", () => $567ea3df3d92044b$export$2213da0eee0aa8f);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $7jTnu = parcelRequire("7jTnu");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $567ea3df3d92044b$var$SaveFilterDialog = (0, $bQWwW.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("J0ugN"))), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/save-filter-dialog/main.tsx"
});
const $567ea3df3d92044b$export$2213da0eee0aa8f = (props)=>{
    if ((0, $7jTnu.fg)('nin-save-filter-dialog-entry-point')) throw new Error('RLL-based AsyncSaveFilterDialog Component should no longer be used');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "save-filters-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "link",
            isDisabled: true
        }, props.buttonText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($567ea3df3d92044b$var$SaveFilterDialog, props));
};

});

parcelRegister("4COCY", function(module, exports) {

$parcel$export(module.exports, "useJqlSearchStatus", () => $2636782f3a6d3c9c$export$6d36bd77a6aeafd9);

var $1BG3A = parcelRequire("1BG3A");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $lHVmb = parcelRequire("lHVmb");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $kEUB1 = parcelRequire("kEUB1");

var $cdF1X = parcelRequire("cdF1X");
const $2636782f3a6d3c9c$export$529d2e9d8e9d3cad = 2000; // wait 2s before making the request
const $2636782f3a6d3c9c$export$bbec15ef0a4926b6 = 7000; // wait 7s before retrying after the previous request
const $2636782f3a6d3c9c$export$cf31b3fd6a57249f = 5; // Check the status no more than 5 times for the same JQL search
const $2636782f3a6d3c9c$var$statusToMessages = (status, formatMessage)=>{
    if (status == null || !('functions' in status) || !Array.isArray(status?.functions)) return [];
    const processing = status.functions.filter((fn)=>fn.app && fn.function && fn.status === 'PROCESSING');
    const functions = Array.from(new Set(processing.map((fn)=>fn.function)));
    const apps = Array.from(new Set(processing.map((fn)=>fn.app)));
    switch(functions.length){
        case 0:
            return [];
        case 1:
            {
                const message = formatMessage((0, $cdF1X.default).singleSlowForgeFunction, {
                    functionName: functions[0],
                    appName: apps[0]
                });
                return [
                    {
                        type: 'info',
                        message: message
                    }
                ];
            }
        default:
            {
                let message;
                switch(apps.length){
                    case 1:
                        message = formatMessage((0, $cdF1X.default).multipleSlowForgeFunctionsFromTheSameApp, {
                            appName: apps[0]
                        });
                        break;
                    case 2:
                        message = formatMessage((0, $cdF1X.default).multipleSlowForgeFunctionsTwoApps, {
                            appName1: apps[0],
                            appName2: apps[1]
                        });
                        break;
                    default:
                        message = formatMessage((0, $cdF1X.default).multipleSlowForgeFunctionsThreeApps, {
                            appName1: apps[0],
                            appName2: apps[1],
                            appName3: apps[2]
                        });
                }
                return [
                    {
                        type: 'info',
                        message: message
                    }
                ];
            }
    }
};
const $2636782f3a6d3c9c$var$analyticsMeta = {
    id: 'jqlSearchStatus',
    packageName: 'jiraIssueNavigator',
    teamName: 'empanada'
};
const $2636782f3a6d3c9c$var$EMPTY_EXTERNAL_INFO = [];
const $2636782f3a6d3c9c$export$6d36bd77a6aeafd9 = ({ query: query, isSearching: isSearching })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [statusMessages, setStatusMessages] = (0, $eJOHy.useState)($2636782f3a6d3c9c$var$EMPTY_EXTERNAL_INFO);
    const isSearchingRef = (0, $eJOHy.useRef)(isSearching);
    const timeoutRef = (0, $eJOHy.useRef)(null);
    const fetchCountRef = (0, $eJOHy.useRef)(0);
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireOperationalEvent = (0, $eJOHy.useCallback)((action, attributes)=>(0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$2636782f3a6d3c9c$var$analyticsMeta.packageName}.${$2636782f3a6d3c9c$var$analyticsMeta.id} ${action}`, attributes), [
        createAnalyticsEvent
    ]);
    const cancelPendingOperations = (0, $eJOHy.useCallback)(()=>{
        timeoutRef.current && clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
        fetchCountRef.current = 0;
    }, []);
    const scheduleSearchStatusFetch = (0, $eJOHy.useCallback)((delay)=>{
        const isRetry = delay === $2636782f3a6d3c9c$export$bbec15ef0a4926b6;
        const defaultAnalyticsAttributes = (0, $lHVmb.createAttributes)({
            isRetry: isRetry
        });
        const timeout = setTimeout(()=>{
            if (fetchCountRef.current >= $2636782f3a6d3c9c$export$cf31b3fd6a57249f) {
                fireOperationalEvent('interrupted', {
                    ...defaultAnalyticsAttributes,
                    reason: 'MAX_ATTEMPTS_REACHED'
                });
                return;
            }
            fireOperationalEvent('attempt', defaultAnalyticsAttributes);
            fetchCountRef.current += 1;
            (0, $j4oe4.fetchQuery)(environment, (0, $1BG3A.default), {
                cloudId: cloudId,
                jql: query
            }, {
                fetchPolicy: 'network-only'
            }).toPromise().then((data)=>{
                let hasPendingFn = false;
                const status = data?.jira?.issueSearchStatus ?? null;
                if (isSearchingRef.current && timeoutRef.current === timeout) {
                    const infos = $2636782f3a6d3c9c$var$statusToMessages(status, formatMessage);
                    setStatusMessages(infos);
                    if (infos.length) {
                        hasPendingFn = true;
                        scheduleSearchStatusFetch($2636782f3a6d3c9c$export$bbec15ef0a4926b6);
                    }
                }
                fireOperationalEvent('finished', {
                    ...defaultAnalyticsAttributes,
                    hasPendingFn: hasPendingFn
                });
            }).catch((error)=>{
                (0, $gYnSx.default)({
                    meta: $2636782f3a6d3c9c$var$analyticsMeta,
                    attributes: (0, $lHVmb.createAttributes)({
                        error: error,
                        isRetry: isRetry
                    })
                });
                if (isSearchingRef.current && timeoutRef.current === timeout) scheduleSearchStatusFetch($2636782f3a6d3c9c$export$bbec15ef0a4926b6);
            });
        }, delay);
        timeoutRef.current = timeout;
    }, [
        cloudId,
        environment,
        fireOperationalEvent,
        formatMessage,
        query
    ]);
    (0, $eJOHy.useEffect)(()=>{
        isSearchingRef.current = isSearching;
    }, [
        isSearching
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setStatusMessages($2636782f3a6d3c9c$var$EMPTY_EXTERNAL_INFO);
        cancelPendingOperations();
        if (isSearching) scheduleSearchStatusFetch($2636782f3a6d3c9c$export$529d2e9d8e9d3cad);
    }, [
        isSearching,
        query,
        cancelPendingOperations,
        scheduleSearchStatusFetch
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            messages: statusMessages
        }), [
        statusMessages
    ]);
};

});
parcelRegister("1BG3A", function(module, exports) {

$parcel$export(module.exports, "default", () => $59b809d06c6bdfe6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06f329a4787d481a42a4c55f0b801953>>
 * @relayHash 7d47bdaa4d5aeb847704c6e13c25fd58
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e680ef9e6d909ed43bf02677fe95ccafcad565518b3a659febcd16aa4f5bbd8
const $59b809d06c6bdfe6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "jql",
                            "variableName": "jql"
                        }
                    ],
                    "concreteType": "JiraIssueSearchStatus",
                    "kind": "LinkedField",
                    "name": "issueSearchStatus",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraJqlFunctionProcessingStatus",
                            "kind": "LinkedField",
                            "name": "functions",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "function"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "app"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "jqlSearchStatus_Query",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "jqlSearchStatus_Query",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "8e680ef9e6d909ed43bf02677fe95ccafcad565518b3a659febcd16aa4f5bbd8",
            "metadata": {},
            "name": "jqlSearchStatus_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$59b809d06c6bdfe6$var$node.hash = "9dd1bed08ceb0d25df132f36097ae6d1";
var $59b809d06c6bdfe6$export$2e2bcd8739ae039 = $59b809d06c6bdfe6$var$node;

});

parcelRegister("cdF1X", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fb766a04ea5acb0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8fb766a04ea5acb0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    singleSlowForgeFunction: {
        "id": "issue-navigator.controllers.jql-search-status.single-slow-forge-function",
        "defaultMessage": "{appName} is still executing the {functionName} JQL function."
    },
    multipleSlowForgeFunctionsFromTheSameApp: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-from-the-same-app",
        "defaultMessage": "{appName} is still executing multiple JQL functions."
    },
    multipleSlowForgeFunctionsTwoApps: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-two-apps",
        "defaultMessage": "{appName1} and {appName2} are still executing multiple JQL functions."
    },
    multipleSlowForgeFunctionsThreeApps: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-three-apps",
        "defaultMessage": "{appName1}, {appName2}, and {appName3} are still executing multiple JQL functions."
    }
});

});


parcelRegister("1fmSG", function(module, exports) {

$parcel$export(module.exports, "useJqlSearch", () => $b4925a5b6cf0a624$export$e69d0de2e354a2cb);

var $eJOHy = parcelRequire("eJOHy");

var $fwKw5 = parcelRequire("fwKw5");

var $3kDjB = parcelRequire("3kDjB");
const $b4925a5b6cf0a624$export$e69d0de2e354a2cb = (changeJql)=>{
    const query = (0, $fwKw5.useResolvedJql)();
    const { refetch: refetch } = (0, $3kDjB.useIssueSearchActions)();
    const onSearch = (0, $eJOHy.useCallback)((jql)=>{
        if (jql === query) // This will execute a new search against the network with current JQL input arguments
        refetch();
        else changeJql && changeJql(jql);
    }, [
        query,
        refetch,
        changeJql
    ]);
    return {
        onSearch: onSearch,
        query: query
    };
};

});

parcelRegister("a8Oge", function(module, exports) {

$parcel$export(module.exports, "default", () => $39acabe3aec5695d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $39acabe3aec5695d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    saveFilterButton: {
        "id": "issue-navigator.jql-builder.save-filter-button",
        "defaultMessage": "Save filter"
    },
    saveFilterDialogTitle: {
        "id": "issue-navigator.jql-builder.save-filter-dialog-title",
        "defaultMessage": "Save filter"
    },
    copyFilterButton: {
        "id": "issue-navigator.jql-builder.copy-filter-button",
        "defaultMessage": "Copy filter"
    },
    copyFilterDialogTitle: {
        "id": "issue-navigator.jql-builder.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    }
});

});

parcelRegister("3d17F", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $b7cc870d17f9e29b$export$d58b72b7d3c4072c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $1NG86 = parcelRequire("1NG86");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $ldQj3 = parcelRequire("ldQj3");
const $b7cc870d17f9e29b$var$IconContainer = ({ children: children })=>{
    if ((0, $6XJko.isVisualRefreshEnabled)()) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_otyru2gc _w8l5t9kd _1752t9kd"
        ])
    }, children);
};
const $b7cc870d17f9e29b$var$MessageContainer = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.150",
        xcss: $b7cc870d17f9e29b$var$stackStyles,
        alignInline: "center"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text"
    }, formatMessage((0, $ldQj3.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $ldQj3.default).noOptionsSecondaryMessage)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $b7cc870d17f9e29b$var$boxStyles
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", {
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyru2gc _18u0idpf _1i4qfg65"
        ])
    }, formatMessage((0, $ldQj3.default).fieldNotFoundMessage)));
};
const $b7cc870d17f9e29b$export$d58b72b7d3c4072c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b7cc870d17f9e29b$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b7cc870d17f9e29b$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon-subtle, #626F86)"
    })));
};
const $b7cc870d17f9e29b$var$boxStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 'space.100',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    paddingBottom: 'space.100',
    color: 'color.text.subtle',
    textAlign: 'center'
});
const $b7cc870d17f9e29b$var$stackStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.100'
});
const $b7cc870d17f9e29b$var$titleStyles = null;
const $b7cc870d17f9e29b$var$iconContainerStyles = null;

});
parcelRegister("ldQj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2049601416c73756$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2049601416c73756$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    fieldNotFoundMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.field-not-found-message",
        "defaultMessage": "We couldn't find the field you are looking for."
    },
    noOptionsPrimaryMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});

});


parcelRegister("in3H6", function(module, exports) {

$parcel$export(module.exports, "ResetButton", () => $51793ad880d1faf0$export$2491f201e3dd9acf);
$parcel$export(module.exports, "default", () => $51793ad880d1faf0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $6XJko = parcelRequire("6XJko");

var $15B20 = parcelRequire("15B20");
const $51793ad880d1faf0$export$2491f201e3dd9acf = ({ onReset: onReset, isResetToFilter: isResetToFilter = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleOnReset = (0, $eJOHy.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, isResetToFilter ? 'goBackToFilterButton' : 'resetButton', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onReset && onReset(isResetToFilter);
    }, [
        onReset,
        isResetToFilter
    ]);
    const resetButtonText = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $15B20.default).clearFiltersButtonText : (0, $15B20.default).resetButtonText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($51793ad880d1faf0$var$ResetButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        testId: "issue-navigator.ui.jql-builder.reset-button",
        appearance: "subtle-link",
        onClick: handleOnReset
    }, formatMessage(isResetToFilter ? (0, $15B20.default).goBackToFilterButtonText : resetButtonText)));
};
var $51793ad880d1faf0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $51793ad880d1faf0$export$2491f201e3dd9acf;
const $51793ad880d1faf0$var$ResetButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zkb7n _i0dlf1ug _1e0c1txw _p12fuuw1 _4cvr1h6o _4t3izwfg _19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("15B20", function(module, exports) {

$parcel$export(module.exports, "default", () => $b581130698f794e7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b581130698f794e7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    clearFiltersButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.clear-filters-button-text",
        "defaultMessage": "Clear filters"
    },
    resetButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.reset-button-text",
        "defaultMessage": "Reset"
    },
    goBackToFilterButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.go-back-to-filter-button-text",
        "defaultMessage": "Go back to filter"
    }
});

});


parcelRegister("beKwt", function(module, exports) {

$parcel$export(module.exports, "useJqlBuilderInstrumentation", () => $57621f75a050aebd$export$42691712ca1334f9);

var $eJOHy = parcelRequire("eJOHy");

var $fAgUF = parcelRequire("fAgUF");
const $57621f75a050aebd$export$42691712ca1334f9 = ()=>{
    const [finished, setFinished] = (0, $eJOHy.useState)(false);
    return (0, $eJOHy.useMemo)(()=>({
            startJqlBuilderMetric: ()=>{
                if (finished) return;
                (0, $fAgUF.NINJqlBuilderAsyncLoad).start();
            },
            stopJqlBuilderMetric: ()=>{
                setFinished(true);
                (0, $fAgUF.NINJqlBuilderAsyncLoad).stop();
            },
            markJqlBuilderMetric: (mark)=>{
                if (finished) return;
                (0, $fAgUF.markOnce)(mark);
            }
        }), [
        finished
    ]);
};

});

parcelRegister("5B9jk", function(module, exports) {

$parcel$export(module.exports, "isOnlyJqlAndDifferentToDefault", () => $9bf62b829f568f84$export$3cfc4f52186efe7d);
$parcel$export(module.exports, "isOnlyFilterAndDifferentToDefault", () => $9bf62b829f568f84$export$933470cfeba275aa);
$parcel$export(module.exports, "filterAndJqlIsTheSameAndDifferentToDefault", () => $9bf62b829f568f84$export$a25fc74cc3fc7015);
$parcel$export(module.exports, "jqlIsDifferentToFilter", () => $9bf62b829f568f84$export$7dfcf59726e2b396);
$parcel$export(module.exports, "isFilterJqlModified", () => $9bf62b829f568f84$export$d3d543997ba807);
$parcel$export(module.exports, "jqlIsDifferentToDefault", () => $9bf62b829f568f84$export$69b172dbb100f335);
const $9bf62b829f568f84$export$3cfc4f52186efe7d = (jqlParam, defaultJqlTerm, filterParam)=>filterParam === undefined && jqlParam !== undefined && jqlParam.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $9bf62b829f568f84$export$933470cfeba275aa = (jqlParam, defaultJqlTerm, filterJqlTerm)=>filterJqlTerm !== undefined && jqlParam === undefined && filterJqlTerm.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $9bf62b829f568f84$export$a25fc74cc3fc7015 = (jqlParam, defaultJqlTerm, filterJqlTerm)=>jqlParam !== undefined && filterJqlTerm !== undefined && jqlParam.toLowerCase() === filterJqlTerm.toLowerCase() && filterJqlTerm.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $9bf62b829f568f84$export$7dfcf59726e2b396 = (jqlParam, filterJqlTerm)=>jqlParam !== undefined && filterJqlTerm !== undefined && filterJqlTerm.toLowerCase() !== jqlParam.toLowerCase();
const $9bf62b829f568f84$export$d3d543997ba807 = ({ query: query, filterJql: filterJql })=>filterJql !== undefined && query.toLowerCase().trim() !== filterJql.toLowerCase().trim();
const $9bf62b829f568f84$export$69b172dbb100f335 = (jqlParam, defaultJqlTerm)=>jqlParam !== undefined && jqlParam.toLowerCase().trim() !== defaultJqlTerm.toLowerCase().trim();

});


parcelRegister("l5sqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb6fd92d51c455d7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $eb6fd92d51c455d7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    screenReaderGroupResultInfo: {
        "id": "issue-navigator.screen-reader-group-result-info",
        "defaultMessage": "Grouping has been applied to the list."
    },
    screenReaderSearchResultInfo: {
        "id": "issue-navigator.screen-reader-search-result-info",
        "defaultMessage": "{total, plural, one {One issue matches your search.} other {{total} issues match your search.}}"
    },
    screenReaderSearchResultMoreInfo: {
        "id": "issue-navigator.screen-reader-search-result-more-info",
        "defaultMessage": "{total, plural, one {{total} or more issues found} other {{total} or more issues found}}."
    },
    screenReaderSearchResultInfoIssueTermRefresh: {
        "id": "issue-navigator.screen-reader-search-result-info-issue-term-refresh",
        "defaultMessage": "{total, plural, one {One work item matches your search.} other {{total} work items match your search.}}"
    },
    screenReaderSearchResultMoreInfoIssueTermRefresh: {
        "id": "issue-navigator.screen-reader-search-result-more-info-issue-term-refresh",
        "defaultMessage": "{total, plural, one {{total} or more work items found} other {{total} or more work items found}}."
    }
});

});

parcelRegister("1TTSy", function(module, exports) {

$parcel$export(module.exports, "default", () => $77f4e139beb9422c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");

var $3IF6p = parcelRequire("3IF6p");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $77f4e139beb9422c$var$RegisterDotShortcut = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ isLoaded: isLoaded }, { open: open }] = (0, $g51Bg.useCommandPaletteIsLoaded)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3IF6p.default), {
        keyMap: {
            '.': {
                callback: (ev)=>{
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'pressed',
                        actionSubject: 'keyboardShortcut'
                    }), 'dotDialogKeyboardShortcut', {
                        keyPressed: '.',
                        keyboardShortcut: true,
                        isLoaded: isLoaded
                    });
                    ev?.preventDefault();
                    open();
                }
            }
        }
    });
};
var $77f4e139beb9422c$export$2e2bcd8739ae039 = $77f4e139beb9422c$var$RegisterDotShortcut;

});

parcelRegister("dpNFU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d57863267313bd6$export$2e2bcd8739ae039);

var $f4kYY = parcelRequire("f4kYY");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lHHP1 = parcelRequire("lHHP1");

var $gQyru = parcelRequire("gQyru");

var $eibCx = parcelRequire("eibCx");

var $HiS1C = parcelRequire("HiS1C");
const $9d57863267313bd6$var$IssueNavigatorSpotlight = ({ hasIssueResults: hasIssueResults, userPreferences: userPreferences, isAiEnabled: isAiEnabled })=>{
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const searchModeResponse = (0, $j4oe4.useFragment)((0, $f4kYY.default), userPreferences);
    const selectedSearchMode = (0, $gQyru.toSearchModeWithBasicModeFallback)(searchModeResponse?.jqlBuilderSearchMode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourCard), {
        mode: selectedSearchMode,
        view: (0, $eibCx.convertToView)(view),
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
var $9d57863267313bd6$export$2e2bcd8739ae039 = $9d57863267313bd6$var$IssueNavigatorSpotlight;

});
parcelRegister("f4kYY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c4bf833445b044$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30a8994404dfcae5d894d268d148ffe9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e1c4bf833445b044$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "spotlight_issueNavigator_IssueNavigatorSpotlight",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jqlBuilderSearchMode"
        }
    ],
    "type": "JiraUserPreferences"
};
$e1c4bf833445b044$var$node.hash = "3c8e72948beb901cccd7a6650610b18e";
var $e1c4bf833445b044$export$2e2bcd8739ae039 = $e1c4bf833445b044$var$node;

});

parcelRegister("gQyru", function(module, exports) {

$parcel$export(module.exports, "toSearchModeWithBasicModeFallback", () => $55476173f94cb033$export$7c0f55a4bd3730ea);
$parcel$export(module.exports, "toServerSearchMode", () => $55476173f94cb033$export$32a166cc1b3e6927);

var $56qWy = parcelRequire("56qWy");
function $55476173f94cb033$export$7c0f55a4bd3730ea(value) {
    switch(value){
        case 0, $56qWy.SERVER_SEARCH_MODE_ADVANCED:
            return 0, $56qWy.SEARCH_MODE_ADVANCED;
        default:
            return 0, $56qWy.DEFAULT_SEARCH_MODE;
    }
}
function $55476173f94cb033$export$32a166cc1b3e6927(mode) {
    switch(mode){
        case 0, $56qWy.SEARCH_MODE_ADVANCED:
            return 0, $56qWy.SERVER_SEARCH_MODE_ADVANCED;
        default:
            return 0, $56qWy.SERVER_SEARCH_MODE_BASIC;
    }
}

});


parcelRegister("78img", function(module, exports) {

$parcel$export(module.exports, "default", () => $6353b9041343e5e1$export$2e2bcd8739ae039);

var $39lci = parcelRequire("39lci");

var $99QSt = parcelRequire("99QSt");

var $7kOkg = parcelRequire("7kOkg");

var $g7uVR = parcelRequire("g7uVR");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $j4oe4 = parcelRequire("j4oe4");

var $g8Az8 = parcelRequire("g8Az8");

var $7tL08 = parcelRequire("7tL08");

var $1tPTE = parcelRequire("1tPTE");

var $6zXPf = parcelRequire("6zXPf");

var $3TtKq = parcelRequire("3TtKq");

var $epTsa = parcelRequire("epTsa");

var $4Oene = parcelRequire("4Oene");

var $7jTnu = parcelRequire("7jTnu");

var $2nr0r = parcelRequire("2nr0r");

var $a9bnL = parcelRequire("a9bnL");

var $2wbY1 = parcelRequire("2wbY1");

var $iRahl = parcelRequire("iRahl");

var $7E6oZ = parcelRequire("7E6oZ");

var $2UTIe = parcelRequire("2UTIe");

var $HiS1C = parcelRequire("HiS1C");

var $fwKw5 = parcelRequire("fwKw5");

var $cJdYi = parcelRequire("cJdYi");

var $3kDjB = parcelRequire("3kDjB");

var $3Ssg5 = parcelRequire("3Ssg5");
const $6353b9041343e5e1$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $6353b9041343e5e1$var$styles = {
    jqlWrapper: "_5ynfkb7n"
};
const $6353b9041343e5e1$var$TopBar = ({ ActionMenu: ActionMenu, filter: filter, issueResults: issueResults, HeaderSkeletonImage: HeaderSkeletonImage, jqlBuilder: jqlBuilder, jiraViewResult: jiraViewResult, projectResult: projectResult, isGroupingSupported: isGroupingSupported, onChangeFilter: onChangeFilter, onChangeJql: onChangeJql, isGridNavigationEnabled: isGridNavigationEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, defaultJql: defaultJql })=>{
    const issueResultsData = (0, $j4oe4.useFragment)((0, $g7uVR.default), issueResults);
    // Compute page data for our search results which is needed when requesting items for the legacy meatball menu
    const offset = (issueResultsData?.issueNavigatorPageInfo?.firstIssuePosition ?? 1) - 1; // offset is 0 based so subtract 1
    const pages = $6353b9041343e5e1$var$getLastPage(issueResultsData?.pageCursors) ?? 0;
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const searchResultPageData = (0, $eJOHy.useMemo)(()=>({
            offset: offset,
            pages: pages,
            total: total
        }), [
        offset,
        pages,
        total
    ]);
    const { filterId: filterId } = (0, $fwKw5.useActiveJql)();
    const jql = (0, $fwKw5.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $cJdYi.useFilterQuery)();
    const filterData = (0, $j4oe4.useFragment)((0, $7kOkg.default), filter);
    const projectData = (0, $j4oe4.useFragment)((0, $99QSt.default), projectResult);
    const jiraViewData = (0, $j4oe4.useFragment)((0, $39lci.default), jiraViewResult);
    const filterDetails = (0, $eJOHy.useMemo)(()=>filterData ? {
            filterId: filterData.filterId,
            name: filterData.name,
            jql: filterData.jql,
            isFavourite: Boolean(filterData.isFavourite)
        } : undefined, [
        filterData
    ]);
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const jiraViewResultData = jiraViewData;
    let changeHierarchy = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let changeGroupedByField = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let changeHideDone = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    let resetView = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') || (0, $epTsa.expVal)('saved_list_view', 'isEnabled', false)) ({ changeHierarchy: changeHierarchy, changeGroupedByField: changeGroupedByField, changeHideDone: changeHideDone, resetView: resetView } = // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3kDjB.useIssueSearchActions)());
    const updateGroupByParam = (0, $3Ssg5.useUpdateUrlQueryParamCallback)('groupBy');
    const onChangeGroupedByField = (0, $eJOHy.useCallback)((nextGroupedByField)=>{
        changeGroupedByField(nextGroupedByField);
        updateGroupByParam(nextGroupedByField);
    }, [
        changeGroupedByField,
        updateGroupByParam
    ]);
    let hideDone = false;
    if ((0, $7jTnu.fg)('jsc_bulk_edit_hide_done_work_items')) hideDone = jiraViewData?.viewSettings?.hideDone ?? false;
    const HierarchyToggle = jiraViewResultData && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7E6oZ.HierarchyToggleItem), {
        isGroupingSupported: isGroupingSupported,
        viewResult: jiraViewResultData,
        onChangeHierarchy: changeHierarchy
    }) : null;
    const GroupByDropdown = isGroupingSupported && jiraViewData && (0, $iRahl.isJiraSpreadsheetView)(jiraViewData) && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tPTE.GroupByDropdown), {
        onChangeGroupedByField: (0, $7jTnu.fg)('jsc_list_query_param_merge') ? onChangeGroupedByField : changeGroupedByField,
        spreadsheetView: jiraViewData
    }) : null;
    let onResetSelectedIssues = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    if ((0, $7jTnu.fg)('jsc_list_hide_done_items')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ reset: onResetSelectedIssues } = (0, $3TtKq.useIssueTableSelectedIssuesActions)());
    if (filterQueryIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderSkeletonImage, null);
    const HideDoneToggle = jiraViewResultData && view !== 'detail' && (0, $7jTnu.fg)('jsc_list_hide_done_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2nr0r.HideDoneItemsToggle), {
        viewResult: jiraViewResultData,
        onChangeHideDone: changeHideDone,
        onResetSelectedIssues: onResetSelectedIssues
    }) : null;
    const FiltersMenuComponent = // eslint-disable-next-line jira/ff/no-preconditioning
    projectData && onChangeJql && (0, $7jTnu.fg)('nin-saved-filters') && (0, $7jTnu.fg)('jira_list_nin_merge') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wbY1.FiltersMenu), {
        defaultJql: defaultJql,
        onChangeJql: onChangeJql,
        projectFragment: projectData
    }) : null;
    const saveResetViewSettingsButton = jiraViewResultData && (0, $epTsa.expVal)('saved_list_view', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9bnL.SaveResetViewSettingsButton), {
        jql: jql,
        onReset: resetView,
        viewFragment: jiraViewResultData
    });
    const pageTopBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7tL08.PageTopBar), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ActionMenu, {
            jql: jql,
            filterId: filterId,
            filterDetails: filterDetails,
            searchResultPageData: searchResultPageData,
            HierarchyToggle: HierarchyToggle,
            GroupByDropdown: GroupByDropdown,
            HideDoneToggle: HideDoneToggle,
            FiltersMenu: FiltersMenuComponent,
            SaveResetViewSettingsButton: saveResetViewSettingsButton,
            isHideDoneWorkItemsEnabled: hideDone,
            onChangeFilter: onChangeFilter,
            isModifiedFilter: (0, $7jTnu.fg)('visual-refresh-headers-buttons') ? filterDetails?.jql !== jql : false,
            isGridNavigationEnabled: isGridNavigationEnabled,
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled
        }),
        bottomBar: jqlBuilder
    });
    if ((0, $6zXPf.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "top-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $6353b9041343e5e1$var$styles.jqlWrapper
        ])
    }, pageTopBar));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
        name: "top-bar"
    }, pageTopBar);
};
var $6353b9041343e5e1$export$2e2bcd8739ae039 = (0, $2UTIe.withReportErrors)($6353b9041343e5e1$var$TopBar, {
    id: 'ui.topbar.unhandled',
    packageName: (0, $iRahl.PACKAGE_NAME),
    teamName: (0, $iRahl.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $g8Az8.isLoaderErrorAttributes)
});

});
parcelRegister("39lci", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa4cfb52c03add68$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6fa5378ea8f831f16ca626e032a29c25>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aa4cfb52c03add68$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "settings"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "topBar_issueNavigator_jiraViewResult",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "GroupByDropdown"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "settings",
                            "variableName": "settings"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SaveResetViewSettingsButton"
                        }
                    ]
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$aa4cfb52c03add68$var$node.hash = "d02aa25581520c55aa425caa01b7ec56";
var $aa4cfb52c03add68$export$2e2bcd8739ae039 = $aa4cfb52c03add68$var$node;

});

parcelRegister("99QSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $efa95ee7432368bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab5dd7dce8653920ac95a27c3c679aec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $efa95ee7432368bf$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisninsavedfiltersenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "topBar_issueNavigator_projectResult",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisninsavedfiltersenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "FiltersMenu_project"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$efa95ee7432368bf$var$node.hash = "ee14c20f4b47a219e3636612ede67b90";
var $efa95ee7432368bf$export$2e2bcd8739ae039 = $efa95ee7432368bf$var$node;

});

parcelRegister("7kOkg", function(module, exports) {

$parcel$export(module.exports, "default", () => $35a3002adb7300df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ab7c2a8b5f9d7e53e2eda0626fb3cbe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $35a3002adb7300df$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topBar_issueNavigator_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$35a3002adb7300df$var$node.hash = "d1fd34a229f9cb2668ab6793af284885";
var $35a3002adb7300df$export$2e2bcd8739ae039 = $35a3002adb7300df$var$node;

});

parcelRegister("g7uVR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a61c5acd048d92c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<222e07e55baf5ff3dcc37bb6cbd7a80e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3a61c5acd048d92c$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "topBar_issueNavigator_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$3a61c5acd048d92c$var$node.hash = "52b4c743e436bc90ea0831559f2c3e48";
var $3a61c5acd048d92c$export$2e2bcd8739ae039 = $3a61c5acd048d92c$var$node;

});

parcelRegister("7tL08", function(module, exports) {

$parcel$export(module.exports, "PageTopBar", () => $1fc13d53be5e9467$export$7e5801dc91bf1819);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $1DXK0 = parcelRequire("1DXK0");

var $gfcvC = parcelRequire("gfcvC");

var $6zXPf = parcelRequire("6zXPf");

var $6XJko = parcelRequire("6XJko");

const $1fc13d53be5e9467$var$SporkPageTopBar = ({ bottomBar: bottomBar, actions: actions, wrapAtMd: wrapAtMd = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: (0, $9fdce687ce348642$export$90c4434a1e138106),
        xcss: [
            !(0, $6XJko.isVisualRefreshEnabled)() && $1fc13d53be5e9467$var$wrapperStylesOld2,
            (0, $6XJko.isVisualRefreshEnabled)() && $1fc13d53be5e9467$var$wrapperStyles,
            wrapAtMd ? $1fc13d53be5e9467$var$wrapAtMdStyle : $1fc13d53be5e9467$var$noWrapStyle
        ]
    }, bottomBar, actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: (0, $9fdce687ce348642$export$1742330ac6a668f0),
        xcss: [
            $1fc13d53be5e9467$var$actionsBoxStyles,
            wrapAtMd && $1fc13d53be5e9467$var$actionsBoxAtMdStyles
        ]
    }, actions));
const $1fc13d53be5e9467$export$7e5801dc91bf1819 = (props)=>(0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1fc13d53be5e9467$var$SporkPageTopBar, {
        bottomBar: props.bottomBar,
        actions: props.actions,
        wrapAtMd: props.wrapAtMd
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gfcvC.default), props);
const $1fc13d53be5e9467$var$noWrapStyle = (0, $1DXK0.xcss)({
    flexWrap: 'nowrap'
});
const $1fc13d53be5e9467$var$wrapAtMdStyle = (0, $1DXK0.xcss)({
    flexWrap: 'wrap-reverse',
    [(0, $6efFi.media).above.md]: {
        flexWrap: 'nowrap'
    }
});
const $1fc13d53be5e9467$var$wrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    paddingTop: 'space.250',
    paddingBottom: 'space.200',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $6efFi.media).above.md]: {
        gap: 'space.300'
    }
});
const $1fc13d53be5e9467$var$wrapperStylesOld2 = (0, $1DXK0.xcss)({
    display: 'flex',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $6efFi.media).above.md]: {
        gap: 'space.300'
    }
});
const $1fc13d53be5e9467$var$actionsBoxAtMdStyles = (0, $1DXK0.xcss)({
    flex: '1 1 auto',
    [(0, $6efFi.media).above.md]: {
        flex: '0 1 auto'
    }
});
const $1fc13d53be5e9467$var$actionsBoxStyles = (0, $1DXK0.xcss)({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 auto'
});

});
parcelRegister("gfcvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f30f0c90ac1afba$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1BWxH = parcelRequire("1BWxH");
const $8f30f0c90ac1afba$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1BWxH.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8f30f0c90ac1afba$var$ActionsWrapper, null, actions) : null
    });
var $8f30f0c90ac1afba$export$2e2bcd8739ae039 = $8f30f0c90ac1afba$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f30f0c90ac1afba$var$ActionsWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1BWxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4d2cd992b0acc82$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7Ob9A = parcelRequire("7Ob9A");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $d4d2cd992b0acc82$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7Ob9A.OuterWrapper), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7Ob9A.TitleWrapper), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Ob9A.TitleContainer), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Ob9A.StyledTitleWrapper), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Ob9A.ActionsWrapper), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7Ob9A.BottomBarWrapper), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
var $d4d2cd992b0acc82$export$2e2bcd8739ae039 = $d4d2cd992b0acc82$var$PageHeader;

});
parcelRegister("7Ob9A", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $f896c1834f9739ce$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $f896c1834f9739ce$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $f896c1834f9739ce$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $f896c1834f9739ce$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $f896c1834f9739ce$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $f896c1834f9739ce$export$6330225854c30dc);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $f896c1834f9739ce$var$styles = {
    bottomBar: "_1pfhpxbi"
};
const $f896c1834f9739ce$var$truncateStyles = null;
const $f896c1834f9739ce$var$outerStyles = null;
const $f896c1834f9739ce$var$titleStyles = null;
const $f896c1834f9739ce$var$titleWrapperStyles = null;
const $f896c1834f9739ce$var$titleWrapperTruncateStyles = null;
const $f896c1834f9739ce$var$titleContainerStyles = null;
const $f896c1834f9739ce$var$actionStyles = null;
const $f896c1834f9739ce$var$titleContainerTruncateStyles = null;
const $f896c1834f9739ce$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
const $f896c1834f9739ce$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $hcewu.default)([
            "_11c8nf1z _12ji1r31 _1qu2glyw _12y31o36 _syaz1fxt _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
const $f896c1834f9739ce$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1y6m _1n261q9c",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
};
const $f896c1834f9739ce$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc _1i4q1hna",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
};
const $f896c1834f9739ce$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
};
const $f896c1834f9739ce$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $f896c1834f9739ce$var$styles.bottomBar,
        children: children
    });
};

});



const $9fdce687ce348642$export$90c4434a1e138106 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar';
const $9fdce687ce348642$export$1742330ac6a668f0 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar.actions';


parcelRegister("2wbY1", function(module, exports) {

$parcel$export(module.exports, "FiltersMenu", () => $2c94accbfe411a12$export$5cf20cdbe868e916);

var $iXztb = parcelRequire("iXztb");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5CSKW = parcelRequire("5CSKW");

var $1OQKp = parcelRequire("1OQKp");

var $7ep4S = parcelRequire("7ep4S");

var $b8OI0 = parcelRequire("b8OI0");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $32OV5 = parcelRequire("32OV5");

var $egViP = parcelRequire("egViP");
const $2c94accbfe411a12$var$styles = {
    fallback: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1mjv _4t3iuuw1"
};
const $2c94accbfe411a12$export$5cf20cdbe868e916 = /*#__PURE__*/ (0, $eJOHy.memo)(({ defaultJql: defaultJql, onChangeJql: onChangeJql, projectFragment: projectFragment })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const projectData = (0, $j4oe4.useFragment)((0, $iXztb.default), projectFragment);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            projectId: projectData.id,
            first: 50
        }), [
        projectData.id
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            defaultJql: defaultJql,
            onChangeJql: (jql)=>onChangeJql(jql, true)
        }), [
        defaultJql,
        onChangeJql
    ]);
    const trigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
            ...triggerProps,
            appearance: "subtle",
            iconAfter: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                    label: "",
                    size: "small"
                }),
            isSelected: triggerProps['aria-expanded'],
            onClick: ()=>(0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'savedFiltersMenu')
        }, formatMessage((0, $32OV5.default).menuTitle)), [
        createAnalyticsEvent,
        formatMessage
    ]);
    const fallback = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            className: (0, $hcewu.default)([
                $2c94accbfe411a12$var$styles.fallback
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null)), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b8OI0.PopupTrigger), {
        entryPoint: (0, $egViP.filtersMenuEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        fallback: fallback,
        placement: "bottom-end",
        role: "dialog",
        shouldRenderToParent: true,
        trigger: trigger
    });
});

});
parcelRegister("iXztb", function(module, exports) {

$parcel$export(module.exports, "default", () => $09461cb318fadbb4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3544619a4781e193582fb065aac4f119>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $09461cb318fadbb4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "FiltersMenu_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraProject"
};
$09461cb318fadbb4$var$node.hash = "10737a2ddd3f3d9a01f47a3d5384848a";
var $09461cb318fadbb4$export$2e2bcd8739ae039 = $09461cb318fadbb4$var$node;

});

parcelRegister("32OV5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b061aa273131fc76$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b061aa273131fc76$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    menuTitle: {
        "id": "jira.issue-navigator.filters-menu.menu-title",
        "defaultMessage": "Saved filters"
    }
});

});

parcelRegister("egViP", function(module, exports) {

$parcel$export(module.exports, "filtersMenuEntryPoint", () => $841d1833e6312223$export$2687e4e1d35338ee);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $lW0cZ = parcelRequire("lW0cZ");

const $841d1833e6312223$export$2687e4e1d35338ee = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("fOOMo")), {
        moduleId: "2d65f12d",
        moduleName: "FiltersMenuContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ projectId: projectId, first: first })=>({
            queries: {
                mainQuery: {
                    parameters: (0, $lW0cZ.default),
                    variables: {
                        projectId: projectId,
                        first: first
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        })
});

});
parcelRegister("lW0cZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee2d1d6957b03547$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cda7bc03026033e95f7c74fc65280db0>>
 * @relayHash 3324147c9e3944a7f2559727e1f42139
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3603b8d4f9dcb53bf86aba4fdc5e6e4dde30ae8663b3707c7575a7a49b16c644
const $ee2d1d6957b03547$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "contextId",
                    "variableName": "projectId"
                }
            ],
            "kind": "ObjectValue",
            "name": "searchParameters"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectId"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "key"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FiltersMenuContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "jwmFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jwmFilters.__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "JiraWorkManagementFilterEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraWorkManagementFilter",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "FragmentSpread",
                                                                            "name": "SavedFilterMenuItem_filter"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v4 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.jwmFilters.edges.node.id"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v5 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.jwmFilters.edges.node.name"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v6 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "jira.jwmFilters.edges.node.jql"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.jwmFilters.edges.node"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.jwmFilters.edges"
                                                }
                                            ],
                                            "type": "JiraWorkManagementFilterConnection"
                                        },
                                        v7 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jwmFilters"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProject.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "jira.jiraProject.key"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FiltersMenuContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "jwmFilters",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraWorkManagementFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEditable"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraWorkManagementFilterConnection"
                                },
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3603b8d4f9dcb53bf86aba4fdc5e6e4dde30ae8663b3707c7575a7a49b16c644",
            "metadata": {},
            "name": "FiltersMenuContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ee2d1d6957b03547$var$node.hash = "5fd2b2fec282b26dc599d6b19a7bb3fd";
var $ee2d1d6957b03547$export$2e2bcd8739ae039 = $ee2d1d6957b03547$var$node;

});

parcelRegister("fOOMo", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4ardH").then(()=>parcelRequire('ad3OL'));

});




parcelRegister("2cvR1", function(module, exports) {

$parcel$export(module.exports, "SidebarCloserController", () => $ab5072dfa3713fc5$export$700866716e53c09d);

var $gHKwt = parcelRequire("gHKwt");

var $6d9QY = parcelRequire("6d9QY");

var $HiS1C = parcelRequire("HiS1C");
const $ab5072dfa3713fc5$export$700866716e53c09d = ()=>{
    const [{ id: id }, { closeSidebar: closeSidebar }] = (0, $gHKwt.useSidebar)();
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const prevView = (0, $6d9QY.usePrevious)(view);
    if (id !== null && view === 'detail' && prevView !== 'detail') closeSidebar();
    return null;
};

});

parcelRegister("f7hID", function(module, exports) {

$parcel$export(module.exports, "SidebarExperienceRegistryWithErrorBoundary", () => $d78df323146a91c4$export$2ca0ed61c620e2d7);

var $4XYVx = parcelRequire("4XYVx");

var $3WOug = parcelRequire("3WOug");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gHKwt = parcelRequire("gHKwt");

var $5mHmY = parcelRequire("5mHmY");


var $1KdDN = parcelRequire("1KdDN");

var $7jTnu = parcelRequire("7jTnu");

var $fwKw5 = parcelRequire("fwKw5");

var $6zIqj = parcelRequire("6zIqj");

var $d8fIq = parcelRequire("d8fIq");

var $3rE61 = parcelRequire("3rE61");

var $6gbGT = parcelRequire("6gbGT");
const $d78df323146a91c4$export$50cee155b5f4b008 = ({ project: project })=>{
    const [{ id: id, content: content }, { closeSidebar: closeSidebar }] = (0, $gHKwt.useSidebar)();
    const jql = (0, $fwKw5.useResolvedJql)();
    const projectData = (0, $j4oe4.useFragment)((0, $3WOug.default), project);
    if (content) return content;
    if (id === (0, $5mHmY.SIDEBAR_EXPERIENCE_NAME)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6zIqj.IssueFieldStatisticsSidebarExperience), {
        jql: jql,
        onClose: closeSidebar
    });
    if (id === (0, $42018301743dbb45$export$716d68d214fad041) && (0, $7jTnu.fg)('jira_list_conditional_formatting')) {
        if ((0, $7jTnu.fg)('saved_list_view_technical_changes')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3rE61.MaybeConditionalFormattingSidebarExperience), {
            project: projectData ?? null,
            onClose: closeSidebar
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6gbGT.MaybeConditionalFormattingSidebarExperienceOld), {
            project: projectData ?? null,
            onClose: closeSidebar
        });
    }
    return null;
};
const $d78df323146a91c4$export$2ca0ed61c620e2d7 = ({ project: project })=>{
    const { closeSidebar: closeSidebar } = (0, $gHKwt.useSidebarActions)();
    const fallback = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d8fIq.ErrorState), {
            onClose: closeSidebar
        }), [
        closeSidebar
    ]);
    const projectData = (0, $j4oe4.useFragment)((0, $4XYVx.default), project);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "sidebarExperienceRegistry",
        packageName: "jiraIssueNavigator",
        teamName: "empanada",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d78df323146a91c4$export$50cee155b5f4b008, {
        project: projectData ?? null
    }));
};

});
parcelRegister("4XYVx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6767dba61de29d65$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8b1e81390a68e04b7eee2c994f46e913>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6767dba61de29d65$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isSavedViewConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                },
                {
                    "kind": "Variable",
                    "name": "isSavedViewConditionalFormattingEnabled",
                    "variableName": "isSavedViewConditionalFormattingEnabled"
                }
            ],
            "kind": "FragmentSpread",
            "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project"
        }
    ],
    "type": "JiraProject"
};
$6767dba61de29d65$var$node.hash = "68c529d353dff98f98ffde69ce1a3cbe";
var $6767dba61de29d65$export$2e2bcd8739ae039 = $6767dba61de29d65$var$node;

});

parcelRegister("3WOug", function(module, exports) {

$parcel$export(module.exports, "default", () => $277db0c7d4940bcb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<342f97ac1c29fc1450d55c7df8b38e85>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $277db0c7d4940bcb$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isConditionalFormattingEnabled"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isSavedViewConditionalFormattingEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project",
    "selections": [
        {
            "condition": "isSavedViewConditionalFormattingEnabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "condition": "isConditionalFormattingEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ConditionalFormattingSidebarExperienceOld_project"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isSavedViewConditionalFormattingEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ConditionalFormattingSidebarExperience_project"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$277db0c7d4940bcb$var$node.hash = "6062124258e30f13bb5ba27435575c95";
var $277db0c7d4940bcb$export$2e2bcd8739ae039 = $277db0c7d4940bcb$var$node;

});

const $42018301743dbb45$export$716d68d214fad041 = 'conditional-formatting';
const $42018301743dbb45$export$a8fd8094a2b22bf9 = 'conditionalFormattingSidebarOpen';

parcelRegister("6zIqj", function(module, exports) {

$parcel$export(module.exports, "IssueFieldStatisticsSidebarExperience", () => $79585b9f48c73c4e$export$63b30538475bf529);

var $eJOHy = parcelRequire("eJOHy");

var $80Alx = parcelRequire("80Alx");

var $cBavF = parcelRequire("cBavF");

var $d8fIq = parcelRequire("d8fIq");
const $79585b9f48c73c4e$var$HELIOS_TEAM_NAME = 'helios-headcoach';
const $79585b9f48c73c4e$export$63b30538475bf529 = ({ jql: jql, onClose: onClose })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $80Alx.useIssueFieldStatisticsEntryPoint)();
    const issueFieldStatisticsRuntimeProps = (0, $eJOHy.useMemo)(()=>({
            jql: jql,
            onClose: onClose
        }), [
        jql,
        onClose
    ]);
    const errorFallback = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d8fIq.ErrorState), {
            onClose: onClose
        }), [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "issueFieldStatisticsSidebar",
        packageName: "jiraIssueNavigatorActionIssueFieldStatistics",
        errorFallback: errorFallback,
        teamName: $79585b9f48c73c4e$var$HELIOS_TEAM_NAME,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        runtimeProps: issueFieldStatisticsRuntimeProps
    });
};

});
parcelRegister("d8fIq", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $01ad5fea1c48d205$export$c1ed4f415b9e7023);

var $eJOHy = parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $Ay1uj = parcelRequire("Ay1uj");

var $6J9k6 = parcelRequire("6J9k6");

var $lRq8t = parcelRequire("lRq8t");

var $j1go5 = parcelRequire("j1go5");

var $7ieXo = parcelRequire("7ieXo");
const $01ad5fea1c48d205$export$c1ed4f415b9e7023 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        alignItems: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        alignItems: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))),
        label: formatMessage((0, $7ieXo.default).close),
        isTooltipDisabled: false,
        onClick: ()=>{
            onClose();
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        alignItems: "center",
        xcss: $01ad5fea1c48d205$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1go5.default), {
        alt: formatMessage((0, $7ieXo.default).warning)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        weight: "bold"
    }, formatMessage((0, $7ieXo.default).errorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        align: "center"
    }, formatMessage((0, $7ieXo.default).errorBody))));
};
const $01ad5fea1c48d205$var$contentStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.800',
    gap: 'space.100'
});

});
parcelRegister("j1go5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3b7fabdf20be871$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $8sLq9 = parcelRequire("8sLq9");

var $eiSz9 = parcelRequire("eiSz9");
const $d3b7fabdf20be871$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8sLq9)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($eiSz9))
});
var $d3b7fabdf20be871$export$2e2bcd8739ae039 = $d3b7fabdf20be871$var$Illustration;
const $d3b7fabdf20be871$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("8sLq9", function(module, exports) {
module.exports = new URL("error-triangle-basic.6c1bbfdc.svg", import.meta.url).toString();

});

parcelRegister("eiSz9", function(module, exports) {
module.exports = new URL("error-triangle-basic-darkmode.aa5ef22c.svg", import.meta.url).toString();

});


parcelRegister("7ieXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ccef3d11c508bf4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9ccef3d11c508bf4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    warning: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.warning-icon-label",
        "defaultMessage": "Warning"
    },
    close: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.close",
        "defaultMessage": "Close"
    },
    errorTitle: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.error-title",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.error-body",
        "defaultMessage": "Try refreshing the page, or check your connection."
    }
});

});



parcelRegister("3rE61", function(module, exports) {

$parcel$export(module.exports, "MaybeConditionalFormattingSidebarExperience", () => $c62158ffb405e94b$export$8e9dd628d56e5950);

var $dpYyz = parcelRequire("dpYyz");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $cBavF = parcelRequire("cBavF");

var $f2JN3 = parcelRequire("f2JN3");

var $116z7 = parcelRequire("116z7");

var $cR6bn = parcelRequire("cR6bn");

var $cpvqH = parcelRequire("cpvqH");

var $ke6T8 = parcelRequire("ke6T8");

var $4EbIU = parcelRequire("4EbIU");

var $d8fIq = parcelRequire("d8fIq");
const $c62158ffb405e94b$export$6db38da61f084c10 = ({ onClose: onClose, project: project })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4EbIU.useConditionalFormattingEntryPoint)();
    const projectData = (0, $j4oe4.useFragment)((0, $dpYyz.default), project);
    const errorFallback = (0, $eJOHy.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $116z7.ExperienceFailure), {
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d8fIq.ErrorState), {
            onClose: onClose
        })), [
        onClose
    ]);
    if (projectData?.key == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cpvqH.FormatRulesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cR6bn.JqlProvider), {
        jqlContext: `project = '${projectData?.key}'`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "conditionalFormattingSidebar",
        packageName: "jiraIssueNavigatorActionConditionalFormatting",
        errorFallback: errorFallback,
        teamName: "Keystone",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        runtimeProps: {
            projectId: projectData?.projectId ?? undefined,
            onCloseSidebar: onClose
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ke6T8.FormatRulesFragment), {
        project: projectData ?? null
    }));
};
const $c62158ffb405e94b$export$8e9dd628d56e5950 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jira_list_conditional_formatting'), $c62158ffb405e94b$export$6db38da61f084c10, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));

});
parcelRegister("dpYyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaeca15761e422f9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<52f8fde0d941f0ad792e87f27af9056b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aaeca15761e422f9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConditionalFormattingSidebarExperience_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 20
                }
            ],
            "kind": "FragmentSpread",
            "name": "FormatRulesNew_project"
        }
    ],
    "type": "JiraProject"
};
$aaeca15761e422f9$var$node.hash = "593c92aafec766a50bb7c1dd5b691e8f";
var $aaeca15761e422f9$export$2e2bcd8739ae039 = $aaeca15761e422f9$var$node;

});

parcelRegister("116z7", function(module, exports) {

$parcel$export(module.exports, "ExperienceFailure", () => $4e9d8e7acc0b9191$export$eed1d73ebdd8c7ab);

var $eJOHy = parcelRequire("eJOHy");

var $aqnJa = parcelRequire("aqnJa");

const $4e9d8e7acc0b9191$var$STABLE_EMPTY_OBJECT = {};
function $4e9d8e7acc0b9191$export$eed1d73ebdd8c7ab({ error: error, attributes: attributes = $4e9d8e7acc0b9191$var$STABLE_EMPTY_OBJECT }) {
    const onExperienceFailure = (0, $aqnJa.useExperienceFail)({
        experience: (0, $42018301743dbb45$export$a8fd8094a2b22bf9),
        attributes: attributes
    });
    (0, $eJOHy.useEffect)(()=>{
        onExperienceFailure((0, $42018301743dbb45$export$a8fd8094a2b22bf9), error);
    }, [
        attributes,
        error,
        onExperienceFailure
    ]);
    (0, $eJOHy.useMemo)(()=>{
        if (false) onExperienceFailure((0, $42018301743dbb45$export$a8fd8094a2b22bf9), error);
    }, [
        error,
        onExperienceFailure
    ]);
    return null;
}

});

parcelRegister("cR6bn", function(module, exports) {

$parcel$export(module.exports, "JqlProvider", () => $c39511b242fbd3bc$export$fdc879e2ba0da048);
$parcel$export(module.exports, "useJqlContext", () => $c39511b242fbd3bc$export$f32e2f688fc08561);

var $eJOHy = parcelRequire("eJOHy");
const $c39511b242fbd3bc$var$JqlContext = /*#__PURE__*/ (0, $eJOHy.createContext)('');
const $c39511b242fbd3bc$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c39511b242fbd3bc$var$JqlContext.Provider, {
        value: jqlContext
    }, children);
const $c39511b242fbd3bc$export$f32e2f688fc08561 = ()=>(0, $eJOHy.useContext)($c39511b242fbd3bc$var$JqlContext);

});

parcelRegister("cpvqH", function(module, exports) {

$parcel$export(module.exports, "FormatRulesContainer", () => $2bf018720ee1ce40$export$2022a9665c731c36);
$parcel$export(module.exports, "useFormatRulesStore", () => $2bf018720ee1ce40$export$2fe3fe2e87aa2741);

var $7IX73 = parcelRequire("7IX73");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7jTnu = parcelRequire("7jTnu");
const $2bf018720ee1ce40$var$initialState = {
    rowRules: [],
    cellRulesByFieldId: {},
    issueIdRowRuleMatched: {},
    rulesJqlInput: {}
};
const $2bf018720ee1ce40$var$actions = {
    setFormatRules: (rules)=>({ setState: setState })=>{
            const newState = {
                ...rules
            };
            setState(newState);
        },
    setRulesForJqlInput: (input)=>({ setState: setState })=>{
            const newState = {
                rulesJqlInput: input
            };
            setState(newState);
        },
    setMatchedRowRule: ({ rule: rule, issueId: issueId })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const newState = {
                issueIdRowRuleMatched: {
                    ...currentState.issueIdRowRuleMatched,
                    [issueId]: rule
                }
            };
            setState(newState);
        },
    removeMatchedRowRule: ({ ruleId: ruleId })=>({ setState: setState, getState: getState })=>{
            const { issueIdRowRuleMatched: issueIdRowRuleMatched } = getState();
            const rowRuleMatched = Object.entries(issueIdRowRuleMatched).filter(([, value])=>value.id !== ruleId);
            const newIssueIdRowRuleMatched = Object.fromEntries(rowRuleMatched);
            setState({
                issueIdRowRuleMatched: newIssueIdRowRuleMatched
            });
        }
};
const $2bf018720ee1ce40$var$oldStore = (0, $GtRbT.createStore)({
    initialState: $2bf018720ee1ce40$var$initialState,
    actions: $2bf018720ee1ce40$var$actions,
    name: 'JWMFormatRulesOld'
});
const $2bf018720ee1ce40$export$2022a9665c731c36 = (0, $6E16M.createContainer)();
const $2bf018720ee1ce40$var$Store = (0, $GtRbT.createStore)({
    initialState: $2bf018720ee1ce40$var$initialState,
    actions: $2bf018720ee1ce40$var$actions,
    name: 'JWMFormatRules',
    containedBy: $2bf018720ee1ce40$export$2022a9665c731c36
});
const $2bf018720ee1ce40$var$useFormatRulesStoreOld = (0, $iJq0l.createHook)($2bf018720ee1ce40$var$oldStore);
const $2bf018720ee1ce40$var$useFormatRulesStoreNew = (0, $iJq0l.createHook)($2bf018720ee1ce40$var$Store);
const $2bf018720ee1ce40$export$2fe3fe2e87aa2741 = ()=>(0, $7jTnu.fg)('jira_list_conditional_formatting') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $2bf018720ee1ce40$var$useFormatRulesStoreNew() : // eslint-disable-next-line react-hooks/rules-of-hooks
    $2bf018720ee1ce40$var$useFormatRulesStoreOld();
const $2bf018720ee1ce40$var$getSerialisedJql = (state)=>(0, $7IX73.serialiseJql)(state.rulesJqlInput);
const $2bf018720ee1ce40$var$useFormatRulesSerialisedJqlOld = (0, $iJq0l.createHook)($2bf018720ee1ce40$var$oldStore, {
    selector: $2bf018720ee1ce40$var$getSerialisedJql
});
const $2bf018720ee1ce40$var$useFormatRulesSerialisedJqlNew = (0, $iJq0l.createHook)($2bf018720ee1ce40$var$Store, {
    selector: $2bf018720ee1ce40$var$getSerialisedJql
});
const $2bf018720ee1ce40$export$3b2286d9a476f9a1 = ()=>(0, $7jTnu.fg)('jira_list_conditional_formatting') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $2bf018720ee1ce40$var$useFormatRulesSerialisedJqlNew() : // eslint-disable-next-line react-hooks/rules-of-hooks
    $2bf018720ee1ce40$var$useFormatRulesSerialisedJqlOld();

});

parcelRegister("ke6T8", function(module, exports) {

$parcel$export(module.exports, "FormatRulesFragment", () => $c74d48a78ea64d73$export$cf415232d9027c0b);

var $fRmqu = parcelRequire("fRmqu");

var $hjfHK = parcelRequire("hjfHK");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $hxd1t = parcelRequire("hxd1t");

var $cpvqH = parcelRequire("cpvqH");
const $c74d48a78ea64d73$export$cf415232d9027c0b = ({ project: project })=>{
    const [, { setFormatRules: setFormatRules, setRulesForJqlInput: setRulesForJqlInput }] = (0, $cpvqH.useFormatRulesStore)();
    const projectData = (0, $j4oe4.useFragment)((0, $hjfHK.default), project);
    (0, $eJOHy.useEffect)(()=>{
        const formattingRulesByProject = projectData?.conditionalFormattingRules;
        if (!formattingRulesByProject) return;
        /* rowRules and cellRulesByFieldId - data to be able to format per rows and per field cell */ let rowRules = [];
        const cellRulesByFieldId = {};
        const rulesJqlInput = {};
        formattingRulesByProject.edges?.forEach((edge, index)=>{
            const rule = edge?.node;
            if (rule) {
                const { formattingArea: formattingArea, formattingColor: formattingColor } = rule;
                let fieldId = null;
                let operator = 'IS';
                let value;
                switch(rule.expression.__typename){
                    case 'JiraFormattingSingleValueOperand':
                        operator = rule.expression.singleValueOperator;
                        ({ value: value, fieldId: fieldId } = rule.expression);
                        break;
                    case 'JiraFormattingMultipleValueOperand':
                        operator = rule.expression.multipleValueOperator;
                        value = rule.expression.values;
                        fieldId = rule.expression.fieldId;
                        break;
                    case 'JiraFormattingNoValueOperand':
                        operator = rule.expression.noValueOperator;
                        fieldId = rule.expression.fieldId;
                        break;
                    default:
                        break;
                }
                const color = (0, $hxd1t.formattingColors)[formattingColor.colorKey || ''];
                const mappedRule = {
                    id: rule.id,
                    fieldId: fieldId,
                    operator: operator,
                    value: value,
                    color: color?.value,
                    formattingArea: formattingArea,
                    index: index,
                    hoverColor: color?.hoverValue
                };
                if (mappedRule.fieldId) {
                    if (mappedRule.formattingArea === 'ROW') rowRules = [
                        ...rowRules,
                        mappedRule
                    ];
                    else cellRulesByFieldId[mappedRule.fieldId] = [
                        ...cellRulesByFieldId[mappedRule.fieldId] || [],
                        mappedRule
                    ];
                    // input to serialise jql input
                    const DUMMY_VALUE = '-';
                    const values = Array.isArray(mappedRule.value) ? mappedRule.value : [
                        mappedRule.value
                    ];
                    if (!rulesJqlInput[mappedRule.fieldId]) rulesJqlInput[mappedRule.fieldId] = [];
                    values.forEach((ruleValue)=>{
                        if (mappedRule.fieldId) rulesJqlInput[mappedRule.fieldId]?.push({
                            value: ruleValue ?? DUMMY_VALUE,
                            label: ruleValue ?? DUMMY_VALUE
                        });
                    });
                }
            }
        });
        setFormatRules({
            rowRules: rowRules,
            cellRulesByFieldId: cellRulesByFieldId
        });
        setRulesForJqlInput(rulesJqlInput);
    }, [
        projectData?.conditionalFormattingRules,
        setFormatRules,
        setRulesForJqlInput
    ]);
    return null;
};
const $c74d48a78ea64d73$export$b52e558485d9c9f9 = ({ query: query })=>{
    const [, { setFormatRules: setFormatRules, setRulesForJqlInput: setRulesForJqlInput }] = (0, $cpvqH.useFormatRulesStore)();
    const { jira: jira } = (0, $j4oe4.usePreloadedQuery)((0, $fRmqu.default), query);
    if ((0, $7jTnu.fg)('jira_list_conditional_formatting')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c74d48a78ea64d73$export$cf415232d9027c0b, {
        project: jira?.jiraProjectByKey ?? null
    });
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        const formattingRulesByProject = jira?.jiraProjectByKey?.conditionalFormattingRules;
        if (!formattingRulesByProject) return;
        /* rowRules and cellRulesByFieldId - data to be able to format per rows and per field cell */ let rowRules = [];
        const cellRulesByFieldId = {};
        const rulesJqlInput = {};
        formattingRulesByProject.edges?.forEach((edge, index)=>{
            const rule = edge?.node;
            if (rule) {
                const { formattingArea: formattingArea, formattingColor: formattingColor } = rule;
                let fieldId = null;
                let operator = 'IS';
                let value;
                switch(rule.expression.__typename){
                    case 'JiraFormattingSingleValueOperand':
                        operator = rule.expression.singleValueOperator;
                        ({ value: value, fieldId: fieldId } = rule.expression);
                        break;
                    case 'JiraFormattingMultipleValueOperand':
                        operator = rule.expression.multipleValueOperator;
                        value = rule.expression.values;
                        fieldId = rule.expression.fieldId;
                        break;
                    case 'JiraFormattingNoValueOperand':
                        operator = rule.expression.noValueOperator;
                        fieldId = rule.expression.fieldId;
                        break;
                    default:
                        break;
                }
                const color = (0, $hxd1t.formattingColors)[formattingColor.colorKey || ''];
                const mappedRule = {
                    id: rule.id,
                    fieldId: fieldId,
                    operator: operator,
                    value: value,
                    color: color?.value,
                    formattingArea: formattingArea,
                    index: index,
                    hoverColor: color?.hoverValue
                };
                if (mappedRule.fieldId) {
                    if (mappedRule.formattingArea === 'ROW') rowRules = [
                        ...rowRules,
                        mappedRule
                    ];
                    else cellRulesByFieldId[mappedRule.fieldId] = [
                        ...cellRulesByFieldId[mappedRule.fieldId] || [],
                        mappedRule
                    ];
                    // input to serialise jql input
                    const DUMMY_VALUE = '-';
                    const values = Array.isArray(mappedRule.value) ? mappedRule.value : [
                        mappedRule.value
                    ];
                    if (!rulesJqlInput[mappedRule.fieldId]) rulesJqlInput[mappedRule.fieldId] = [];
                    values.forEach((ruleValue)=>{
                        if (mappedRule.fieldId) rulesJqlInput[mappedRule.fieldId]?.push({
                            value: ruleValue ?? DUMMY_VALUE,
                            label: ruleValue ?? DUMMY_VALUE
                        });
                    });
                }
            }
        });
        setFormatRules({
            rowRules: rowRules,
            cellRulesByFieldId: cellRulesByFieldId
        });
        setRulesForJqlInput(rulesJqlInput);
    }, [
        jira?.jiraProjectByKey?.conditionalFormattingRules,
        setFormatRules,
        setRulesForJqlInput
    ]);
    return null;
};

});
parcelRegister("fRmqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbc3dae492152535$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1b30c81f42108e10a82ec108cd687480>>
 * @relayHash eea6298bb0f0a1e53b265b881a3483fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d85cca612b260459285167e3253368af46849c9d9ef291c02e5f8606c0f50ab9

var $37Ewn = parcelRequire("37Ewn");
const $fbc3dae492152535$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v7 = {
        "kind": "ScalarField",
        "name": "formattingArea"
    }, v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v9 = {
        "kind": "LinkedField",
        "name": "expression",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "singleValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ],
                "type": "JiraFormattingSingleValueOperand"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "multipleValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "values"
                    }
                ],
                "type": "JiraFormattingMultipleValueOperand"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "noValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    }
                ],
                "type": "JiraFormattingNoValueOperand"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FormatRulesNewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "kind": "FragmentSpread",
                                    "name": "FormatRulesNew_project"
                                },
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ 
                                                            ]
                                                        },
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FormatRulesNewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d85cca612b260459285167e3253368af46849c9d9ef291c02e5f8606c0f50ab9",
            "metadata": {},
            "name": "FormatRulesNewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fbc3dae492152535$var$node.hash = "50b4c19a698d3a37927a4d8f4804e6d8";
(0, $37Ewn.PreloadableQueryRegistry).set($fbc3dae492152535$var$node.params.id, $fbc3dae492152535$var$node);
var $fbc3dae492152535$export$2e2bcd8739ae039 = $fbc3dae492152535$var$node;

});

parcelRegister("hjfHK", function(module, exports) {

$parcel$export(module.exports, "default", () => $03a5954b12bc9bf1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5e6d847ee30a1ccf0b58e486fc725bfe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03a5954b12bc9bf1$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "name": "FormatRulesNew_project",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "first"
                    }
                ],
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "formattingColor",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "formattingArea"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "expression",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "singleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "JiraFormattingSingleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "multipleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "values"
                                                    }
                                                ],
                                                "type": "JiraFormattingMultipleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "noValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    }
                                                ],
                                                "type": "JiraFormattingNoValueOperand"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
}();
$03a5954b12bc9bf1$var$node.hash = "57dc85da29364fdc529ccf4b7f6e61a2";
var $03a5954b12bc9bf1$export$2e2bcd8739ae039 = $03a5954b12bc9bf1$var$node;

});

parcelRegister("hxd1t", function(module, exports) {

$parcel$export(module.exports, "formattingColors", () => $a646b3e02ce65dba$export$2fedf4ac4eb04087);
$parcel$export(module.exports, "accessibleFormattingColors", () => $a646b3e02ce65dba$export$bef44f43b99e197e);
$parcel$export(module.exports, "getColorKeyFromValue", () => $a646b3e02ce65dba$export$ae7e938b8bdf2df5);

var $LFmXM = parcelRequire("LFmXM");

var $hIDJp = parcelRequire("hIDJp");
const $a646b3e02ce65dba$export$2fedf4ac4eb04087 = {
    lightPurple: {
        label: (0, $hIDJp.default).lightPurple,
        value: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
        hoverValue: "var(--ds-background-accent-purple-subtlest-hovered, #DFD8FD)"
    },
    lightBlue: {
        label: (0, $hIDJp.default).lightBlue,
        value: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
        hoverValue: "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)"
    },
    lightGreen: {
        label: (0, $hIDJp.default).lightGreen,
        value: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        hoverValue: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)"
    },
    lightTeal: {
        label: (0, $hIDJp.default).lightTeal,
        value: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        hoverValue: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)"
    },
    lightYellow: {
        label: (0, $hIDJp.default).lightYellow,
        value: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        hoverValue: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)"
    },
    lightRed: {
        label: (0, $hIDJp.default).lightRed,
        value: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        hoverValue: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)"
    },
    lightGray: {
        label: (0, $hIDJp.default).lightGray,
        value: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
        hoverValue: "var(--ds-background-accent-gray-subtlest-hovered, #DCDFE4)"
    },
    purple: {
        label: (0, $hIDJp.default).purple,
        value: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hoverValue: "var(--ds-background-accent-purple-subtler-hovered, #B8ACF6)"
    },
    blue: {
        label: (0, $hIDJp.default).blue,
        value: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hoverValue: "var(--ds-background-accent-blue-subtler-hovered, #85B8FF)"
    },
    green: {
        label: (0, $hIDJp.default).green,
        value: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hoverValue: "var(--ds-background-accent-green-subtler-hovered, #7EE2B8)"
    },
    teal: {
        label: (0, $hIDJp.default).teal,
        value: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hoverValue: "var(--ds-background-accent-teal-subtler-hovered, #9DD9EE)"
    },
    yellow: {
        label: (0, $hIDJp.default).yellow,
        value: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hoverValue: "var(--ds-background-accent-yellow-subtler-hovered, #F5CD47)"
    },
    red: {
        label: (0, $hIDJp.default).red,
        value: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hoverValue: "var(--ds-background-accent-red-subtler-hovered, #FD9891)"
    },
    gray: {
        label: (0, $hIDJp.default).gray,
        value: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hoverValue: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)"
    }
};
const $a646b3e02ce65dba$var$nonAccessibleColors = new Set([
    'lightBlue',
    'blue'
]);
const $a646b3e02ce65dba$export$bef44f43b99e197e = Object.fromEntries(Object.entries($a646b3e02ce65dba$export$2fedf4ac4eb04087).filter(([key])=>!$a646b3e02ce65dba$var$nonAccessibleColors.has(key)));
const $a646b3e02ce65dba$export$ae7e938b8bdf2df5 = (0, $LFmXM.default)((value)=>{
    const selectedColor = Object.entries($a646b3e02ce65dba$export$2fedf4ac4eb04087).find(([_, color])=>color.value === value);
    return selectedColor?.[0];
});

});
parcelRegister("hIDJp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c343c1aff2ff9a11$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c343c1aff2ff9a11$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    lightPurple: {
        "id": "issue-navigator-conditional-formatting-sidebar.common.utils.formatting-colors.light-purple",
        "defaultMessage": "Subtle purple"
    },
    lightBlue: {
        "id": "issue-navigator-conditional-formatting-sidebar.common.utils.formatting-colors.light-blue",
        "defaultMessage": "Subtle blue"
    },
    lightGreen: {
        "id": "issue-navigator-conditional-formatting-sidebar.common.utils.formatting-colors.light-green",
        "defaultMessage": "Subtle green"
    },
    lightTeal: {
        "id": "issue-navigator-conditional-formatting-sidebar.common.utils.formatting-colors.light-teal",
        "defaultMessage": "Subtle teal"
    },
    lightYellow: {
        "id": "issue-navigator-conditional-formatting-sidebar.common.utils.formatting-colors.light-yellow",
        "defaultMessage": "Subtle yellow"
    },
    lightRed: {
        "id": "issue-navigator-conditional-formatting-sidebar.common.utils.formatting-colors.light-red",
        "defaultMessage": "Subtle red"
    },
    lightGray: {
        "id": "issue-navigator-conditional-formatting-sidebar.common.utils.formatting-colors.light-gray",
        "defaultMessage": "Subtle gray"
    },
    purple: {
        "id": "issue-navigator-conditional-formatting-sidebar.common.utils.formatting-colors.purple",
        "defaultMessage": "Bold purple"
    },
    blue: {
        "id": "issue-navigator-conditional-formatting-sidebar.common.utils.formatting-colors.blue",
        "defaultMessage": "Bold blue"
    },
    green: {
        "id": "issue-navigator-conditional-formatting-sidebar.common.utils.formatting-colors.green",
        "defaultMessage": "Bold green"
    },
    teal: {
        "id": "issue-navigator-conditional-formatting-sidebar.common.utils.formatting-colors.teal",
        "defaultMessage": "Bold teal"
    },
    yellow: {
        "id": "issue-navigator-conditional-formatting-sidebar.common.utils.formatting-colors.yellow",
        "defaultMessage": "Bold yellow"
    },
    red: {
        "id": "issue-navigator-conditional-formatting-sidebar.common.utils.formatting-colors.red",
        "defaultMessage": "Bold red"
    },
    gray: {
        "id": "issue-navigator-conditional-formatting-sidebar.common.utils.formatting-colors.gray",
        "defaultMessage": "Bold gray"
    }
});

});




parcelRegister("6gbGT", function(module, exports) {

$parcel$export(module.exports, "MaybeConditionalFormattingSidebarExperienceOld", () => $5901763364b6fd19$export$4e53860ff94ae25a);

var $cVvBF = parcelRequire("cVvBF");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $cBavF = parcelRequire("cBavF");

var $dQ1Tp = parcelRequire("dQ1Tp");

var $f2JN3 = parcelRequire("f2JN3");

var $116z7 = parcelRequire("116z7");

var $cR6bn = parcelRequire("cR6bn");

var $6xXfL = parcelRequire("6xXfL");

var $gk2CF = parcelRequire("gk2CF");

var $d8fIq = parcelRequire("d8fIq");
const $5901763364b6fd19$export$305cd500fd3cdbea = ({ onClose: onClose, project: project })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $dQ1Tp.useConditionalFormattingEntryPoint)();
    const projectData = (0, $j4oe4.useFragment)((0, $cVvBF.default), project);
    const errorFallback = (0, $eJOHy.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $116z7.ExperienceFailure), {
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d8fIq.ErrorState), {
            onClose: onClose
        })), [
        onClose
    ]);
    if (projectData?.key == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6xXfL.FormatRulesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cR6bn.JqlProvider), {
        jqlContext: `project = '${projectData?.key}'`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "conditionalFormattingSidebar",
        packageName: "jiraIssueNavigatorActionConditionalFormatting",
        errorFallback: errorFallback,
        teamName: "Keystone",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        runtimeProps: {
            projectId: projectData?.projectId ?? undefined,
            onClose: onClose,
            showOnboarding: false
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gk2CF.FormatRulesFragment), {
        project: projectData ?? null
    }));
};
const $5901763364b6fd19$export$4e53860ff94ae25a = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jira_list_conditional_formatting'), $5901763364b6fd19$export$305cd500fd3cdbea, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));

});
parcelRegister("cVvBF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3c31c5573299d0d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<553a77e197ff24dd7c9188ac38cc24b4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b3c31c5573299d0d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConditionalFormattingSidebarExperienceOld_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 20
                }
            ],
            "kind": "FragmentSpread",
            "name": "FormatRules"
        }
    ],
    "type": "JiraProject"
};
$b3c31c5573299d0d$var$node.hash = "1c67a6820bbe6210dc3b3345c97a2554";
var $b3c31c5573299d0d$export$2e2bcd8739ae039 = $b3c31c5573299d0d$var$node;

});

parcelRegister("6xXfL", function(module, exports) {

$parcel$export(module.exports, "FormatRulesContainer", () => $e028b46b483d5a36$export$2022a9665c731c36);
$parcel$export(module.exports, "useFormatRulesStore", () => $e028b46b483d5a36$export$2fe3fe2e87aa2741);
$parcel$export(module.exports, "useFormatRulesSerialisedJql", () => $e028b46b483d5a36$export$3b2286d9a476f9a1);

var $7IX73 = parcelRequire("7IX73");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7jTnu = parcelRequire("7jTnu");
const $e028b46b483d5a36$var$initialState = {
    rowRules: [],
    cellRulesByFieldId: {},
    issueIdRowRuleMatched: {},
    rulesJqlInput: {}
};
const $e028b46b483d5a36$var$actions = {
    setFormatRules: (rules)=>({ setState: setState })=>{
            const newState = {
                ...rules
            };
            setState(newState);
        },
    setRulesForJqlInput: (input)=>({ setState: setState })=>{
            const newState = {
                rulesJqlInput: input
            };
            setState(newState);
        },
    setMatchedRowRule: ({ rule: rule, issueId: issueId })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const newState = {
                issueIdRowRuleMatched: {
                    ...currentState.issueIdRowRuleMatched,
                    [issueId]: rule
                }
            };
            setState(newState);
        },
    removeMatchedRowRule: ({ ruleId: ruleId })=>({ setState: setState, getState: getState })=>{
            const { issueIdRowRuleMatched: issueIdRowRuleMatched } = getState();
            const rowRuleMatched = Object.entries(issueIdRowRuleMatched).filter(([, value])=>value.id !== ruleId);
            const newIssueIdRowRuleMatched = Object.fromEntries(rowRuleMatched);
            setState({
                issueIdRowRuleMatched: newIssueIdRowRuleMatched
            });
        }
};
const $e028b46b483d5a36$var$oldStore = (0, $GtRbT.createStore)({
    initialState: $e028b46b483d5a36$var$initialState,
    actions: $e028b46b483d5a36$var$actions,
    name: 'JWMFormatRulesOld'
});
const $e028b46b483d5a36$export$2022a9665c731c36 = (0, $6E16M.createContainer)();
const $e028b46b483d5a36$var$Store = (0, $GtRbT.createStore)({
    initialState: $e028b46b483d5a36$var$initialState,
    actions: $e028b46b483d5a36$var$actions,
    name: 'JWMFormatRules',
    containedBy: $e028b46b483d5a36$export$2022a9665c731c36
});
const $e028b46b483d5a36$var$useFormatRulesStoreOld = (0, $iJq0l.createHook)($e028b46b483d5a36$var$oldStore);
const $e028b46b483d5a36$var$useFormatRulesStoreNew = (0, $iJq0l.createHook)($e028b46b483d5a36$var$Store);
const $e028b46b483d5a36$export$2fe3fe2e87aa2741 = ()=>(0, $7jTnu.fg)('jira_list_conditional_formatting') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $e028b46b483d5a36$var$useFormatRulesStoreNew() : // eslint-disable-next-line react-hooks/rules-of-hooks
    $e028b46b483d5a36$var$useFormatRulesStoreOld();
const $e028b46b483d5a36$var$getSerialisedJql = (state)=>(0, $7IX73.serialiseJql)(state.rulesJqlInput);
const $e028b46b483d5a36$var$useFormatRulesSerialisedJqlOld = (0, $iJq0l.createHook)($e028b46b483d5a36$var$oldStore, {
    selector: $e028b46b483d5a36$var$getSerialisedJql
});
const $e028b46b483d5a36$var$useFormatRulesSerialisedJqlNew = (0, $iJq0l.createHook)($e028b46b483d5a36$var$Store, {
    selector: $e028b46b483d5a36$var$getSerialisedJql
});
const $e028b46b483d5a36$export$3b2286d9a476f9a1 = ()=>(0, $7jTnu.fg)('jira_list_conditional_formatting') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $e028b46b483d5a36$var$useFormatRulesSerialisedJqlNew() : // eslint-disable-next-line react-hooks/rules-of-hooks
    $e028b46b483d5a36$var$useFormatRulesSerialisedJqlOld();

});

parcelRegister("gk2CF", function(module, exports) {

$parcel$export(module.exports, "FormatRulesFragment", () => $ca6a3b5363934a7d$export$cf415232d9027c0b);
$parcel$export(module.exports, "FormatRules", () => $ca6a3b5363934a7d$export$85cc1c447494ea9e);

var $122Eb = parcelRequire("122Eb");

var $1nwHQ = parcelRequire("1nwHQ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $dGUd3 = parcelRequire("dGUd3");

var $6xXfL = parcelRequire("6xXfL");
const $ca6a3b5363934a7d$export$cf415232d9027c0b = ({ project: project })=>{
    const [, { setFormatRules: setFormatRules, setRulesForJqlInput: setRulesForJqlInput }] = (0, $6xXfL.useFormatRulesStore)();
    const projectData = (0, $j4oe4.useFragment)((0, $1nwHQ.default), project);
    (0, $eJOHy.useEffect)(()=>{
        const formattingRulesByProject = projectData?.conditionalFormattingRules;
        if (!formattingRulesByProject) return;
        /* rowRules and cellRulesByFieldId - data to be able to format per rows and per field cell */ let rowRules = [];
        const cellRulesByFieldId = {};
        const rulesJqlInput = {};
        formattingRulesByProject.edges?.forEach((edge, index)=>{
            const rule = edge?.node;
            if (rule) {
                const { formattingArea: formattingArea, formattingColor: formattingColor } = rule;
                let fieldId = null;
                let operator = 'IS';
                let value;
                switch(rule.expression.__typename){
                    case 'JiraFormattingSingleValueOperand':
                        operator = rule.expression.singleValueOperator;
                        ({ value: value, fieldId: fieldId } = rule.expression);
                        break;
                    case 'JiraFormattingMultipleValueOperand':
                        operator = rule.expression.multipleValueOperator;
                        value = rule.expression.values;
                        fieldId = rule.expression.fieldId;
                        break;
                    case 'JiraFormattingNoValueOperand':
                        operator = rule.expression.noValueOperator;
                        fieldId = rule.expression.fieldId;
                        break;
                    default:
                        break;
                }
                const color = (0, $dGUd3.formattingColors)[formattingColor.colorKey || ''];
                const mappedRule = {
                    id: rule.id,
                    fieldId: fieldId,
                    operator: operator,
                    value: value,
                    color: color?.value,
                    formattingArea: formattingArea,
                    index: index,
                    hoverColor: color?.hoverValue
                };
                if (mappedRule.fieldId) {
                    if (mappedRule.formattingArea === 'ROW') rowRules = [
                        ...rowRules,
                        mappedRule
                    ];
                    else cellRulesByFieldId[mappedRule.fieldId] = [
                        ...cellRulesByFieldId[mappedRule.fieldId] || [],
                        mappedRule
                    ];
                    // input to serialise jql input
                    const DUMMY_VALUE = '-';
                    const values = Array.isArray(mappedRule.value) ? mappedRule.value : [
                        mappedRule.value
                    ];
                    if (!rulesJqlInput[mappedRule.fieldId]) rulesJqlInput[mappedRule.fieldId] = [];
                    values.forEach((ruleValue)=>{
                        if (mappedRule.fieldId) rulesJqlInput[mappedRule.fieldId]?.push({
                            value: ruleValue ?? DUMMY_VALUE,
                            label: ruleValue ?? DUMMY_VALUE
                        });
                    });
                }
            }
        });
        setFormatRules({
            rowRules: rowRules,
            cellRulesByFieldId: cellRulesByFieldId
        });
        setRulesForJqlInput(rulesJqlInput);
    }, [
        projectData?.conditionalFormattingRules,
        setFormatRules,
        setRulesForJqlInput
    ]);
    return null;
};
const $ca6a3b5363934a7d$export$85cc1c447494ea9e = ({ query: query })=>{
    const [, { setFormatRules: setFormatRules, setRulesForJqlInput: setRulesForJqlInput }] = (0, $6xXfL.useFormatRulesStore)();
    const { jira: jira } = (0, $j4oe4.usePreloadedQuery)((0, $122Eb.default), query);
    if ((0, $7jTnu.fg)('jira_list_conditional_formatting')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ca6a3b5363934a7d$export$cf415232d9027c0b, {
        project: jira?.jiraProjectByKey ?? null
    });
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        const formattingRulesByProject = jira?.jiraProjectByKey?.conditionalFormattingRules;
        if (!formattingRulesByProject) return;
        /* rowRules and cellRulesByFieldId - data to be able to format per rows and per field cell */ let rowRules = [];
        const cellRulesByFieldId = {};
        const rulesJqlInput = {};
        formattingRulesByProject.edges?.forEach((edge, index)=>{
            const rule = edge?.node;
            if (rule) {
                const { formattingArea: formattingArea, formattingColor: formattingColor } = rule;
                let fieldId = null;
                let operator = 'IS';
                let value;
                switch(rule.expression.__typename){
                    case 'JiraFormattingSingleValueOperand':
                        operator = rule.expression.singleValueOperator;
                        ({ value: value, fieldId: fieldId } = rule.expression);
                        break;
                    case 'JiraFormattingMultipleValueOperand':
                        operator = rule.expression.multipleValueOperator;
                        value = rule.expression.values;
                        fieldId = rule.expression.fieldId;
                        break;
                    case 'JiraFormattingNoValueOperand':
                        operator = rule.expression.noValueOperator;
                        fieldId = rule.expression.fieldId;
                        break;
                    default:
                        break;
                }
                const color = (0, $dGUd3.formattingColors)[formattingColor.colorKey || ''];
                const mappedRule = {
                    id: rule.id,
                    fieldId: fieldId,
                    operator: operator,
                    value: value,
                    color: color?.value,
                    formattingArea: formattingArea,
                    index: index,
                    hoverColor: color?.hoverValue
                };
                if (mappedRule.fieldId) {
                    if (mappedRule.formattingArea === 'ROW') rowRules = [
                        ...rowRules,
                        mappedRule
                    ];
                    else cellRulesByFieldId[mappedRule.fieldId] = [
                        ...cellRulesByFieldId[mappedRule.fieldId] || [],
                        mappedRule
                    ];
                    // input to serialise jql input
                    const DUMMY_VALUE = '-';
                    const values = Array.isArray(mappedRule.value) ? mappedRule.value : [
                        mappedRule.value
                    ];
                    if (!rulesJqlInput[mappedRule.fieldId]) rulesJqlInput[mappedRule.fieldId] = [];
                    values.forEach((ruleValue)=>{
                        if (mappedRule.fieldId) rulesJqlInput[mappedRule.fieldId]?.push({
                            value: ruleValue ?? DUMMY_VALUE,
                            label: ruleValue ?? DUMMY_VALUE
                        });
                    });
                }
            }
        });
        setFormatRules({
            rowRules: rowRules,
            cellRulesByFieldId: cellRulesByFieldId
        });
        setRulesForJqlInput(rulesJqlInput);
    }, [
        jira?.jiraProjectByKey?.conditionalFormattingRules,
        setFormatRules,
        setRulesForJqlInput
    ]);
    return null;
};

});
parcelRegister("122Eb", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f3e32651cdd941$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b04f03ebac43e14823c695fee7c96bac>>
 * @relayHash 675361bd8a0cbf4e577c3d4a64e58d93
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a053b466a5a7278a0b6b6373921b28f57107b4a597af1f3eaa118e9a60bc2b09

var $37Ewn = parcelRequire("37Ewn");
const $74f3e32651cdd941$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v7 = {
        "kind": "ScalarField",
        "name": "formattingArea"
    }, v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v9 = {
        "kind": "LinkedField",
        "name": "expression",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "singleValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ],
                "type": "JiraFormattingSingleValueOperand"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "multipleValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "values"
                    }
                ],
                "type": "JiraFormattingMultipleValueOperand"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "noValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    }
                ],
                "type": "JiraFormattingNoValueOperand"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FormatRulesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "kind": "FragmentSpread",
                                    "name": "FormatRules"
                                },
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ 
                                                            ]
                                                        },
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FormatRulesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a053b466a5a7278a0b6b6373921b28f57107b4a597af1f3eaa118e9a60bc2b09",
            "metadata": {},
            "name": "FormatRulesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$74f3e32651cdd941$var$node.hash = "a18a3649745191d38e6ffb3470019909";
(0, $37Ewn.PreloadableQueryRegistry).set($74f3e32651cdd941$var$node.params.id, $74f3e32651cdd941$var$node);
var $74f3e32651cdd941$export$2e2bcd8739ae039 = $74f3e32651cdd941$var$node;

});

parcelRegister("1nwHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f70517319a83e20$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<64d987680eaf97ad3df7137360486810>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0f70517319a83e20$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "name": "FormatRules",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "first"
                    }
                ],
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "formattingColor",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "formattingArea"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "expression",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "singleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "JiraFormattingSingleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "multipleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "values"
                                                    }
                                                ],
                                                "type": "JiraFormattingMultipleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "noValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    }
                                                ],
                                                "type": "JiraFormattingNoValueOperand"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
}();
$0f70517319a83e20$var$node.hash = "53cee9935758d1283f056e0039c8153a";
var $0f70517319a83e20$export$2e2bcd8739ae039 = $0f70517319a83e20$var$node;

});

parcelRegister("dGUd3", function(module, exports) {

$parcel$export(module.exports, "formattingColors", () => $a4eb1a317ca8f680$export$2fedf4ac4eb04087);
$parcel$export(module.exports, "accessibleFormattingColors", () => $a4eb1a317ca8f680$export$bef44f43b99e197e);
$parcel$export(module.exports, "getColorKeyFromValue", () => $a4eb1a317ca8f680$export$ae7e938b8bdf2df5);

var $LFmXM = parcelRequire("LFmXM");

var $4hch1 = parcelRequire("4hch1");
const $a4eb1a317ca8f680$export$2fedf4ac4eb04087 = {
    lightPurple: {
        label: (0, $4hch1.default).lightPurple,
        value: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
        hoverValue: "var(--ds-background-accent-purple-subtlest-hovered, #DFD8FD)"
    },
    lightBlue: {
        label: (0, $4hch1.default).lightBlue,
        value: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
        hoverValue: "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)"
    },
    lightGreen: {
        label: (0, $4hch1.default).lightGreen,
        value: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        hoverValue: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)"
    },
    lightTeal: {
        label: (0, $4hch1.default).lightTeal,
        value: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        hoverValue: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)"
    },
    lightYellow: {
        label: (0, $4hch1.default).lightYellow,
        value: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        hoverValue: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)"
    },
    lightRed: {
        label: (0, $4hch1.default).lightRed,
        value: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        hoverValue: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)"
    },
    lightGray: {
        label: (0, $4hch1.default).lightGray,
        value: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
        hoverValue: "var(--ds-background-accent-gray-subtlest-hovered, #DCDFE4)"
    },
    purple: {
        label: (0, $4hch1.default).purple,
        value: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hoverValue: "var(--ds-background-accent-purple-subtler-hovered, #B8ACF6)"
    },
    blue: {
        label: (0, $4hch1.default).blue,
        value: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hoverValue: "var(--ds-background-accent-blue-subtler-hovered, #85B8FF)"
    },
    green: {
        label: (0, $4hch1.default).green,
        value: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hoverValue: "var(--ds-background-accent-green-subtler-hovered, #7EE2B8)"
    },
    teal: {
        label: (0, $4hch1.default).teal,
        value: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hoverValue: "var(--ds-background-accent-teal-subtler-hovered, #9DD9EE)"
    },
    yellow: {
        label: (0, $4hch1.default).yellow,
        value: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hoverValue: "var(--ds-background-accent-yellow-subtler-hovered, #F5CD47)"
    },
    red: {
        label: (0, $4hch1.default).red,
        value: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hoverValue: "var(--ds-background-accent-red-subtler-hovered, #FD9891)"
    },
    gray: {
        label: (0, $4hch1.default).gray,
        value: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hoverValue: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)"
    }
};
const $a4eb1a317ca8f680$var$nonAccessibleColors = new Set([
    'lightBlue',
    'blue'
]);
const $a4eb1a317ca8f680$export$bef44f43b99e197e = Object.fromEntries(Object.entries($a4eb1a317ca8f680$export$2fedf4ac4eb04087).filter(([key])=>!$a4eb1a317ca8f680$var$nonAccessibleColors.has(key)));
const $a4eb1a317ca8f680$export$ae7e938b8bdf2df5 = (0, $LFmXM.default)((value)=>{
    const selectedColor = Object.entries($a4eb1a317ca8f680$export$2fedf4ac4eb04087).find(([_, color])=>color.value === value);
    return selectedColor?.[0];
});

});
parcelRegister("4hch1", function(module, exports) {

$parcel$export(module.exports, "default", () => $059b0cba1e2b3d71$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $059b0cba1e2b3d71$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    lightPurple: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-purple",
        "defaultMessage": "Subtle purple"
    },
    lightBlue: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-blue",
        "defaultMessage": "Subtle blue"
    },
    lightGreen: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-green",
        "defaultMessage": "Subtle green"
    },
    lightTeal: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-teal",
        "defaultMessage": "Subtle teal"
    },
    lightYellow: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-yellow",
        "defaultMessage": "Subtle yellow"
    },
    lightRed: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-red",
        "defaultMessage": "Subtle red"
    },
    lightGray: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-gray",
        "defaultMessage": "Subtle gray"
    },
    purple: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.purple",
        "defaultMessage": "Bold purple"
    },
    blue: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.blue",
        "defaultMessage": "Bold blue"
    },
    green: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.green",
        "defaultMessage": "Bold green"
    },
    teal: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.teal",
        "defaultMessage": "Bold teal"
    },
    yellow: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.yellow",
        "defaultMessage": "Bold yellow"
    },
    red: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.red",
        "defaultMessage": "Bold red"
    },
    gray: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.gray",
        "defaultMessage": "Bold gray"
    }
});

});





parcelRegister("5eCXQ", function(module, exports) {

$parcel$export(module.exports, "SpotlightExploreListClickListener", () => $570edcd65c450728$export$b2f7d074212242f3);

var $eJOHy = parcelRequire("eJOHy");

var $82cqT = parcelRequire("82cqT");

var $5V25X = parcelRequire("5V25X");

var $iRahl = parcelRequire("iRahl");

var $HiS1C = parcelRequire("HiS1C");

var $eibCx = parcelRequire("eibCx");

var $fwKw5 = parcelRequire("fwKw5");
const $570edcd65c450728$var$EXPLORE_LIST_TRIGGER = 'jira-nin-list-merge-modal-onboarding-explore-list-clicked';
const $570edcd65c450728$export$b2f7d074212242f3 = ()=>{
    const { filterId: filterId } = (0, $fwKw5.useActiveJql)();
    const { setView: setView } = (0, $HiS1C.useSelectedViewActions)();
    const hasClicked = (0, $eJOHy.useRef)(false);
    const { isActive: isExploreListViewClicked } = (0, $5V25X.useTrigger)($570edcd65c450728$var$EXPLORE_LIST_TRIGGER);
    (0, $eJOHy.useEffect)(()=>{
        if (!hasClicked.current && isExploreListViewClicked) {
            const newView = filterId && (0, $82cqT.isCustomFilter)(filterId) ? (0, $eibCx.convertFilterIdToIssueNavigatorId)(filterId) : (0, $iRahl.LIST_VIEW_ID);
            setView(newView, '');
            hasClicked.current = true;
        }
    }, [
        filterId,
        isExploreListViewClicked,
        setView
    ]);
    return null;
};

});


parcelRegister("7QuRk", function(module, exports) {

$parcel$export(module.exports, "SelectedIssue", () => $e481ae70beb05107$export$39b2b4a30505b395);

var $cK2RJ = parcelRequire("cK2RJ");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $ljej9 = parcelRequire("ljej9");

var $7jTnu = parcelRequire("7jTnu");

var $eibCx = parcelRequire("eibCx");

var $7681X = parcelRequire("7681X");

var $HiS1C = parcelRequire("HiS1C");

var $3kDjB = parcelRequire("3kDjB");

var $lvpZz = parcelRequire("lvpZz");
const $e481ae70beb05107$export$39b2b4a30505b395 = ({ children: children, issues: issues, selectedIssueKey: selectedIssueKey, onChange: onChange })=>{
    const [{ view: view }] = (0, $HiS1C.useSelectedViewState)();
    const searchKey = (0, $3kDjB.useSearchKey)();
    const issueData = (0, $j4oe4.useFragment)((0, $cK2RJ.default), issues);
    let issuesFlatList;
    if ((0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    issuesFlatList = (0, $lvpZz.useFlatListIssues)();
    const issueKeys = (0, $eJOHy.useMemo)(()=>view !== 'detail' && issuesFlatList && (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? issuesFlatList : issueData?.edges?.map((edge)=>(0, $ljej9.toIssueKey)(edge?.node?.key ?? '')) ?? [], [
        issuesFlatList,
        issueData?.edges,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7681X.SelectedIssueContainer), {
        view: (0, $eibCx.convertToView)(view),
        issueKeys: issueKeys,
        searchKey: searchKey,
        selectedIssueKey: selectedIssueKey,
        onChange: onChange
    }, children);
};

});
parcelRegister("cK2RJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ecfb59f80af34ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<861c6a2b5276ec2a8b6ba119835e232f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ecfb59f80af34ac$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedIssue_issueNavigator",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$6ecfb59f80af34ac$var$node.hash = "966aa39a272d43746556adcb1b54c0d8";
var $6ecfb59f80af34ac$export$2e2bcd8739ae039 = $6ecfb59f80af34ac$var$node;

});


parcelRegister("2y1A0", function(module, exports) {

$parcel$export(module.exports, "SelectedViewContainer", () => $0660590783621ed6$export$6e497a97feb37da2);

var $6aIRn = parcelRequire("6aIRn");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $HiS1C = parcelRequire("HiS1C");

var $3kDjB = parcelRequire("3kDjB");
const $0660590783621ed6$export$6e497a97feb37da2 = ({ children: children, jiraView: jiraView, onSetView: onSetView })=>{
    const { changeView: changeView } = (0, $3kDjB.useIssueSearchActions)();
    const jiraViewData = (0, $j4oe4.useFragment)((0, $6aIRn.default), jiraView);
    const viewId = (0, $eibCx.parseIssueNavigatorViewIdOrDefault)(jiraViewData?.viewId, (0, $iRahl.DEFAULT_VIEW_ID));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $HiS1C.Container), {
        view: viewId,
        onSetView: onSetView,
        onIssueSearchForView: changeView
    }, children);
};

});
parcelRegister("6aIRn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c224b593a596f1f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04fbb2bde6ed8bae3b30f5a477ad3660>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2c224b593a596f1f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedView_issueNavigator_SelectedViewContainer",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "viewId"
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$2c224b593a596f1f$var$node.hash = "7af7655c76c900649cc8f8ecf6ff6734";
var $2c224b593a596f1f$export$2e2bcd8739ae039 = $2c224b593a596f1f$var$node;

});


parcelRegister("3YMzi", function(module, exports) {

$parcel$export(module.exports, "IssueSearchInputProvider", () => $268d66377c42747a$export$b6ab4b45f9fc3fe0);

var $4LYiI = parcelRequire("4LYiI");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $iRahl = parcelRequire("iRahl");

var $fwKw5 = parcelRequire("fwKw5");

var $cJdYi = parcelRequire("cJdYi");
const $268d66377c42747a$var$getFilterFromSearchInput = (searchParam)=>{
    if (searchParam?.type === (0, $iRahl.SearchInputTypes).JQL) return undefined;
    return searchParam.type === (0, $iRahl.SearchInputTypes).FILTER_AND_JQL ? searchParam.filter : searchParam;
};
const $268d66377c42747a$export$b6ab4b45f9fc3fe0 = /*#__PURE__*/ (0, $eJOHy.memo)(({ children: children, filterQuery: filterQuery, refetch: refetch, searchInput: searchInput, jiraFilter: jiraFilter })=>{
    const filterData = (0, $j4oe4.useFragment)((0, $4LYiI.default), jiraFilter);
    const filterInput = $268d66377c42747a$var$getFilterFromSearchInput(searchInput);
    const filterId = filterInput?.type === (0, $iRahl.FilterTypes).ID ? filterInput?.value : undefined;
    const filterJql = filterInput?.type === (0, $iRahl.FilterTypes).JQL ? filterInput?.value : filterData?.jql;
    const isFilterEditable = filterData?.isEditable;
    let jql;
    if (searchInput?.type === (0, $iRahl.SearchInputTypes).FILTER_AND_JQL || searchInput?.type === (0, $iRahl.SearchInputTypes).JQL) jql = searchInput?.jql;
    const initialJql = (0, $eJOHy.useRef)((0, $7jTnu.fg)('jracloud_85520_hydration_ref_only_on_page_load') ? jql ?? filterJql : undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJdYi.FilterQueryProvider), {
        query: filterQuery,
        refetch: refetch,
        filterId: filterId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fwKw5.ActiveJqlProvider), {
        initialJql: initialJql.current,
        filterId: filterId,
        filterJql: filterJql,
        jql: jql,
        isFilterEditable: isFilterEditable ?? undefined
    }, children));
});

});
parcelRegister("4LYiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a90757d88f89891$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d378146f64cc5ac448022a161198ec9e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4a90757d88f89891$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "IssueSearchInputProvider_jiraFilter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$4a90757d88f89891$var$node.hash = "07d892c67fb0e3830707a3d1cccfa800";
var $4a90757d88f89891$export$2e2bcd8739ae039 = $4a90757d88f89891$var$node;

});



parcelRegister("9I5E1", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $9f17996c86676e6c$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $9f17996c86676e6c$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $9f17996c86676e6c$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $9f17996c86676e6c$export$c7732c55900cf0b9);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

const $9f17996c86676e6c$var$AsyncGettingStartedPanelShouldRender = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("kcqI9")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

const $9f17996c86676e6c$var$AsyncGettingStartedPanel = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("af8GM")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

const $9f17996c86676e6c$var$AsyncGettingStartedPanelOpenButton = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("jgb0S")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

const $9f17996c86676e6c$var$AsyncGettingStartedPanelReopenSpotlight = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("3ZBgZ")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $9f17996c86676e6c$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f17996c86676e6c$var$AsyncGettingStartedPanelShouldRender, null));
$9f17996c86676e6c$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $9f17996c86676e6c$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f17996c86676e6c$var$AsyncGettingStartedPanel, null));
$9f17996c86676e6c$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $9f17996c86676e6c$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f17996c86676e6c$var$AsyncGettingStartedPanelOpenButton, null));
$9f17996c86676e6c$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $9f17996c86676e6c$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f17996c86676e6c$var$AsyncGettingStartedPanelReopenSpotlight, null));
$9f17996c86676e6c$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("kcqI9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("8OOe7")
]).then(()=>parcelRequire('5UcAl'));

});

parcelRegister("af8GM", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("8YM4r")
]).then(()=>parcelRequire('6tZJD'));

});

parcelRegister("jgb0S", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("izzmP")
]).then(()=>parcelRequire('8IDjP'));

});

parcelRegister("3ZBgZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kVX56"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("caLxL")
]).then(()=>parcelRequire('c2Xzs'));

});


parcelRegister("2tWP9", function(module, exports) {

$parcel$export(module.exports, "ProjectIssueNavigatorHeaderSkeleton", () => $1a2c56de285a8aff$export$28359b78c47abc93);
/* project-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $321VJ = parcelRequire("321VJ");
const $1a2c56de285a8aff$var$customCssStyles = null;
const $1a2c56de285a8aff$var$containerStyles = {
    height: '104px'
};
const $1a2c56de285a8aff$export$28359b78c47abc93 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($321VJ))),
        containerStyles: $1a2c56de285a8aff$var$containerStyles,
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("321VJ", function(module, exports) {
module.exports = new URL("project-issue-navigator-header-skeleton.tpl.7e712bab.svg", import.meta.url).toString();

});


parcelRegister("5OzqY", function(module, exports) {

$parcel$export(module.exports, "default", () => $69c414756ef69016$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<188813c08a6b767043dfdfcd6e9e6e61>>
 * @relayHash 4269726e8ba7ceef0720803c06ec9dc3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4da1e676fb4717f68009f63522b10789960d60fc3543044cb90995abbb254a51
const $69c414756ef69016$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "documentTitleQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "documentTitleQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4da1e676fb4717f68009f63522b10789960d60fc3543044cb90995abbb254a51",
            "metadata": {},
            "name": "documentTitleQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$69c414756ef69016$var$node.hash = "37cf341ecbc6674a0e4301d1a119d06d";
var $69c414756ef69016$export$2e2bcd8739ae039 = $69c414756ef69016$var$node;

});

parcelRegister("aBIfT", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $730554390b82eb2a$export$dd5ad0b65cf665da);

var $eJOHy = parcelRequire("eJOHy");

var $bJscI = parcelRequire("bJscI");

var $baxYj = parcelRequire("baxYj");
// eslint-disable-next-line jira/react/no-class-components
class $730554390b82eb2a$var$DocumentTitleOld extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $baxYj.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $baxYj.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $baxYj.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $730554390b82eb2a$export$dd5ad0b65cf665da = (0, $bJscI.componentWithFG)('jira-concurrent-document-title', (0, $baxYj.DocumentTitleHelper), $730554390b82eb2a$var$DocumentTitleOld);

});

parcelRegister("foygf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c3c507384f706af$export$2e2bcd8739ae039);

var $2QLjh = parcelRequire("2QLjh");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $k71qx = parcelRequire("k71qx");

var $h6slU = parcelRequire("h6slU");

var $gFB4g = parcelRequire("gFB4g");

var $gfcvC = parcelRequire("gfcvC");

var $1KdDN = parcelRequire("1KdDN");

var $g8Az8 = parcelRequire("g8Az8");

var $epTsa = parcelRequire("epTsa");

var $aBIfT = parcelRequire("aBIfT");

var $lRq8t = parcelRequire("lRq8t");

var $6zXPf = parcelRequire("6zXPf");

var $82cqT = parcelRequire("82cqT");

var $aBVfX = parcelRequire("aBVfX");

var $7RWaJ = parcelRequire("7RWaJ");

var $egm3s = parcelRequire("egm3s");

var $ch9En = parcelRequire("ch9En");

var $2QLjh = parcelRequire("2QLjh");

var $kEUB1 = parcelRequire("kEUB1");

var $cECwI = parcelRequire("cECwI");

var $7jTnu = parcelRequire("7jTnu");

var $hJkmA = parcelRequire("hJkmA");

var $7Nlco = parcelRequire("7Nlco");
const $1c3c507384f706af$export$49640514ca453805 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$FilterTitleTooltipTagStyled, {
        ref: ref,
        ...props
    }));
const $1c3c507384f706af$var$ProjectBreadcrumbWithData = ({ queryReference: queryReference, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.usePreloadedQuery)((0, $2QLjh.default), queryReference);
    const projectName = data?.jira?.jiraProjectByKey?.name ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $6zXPf.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBIfT.DocumentTitle), {
        title: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $hJkmA.default).windowTitleMigrationIssueTermRefresh : (0, $hJkmA.default).windowTitleMigration, {
            projectName: projectName
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gFB4g.default), {
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h6slU.default), null)));
};
const $1c3c507384f706af$var$BreadcrumbFallback = ({ projectKey: projectKey, projectName: projectName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gFB4g.default), {
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h6slU.default), null));
const $1c3c507384f706af$var$Header = ({ projectKey: projectKey, jql: jql, filterId: filterId, filterDetails: filterDetails, searchResultPageData: searchResultPageData, isQuickFiltersDisabled: isQuickFiltersDisabled = false, HierarchyToggle: HierarchyToggle, GroupByDropdown: GroupByDropdown, HideDoneToggle: HideDoneToggle, FiltersMenu: FiltersMenu, SaveResetViewSettingsButton: SaveResetViewSettingsButton, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isHideDoneSupportEnabled: isHideDoneSupportEnabled, isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled, onChangeFilter: onChangeFilter })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $2QLjh.default));
    const cloudId = (0, $kEUB1.useCloudId)();
    (0, $eJOHy.useEffect)(()=>{
        loadQuery({
            projectKey: projectKey,
            cloudId: cloudId
        });
    }, [
        loadQuery,
        projectKey,
        cloudId
    ]);
    const heading = formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hJkmA.default).headingIssueTermRefresh : (0, $hJkmA.default).heading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gfcvC.default), {
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
            name: "page-header",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$BreadcrumbFallback, {
                projectKey: projectKey,
                projectName: ""
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
            id: "ui.project-name-query.boundary",
            packageName: "projectIssueNavigator",
            teamName: "empanada",
            sendToPrivacyUnsafeSplunk: true,
            attributes: (0, $g8Az8.isLoaderErrorAttributes),
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$BreadcrumbFallback, {
                    projectKey: projectKey,
                    projectName: projectKey
                })
        }, queryReference !== null && queryReference !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$ProjectBreadcrumbWithData, {
            queryReference: queryReference,
            projectKey: projectKey
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$BreadcrumbFallback, {
            projectKey: projectKey,
            projectName: ""
        }))),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Nlco.default), {
            jql: jql,
            filterId: filterId,
            isModifiedFilter: filterDetails?.jql !== jql,
            searchResultPageData: searchResultPageData,
            isQuickFiltersDisabled: isQuickFiltersDisabled,
            HierarchyToggle: HierarchyToggle,
            GroupByDropdown: GroupByDropdown,
            HideDoneToggle: HideDoneToggle,
            FiltersMenu: FiltersMenu,
            SaveResetViewSettingsButton: SaveResetViewSettingsButton,
            isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
            isHideDoneSupportEnabled: isHideDoneSupportEnabled,
            isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled,
            onChangeFilter: onChangeFilter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$HeaderContentWrapper, null, (0, $82cqT.isFilterId)(filterId) && filterDetails ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: filterDetails.name,
        tag: $1c3c507384f706af$export$49640514ca453805,
        position: "mouse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c3c507384f706af$var$FilterTitleTooltipContent, null, filterDetails.name)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $egm3s.FavoriteButtonHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $egm3s.FavoriteButton), {
        filterId: filterDetails.filterId,
        isFavoriteInitial: filterDetails.isFavourite
    })), (0, $82cqT.isCustomFilter)(filterDetails.filterId) && filterId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7RWaJ.DetailsButtonHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBVfX.DetailsPopup), {
        filterId: filterId
    }))) : heading)));
};
const $1c3c507384f706af$var$MemoHeader = /*#__PURE__*/ (0, $eJOHy.memo)($1c3c507384f706af$var$Header);
var $1c3c507384f706af$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $1c3c507384f706af$var$MemoHeader;
const $1c3c507384f706af$var$FilterTitleTooltipTagStyled = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1c3c507384f706af$var$FilterTitleTooltipContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $1c3c507384f706af$var$HeaderContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8nf1z _1e0c116y _4cvr1y6m _4t3izwfg _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2QLjh", function(module, exports) {

$parcel$export(module.exports, "default", () => $544440175bd0f6b9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67e071a33cf45c408e850b759f06d544>>
 * @relayHash 2dcb74ffdda96ee8a118627d99d348d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 95320ce8ef75d958fcc0085329ca22dbd72ca5869d41448c798a39e83b9c8b19
const $544440175bd0f6b9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainProjectNameQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainProjectNameQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "95320ce8ef75d958fcc0085329ca22dbd72ca5869d41448c798a39e83b9c8b19",
            "metadata": {},
            "name": "mainProjectNameQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$544440175bd0f6b9$var$node.hash = "fca14514ec7cc9e866219e1ef4f3f1e9";
var $544440175bd0f6b9$export$2e2bcd8739ae039 = $544440175bd0f6b9$var$node;

});

parcelRegister("aBVfX", function(module, exports) {

$parcel$export(module.exports, "DetailsPopup", () => $276102c584ea09ec$export$b61797ace80c3d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $kmlzw = parcelRequire("kmlzw");

var $goZPP = parcelRequire("goZPP");

var $7ep4S = parcelRequire("7ep4S");

var $lRq8t = parcelRequire("lRq8t");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");

var $j0saC = parcelRequire("j0saC");

var $7jTnu = parcelRequire("7jTnu");

var $4aSRi = parcelRequire("4aSRi");

var $b8OI0 = parcelRequire("b8OI0");

var $cECwI = parcelRequire("cECwI");

var $4ihOZ = parcelRequire("4ihOZ");

var $kEUB1 = parcelRequire("kEUB1");

var $bJscI = parcelRequire("bJscI");

var $gYnSx = parcelRequire("gYnSx");


var $cjyd0 = parcelRequire("cjyd0");

var $5b2kY = parcelRequire("5b2kY");

var $2dahp = parcelRequire("2dahp");

var $1RiLs = parcelRequire("1RiLs");

const $276102c584ea09ec$var$DetailsPopupOld = ({ filterId: filterId, defaultOpen: defaultOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $4aSRi.useModalDialogActions)();
    const triggerRef = (0, $eJOHy.useRef)(null);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultOpen);
    const onClose = (0, $eJOHy.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const titleId = 'issue-navigator-custom-filters.ui.details-popup.popup.title';
    const onTriggerClick = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        setIsOpen(!isOpen);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'filterDetailsButton');
    }, [
        isOpen,
        setIsOpen
    ]);
    const [isEditFilterModalOpen, setIsEditFilterModalOpen] = (0, $eJOHy.useState)(false);
    const onOpenEditFilterModal = (0, $eJOHy.useCallback)(()=>{
        if (!(0, $7jTnu.fg)('nin-save-filter-dialog-entry-point')) setIsEditFilterModalOpen(true);
        else setReturnFocusTo(triggerRef);
        onClose();
    }, [
        onClose,
        setReturnFocusTo
    ]);
    const onCloseEditFilterModal = (0, $eJOHy.useCallback)(()=>{
        setIsEditFilterModalOpen(false);
        setReturnFocusTo(triggerRef);
    }, [
        setReturnFocusTo
    ]);
    const Content = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5b2kY.PopupContent), {
            ...props,
            triggerRef: triggerRef,
            onOpenEditFilterModal: onOpenEditFilterModal,
            onOpenNewSubscriptionModal: onClose,
            filterId: filterId,
            titleId: titleId
        }), [
        filterId,
        onClose,
        onOpenEditFilterModal
    ]);
    const Trigger = (0, $eJOHy.useCallback)((props)=>{
        const ref = (0, $kmlzw.mergeRefs)([
            props.ref,
            triggerRef
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            ...props,
            appearance: "link",
            onClick: onTriggerClick,
            isSelected: isOpen,
            onMouseOver: (0, $5b2kY.preloadPopupContentComponent),
            testId: "issue-navigator-custom-filters.ui.details-popup.button",
            ref: ref
        }, formatMessage((0, $2dahp.default).filterDetails));
    }, [
        isOpen,
        onTriggerClick,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !(0, $7jTnu.fg)('nin-save-filter-dialog-entry-point') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j0saC.AsyncUpdateFilterDialog), {
        filterId: filterId,
        onClose: onCloseEditFilterModal,
        isOpen: isEditFilterModalOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: onClose,
        shouldRenderToParent: true,
        placement: "bottom-start",
        messageId: "issue-navigator-custom-filters.ui.details-popup.popup",
        messageType: "transactional",
        content: Content,
        trigger: Trigger,
        testId: "issue-navigator-custom-filters.ui.details-popup.popup",
        role: "dialog",
        titleId: titleId
    }));
};
const $276102c584ea09ec$var$Trigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ triggerRef: triggerRef, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const mergedRef = (0, $kmlzw.mergeRefs)([
        ref,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ...props,
        appearance: "link",
        isSelected: props['aria-expanded'],
        testId: "issue-navigator-custom-filters.ui.details-popup.button",
        ref: mergedRef
    }, formatMessage((0, $2dahp.default).filterDetails));
});
const $276102c584ea09ec$var$DetailsPopupNew = ({ filterId: filterId })=>{
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const activationId = (0, $4ihOZ.useActivationId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            filterId: filterId,
            activationId: activationId,
            cloudId: cloudId,
            isAnonymous: isAnonymous
        }), [
        filterId,
        activationId,
        cloudId,
        isAnonymous
    ]);
    const triggerRef = (0, $eJOHy.useRef)(null);
    const titleId = 'issue-navigator-custom-filters.ui.details-popup.popup.title';
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            titleId: titleId,
            triggerRef: triggerRef
        }), [
        triggerRef,
        titleId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b8OI0.PopupTrigger), {
        entryPoint: (0, $cjyd0.popupContentEntrypoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        trigger: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($276102c584ea09ec$var$Trigger, {
                ...props,
                triggerRef: triggerRef
            }),
        errorFallback: (0, $1RiLs.ErrorState),
        onError: (props)=>{
            (0, $gYnSx.default)({
                ...props,
                meta: {
                    id: 'DetailsPopupEntryPoint',
                    packageName: (0, $117f1f77d62e6b3b$export$ad257a98f20ee631),
                    teamName: 'empanada'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        },
        shouldRenderToParent: true,
        placement: "bottom-start",
        testId: "issue-navigator-custom-filters.ui.details-popup.popup",
        role: "dialog",
        titleId: titleId,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($276102c584ea09ec$var$LoadingFallback, null)
    });
};
const $276102c584ea09ec$export$b61797ace80c3d8 = (0, $bJscI.componentWithFG)('nin_filter_details_popup_entrypoint_migration', $276102c584ea09ec$var$DetailsPopupNew, $276102c584ea09ec$var$DetailsPopupOld);
const $276102c584ea09ec$var$LoadingFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($276102c584ea09ec$var$LoadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $276102c584ea09ec$var$LoadingWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo1wug _18m91wug _y3gn1h6o _1bsb1vif _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _c71lqdd9",
            __cmplp.className
        ])
    });
});

});
const $117f1f77d62e6b3b$export$ad257a98f20ee631 = 'jiraIssueNavigatorCustomFilters';

parcelRegister("cjyd0", function(module, exports) {

$parcel$export(module.exports, "popupContentEntrypoint", () => $a9b932e4b31faebc$export$530cc5cbdf6236ea);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $8oKDI = parcelRequire("8oKDI");

var $94jkS = parcelRequire("94jkS");

const $a9b932e4b31faebc$export$530cc5cbdf6236ea = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("eCu9h")), {
        moduleId: "0bfd023c",
        priority: "interaction"
    }),
    getPreloadProps: ({ filterId: filterId, activationId: activationId, cloudId: cloudId, isAnonymous: isAnonymous })=>{
        const filterAri = (0, $8oKDI.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'filter',
            resourceId: filterId,
            activationId: activationId
        });
        return {
            queries: {
                filterData: {
                    parameters: $94jkS.default,
                    variables: {
                        filterAri: filterAri,
                        isAnonymous: isAnonymous
                    }
                }
            },
            extraProps: {
                filterId: filterId,
                filterAri: filterAri
            }
        };
    }
});

});
parcelRegister("94jkS", function(module, exports) {

$parcel$export(module.exports, "default", () => $039be8120411891e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cabde37d42247daed0f55869eb5b6fd9>>
 * @relayHash 9f4cdfd24c4837edbec911e81f56cc4c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6bc8c23e9cd41f906771238f4fc28eed8056bad2b96a927b890039d4d973ea8d
const $039be8120411891e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v5 /*: any*/ 
        ]
    }, v7 = [
        v2 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "concreteType": "JiraGroup",
        "kind": "LinkedField",
        "name": "group",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            v2 /*: any*/ ,
            v5 /*: any*/ 
        ]
    }, v10 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v6 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityProjectGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "JiraRole",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": v7 /*: any*/ 
                        }
                    ],
                    "type": "JiraShareableEntityProjectRoleGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v8 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityGroupGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v9 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityUserGrant"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainPopupContentFilterByAriQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "description_issueNavigatorCustomFilters"
                                                },
                                                {
                                                    "condition": "isAnonymous",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "owner_issueNavigatorCustomFilters"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "subscriptions_issueNavigatorCustomFilters"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "permissions_issueNavigatorCustomFilters"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.filter"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainPopupContentFilterByAriQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "filter",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v2 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditable"
                                        },
                                        {
                                            "concreteType": "JiraShareableEntityShareGrantConnection",
                                            "kind": "LinkedField",
                                            "name": "shareGrants",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraShareableEntityEditGrantConnection",
                                            "kind": "LinkedField",
                                            "name": "editGrants",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isAnonymous",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "owner",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "filterId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "last",
                                                            "value": 5
                                                        }
                                                    ],
                                                    "concreteType": "JiraFilterEmailSubscriptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "emailSubscriptions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFilterEmailSubscriptionEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFilterEmailSubscription",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "emailSubscriptions(last:5)"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraCustomFilter"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6bc8c23e9cd41f906771238f4fc28eed8056bad2b96a927b890039d4d973ea8d",
            "metadata": {},
            "name": "mainPopupContentFilterByAriQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$039be8120411891e$var$node.hash = "0d557f612ff494f70f6caa72336c5a34";
var $039be8120411891e$export$2e2bcd8739ae039 = $039be8120411891e$var$node;

});

parcelRegister("eCu9h", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("4P97l")
]).then(()=>parcelRequire('cCtZP'));

});


parcelRegister("5b2kY", function(module, exports) {

$parcel$export(module.exports, "preloadPopupContentComponent", () => $58e38ec48da4d91e$export$c115357d632001d1);
$parcel$export(module.exports, "PopupContent", () => $58e38ec48da4d91e$export$2a2c7ba12d3231e3);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $8gBzI = parcelRequire("8gBzI");

var $i4zO4 = parcelRequire("i4zO4");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $58e38ec48da4d91e$export$1c4b66177193d06d = (0, $bQWwW.lazy)(()=>(parcelRequire("kKpv3")), {
    moduleId: "./src/packages/issue-navigator/custom-filters/src/ui/details-popup/popup-content/index.tsx"
});
const $58e38ec48da4d91e$export$c115357d632001d1 = ()=>$58e38ec48da4d91e$export$1c4b66177193d06d.preload();
const $58e38ec48da4d91e$var$LoadingFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58e38ec48da4d91e$var$LoadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null));
const $58e38ec48da4d91e$export$2a2c7ba12d3231e3 = (props)=>{
    (0, $8gBzI.useUFOComponentExperience)((0, $i4zO4.viewDetailsPopupExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "popup-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58e38ec48da4d91e$var$LoadingFallback, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58e38ec48da4d91e$export$1c4b66177193d06d, props));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $58e38ec48da4d91e$var$ContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo1wug _18m91wug _1bsb1vif _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _c71lqdd9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $58e38ec48da4d91e$var$LoadingWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $58e38ec48da4d91e$var$ContentWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8gBzI", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $f45c0feaf94c0f80$export$30ab340faaed55d4);

var $eJOHy = parcelRequire("eJOHy");
const $f45c0feaf94c0f80$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eJOHy.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $f45c0feaf94c0f80$export$30ab340faaed55d4 = (experience)=>{
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $f45c0feaf94c0f80$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("i4zO4", function(module, exports) {

$parcel$export(module.exports, "viewDetailsPopupExperience", () => $8ca5397f7d08497b$export$54c37dd263cb6171);
$parcel$export(module.exports, "viewNewSubscriptionModal", () => $8ca5397f7d08497b$export$1584a1158c503c0a);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $8ca5397f7d08497b$export$54c37dd263cb6171 = new (0, $f39LL.UFOExperience)('jira-issue-navigator.custom-filters.view-details-popup', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});
const $8ca5397f7d08497b$export$1584a1158c503c0a = new (0, $f39LL.UFOExperience)('jira-issue-navigator.custom-filters.details-popup.view-new-subscription-modal', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("kKpv3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("hmZy3")
]).then(()=>parcelRequire('hS0rx'));

});


parcelRegister("2dahp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1abd1b914f16bcb4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1abd1b914f16bcb4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    filterDetails: {
        "id": "issue-navigator-custom-filters.details-popup.filter-details",
        "defaultMessage": "Filter details"
    }
});

});

parcelRegister("1RiLs", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $8f39fa98a026f447$export$c1ed4f415b9e7023);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $dyvFQ = parcelRequire("dyvFQ");

var $9vvZ3 = parcelRequire("9vvZ3");
const $8f39fa98a026f447$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyvFQ.ErrorState), {
        description: formatMessage((0, $9vvZ3.default).errorMessage),
        pageAction: "detailsPopup"
    });
};

});
parcelRegister("dyvFQ", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $147eb7ee5e3e0a78$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $goZPP = parcelRequire("goZPP");

var $1NG86 = parcelRequire("1NG86");

var $dPMMf = parcelRequire("dPMMf");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $ivs94 = parcelRequire("ivs94");

var $1m9Wj = parcelRequire("1m9Wj");
const $147eb7ee5e3e0a78$var$BOX_HEIGHT = (0, $dPMMf.gridSize) * 18;
const $147eb7ee5e3e0a78$var$ERROR_ICON_BOX_WRAPPER_HEIGHT = (0, $dPMMf.gridSize) * 9;
const $147eb7ee5e3e0a78$var$ICON_SIZE = (0, $dPMMf.gridSize) * 9;
const $147eb7ee5e3e0a78$export$c1ed4f415b9e7023 = (props)=>{
    const { pageAction: pageAction, onRetry: onRetry, description: description, role: role } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = ()=>{
        onRetry?.();
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), `${pageAction}Retry clicked`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147eb7ee5e3e0a78$var$StyledBox, {
        height: $147eb7ee5e3e0a78$var$BOX_HEIGHT,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147eb7ee5e3e0a78$var$StyledBox, {
        height: $147eb7ee5e3e0a78$var$ERROR_ICON_BOX_WRAPPER_HEIGHT,
        iconSize: $147eb7ee5e3e0a78$var$ICON_SIZE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1m9Wj.StyledText), null, description !== undefined ? description : formatMessage((0, $ivs94.default).errorMessage)), (onRetry || !(0, $7jTnu.fg)('nin_filter_details_popup_entrypoint_migration')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClick,
        appearance: "link",
        testId: "issue-navigator-actions-common.ui.error.button"
    }, formatMessage((0, $ivs94.default).retryMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $147eb7ee5e3e0a78$var$StyledBox = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ivs94", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fc2779f4954708a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7fc2779f4954708a$var$messages = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-actions-common.error.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-actions-common.error.retry-message",
        "defaultMessage": "Click to retry"
    }
});
var $7fc2779f4954708a$export$2e2bcd8739ae039 = $7fc2779f4954708a$var$messages;

});

parcelRegister("1m9Wj", function(module, exports) {

$parcel$export(module.exports, "StyledText", () => $fe5d3814363465dc$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $806LH = parcelRequire("806LH");
const $fe5d3814363465dc$export$d675f139b342d51a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $fe5d3814363465dc$var$StyledTextComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $fe5d3814363465dc$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fe5d3814363465dc$var$StyledTextComponent, props));

});


parcelRegister("9vvZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf3c3c0c3c8efca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5cf3c3c0c3c8efca$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-custom-filters.details-popup.error-state.error-message",
        "defaultMessage": "We couldn't display the filter details."
    }
});

});



parcelRegister("7RWaJ", function(module, exports) {

$parcel$export(module.exports, "DetailsButtonHeaderWrapper", () => $abb34d3c862a37c9$export$1eb74eb504903ed6);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $abb34d3c862a37c9$export$1eb74eb504903ed6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _19pkv77o _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("egm3s", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $350054eec8c06571$export$8d5dab2ad1e19ea0);
$parcel$export(module.exports, "FavoriteButtonHeaderWrapper", () => $350054eec8c06571$export$5ca4047aa6ecffac);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fNmFZ = parcelRequire("fNmFZ");

var $aMJA4 = parcelRequire("aMJA4");
const $350054eec8c06571$export$8d5dab2ad1e19ea0 = ({ filterId: filterId, isFavoriteInitial: isFavoriteInitial, favoriteItemName: favoriteItemName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fNmFZ.default), {
        key: filterId,
        itemType: (0, $aMJA4.FILTERS_ITEM_TYPE),
        itemId: filterId,
        isFavoriteInitial: isFavoriteInitial,
        favoriteItemName: favoriteItemName,
        isShownInList: true
    });
const $350054eec8c06571$export$5ca4047aa6ecffac = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _4t3izwfg _19pkze3t _2hwx1b66 _otyrze3t _18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fNmFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4961e4a04dcd2feb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dFtHW = parcelRequire("dFtHW");


var $c5DQI = parcelRequire("c5DQI");
class $4961e4a04dcd2feb$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFtHW.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c5DQI.FavoriteButton), {
                ...this.props,
                favoriteChangeContext: favoriteChangeContext
            }));
    }
}

});
parcelRegister("c5DQI", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $9f486e8c0fd92397$export$8d5dab2ad1e19ea0);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $fVPN0 = parcelRequire("fVPN0");

var $aMJA4 = parcelRequire("aMJA4");

var $9R7x8 = parcelRequire("9R7x8");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $9f486e8c0fd92397$var$isProduction = window.BUILD_KEY !== 'JF-TEST';
class $9f486e8c0fd92397$export$8d5dab2ad1e19ea0 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isFavoriteInitial: undefined,
            favoriteItemName: undefined,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props), this.onClick = (analyticsEvent)=>{
            const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType, onClick: onClick } = this.props;
            const { changeFavorite: changeFavorite } = favoriteChangeContext;
            if (changeFavorite) changeFavorite({
                id: itemId,
                type: itemType,
                value: !this.getIsFavorite()
            }, analyticsEvent);
            if (typeof onClick === 'function') onClick();
        };
        this.state = {
            isFavorite: props.isFavoriteInitial
        };
    }
    componentDidMount() {
        const { itemId: itemId, itemType: itemType } = this.props;
        if (typeof itemId === 'undefined' || typeof itemType === 'undefined') return;
        // Adding an Error here for the next dev to implement this button.
        // This error won't show in prod, but will show when running a fragment.
        if (!$9f486e8c0fd92397$var$isProduction && !(0, $aMJA4.VALID_ITEM_TYPES).includes(itemType)) throw new Error(`FavoriteButton: Invalid value for prop 'type'.\n You passed: "${itemType}"\n It must be one of [${JSON.stringify((0, $aMJA4.VALID_ITEM_TYPES))}]\n\n`);
        if (typeof this.props.isFavoriteInitial !== 'undefined') // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        this.props.favoriteChangeContext.items[itemType][itemId] = {
            id: itemId,
            type: itemType,
            value: this.props.isFavoriteInitial,
            pending: false
        };
        if (this.getIsFavorite() === undefined) (0, $9R7x8.getFavorite)({
            id: itemId,
            type: itemType
        }).then((isFavorite)=>{
            this.setState({
                isFavorite: isFavorite
            });
        });
    }
    getIsFavorite() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.value : this.state.isFavorite;
    }
    getIsPending() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.pending : false;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": "favourite-button.favorite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fVPN0.default), {
            isFavorite: this.getIsFavorite(),
            favoriteItemName: this.props.favoriteItemName,
            pending: this.getIsPending(),
            hideTooltip: this.props.hideTooltip,
            tooltipPosition: this.props.tooltipPosition,
            onClick: this.onClick,
            isShownInList: this.props.isShownInList,
            isSmall: this.props.isSmall
        }));
    }
}

});
parcelRegister("fVPN0", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $c7558d16e1b4ddea$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $c7558d16e1b4ddea$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eq3Hf = parcelRequire("eq3Hf");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $gGgaG = parcelRequire("gGgaG");

var $aaIe7 = parcelRequire("aaIe7");

var $2Cx9n = parcelRequire("2Cx9n");

var $91hUW = parcelRequire("91hUW");

var $dLR8J = parcelRequire("dLR8J");

var $k71qx = parcelRequire("k71qx");

var $l5htz = parcelRequire("l5htz");

var $f2JN3 = parcelRequire("f2JN3");

var $6YFG2 = parcelRequire("6YFG2");

var $6XJko = parcelRequire("6XJko");

var $6urTU = parcelRequire("6urTU");
const $c7558d16e1b4ddea$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $c7558d16e1b4ddea$export$f8ad2acf0ec4860f extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $c7558d16e1b4ddea$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$db65185b5889c83, {
            "data-testid": $c7558d16e1b4ddea$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($91hUW))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6urTU.default).removeFromStarred)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aaIe7))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2Cx9n))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6urTU.default).addToStarred)
        }));
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
            const StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))) : (0, (/*@__PURE__*/$parcel$interopDefault($aaIe7)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label,
                size: isSmall ? 'small' : 'medium'
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6urTU.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6urTU.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }, (0, $6XJko.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $c7558d16e1b4ddea$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $l5htz.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $6YFG2.default))($c7558d16e1b4ddea$export$f8ad2acf0ec4860f);
const $c7558d16e1b4ddea$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1rr0 _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBase = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseNew, $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $c7558d16e1b4ddea$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syaz1oju",
            __cmplp.isFavorite ? "_30l31vop" : "_30l3wdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$db65185b5889c83 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2Cx9n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e88d859d9ad0102$var$_react = $1e88d859d9ad0102$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $1e88d859d9ad0102$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e88d859d9ad0102$var$StarIcon = (props)=>/*#__PURE__*/ $1e88d859d9ad0102$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props));
$1e88d859d9ad0102$var$StarIcon.displayName = 'StarIcon';
var $1e88d859d9ad0102$var$_default = module.exports.default = $1e88d859d9ad0102$var$StarIcon;

});

parcelRegister("91hUW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $69121b14e227da1b$var$_react = $69121b14e227da1b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $69121b14e227da1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $69121b14e227da1b$var$StarFilledIcon = (props)=>/*#__PURE__*/ $69121b14e227da1b$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props));
$69121b14e227da1b$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $69121b14e227da1b$var$_default = module.exports.default = $69121b14e227da1b$var$StarFilledIcon;

});

parcelRegister("6urTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $708ae8e1a771b9ca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $708ae8e1a771b9ca$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});


parcelRegister("9R7x8", function(module, exports) {

$parcel$export(module.exports, "getFavorite", () => $d577b9b229521b80$export$fce5eda070ce88d0);

var $jGzN3 = parcelRequire("jGzN3");
const $d577b9b229521b80$export$959ca2ee969adb8d = (request)=>`/rest/internal/2/favourites/${request.type}/${request.id}`;
const $d577b9b229521b80$export$fce5eda070ce88d0 = async (request)=>(0, $jGzN3.performGetRequest)($d577b9b229521b80$export$959ca2ee969adb8d(request));

});




parcelRegister("hJkmA", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc994481ec05bb8b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cc994481ec05bb8b$var$messages = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "project-issue-navigator.heading",
        "defaultMessage": "Issues"
    },
    windowTitleMigration: {
        "id": "project-issue-navigator.window-title-migration",
        "defaultMessage": "{projectName} - Issues"
    },
    windowTitleMigrationIssueTermRefresh: {
        "id": "project-issue-navigator.window-title-migration-issue-term-refresh",
        "defaultMessage": "{projectName} - All work"
    },
    headingIssueTermRefresh: {
        "id": "project-issue-navigator.heading-issue-term-refresh",
        "defaultMessage": "All work"
    }
});
var $cc994481ec05bb8b$export$2e2bcd8739ae039 = $cc994481ec05bb8b$var$messages;

});

parcelRegister("7Nlco", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b267bf2ee1c0f9d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $e0I8k = parcelRequire("e0I8k");

var $b5RwB = parcelRequire("b5RwB");

var $guChT = parcelRequire("guChT");

var $ftN6c = parcelRequire("ftN6c");

var $jYYbf = parcelRequire("jYYbf");

var $895TH = parcelRequire("895TH");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $epTsa = parcelRequire("epTsa");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $4BO6a = parcelRequire("4BO6a");

var $9PZtK = parcelRequire("9PZtK");

var $hqg31 = parcelRequire("hqg31");


var $iCNcB = parcelRequire("iCNcB");

var $2YvCN = parcelRequire("2YvCN");

var $hOebY = parcelRequire("hOebY");

var $82cqT = parcelRequire("82cqT");

var $fAgUF = parcelRequire("fAgUF");

var $6fNuu = parcelRequire("6fNuu");

var $iUwEA = parcelRequire("iUwEA");

var $dpFVo = parcelRequire("dpFVo");

var $6zXPf = parcelRequire("6zXPf");

var $gCeeo = parcelRequire("gCeeo");

var $cECwI = parcelRequire("cECwI");

var $6XJko = parcelRequire("6XJko");

var $aaLZH = parcelRequire("aaLZH");

var $bJscI = parcelRequire("bJscI");

var $gn3Hu = parcelRequire("gn3Hu");
const $3b267bf2ee1c0f9d$var$HierarchyToggleWrapper = ({ children: children })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        paddingInline: "space.150",
        onClick: (e)=>e.stopPropagation()
    }, children);
const $3b267bf2ee1c0f9d$var$HideDoneToggleWrapper = ({ children: children })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.050",
        paddingInline: "space.150",
        onClick: (e)=>e.stopPropagation()
    }, children);
const $3b267bf2ee1c0f9d$var$MaybeSpotlightTarget = (0, $bJscI.componentWithFG)('jira_list_nin_merge', (0, $guChT.default), ({ children: children })=>children);
const $3b267bf2ee1c0f9d$var$AdditionalItemsWrapper = (0, $f2JN3.componentWithCondition)(()=>(0, $epTsa.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3b267bf2ee1c0f9d$var$menuItemStyles
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children));
const $3b267bf2ee1c0f9d$var$PageActions = ({ jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter, searchResultPageData: searchResultPageData, isQuickFiltersDisabled: isQuickFiltersDisabled = false, HierarchyToggle: HierarchyToggle, GroupByDropdown: GroupByDropdown, HideDoneToggle: HideDoneToggle, FiltersMenu: FiltersMenu, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isHideDoneSupportEnabled: isHideDoneSupportEnabled, isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled, isGridNavigationEnabled: isGridNavigationEnabled, SaveResetViewSettingsButton: SaveResetViewSettingsButton, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled, onChangeFilter: onChangeFilter })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).PAGE_ACTIONS_START);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).PAGE_ACTIONS_END);
    }, []);
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const savedFilter = (0, $82cqT.isFilterId)(filterId) ? filterId : undefined; // filter out non-standard PIN named filters
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireAdvanceSearchClickAnalytics = (e)=>{
        const leftClick = e.type === 'contextmenu';
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const withCmd = e.ctrlKey || e.metaKey;
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'advancedSearchButton', {
            openedIn: leftClick && !withCmd ? 'sameTab' : 'newTab'
        });
    };
    const jqlString = isModifiedFilter ? jql : undefined;
    const advancedSearchHref = (0, $7jTnu.fg)('nin_fix_stringify_in_go_to_advanced') ? `/issues/?${(0, $e0I8k.stringify)({
        jql: jqlString,
        filter: filterId
    })}` : `/issues/?${(0, $b5RwB.stringify)({
        jql: jqlString,
        filter: filterId
    })}`;
    const HierarchyToggleComponent = HierarchyToggle !== null && HierarchyToggle !== undefined && (0, $epTsa.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        key: (0, $a0674c45e0861e1c$export$72cbdf7971462ebd),
        component: $3b267bf2ee1c0f9d$var$HierarchyToggleWrapper
    }, HierarchyToggle) : null;
    const HideDoneToggleComponent = HideDoneToggle !== null && HideDoneToggle !== undefined && (0, $7jTnu.fg)('jsc_list_hide_done_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "nin-hide-done-toggle-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        key: (0, $a0674c45e0861e1c$export$6e37bc383199950c),
        component: $3b267bf2ee1c0f9d$var$HideDoneToggleWrapper
    }, HideDoneToggle)) : null;
    const viewOptions = HideDoneToggleComponent || HierarchyToggleComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, HideDoneToggleComponent, HierarchyToggleComponent) : null;
    const additionalMenuItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        key: (0, $a0674c45e0861e1c$export$a7a312131aa962e0),
        onClick: (e)=>fireAdvanceSearchClickAnalytics(e),
        href: advancedSearchHref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$AdditionalItemsWrapper, null, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gn3Hu.default).allIssuesIssueTermRefresh : (0, $gn3Hu.default).allIssues)));
    const customExportTrigger = (isOpen, triggerButtonProps)=>{
        const { triggerRef: triggerRef, ...props } = triggerButtonProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hOebY.FilterIconButton), {
            customTriggerProps: {
                ...props,
                ref: triggerRef
            },
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($895TH))),
            label: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gn3Hu.default).exportIssuesButtonIconLabelIssueTermRefresh : (0, $gn3Hu.default).exportIssuesButtonIconLabel),
            isSelected: isOpen
        });
    };
    const customExportDisabled = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hOebY.FilterIconButton), {
        isDisabled: true,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($895TH))),
        label: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gn3Hu.default).exportIssuesButtonIconLabelIssueTermRefresh : (0, $gn3Hu.default).exportIssuesButtonIconLabel)
    });
    let enableQuickFilters = false;
    if ((0, $6zXPf.getWillShowNav4)()) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isNaturalLanguageMode] = (0, $iUwEA.useNaturalLanguageMode)();
        enableQuickFilters = !isNaturalLanguageMode && !isQuickFiltersDisabled;
    }
    const viewSwitcher = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$MaybeSpotlightTarget, {
        name: "project-issue-navigator.ui.page-actions.view-switcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6fNuu.default), {
        filterId: filterId
    })));
    const exportMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9PZtK.default), {
        jql: jql,
        filterId: savedFilter,
        isModifiedFilter: isModifiedFilter,
        showEcosystemApps: false,
        ...(0, $6zXPf.getWillShowNav4)() && {
            customTriggerButton: customExportTrigger,
            customDisabledButton: customExportDisabled
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$export$48377ae1c677702b, null, !isAnonymous && (0, $dpFVo.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2YvCN.ShareButton), {
        jql: jql,
        filterId: savedFilter,
        isModifiedFilter: isModifiedFilter
    })), (0, $6zXPf.getWillShowNav4)() && enableQuickFilters && // eslint-disable-next-line jira/ff/no-preconditioning
    !((0, $7jTnu.fg)('nin-saved-filters') && (0, $7jTnu.fg)('jira_list_nin_merge')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iCNcB.default), {
        onChangeFilter: onChangeFilter
    })), FiltersMenu && (0, $7jTnu.fg)('nin-saved-filters') && (0, $7jTnu.fg)('jira_list_nin_merge') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$StyledPageAction, null, FiltersMenu), GroupByDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$StyledPageAction, null, GroupByDropdown), !((0, $6XJko.isVisualRefreshEnabled)() && (0, $7jTnu.fg)('visual-refresh-headers-buttons')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaLZH.IssueNavigatorFeatureGuard), {
        featureKey: "isExportMenuEnabled",
        on: exportMenu,
        fallback: exportMenu
    }), (0, $dpFVo.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BO6a.default), {
        jql: jql,
        filterId: savedFilter,
        isModifiedFilter: isModifiedFilter
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaLZH.IssueNavigatorFeatureGuard), {
        featureKey: "isViewSwitcherEnabled",
        on: viewSwitcher,
        fallback: viewSwitcher
    }), SaveResetViewSettingsButton && (0, $epTsa.expVal)('saved_list_view', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $3b267bf2ee1c0f9d$var$styles.saveResetButtonWrapper
        ])
    }, SaveResetViewSettingsButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b267bf2ee1c0f9d$var$MaybeSpotlightTarget, {
        name: "project-issue-navigator.ui.page-actions.meatball-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hqg31.default), {
        jql: jql,
        filterId: savedFilter,
        searchResultPageData: searchResultPageData,
        additionalMenuItems: (0, $6zXPf.getWillShowNav4)() && additionalMenuItems,
        viewOptions: viewOptions,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        isHideDoneSupportEnabled: isHideDoneSupportEnabled,
        isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled,
        isModifiedFilter: isModifiedFilter,
        isGridNavigationEnabled: isGridNavigationEnabled,
        isInlineFieldConfigEnabled: isInlineFieldConfigEnabled
    }))));
};
var $3b267bf2ee1c0f9d$export$2e2bcd8739ae039 = $3b267bf2ee1c0f9d$var$PageActions;
const $3b267bf2ee1c0f9d$var$styles = {
    saveResetButtonWrapper: "_19pkidpf _2hwx1b66 _otyridpf _18u0r5cr _1ul9idpf"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b267bf2ee1c0f9d$var$StyledPageAction = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1b66 _otyridpf _18u01b66 _1ul9idpf _1xoqidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3b267bf2ee1c0f9d$export$48377ae1c677702b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c",
            __cmplp.className
        ])
    });
});
const $3b267bf2ee1c0f9d$var$menuItemStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});

});
parcelRegister("e0I8k", function(module, exports) {

$parcel$export(module.exports, "decode", () => $a3334cc298c2f94d$export$2f872c0f2117be69, (v) => $a3334cc298c2f94d$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "parse", () => $a3334cc298c2f94d$export$98e6a39c04603d36, (v) => $a3334cc298c2f94d$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "encode", () => $a3334cc298c2f94d$export$c564cdbbe6da493, (v) => $a3334cc298c2f94d$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "stringify", () => $a3334cc298c2f94d$export$fac44ee5b035f737, (v) => $a3334cc298c2f94d$export$fac44ee5b035f737 = v);
var $a3334cc298c2f94d$export$2f872c0f2117be69;
var $a3334cc298c2f94d$export$98e6a39c04603d36;
var $a3334cc298c2f94d$export$c564cdbbe6da493;
var $a3334cc298c2f94d$export$fac44ee5b035f737;
'use strict';

$a3334cc298c2f94d$export$2f872c0f2117be69 = $a3334cc298c2f94d$export$98e6a39c04603d36 = (parcelRequire("dsfwg"));

$a3334cc298c2f94d$export$c564cdbbe6da493 = $a3334cc298c2f94d$export$fac44ee5b035f737 = (parcelRequire("6vVY0"));

});
parcelRegister("dsfwg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $9cb9edb7aa9a3001$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$9cb9edb7aa9a3001$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($9cb9edb7aa9a3001$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $9cb9edb7aa9a3001$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("6vVY0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $4be29a4f00cc422b$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $4be29a4f00cc422b$var$map($4be29a4f00cc422b$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(k)) + eq;
        if ($4be29a4f00cc422b$var$isArray(obj[k])) return $4be29a4f00cc422b$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(name)) + eq + encodeURIComponent($4be29a4f00cc422b$var$stringifyPrimitive(obj));
};
var $4be29a4f00cc422b$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $4be29a4f00cc422b$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $4be29a4f00cc422b$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});


parcelRegister("895TH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::89ab4c41f5117fc720387c91095ca641>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ee3bd169b82740f$var$_react = $5ee3bd169b82740f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5ee3bd169b82740f$var$_upload = $5ee3bd169b82740f$var$_interopRequireDefault((parcelRequire("1Bhzj")));

var $5ee3bd169b82740f$var$_export = $5ee3bd169b82740f$var$_interopRequireDefault((parcelRequire("lS60U")));
function $5ee3bd169b82740f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for UploadIcon.
 * This component is UploadIcon, with `UNSAFE_fallbackIcon` set to "ExportIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ee3bd169b82740f$var$UploadIcon = (props)=>/*#__PURE__*/ $5ee3bd169b82740f$var$_react.default.createElement($5ee3bd169b82740f$var$_upload.default, Object.assign({
        name: "UploadIcon",
        LEGACY_fallbackIcon: $5ee3bd169b82740f$var$_export.default
    }, props));
$5ee3bd169b82740f$var$UploadIcon.displayName = 'UploadIconMigration';
var $5ee3bd169b82740f$var$_default = module.exports.default = $5ee3bd169b82740f$var$UploadIcon;

});
parcelRegister("1Bhzj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afc4f0315b11d9afea68ddf0758e998e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12a6dfe6352f87c1$var$_react = $12a6dfe6352f87c1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $12a6dfe6352f87c1$var$_baseNew = $12a6dfe6352f87c1$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $12a6dfe6352f87c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $12a6dfe6352f87c1$var$UploadIcon = (props)=>/*#__PURE__*/ $12a6dfe6352f87c1$var$_react.default.createElement($12a6dfe6352f87c1$var$_baseNew.default, Object.assign({
        name: "UploadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.47 1.22a.75.75 0 0 1 1.06 0l4 4-1.06 1.06-2.72-2.72V11h-1.5V3.56L4.53 6.28 3.47 5.22zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$12a6dfe6352f87c1$var$UploadIcon.displayName = 'UploadIcon';
var $12a6dfe6352f87c1$var$_default = module.exports.default = $12a6dfe6352f87c1$var$UploadIcon;

});

parcelRegister("lS60U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fec34e50bddc7eea$var$_react = $fec34e50bddc7eea$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $fec34e50bddc7eea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fec34e50bddc7eea$var$ExportIcon = (props)=>/*#__PURE__*/ $fec34e50bddc7eea$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
    }, props));
$fec34e50bddc7eea$var$ExportIcon.displayName = 'ExportIcon';
var $fec34e50bddc7eea$var$_default = module.exports.default = $fec34e50bddc7eea$var$ExportIcon;

});


parcelRegister("4BO6a", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d53258af9233a97$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $goZPP = parcelRequire("goZPP");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $c9uTK = parcelRequire("c9uTK");

var $7Hxeg = parcelRequire("7Hxeg");
const $1d53258af9233a97$var$AdvancedSearchButton = ({ jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const jqlString = isModifiedFilter ? jql : undefined;
    const href = `/issues/?${(0, $b5RwB.stringify)({
        jql: jqlString,
        filter: filterId
    })}`;
    const fireClickAnalytics = (e, leftClick)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const withCmd = e.ctrlKey || e.metaKey;
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'advancedSearchButton', {
            openedIn: leftClick && !withCmd ? 'sameTab' : 'newTab'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        testId: "issue-navigator-action-advanced-search-button.advanced-search-button",
        onContextMenu: (e)=>fireClickAnalytics(e, false),
        onClick: (e)=>fireClickAnalytics(e, true),
        href: href,
        component: (0, $c9uTK.Link)
    }, ' ', formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7Hxeg.default).allIssuesIssueTermRefresh : (0, $7Hxeg.default).allIssues));
};
var $1d53258af9233a97$export$2e2bcd8739ae039 = $1d53258af9233a97$var$AdvancedSearchButton;

});
parcelRegister("7Hxeg", function(module, exports) {

$parcel$export(module.exports, "default", () => $024b44c06c6af931$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $024b44c06c6af931$var$messages = (0, $7qGN1.defineMessages)({
    allIssues: {
        "id": "issue-navigator-action-advanced-search-button.all-issues",
        "defaultMessage": "Go to all issues"
    },
    allIssuesIssueTermRefresh: {
        "id": "issue-navigator-action-advanced-search-button.all-issues-issue-term-refresh",
        "defaultMessage": "Go to all work items"
    }
});
var $024b44c06c6af931$export$2e2bcd8739ae039 = $024b44c06c6af931$var$messages;

});


parcelRegister("9PZtK", function(module, exports) {

$parcel$export(module.exports, "default", () => $52db55e2c3054746$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7rjYb = parcelRequire("7rjYb");

var $7jTnu = parcelRequire("7jTnu");

var $1KdDN = parcelRequire("1KdDN");

var $lRq8t = parcelRequire("lRq8t");

var $dyvFQ = parcelRequire("dyvFQ");

var $2k6Pt = parcelRequire("2k6Pt");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $71NoK = parcelRequire("71NoK");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $52db55e2c3054746$var$ExportIssues = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("bBtWe")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/actions/export-issues/src/ui/index.tsx"
});
const $52db55e2c3054746$var$Fallback = ({ onRetry: onRetry, customTriggerButton: customTriggerButton })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const triggerButton = ({ triggerRef: triggerRef, ...props })=>customTriggerButton ? customTriggerButton(false, {
            triggerRef: triggerRef,
            ...props
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2k6Pt.FilterButton), {
            ...props,
            text: formatMessage((0, $71NoK.default).exportButtonText),
            label: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $71NoK.default).exportIssuesButtonIconLabelIssueTerminologyRefreshM4 : (0, $71NoK.default).exportIssuesButtonIconLabel),
            ref: triggerRef
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>triggerButton({
                triggerRef: triggerRef,
                ...props
            }),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact",
        shouldRenderToParent: (0, $7jTnu.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyvFQ.ErrorState), {
        onRetry: onRetry,
        pageAction: "exportIssues"
    }));
};
const $52db55e2c3054746$var$AsyncExportIssues = (props)=>{
    const { customTriggerButton: customTriggerButton, customDisabledButton: customDisabledButton } = props;
    const [resetCaughtError, setResetCaughtError] = (0, $eJOHy.useState)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorActionExportIssues",
        id: "async-export-issues",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($52db55e2c3054746$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error),
                customTriggerButton: customTriggerButton
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-export-issues",
        fallback: customDisabledButton ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2k6Pt.FilterButton), {
            isDisabled: true,
            text: formatMessage((0, $71NoK.default).exportButtonText),
            label: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $71NoK.default).exportIssuesButtonIconLabelIssueTerminologyRefreshM4 : (0, $71NoK.default).exportIssuesButtonIconLabel)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($52db55e2c3054746$var$ExportIssues, props)));
};
var $52db55e2c3054746$export$2e2bcd8739ae039 = $52db55e2c3054746$var$AsyncExportIssues;

});
parcelRegister("2k6Pt", function(module, exports) {

$parcel$export(module.exports, "FilterButton", () => $070635dd59b3e334$export$fb46dd9777cc6db0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $5lAAn = parcelRequire("5lAAn");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $jd93d = parcelRequire("jd93d");
const $070635dd59b3e334$var$ConditionalWrapper = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('empanada_nin_covnert_share_to_entrypoint') || (0, $7jTnu.fg)('empanada_nin_convert_apps_to_entrypoint'), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children), ({ vcId: vcId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $070635dd59b3e334$var$buttonWrapperStyles,
        "data-vc": `${vcId}-button${false ? '-ssr' : ''}`
    }, children));
const $070635dd59b3e334$export$fb46dd9777cc6db0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isSelected: isSelected, onClick: onClick, testId: testId, vcId: vcId, isDisabled: isDisabled, text: text, label: label, customTriggerProps: customTriggerProps }, ref)=>{
    const mergedRefs = (0, $jd93d.default)(ref, customTriggerProps?.ref ?? null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($070635dd59b3e334$var$ConditionalWrapper, {
        vcId: vcId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        isSelected: isSelected,
        onClick: onClick,
        ...(0, $7jTnu.fg)('empanada_nin_covnert_share_to_entrypoint') ? {} : {
            ref: ref
        },
        testId: testId,
        isDisabled: isDisabled,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($070635dd59b3e334$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            label: label,
            color: "currentColor",
            size: "small"
        })),
        "data-vc": (0, $7jTnu.fg)('empanada_nin_covnert_share_to_entrypoint') || (0, $7jTnu.fg)('empanada_nin_convert_apps_to_entrypoint') ? `${vcId}-button${false ? '-ssr' : ''}` : undefined,
        ...customTriggerProps,
        ...(0, $7jTnu.fg)('empanada_nin_covnert_share_to_entrypoint') ? {
            ref: mergedRefs
        } : {}
    }, text));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $070635dd59b3e334$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o _2hwx196n",
            __cmplp.className
        ])
    });
});
const $070635dd59b3e334$var$buttonWrapperStyles = (0, $1DXK0.xcss)({
    position: 'relative'
});

});

parcelRegister("71NoK", function(module, exports) {

$parcel$export(module.exports, "default", () => $172feb23b9791a3f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $172feb23b9791a3f$var$messages = (0, $7qGN1.defineMessages)({
    exportButtonText: {
        "id": "issue-navigator-action-export-issues.export-button-text",
        "defaultMessage": "Export"
    },
    exportIssuesButtonIconLabel: {
        "id": "issue-navigator-action-export-issues.export-issues-button-icon-label",
        "defaultMessage": "Open export issues dropdown"
    },
    exportIssuesButtonIconLabelIssueTerminologyRefreshM4: {
        "id": "issue-navigator-action-export-issues.export-issues-button-icon-label-issue-terminology-refresh-m4",
        "defaultMessage": "Open export work items dropdown"
    }
});
var $172feb23b9791a3f$export$2e2bcd8739ae039 = $172feb23b9791a3f$var$messages;

});

parcelRegister("bBtWe", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hv7bx").then(()=>parcelRequire('4hiou'));

});


parcelRegister("hqg31", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b7f70980314b5ca$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aMdh8 = parcelRequire("aMdh8");

var $7ep4S = parcelRequire("7ep4S");

var $ftN6c = parcelRequire("ftN6c");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");

var $NByNW = parcelRequire("NByNW");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $8NIGX = parcelRequire("8NIGX");

var $lRq8t = parcelRequire("lRq8t");

var $bbdV2 = parcelRequire("bbdV2");

var $cBavF = parcelRequire("cBavF");

var $ciFJV = parcelRequire("ciFJV");

var $7jTnu = parcelRequire("7jTnu");

var $dyvFQ = parcelRequire("dyvFQ");

var $lHHP1 = parcelRequire("lHHP1");

var $jd93d = parcelRequire("jd93d");

var $3cJQz = parcelRequire("3cJQz");

var $cECwI = parcelRequire("cECwI");

var $6XJko = parcelRequire("6XJko");

var $gCeeo = parcelRequire("gCeeo");

var $aaLZH = parcelRequire("aaLZH");

var $iHDt0 = parcelRequire("iHDt0");

var $d3C6g = parcelRequire("d3C6g");

var $3kMpn = parcelRequire("3kMpn");

var $eVgYc = parcelRequire("eVgYc");

var $iJf9r = parcelRequire("iJf9r");

const $8b7f70980314b5ca$var$StatisticsOnboardingSpotlight = ({ children: children, shouldShowSpotlight: shouldShowSpotlight, coordinationClient: coordinationClient, onStatisticsTryNow: onStatisticsTryNow, onStatisticsOnboardingStop: onStatisticsOnboardingStop })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eVgYc.StatisticsOnboarding), {
        shouldShowSpotlight: shouldShowSpotlight,
        coordinationClient: coordinationClient,
        onStatisticsTryNow: onStatisticsTryNow,
        onStatisticsOnboardingStop: ()=>onStatisticsOnboardingStop((0, $a9fb9c3dd2da1efa$export$36bc26bb4371a2a))
    }, children);
const $8b7f70980314b5ca$export$ef4a0fdddd7eccb7 = ({ jql: jql, filterId: filterId = '', searchResultPageData: searchResultPageData, additionalMenuItems: additionalMenuItems, showEcosystemAppsInExport: showEcosystemAppsInExport, viewOptions: viewOptions, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isHideDoneSupportEnabled: isHideDoneSupportEnabled, isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled, isModifiedFilter: isModifiedFilter, isGridNavigationEnabled: isGridNavigationEnabled, isInlineFieldConfigEnabled: isInlineFieldConfigEnabled })=>{
    const { data: data, loading: loading, error: error, fetch: fetch, requestPayload: requestPayload } = (0, $iHDt0.useMeatballMenuItems)(searchResultPageData);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isNinChangeboardingEnabled = (0, $eJOHy.useContext)((0, $lHHP1.NinChangeboardingContext));
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const shouldShowOptOut = isNinChangeboardingEnabled && !isAnonymous && !(0, $7jTnu.fg)('nin_remove_opt_out');
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const lastUsedRequestPayload = (0, $eJOHy.useRef)();
    const hasPreviousError = (0, $eJOHy.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        const isMeatballMenuOpenedWithNewPayload = isOpen && JSON.stringify(requestPayload) !== JSON.stringify(lastUsedRequestPayload.current);
        if (!loading && !hasPreviousError.current && isMeatballMenuOpenedWithNewPayload) {
            fetch(requestPayload);
            lastUsedRequestPayload.current = requestPayload;
        }
        // If there was a fetch error, we clear the lastUsedRequestPayload
        if (error) {
            hasPreviousError.current = true;
            lastUsedRequestPayload.current = undefined;
        }
    }, [
        fetch,
        isOpen,
        loading,
        requestPayload,
        error
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $d3C6g.meatballMenuPopUpEntryPoint), {});
    const { shouldShowSpotlight: shouldShowSpotlight, onStatisticsOnboardingStop: onStatisticsOnboardingStop, coordinationClient: coordinationClient } = (0, $iJf9r.useStatisticsSpotlight)();
    const onStatisticsTryNow = ()=>{
        onStatisticsOnboardingStop((0, $a9fb9c3dd2da1efa$export$e328a74db0175ecc));
        entryPointActions.load();
        setIsOpen(true);
    };
    const isConditionalFormattingEnabled = (0, $7jTnu.fg)('jira_list_conditional_formatting') && // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $aaLZH.useIssueNavigatorFeatures)().isConditionalFormattingEnabled;
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            jql: jql,
            filterId: filterId,
            additionalMenuItems: additionalMenuItems,
            viewOptions: viewOptions,
            shouldShowOptOut: shouldShowOptOut,
            data: data,
            showEcosystemAppsInExport: showEcosystemAppsInExport,
            isHideDoneWorkItemsEnabled: isHideDoneSupportEnabled && isHideDoneWorkItemsEnabled && (0, $7jTnu.fg)('jsc_bulk_edit_hide_done_work_items'),
            isConditionalFormattingEnabled: isConditionalFormattingEnabled && (0, $7jTnu.fg)('jira_list_conditional_formatting'),
            isModifiedFilter: isModifiedFilter,
            isGridNavigationEnabled: isGridNavigationEnabled && (0, $7jTnu.fg)('jira_nin_navigation_onboarding'),
            isInlineFieldConfigEnabled: isInlineFieldConfigEnabled && (0, $7jTnu.fg)('jsc_project_scoped_column_config_for_csv_export')
        }), [
        jql,
        filterId,
        additionalMenuItems,
        viewOptions,
        shouldShowOptOut,
        data,
        showEcosystemAppsInExport,
        isHideDoneSupportEnabled,
        isHideDoneWorkItemsEnabled,
        isConditionalFormattingEnabled,
        isModifiedFilter,
        isGridNavigationEnabled,
        isInlineFieldConfigEnabled
    ]);
    const entryPointTriggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const [retryKey, setRetryKey] = (0, $eJOHy.useState)(0);
    const errorFallback = (onRetry)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyvFQ.ErrorState), {
            onRetry: onRetry,
            pageAction: "meatballMenu"
        });
    const { showToggleOnboarding: showToggleOnboarding } = (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3cJQz.useHierarchyOnboardingContext)() : {
        showToggleOnboarding: false
    };
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (showToggleOnboarding && isIssueHierarchySupportEnabled) {
            // We cannot access the ref of the "next" button in the onboarding spotlight.
            // Easiest workaround is to load the entrypoint here before we open the menu.
            // Once onboarding is removed, we can likely remove the entire isOpen prop from
            // the DropdownMenu component to avoid this issue in the future.
            entryPointActions.load();
            setIsOpen(true);
        }
    }, [
        showToggleOnboarding,
        entryPointActions,
        isIssueHierarchySupportEnabled
    ]);
    const { showHideDoneOnboarding: showHideDoneOnboarding } = (0, $7jTnu.fg)('jsc_list_hide_done_items') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8NIGX.useHideDoneOnboarding)({
        isHideDoneSupportEnabled: isHideDoneSupportEnabled
    }) : {
        showHideDoneOnboarding: false
    };
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (showHideDoneOnboarding && isHideDoneSupportEnabled && (0, $7jTnu.fg)('jsc_list_hide_done_items')) {
            // We cannot open the menu without loading the entrypoint.
            // Easiest workaround is to load the entrypoint here before we open the menu.
            // Once onboarding is removed, we can likely remove the entire isOpen prop from
            // the DropdownMenu component to avoid this issue in the future.
            entryPointActions.load();
            setIsOpen(true);
        }
    }, [
        entryPointActions,
        isHideDoneSupportEnabled,
        showHideDoneOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        isLoading: loading && JSON.stringify(requestPayload) === JSON.stringify(lastUsedRequestPayload.current),
        onOpenChange: (nextState)=>{
            if (nextState.isOpen) hasPreviousError.current = false;
            setIsOpen(nextState.isOpen);
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: nextState.isOpen ? 'opened' : 'closed',
                actionSubject: 'button'
            }), 'meatballMenuPopup');
        },
        isOpen: isOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>(0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b7f70980314b5ca$var$StatisticsOnboardingSpotlight, {
                shouldShowSpotlight: shouldShowSpotlight,
                onStatisticsTryNow: onStatisticsTryNow,
                onStatisticsOnboardingStop: onStatisticsOnboardingStop,
                coordinationClient: coordinationClient
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ref: (0, $jd93d.mergeRefs)(triggerRef, entryPointTriggerRef),
                ...props,
                testId: "issue-navigator-action-meatball-menu.ui.menu-trigger",
                isSelected: isOpen,
                label: formatMessage((0, $3kMpn.default).moreActionsLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($NByNW))),
                isTooltipDisabled: false
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b7f70980314b5ca$var$StatisticsOnboardingSpotlight, {
                shouldShowSpotlight: shouldShowSpotlight,
                onStatisticsTryNow: onStatisticsTryNow,
                onStatisticsOnboardingStop: onStatisticsOnboardingStop,
                coordinationClient: coordinationClient
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                testId: "issue-navigator-action-meatball-menu.ui.menu-trigger",
                spacing: "default",
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                    label: formatMessage((0, $3kMpn.default).moreActionsLabel),
                    LEGACY_size: "medium",
                    spacing: "spacious"
                }),
                ref: (0, $jd93d.mergeRefs)(triggerRef, entryPointTriggerRef)
            })),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact",
        testId: "issue-navigator-action-meatball-menu.ui.dropdown-menu",
        shouldRenderToParent: (0, $7jTnu.fg)('should-render-to-parent-should-be-true-empanada')
    }, !error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        key: retryKey,
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "popup-content",
        packageName: "jiraIssueNavigatorActionMeatballMenu",
        errorFallback: ()=>errorFallback(()=>{
                ()=>setRetryKey((prev)=>prev + 1);
            }),
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $8b7f70980314b5ca$var$spinnerContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small"
        })),
        runtimeProps: runtimeProps
    }) : errorFallback(()=>{
        fetch(requestPayload);
        lastUsedRequestPayload.current = requestPayload;
    }));
};
const $8b7f70980314b5ca$var$spinnerContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
var $8b7f70980314b5ca$export$2e2bcd8739ae039 = $8b7f70980314b5ca$export$ef4a0fdddd7eccb7;

});
parcelRegister("iHDt0", function(module, exports) {

$parcel$export(module.exports, "useMeatballMenuItems", () => $da015a7edbce1610$export$dcc369963df3381d);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $hPZg4 = parcelRequire("hPZg4");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");
const $da015a7edbce1610$export$162e19c052deab0b = '/rest/issueNav/1/issueNav/operations/tools';
const $da015a7edbce1610$export$34482912a4c2747c = (options)=>(0, $jGzN3.performPostRequest)($da015a7edbce1610$export$162e19c052deab0b, {
        credentials: 'same-origin',
        body: (0, $b5RwB.stringify)(options),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Atlassian-Token': 'no-check',
            __amdModuleName: 'jira/issue/utils/xsrf-token-header'
        }
    });
const $da015a7edbce1610$export$dcc369963df3381d = (searchResultPageData)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $hPZg4.useService)($da015a7edbce1610$export$34482912a4c2747c);
    const { offset: offset, pages: pages, total: total } = searchResultPageData;
    // Issue count here is used to show warning message in
    // bulk edit page. We show a warning message if the issue count is > 999.
    const allIssues = total > 999 ? 1000 : 999;
    const requestPayload = {
        offset: offset,
        searchResultsTotal: (0, $7jTnu.fg)('jsc_m2_hierarchy_fe_changes') ? allIssues : total,
        searchResultsPages: pages,
        // useColumns and skipColumns aren't used in the endpoint but is required for the constructor
        useColumns: false,
        skipColumns: false,
        new: true
    };
    (0, $eJOHy.useEffect)(()=>{
        if (loading) return;
        if (error) (0, $gYnSx.default)({
            error: error,
            event: createAnalyticsEvent({}),
            meta: {
                id: 'useMeatballMenuItems'
            }
        });
        else if (data) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useMeatballMenuItems succeeded', 'meatballMenu');
    }, [
        createAnalyticsEvent,
        data,
        error,
        loading
    ]);
    return {
        loading: loading,
        error: error,
        data: data,
        fetch: fetch,
        requestPayload: requestPayload
    };
};

});

parcelRegister("d3C6g", function(module, exports) {

$parcel$export(module.exports, "meatballMenuPopUpEntryPoint", () => $a008388a2916bef0$export$a544c6272b25c45e);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $a008388a2916bef0$export$a544c6272b25c45e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("fu5SQ")), {
        moduleId: "87e9200c",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fu5SQ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4FQLY").then(()=>parcelRequire('dxZWk'));

});


parcelRegister("3kMpn", function(module, exports) {

$parcel$export(module.exports, "default", () => $398b8087b6e6aa75$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $398b8087b6e6aa75$var$messages = (0, $7qGN1.defineMessages)({
    moreActionsLabel: {
        "id": "issue-navigator-action-meatball-menu.more-actions-label",
        "defaultMessage": "More actions"
    },
    actionsOptOutDisplayText: {
        "id": "issue-navigator-action-meatball-menu.actions-opt-out-display-text",
        "defaultMessage": "Go back to the old issue search"
    },
    actionsGiveFeedbackDisplayText: {
        "id": "issue-navigator-action-meatball-menu.actions-give-feedback-display-text",
        "defaultMessage": "Give feedback"
    },
    feedbackTitle: {
        "id": "issue-navigator-action-meatball-menu.feedback-title",
        "defaultMessage": "Give feedback for issue search"
    },
    feedbackTitleDetails: {
        "id": "issue-navigator-action-meatball-menu.feedback-title-details",
        "defaultMessage": "Let us know how we can improve this experience."
    },
    feedbackTitleDetailsContactSupport: {
        "id": "issue-navigator-action-meatball-menu.feedback-title-details-contact-support",
        "defaultMessage": "If you\u2019re having technical issues, contact our support team."
    },
    feedbackTypePlaceholder: {
        "id": "issue-navigator-action-meatball-menu.feedback-type-placeholder",
        "defaultMessage": "Select an option"
    },
    bulkChangeIssues: {
        "id": "issue-navigator-action-meatball-menu.bulk-change-issues",
        "defaultMessage": "Bulk change work items"
    },
    bulkChangeIssuesOldTerminology: {
        "id": "issue-navigator-action-meatball-menu.bulk-change-issues-old-terminology",
        "defaultMessage": "Bulk change issues"
    },
    viewIssuesAsAChart: {
        "id": "issue-navigator-action-meatball-menu.view-issues-as-a-chart",
        "defaultMessage": "View issues as a chart"
    },
    viewWorkItemsAsAChart: {
        "id": "issue-navigator-action-meatball-menu.view-issues-as-a-chart-issue-term-refresh",
        "defaultMessage": "View work items as a chart"
    },
    export: {
        "id": "issue-navigator-action-meatball-menu.export",
        "defaultMessage": "Export"
    },
    newLozengeLabel: {
        "id": "issue-navigator-action-meatball-menu.new-lozenge-label",
        "defaultMessage": "New"
    },
    actionsOptOutDisplayTextIssueTerminologyRefreshM4: {
        "id": "issue-navigator-action-meatball-menu.actions-opt-out-display-text-issue-terminology-refresh-m4",
        "defaultMessage": "Go back to the old search"
    },
    feedbackTitleIssueTerminologyRefreshM4: {
        "id": "issue-navigator-action-meatball-menu.feedback-title-issue-terminology-refresh-m4",
        "defaultMessage": "Give feedback for the search"
    },
    formatRules: {
        "id": "issue-navigator-action-meatball-menu.formatRules",
        "defaultMessage": "Format rules"
    },
    keyboardNavigation: {
        "id": "issue-navigator-action-meatball-menu.keyboard-navigation",
        "defaultMessage": "Keyboard navigation"
    }
});
var $398b8087b6e6aa75$export$2e2bcd8739ae039 = $398b8087b6e6aa75$var$messages;

});

parcelRegister("eVgYc", function(module, exports) {

$parcel$export(module.exports, "StatisticsOnboarding", () => $893409cbddc2af78$export$d628ca45cec6f862);

var $eJOHy = parcelRequire("eJOHy");

var $fBe2p = parcelRequire("fBe2p");
var $guChT = parcelRequire("guChT");
var $d2s5v = parcelRequire("d2s5v");

var $58yRG = parcelRequire("58yRG");

var $3CprG = parcelRequire("3CprG");

var $kwVIr = parcelRequire("kwVIr");

var $hJw7S = parcelRequire("hJw7S");

var $lRq8t = parcelRequire("lRq8t");

var $9HHOs = parcelRequire("9HHOs");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $4stTh = parcelRequire("4stTh");

const $893409cbddc2af78$export$d628ca45cec6f862 = ({ shouldShowSpotlight: shouldShowSpotlight, coordinationClient: coordinationClient, onStatisticsTryNow: onStatisticsTryNow, onStatisticsOnboardingStop: onStatisticsOnboardingStop, children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    if (!shouldShowSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CprG.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: "nin-meatball-button-statistics-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fBe2p.Pulse), {
        radius: 3,
        pulse: shouldShowSpotlight
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        heading: formatMessage((0, $4stTh.default).getWorkInsights),
        messageId: (0, $7jTnu.fg)('helios_nin_statistics_onboarding_spotlight') ? (0, $a9fb9c3dd2da1efa$export$e57f07f68ad825f4) : (0, $a9fb9c3dd2da1efa$export$60f0ae43d6be43f1),
        image: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($hJw7S))) : (0, (/*@__PURE__*/$parcel$interopDefault($kwVIr))),
        key: "nin-meatball-button-statistics-spotlight",
        actions: [
            {
                onClick: onStatisticsTryNow,
                text: formatMessage((0, $4stTh.default).tryItOut)
            },
            {
                onClick: onStatisticsOnboardingStop,
                text: formatMessage((0, $4stTh.default).dismiss)
            }
        ],
        targetRadius: 3,
        targetBgColor: "var(--ds-background-discovery, #F3F0FF)",
        target: "nin-meatball-button-statistics-spotlight",
        messageType: "engagement",
        dialogPlacement: "bottom right"
    }, (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? formatMessage((0, $4stTh.default).onboardingStatisticsDescriptionIssueTermRefresh) : formatMessage((0, $4stTh.default).onboardingStatisticsDescription))));
};

});
parcelRegister("kwVIr", function(module, exports) {
module.exports = new URL("issue-view-statistics-onboarding.3f045443.gif", import.meta.url).toString();

});

parcelRegister("hJw7S", function(module, exports) {
module.exports = new URL("issue-view-statistics-onboarding-dark-mode.18820f06.gif", import.meta.url).toString();

});

parcelRegister("4stTh", function(module, exports) {

$parcel$export(module.exports, "default", () => $11d534166ca1c173$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $11d534166ca1c173$var$messages = (0, $7qGN1.defineMessages)({
    onboardingStatisticsDescription: {
        "id": "issue-navigator-action-meatball-menu.onboarding-statistics-description",
        "defaultMessage": "You can now create charts from filtered issues for quick and useful insights."
    },
    onboardingStatisticsDescriptionIssueTermRefresh: {
        "id": "issue-navigator-action-meatball-menu.onboarding-statistics-description-issue-term-refresh",
        "defaultMessage": "You can now create charts from filtered work items for quick and useful insights."
    },
    tryItOut: {
        "id": "issue-navigator-action-meatball-menu.try-it-out",
        "defaultMessage": "Try it out"
    },
    dismiss: {
        "id": "issue-navigator-action-meatball-menu.dismiss",
        "defaultMessage": "Dismiss"
    },
    getWorkInsights: {
        "id": "issue-navigator-action-meatball-menu.get-work-insights",
        "defaultMessage": "Get work insights"
    }
});
var $11d534166ca1c173$export$2e2bcd8739ae039 = $11d534166ca1c173$var$messages;

});

const $a9fb9c3dd2da1efa$export$c7e6a6b283196232 = '/gateway/api';
const $a9fb9c3dd2da1efa$export$60f0ae43d6be43f1 = 'jira-nin-statistics-onboarding-spotlight';
const $a9fb9c3dd2da1efa$export$e57f07f68ad825f4 = 'jira_helios_nin_statistics_onboarding';
const $a9fb9c3dd2da1efa$export$e328a74db0175ecc = 'jiraNinStatisticsOnboardingTryItOut';
const $a9fb9c3dd2da1efa$export$36bc26bb4371a2a = 'jiraNinStatisticsOnboardingDismiss';
const $a9fb9c3dd2da1efa$export$db1926f449c86467 = 'jiraNinStatisticsOnboardingSpotlight';


parcelRegister("iJf9r", function(module, exports) {

$parcel$export(module.exports, "useStatisticsSpotlight", () => $ae90a3ffa5b02d19$export$e4f5ca4f8dca0290);

var $eJOHy = parcelRequire("eJOHy");

var $7UDun = parcelRequire("7UDun");

var $9zZj0 = parcelRequire("9zZj0");

var $kEUB1 = parcelRequire("kEUB1");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

const $ae90a3ffa5b02d19$export$e4f5ca4f8dca0290 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const [showPulse, setShowPulse] = (0, $eJOHy.useState)(false);
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, (0, $a9fb9c3dd2da1efa$export$c7e6a6b283196232), false, '', 'engagement'), [
        cloudId
    ]);
    const [isMessageActive, stopMessage] = (0, $7UDun.useCoordination)(coordinationClient, (0, $7jTnu.fg)('helios_nin_statistics_onboarding_spotlight') ? (0, $a9fb9c3dd2da1efa$export$e57f07f68ad825f4) : (0, $a9fb9c3dd2da1efa$export$60f0ae43d6be43f1));
    (0, $eJOHy.useEffect)(()=>{
        if (isMessageActive) {
            setShowPulse(true);
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'spotlight'
            }), (0, $a9fb9c3dd2da1efa$export$db1926f449c86467));
        }
    }, [
        coordinationClient,
        createAnalyticsEvent,
        isMessageActive
    ]);
    const onStatisticsOnboardingStop = (0, $eJOHy.useCallback)((actionSubject)=>{
        stopMessage();
        setShowPulse(false);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: `${actionSubject} button`
        }));
    }, [
        stopMessage,
        createAnalyticsEvent
    ]);
    return {
        shouldShowSpotlight: showPulse,
        onStatisticsOnboardingStop: onStatisticsOnboardingStop,
        coordinationClient: coordinationClient
    };
};

});


const $a0674c45e0861e1c$export$8a0f2e68464a820f = 'bulk_create_dd_link';
const $a0674c45e0861e1c$export$efad93080758a558 = 'bulkedit_curr_pg';
const $a0674c45e0861e1c$export$66cb530046350ea5 = 'bulkedit_all';
const $a0674c45e0861e1c$export$df7b2838a6fc207e = 'gin-meatball-menu-clear-sorts';
const $a0674c45e0861e1c$export$e389676e8d50a810 = 'opt-out-feedback';
const $a0674c45e0861e1c$export$c1dcd93cb65a1cc5 = 'connect-app';
const $a0674c45e0861e1c$export$3c1bb52064935485 = 'give-feedback';
const $a0674c45e0861e1c$export$a7a312131aa962e0 = 'go-to-all-issues';
const $a0674c45e0861e1c$export$72cbdf7971462ebd = 'hierarchy-toggle';
const $a0674c45e0861e1c$export$6e37bc383199950c = 'hide-done-toggle';
const $a0674c45e0861e1c$export$5fba477f4490fb8 = 'view-issues-as-a-chart';
const $a0674c45e0861e1c$export$ca7970ebc7c680b2 = 'conditional-formatting';
const $a0674c45e0861e1c$export$d544dff0deb6c9b0 = 'export-issues';
const $a0674c45e0861e1c$export$f95c3bbe4abbef8 = 'keyboard-navigation';

parcelRegister("iCNcB", function(module, exports) {

$parcel$export(module.exports, "default", () => $951529af43e759ab$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $KDB2z = parcelRequire("KDB2z");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $cECwI = parcelRequire("cECwI");

var $6XJko = parcelRequire("6XJko");

var $gCY1z = parcelRequire("gCY1z");

var $lR5Ef = parcelRequire("lR5Ef");
const $951529af43e759ab$var$QuickFiltersDropdown = ({ isOpen: isOpen = false, onChangeFilter: onChangeFilter })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const urlPrefix = match.url.endsWith('/') ? `${match.url}?filter=` : `${match.url}/?filter=`;
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnOpenChange = (0, $eJOHy.useCallback)(({ isOpen: newIsOpen })=>{
        if (newIsOpen) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        }), 'issueNavigatorQuickFiltersDropdown');
        else (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'dropdown'
        }), 'issueNavigatorQuickFiltersDropdown');
    }, [
        createAnalyticsEvent
    ]);
    const handleOnClick = (0, $eJOHy.useCallback)((filter)=>(e)=>{
            if (onChangeFilter && (0, $7jTnu.fg)('jira_nin_smart_link')) {
                onChangeFilter(filter);
                e.preventDefault();
            }
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'filter',
                action: 'selected'
            }), 'issueNavigatorQuickFiltersDropdown', {
                filter: filter
            });
        }, [
        createAnalyticsEvent,
        onChangeFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: (0, $6XJko.isVisualRefreshEnabled)() ? ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($KDB2z))),
                label: formatMessage((0, $lR5Ef.default).quickFilterDropdownTrigger),
                ref: triggerRef,
                isTooltipDisabled: false
            }) : formatMessage((0, $lR5Ef.default).quickFilterDropdownTrigger),
        shouldRenderToParent: true,
        defaultOpen: isOpen,
        testId: "issue-navigator-action-quick-filters",
        onOpenChange: handleOnOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: `${urlPrefix}myopenissues`,
        onClick: handleOnClick('myopenissues')
    }, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $lR5Ef.default).myOpenIssuesIssueTermRefresh : (0, $lR5Ef.default).myOpenIssues)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: `${urlPrefix}reportedbyme`,
        onClick: handleOnClick('reportedbyme')
    }, formatMessage((0, $lR5Ef.default).reportedByMe)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: `${urlPrefix}allopenissues`,
        onClick: handleOnClick('allopenissues')
    }, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $lR5Ef.default).openIssuesIssueTermRefresh : (0, $lR5Ef.default).openIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: `${urlPrefix}doneissues`,
        onClick: handleOnClick('doneissues')
    }, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $lR5Ef.default).doneIssuesIssueTermRefresh : (0, $lR5Ef.default).doneIssues)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: `${urlPrefix}recentlyviewed`,
        onClick: handleOnClick('recentlyviewed')
    }, formatMessage((0, $lR5Ef.default).viewedRecently)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: `${urlPrefix}resolvedrecently`,
        onClick: handleOnClick('resolvedrecently')
    }, formatMessage((0, $lR5Ef.default).resolvedRecently)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: `${urlPrefix}updatedrecently`,
        onClick: handleOnClick('updatedrecently')
    }, formatMessage((0, $lR5Ef.default).updatedRecently))));
};
var $951529af43e759ab$export$2e2bcd8739ae039 = $951529af43e759ab$var$QuickFiltersDropdown;

});
parcelRegister("lR5Ef", function(module, exports) {

$parcel$export(module.exports, "default", () => $7183a7bee28dabf3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7183a7bee28dabf3$var$messages = (0, $7qGN1.defineMessages)({
    quickFilterDropdownTrigger: {
        "id": "issue-navigator-action-quick-filters.quick-filter-dropdown-trigger",
        "defaultMessage": "Quick filters"
    },
    myOpenIssues: {
        "id": "issue-navigator-action-quick-filters.my-open-issues",
        "defaultMessage": "My open issues"
    },
    myOpenIssuesIssueTermRefresh: {
        "id": "issue-navigator-action-quick-filters.my-open-issues-issue-term-refresh",
        "defaultMessage": "My open work items"
    },
    reportedByMe: {
        "id": "issue-navigator-action-quick-filters.reported-by-me",
        "defaultMessage": "Reported by me"
    },
    openIssues: {
        "id": "issue-navigator-action-quick-filters.open-issues",
        "defaultMessage": "Open issues"
    },
    openIssuesIssueTermRefresh: {
        "id": "issue-navigator-action-quick-filters.open-issues-issue-term-refresh",
        "defaultMessage": "Open work items"
    },
    doneIssues: {
        "id": "issue-navigator-action-quick-filters.done-issues",
        "defaultMessage": "Done issues"
    },
    doneIssuesIssueTermRefresh: {
        "id": "issue-navigator-action-quick-filters.done-issues-issue-term-refresh",
        "defaultMessage": "Done work items"
    },
    viewedRecently: {
        "id": "issue-navigator-action-quick-filters.viewed-recently",
        "defaultMessage": "Viewed recently"
    },
    createdRecently: {
        "id": "issue-navigator-action-quick-filters.created-recently",
        "defaultMessage": "Created recently"
    },
    resolvedRecently: {
        "id": "issue-navigator-action-quick-filters.resolved-recently",
        "defaultMessage": "Resolved recently"
    },
    updatedRecently: {
        "id": "issue-navigator-action-quick-filters.updated-recently",
        "defaultMessage": "Updated recently"
    }
});
var $7183a7bee28dabf3$export$2e2bcd8739ae039 = $7183a7bee28dabf3$var$messages;

});


parcelRegister("2YvCN", function(module, exports) {

$parcel$export(module.exports, "ShareButton", () => $6f8153cc882b3418$export$e980dfbc2840e8bc);

var $eJOHy = parcelRequire("eJOHy");

var $8QoO2 = parcelRequire("8QoO2");

var $3IF6p = parcelRequire("3IF6p");

var $lRq8t = parcelRequire("lRq8t");

var $2k6Pt = parcelRequire("2k6Pt");

var $82cqT = parcelRequire("82cqT");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $figsJ = parcelRequire("figsJ");

var $dF958 = parcelRequire("dF958");

var $7jTnu = parcelRequire("7jTnu");

var $2Nm85 = parcelRequire("2Nm85");

var $aBKRG = parcelRequire("aBKRG");

var $ez3Jz = parcelRequire("ez3Jz");

var $cngM5 = parcelRequire("cngM5");


const $6f8153cc882b3418$var$JiraShareButton = (parcelRequire("csC3K")).default;
const $6f8153cc882b3418$var$getShareLink = (param, value)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { hostname: hostname, protocol: protocol } = window.location;
    return `${protocol}//${hostname}/issues/?${param}=${encodeURIComponent(value)}`;
};
const $6f8153cc882b3418$var$CustomTriggerButton = ({ isDisabled: isDisabled, isSelected: isSelected, onClick: onClick }, triggerProps)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const buttonRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onKeyboardShortcutClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'pressed',
            actionSubject: 'keyboardShortcut'
        }), 'shareSearchCriteriaModalKeyboardShortcut', {
            keyPressed: 's',
            keyboardShortcut: true
        });
        if ((0, $7jTnu.fg)('empanada_nin_covnert_share_to_entrypoint')) // Simulate a real button click because the Entrypoint doesn't use an onClick callback
        buttonRef.current?.click();
        else onClick();
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const shortcutsKeyMap = (0, $eJOHy.useMemo)(()=>({
            s: {
                callback: onKeyboardShortcutClick,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, formatMessage((0, $cngM5.messages).shareKeyboardShortcut))
            }
        }), [
        formatMessage,
        onKeyboardShortcutClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3IF6p.default), {
        keyMap: shortcutsKeyMap
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2k6Pt.FilterButton), {
        ref: buttonRef,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        label: "",
        text: formatMessage((0, $cngM5.messages).share),
        customTriggerProps: {
            ...triggerProps,
            'aria-haspopup': false
        },
        vcId: "share-button"
    }));
};
const $6f8153cc882b3418$var$addContextToEvent = (event)=>{
    const attributes = event.context.map((context)=>context.attributes);
    event.update((payload)=>({
            ...payload,
            attributes: Object.assign(event.payload.attributes || {}, ...attributes)
        }));
};
const $6f8153cc882b3418$export$e980dfbc2840e8bc = ({ jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const subProduct = (0, $figsJ.useSubProduct)();
    const [shouldShowThirdPartyNudge, setShouldShowThirdPartyNudge] = (0, $eJOHy.useState)(false);
    const showFilterShareLinkNew = filterId !== undefined && (0, $82cqT.isCustomFilter)(filterId) && !isModifiedFilter;
    // share custom filters by ID if the JQL is not overridden, otherwise just share the JQL
    const additionalProps = showFilterShareLinkNew ? {
        integrationType: (0, $2Nm85.INTEGRATION_TYPES).FILTER,
        shareContentType: (0, $2Nm85.INTEGRATION_TYPES).FILTER,
        shareLink: $6f8153cc882b3418$var$getShareLink('filter', filterId),
        shareTitle: formatMessage((0, $cngM5.messages).filter),
        shareFormTitle: formatMessage((0, $cngM5.messages).dialogTitleFilter)
    } : {
        integrationType: (0, $2Nm85.INTEGRATION_TYPES).SEARCH,
        shareContentType: (0, $2Nm85.INTEGRATION_TYPES).SEARCH,
        shareLink: $6f8153cc882b3418$var$getShareLink('jql', jql),
        shareTitle: formatMessage((0, $cngM5.messages).search),
        shareFormTitle: formatMessage((0, $cngM5.messages).dialogTitleSearch)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8QoO2.default), {
        channel: "*",
        onEvent: $6f8153cc882b3418$var$addContextToEvent
    }, shouldShowThirdPartyNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dF958.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6f8153cc882b3418$var$JiraShareButton, {
        teamName: "empanada",
        errorBoundaryId: "issue-navigator-action-share",
        triggerButtonStyle: "icon-with-text",
        productId: "jira",
        subProductId: (0, $ez3Jz.getShareSubProductId)(subProduct),
        objectAri: "" // The legacy sharing API does not use ARIs
        ,
        legacyShareClientConfig: (0, $aBKRG.shareSearchClientConfig),
        renderCustomTriggerButton: $6f8153cc882b3418$var$CustomTriggerButton,
        onTriggerButtonClick: ()=>{
            setShouldShowThirdPartyNudge(true);
        },
        ...(0, $7jTnu.fg)('empanada_nin_covnert_share_to_entrypoint') ? {
            dialogPlacement: 'bottom-end'
        } : {},
        ...additionalProps
    }));
};

});
parcelRegister("2Nm85", function(module, exports) {

$parcel$export(module.exports, "INTEGRATION_TYPES", () => $b13d0c2cb4f7058b$export$195813ac8b6ae6f9);
const $b13d0c2cb4f7058b$export$195813ac8b6ae6f9 = {
    FILTER: 'filter',
    SEARCH: 'search'
};

});

parcelRegister("aBKRG", function(module, exports) {

$parcel$export(module.exports, "shareSearchClientConfig", () => $8077901cb86ef8a6$export$14295897acb58714);

var $2Nm85 = parcelRequire("2Nm85");
const $8077901cb86ef8a6$export$14295897acb58714 = {
    getShareEndpoint: ({ link: link, type: type })=>type === (0, $2Nm85.INTEGRATION_TYPES).FILTER ? `/rest/share/1.0/filter/${new URL(link).searchParams.get('filter') || ''}` : '/rest/share/1.0/search',
    getSharePayload: ({ link: link, type: type })=>{
        const jql = new URL(link).searchParams.get('jql');
        return type === (0, $2Nm85.INTEGRATION_TYPES).SEARCH && jql !== null ? {
            jql: jql
        } : {};
    }
};

});

parcelRegister("ez3Jz", function(module, exports) {

$parcel$export(module.exports, "getShareSubProductId", () => $a7190c029c2ea334$export$4a20278dd1d015dd);
const $a7190c029c2ea334$var$subProductMap = {
    addon: 'jira-addon',
    core: 'jira-core',
    polaris: 'jira-polaris',
    portfolio: 'jira-portfolio',
    serviceDesk: 'jira-servicedesk',
    software: 'jira-software',
    platform: 'jira-platform',
    unknown: 'jira-unknown'
};
const $a7190c029c2ea334$export$4a20278dd1d015dd = (subProduct)=>subProduct && $a7190c029c2ea334$var$subProductMap[subProduct] || 'jira-platform';

});

parcelRegister("cngM5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d7bd7d1a0cfdd8ab$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d7bd7d1a0cfdd8ab$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    dialogTitleFilter: {
        "id": "issue-navigator-action-share-button.dialog-title-filter",
        "defaultMessage": "Share current filter"
    },
    dialogTitleSearch: {
        "id": "issue-navigator-action-share-button.dialog-title-search",
        "defaultMessage": "Share search criteria"
    },
    filter: {
        "id": "issue-navigator-action-share-button.filter",
        "defaultMessage": "Filter"
    },
    search: {
        "id": "issue-navigator-action-share-button.search",
        "defaultMessage": "Search"
    },
    share: {
        "id": "issue-navigator-action-share-button.share",
        "defaultMessage": "Share"
    },
    shareKeyboardShortcut: {
        "id": "issue-navigator-action-share-button.share-keyboard-shortcut",
        "defaultMessage": "Open share modal"
    }
});

});

parcelRegister("csC3K", function(module, exports) {

module.exports = (parcelRequire("g81qY"))('empanada_nin_covnert_share_to_entrypoint', function() {
    return parcelRequire('kk78e');
}, function() {
    return parcelRequire('la2MJ');
});

});


parcelRegister("hOebY", function(module, exports) {

$parcel$export(module.exports, "FilterIconButton", () => $321f0f715ecfa0ae$export$2c752f0ff253a7e6);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $321f0f715ecfa0ae$export$2c752f0ff253a7e6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isSelected: isSelected, onClick: onClick, testId: testId, isDisabled: isDisabled, icon: icon, label: label, customTriggerProps: customTriggerProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $321f0f715ecfa0ae$var$iconButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        isDisabled: isDisabled,
        icon: icon,
        label: label,
        ...customTriggerProps
    })));
const $321f0f715ecfa0ae$var$iconButtonWrapperStyles = (0, $1DXK0.xcss)({
    position: 'relative'
});

});

parcelRegister("6fNuu", function(module, exports) {

$parcel$export(module.exports, "default", () => $05b34bd9feb8ad95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $cRAIo = parcelRequire("cRAIo");

var $eIIrM = parcelRequire("eIIrM");

var $9S9DZ = parcelRequire("9S9DZ");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $1OKaP = parcelRequire("1OKaP");

var $k71qx = parcelRequire("k71qx");

var $3IF6p = parcelRequire("3IF6p");

var $epTsa = parcelRequire("epTsa");

var $dTocu = parcelRequire("dTocu");

var $82cqT = parcelRequire("82cqT");

var $lHHP1 = parcelRequire("lHHP1");

var $6sTi7 = parcelRequire("6sTi7");

var $fNOMn = parcelRequire("fNOMn");

var $437hw = parcelRequire("437hw");

var $6zXPf = parcelRequire("6zXPf");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $ljej9 = parcelRequire("ljej9");

var $dQ4Ik = parcelRequire("dQ4Ik");

var $6XJko = parcelRequire("6XJko");

var $iRahl = parcelRequire("iRahl");

var $eibCx = parcelRequire("eibCx");

var $fAgUF = parcelRequire("fAgUF");

var $1wL9i = parcelRequire("1wL9i");

var $HiS1C = parcelRequire("HiS1C");

var $gApH5 = parcelRequire("gApH5");
const $05b34bd9feb8ad95$var$KeyboardShortcuts = ({ view: view, onToggle: onToggle, intl: { formatMessage: formatMessage } })=>{
    const isDetailView = view === (0, $iRahl.views).detail;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3IF6p.default), {
        keyMap: {
            t: {
                callback: ()=>{
                    const newView = isDetailView ? (0, $iRahl.views).list : (0, $iRahl.views).detail;
                    onToggle(newView, true);
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage(isDetailView ? (0, $gApH5.default).listText : (0, $gApH5.default).detailText))
            }
        }
    });
};
const $05b34bd9feb8ad95$export$c774a1845e27fedc = ({ view: view, onToggle: onToggle, intl: intl })=>{
    const { formatMessage: formatMessage } = intl;
    const testIdPrefix = 'issue-navigator.ui.refinement-bar.view-switcher.toggle-button.';
    let listLabel = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($05b34bd9feb8ad95$var$IconLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            size: "UNSAFE_small",
            weight: "semibold"
        }, formatMessage((0, $gApH5.default).listOptionLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cRAIo))), {
            label: "",
            LEGACY_size: "small"
        })), [
        formatMessage
    ]);
    let detailLabel = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($05b34bd9feb8ad95$var$IconLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            size: "UNSAFE_small",
            weight: "semibold"
        }, formatMessage((0, $gApH5.default).detailOptionLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eIIrM))), {
            label: "",
            LEGACY_size: "small"
        })), [
        formatMessage
    ]);
    if ((0, $6zXPf.getWillShowNav4)()) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        listLabel = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                size: "UNSAFE_small",
                weight: "semibold"
            }, formatMessage((0, $gApH5.default).listOptionLabel)), [
            formatMessage
        ]); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        detailLabel = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                size: "UNSAFE_small",
                weight: "semibold"
            }, formatMessage((0, $gApH5.default).detailOptionLabel)), [
            formatMessage
        ]);
    }
    if ((0, $6XJko.isVisualRefreshEnabled)()) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        listLabel = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: formatMessage((0, $gApH5.default).listOptionLabel)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                paddingInline: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OKaP))), {
                label: formatMessage((0, $gApH5.default).listOptionLabel)
            }))), [
            formatMessage
        ]); // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        detailLabel = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: formatMessage((0, $gApH5.default).detailOptionLabel)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                paddingInline: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9S9DZ))), {
                label: formatMessage((0, $gApH5.default).detailOptionLabel)
            }))), [
            formatMessage
        ]);
    }
    const options = (0, $eJOHy.useMemo)(()=>[
            {
                id: (0, $iRahl.views).list,
                label: listLabel,
                testId: `${testIdPrefix}${(0, $iRahl.views).list}`
            },
            {
                id: (0, $iRahl.views).detail,
                label: detailLabel,
                testId: `${testIdPrefix}${(0, $iRahl.views).detail}`
            }
        ], [
        listLabel,
        detailLabel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($05b34bd9feb8ad95$var$KeyboardShortcuts, {
        view: view,
        onToggle: onToggle,
        intl: intl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dQ4Ik.default), {
        label: formatMessage((0, $gApH5.default).toggleButtonsLabel),
        isCompact: (0, $6XJko.isVisualRefreshEnabled)(),
        options: options,
        selectedOption: view,
        onChange: (newView)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onToggle(newView, false);
        }
    }));
};
$05b34bd9feb8ad95$export$c774a1845e27fedc.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $05b34bd9feb8ad95$export$3f624639bbe23442 = ({ filterId: filterId })=>{
    (0, $fAgUF.markOnce)((0, $fAgUF.marks).PAGE_ACTIONS_VIEW_SWITCHER_START);
    (0, $eJOHy.useLayoutEffect)(()=>{
        (0, $fAgUF.markOnce)((0, $fAgUF.marks).PAGE_ACTIONS_VIEW_SWITCHER_END);
    }, []);
    const selectedIssueKey = (0, $1wL9i.useSelectedIssueKey)();
    const [{ view: view }, { setView: setView }] = (0, $HiS1C.useSelectedViewState)();
    const intl = (0, $dTocu.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnToggle = (0, $eJOHy.useCallback)((newView, isKeyboardShortcut)=>{
        // When toggling to detail view we want to update the issue key in the URL to match the currently selected
        // issue. When toggling to list view we want to discard the issue key from the URL.
        const newIssueKey = newView === (0, $iRahl.views).detail ? selectedIssueKey : (0, $ljej9.toIssueKey)('');
        let resolvedNewView = (0, $eibCx.convertToIssueNavigatorId)(newView);
        if (newView === (0, $iRahl.views).list && filterId && (0, $82cqT.isCustomFilter)(filterId)) resolvedNewView = (0, $eibCx.convertFilterIdToIssueNavigatorId)(filterId);
        setView(resolvedNewView, newIssueKey);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'switchIssueNavigatorView', {
            keyboardShortcut: isKeyboardShortcut,
            switchToView: newView
        });
        return true;
    }, [
        selectedIssueKey,
        filterId,
        setView,
        createAnalyticsEvent
    ]);
    const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourTarget), {
        engagementId: "nin.view-switcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($05b34bd9feb8ad95$export$c774a1845e27fedc, {
        view: (0, $eibCx.convertToView)(view),
        onToggle: handleOnToggle,
        intl: intl
    }));
    const renderSpotlightCard = ({ onEndTour: onEndTour, onSetActiveCard: onSetActiveCard })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fNOMn.default), {
            cardKey: (0, $6sTi7.cardKeys).GLOBAL_SCOPE_VIEW_SWITCHER,
            dialogWidth: 272,
            dialogPlacement: "bottom right",
            actions: view === 'detail' ? [
                {
                    onClick: ()=>{
                        onEndTour();
                    },
                    text: intl.formatMessage((0, $gApH5.default).done)
                }
            ] : [
                {
                    onClick: ()=>{
                        onSetActiveCard((0, $6sTi7.cardKeys).GLOBAL_SCOPE_COLUMN_PICKER);
                    },
                    text: intl.formatMessage((0, $gApH5.default).next)
                },
                {
                    appearance: 'subtle',
                    onClick: ()=>{
                        onEndTour();
                    },
                    text: intl.formatMessage((0, $gApH5.default).skip)
                }
            ],
            heading: intl.formatMessage((0, $gApH5.default).tourHeading),
            target: "nin.spotlight.view-switcher",
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            targetRadius: 3,
            messageId: "issue-navigator.ui.view-switcher.spotlight-tour-card.nin.spotlight.view-switcher.spotlight",
            messageType: "transactional"
        }, intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gApH5.default).tourBodyIssueTermRefresh : (0, $gApH5.default).tourBody));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $437hw.default), {
        name: "nin.spotlight.view-switcher",
        renderSpotlightCard: renderSpotlightCard
    }, children);
};
var $05b34bd9feb8ad95$export$2e2bcd8739ae039 // clean up this styled element with getWillShowNav4
 = $05b34bd9feb8ad95$export$3f624639bbe23442;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $05b34bd9feb8ad95$var$IconLabel = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            (0, $6XJko.isVisualRefreshEnabled)() ? "_zulp1b66" : "_10cu1b66 _2t30idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eIIrM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::514cbdd1fb828ca052784fd79788c51d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab77a706171fa497$var$_react = $ab77a706171fa497$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ab77a706171fa497$var$_panelRight = $ab77a706171fa497$var$_interopRequireDefault((parcelRequire("f4WMd")));

var $ab77a706171fa497$var$_detailView = $ab77a706171fa497$var$_interopRequireDefault((parcelRequire("H5mkF")));
function $ab77a706171fa497$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PanelRightIcon.
 * This component is PanelRightIcon, with `UNSAFE_fallbackIcon` set to "DetailViewIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab77a706171fa497$var$PanelRightIcon = (props)=>/*#__PURE__*/ $ab77a706171fa497$var$_react.default.createElement($ab77a706171fa497$var$_panelRight.default, Object.assign({
        name: "PanelRightIcon",
        LEGACY_fallbackIcon: $ab77a706171fa497$var$_detailView.default
    }, props));
$ab77a706171fa497$var$PanelRightIcon.displayName = 'PanelRightIconMigration';
var $ab77a706171fa497$var$_default = module.exports.default = $ab77a706171fa497$var$PanelRightIcon;

});
parcelRegister("f4WMd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::24c85da433a7def76f682c2e482c8374>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afa4d2955554e918$var$_react = $afa4d2955554e918$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $afa4d2955554e918$var$_baseNew = $afa4d2955554e918$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $afa4d2955554e918$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PanelRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afa4d2955554e918$var$PanelRightIcon = (props)=>/*#__PURE__*/ $afa4d2955554e918$var$_react.default.createElement($afa4d2955554e918$var$_baseNew.default, Object.assign({
        name: "PanelRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.5-.5H9.5v11H14a.5.5 0 0 0 .5-.5zM13 10v1.5h-2V10zm0-3v1.5h-2V7zm0-3v1.5h-2V4zM1.5 13a.5.5 0 0 0 .5.5h6v-11H2a.5.5 0 0 0-.5.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$afa4d2955554e918$var$PanelRightIcon.displayName = 'PanelRightIcon';
var $afa4d2955554e918$var$_default = module.exports.default = $afa4d2955554e918$var$PanelRightIcon;

});

parcelRegister("H5mkF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08182c7e1ed0b465$var$_react = $08182c7e1ed0b465$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $08182c7e1ed0b465$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $08182c7e1ed0b465$var$DetailViewIcon = (props)=>/*#__PURE__*/ $08182c7e1ed0b465$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14 17h6V7.01C20 7 14 7 14 7zM12 5h8c1.11 0 2 .9 2 2.01V17a2 2 0 0 1-2 2h-8zM2 7h8V5H3a1 1 0 0 0-1 1zm0 4h8V9H2zm0 7c0 .55.45 1 1 1h7v-2H2zm0-3h8v-2H2z"/></svg>`
    }, props));
$08182c7e1ed0b465$var$DetailViewIcon.displayName = 'DetailViewIcon';
var $08182c7e1ed0b465$var$_default = module.exports.default = $08182c7e1ed0b465$var$DetailViewIcon;

});


parcelRegister("9S9DZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4628d836a2702117fd4aa5f1325a9af2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7300a347552361ca$var$_react = $7300a347552361ca$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7300a347552361ca$var$_baseNew = $7300a347552361ca$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7300a347552361ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumnsSidebarLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7300a347552361ca$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>/*#__PURE__*/ $7300a347552361ca$var$_react.default.createElement($7300a347552361ca$var$_baseNew.default, Object.assign({
        name: "LayoutTwoColumnsSidebarLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-7.75C6.115 1 5.5 1.616 5.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h7.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11H7v-11zM4 2.375C4 1.615 3.384 1 2.625 1h-1.25C.615 1 0 1.616 0 2.375v11.25C0 14.385.616 15 1.375 15h1.25C3.385 15 4 14.384 4 13.625zM2.5 2.5v11h-1v-11z" clip-rule="evenodd"/>`
    }, props));
$7300a347552361ca$var$LayoutTwoColumnsSidebarLeftIcon.displayName = 'LayoutTwoColumnsSidebarLeftIcon';
var $7300a347552361ca$var$_default = module.exports.default = $7300a347552361ca$var$LayoutTwoColumnsSidebarLeftIcon;

});

parcelRegister("1OKaP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::039ea8d33e9a1538394bd0f26af6a9f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $152e470ea615d0eb$var$_react = $152e470ea615d0eb$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $152e470ea615d0eb$var$_baseNew = $152e470ea615d0eb$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $152e470ea615d0eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Table".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for tables, tabular data, and spreadsheets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $152e470ea615d0eb$var$TableIcon = (props)=>/*#__PURE__*/ $152e470ea615d0eb$var$_react.default.createElement($152e470ea615d0eb$var$_baseNew.default, Object.assign({
        name: "TableIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8.75h-8v3.75H14a.5.5 0 0 0 .5-.5zM1.5 12a.5.5 0 0 0 .5.5h3V8.75H1.5zm13-8a.5.5 0 0 0-.5-.5H6.5v3.75h8zm-13 3.25H5V3.5H2a.5.5 0 0 0-.5.5zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$152e470ea615d0eb$var$TableIcon.displayName = 'TableIcon';
var $152e470ea615d0eb$var$_default = module.exports.default = $152e470ea615d0eb$var$TableIcon;

});

parcelRegister("6sTi7", function(module, exports) {

$parcel$export(module.exports, "cardKeys", () => $fe025dbff69a9482$export$79399c5778983d77);
/**
 * Collection of keys representing individual spotlight cards displayed within the issue navigator.
 */ const $fe025dbff69a9482$export$79399c5778983d77 = {
    GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL: 'global-scope.jql-builder-with-ai.natural-language-to-jql',
    GLOBAL_SCOPE_VIEW_SWITCHER: 'global-scope.view-switcher',
    GLOBAL_SCOPE_COLUMN_PICKER: 'global-scope.column-picker',
    JQL_BUILDER_NL_TOGGLE: 'jql-builder-with-ai.natural-language-toggle',
    JQL_BUILDER_NL_TO_JQL: 'jql-builder-with-ai.natural-language-to-jql'
};

});

parcelRegister("fNOMn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b9bd65aec627275$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5b9bd65aec627275$var$SpotlightTourCardAsync = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("aOhkZ")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/ui/spotlight-tour-card/main.tsx"
});
const $5b9bd65aec627275$var$SpotlightTourCard = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-issue-navigator-changeboarding-spotlight-tour-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-issue-navigator-changeboarding-spotlight-tour-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5b9bd65aec627275$var$SpotlightTourCardAsync, props)));
var $5b9bd65aec627275$export$2e2bcd8739ae039 = $5b9bd65aec627275$var$SpotlightTourCard;

});
parcelRegister("aOhkZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("3L085").then(()=>parcelRequire('966Nd'));

});


parcelRegister("437hw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb7042db8e62785d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");
var $d2s5v = parcelRequire("d2s5v");

var $gokBr = parcelRequire("gokBr");
/**
 *
 * Renders a spotlight target and associated spotlight card.
 */ const $cb7042db8e62785d$var$SpotlightTourTarget = ({ children: children, name: name, renderSpotlightCard: renderSpotlightCard })=>{
    const { onEndTour: onEndTour, onSetActiveCard: onSetActiveCard } = (0, $gokBr.useSpotlightCoordinationActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: name
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, typeof renderSpotlightCard === 'function' ? renderSpotlightCard({
        onEndTour: onEndTour,
        onSetActiveCard: onSetActiveCard
    }) : renderSpotlightCard));
};
var $cb7042db8e62785d$export$2e2bcd8739ae039 = $cb7042db8e62785d$var$SpotlightTourTarget;

});
parcelRegister("gokBr", function(module, exports) {

$parcel$export(module.exports, "useIsActiveSpotlightCard", () => $afabf68402b50fe5$export$ac706a6842f43035);
$parcel$export(module.exports, "useSpotlightCoordinationActions", () => $afabf68402b50fe5$export$d0297e733168e478);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

const $afabf68402b50fe5$var$initialState = {
    cardKey: null,
    onStopCoordination: null
};
const $afabf68402b50fe5$var$actions = {
    onSetActiveCard: (cardKey, stop)=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            setState({
                cardKey: cardKey,
                onStopCoordination: stop ?? onStopCoordination
            });
        },
    onEndTour: ()=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            onStopCoordination && onStopCoordination();
            setState({
                cardKey: null,
                onStopCoordination: null
            });
        }
};
const $afabf68402b50fe5$var$Store = (0, $GtRbT.createStore)({
    initialState: $afabf68402b50fe5$var$initialState,
    actions: $afabf68402b50fe5$var$actions
});
const $afabf68402b50fe5$export$ac706a6842f43035 = (0, $iJq0l.createHook)($afabf68402b50fe5$var$Store, {
    selector: (state, cardKeys)=>Array.isArray(cardKeys) ? state.cardKey !== null && cardKeys.includes(state.cardKey) : state.cardKey === cardKeys
});
const $afabf68402b50fe5$export$d0297e733168e478 = (0, $iJq0l.createActionsHook)($afabf68402b50fe5$var$Store);

});


parcelRegister("dQ4Ik", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e786e53309ddc04$export$2e2bcd8739ae039);

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $1JGvk = parcelRequire("1JGvk");

var $aCCNU = parcelRequire("aCCNU");
var $9e786e53309ddc04$export$2e2bcd8739ae039 = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), (0, $1JGvk.ToggleButtons), (0, $aCCNU.default));

});
parcelRegister("1JGvk", function(module, exports) {

$parcel$export(module.exports, "ToggleButtons", () => $40397b328aa6cd17$export$34301fadafd0cd9d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");
const $40397b328aa6cd17$export$34301fadafd0cd9d = ({ options: options, selectedOption: selectedOption, onChange: onChange, label: label, isCompact: isCompact, expDesignRefresh: expDesignRefresh })=>{
    const getButtonWithContext = (0, $eJOHy.useCallback)(({ option: option, isSelected: isSelected })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
            role: "radio",
            "aria-checked": isSelected,
            xcss: [
                expDesignRefresh ? $40397b328aa6cd17$var$baseStylesDesignRefresh : $40397b328aa6cd17$var$baseStyles,
                !isCompact && (expDesignRefresh ? $40397b328aa6cd17$var$wideStylesDesignRefresh : $40397b328aa6cd17$var$wideStyles),
                isSelected && (expDesignRefresh ? $40397b328aa6cd17$var$selectedStylesDesignRefresh : $40397b328aa6cd17$var$selectedStyles)
            ],
            onClick: (event, analyticsEvent)=>!isSelected && onChange(option.id, event, analyticsEvent),
            isDisabled: option.isDisabled,
            testId: option.testId,
            interactionName: option.interactionName,
            children: option.label
        }, option.id), [
        onChange,
        isCompact,
        expDesignRefresh
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        role: "radiogroup",
        xcss: expDesignRefresh ? $40397b328aa6cd17$var$containerStylesDesignRefresh : $40397b328aa6cd17$var$containerStyles,
        "aria-label": label,
        as: "fieldset",
        children: options.map((option)=>getButtonWithContext({
                option: option,
                isSelected: option.id === selectedOption
            }))
    });
};
const $40397b328aa6cd17$var$containerStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingInline: 'space.025',
    gap: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    height: '2rem'
});
const $40397b328aa6cd17$var$containerStylesDesignRefresh = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: "var(--ds-radius-small, 6px)",
    padding: 'space.050',
    gap: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    height: '2rem'
});
const $40397b328aa6cd17$var$baseStyles = (0, $1DXK0.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    border: '1px solid transparent',
    borderRadius: "var(--ds-radius-xsmall, 2px)",
    color: 'color.text.subtle',
    height: '26px',
    fontWeight: 'font.weight.medium',
    padding: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    },
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':disabled': {
        background: "var(--ds-background-disabled, #091E4208)",
        color: 'color.text.disabled'
    }
});
const $40397b328aa6cd17$var$baseStylesDesignRefresh = (0, $1DXK0.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    border: '1px solid transparent',
    borderRadius: "var(--ds-radius-xsmall, 3px)",
    color: 'color.text.subtle',
    height: '24px',
    fontWeight: 'font.weight.medium',
    padding: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    },
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':disabled': {
        background: "var(--ds-background-disabled, #091E4208)",
        color: 'color.text.disabled'
    }
});
const $40397b328aa6cd17$var$selectedStyles = (0, $1DXK0.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
    color: 'color.text.selected',
    cursor: 'default',
    ':hover': {
        background: "var(--ds-background-selected, #E9F2FF)",
        color: 'color.text.selected'
    }
});
const $40397b328aa6cd17$var$selectedStylesDesignRefresh = (0, $1DXK0.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: 'color.text.selected',
    cursor: 'default',
    ':hover': {
        background: "var(--ds-background-selected, #E9F2FF)",
        color: 'color.text.selected'
    }
});
const $40397b328aa6cd17$var$wideStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $40397b328aa6cd17$var$wideStylesDesignRefresh = (0, $1DXK0.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.100'
});

});

parcelRegister("aCCNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $df5f0ece3abdd2b7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $ucEZR = parcelRequire("ucEZR");

var $g60Pz = parcelRequire("g60Pz");
let $df5f0ece3abdd2b7$var$uniqueId = 0;
const $df5f0ece3abdd2b7$var$ToggleButtonsOld = ({ label: label, options: options, selectedOption: selectedOption, onChange: onChange })=>{
    (0, $g60Pz.assertPrecondition)(()=>({
            precondition: options.length > 0,
            message: `ToggleButtons requires at least one option, but received ${options.length}`
        }));
    (0, $g60Pz.assertPrecondition)(()=>({
            precondition: (0, $g60Pz.findDuplicateIds)(options) === null,
            message: `ToggleButtons requires that every option has a unique ID, but received "${(0, $g60Pz.findDuplicateIds)(options)}" multiple times`
        }));
    (0, $g60Pz.assertPrecondition)(()=>({
            precondition: options.findIndex((option)=>option.id === selectedOption) !== -1,
            message: `ToggleButtons requires that the selectedOption matches the ID of one of the passed options, but "${selectedOption}" did not`
        }));
    const [id] = (0, $eJOHy.useState)(()=>`toggle-buttons-${$df5f0ece3abdd2b7$var$uniqueId++}`);
    const fieldsetRef = (0, $eJOHy.useRef)(null);
    const selectedOptionRef = (0, $eJOHy.useRef)();
    const [selectedOptionPosition, setSelectedOptionPosition] = (0, $eJOHy.useState)();
    (0, $eJOHy.useEffect)(()=>{
        const fieldset = fieldsetRef.current;
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function, jira/jira-ssr/no-unchecked-globals-usage
        if (!fieldset || !window.ResizeObserver) return ()=>{};
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resizeObserver = new window.ResizeObserver(()=>{
            const element = selectedOptionRef.current;
            if (element) setSelectedOptionPosition({
                left: element.offsetLeft,
                top: element.offsetTop,
                width: element.offsetWidth,
                height: element.offsetHeight
            });
        });
        resizeObserver.observe(fieldset);
        return ()=>{
            resizeObserver.unobserve(fieldset);
        };
    }, [
        selectedOption
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df5f0ece3abdd2b7$var$Fieldset, {
        ref: fieldsetRef,
        selectedOptionPosition: selectedOptionPosition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("legend", null, label), options.map((option)=>{
        const isChecked = selectedOption === option.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ucEZR.default), {
            key: option.id,
            name: id,
            value: option.id,
            isChecked: isChecked,
            isDisabled: !!option.isDisabled,
            onChange: onChange,
            // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown> | undefined' is not assignable to type 'Ref<OptionProps> | undefined'.
            ref: isChecked ? selectedOptionRef : undefined,
            testId: option.testId
        }, option.label);
    }));
};
// The !important rules are required so that we can use this mixin on selectors
// with arbitrary specificity
const $df5f0ece3abdd2b7$var$selectedOptionIndicator = {
    backgroundColor: `${"var(--ds-background-accent-gray-subtler, #DCDFE4)"} !important`,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: `${"var(--ds-radius-small, 3px)"} !important`
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df5f0ece3abdd2b7$var$Fieldset = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "fieldset", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedOptionPosition: selectedOptionPosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ozn9do": (0, $awdRS.default)(__cmplp.selectedOptionPosition?.left, "px"),
            "--_1ibdxcf": (0, $awdRS.default)(__cmplp.selectedOptionPosition?.top, "px"),
            "--_1ggrzjo": (0, $awdRS.default)(__cmplp.selectedOptionPosition?.width, "px"),
            "--_1797z6d": (0, $awdRS.default)(__cmplp.selectedOptionPosition?.height, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _11c8dcr7 _1e0c1txw _1n261g80 _1bsb1ris _p12f1osq _kqswh2mm _bfhkm7j4 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _k48p1pd9 _1p1dangw _syaz1fxt _1qiiidpf _12o6idpf _19mbidpf _1ob8idpf _1e1midpf _p8t715vq _b4u715vq _1se6t94y _soiet94y _1jhnstnw _1r9t7mnp _kj6f1q9c _10bvh2mm _1nvfze3t _1nei1b66 _rt2pze3t _bmksze3t _fhioidpf _1kt9b3bt _1cs8stnw _rfx3421c _1rusksj1 _qs2z1l1k _1cg61yx9 _mlfedkwg",
            __cmplp.selectedOptionPosition ? "_cfu11ule" : "_cfu1glyw",
            __cmplp.selectedOptionPosition?.left ? "_qnecejz7" : "_qnecidpf",
            __cmplp.selectedOptionPosition?.top ? "_1auk1nuc" : "_1aukidpf",
            __cmplp.selectedOptionPosition?.width ? "_1mp412nj" : "_1mp4idpf",
            __cmplp.selectedOptionPosition?.height ? "_kfgt1d85" : "_kfgtidpf",
            !__cmplp.selectedOptionPosition && "_1ph3421c _15e9ksj1",
            __cmplp.className
        ])
    });
});
var $df5f0ece3abdd2b7$export$2e2bcd8739ae039 = $df5f0ece3abdd2b7$var$ToggleButtonsOld;

});
parcelRegister("ucEZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1a484822ee0f4ba$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
var $f1a484822ee0f4ba$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ name: name, value: value, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, children: children, testId: testId }, ref)=>{
    const id = `${name}-${value}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1a484822ee0f4ba$var$Container, {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "radio",
        id: id,
        name: name,
        value: value,
        checked: isChecked,
        disabled: isDisabled,
        "data-testid": testId,
        onChange: (event)=>onChange(value, event)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("label", {
        htmlFor: id
    }, children));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1a484822ee0f4ba$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v69yidpf _ogxmidpf _1qtqidpf _n9z4idpf _scffidpf _1yzy15vq _bgrh15vq _5hv9t94y _pytkt94y _khufstnw _11127mnp _1ru31q9c _1iohfajl _15pj1ule _d7ff1b66 _1j8612x7 _1qrc1b66 _4yng12x7 _1vzltlke _1hhy73ad _1emz73ad _1efl1lh4 _7el91vm4 _15pqglyw _vrjh166n _c2fy18uv _ynfu18uv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("g60Pz", function(module, exports) {

$parcel$export(module.exports, "findDuplicateIds", () => $d27f41633e9b3601$export$e5f5e25214715ca1);
$parcel$export(module.exports, "assertPrecondition", () => $d27f41633e9b3601$export$5565eefbe4b468a0);
const $d27f41633e9b3601$export$e5f5e25214715ca1 = (options)=>{
    for(let i = 0; i < options.length - 1; ++i)for(let j = i + 1; j < options.length; ++j){
        if (options[i].id === options[j].id) return options[i].id;
    }
    return null;
};
const $d27f41633e9b3601$export$5565eefbe4b468a0 = (evaluatePrecondition)=>{};

});



parcelRegister("gApH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2a740695b4ac9af$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f2a740695b4ac9af$var$messages = (0, $7qGN1.defineMessages)({
    done: {
        "id": "issue-navigator.view-switcher.done",
        "defaultMessage": "Done"
    },
    next: {
        "id": "issue-navigator.view-switcher.next",
        "defaultMessage": "Next"
    },
    skip: {
        "id": "issue-navigator.view-switcher.skip",
        "defaultMessage": "Skip"
    },
    tourHeading: {
        "id": "issue-navigator.view-switcher.tour-heading",
        "defaultMessage": "View switcher"
    },
    tourBody: {
        "id": "issue-navigator.view-switcher.tour-body",
        "defaultMessage": "Switch between these two views to easily scan through a list or view the details of the issues."
    },
    detailText: {
        "id": "issue-navigator.refinement-bar.view-switcher.detail-text",
        "defaultMessage": "Switch to detail view"
    },
    listText: {
        "id": "issue-navigator.refinement-bar.view-switcher.list-text",
        "defaultMessage": "Switch to list view"
    },
    toggleButtonsLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.toggle-buttons-label",
        "defaultMessage": "Select view"
    },
    detailOptionLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.detail-option-label",
        "defaultMessage": "Detail view"
    },
    listOptionLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.list-option-label",
        "defaultMessage": "List view"
    },
    tourBodyIssueTermRefresh: {
        "id": "issue-navigator.view-switcher.tour-body-issue-term-refresh",
        "defaultMessage": "Switch between these two views to easily scan through a list or view the details of the work item."
    }
});
var $f2a740695b4ac9af$export$2e2bcd8739ae039 = $f2a740695b4ac9af$var$messages;

});


parcelRegister("iUwEA", function(module, exports) {

$parcel$export(module.exports, "useNaturalLanguageMode", () => $6703b84e2e411836$export$617c50bbd595c5ac);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $6703b84e2e411836$var$initialState = {
    isNaturalLanguageMode: false
};
const $6703b84e2e411836$export$e324594224ef24da = {
    toggleNaturalLanguageMode: ()=>({ setState: setState, getState: getState })=>{
            setState({
                isNaturalLanguageMode: !getState().isNaturalLanguageMode
            });
        },
    exitNaturalLanguageMode: ()=>({ setState: setState })=>{
            setState({
                isNaturalLanguageMode: false
            });
        }
};
const $6703b84e2e411836$var$Store = (0, $GtRbT.createStore)({
    initialState: $6703b84e2e411836$var$initialState,
    actions: $6703b84e2e411836$export$e324594224ef24da
});
const $6703b84e2e411836$export$42a852a2b6b56249 = (0, $6E16M.createContainer)($6703b84e2e411836$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                isNaturalLanguageMode: false
            });
        }
});
const $6703b84e2e411836$var$getNaturalLanguageMode = (state)=>state.isNaturalLanguageMode;
const $6703b84e2e411836$export$617c50bbd595c5ac = (0, $iJq0l.createHook)($6703b84e2e411836$var$Store, {
    selector: $6703b84e2e411836$var$getNaturalLanguageMode
});
const $6703b84e2e411836$export$d99c2d47e59edc60 = (0, $iJq0l.createActionsHook)($6703b84e2e411836$var$Store);

});

parcelRegister("gn3Hu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a01744634b090e1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5a01744634b090e1$var$messages = (0, $7qGN1.defineMessages)({
    allIssues: {
        "id": "project-issue-navigator.page-actions.all-issues",
        "defaultMessage": "Go to all issues"
    },
    exportIssuesButtonIconLabel: {
        "id": "project-issue-navigator.page-actions.export-issues-button-icon-label",
        "defaultMessage": "Open export issues dropdown"
    },
    allIssuesIssueTermRefresh: {
        "id": "project-issue-navigator.page-actions.all-issues-issue-term-refresh",
        "defaultMessage": "Go to all work items"
    },
    exportIssuesButtonIconLabelIssueTermRefresh: {
        "id": "project-issue-navigator.page-actions.export-issues-button-icon-label-issue-term-refresh",
        "defaultMessage": "Open export work items dropdown"
    }
});
var $5a01744634b090e1$export$2e2bcd8739ae039 = $5a01744634b090e1$var$messages;

});



parcelRegister("epLyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fbb9d6bfd27c3af$export$2e2bcd8739ae039);

var $5OzqY = parcelRequire("5OzqY");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $aBIfT = parcelRequire("aBIfT");

var $7jTnu = parcelRequire("7jTnu");

var $qRwd2 = parcelRequire("qRwd2");
const $7fbb9d6bfd27c3af$var$NavigatorDocumentTitle = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.usePreloadedQuery)((0, $5OzqY.default), queryReference);
    const projectName = data?.jira?.jiraProjectByKey?.name ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBIfT.DocumentTitle), {
        title: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $qRwd2.default).windowTitleMigrationIssueTermRefresh : (0, $qRwd2.default).windowTitleMigration, {
            projectName: projectName
        })
    });
};
var $7fbb9d6bfd27c3af$export$2e2bcd8739ae039 = $7fbb9d6bfd27c3af$var$NavigatorDocumentTitle;

});
parcelRegister("qRwd2", function(module, exports) {

$parcel$export(module.exports, "default", () => $54bf144ca602d19e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $54bf144ca602d19e$var$messages = (0, $7qGN1.defineMessages)({
    windowTitleMigrationIssueTermRefresh: {
        "id": "project-issue-navigator.window-title-migration-issue-term-refresh",
        "defaultMessage": "{projectName} - All work"
    },
    windowTitleMigration: {
        "id": "project-issue-navigator.window-title-migration",
        "defaultMessage": "{projectName} - Issues"
    }
});
var $54bf144ca602d19e$export$2e2bcd8739ae039 = $54bf144ca602d19e$var$messages;

});



parcelRegister("lA4uT", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $70fb2661bfe02c7c$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $70fb2661bfe02c7c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $70fb2661bfe02c7c$export$9b3029ee6188a41f);

var $eJOHy = parcelRequire("eJOHy");

var $2gvG4 = parcelRequire("2gvG4");

var $6whQo = parcelRequire("6whQo");

var $kVpZx = parcelRequire("kVpZx");

var $ioEQd = parcelRequire("ioEQd");

var $4l9pO = parcelRequire("4l9pO");

var $2UxSQ = parcelRequire("2UxSQ");

var $jPcl6 = parcelRequire("jPcl6");

var $9j9F7 = parcelRequire("9j9F7");

var $jSrj1 = parcelRequire("jSrj1");
const $70fb2661bfe02c7c$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $70fb2661bfe02c7c$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $70fb2661bfe02c7c$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $9j9F7.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $jPcl6.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $jSrj1.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6whQo.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2UxSQ.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $kVpZx.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4l9pO.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $70fb2661bfe02c7c$export$9b3029ee6188a41f = $70fb2661bfe02c7c$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("6whQo", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $3708d872c36dd1bb$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $3708d872c36dd1bb$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $3708d872c36dd1bb$export$d93d677ef2f33c5c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $3708d872c36dd1bb$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    (0, $eJOHy.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $3708d872c36dd1bb$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingsConfig);
        (0, $2QO3b.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("4l9pO", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $4802f5e968b3fe62$export$575e93c0f9905999);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $k04JP = parcelRequire("k04JP");

var $6uWhG = parcelRequire("6uWhG");

var $2HxHL = parcelRequire("2HxHL");

var $akiS9 = parcelRequire("akiS9");

var $dydef = parcelRequire("dydef");

var $9DwQv = parcelRequire("9DwQv");

const $4802f5e968b3fe62$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
};
class $4802f5e968b3fe62$export$575e93c0f9905999 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $k04JP.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $akiS9.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $2e47af044bce450a$export$99c08ec92759c71c));
                (0, $6uWhG.setMark)((0, $2e47af044bce450a$export$99c08ec92759c71c));
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $2e47af044bce450a$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $4802f5e968b3fe62$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $akiS9.PRODUCT_START_MARK), true);
            $4802f5e968b3fe62$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});
const $2e47af044bce450a$export$56940a9488e85199 = 'jira.fe.spa-';
const $2e47af044bce450a$export$45c4b6bf7935c69a = `${$2e47af044bce450a$export$56940a9488e85199}start`;
const $2e47af044bce450a$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $2e47af044bce450a$export$ff834eccc35b9089 = 'appBundleReady';
const $2e47af044bce450a$export$86b05e34d462ead8 = 'prefetchApiReady';
const $2e47af044bce450a$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $2e47af044bce450a$export$3ae43cc1782d058f = 'jswRenderStart';
const $2e47af044bce450a$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $2e47af044bce450a$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $2e47af044bce450a$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $2e47af044bce450a$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $2e47af044bce450a$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $2e47af044bce450a$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $2e47af044bce450a$export$99c08ec92759c71c = 'tti-raf-mark';
const $2e47af044bce450a$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("2UxSQ", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $9ca3da1474781c5a$export$d91154f099475c5);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $ioEQd = parcelRequire("ioEQd");
class $9ca3da1474781c5a$export$d91154f099475c5 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $ioEQd.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("jPcl6", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9af3d786d904c43c$export$bf239ac2bfb04967);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $9af3d786d904c43c$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("9j9F7", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $79450f1fef3080e8$export$e63862cd888fe05a);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $ioEQd = parcelRequire("ioEQd");
var $8tVkR = parcelRequire("8tVkR");
async function $79450f1fef3080e8$export$e63862cd888fe05a() {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $ioEQd.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $8tVkR.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("jSrj1", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $0af00334d248807d$export$f00f1e874ce869e9);

var $kVpZx = parcelRequire("kVpZx");

var $j500r = parcelRequire("j500r");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0af00334d248807d$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0af00334d248807d$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0af00334d248807d$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $0af00334d248807d$export$7b4abba432e57989 = (value)=>$0af00334d248807d$var$isString(value) && $0af00334d248807d$var$startsAsObject(value) || $0af00334d248807d$var$isObject(value);
const $0af00334d248807d$export$fcc03ee4c944962f = (featureFlagValue)=>$0af00334d248807d$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $0af00334d248807d$export$d2818866b4acbea4 = new Map();
const $0af00334d248807d$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $j500r.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $0af00334d248807d$export$fcc03ee4c944962f(value);
            $0af00334d248807d$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("2MmuH", function(module, exports) {

$parcel$export(module.exports, "WelcomeModal", () => $9d1aea9e31439ae5$export$9d12d42929c3fcf);

var $eJOHy = parcelRequire("eJOHy");

var $eaCdv = parcelRequire("eaCdv");

var $egzgh = parcelRequire("egzgh");

var $1KdDN = parcelRequire("1KdDN");

var $eJrcF = parcelRequire("eJrcF");

var $dZRaT = parcelRequire("dZRaT");

var $7jTnu = parcelRequire("7jTnu");
const $9d1aea9e31439ae5$var$ConditionalWelcomeModalForSoftware = ()=>{
    const shouldShowModal = (0, $egzgh.useShouldShowWelcomeModal)('list');
    const { data: data } = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    const isSoftwareProject = data?.projectType === 'software';
    return shouldShowModal && isSoftwareProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eaCdv.AsyncWelcomeModal), {
        source: "list"
    }) : null;
};
const $9d1aea9e31439ae5$export$9d12d42929c3fcf = ()=>{
    if (!(0, $7jTnu.fg)('jira_list_nin_merge')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "welcome-modal-list-view",
        packageName: "jiraBusinessList",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9d1aea9e31439ae5$var$ConditionalWelcomeModalForSoftware, null));
};

});
parcelRegister("eaCdv", function(module, exports) {

$parcel$export(module.exports, "AsyncWelcomeModal", () => $f425abc4bad8a088$export$d08881a6c29dfdb2);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");


var $hLlIx = parcelRequire("hLlIx");

var $bonXV = parcelRequire("bonXV");

var $ch9En = parcelRequire("ch9En");

var $16sa1 = parcelRequire("16sa1");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f425abc4bad8a088$var$LazyWelcomeModal = (0, $bQWwW.lazy)(()=>(parcelRequire("eZcP6")).then(({ WelcomeModal: WelcomeModal })=>WelcomeModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/welcome-modal/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f425abc4bad8a088$var$LazyWelcomeModalWizard = (0, $bQWwW.lazy)(()=>(parcelRequire("5hANT")).then(({ WelcomeModal: WelcomeModal })=>WelcomeModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/welcome-modal/wizard/index.tsx"
});
const $f425abc4bad8a088$export$d08881a6c29dfdb2 = ({ source: source })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "async-onboarding-welcome-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hLlIx.ErrorBoundaryWithChunkErrorLogging), {
        id: "asyncWelcomeModalComponent",
        fallback: "unmount",
        packageName: "jiraSoftwareOnboardingModals",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "software-onboarding-modals-welcome-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $7jTnu.fg)('jira_onboarding_wizard_m1_feature_gate') && [
        'list',
        'board'
    ].includes(source) && // our new wizard only needs to render on list/board
    (0, $bonXV.sessionStorageProvider).get((0, $2b839a8453de5367$export$c9dc4cb209930823)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f425abc4bad8a088$var$LazyWelcomeModalWizard, {
        source: source
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f425abc4bad8a088$var$LazyWelcomeModal, {
        source: source
    }))));
};

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $2b839a8453de5367$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $2b839a8453de5367$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $2b839a8453de5367$export$e3884212029f7bef = 'should-show-welcome-modal';
const $2b839a8453de5367$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $2b839a8453de5367$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $2b839a8453de5367$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $2b839a8453de5367$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $2b839a8453de5367$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $2b839a8453de5367$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $2b839a8453de5367$export$6e69f8dc03075ef8 = 'team-type';
const $2b839a8453de5367$export$c06666264cd35603 = 'team-type-shorthand';
const $2b839a8453de5367$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $2b839a8453de5367$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $2b839a8453de5367$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $2b839a8453de5367$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $2b839a8453de5367$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $2b839a8453de5367$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $2b839a8453de5367$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $2b839a8453de5367$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $2b839a8453de5367$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $2b839a8453de5367$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $2b839a8453de5367$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $2b839a8453de5367$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $2b839a8453de5367$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $2b839a8453de5367$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $2b839a8453de5367$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $2b839a8453de5367$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $2b839a8453de5367$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $2b839a8453de5367$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $2b839a8453de5367$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $2b839a8453de5367$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $2b839a8453de5367$export$468488291ccd988 = 'timelineAddItemNudge';
const $2b839a8453de5367$export$7a33548109ac931d = 'createFormNudge';
const $2b839a8453de5367$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $2b839a8453de5367$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $2b839a8453de5367$export$594d3436316492be = 'summaryViewNudge';
const $2b839a8453de5367$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $2b839a8453de5367$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $2b839a8453de5367$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $2b839a8453de5367$export$699265ec8ad9a740 = 'Software Development';
const $2b839a8453de5367$export$e07d1fa2da8ed874 = 'Customer Service';
const $2b839a8453de5367$export$76dcec3f438d9e56 = 'IT Support';
const $2b839a8453de5367$export$9a574c301f67ba30 = 'Human Resources';
const $2b839a8453de5367$export$363ec144a94029c8 = 'Finance';
const $2b839a8453de5367$export$df0fb32d68ae1e78 = 'Legal';
const $2b839a8453de5367$export$d9c0e3e59442fb4 = 'Marketing';
const $2b839a8453de5367$export$27dbc7d7ce66e6e3 = 'Operations';
const $2b839a8453de5367$export$a5dce388adf922bd = 'Sales';
const $2b839a8453de5367$export$e1473b31a257caff = 'Data Science';
const $2b839a8453de5367$export$85657457db93c2c2 = 'Product Management';
const $2b839a8453de5367$export$c0c2d1dfaeba89dd = 'Project Management';
const $2b839a8453de5367$export$2e6a7ad3ab9c82a3 = 'Design';
const $2b839a8453de5367$export$7b60378c3b4372e9 = 'Other or Personal';
const $2b839a8453de5367$export$572242e58bd07594 = 'CS';
const $2b839a8453de5367$export$d7de553940261eba = 'ITS';
const $2b839a8453de5367$export$4c29d0d04c15e55d = 'HR';
const $2b839a8453de5367$export$3950f7f841bf94b6 = 'FNC';
const $2b839a8453de5367$export$881249b988b6030f = 'LGL';
const $2b839a8453de5367$export$e4824f74b9879164 = 'MKT';
const $2b839a8453de5367$export$4f3cb0844009af52 = 'OPS';
const $2b839a8453de5367$export$1a65d50c4a641bb4 = 'SAL';
const $2b839a8453de5367$export$9ee64e8fbd8b03a2 = 'DS';
const $2b839a8453de5367$export$b8b1ac856ba1434b = 'DEV';
const $2b839a8453de5367$export$4f54a09a24fd1d74 = 'PDM';
const $2b839a8453de5367$export$79685802e8ff1098 = 'PJM';
const $2b839a8453de5367$export$e5c438b7501b5a24 = 'DES';
const $2b839a8453de5367$export$cbc0e551d91a692d = 'OTR';

parcelRegister("eZcP6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("8QSHq")
]).then(()=>parcelRequire('fmEci'));

});

parcelRegister("5hANT", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("lwWcG")
]).then(()=>parcelRequire('faS2r'));

});


parcelRegister("egzgh", function(module, exports) {

$parcel$export(module.exports, "useShouldShowModalBasedOnSessionStorage", () => $b456e169e3488e0b$export$b39cbd941f378bec);
$parcel$export(module.exports, "useShouldShowWelcomeModal", () => $b456e169e3488e0b$export$b01115c2f75a04f8);

var $eJOHy = parcelRequire("eJOHy");


var $bonXV = parcelRequire("bonXV");

var $gMNY3 = parcelRequire("gMNY3");
const $b456e169e3488e0b$export$b39cbd941f378bec = ()=>{
    const shouldShowModalBasedOnSessionStorage = (0, $eJOHy.useMemo)(()=>{
        const isWizardDuringSignup = (0, $bonXV.sessionStorageProvider).get((0, $2b839a8453de5367$export$c45d2ea50af63a85));
        if (isWizardDuringSignup) return false;
        const sessionStorageVal = (0, $bonXV.sessionStorageProvider).get((0, $2b839a8453de5367$export$e3884212029f7bef));
        if (sessionStorageVal === undefined) return false;
        return true;
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // Remove the session storage value to prevent the modal showing again
        (0, $bonXV.sessionStorageProvider).remove((0, $2b839a8453de5367$export$e3884212029f7bef));
    }, []);
    return shouldShowModalBasedOnSessionStorage;
};
const $b456e169e3488e0b$export$b01115c2f75a04f8 = (source)=>{
    const canShowNudgeTour = (0, $gMNY3.useCanShowNudgeTour)();
    const sessionStorageVal = (0, $eJOHy.useMemo)(()=>(0, $bonXV.sessionStorageProvider).get((0, $2b839a8453de5367$export$e3884212029f7bef)), []);
    const isWizardDuringSignup = (0, $bonXV.sessionStorageProvider).get((0, $2b839a8453de5367$export$c45d2ea50af63a85));
    if (isWizardDuringSignup) return false;
    if (sessionStorageVal === undefined) return false;
    return canShowNudgeTour(source);
};

});
parcelRegister("gMNY3", function(module, exports) {

$parcel$export(module.exports, "useCanShowNudgeTour", () => $ed2f93c043223105$export$3381da528a252680);

var $7jTnu = parcelRequire("7jTnu");

var $9ycBx = parcelRequire("9ycBx");

var $gxP9D = parcelRequire("gxP9D");
const $ed2f93c043223105$export$3381da528a252680 = ()=>{
    const [completedTaskList] = (0, $gxP9D.useCompletedTaskList)();
    const [shouldShowScrumOnboardingExperience] = (0, $gxP9D.useShouldShowScrumOnboardingExperience)();
    const [shouldShowOnboardingKanbanTour] = (0, $gxP9D.useShouldShowOnboardingKanbanTour)();
    const shouldShowOnboardingScrumTour = shouldShowScrumOnboardingExperience === true && // edge case for KURO-2088: After welcome modal failed to load, users complete welcome tour by themselves. Welcome modal should be skipped to load on refreshment.
    !completedTaskList.includes((0, $9ycBx.SCRUM_ONBOARDING_TASK));
    return (source)=>{
        switch(source){
            case 'board':
                return shouldShowOnboardingKanbanTour;
            case 'backlog':
                return shouldShowOnboardingScrumTour;
            case 'timeline':
                // display if eligible for either board/backlog scenarios
                return shouldShowOnboardingKanbanTour || shouldShowOnboardingScrumTour;
            case 'list':
                if ((0, $7jTnu.fg)('jira_onboarding_wizard_m1_feature_gate')) return true;
                return false;
            default:
                return false;
        }
    };
};

});





const $e2e3f134560cc64f$export$dcd281f501ceae1a = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
const $e2e3f134560cc64f$export$2aca0ebce9a48d61 = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.visible-fields';
const $e2e3f134560cc64f$export$fc60a8d420264e7d = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.hidden-fields';
const $e2e3f134560cc64f$export$e1184c3be46bd7cb = false;
const $e2e3f134560cc64f$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $e2e3f134560cc64f$export$988f0f6f6457039a = 'status-and-approval-spotlight';

const $6f32016c90d98258$export$87b07f66f76af007 = 1000;
const $6f32016c90d98258$export$7cf28317477c9e48 = 'w';

const $ecd600060529b307$export$cb17e3c17bc50301 = 'Epic';
const $ecd600060529b307$export$d29cf9c8492f955d = 'Base';
const $ecd600060529b307$export$7fbc739f2667a35e = 'Subtask';

const $ec5902adfb6dec1f$export$37b67b9fa9f77199 = 'APPLINK_MISSING';
const $ec5902adfb6dec1f$export$d1fe0e8f550fe68d = 'APPLINK_REQ_AUTH';
const $ec5902adfb6dec1f$export$a6054426471fb4c4 = 'REMOTE_SERVER';
const $ec5902adfb6dec1f$export$cdf8a4853fe35e61 = 'REMOTE_LINK_MISSING';


$parcel$global.rlb("d9fW6")
//# sourceMappingURL=async-project-issue-navigator-entrypoint.9f1bd973.js.map
